// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/@paylixecommerce/shared/dist/cjs/assets/style.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fontawesome/scss/webfonts/fa-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fontawesome/scss/webfonts/fa-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fontawesome/scss/webfonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fontawesome/scss/webfonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fontawesome/scss/webfonts/fa-light-300.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/fontawesome/scss/webfonts/fa-light-300.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/fontawesome/scss/webfonts/fa-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/fontawesome/scss/webfonts/fa-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("assets/fontawesome/scss/webfonts/fa-thin-100.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("assets/fontawesome/scss/webfonts/fa-thin-100.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("assets/NEW/font/Inter.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSA3LjVMMTAgMTIuNUwxNSA3LjUiIHN0cm9rZT0iI0EyQUFCNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap v5.0.2 (https://getbootstrap.com/)
 * Copyright 2011-2021 The Bootstrap Authors
 * Copyright 2011-2021 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-font-sans-serif);
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  background-color: currentColor;
  border: 0;
  opacity: 0.25;
}

hr:not([size]) {
  height: 1px;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-bs-original-title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

mark, .mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

sub,
sup {
  position: relative;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #0d6efd;
  text-decoration: underline;
}
a:hover {
  color: #0a58ca;
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  direction: ltr /* rtl:ignore */;
  unicode-bidi: bidi-override;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
}
pre code {
  color: inherit;
  word-break: normal;
}

code {
  color: #d63384;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: #6c757d;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]::-webkit-calendar-picker-indicator {
  display: none;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
*::-webkit-search-decoration {
  -webkit-appearance: none;
}

*::-webkit-color-swatch-wrapper {
  padding: 0;
}

*::file-selector-button {
  font: inherit;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-weight: 300;
}

.display-1 {
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-weight: 300;
  line-height: 1.2;
}

.display-5 {
  font-weight: 300;
  line-height: 1.2;
}

.display-6 {
  font-weight: 300;
  line-height: 1.2;
}

.initialism {
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.btn {
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
}
.btn:hover {
  color: #212529;
}
.btn-check:focus + .btn, .btn:focus {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  pointer-events: none;
  opacity: 0.65;
}

.btn-link {
  font-weight: 400;
  color: #0d6efd;
  text-decoration: underline;
}
.btn-link:hover {
  color: #0a58ca;
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
}

.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}

.pagination {
  display: flex;
}

.page-link {
  position: relative;
  display: block;
  color: #0d6efd;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  z-index: 2;
  color: #0a58ca;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 3;
  color: #0a58ca;
  background-color: #e9ecef;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  border-color: #0d6efd;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
  border-color: #dee2e6;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
  }
}
/*!
 * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 */
.fa {
  font-family: var(--fa-style-family, "Font Awesome 6 Pro");
  font-weight: var(--fa-style, 900);
}

.fa,
.fas,
.fa-solid,
.far,
.fa-regular,
.fal,
.fa-light,
.fat,
.fa-thin,
.fad,
.fa-duotone,
.fab,
.fa-brands {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: var(--fa-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flash {
  animation-name: fa-flash;
  animation-delay: var(--fa-animation-delay, 0);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
  .fa-fade,
  .fa-flash,
  .fa-flip,
  .fa-pulse,
  .fa-spin,
  .fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-flash {
  0%, 100% {
    opacity: var(--fa-flash-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-flash-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, none));
}

.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: var(--fa-stack-z-index, auto);
}

.fa-stack-1x {
  line-height: inherit;
}

.fa-stack-2x {
  font-size: 2em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.fa-0::before {
  content: "\\30 ";
}

.fa-1::before {
  content: "\\31 ";
}

.fa-2::before {
  content: "\\32 ";
}

.fa-3::before {
  content: "\\33 ";
}

.fa-4::before {
  content: "\\34 ";
}

.fa-5::before {
  content: "\\35 ";
}

.fa-6::before {
  content: "\\36 ";
}

.fa-7::before {
  content: "\\37 ";
}

.fa-8::before {
  content: "\\38 ";
}

.fa-9::before {
  content: "\\39 ";
}

.fa-360-degrees::before {
  content: "\\e2dc";
}

.fa-a::before {
  content: "A";
}

.fa-abacus::before {
  content: "\\f640";
}

.fa-accent-grave::before {
  content: "\\\`";
}

.fa-acorn::before {
  content: "\\f6ae";
}

.fa-address-book::before {
  content: "\\f2b9";
}

.fa-contact-book::before {
  content: "\\f2b9";
}

.fa-address-card::before {
  content: "\\f2bb";
}

.fa-contact-card::before {
  content: "\\f2bb";
}

.fa-vcard::before {
  content: "\\f2bb";
}

.fa-air-conditioner::before {
  content: "\\f8f4";
}

.fa-airplay::before {
  content: "\\e089";
}

.fa-alarm-clock::before {
  content: "\\f34e";
}

.fa-alarm-exclamation::before {
  content: "\\f843";
}

.fa-alarm-plus::before {
  content: "\\f844";
}

.fa-alarm-snooze::before {
  content: "\\f845";
}

.fa-album::before {
  content: "\\f89f";
}

.fa-album-collection::before {
  content: "\\f8a0";
}

.fa-alicorn::before {
  content: "\\f6b0";
}

.fa-alien::before {
  content: "\\f8f5";
}

.fa-alien-8bit::before {
  content: "\\f8f6";
}

.fa-alien-monster::before {
  content: "\\f8f6";
}

.fa-align-center::before {
  content: "\\f037";
}

.fa-align-justify::before {
  content: "\\f039";
}

.fa-align-left::before {
  content: "\\f036";
}

.fa-align-right::before {
  content: "\\f038";
}

.fa-align-slash::before {
  content: "\\f846";
}

.fa-alt::before {
  content: "\\e08a";
}

.fa-amp-guitar::before {
  content: "\\f8a1";
}

.fa-ampersand::before {
  content: "\\&";
}

.fa-anchor::before {
  content: "\\f13d";
}

.fa-angel::before {
  content: "\\f779";
}

.fa-angle::before {
  content: "\\e08c";
}

.fa-angle-90::before {
  content: "\\e08d";
}

.fa-angle-down::before {
  content: "\\f107";
}

.fa-angle-left::before {
  content: "\\f104";
}

.fa-angle-right::before {
  content: "\\f105";
}

.fa-angle-up::before {
  content: "\\f106";
}

.fa-angles-down::before {
  content: "\\f103";
}

.fa-angle-double-down::before {
  content: "\\f103";
}

.fa-angles-left::before {
  content: "\\f100";
}

.fa-angle-double-left::before {
  content: "\\f100";
}

.fa-angles-right::before {
  content: "\\f101";
}

.fa-angle-double-right::before {
  content: "\\f101";
}

.fa-angles-up::before {
  content: "\\f102";
}

.fa-angle-double-up::before {
  content: "\\f102";
}

.fa-ankh::before {
  content: "\\f644";
}

.fa-aperture::before {
  content: "\\e2df";
}

.fa-apostrophe::before {
  content: "\\'";
}

.fa-apple-core::before {
  content: "\\e08f";
}

.fa-apple-whole::before {
  content: "\\f5d1";
}

.fa-apple-alt::before {
  content: "\\f5d1";
}

.fa-archway::before {
  content: "\\f557";
}

.fa-arrow-down::before {
  content: "\\f063";
}

.fa-arrow-down-1-9::before {
  content: "\\f162";
}

.fa-sort-numeric-asc::before {
  content: "\\f162";
}

.fa-sort-numeric-down::before {
  content: "\\f162";
}

.fa-arrow-down-9-1::before {
  content: "\\f886";
}

.fa-sort-numeric-desc::before {
  content: "\\f886";
}

.fa-sort-numeric-down-alt::before {
  content: "\\f886";
}

.fa-arrow-down-a-z::before {
  content: "\\f15d";
}

.fa-sort-alpha-asc::before {
  content: "\\f15d";
}

.fa-sort-alpha-down::before {
  content: "\\f15d";
}

.fa-arrow-down-arrow-up::before {
  content: "\\f883";
}

.fa-sort-alt::before {
  content: "\\f883";
}

.fa-arrow-down-big-small::before {
  content: "\\f88c";
}

.fa-sort-size-down::before {
  content: "\\f88c";
}

.fa-arrow-down-from-dotted-line::before {
  content: "\\e090";
}

.fa-arrow-down-from-line::before {
  content: "\\f345";
}

.fa-arrow-from-top::before {
  content: "\\f345";
}

.fa-arrow-down-left::before {
  content: "\\e091";
}

.fa-arrow-down-left-and-arrow-up-right-to-center::before {
  content: "\\e092";
}

.fa-arrow-down-long::before {
  content: "\\f175";
}

.fa-long-arrow-down::before {
  content: "\\f175";
}

.fa-arrow-down-right::before {
  content: "\\e093";
}

.fa-arrow-down-short-wide::before {
  content: "\\f884";
}

.fa-sort-amount-desc::before {
  content: "\\f884";
}

.fa-sort-amount-down-alt::before {
  content: "\\f884";
}

.fa-arrow-down-small-big::before {
  content: "\\f88d";
}

.fa-sort-size-down-alt::before {
  content: "\\f88d";
}

.fa-arrow-down-square-triangle::before {
  content: "\\f889";
}

.fa-sort-shapes-down-alt::before {
  content: "\\f889";
}

.fa-arrow-down-to-bracket::before {
  content: "\\e094";
}

.fa-arrow-down-to-dotted-line::before {
  content: "\\e095";
}

.fa-arrow-down-to-line::before {
  content: "\\f33d";
}

.fa-arrow-to-bottom::before {
  content: "\\f33d";
}

.fa-arrow-down-to-square::before {
  content: "\\e096";
}

.fa-arrow-down-triangle-square::before {
  content: "\\f888";
}

.fa-sort-shapes-down::before {
  content: "\\f888";
}

.fa-arrow-down-wide-short::before {
  content: "\\f160";
}

.fa-sort-amount-asc::before {
  content: "\\f160";
}

.fa-sort-amount-down::before {
  content: "\\f160";
}

.fa-arrow-down-z-a::before {
  content: "\\f881";
}

.fa-sort-alpha-desc::before {
  content: "\\f881";
}

.fa-sort-alpha-down-alt::before {
  content: "\\f881";
}

.fa-arrow-left::before {
  content: "\\f060";
}

.fa-arrow-left-from-line::before {
  content: "\\f344";
}

.fa-arrow-from-right::before {
  content: "\\f344";
}

.fa-arrow-left-long::before {
  content: "\\f177";
}

.fa-long-arrow-left::before {
  content: "\\f177";
}

.fa-arrow-left-long-to-line::before {
  content: "\\e3d4";
}

.fa-arrow-left-to-line::before {
  content: "\\f33e";
}

.fa-arrow-to-left::before {
  content: "\\f33e";
}

.fa-arrow-pointer::before {
  content: "\\f245";
}

.fa-mouse-pointer::before {
  content: "\\f245";
}

.fa-arrow-right::before {
  content: "\\f061";
}

.fa-arrow-right-arrow-left::before {
  content: "\\f0ec";
}

.fa-exchange::before {
  content: "\\f0ec";
}

.fa-arrow-right-from-bracket::before {
  content: "\\f08b";
}

.fa-sign-out::before {
  content: "\\f08b";
}

.fa-arrow-right-from-line::before {
  content: "\\f343";
}

.fa-arrow-from-left::before {
  content: "\\f343";
}

.fa-arrow-right-long::before {
  content: "\\f178";
}

.fa-long-arrow-right::before {
  content: "\\f178";
}

.fa-arrow-right-long-to-line::before {
  content: "\\e3d5";
}

.fa-arrow-right-to-bracket::before {
  content: "\\f090";
}

.fa-sign-in::before {
  content: "\\f090";
}

.fa-arrow-right-to-line::before {
  content: "\\f340";
}

.fa-arrow-to-right::before {
  content: "\\f340";
}

.fa-arrow-rotate-left::before {
  content: "\\f0e2";
}

.fa-arrow-left-rotate::before {
  content: "\\f0e2";
}

.fa-arrow-rotate-back::before {
  content: "\\f0e2";
}

.fa-arrow-rotate-backward::before {
  content: "\\f0e2";
}

.fa-undo::before {
  content: "\\f0e2";
}

.fa-arrow-rotate-right::before {
  content: "\\f01e";
}

.fa-arrow-right-rotate::before {
  content: "\\f01e";
}

.fa-arrow-rotate-forward::before {
  content: "\\f01e";
}

.fa-redo::before {
  content: "\\f01e";
}

.fa-arrow-trend-down::before {
  content: "\\e097";
}

.fa-arrow-trend-up::before {
  content: "\\e098";
}

.fa-arrow-turn-down::before {
  content: "\\f149";
}

.fa-level-down::before {
  content: "\\f149";
}

.fa-arrow-turn-down-left::before {
  content: "\\e2e1";
}

.fa-arrow-turn-down-right::before {
  content: "\\e3d6";
}

.fa-arrow-turn-up::before {
  content: "\\f148";
}

.fa-level-up::before {
  content: "\\f148";
}

.fa-arrow-up::before {
  content: "\\f062";
}

.fa-arrow-up-1-9::before {
  content: "\\f163";
}

.fa-sort-numeric-up::before {
  content: "\\f163";
}

.fa-arrow-up-9-1::before {
  content: "\\f887";
}

.fa-sort-numeric-up-alt::before {
  content: "\\f887";
}

.fa-arrow-up-a-z::before {
  content: "\\f15e";
}

.fa-sort-alpha-up::before {
  content: "\\f15e";
}

.fa-arrow-up-arrow-down::before {
  content: "\\e099";
}

.fa-sort-up-down::before {
  content: "\\e099";
}

.fa-arrow-up-big-small::before {
  content: "\\f88e";
}

.fa-sort-size-up::before {
  content: "\\f88e";
}

.fa-arrow-up-from-bracket::before {
  content: "\\e09a";
}

.fa-arrow-up-from-dotted-line::before {
  content: "\\e09b";
}

.fa-arrow-up-from-line::before {
  content: "\\f342";
}

.fa-arrow-from-bottom::before {
  content: "\\f342";
}

.fa-arrow-up-from-square::before {
  content: "\\e09c";
}

.fa-arrow-up-left::before {
  content: "\\e09d";
}

.fa-arrow-up-left-from-circle::before {
  content: "\\e09e";
}

.fa-arrow-up-long::before {
  content: "\\f176";
}

.fa-long-arrow-up::before {
  content: "\\f176";
}

.fa-arrow-up-right::before {
  content: "\\e09f";
}

.fa-arrow-up-right-and-arrow-down-left-from-center::before {
  content: "\\e0a0";
}

.fa-arrow-up-right-from-square::before {
  content: "\\f08e";
}

.fa-external-link::before {
  content: "\\f08e";
}

.fa-arrow-up-short-wide::before {
  content: "\\f885";
}

.fa-sort-amount-up-alt::before {
  content: "\\f885";
}

.fa-arrow-up-small-big::before {
  content: "\\f88f";
}

.fa-sort-size-up-alt::before {
  content: "\\f88f";
}

.fa-arrow-up-square-triangle::before {
  content: "\\f88b";
}

.fa-sort-shapes-up-alt::before {
  content: "\\f88b";
}

.fa-arrow-up-to-dotted-line::before {
  content: "\\e0a1";
}

.fa-arrow-up-to-line::before {
  content: "\\f341";
}

.fa-arrow-to-top::before {
  content: "\\f341";
}

.fa-arrow-up-triangle-square::before {
  content: "\\f88a";
}

.fa-sort-shapes-up::before {
  content: "\\f88a";
}

.fa-arrow-up-wide-short::before {
  content: "\\f161";
}

.fa-sort-amount-up::before {
  content: "\\f161";
}

.fa-arrow-up-z-a::before {
  content: "\\f882";
}

.fa-sort-alpha-up-alt::before {
  content: "\\f882";
}

.fa-arrows-cross::before {
  content: "\\e0a2";
}

.fa-arrows-from-dotted-line::before {
  content: "\\e0a3";
}

.fa-arrows-from-line::before {
  content: "\\e0a4";
}

.fa-arrows-left-right::before {
  content: "\\f07e";
}

.fa-arrows-h::before {
  content: "\\f07e";
}

.fa-arrows-maximize::before {
  content: "\\f31d";
}

.fa-expand-arrows::before {
  content: "\\f31d";
}

.fa-arrows-minimize::before {
  content: "\\e0a5";
}

.fa-compress-arrows::before {
  content: "\\e0a5";
}

.fa-arrows-repeat::before {
  content: "\\f364";
}

.fa-repeat-alt::before {
  content: "\\f364";
}

.fa-arrows-repeat-1::before {
  content: "\\f366";
}

.fa-repeat-1-alt::before {
  content: "\\f366";
}

.fa-arrows-retweet::before {
  content: "\\f361";
}

.fa-retweet-alt::before {
  content: "\\f361";
}

.fa-arrows-rotate::before {
  content: "\\f021";
}

.fa-refresh::before {
  content: "\\f021";
}

.fa-sync::before {
  content: "\\f021";
}

.fa-arrows-to-dotted-line::before {
  content: "\\e0a6";
}

.fa-arrows-to-line::before {
  content: "\\e0a7";
}

.fa-arrows-up-down::before {
  content: "\\f07d";
}

.fa-arrows-v::before {
  content: "\\f07d";
}

.fa-arrows-up-down-left-right::before {
  content: "\\f047";
}

.fa-arrows::before {
  content: "\\f047";
}

.fa-asterisk::before {
  content: "\\*";
}

.fa-at::before {
  content: "\\@";
}

.fa-atom::before {
  content: "\\f5d2";
}

.fa-atom-simple::before {
  content: "\\f5d3";
}

.fa-atom-alt::before {
  content: "\\f5d3";
}

.fa-audio-description::before {
  content: "\\f29e";
}

.fa-audio-description-slash::before {
  content: "\\e0a8";
}

.fa-austral-sign::before {
  content: "\\e0a9";
}

.fa-avocado::before {
  content: "\\e0aa";
}

.fa-award::before {
  content: "\\f559";
}

.fa-award-simple::before {
  content: "\\e0ab";
}

.fa-axe::before {
  content: "\\f6b2";
}

.fa-axe-battle::before {
  content: "\\f6b3";
}

.fa-b::before {
  content: "B";
}

.fa-baby::before {
  content: "\\f77c";
}

.fa-baby-carriage::before {
  content: "\\f77d";
}

.fa-carriage-baby::before {
  content: "\\f77d";
}

.fa-backpack::before {
  content: "\\f5d4";
}

.fa-backward::before {
  content: "\\f04a";
}

.fa-backward-fast::before {
  content: "\\f049";
}

.fa-fast-backward::before {
  content: "\\f049";
}

.fa-backward-step::before {
  content: "\\f048";
}

.fa-step-backward::before {
  content: "\\f048";
}

.fa-bacon::before {
  content: "\\f7e5";
}

.fa-bacteria::before {
  content: "\\e059";
}

.fa-bacterium::before {
  content: "\\e05a";
}

.fa-badge::before {
  content: "\\f335";
}

.fa-badge-check::before {
  content: "\\f336";
}

.fa-badge-dollar::before {
  content: "\\f645";
}

.fa-badge-percent::before {
  content: "\\f646";
}

.fa-badge-sheriff::before {
  content: "\\f8a2";
}

.fa-badger-honey::before {
  content: "\\f6b4";
}

.fa-badminton::before {
  content: "\\e33a";
}

.fa-bag-shopping::before {
  content: "\\f290";
}

.fa-shopping-bag::before {
  content: "\\f290";
}

.fa-bagel::before {
  content: "\\e3d7";
}

.fa-bags-shopping::before {
  content: "\\f847";
}

.fa-baguette::before {
  content: "\\e3d8";
}

.fa-bahai::before {
  content: "\\f666";
}

.fa-baht-sign::before {
  content: "\\e0ac";
}

.fa-ball-pile::before {
  content: "\\f77e";
}

.fa-balloon::before {
  content: "\\e2e3";
}

.fa-balloons::before {
  content: "\\e2e4";
}

.fa-ballot::before {
  content: "\\f732";
}

.fa-ballot-check::before {
  content: "\\f733";
}

.fa-ban::before {
  content: "\\f05e";
}

.fa-cancel::before {
  content: "\\f05e";
}

.fa-ban-bug::before {
  content: "\\f7f9";
}

.fa-debug::before {
  content: "\\f7f9";
}

.fa-ban-parking::before {
  content: "\\f616";
}

.fa-parking-circle-slash::before {
  content: "\\f616";
}

.fa-ban-smoking::before {
  content: "\\f54d";
}

.fa-smoking-ban::before {
  content: "\\f54d";
}

.fa-banana::before {
  content: "\\e2e5";
}

.fa-bandage::before {
  content: "\\f462";
}

.fa-band-aid::before {
  content: "\\f462";
}

.fa-bangladeshi-taka-sign::before {
  content: "\\e2e6";
}

.fa-banjo::before {
  content: "\\f8a3";
}

.fa-bank::before {
  content: "\\f19c";
}

.fa-institution::before {
  content: "\\f19c";
}

.fa-university::before {
  content: "\\f19c";
}

.fa-barcode::before {
  content: "\\f02a";
}

.fa-barcode-read::before {
  content: "\\f464";
}

.fa-barcode-scan::before {
  content: "\\f465";
}

.fa-bars::before {
  content: "\\f0c9";
}

.fa-navicon::before {
  content: "\\f0c9";
}

.fa-bars-filter::before {
  content: "\\e0ad";
}

.fa-bars-progress::before {
  content: "\\f828";
}

.fa-tasks-alt::before {
  content: "\\f828";
}

.fa-bars-sort::before {
  content: "\\e0ae";
}

.fa-bars-staggered::before {
  content: "\\f550";
}

.fa-reorder::before {
  content: "\\f550";
}

.fa-stream::before {
  content: "\\f550";
}

.fa-baseball::before {
  content: "\\f433";
}

.fa-baseball-ball::before {
  content: "\\f433";
}

.fa-baseball-bat-ball::before {
  content: "\\f432";
}

.fa-basket-shopping::before {
  content: "\\f291";
}

.fa-shopping-basket::before {
  content: "\\f291";
}

.fa-basket-shopping-simple::before {
  content: "\\e0af";
}

.fa-shopping-basket-alt::before {
  content: "\\e0af";
}

.fa-basketball::before {
  content: "\\f434";
}

.fa-basketball-ball::before {
  content: "\\f434";
}

.fa-basketball-hoop::before {
  content: "\\f435";
}

.fa-bat::before {
  content: "\\f6b5";
}

.fa-bath::before {
  content: "\\f2cd";
}

.fa-bathtub::before {
  content: "\\f2cd";
}

.fa-battery-bolt::before {
  content: "\\f376";
}

.fa-battery-empty::before {
  content: "\\f244";
}

.fa-battery-0::before {
  content: "\\f244";
}

.fa-battery-exclamation::before {
  content: "\\e0b0";
}

.fa-battery-full::before {
  content: "\\f240";
}

.fa-battery::before {
  content: "\\f240";
}

.fa-battery-5::before {
  content: "\\f240";
}

.fa-battery-half::before {
  content: "\\f242";
}

.fa-battery-3::before {
  content: "\\f242";
}

.fa-battery-low::before {
  content: "\\e0b1";
}

.fa-battery-1::before {
  content: "\\e0b1";
}

.fa-battery-quarter::before {
  content: "\\f243";
}

.fa-battery-2::before {
  content: "\\f243";
}

.fa-battery-slash::before {
  content: "\\f377";
}

.fa-battery-three-quarters::before {
  content: "\\f241";
}

.fa-battery-4::before {
  content: "\\f241";
}

.fa-bed::before {
  content: "\\f236";
}

.fa-bed-bunk::before {
  content: "\\f8f8";
}

.fa-bed-empty::before {
  content: "\\f8f9";
}

.fa-bed-front::before {
  content: "\\f8f7";
}

.fa-bed-alt::before {
  content: "\\f8f7";
}

.fa-bed-pulse::before {
  content: "\\f487";
}

.fa-procedures::before {
  content: "\\f487";
}

.fa-bee::before {
  content: "\\e0b2";
}

.fa-beer-mug::before {
  content: "\\e0b3";
}

.fa-beer-foam::before {
  content: "\\e0b3";
}

.fa-beer-mug-empty::before {
  content: "\\f0fc";
}

.fa-beer::before {
  content: "\\f0fc";
}

.fa-bell::before {
  content: "\\f0f3";
}

.fa-bell-concierge::before {
  content: "\\f562";
}

.fa-concierge-bell::before {
  content: "\\f562";
}

.fa-bell-exclamation::before {
  content: "\\f848";
}

.fa-bell-on::before {
  content: "\\f8fa";
}

.fa-bell-plus::before {
  content: "\\f849";
}

.fa-bell-school::before {
  content: "\\f5d5";
}

.fa-bell-school-slash::before {
  content: "\\f5d6";
}

.fa-bell-slash::before {
  content: "\\f1f6";
}

.fa-bells::before {
  content: "\\f77f";
}

.fa-bench-tree::before {
  content: "\\e2e7";
}

.fa-bezier-curve::before {
  content: "\\f55b";
}

.fa-bicycle::before {
  content: "\\f206";
}

.fa-binary::before {
  content: "\\e33b";
}

.fa-binary-circle-check::before {
  content: "\\e33c";
}

.fa-binary-lock::before {
  content: "\\e33d";
}

.fa-binary-slash::before {
  content: "\\e33e";
}

.fa-binoculars::before {
  content: "\\f1e5";
}

.fa-biohazard::before {
  content: "\\f780";
}

.fa-bitcoin-sign::before {
  content: "\\e0b4";
}

.fa-blanket::before {
  content: "\\f498";
}

.fa-blanket-fire::before {
  content: "\\e3da";
}

.fa-blender::before {
  content: "\\f517";
}

.fa-blender-phone::before {
  content: "\\f6b6";
}

.fa-blinds::before {
  content: "\\f8fb";
}

.fa-blinds-open::before {
  content: "\\f8fc";
}

.fa-blinds-raised::before {
  content: "\\f8fd";
}

.fa-block-brick::before {
  content: "\\e3db";
}

.fa-wall-brick::before {
  content: "\\e3db";
}

.fa-block-brick-fire::before {
  content: "\\e3dc";
}

.fa-firewall::before {
  content: "\\e3dc";
}

.fa-block-question::before {
  content: "\\e3dd";
}

.fa-block-quote::before {
  content: "\\e0b5";
}

.fa-blog::before {
  content: "\\f781";
}

.fa-blueberries::before {
  content: "\\e2e8";
}

.fa-bold::before {
  content: "\\f032";
}

.fa-bolt::before {
  content: "\\f0e7";
}

.fa-flash::before {
  content: "\\f0e7";
}

.fa-bolt-auto::before {
  content: "\\e0b6";
}

.fa-bolt-lightning::before {
  content: "\\e0b7";
}

.fa-bolt-slash::before {
  content: "\\e0b8";
}

.fa-bomb::before {
  content: "\\f1e2";
}

.fa-bone::before {
  content: "\\f5d7";
}

.fa-bone-break::before {
  content: "\\f5d8";
}

.fa-bong::before {
  content: "\\f55c";
}

.fa-book::before {
  content: "\\f02d";
}

.fa-book-arrow-right::before {
  content: "\\e0b9";
}

.fa-book-arrow-up::before {
  content: "\\e0ba";
}

.fa-book-atlas::before {
  content: "\\f558";
}

.fa-atlas::before {
  content: "\\f558";
}

.fa-book-bible::before {
  content: "\\f647";
}

.fa-bible::before {
  content: "\\f647";
}

.fa-book-blank::before {
  content: "\\f5d9";
}

.fa-book-alt::before {
  content: "\\f5d9";
}

.fa-book-bookmark::before {
  content: "\\e0bb";
}

.fa-book-circle-arrow-right::before {
  content: "\\e0bc";
}

.fa-book-circle-arrow-up::before {
  content: "\\e0bd";
}

.fa-book-copy::before {
  content: "\\e0be";
}

.fa-book-font::before {
  content: "\\e0bf";
}

.fa-book-heart::before {
  content: "\\f499";
}

.fa-book-journal-whills::before {
  content: "\\f66a";
}

.fa-journal-whills::before {
  content: "\\f66a";
}

.fa-book-medical::before {
  content: "\\f7e6";
}

.fa-book-open::before {
  content: "\\f518";
}

.fa-book-open-cover::before {
  content: "\\e0c0";
}

.fa-book-open-alt::before {
  content: "\\e0c0";
}

.fa-book-open-reader::before {
  content: "\\f5da";
}

.fa-book-reader::before {
  content: "\\f5da";
}

.fa-book-quran::before {
  content: "\\f687";
}

.fa-quran::before {
  content: "\\f687";
}

.fa-book-section::before {
  content: "\\e0c1";
}

.fa-book-law::before {
  content: "\\e0c1";
}

.fa-book-skull::before {
  content: "\\f6b7";
}

.fa-book-dead::before {
  content: "\\f6b7";
}

.fa-book-sparkles::before {
  content: "\\f6b8";
}

.fa-book-spells::before {
  content: "\\f6b8";
}

.fa-book-tanakh::before {
  content: "\\f827";
}

.fa-tanakh::before {
  content: "\\f827";
}

.fa-book-user::before {
  content: "\\f7e7";
}

.fa-bookmark::before {
  content: "\\f02e";
}

.fa-bookmark-slash::before {
  content: "\\e0c2";
}

.fa-books::before {
  content: "\\f5db";
}

.fa-books-medical::before {
  content: "\\f7e8";
}

.fa-boombox::before {
  content: "\\f8a5";
}

.fa-boot::before {
  content: "\\f782";
}

.fa-boot-heeled::before {
  content: "\\e33f";
}

.fa-booth-curtain::before {
  content: "\\f734";
}

.fa-border-all::before {
  content: "\\f84c";
}

.fa-border-bottom::before {
  content: "\\f84d";
}

.fa-border-bottom-right::before {
  content: "\\f854";
}

.fa-border-style-alt::before {
  content: "\\f854";
}

.fa-border-center-h::before {
  content: "\\f89c";
}

.fa-border-center-v::before {
  content: "\\f89d";
}

.fa-border-inner::before {
  content: "\\f84e";
}

.fa-border-left::before {
  content: "\\f84f";
}

.fa-border-none::before {
  content: "\\f850";
}

.fa-border-outer::before {
  content: "\\f851";
}

.fa-border-right::before {
  content: "\\f852";
}

.fa-border-top::before {
  content: "\\f855";
}

.fa-border-top-left::before {
  content: "\\f853";
}

.fa-border-style::before {
  content: "\\f853";
}

.fa-bow-arrow::before {
  content: "\\f6b9";
}

.fa-bowl-chopsticks::before {
  content: "\\e2e9";
}

.fa-bowl-chopsticks-noodles::before {
  content: "\\e2ea";
}

.fa-bowl-hot::before {
  content: "\\f823";
}

.fa-soup::before {
  content: "\\f823";
}

.fa-bowl-rice::before {
  content: "\\e2eb";
}

.fa-bowl-scoop::before {
  content: "\\e3de";
}

.fa-bowl-shaved-ice::before {
  content: "\\e3de";
}

.fa-bowl-scoops::before {
  content: "\\e3df";
}

.fa-bowl-spoon::before {
  content: "\\e3e0";
}

.fa-bowling-ball::before {
  content: "\\f436";
}

.fa-bowling-ball-pin::before {
  content: "\\e0c3";
}

.fa-bowling-pins::before {
  content: "\\f437";
}

.fa-box::before {
  content: "\\f466";
}

.fa-box-archive::before {
  content: "\\f187";
}

.fa-archive::before {
  content: "\\f187";
}

.fa-box-ballot::before {
  content: "\\f735";
}

.fa-box-check::before {
  content: "\\f467";
}

.fa-box-circle-check::before {
  content: "\\e0c4";
}

.fa-box-dollar::before {
  content: "\\f4a0";
}

.fa-box-usd::before {
  content: "\\f4a0";
}

.fa-box-heart::before {
  content: "\\f49d";
}

.fa-box-open::before {
  content: "\\f49e";
}

.fa-box-open-full::before {
  content: "\\f49c";
}

.fa-box-full::before {
  content: "\\f49c";
}

.fa-box-taped::before {
  content: "\\f49a";
}

.fa-box-alt::before {
  content: "\\f49a";
}

.fa-box-tissue::before {
  content: "\\e05b";
}

.fa-boxes-stacked::before {
  content: "\\f468";
}

.fa-boxes::before {
  content: "\\f468";
}

.fa-boxes-alt::before {
  content: "\\f468";
}

.fa-boxing-glove::before {
  content: "\\f438";
}

.fa-glove-boxing::before {
  content: "\\f438";
}

.fa-bracket-curly::before {
  content: "\\{";
}

.fa-bracket-curly-left::before {
  content: "\\{";
}

.fa-bracket-curly-right::before {
  content: "\\}";
}

.fa-bracket-round::before {
  content: "\\(";
}

.fa-parenthesis::before {
  content: "\\(";
}

.fa-bracket-round-right::before {
  content: "\\)";
}

.fa-bracket-square::before {
  content: "\\[";
}

.fa-bracket::before {
  content: "\\[";
}

.fa-bracket-left::before {
  content: "\\[";
}

.fa-bracket-square-right::before {
  content: "\\]";
}

.fa-brackets-curly::before {
  content: "\\f7ea";
}

.fa-brackets-round::before {
  content: "\\e0c5";
}

.fa-parentheses::before {
  content: "\\e0c5";
}

.fa-brackets-square::before {
  content: "\\f7e9";
}

.fa-brackets::before {
  content: "\\f7e9";
}

.fa-braille::before {
  content: "\\f2a1";
}

.fa-brain::before {
  content: "\\f5dc";
}

.fa-brain-arrow-curved-right::before {
  content: "\\f677";
}

.fa-mind-share::before {
  content: "\\f677";
}

.fa-brain-circuit::before {
  content: "\\e0c6";
}

.fa-brake-warning::before {
  content: "\\e0c7";
}

.fa-bread-loaf::before {
  content: "\\f7eb";
}

.fa-bread-slice::before {
  content: "\\f7ec";
}

.fa-bread-slice-butter::before {
  content: "\\e3e1";
}

.fa-briefcase::before {
  content: "\\f0b1";
}

.fa-briefcase-arrow-right::before {
  content: "\\e2f2";
}

.fa-briefcase-blank::before {
  content: "\\e0c8";
}

.fa-briefcase-medical::before {
  content: "\\f469";
}

.fa-brightness::before {
  content: "\\e0c9";
}

.fa-brightness-low::before {
  content: "\\e0ca";
}

.fa-bring-forward::before {
  content: "\\f856";
}

.fa-bring-front::before {
  content: "\\f857";
}

.fa-broccoli::before {
  content: "\\e3e2";
}

.fa-broom::before {
  content: "\\f51a";
}

.fa-browser::before {
  content: "\\f37e";
}

.fa-browsers::before {
  content: "\\e0cb";
}

.fa-brush::before {
  content: "\\f55d";
}

.fa-bug::before {
  content: "\\f188";
}

.fa-building::before {
  content: "\\f1ad";
}

.fa-buildings::before {
  content: "\\e0cc";
}

.fa-bullhorn::before {
  content: "\\f0a1";
}

.fa-bullseye::before {
  content: "\\f140";
}

.fa-bullseye-arrow::before {
  content: "\\f648";
}

.fa-bullseye-pointer::before {
  content: "\\f649";
}

.fa-burger::before {
  content: "\\f805";
}

.fa-hamburger::before {
  content: "\\f805";
}

.fa-burger-cheese::before {
  content: "\\f7f1";
}

.fa-cheeseburger::before {
  content: "\\f7f1";
}

.fa-burger-fries::before {
  content: "\\e0cd";
}

.fa-burger-glass::before {
  content: "\\e0ce";
}

.fa-burger-lettuce::before {
  content: "\\e3e3";
}

.fa-burger-soda::before {
  content: "\\f858";
}

.fa-burrito::before {
  content: "\\f7ed";
}

.fa-bus::before {
  content: "\\f207";
}

.fa-bus-school::before {
  content: "\\f5dd";
}

.fa-bus-simple::before {
  content: "\\f55e";
}

.fa-bus-alt::before {
  content: "\\f55e";
}

.fa-business-time::before {
  content: "\\f64a";
}

.fa-briefcase-clock::before {
  content: "\\f64a";
}

.fa-butter::before {
  content: "\\e3e4";
}

.fa-c::before {
  content: "C";
}

.fa-cabinet-filing::before {
  content: "\\f64b";
}

.fa-cable-car::before {
  content: "\\e0cf";
}

.fa-cactus::before {
  content: "\\f8a7";
}

.fa-cake-candles::before {
  content: "\\f1fd";
}

.fa-birthday-cake::before {
  content: "\\f1fd";
}

.fa-cake-slice::before {
  content: "\\e3e5";
}

.fa-shortcake::before {
  content: "\\e3e5";
}

.fa-calculator::before {
  content: "\\f1ec";
}

.fa-calculator-simple::before {
  content: "\\f64c";
}

.fa-calculator-alt::before {
  content: "\\f64c";
}

.fa-calendar::before {
  content: "\\f133";
}

.fa-calendar-arrow-down::before {
  content: "\\e0d0";
}

.fa-calendar-download::before {
  content: "\\e0d0";
}

.fa-calendar-arrow-up::before {
  content: "\\e0d1";
}

.fa-calendar-upload::before {
  content: "\\e0d1";
}

.fa-calendar-check::before {
  content: "\\f274";
}

.fa-calendar-clock::before {
  content: "\\e0d2";
}

.fa-calendar-time::before {
  content: "\\e0d2";
}

.fa-calendar-day::before {
  content: "\\f783";
}

.fa-calendar-days::before {
  content: "\\f073";
}

.fa-calendar-alt::before {
  content: "\\f073";
}

.fa-calendar-exclamation::before {
  content: "\\f334";
}

.fa-calendar-heart::before {
  content: "\\e0d3";
}

.fa-calendar-image::before {
  content: "\\e0d4";
}

.fa-calendar-lines::before {
  content: "\\e0d5";
}

.fa-calendar-note::before {
  content: "\\e0d5";
}

.fa-calendar-minus::before {
  content: "\\f272";
}

.fa-calendar-pen::before {
  content: "\\f333";
}

.fa-calendar-edit::before {
  content: "\\f333";
}

.fa-calendar-plus::before {
  content: "\\f271";
}

.fa-calendar-range::before {
  content: "\\e0d6";
}

.fa-calendar-star::before {
  content: "\\f736";
}

.fa-calendar-week::before {
  content: "\\f784";
}

.fa-calendar-xmark::before {
  content: "\\f273";
}

.fa-calendar-times::before {
  content: "\\f273";
}

.fa-calendars::before {
  content: "\\e0d7";
}

.fa-camcorder::before {
  content: "\\f8a8";
}

.fa-video-handheld::before {
  content: "\\f8a8";
}

.fa-camera::before {
  content: "\\f030";
}

.fa-camera-alt::before {
  content: "\\f030";
}

.fa-camera-cctv::before {
  content: "\\f8ac";
}

.fa-cctv::before {
  content: "\\f8ac";
}

.fa-camera-movie::before {
  content: "\\f8a9";
}

.fa-camera-polaroid::before {
  content: "\\f8aa";
}

.fa-camera-retro::before {
  content: "\\f083";
}

.fa-camera-rotate::before {
  content: "\\e0d8";
}

.fa-camera-security::before {
  content: "\\f8fe";
}

.fa-camera-home::before {
  content: "\\f8fe";
}

.fa-camera-slash::before {
  content: "\\e0d9";
}

.fa-camera-viewfinder::before {
  content: "\\e0da";
}

.fa-camera-web::before {
  content: "\\f832";
}

.fa-webcam::before {
  content: "\\f832";
}

.fa-camera-web-slash::before {
  content: "\\f833";
}

.fa-webcam-slash::before {
  content: "\\f833";
}

.fa-campfire::before {
  content: "\\f6ba";
}

.fa-campground::before {
  content: "\\f6bb";
}

.fa-can-food::before {
  content: "\\e3e6";
}

.fa-candle-holder::before {
  content: "\\f6bc";
}

.fa-candy::before {
  content: "\\e3e7";
}

.fa-candy-bar::before {
  content: "\\e3e8";
}

.fa-chocolate-bar::before {
  content: "\\e3e8";
}

.fa-candy-cane::before {
  content: "\\f786";
}

.fa-candy-corn::before {
  content: "\\f6bd";
}

.fa-cannabis::before {
  content: "\\f55f";
}

.fa-capsules::before {
  content: "\\f46b";
}

.fa-car::before {
  content: "\\f1b9";
}

.fa-automobile::before {
  content: "\\f1b9";
}

.fa-car-battery::before {
  content: "\\f5df";
}

.fa-battery-car::before {
  content: "\\f5df";
}

.fa-car-bolt::before {
  content: "\\e341";
}

.fa-car-building::before {
  content: "\\f859";
}

.fa-car-bump::before {
  content: "\\f5e0";
}

.fa-car-bus::before {
  content: "\\f85a";
}

.fa-car-circle-bolt::before {
  content: "\\e342";
}

.fa-car-crash::before {
  content: "\\f5e1";
}

.fa-car-garage::before {
  content: "\\f5e2";
}

.fa-car-mirrors::before {
  content: "\\e343";
}

.fa-car-rear::before {
  content: "\\f5de";
}

.fa-car-alt::before {
  content: "\\f5de";
}

.fa-car-side::before {
  content: "\\f5e4";
}

.fa-car-side-bolt::before {
  content: "\\e344";
}

.fa-car-tilt::before {
  content: "\\f5e5";
}

.fa-car-wash::before {
  content: "\\f5e6";
}

.fa-car-wrench::before {
  content: "\\f5e3";
}

.fa-car-mechanic::before {
  content: "\\f5e3";
}

.fa-caravan::before {
  content: "\\f8ff";
}

.fa-caravan-simple::before {
  content: "\\e000";
}

.fa-caravan-alt::before {
  content: "\\e000";
}

.fa-card-club::before {
  content: "\\e3e9";
}

.fa-card-diamond::before {
  content: "\\e3ea";
}

.fa-card-heart::before {
  content: "\\e3eb";
}

.fa-card-spade::before {
  content: "\\e3ec";
}

.fa-cards::before {
  content: "\\e3ed";
}

.fa-caret-down::before {
  content: "\\f0d7";
}

.fa-caret-left::before {
  content: "\\f0d9";
}

.fa-caret-right::before {
  content: "\\f0da";
}

.fa-caret-up::before {
  content: "\\f0d8";
}

.fa-carrot::before {
  content: "\\f787";
}

.fa-cars::before {
  content: "\\f85b";
}

.fa-cart-arrow-down::before {
  content: "\\f218";
}

.fa-cart-arrow-up::before {
  content: "\\e3ee";
}

.fa-cart-circle-arrow-down::before {
  content: "\\e3ef";
}

.fa-cart-circle-arrow-up::before {
  content: "\\e3f0";
}

.fa-cart-circle-check::before {
  content: "\\e3f1";
}

.fa-cart-circle-exclamation::before {
  content: "\\e3f2";
}

.fa-cart-circle-plus::before {
  content: "\\e3f3";
}

.fa-cart-circle-xmark::before {
  content: "\\e3f4";
}

.fa-cart-flatbed::before {
  content: "\\f474";
}

.fa-dolly-flatbed::before {
  content: "\\f474";
}

.fa-cart-flatbed-boxes::before {
  content: "\\f475";
}

.fa-dolly-flatbed-alt::before {
  content: "\\f475";
}

.fa-cart-flatbed-empty::before {
  content: "\\f476";
}

.fa-dolly-flatbed-empty::before {
  content: "\\f476";
}

.fa-cart-flatbed-suitcase::before {
  content: "\\f59d";
}

.fa-luggage-cart::before {
  content: "\\f59d";
}

.fa-cart-minus::before {
  content: "\\e0db";
}

.fa-cart-plus::before {
  content: "\\f217";
}

.fa-cart-shopping::before {
  content: "\\f07a";
}

.fa-shopping-cart::before {
  content: "\\f07a";
}

.fa-cart-shopping-fast::before {
  content: "\\e0dc";
}

.fa-cart-xmark::before {
  content: "\\e0dd";
}

.fa-cash-register::before {
  content: "\\f788";
}

.fa-cassette-betamax::before {
  content: "\\f8a4";
}

.fa-betamax::before {
  content: "\\f8a4";
}

.fa-cassette-tape::before {
  content: "\\f8ab";
}

.fa-cassette-vhs::before {
  content: "\\f8ec";
}

.fa-vhs::before {
  content: "\\f8ec";
}

.fa-castle::before {
  content: "\\e0de";
}

.fa-cat::before {
  content: "\\f6be";
}

.fa-cat-space::before {
  content: "\\e001";
}

.fa-cauldron::before {
  content: "\\f6bf";
}

.fa-cedi-sign::before {
  content: "\\e0df";
}

.fa-cent-sign::before {
  content: "\\e3f5";
}

.fa-certificate::before {
  content: "\\f0a3";
}

.fa-chair::before {
  content: "\\f6c0";
}

.fa-chair-office::before {
  content: "\\f6c1";
}

.fa-chalkboard::before {
  content: "\\f51b";
}

.fa-blackboard::before {
  content: "\\f51b";
}

.fa-chalkboard-user::before {
  content: "\\f51c";
}

.fa-chalkboard-teacher::before {
  content: "\\f51c";
}

.fa-champagne-glass::before {
  content: "\\f79e";
}

.fa-glass-champagne::before {
  content: "\\f79e";
}

.fa-champagne-glasses::before {
  content: "\\f79f";
}

.fa-glass-cheers::before {
  content: "\\f79f";
}

.fa-charging-station::before {
  content: "\\f5e7";
}

.fa-chart-area::before {
  content: "\\f1fe";
}

.fa-area-chart::before {
  content: "\\f1fe";
}

.fa-chart-bar::before {
  content: "\\f080";
}

.fa-bar-chart::before {
  content: "\\f080";
}

.fa-chart-bullet::before {
  content: "\\e0e1";
}

.fa-chart-candlestick::before {
  content: "\\e0e2";
}

.fa-chart-column::before {
  content: "\\e0e3";
}

.fa-chart-gantt::before {
  content: "\\e0e4";
}

.fa-chart-line::before {
  content: "\\f201";
}

.fa-line-chart::before {
  content: "\\f201";
}

.fa-chart-line-down::before {
  content: "\\f64d";
}

.fa-chart-line-up::before {
  content: "\\e0e5";
}

.fa-chart-mixed::before {
  content: "\\f643";
}

.fa-analytics::before {
  content: "\\f643";
}

.fa-chart-network::before {
  content: "\\f78a";
}

.fa-chart-pie::before {
  content: "\\f200";
}

.fa-pie-chart::before {
  content: "\\f200";
}

.fa-chart-pie-simple::before {
  content: "\\f64e";
}

.fa-chart-pie-alt::before {
  content: "\\f64e";
}

.fa-chart-pyramid::before {
  content: "\\e0e6";
}

.fa-chart-radar::before {
  content: "\\e0e7";
}

.fa-chart-scatter::before {
  content: "\\f7ee";
}

.fa-chart-scatter-3d::before {
  content: "\\e0e8";
}

.fa-chart-scatter-bubble::before {
  content: "\\e0e9";
}

.fa-chart-tree-map::before {
  content: "\\e0ea";
}

.fa-chart-user::before {
  content: "\\f6a3";
}

.fa-user-chart::before {
  content: "\\f6a3";
}

.fa-chart-waterfall::before {
  content: "\\e0eb";
}

.fa-check::before {
  content: "\\f00c";
}

.fa-check-double::before {
  content: "\\f560";
}

.fa-check-to-slot::before {
  content: "\\f772";
}

.fa-vote-yea::before {
  content: "\\f772";
}

.fa-cheese::before {
  content: "\\f7ef";
}

.fa-cheese-swiss::before {
  content: "\\f7f0";
}

.fa-cherries::before {
  content: "\\e0ec";
}

.fa-chess::before {
  content: "\\f439";
}

.fa-chess-bishop::before {
  content: "\\f43a";
}

.fa-chess-bishop-piece::before {
  content: "\\f43b";
}

.fa-chess-bishop-alt::before {
  content: "\\f43b";
}

.fa-chess-board::before {
  content: "\\f43c";
}

.fa-chess-clock::before {
  content: "\\f43d";
}

.fa-chess-clock-flip::before {
  content: "\\f43e";
}

.fa-chess-clock-alt::before {
  content: "\\f43e";
}

.fa-chess-king::before {
  content: "\\f43f";
}

.fa-chess-king-piece::before {
  content: "\\f440";
}

.fa-chess-king-alt::before {
  content: "\\f440";
}

.fa-chess-knight::before {
  content: "\\f441";
}

.fa-chess-knight-piece::before {
  content: "\\f442";
}

.fa-chess-knight-alt::before {
  content: "\\f442";
}

.fa-chess-pawn::before {
  content: "\\f443";
}

.fa-chess-pawn-piece::before {
  content: "\\f444";
}

.fa-chess-pawn-alt::before {
  content: "\\f444";
}

.fa-chess-queen::before {
  content: "\\f445";
}

.fa-chess-queen-piece::before {
  content: "\\f446";
}

.fa-chess-queen-alt::before {
  content: "\\f446";
}

.fa-chess-rook::before {
  content: "\\f447";
}

.fa-chess-rook-piece::before {
  content: "\\f448";
}

.fa-chess-rook-alt::before {
  content: "\\f448";
}

.fa-chestnut::before {
  content: "\\e3f6";
}

.fa-chevron-down::before {
  content: "\\f078";
}

.fa-chevron-left::before {
  content: "\\f053";
}

.fa-chevron-right::before {
  content: "\\f054";
}

.fa-chevron-up::before {
  content: "\\f077";
}

.fa-chevrons-down::before {
  content: "\\f322";
}

.fa-chevron-double-down::before {
  content: "\\f322";
}

.fa-chevrons-left::before {
  content: "\\f323";
}

.fa-chevron-double-left::before {
  content: "\\f323";
}

.fa-chevrons-right::before {
  content: "\\f324";
}

.fa-chevron-double-right::before {
  content: "\\f324";
}

.fa-chevrons-up::before {
  content: "\\f325";
}

.fa-chevron-double-up::before {
  content: "\\f325";
}

.fa-child::before {
  content: "\\f1ae";
}

.fa-chimney::before {
  content: "\\f78b";
}

.fa-chopsticks::before {
  content: "\\e3f7";
}

.fa-church::before {
  content: "\\f51d";
}

.fa-circle::before {
  content: "\\f111";
}

.fa-circle-0::before {
  content: "\\e0ed";
}

.fa-circle-1::before {
  content: "\\e0ee";
}

.fa-circle-2::before {
  content: "\\e0ef";
}

.fa-circle-3::before {
  content: "\\e0f0";
}

.fa-circle-4::before {
  content: "\\e0f1";
}

.fa-circle-5::before {
  content: "\\e0f2";
}

.fa-circle-6::before {
  content: "\\e0f3";
}

.fa-circle-7::before {
  content: "\\e0f4";
}

.fa-circle-8::before {
  content: "\\e0f5";
}

.fa-circle-9::before {
  content: "\\e0f6";
}

.fa-circle-a::before {
  content: "\\e0f7";
}

.fa-circle-ampersand::before {
  content: "\\e0f8";
}

.fa-circle-arrow-down::before {
  content: "\\f0ab";
}

.fa-arrow-circle-down::before {
  content: "\\f0ab";
}

.fa-circle-arrow-down-left::before {
  content: "\\e0f9";
}

.fa-circle-arrow-down-right::before {
  content: "\\e0fa";
}

.fa-circle-arrow-left::before {
  content: "\\f0a8";
}

.fa-arrow-circle-left::before {
  content: "\\f0a8";
}

.fa-circle-arrow-right::before {
  content: "\\f0a9";
}

.fa-arrow-circle-right::before {
  content: "\\f0a9";
}

.fa-circle-arrow-up::before {
  content: "\\f0aa";
}

.fa-arrow-circle-up::before {
  content: "\\f0aa";
}

.fa-circle-arrow-up-left::before {
  content: "\\e0fb";
}

.fa-circle-arrow-up-right::before {
  content: "\\e0fc";
}

.fa-circle-b::before {
  content: "\\e0fd";
}

.fa-circle-bolt::before {
  content: "\\e0fe";
}

.fa-circle-book-open::before {
  content: "\\e0ff";
}

.fa-book-circle::before {
  content: "\\e0ff";
}

.fa-circle-bookmark::before {
  content: "\\e100";
}

.fa-bookmark-circle::before {
  content: "\\e100";
}

.fa-circle-c::before {
  content: "\\e101";
}

.fa-circle-calendar::before {
  content: "\\e102";
}

.fa-calendar-circle::before {
  content: "\\e102";
}

.fa-circle-camera::before {
  content: "\\e103";
}

.fa-camera-circle::before {
  content: "\\e103";
}

.fa-circle-caret-down::before {
  content: "\\f32d";
}

.fa-caret-circle-down::before {
  content: "\\f32d";
}

.fa-circle-caret-left::before {
  content: "\\f32e";
}

.fa-caret-circle-left::before {
  content: "\\f32e";
}

.fa-circle-caret-right::before {
  content: "\\f330";
}

.fa-caret-circle-right::before {
  content: "\\f330";
}

.fa-circle-caret-up::before {
  content: "\\f331";
}

.fa-caret-circle-up::before {
  content: "\\f331";
}

.fa-circle-check::before {
  content: "\\f058";
}

.fa-check-circle::before {
  content: "\\f058";
}

.fa-circle-chevron-down::before {
  content: "\\f13a";
}

.fa-chevron-circle-down::before {
  content: "\\f13a";
}

.fa-circle-chevron-left::before {
  content: "\\f137";
}

.fa-chevron-circle-left::before {
  content: "\\f137";
}

.fa-circle-chevron-right::before {
  content: "\\f138";
}

.fa-chevron-circle-right::before {
  content: "\\f138";
}

.fa-circle-chevron-up::before {
  content: "\\f139";
}

.fa-chevron-circle-up::before {
  content: "\\f139";
}

.fa-circle-d::before {
  content: "\\e104";
}

.fa-circle-dashed::before {
  content: "\\e105";
}

.fa-circle-divide::before {
  content: "\\e106";
}

.fa-circle-dollar::before {
  content: "\\f2e8";
}

.fa-dollar-circle::before {
  content: "\\f2e8";
}

.fa-usd-circle::before {
  content: "\\f2e8";
}

.fa-circle-dollar-to-slot::before {
  content: "\\f4b9";
}

.fa-donate::before {
  content: "\\f4b9";
}

.fa-circle-dot::before {
  content: "\\f192";
}

.fa-dot-circle::before {
  content: "\\f192";
}

.fa-circle-down::before {
  content: "\\f358";
}

.fa-arrow-alt-circle-down::before {
  content: "\\f358";
}

.fa-circle-down-left::before {
  content: "\\e107";
}

.fa-circle-down-right::before {
  content: "\\e108";
}

.fa-circle-e::before {
  content: "\\e109";
}

.fa-circle-ellipsis::before {
  content: "\\e10a";
}

.fa-circle-ellipsis-vertical::before {
  content: "\\e10b";
}

.fa-circle-envelope::before {
  content: "\\e10c";
}

.fa-envelope-circle::before {
  content: "\\e10c";
}

.fa-circle-exclamation::before {
  content: "\\f06a";
}

.fa-exclamation-circle::before {
  content: "\\f06a";
}

.fa-circle-exclamation-check::before {
  content: "\\e10d";
}

.fa-circle-f::before {
  content: "\\e10e";
}

.fa-circle-g::before {
  content: "\\e10f";
}

.fa-circle-h::before {
  content: "\\f47e";
}

.fa-hospital-symbol::before {
  content: "\\f47e";
}

.fa-circle-half::before {
  content: "\\e110";
}

.fa-circle-half-stroke::before {
  content: "\\f042";
}

.fa-adjust::before {
  content: "\\f042";
}

.fa-circle-heart::before {
  content: "\\f4c7";
}

.fa-heart-circle::before {
  content: "\\f4c7";
}

.fa-circle-i::before {
  content: "\\e111";
}

.fa-circle-info::before {
  content: "\\f05a";
}

.fa-info-circle::before {
  content: "\\f05a";
}

.fa-circle-j::before {
  content: "\\e112";
}

.fa-circle-k::before {
  content: "\\e113";
}

.fa-circle-l::before {
  content: "\\e114";
}

.fa-circle-left::before {
  content: "\\f359";
}

.fa-arrow-alt-circle-left::before {
  content: "\\f359";
}

.fa-circle-location-arrow::before {
  content: "\\f602";
}

.fa-location-circle::before {
  content: "\\f602";
}

.fa-circle-m::before {
  content: "\\e115";
}

.fa-circle-microphone::before {
  content: "\\e116";
}

.fa-microphone-circle::before {
  content: "\\e116";
}

.fa-circle-microphone-lines::before {
  content: "\\e117";
}

.fa-microphone-circle-alt::before {
  content: "\\e117";
}

.fa-circle-minus::before {
  content: "\\f056";
}

.fa-minus-circle::before {
  content: "\\f056";
}

.fa-circle-n::before {
  content: "\\e118";
}

.fa-circle-notch::before {
  content: "\\f1ce";
}

.fa-circle-o::before {
  content: "\\e119";
}

.fa-circle-p::before {
  content: "\\e11a";
}

.fa-circle-parking::before {
  content: "\\f615";
}

.fa-parking-circle::before {
  content: "\\f615";
}

.fa-circle-pause::before {
  content: "\\f28b";
}

.fa-pause-circle::before {
  content: "\\f28b";
}

.fa-circle-phone::before {
  content: "\\e11b";
}

.fa-phone-circle::before {
  content: "\\e11b";
}

.fa-circle-phone-flip::before {
  content: "\\e11c";
}

.fa-phone-circle-alt::before {
  content: "\\e11c";
}

.fa-circle-phone-hangup::before {
  content: "\\e11d";
}

.fa-phone-circle-down::before {
  content: "\\e11d";
}

.fa-circle-play::before {
  content: "\\f144";
}

.fa-play-circle::before {
  content: "\\f144";
}

.fa-circle-plus::before {
  content: "\\f055";
}

.fa-plus-circle::before {
  content: "\\f055";
}

.fa-circle-q::before {
  content: "\\e11e";
}

.fa-circle-quarter::before {
  content: "\\e11f";
}

.fa-circle-quarters::before {
  content: "\\e3f8";
}

.fa-circle-question::before {
  content: "\\f059";
}

.fa-question-circle::before {
  content: "\\f059";
}

.fa-circle-r::before {
  content: "\\e120";
}

.fa-circle-radiation::before {
  content: "\\f7ba";
}

.fa-radiation-alt::before {
  content: "\\f7ba";
}

.fa-circle-right::before {
  content: "\\f35a";
}

.fa-arrow-alt-circle-right::before {
  content: "\\f35a";
}

.fa-circle-s::before {
  content: "\\e121";
}

.fa-circle-small::before {
  content: "\\e122";
}

.fa-circle-sort::before {
  content: "\\e030";
}

.fa-sort-circle::before {
  content: "\\e030";
}

.fa-circle-sort-down::before {
  content: "\\e031";
}

.fa-sort-circle-down::before {
  content: "\\e031";
}

.fa-circle-sort-up::before {
  content: "\\e032";
}

.fa-sort-circle-up::before {
  content: "\\e032";
}

.fa-circle-star::before {
  content: "\\e123";
}

.fa-star-circle::before {
  content: "\\e123";
}

.fa-circle-stop::before {
  content: "\\f28d";
}

.fa-stop-circle::before {
  content: "\\f28d";
}

.fa-circle-t::before {
  content: "\\e124";
}

.fa-circle-three-quarters::before {
  content: "\\e125";
}

.fa-circle-trash::before {
  content: "\\e126";
}

.fa-trash-circle::before {
  content: "\\e126";
}

.fa-circle-u::before {
  content: "\\e127";
}

.fa-circle-up::before {
  content: "\\f35b";
}

.fa-arrow-alt-circle-up::before {
  content: "\\f35b";
}

.fa-circle-up-left::before {
  content: "\\e128";
}

.fa-circle-up-right::before {
  content: "\\e129";
}

.fa-circle-user::before {
  content: "\\f2bd";
}

.fa-user-circle::before {
  content: "\\f2bd";
}

.fa-circle-v::before {
  content: "\\e12a";
}

.fa-circle-video::before {
  content: "\\e12b";
}

.fa-video-circle::before {
  content: "\\e12b";
}

.fa-circle-w::before {
  content: "\\e12c";
}

.fa-circle-waveform-lines::before {
  content: "\\e12d";
}

.fa-waveform-circle::before {
  content: "\\e12d";
}

.fa-circle-x::before {
  content: "\\e12e";
}

.fa-circle-xmark::before {
  content: "\\f057";
}

.fa-times-circle::before {
  content: "\\f057";
}

.fa-xmark-circle::before {
  content: "\\f057";
}

.fa-circle-y::before {
  content: "\\e12f";
}

.fa-circle-z::before {
  content: "\\e130";
}

.fa-citrus::before {
  content: "\\e2f4";
}

.fa-citrus-slice::before {
  content: "\\e2f5";
}

.fa-city::before {
  content: "\\f64f";
}

.fa-clapperboard::before {
  content: "\\e131";
}

.fa-clapperboard-play::before {
  content: "\\e132";
}

.fa-clarinet::before {
  content: "\\f8ad";
}

.fa-claw-marks::before {
  content: "\\f6c2";
}

.fa-clipboard::before {
  content: "\\f328";
}

.fa-clipboard-check::before {
  content: "\\f46c";
}

.fa-clipboard-list::before {
  content: "\\f46d";
}

.fa-clipboard-list-check::before {
  content: "\\f737";
}

.fa-clipboard-medical::before {
  content: "\\e133";
}

.fa-clipboard-prescription::before {
  content: "\\f5e8";
}

.fa-clipboard-user::before {
  content: "\\f7f3";
}

.fa-clock::before {
  content: "\\f017";
}

.fa-clock-four::before {
  content: "\\f017";
}

.fa-clock-desk::before {
  content: "\\e134";
}

.fa-clock-eight::before {
  content: "\\e345";
}

.fa-clock-eight-thirty::before {
  content: "\\e346";
}

.fa-clock-eleven::before {
  content: "\\e347";
}

.fa-clock-eleven-thirty::before {
  content: "\\e348";
}

.fa-clock-five::before {
  content: "\\e349";
}

.fa-clock-five-thirty::before {
  content: "\\e34a";
}

.fa-clock-four-thirty::before {
  content: "\\e34b";
}

.fa-clock-nine::before {
  content: "\\e34c";
}

.fa-clock-nine-thirty::before {
  content: "\\e34d";
}

.fa-clock-one::before {
  content: "\\e34e";
}

.fa-clock-one-thirty::before {
  content: "\\e34f";
}

.fa-clock-rotate-left::before {
  content: "\\f1da";
}

.fa-history::before {
  content: "\\f1da";
}

.fa-clock-seven::before {
  content: "\\e350";
}

.fa-clock-seven-thirty::before {
  content: "\\e351";
}

.fa-clock-six::before {
  content: "\\e352";
}

.fa-clock-six-thirty::before {
  content: "\\e353";
}

.fa-clock-ten::before {
  content: "\\e354";
}

.fa-clock-ten-thirty::before {
  content: "\\e355";
}

.fa-clock-three::before {
  content: "\\e356";
}

.fa-clock-three-thirty::before {
  content: "\\e357";
}

.fa-clock-twelve::before {
  content: "\\e358";
}

.fa-clock-twelve-thirty::before {
  content: "\\e359";
}

.fa-clock-two::before {
  content: "\\e35a";
}

.fa-clock-two-thirty::before {
  content: "\\e35b";
}

.fa-clone::before {
  content: "\\f24d";
}

.fa-closed-captioning::before {
  content: "\\f20a";
}

.fa-closed-captioning-slash::before {
  content: "\\e135";
}

.fa-clothes-hanger::before {
  content: "\\e136";
}

.fa-cloud::before {
  content: "\\f0c2";
}

.fa-cloud-arrow-down::before {
  content: "\\f0ed";
}

.fa-cloud-download::before {
  content: "\\f0ed";
}

.fa-cloud-download-alt::before {
  content: "\\f0ed";
}

.fa-cloud-arrow-up::before {
  content: "\\f0ee";
}

.fa-cloud-upload::before {
  content: "\\f0ee";
}

.fa-cloud-upload-alt::before {
  content: "\\f0ee";
}

.fa-cloud-bolt::before {
  content: "\\f76c";
}

.fa-thunderstorm::before {
  content: "\\f76c";
}

.fa-cloud-bolt-moon::before {
  content: "\\f76d";
}

.fa-thunderstorm-moon::before {
  content: "\\f76d";
}

.fa-cloud-bolt-sun::before {
  content: "\\f76e";
}

.fa-thunderstorm-sun::before {
  content: "\\f76e";
}

.fa-cloud-check::before {
  content: "\\e35c";
}

.fa-cloud-drizzle::before {
  content: "\\f738";
}

.fa-cloud-fog::before {
  content: "\\f74e";
}

.fa-fog::before {
  content: "\\f74e";
}

.fa-cloud-hail::before {
  content: "\\f739";
}

.fa-cloud-hail-mixed::before {
  content: "\\f73a";
}

.fa-cloud-meatball::before {
  content: "\\f73b";
}

.fa-cloud-minus::before {
  content: "\\e35d";
}

.fa-cloud-moon::before {
  content: "\\f6c3";
}

.fa-cloud-moon-rain::before {
  content: "\\f73c";
}

.fa-cloud-music::before {
  content: "\\f8ae";
}

.fa-cloud-plus::before {
  content: "\\e35e";
}

.fa-cloud-rain::before {
  content: "\\f73d";
}

.fa-cloud-rainbow::before {
  content: "\\f73e";
}

.fa-cloud-showers::before {
  content: "\\f73f";
}

.fa-cloud-showers-heavy::before {
  content: "\\f740";
}

.fa-cloud-slash::before {
  content: "\\e137";
}

.fa-cloud-sleet::before {
  content: "\\f741";
}

.fa-cloud-snow::before {
  content: "\\f742";
}

.fa-cloud-sun::before {
  content: "\\f6c4";
}

.fa-cloud-sun-rain::before {
  content: "\\f743";
}

.fa-cloud-word::before {
  content: "\\e138";
}

.fa-cloud-xmark::before {
  content: "\\e35f";
}

.fa-clouds::before {
  content: "\\f744";
}

.fa-clouds-moon::before {
  content: "\\f745";
}

.fa-clouds-sun::before {
  content: "\\f746";
}

.fa-clover::before {
  content: "\\e139";
}

.fa-club::before {
  content: "\\f327";
}

.fa-coconut::before {
  content: "\\e2f6";
}

.fa-code::before {
  content: "\\f121";
}

.fa-code-branch::before {
  content: "\\f126";
}

.fa-code-commit::before {
  content: "\\f386";
}

.fa-code-compare::before {
  content: "\\e13a";
}

.fa-code-fork::before {
  content: "\\e13b";
}

.fa-code-merge::before {
  content: "\\f387";
}

.fa-code-pull-request::before {
  content: "\\e13c";
}

.fa-code-pull-request-closed::before {
  content: "\\e3f9";
}

.fa-code-pull-request-draft::before {
  content: "\\e3fa";
}

.fa-code-simple::before {
  content: "\\e13d";
}

.fa-coffee-bean::before {
  content: "\\e13e";
}

.fa-coffee-beans::before {
  content: "\\e13f";
}

.fa-coffee-pot::before {
  content: "\\e002";
}

.fa-coffin::before {
  content: "\\f6c6";
}

.fa-coffin-cross::before {
  content: "\\e051";
}

.fa-coin::before {
  content: "\\f85c";
}

.fa-coin-blank::before {
  content: "\\e3fb";
}

.fa-coin-front::before {
  content: "\\e3fc";
}

.fa-coin-vertical::before {
  content: "\\e3fd";
}

.fa-coins::before {
  content: "\\f51e";
}

.fa-colon::before {
  content: "\\:";
}

.fa-colon-sign::before {
  content: "\\e140";
}

.fa-columns-3::before {
  content: "\\e361";
}

.fa-comet::before {
  content: "\\e003";
}

.fa-comma::before {
  content: "\\,";
}

.fa-command::before {
  content: "\\e142";
}

.fa-comment::before {
  content: "\\f075";
}

.fa-comment-arrow-down::before {
  content: "\\e143";
}

.fa-comment-arrow-up::before {
  content: "\\e144";
}

.fa-comment-arrow-up-right::before {
  content: "\\e145";
}

.fa-comment-captions::before {
  content: "\\e146";
}

.fa-comment-check::before {
  content: "\\f4ac";
}

.fa-comment-code::before {
  content: "\\e147";
}

.fa-comment-dollar::before {
  content: "\\f651";
}

.fa-comment-dots::before {
  content: "\\f4ad";
}

.fa-commenting::before {
  content: "\\f4ad";
}

.fa-comment-exclamation::before {
  content: "\\f4af";
}

.fa-comment-image::before {
  content: "\\e148";
}

.fa-comment-lines::before {
  content: "\\f4b0";
}

.fa-comment-medical::before {
  content: "\\f7f5";
}

.fa-comment-middle::before {
  content: "\\e149";
}

.fa-comment-middle-top::before {
  content: "\\e14a";
}

.fa-comment-minus::before {
  content: "\\f4b1";
}

.fa-comment-music::before {
  content: "\\f8b0";
}

.fa-comment-pen::before {
  content: "\\f4ae";
}

.fa-comment-edit::before {
  content: "\\f4ae";
}

.fa-comment-plus::before {
  content: "\\f4b2";
}

.fa-comment-question::before {
  content: "\\e14b";
}

.fa-comment-quote::before {
  content: "\\e14c";
}

.fa-comment-slash::before {
  content: "\\f4b3";
}

.fa-comment-smile::before {
  content: "\\f4b4";
}

.fa-comment-sms::before {
  content: "\\f7cd";
}

.fa-sms::before {
  content: "\\f7cd";
}

.fa-comment-text::before {
  content: "\\e14d";
}

.fa-comment-xmark::before {
  content: "\\f4b5";
}

.fa-comment-times::before {
  content: "\\f4b5";
}

.fa-comments::before {
  content: "\\f086";
}

.fa-comments-dollar::before {
  content: "\\f653";
}

.fa-comments-question::before {
  content: "\\e14e";
}

.fa-comments-question-check::before {
  content: "\\e14f";
}

.fa-compact-disc::before {
  content: "\\f51f";
}

.fa-compass::before {
  content: "\\f14e";
}

.fa-compass-drafting::before {
  content: "\\f568";
}

.fa-drafting-compass::before {
  content: "\\f568";
}

.fa-compass-slash::before {
  content: "\\f5e9";
}

.fa-compress::before {
  content: "\\f066";
}

.fa-compress-wide::before {
  content: "\\f326";
}

.fa-computer-classic::before {
  content: "\\f8b1";
}

.fa-computer-mouse::before {
  content: "\\f8cc";
}

.fa-mouse::before {
  content: "\\f8cc";
}

.fa-computer-mouse-scrollwheel::before {
  content: "\\f8cd";
}

.fa-mouse-alt::before {
  content: "\\f8cd";
}

.fa-computer-speaker::before {
  content: "\\f8b2";
}

.fa-container-storage::before {
  content: "\\f4b7";
}

.fa-conveyor-belt::before {
  content: "\\f46e";
}

.fa-conveyor-belt-boxes::before {
  content: "\\f46f";
}

.fa-conveyor-belt-alt::before {
  content: "\\f46f";
}

.fa-conveyor-belt-empty::before {
  content: "\\e150";
}

.fa-cookie::before {
  content: "\\f563";
}

.fa-cookie-bite::before {
  content: "\\f564";
}

.fa-copy::before {
  content: "\\f0c5";
}

.fa-copyright::before {
  content: "\\f1f9";
}

.fa-corn::before {
  content: "\\f6c7";
}

.fa-corner::before {
  content: "\\e3fe";
}

.fa-couch::before {
  content: "\\f4b8";
}

.fa-cow::before {
  content: "\\f6c8";
}

.fa-cowbell::before {
  content: "\\f8b3";
}

.fa-cowbell-circle-plus::before {
  content: "\\f8b4";
}

.fa-cowbell-more::before {
  content: "\\f8b4";
}

.fa-crab::before {
  content: "\\e3ff";
}

.fa-crate-apple::before {
  content: "\\f6b1";
}

.fa-apple-crate::before {
  content: "\\f6b1";
}

.fa-crate-empty::before {
  content: "\\e151";
}

.fa-credit-card::before {
  content: "\\f09d";
}

.fa-credit-card-alt::before {
  content: "\\f09d";
}

.fa-credit-card-blank::before {
  content: "\\f389";
}

.fa-credit-card-front::before {
  content: "\\f38a";
}

.fa-creemee::before {
  content: "\\e400";
}

.fa-soft-serve::before {
  content: "\\e400";
}

.fa-cricket-bat-ball::before {
  content: "\\f449";
}

.fa-cricket::before {
  content: "\\f449";
}

.fa-croissant::before {
  content: "\\f7f6";
}

.fa-crop::before {
  content: "\\f125";
}

.fa-crop-simple::before {
  content: "\\f565";
}

.fa-crop-alt::before {
  content: "\\f565";
}

.fa-cross::before {
  content: "\\f654";
}

.fa-crosshairs::before {
  content: "\\f05b";
}

.fa-crow::before {
  content: "\\f520";
}

.fa-crown::before {
  content: "\\f521";
}

.fa-crutch::before {
  content: "\\f7f7";
}

.fa-crutches::before {
  content: "\\f7f8";
}

.fa-cruzeiro-sign::before {
  content: "\\e152";
}

.fa-crystal-ball::before {
  content: "\\e362";
}

.fa-cube::before {
  content: "\\f1b2";
}

.fa-cubes::before {
  content: "\\f1b3";
}

.fa-cucumber::before {
  content: "\\e401";
}

.fa-cup-straw::before {
  content: "\\e363";
}

.fa-cup-straw-swoosh::before {
  content: "\\e364";
}

.fa-cup-togo::before {
  content: "\\f6c5";
}

.fa-coffee-togo::before {
  content: "\\f6c5";
}

.fa-cupcake::before {
  content: "\\e402";
}

.fa-curling-stone::before {
  content: "\\f44a";
}

.fa-curling::before {
  content: "\\f44a";
}

.fa-custard::before {
  content: "\\e403";
}

.fa-d::before {
  content: "D";
}

.fa-dagger::before {
  content: "\\f6cb";
}

.fa-dash::before {
  content: "\\e404";
}

.fa-database::before {
  content: "\\f1c0";
}

.fa-deer::before {
  content: "\\f78e";
}

.fa-deer-rudolph::before {
  content: "\\f78f";
}

.fa-delete-left::before {
  content: "\\f55a";
}

.fa-backspace::before {
  content: "\\f55a";
}

.fa-delete-right::before {
  content: "\\e154";
}

.fa-democrat::before {
  content: "\\f747";
}

.fa-desktop::before {
  content: "\\f390";
}

.fa-desktop-alt::before {
  content: "\\f390";
}

.fa-desktop-arrow-down::before {
  content: "\\e155";
}

.fa-dharmachakra::before {
  content: "\\f655";
}

.fa-diagram-lean-canvas::before {
  content: "\\e156";
}

.fa-diagram-nested::before {
  content: "\\e157";
}

.fa-diagram-project::before {
  content: "\\f542";
}

.fa-project-diagram::before {
  content: "\\f542";
}

.fa-diagram-sankey::before {
  content: "\\e158";
}

.fa-diagram-venn::before {
  content: "\\e15a";
}

.fa-dial::before {
  content: "\\e15b";
}

.fa-dial-med-high::before {
  content: "\\e15b";
}

.fa-dial-high::before {
  content: "\\e15c";
}

.fa-dial-low::before {
  content: "\\e15d";
}

.fa-dial-max::before {
  content: "\\e15e";
}

.fa-dial-med::before {
  content: "\\e15f";
}

.fa-dial-med-low::before {
  content: "\\e160";
}

.fa-dial-min::before {
  content: "\\e161";
}

.fa-dial-off::before {
  content: "\\e162";
}

.fa-diamond::before {
  content: "\\f219";
}

.fa-diamond-exclamation::before {
  content: "\\e405";
}

.fa-diamond-turn-right::before {
  content: "\\f5eb";
}

.fa-directions::before {
  content: "\\f5eb";
}

.fa-dice::before {
  content: "\\f522";
}

.fa-dice-d10::before {
  content: "\\f6cd";
}

.fa-dice-d12::before {
  content: "\\f6ce";
}

.fa-dice-d20::before {
  content: "\\f6cf";
}

.fa-dice-d4::before {
  content: "\\f6d0";
}

.fa-dice-d6::before {
  content: "\\f6d1";
}

.fa-dice-d8::before {
  content: "\\f6d2";
}

.fa-dice-five::before {
  content: "\\f523";
}

.fa-dice-four::before {
  content: "\\f524";
}

.fa-dice-one::before {
  content: "\\f525";
}

.fa-dice-six::before {
  content: "\\f526";
}

.fa-dice-three::before {
  content: "\\f527";
}

.fa-dice-two::before {
  content: "\\f528";
}

.fa-diploma::before {
  content: "\\f5ea";
}

.fa-scroll-ribbon::before {
  content: "\\f5ea";
}

.fa-disc-drive::before {
  content: "\\f8b5";
}

.fa-disease::before {
  content: "\\f7fa";
}

.fa-display::before {
  content: "\\e163";
}

.fa-display-arrow-down::before {
  content: "\\e164";
}

.fa-display-code::before {
  content: "\\e165";
}

.fa-desktop-code::before {
  content: "\\e165";
}

.fa-display-medical::before {
  content: "\\e166";
}

.fa-desktop-medical::before {
  content: "\\e166";
}

.fa-display-slash::before {
  content: "\\e2fa";
}

.fa-desktop-slash::before {
  content: "\\e2fa";
}

.fa-distribute-spacing-horizontal::before {
  content: "\\e365";
}

.fa-distribute-spacing-vertical::before {
  content: "\\e366";
}

.fa-ditto::before {
  content: "\\"";
}

.fa-divide::before {
  content: "\\f529";
}

.fa-dna::before {
  content: "\\f471";
}

.fa-do-not-enter::before {
  content: "\\f5ec";
}

.fa-dog::before {
  content: "\\f6d3";
}

.fa-dog-leashed::before {
  content: "\\f6d4";
}

.fa-dollar-sign::before {
  content: "\\\$";
}

.fa-dollar::before {
  content: "\\\$";
}

.fa-usd::before {
  content: "\\\$";
}

.fa-dolly::before {
  content: "\\f472";
}

.fa-dolly-box::before {
  content: "\\f472";
}

.fa-dolly-empty::before {
  content: "\\f473";
}

.fa-dolphin::before {
  content: "\\e168";
}

.fa-dong-sign::before {
  content: "\\e169";
}

.fa-donut::before {
  content: "\\e406";
}

.fa-doughnut::before {
  content: "\\e406";
}

.fa-door-closed::before {
  content: "\\f52a";
}

.fa-door-open::before {
  content: "\\f52b";
}

.fa-dove::before {
  content: "\\f4ba";
}

.fa-down::before {
  content: "\\f354";
}

.fa-arrow-alt-down::before {
  content: "\\f354";
}

.fa-down-from-dotted-line::before {
  content: "\\e407";
}

.fa-down-from-line::before {
  content: "\\f349";
}

.fa-arrow-alt-from-top::before {
  content: "\\f349";
}

.fa-down-left::before {
  content: "\\e16a";
}

.fa-down-left-and-up-right-to-center::before {
  content: "\\f422";
}

.fa-compress-alt::before {
  content: "\\f422";
}

.fa-down-long::before {
  content: "\\f309";
}

.fa-long-arrow-alt-down::before {
  content: "\\f309";
}

.fa-down-right::before {
  content: "\\e16b";
}

.fa-down-to-dotted-line::before {
  content: "\\e408";
}

.fa-down-to-line::before {
  content: "\\f34a";
}

.fa-arrow-alt-to-bottom::before {
  content: "\\f34a";
}

.fa-download::before {
  content: "\\f019";
}

.fa-dragon::before {
  content: "\\f6d5";
}

.fa-draw-circle::before {
  content: "\\f5ed";
}

.fa-draw-polygon::before {
  content: "\\f5ee";
}

.fa-draw-square::before {
  content: "\\f5ef";
}

.fa-dreidel::before {
  content: "\\f792";
}

.fa-drone::before {
  content: "\\f85f";
}

.fa-drone-front::before {
  content: "\\f860";
}

.fa-drone-alt::before {
  content: "\\f860";
}

.fa-droplet::before {
  content: "\\f043";
}

.fa-tint::before {
  content: "\\f043";
}

.fa-droplet-degree::before {
  content: "\\f748";
}

.fa-dewpoint::before {
  content: "\\f748";
}

.fa-droplet-percent::before {
  content: "\\f750";
}

.fa-humidity::before {
  content: "\\f750";
}

.fa-droplet-slash::before {
  content: "\\f5c7";
}

.fa-tint-slash::before {
  content: "\\f5c7";
}

.fa-drum::before {
  content: "\\f569";
}

.fa-drum-steelpan::before {
  content: "\\f56a";
}

.fa-drumstick::before {
  content: "\\f6d6";
}

.fa-drumstick-bite::before {
  content: "\\f6d7";
}

.fa-dryer::before {
  content: "\\f861";
}

.fa-dryer-heat::before {
  content: "\\f862";
}

.fa-dryer-alt::before {
  content: "\\f862";
}

.fa-duck::before {
  content: "\\f6d8";
}

.fa-dumbbell::before {
  content: "\\f44b";
}

.fa-dumpster::before {
  content: "\\f793";
}

.fa-dumpster-fire::before {
  content: "\\f794";
}

.fa-dungeon::before {
  content: "\\f6d9";
}

.fa-e::before {
  content: "E";
}

.fa-ear::before {
  content: "\\f5f0";
}

.fa-ear-deaf::before {
  content: "\\f2a4";
}

.fa-deaf::before {
  content: "\\f2a4";
}

.fa-deafness::before {
  content: "\\f2a4";
}

.fa-hard-of-hearing::before {
  content: "\\f2a4";
}

.fa-ear-listen::before {
  content: "\\f2a2";
}

.fa-assistive-listening-systems::before {
  content: "\\f2a2";
}

.fa-ear-muffs::before {
  content: "\\f795";
}

.fa-earth-africa::before {
  content: "\\f57c";
}

.fa-globe-africa::before {
  content: "\\f57c";
}

.fa-earth-americas::before {
  content: "\\f57d";
}

.fa-earth::before {
  content: "\\f57d";
}

.fa-globe-americas::before {
  content: "\\f57d";
}

.fa-earth-asia::before {
  content: "\\f57e";
}

.fa-globe-asia::before {
  content: "\\f57e";
}

.fa-earth-europa::before {
  content: "\\f7a2";
}

.fa-globe-europe::before {
  content: "\\f7a2";
}

.fa-eclipse::before {
  content: "\\f749";
}

.fa-egg::before {
  content: "\\f7fb";
}

.fa-egg-fried::before {
  content: "\\f7fc";
}

.fa-eggplant::before {
  content: "\\e16c";
}

.fa-eject::before {
  content: "\\f052";
}

.fa-elephant::before {
  content: "\\f6da";
}

.fa-elevator::before {
  content: "\\e16d";
}

.fa-ellipsis::before {
  content: "\\f141";
}

.fa-ellipsis-h::before {
  content: "\\f141";
}

.fa-ellipsis-stroke::before {
  content: "\\f39b";
}

.fa-ellipsis-h-alt::before {
  content: "\\f39b";
}

.fa-ellipsis-stroke-vertical::before {
  content: "\\f39c";
}

.fa-ellipsis-v-alt::before {
  content: "\\f39c";
}

.fa-ellipsis-vertical::before {
  content: "\\f142";
}

.fa-ellipsis-v::before {
  content: "\\f142";
}

.fa-empty-set::before {
  content: "\\f656";
}

.fa-engine::before {
  content: "\\e16e";
}

.fa-engine-warning::before {
  content: "\\f5f2";
}

.fa-engine-exclamation::before {
  content: "\\f5f2";
}

.fa-envelope::before {
  content: "\\f0e0";
}

.fa-envelope-dot::before {
  content: "\\e16f";
}

.fa-envelope-badge::before {
  content: "\\e16f";
}

.fa-envelope-open::before {
  content: "\\f2b6";
}

.fa-envelope-open-dollar::before {
  content: "\\f657";
}

.fa-envelope-open-text::before {
  content: "\\f658";
}

.fa-envelopes::before {
  content: "\\e170";
}

.fa-envelopes-bulk::before {
  content: "\\f674";
}

.fa-mail-bulk::before {
  content: "\\f674";
}

.fa-equals::before {
  content: "\\=";
}

.fa-eraser::before {
  content: "\\f12d";
}

.fa-escalator::before {
  content: "\\e171";
}

.fa-ethernet::before {
  content: "\\f796";
}

.fa-euro-sign::before {
  content: "\\f153";
}

.fa-eur::before {
  content: "\\f153";
}

.fa-euro::before {
  content: "\\f153";
}

.fa-exclamation::before {
  content: "\\!";
}

.fa-expand::before {
  content: "\\f065";
}

.fa-expand-wide::before {
  content: "\\f320";
}

.fa-eye::before {
  content: "\\f06e";
}

.fa-eye-dropper::before {
  content: "\\f1fb";
}

.fa-eye-dropper-empty::before {
  content: "\\f1fb";
}

.fa-eyedropper::before {
  content: "\\f1fb";
}

.fa-eye-dropper-full::before {
  content: "\\e172";
}

.fa-eye-dropper-half::before {
  content: "\\e173";
}

.fa-eye-evil::before {
  content: "\\f6db";
}

.fa-eye-low-vision::before {
  content: "\\f2a8";
}

.fa-low-vision::before {
  content: "\\f2a8";
}

.fa-eye-slash::before {
  content: "\\f070";
}

.fa-eyes::before {
  content: "\\e367";
}

.fa-f::before {
  content: "F";
}

.fa-face-angry::before {
  content: "\\f556";
}

.fa-angry::before {
  content: "\\f556";
}

.fa-face-angry-horns::before {
  content: "\\e368";
}

.fa-face-anguished::before {
  content: "\\e369";
}

.fa-face-anxious-sweat::before {
  content: "\\e36a";
}

.fa-face-astonished::before {
  content: "\\e36b";
}

.fa-face-awesome::before {
  content: "\\e409";
}

.fa-gave-dandy::before {
  content: "\\e409";
}

.fa-face-confounded::before {
  content: "\\e36c";
}

.fa-face-confused::before {
  content: "\\e36d";
}

.fa-face-cowboy-hat::before {
  content: "\\e36e";
}

.fa-face-disappointed::before {
  content: "\\e36f";
}

.fa-face-disguise::before {
  content: "\\e370";
}

.fa-face-dizzy::before {
  content: "\\f567";
}

.fa-dizzy::before {
  content: "\\f567";
}

.fa-face-downcast-sweat::before {
  content: "\\e371";
}

.fa-face-drooling::before {
  content: "\\e372";
}

.fa-face-explode::before {
  content: "\\e2fe";
}

.fa-exploding-head::before {
  content: "\\e2fe";
}

.fa-face-expressionless::before {
  content: "\\e373";
}

.fa-face-eyes-xmarks::before {
  content: "\\e374";
}

.fa-face-fearful::before {
  content: "\\e375";
}

.fa-face-flushed::before {
  content: "\\f579";
}

.fa-flushed::before {
  content: "\\f579";
}

.fa-face-frown::before {
  content: "\\f119";
}

.fa-frown::before {
  content: "\\f119";
}

.fa-face-frown-open::before {
  content: "\\f57a";
}

.fa-frown-open::before {
  content: "\\f57a";
}

.fa-face-frown-slight::before {
  content: "\\e376";
}

.fa-face-glasses::before {
  content: "\\e377";
}

.fa-face-grimace::before {
  content: "\\f57f";
}

.fa-grimace::before {
  content: "\\f57f";
}

.fa-face-grin::before {
  content: "\\f580";
}

.fa-grin::before {
  content: "\\f580";
}

.fa-face-grin-beam::before {
  content: "\\f582";
}

.fa-grin-beam::before {
  content: "\\f582";
}

.fa-face-grin-beam-sweat::before {
  content: "\\f583";
}

.fa-grin-beam-sweat::before {
  content: "\\f583";
}

.fa-face-grin-hearts::before {
  content: "\\f584";
}

.fa-grin-hearts::before {
  content: "\\f584";
}

.fa-face-grin-squint::before {
  content: "\\f585";
}

.fa-grin-squint::before {
  content: "\\f585";
}

.fa-face-grin-squint-tears::before {
  content: "\\f586";
}

.fa-grin-squint-tears::before {
  content: "\\f586";
}

.fa-face-grin-stars::before {
  content: "\\f587";
}

.fa-grin-stars::before {
  content: "\\f587";
}

.fa-face-grin-tears::before {
  content: "\\f588";
}

.fa-grin-tears::before {
  content: "\\f588";
}

.fa-face-grin-tongue::before {
  content: "\\f589";
}

.fa-grin-tongue::before {
  content: "\\f589";
}

.fa-face-grin-tongue-squint::before {
  content: "\\f58a";
}

.fa-grin-tongue-squint::before {
  content: "\\f58a";
}

.fa-face-grin-tongue-wink::before {
  content: "\\f58b";
}

.fa-grin-tongue-wink::before {
  content: "\\f58b";
}

.fa-face-grin-wide::before {
  content: "\\f581";
}

.fa-grin-alt::before {
  content: "\\f581";
}

.fa-face-grin-wink::before {
  content: "\\f58c";
}

.fa-grin-wink::before {
  content: "\\f58c";
}

.fa-face-hand-over-mouth::before {
  content: "\\e378";
}

.fa-face-hand-yawn::before {
  content: "\\e379";
}

.fa-face-head-bandage::before {
  content: "\\e37a";
}

.fa-face-hushed::before {
  content: "\\e37b";
}

.fa-face-icicles::before {
  content: "\\e37c";
}

.fa-face-kiss::before {
  content: "\\f596";
}

.fa-kiss::before {
  content: "\\f596";
}

.fa-face-kiss-beam::before {
  content: "\\f597";
}

.fa-kiss-beam::before {
  content: "\\f597";
}

.fa-face-kiss-closed-eyes::before {
  content: "\\e37d";
}

.fa-face-kiss-wink-heart::before {
  content: "\\f598";
}

.fa-kiss-wink-heart::before {
  content: "\\f598";
}

.fa-face-laugh::before {
  content: "\\f599";
}

.fa-laugh::before {
  content: "\\f599";
}

.fa-face-laugh-beam::before {
  content: "\\f59a";
}

.fa-laugh-beam::before {
  content: "\\f59a";
}

.fa-face-laugh-squint::before {
  content: "\\f59b";
}

.fa-laugh-squint::before {
  content: "\\f59b";
}

.fa-face-laugh-wink::before {
  content: "\\f59c";
}

.fa-laugh-wink::before {
  content: "\\f59c";
}

.fa-face-lying::before {
  content: "\\e37e";
}

.fa-face-mask::before {
  content: "\\e37f";
}

.fa-face-meh::before {
  content: "\\f11a";
}

.fa-meh::before {
  content: "\\f11a";
}

.fa-face-meh-blank::before {
  content: "\\f5a4";
}

.fa-meh-blank::before {
  content: "\\f5a4";
}

.fa-face-monocle::before {
  content: "\\e380";
}

.fa-face-nauseated::before {
  content: "\\e381";
}

.fa-face-nose-steam::before {
  content: "\\e382";
}

.fa-face-party::before {
  content: "\\e383";
}

.fa-face-pensive::before {
  content: "\\e384";
}

.fa-face-persevering::before {
  content: "\\e385";
}

.fa-face-pleading::before {
  content: "\\e386";
}

.fa-face-pouting::before {
  content: "\\e387";
}

.fa-face-raised-eyebrow::before {
  content: "\\e388";
}

.fa-face-relieved::before {
  content: "\\e389";
}

.fa-face-rolling-eyes::before {
  content: "\\f5a5";
}

.fa-meh-rolling-eyes::before {
  content: "\\f5a5";
}

.fa-face-sad-cry::before {
  content: "\\f5b3";
}

.fa-sad-cry::before {
  content: "\\f5b3";
}

.fa-face-sad-sweat::before {
  content: "\\e38a";
}

.fa-face-sad-tear::before {
  content: "\\f5b4";
}

.fa-sad-tear::before {
  content: "\\f5b4";
}

.fa-face-scream::before {
  content: "\\e38b";
}

.fa-face-shush::before {
  content: "\\e38c";
}

.fa-face-sleeping::before {
  content: "\\e38d";
}

.fa-face-sleepy::before {
  content: "\\e38e";
}

.fa-face-smile::before {
  content: "\\f118";
}

.fa-smile::before {
  content: "\\f118";
}

.fa-face-smile-beam::before {
  content: "\\f5b8";
}

.fa-smile-beam::before {
  content: "\\f5b8";
}

.fa-face-smile-halo::before {
  content: "\\e38f";
}

.fa-face-smile-hearts::before {
  content: "\\e390";
}

.fa-face-smile-horns::before {
  content: "\\e391";
}

.fa-face-smile-plus::before {
  content: "\\f5b9";
}

.fa-smile-plus::before {
  content: "\\f5b9";
}

.fa-face-smile-relaxed::before {
  content: "\\e392";
}

.fa-face-smile-tear::before {
  content: "\\e393";
}

.fa-face-smile-tongue::before {
  content: "\\e394";
}

.fa-face-smile-upside-down::before {
  content: "\\e395";
}

.fa-face-smile-wink::before {
  content: "\\f4da";
}

.fa-smile-wink::before {
  content: "\\f4da";
}

.fa-face-smiling-hands::before {
  content: "\\e396";
}

.fa-face-smirking::before {
  content: "\\e397";
}

.fa-face-sunglasses::before {
  content: "\\e398";
}

.fa-face-surprise::before {
  content: "\\f5c2";
}

.fa-surprise::before {
  content: "\\f5c2";
}

.fa-face-swear::before {
  content: "\\e399";
}

.fa-face-thermometer::before {
  content: "\\e39a";
}

.fa-face-thinking::before {
  content: "\\e39b";
}

.fa-face-tired::before {
  content: "\\f5c8";
}

.fa-tired::before {
  content: "\\f5c8";
}

.fa-face-tissue::before {
  content: "\\e39c";
}

.fa-face-tongue-money::before {
  content: "\\e39d";
}

.fa-face-tongue-sweat::before {
  content: "\\e39e";
}

.fa-face-unamused::before {
  content: "\\e39f";
}

.fa-face-viewfinder::before {
  content: "\\e2ff";
}

.fa-face-vomit::before {
  content: "\\e3a0";
}

.fa-face-weary::before {
  content: "\\e3a1";
}

.fa-face-woozy::before {
  content: "\\e3a2";
}

.fa-face-worried::before {
  content: "\\e3a3";
}

.fa-face-zany::before {
  content: "\\e3a4";
}

.fa-face-zipper::before {
  content: "\\e3a5";
}

.fa-falafel::before {
  content: "\\e40a";
}

.fa-family::before {
  content: "\\e300";
}

.fa-family-dress::before {
  content: "\\e301";
}

.fa-family-pants::before {
  content: "\\e302";
}

.fa-fan::before {
  content: "\\f863";
}

.fa-fan-table::before {
  content: "\\e004";
}

.fa-farm::before {
  content: "\\f864";
}

.fa-barn-silo::before {
  content: "\\f864";
}

.fa-faucet::before {
  content: "\\e005";
}

.fa-faucet-drip::before {
  content: "\\e006";
}

.fa-fax::before {
  content: "\\f1ac";
}

.fa-feather::before {
  content: "\\f52d";
}

.fa-feather-pointed::before {
  content: "\\f56b";
}

.fa-feather-alt::before {
  content: "\\f56b";
}

.fa-fence::before {
  content: "\\e303";
}

.fa-ferris-wheel::before {
  content: "\\e174";
}

.fa-field-hockey-stick-ball::before {
  content: "\\f44c";
}

.fa-field-hockey::before {
  content: "\\f44c";
}

.fa-file::before {
  content: "\\f15b";
}

.fa-file-arrow-down::before {
  content: "\\f56d";
}

.fa-file-download::before {
  content: "\\f56d";
}

.fa-file-arrow-up::before {
  content: "\\f574";
}

.fa-file-upload::before {
  content: "\\f574";
}

.fa-file-audio::before {
  content: "\\f1c7";
}

.fa-file-binary::before {
  content: "\\e175";
}

.fa-file-certificate::before {
  content: "\\f5f3";
}

.fa-file-award::before {
  content: "\\f5f3";
}

.fa-file-chart-column::before {
  content: "\\f659";
}

.fa-file-chart-line::before {
  content: "\\f659";
}

.fa-file-chart-pie::before {
  content: "\\f65a";
}

.fa-file-check::before {
  content: "\\f316";
}

.fa-file-code::before {
  content: "\\f1c9";
}

.fa-file-contract::before {
  content: "\\f56c";
}

.fa-file-csv::before {
  content: "\\f6dd";
}

.fa-file-dashed-line::before {
  content: "\\f877";
}

.fa-page-break::before {
  content: "\\f877";
}

.fa-file-excel::before {
  content: "\\f1c3";
}

.fa-file-exclamation::before {
  content: "\\f31a";
}

.fa-file-export::before {
  content: "\\f56e";
}

.fa-arrow-right-from-file::before {
  content: "\\f56e";
}

.fa-file-heart::before {
  content: "\\e176";
}

.fa-file-image::before {
  content: "\\f1c5";
}

.fa-file-import::before {
  content: "\\f56f";
}

.fa-arrow-right-to-file::before {
  content: "\\f56f";
}

.fa-file-invoice::before {
  content: "\\f570";
}

.fa-file-invoice-dollar::before {
  content: "\\f571";
}

.fa-file-lines::before {
  content: "\\f15c";
}

.fa-file-alt::before {
  content: "\\f15c";
}

.fa-file-text::before {
  content: "\\f15c";
}

.fa-file-lock::before {
  content: "\\e3a6";
}

.fa-file-magnifying-glass::before {
  content: "\\f865";
}

.fa-file-search::before {
  content: "\\f865";
}

.fa-file-medical::before {
  content: "\\f477";
}

.fa-file-minus::before {
  content: "\\f318";
}

.fa-file-music::before {
  content: "\\f8b6";
}

.fa-file-pdf::before {
  content: "\\f1c1";
}

.fa-file-pen::before {
  content: "\\f31c";
}

.fa-file-edit::before {
  content: "\\f31c";
}

.fa-file-plus::before {
  content: "\\f319";
}

.fa-file-plus-minus::before {
  content: "\\e177";
}

.fa-file-powerpoint::before {
  content: "\\f1c4";
}

.fa-file-prescription::before {
  content: "\\f572";
}

.fa-file-signature::before {
  content: "\\f573";
}

.fa-file-slash::before {
  content: "\\e3a7";
}

.fa-file-spreadsheet::before {
  content: "\\f65b";
}

.fa-file-user::before {
  content: "\\f65c";
}

.fa-file-video::before {
  content: "\\f1c8";
}

.fa-file-waveform::before {
  content: "\\f478";
}

.fa-file-medical-alt::before {
  content: "\\f478";
}

.fa-file-word::before {
  content: "\\f1c2";
}

.fa-file-xmark::before {
  content: "\\f317";
}

.fa-file-times::before {
  content: "\\f317";
}

.fa-file-zipper::before {
  content: "\\f1c6";
}

.fa-file-archive::before {
  content: "\\f1c6";
}

.fa-files::before {
  content: "\\e178";
}

.fa-files-medical::before {
  content: "\\f7fd";
}

.fa-fill::before {
  content: "\\f575";
}

.fa-fill-drip::before {
  content: "\\f576";
}

.fa-film::before {
  content: "\\f008";
}

.fa-film-canister::before {
  content: "\\f8b7";
}

.fa-film-simple::before {
  content: "\\f3a0";
}

.fa-film-alt::before {
  content: "\\f3a0";
}

.fa-film-slash::before {
  content: "\\e179";
}

.fa-films::before {
  content: "\\e17a";
}

.fa-filter::before {
  content: "\\f0b0";
}

.fa-filter-circle-dollar::before {
  content: "\\f662";
}

.fa-funnel-dollar::before {
  content: "\\f662";
}

.fa-filter-circle-xmark::before {
  content: "\\e17b";
}

.fa-filter-list::before {
  content: "\\e17c";
}

.fa-filter-slash::before {
  content: "\\e17d";
}

.fa-filters::before {
  content: "\\e17e";
}

.fa-fingerprint::before {
  content: "\\f577";
}

.fa-fire::before {
  content: "\\f06d";
}

.fa-fire-extinguisher::before {
  content: "\\f134";
}

.fa-fire-flame::before {
  content: "\\f6df";
}

.fa-flame::before {
  content: "\\f6df";
}

.fa-fire-flame-curved::before {
  content: "\\f7e4";
}

.fa-fire-alt::before {
  content: "\\f7e4";
}

.fa-fire-flame-simple::before {
  content: "\\f46a";
}

.fa-burn::before {
  content: "\\f46a";
}

.fa-fire-hydrant::before {
  content: "\\e17f";
}

.fa-fire-smoke::before {
  content: "\\f74b";
}

.fa-fireplace::before {
  content: "\\f79a";
}

.fa-fish::before {
  content: "\\f578";
}

.fa-fish-bones::before {
  content: "\\e304";
}

.fa-fish-cooked::before {
  content: "\\f7fe";
}

.fa-fishing-rod::before {
  content: "\\e3a8";
}

.fa-flag::before {
  content: "\\f024";
}

.fa-flag-checkered::before {
  content: "\\f11e";
}

.fa-flag-pennant::before {
  content: "\\f456";
}

.fa-pennant::before {
  content: "\\f456";
}

.fa-flag-swallowtail::before {
  content: "\\f74c";
}

.fa-flag-alt::before {
  content: "\\f74c";
}

.fa-flag-usa::before {
  content: "\\f74d";
}

.fa-flashlight::before {
  content: "\\f8b8";
}

.fa-flask::before {
  content: "\\f0c3";
}

.fa-flask-round-poison::before {
  content: "\\f6e0";
}

.fa-flask-poison::before {
  content: "\\f6e0";
}

.fa-flask-round-potion::before {
  content: "\\f6e1";
}

.fa-flask-potion::before {
  content: "\\f6e1";
}

.fa-flatbread::before {
  content: "\\e40b";
}

.fa-flatbread-stuffed::before {
  content: "\\e40c";
}

.fa-floppy-disk::before {
  content: "\\f0c7";
}

.fa-save::before {
  content: "\\f0c7";
}

.fa-floppy-disk-circle-arrow-right::before {
  content: "\\e180";
}

.fa-save-circle-arrow-right::before {
  content: "\\e180";
}

.fa-floppy-disk-circle-xmark::before {
  content: "\\e181";
}

.fa-floppy-disk-times::before {
  content: "\\e181";
}

.fa-save-circle-xmark::before {
  content: "\\e181";
}

.fa-save-times::before {
  content: "\\e181";
}

.fa-floppy-disk-pen::before {
  content: "\\e182";
}

.fa-floppy-disks::before {
  content: "\\e183";
}

.fa-florin-sign::before {
  content: "\\e184";
}

.fa-flower::before {
  content: "\\f7ff";
}

.fa-flower-daffodil::before {
  content: "\\f800";
}

.fa-flower-tulip::before {
  content: "\\f801";
}

.fa-flute::before {
  content: "\\f8b9";
}

.fa-flux-capacitor::before {
  content: "\\f8ba";
}

.fa-flying-disc::before {
  content: "\\e3a9";
}

.fa-folder::before {
  content: "\\f07b";
}

.fa-folder-arrow-down::before {
  content: "\\e053";
}

.fa-folder-download::before {
  content: "\\e053";
}

.fa-folder-arrow-up::before {
  content: "\\e054";
}

.fa-folder-upload::before {
  content: "\\e054";
}

.fa-folder-blank::before {
  content: "\\e185";
}

.fa-folder-bookmark::before {
  content: "\\e186";
}

.fa-folder-gear::before {
  content: "\\e187";
}

.fa-folder-cog::before {
  content: "\\e187";
}

.fa-folder-grid::before {
  content: "\\e188";
}

.fa-folder-heart::before {
  content: "\\e189";
}

.fa-folder-image::before {
  content: "\\e18a";
}

.fa-folder-magnifying-glass::before {
  content: "\\e18b";
}

.fa-folder-search::before {
  content: "\\e18b";
}

.fa-folder-medical::before {
  content: "\\e18c";
}

.fa-folder-minus::before {
  content: "\\f65d";
}

.fa-folder-music::before {
  content: "\\e18d";
}

.fa-folder-open::before {
  content: "\\f07c";
}

.fa-folder-plus::before {
  content: "\\f65e";
}

.fa-folder-tree::before {
  content: "\\f802";
}

.fa-folder-user::before {
  content: "\\e18e";
}

.fa-folder-xmark::before {
  content: "\\f65f";
}

.fa-folder-times::before {
  content: "\\f65f";
}

.fa-folders::before {
  content: "\\f660";
}

.fa-fondue-pot::before {
  content: "\\e40d";
}

.fa-font::before {
  content: "\\f031";
}

.fa-font-case::before {
  content: "\\f866";
}

.fa-football::before {
  content: "\\f44e";
}

.fa-football-ball::before {
  content: "\\f44e";
}

.fa-football-helmet::before {
  content: "\\f44f";
}

.fa-fork::before {
  content: "\\f2e3";
}

.fa-utensil-fork::before {
  content: "\\f2e3";
}

.fa-fork-knife::before {
  content: "\\f2e6";
}

.fa-utensils-alt::before {
  content: "\\f2e6";
}

.fa-forklift::before {
  content: "\\f47a";
}

.fa-forward::before {
  content: "\\f04e";
}

.fa-forward-fast::before {
  content: "\\f050";
}

.fa-fast-forward::before {
  content: "\\f050";
}

.fa-forward-step::before {
  content: "\\f051";
}

.fa-step-forward::before {
  content: "\\f051";
}

.fa-franc-sign::before {
  content: "\\e18f";
}

.fa-french-fries::before {
  content: "\\f803";
}

.fa-frog::before {
  content: "\\f52e";
}

.fa-function::before {
  content: "\\f661";
}

.fa-futbol::before {
  content: "\\f1e3";
}

.fa-futbol-ball::before {
  content: "\\f1e3";
}

.fa-soccer-ball::before {
  content: "\\f1e3";
}

.fa-g::before {
  content: "G";
}

.fa-galaxy::before {
  content: "\\e008";
}

.fa-gallery-thumbnails::before {
  content: "\\e3aa";
}

.fa-game-board::before {
  content: "\\f867";
}

.fa-game-board-simple::before {
  content: "\\f868";
}

.fa-game-board-alt::before {
  content: "\\f868";
}

.fa-game-console-handheld::before {
  content: "\\f8bb";
}

.fa-gamepad::before {
  content: "\\f11b";
}

.fa-gamepad-modern::before {
  content: "\\f8bc";
}

.fa-gamepad-alt::before {
  content: "\\f8bc";
}

.fa-garage::before {
  content: "\\e009";
}

.fa-garage-car::before {
  content: "\\e00a";
}

.fa-garage-open::before {
  content: "\\e00b";
}

.fa-garlic::before {
  content: "\\e40e";
}

.fa-gas-pump::before {
  content: "\\f52f";
}

.fa-gas-pump-slash::before {
  content: "\\f5f4";
}

.fa-gauge::before {
  content: "\\f625";
}

.fa-dashboard::before {
  content: "\\f625";
}

.fa-gauge-high::before {
  content: "\\f625";
}

.fa-tachometer-alt::before {
  content: "\\f625";
}

.fa-tachometer-alt-fast::before {
  content: "\\f625";
}

.fa-gauge-low::before {
  content: "\\f627";
}

.fa-tachometer-alt-slow::before {
  content: "\\f627";
}

.fa-gauge-max::before {
  content: "\\f626";
}

.fa-tachometer-alt-fastest::before {
  content: "\\f626";
}

.fa-gauge-med::before {
  content: "\\f624";
}

.fa-tachometer-alt-average::before {
  content: "\\f624";
}

.fa-gauge-min::before {
  content: "\\f628";
}

.fa-tachometer-alt-slowest::before {
  content: "\\f628";
}

.fa-gauge-simple::before {
  content: "\\f62a";
}

.fa-gauge-simple-high::before {
  content: "\\f62a";
}

.fa-tachometer::before {
  content: "\\f62a";
}

.fa-gauge-simple-low::before {
  content: "\\f62c";
}

.fa-tachometer-slow::before {
  content: "\\f62c";
}

.fa-gauge-simple-max::before {
  content: "\\f62b";
}

.fa-tachometer-fastest::before {
  content: "\\f62b";
}

.fa-gauge-simple-med::before {
  content: "\\f629";
}

.fa-tachometer-average::before {
  content: "\\f629";
}

.fa-gauge-simple-min::before {
  content: "\\f62d";
}

.fa-tachometer-slowest::before {
  content: "\\f62d";
}

.fa-gavel::before {
  content: "\\f0e3";
}

.fa-legal::before {
  content: "\\f0e3";
}

.fa-gear::before {
  content: "\\f013";
}

.fa-cog::before {
  content: "\\f013";
}

.fa-gears::before {
  content: "\\f085";
}

.fa-cogs::before {
  content: "\\f085";
}

.fa-gem::before {
  content: "\\f3a5";
}

.fa-genderless::before {
  content: "\\f22d";
}

.fa-ghost::before {
  content: "\\f6e2";
}

.fa-gif::before {
  content: "\\e190";
}

.fa-gift::before {
  content: "\\f06b";
}

.fa-gift-card::before {
  content: "\\f663";
}

.fa-gifts::before {
  content: "\\f79c";
}

.fa-gingerbread-man::before {
  content: "\\f79d";
}

.fa-glass::before {
  content: "\\f804";
}

.fa-glass-citrus::before {
  content: "\\f869";
}

.fa-glass-empty::before {
  content: "\\e191";
}

.fa-glass-half::before {
  content: "\\e192";
}

.fa-glass-half-empty::before {
  content: "\\e192";
}

.fa-glass-half-full::before {
  content: "\\e192";
}

.fa-glasses::before {
  content: "\\f530";
}

.fa-glasses-round::before {
  content: "\\f5f5";
}

.fa-glasses-alt::before {
  content: "\\f5f5";
}

.fa-globe::before {
  content: "\\f0ac";
}

.fa-globe-snow::before {
  content: "\\f7a3";
}

.fa-globe-stand::before {
  content: "\\f5f6";
}

.fa-goal-net::before {
  content: "\\e3ab";
}

.fa-golf-ball-tee::before {
  content: "\\f450";
}

.fa-golf-ball::before {
  content: "\\f450";
}

.fa-golf-club::before {
  content: "\\f451";
}

.fa-golf-flag-hole::before {
  content: "\\e3ac";
}

.fa-gopuram::before {
  content: "\\f664";
}

.fa-graduation-cap::before {
  content: "\\f19d";
}

.fa-mortar-board::before {
  content: "\\f19d";
}

.fa-gramophone::before {
  content: "\\f8bd";
}

.fa-grapes::before {
  content: "\\e306";
}

.fa-grate::before {
  content: "\\e193";
}

.fa-grate-droplet::before {
  content: "\\e194";
}

.fa-greater-than::before {
  content: "\\>";
}

.fa-greater-than-equal::before {
  content: "\\f532";
}

.fa-grid::before {
  content: "\\e195";
}

.fa-grid-3::before {
  content: "\\e195";
}

.fa-grid-2::before {
  content: "\\e196";
}

.fa-grid-2-plus::before {
  content: "\\e197";
}

.fa-grid-4::before {
  content: "\\e198";
}

.fa-grid-5::before {
  content: "\\e199";
}

.fa-grid-dividers::before {
  content: "\\e3ad";
}

.fa-grid-horizontal::before {
  content: "\\e307";
}

.fa-grip::before {
  content: "\\f58d";
}

.fa-grip-horizontal::before {
  content: "\\f58d";
}

.fa-grip-dots::before {
  content: "\\e410";
}

.fa-grip-dots-vertical::before {
  content: "\\e411";
}

.fa-grip-lines::before {
  content: "\\f7a4";
}

.fa-grip-lines-vertical::before {
  content: "\\f7a5";
}

.fa-grip-vertical::before {
  content: "\\f58e";
}

.fa-guarani-sign::before {
  content: "\\e19a";
}

.fa-guitar::before {
  content: "\\f7a6";
}

.fa-guitar-electric::before {
  content: "\\f8be";
}

.fa-guitars::before {
  content: "\\f8bf";
}

.fa-gun::before {
  content: "\\e19b";
}

.fa-gun-slash::before {
  content: "\\e19c";
}

.fa-gun-squirt::before {
  content: "\\e19d";
}

.fa-h::before {
  content: "H";
}

.fa-h1::before {
  content: "\\f313";
}

.fa-h2::before {
  content: "\\f314";
}

.fa-h3::before {
  content: "\\f315";
}

.fa-h4::before {
  content: "\\f86a";
}

.fa-h5::before {
  content: "\\e412";
}

.fa-h6::before {
  content: "\\e413";
}

.fa-hammer::before {
  content: "\\f6e3";
}

.fa-hammer-crash::before {
  content: "\\e414";
}

.fa-hammer-war::before {
  content: "\\f6e4";
}

.fa-hamsa::before {
  content: "\\f665";
}

.fa-hand::before {
  content: "\\f256";
}

.fa-hand-paper::before {
  content: "\\f256";
}

.fa-hand-back-fist::before {
  content: "\\f255";
}

.fa-hand-rock::before {
  content: "\\f255";
}

.fa-hand-back-point-down::before {
  content: "\\e19e";
}

.fa-hand-back-point-left::before {
  content: "\\e19f";
}

.fa-hand-back-point-ribbon::before {
  content: "\\e1a0";
}

.fa-hand-back-point-right::before {
  content: "\\e1a1";
}

.fa-hand-back-point-up::before {
  content: "\\e1a2";
}

.fa-hand-dots::before {
  content: "\\f461";
}

.fa-allergies::before {
  content: "\\f461";
}

.fa-hand-fingers-crossed::before {
  content: "\\e1a3";
}

.fa-hand-fist::before {
  content: "\\f6de";
}

.fa-fist-raised::before {
  content: "\\f6de";
}

.fa-hand-heart::before {
  content: "\\f4bc";
}

.fa-hand-holding::before {
  content: "\\f4bd";
}

.fa-hand-holding-box::before {
  content: "\\f47b";
}

.fa-hand-holding-dollar::before {
  content: "\\f4c0";
}

.fa-hand-holding-usd::before {
  content: "\\f4c0";
}

.fa-hand-holding-droplet::before {
  content: "\\f4c1";
}

.fa-hand-holding-water::before {
  content: "\\f4c1";
}

.fa-hand-holding-heart::before {
  content: "\\f4be";
}

.fa-hand-holding-magic::before {
  content: "\\f6e5";
}

.fa-hand-holding-medical::before {
  content: "\\e05c";
}

.fa-hand-holding-seedling::before {
  content: "\\f4bf";
}

.fa-hand-holding-skull::before {
  content: "\\e1a4";
}

.fa-hand-horns::before {
  content: "\\e1a9";
}

.fa-hand-lizard::before {
  content: "\\f258";
}

.fa-hand-love::before {
  content: "\\e1a5";
}

.fa-hand-middle-finger::before {
  content: "\\f806";
}

.fa-hand-peace::before {
  content: "\\f25b";
}

.fa-hand-point-down::before {
  content: "\\f0a7";
}

.fa-hand-point-left::before {
  content: "\\f0a5";
}

.fa-hand-point-ribbon::before {
  content: "\\e1a6";
}

.fa-hand-point-right::before {
  content: "\\f0a4";
}

.fa-hand-point-up::before {
  content: "\\f0a6";
}

.fa-hand-pointer::before {
  content: "\\f25a";
}

.fa-hand-scissors::before {
  content: "\\f257";
}

.fa-hand-sparkles::before {
  content: "\\e05d";
}

.fa-hand-spock::before {
  content: "\\f259";
}

.fa-hand-wave::before {
  content: "\\e1a7";
}

.fa-hands::before {
  content: "\\f2a7";
}

.fa-sign-language::before {
  content: "\\f2a7";
}

.fa-signing::before {
  content: "\\f2a7";
}

.fa-hands-asl-interpreting::before {
  content: "\\f2a3";
}

.fa-american-sign-language-interpreting::before {
  content: "\\f2a3";
}

.fa-asl-interpreting::before {
  content: "\\f2a3";
}

.fa-hands-american-sign-language-interpreting::before {
  content: "\\f2a3";
}

.fa-hands-bubbles::before {
  content: "\\e05e";
}

.fa-hands-wash::before {
  content: "\\e05e";
}

.fa-hands-clapping::before {
  content: "\\e1a8";
}

.fa-hands-holding::before {
  content: "\\f4c2";
}

.fa-hands-holding-diamond::before {
  content: "\\f47c";
}

.fa-hand-receiving::before {
  content: "\\f47c";
}

.fa-hands-holding-dollar::before {
  content: "\\f4c5";
}

.fa-hands-usd::before {
  content: "\\f4c5";
}

.fa-hands-holding-heart::before {
  content: "\\f4c3";
}

.fa-hands-heart::before {
  content: "\\f4c3";
}

.fa-hands-praying::before {
  content: "\\f684";
}

.fa-praying-hands::before {
  content: "\\f684";
}

.fa-handshake::before {
  content: "\\f2b5";
}

.fa-handshake-angle::before {
  content: "\\f4c4";
}

.fa-hands-helping::before {
  content: "\\f4c4";
}

.fa-handshake-simple::before {
  content: "\\f4c6";
}

.fa-handshake-alt::before {
  content: "\\f4c6";
}

.fa-handshake-simple-slash::before {
  content: "\\e05f";
}

.fa-handshake-alt-slash::before {
  content: "\\e05f";
}

.fa-handshake-slash::before {
  content: "\\e060";
}

.fa-hanukiah::before {
  content: "\\f6e6";
}

.fa-hard-drive::before {
  content: "\\f0a0";
}

.fa-hdd::before {
  content: "\\f0a0";
}

.fa-hashtag::before {
  content: "\\#";
}

.fa-hashtag-lock::before {
  content: "\\e415";
}

.fa-hat-chef::before {
  content: "\\f86b";
}

.fa-hat-cowboy::before {
  content: "\\f8c0";
}

.fa-hat-cowboy-side::before {
  content: "\\f8c1";
}

.fa-hat-santa::before {
  content: "\\f7a7";
}

.fa-hat-winter::before {
  content: "\\f7a8";
}

.fa-hat-witch::before {
  content: "\\f6e7";
}

.fa-hat-wizard::before {
  content: "\\f6e8";
}

.fa-head-side::before {
  content: "\\f6e9";
}

.fa-head-side-brain::before {
  content: "\\f808";
}

.fa-head-side-cough::before {
  content: "\\e061";
}

.fa-head-side-cough-slash::before {
  content: "\\e062";
}

.fa-head-side-goggles::before {
  content: "\\f6ea";
}

.fa-head-vr::before {
  content: "\\f6ea";
}

.fa-head-side-headphones::before {
  content: "\\f8c2";
}

.fa-head-side-heart::before {
  content: "\\e1aa";
}

.fa-head-side-mask::before {
  content: "\\e063";
}

.fa-head-side-medical::before {
  content: "\\f809";
}

.fa-head-side-virus::before {
  content: "\\e064";
}

.fa-heading::before {
  content: "\\f1dc";
}

.fa-header::before {
  content: "\\f1dc";
}

.fa-headphones::before {
  content: "\\f025";
}

.fa-headphones-simple::before {
  content: "\\f58f";
}

.fa-headphones-alt::before {
  content: "\\f58f";
}

.fa-headset::before {
  content: "\\f590";
}

.fa-heart::before {
  content: "\\f004";
}

.fa-heart-crack::before {
  content: "\\f7a9";
}

.fa-heart-broken::before {
  content: "\\f7a9";
}

.fa-heart-half::before {
  content: "\\e1ab";
}

.fa-heart-half-stroke::before {
  content: "\\e1ac";
}

.fa-heart-half-alt::before {
  content: "\\e1ac";
}

.fa-heart-pulse::before {
  content: "\\f21e";
}

.fa-heartbeat::before {
  content: "\\f21e";
}

.fa-heat::before {
  content: "\\e00c";
}

.fa-helicopter::before {
  content: "\\f533";
}

.fa-helmet-battle::before {
  content: "\\f6eb";
}

.fa-helmet-safety::before {
  content: "\\f807";
}

.fa-hard-hat::before {
  content: "\\f807";
}

.fa-hat-hard::before {
  content: "\\f807";
}

.fa-hexagon::before {
  content: "\\f312";
}

.fa-hexagon-check::before {
  content: "\\e416";
}

.fa-hexagon-divide::before {
  content: "\\e1ad";
}

.fa-hexagon-exclamation::before {
  content: "\\e417";
}

.fa-hexagon-minus::before {
  content: "\\f307";
}

.fa-minus-hexagon::before {
  content: "\\f307";
}

.fa-hexagon-plus::before {
  content: "\\f300";
}

.fa-plus-hexagon::before {
  content: "\\f300";
}

.fa-hexagon-xmark::before {
  content: "\\f2ee";
}

.fa-times-hexagon::before {
  content: "\\f2ee";
}

.fa-xmark-hexagon::before {
  content: "\\f2ee";
}

.fa-high-definition::before {
  content: "\\e1ae";
}

.fa-rectangle-hd::before {
  content: "\\e1ae";
}

.fa-highlighter::before {
  content: "\\f591";
}

.fa-highlighter-line::before {
  content: "\\e1af";
}

.fa-hippo::before {
  content: "\\f6ed";
}

.fa-hockey-mask::before {
  content: "\\f6ee";
}

.fa-hockey-puck::before {
  content: "\\f453";
}

.fa-hockey-stick-puck::before {
  content: "\\e3ae";
}

.fa-hockey-sticks::before {
  content: "\\f454";
}

.fa-holly-berry::before {
  content: "\\f7aa";
}

.fa-honey-pot::before {
  content: "\\e418";
}

.fa-hood-cloak::before {
  content: "\\f6ef";
}

.fa-horizontal-rule::before {
  content: "\\f86c";
}

.fa-horse::before {
  content: "\\f6f0";
}

.fa-horse-head::before {
  content: "\\f7ab";
}

.fa-horse-saddle::before {
  content: "\\f8c3";
}

.fa-hose::before {
  content: "\\e419";
}

.fa-hose-reel::before {
  content: "\\e41a";
}

.fa-hospital::before {
  content: "\\f0f8";
}

.fa-hospital-user::before {
  content: "\\f80d";
}

.fa-hospital-wide::before {
  content: "\\f47d";
}

.fa-hospital-alt::before {
  content: "\\f47d";
}

.fa-hospitals::before {
  content: "\\f80e";
}

.fa-hot-tub-person::before {
  content: "\\f593";
}

.fa-hot-tub::before {
  content: "\\f593";
}

.fa-hotdog::before {
  content: "\\f80f";
}

.fa-hotel::before {
  content: "\\f594";
}

.fa-hourglass::before {
  content: "\\f254";
}

.fa-hourglass-2::before {
  content: "\\f254";
}

.fa-hourglass-half::before {
  content: "\\f254";
}

.fa-hourglass-clock::before {
  content: "\\e41b";
}

.fa-hourglass-empty::before {
  content: "\\f252";
}

.fa-hourglass-end::before {
  content: "\\f253";
}

.fa-hourglass-3::before {
  content: "\\f253";
}

.fa-hourglass-start::before {
  content: "\\f251";
}

.fa-hourglass-1::before {
  content: "\\f251";
}

.fa-house::before {
  content: "\\f015";
}

.fa-home::before {
  content: "\\f015";
}

.fa-house-blank::before {
  content: "\\f80a";
}

.fa-home-blank::before {
  content: "\\f80a";
}

.fa-home-lg-alt::before {
  content: "\\f80a";
}

.fa-house-building::before {
  content: "\\e1b1";
}

.fa-house-chimney::before {
  content: "\\e3af";
}

.fa-home-lg::before {
  content: "\\e3af";
}

.fa-house-chimney-blank::before {
  content: "\\e3b0";
}

.fa-house-chimney-crack::before {
  content: "\\f6f1";
}

.fa-house-damage::before {
  content: "\\f6f1";
}

.fa-house-chimney-heart::before {
  content: "\\e1b2";
}

.fa-house-chimney-medical::before {
  content: "\\f7f2";
}

.fa-clinic-medical::before {
  content: "\\f7f2";
}

.fa-house-chimney-user::before {
  content: "\\e065";
}

.fa-house-chimney-window::before {
  content: "\\e00d";
}

.fa-house-crack::before {
  content: "\\e3b1";
}

.fa-house-day::before {
  content: "\\e00e";
}

.fa-house-flood::before {
  content: "\\f74f";
}

.fa-house-heart::before {
  content: "\\f4c9";
}

.fa-home-heart::before {
  content: "\\f4c9";
}

.fa-house-laptop::before {
  content: "\\e066";
}

.fa-laptop-house::before {
  content: "\\e066";
}

.fa-house-medical::before {
  content: "\\e3b2";
}

.fa-house-night::before {
  content: "\\e010";
}

.fa-house-person-leave::before {
  content: "\\e00f";
}

.fa-house-person-depart::before {
  content: "\\e00f";
}

.fa-house-person-return::before {
  content: "\\e011";
}

.fa-house-person-arrive::before {
  content: "\\e011";
}

.fa-house-signal::before {
  content: "\\e012";
}

.fa-house-tree::before {
  content: "\\e1b3";
}

.fa-house-turret::before {
  content: "\\e1b4";
}

.fa-house-user::before {
  content: "\\e1b0";
}

.fa-home-user::before {
  content: "\\e1b0";
}

.fa-house-window::before {
  content: "\\e3b3";
}

.fa-hryvnia-sign::before {
  content: "\\f6f2";
}

.fa-hryvnia::before {
  content: "\\f6f2";
}

.fa-hundred-points::before {
  content: "\\e41c";
}

.fa-100::before {
  content: "\\e41c";
}

.fa-hurricane::before {
  content: "\\f751";
}

.fa-hyphen::before {
  content: "\\-";
}

.fa-i::before {
  content: "I";
}

.fa-i-cursor::before {
  content: "\\f246";
}

.fa-ice-cream::before {
  content: "\\f810";
}

.fa-ice-skate::before {
  content: "\\f7ac";
}

.fa-icicles::before {
  content: "\\f7ad";
}

.fa-icons::before {
  content: "\\f86d";
}

.fa-heart-music-camera-bolt::before {
  content: "\\f86d";
}

.fa-id-badge::before {
  content: "\\f2c1";
}

.fa-id-card::before {
  content: "\\f2c2";
}

.fa-drivers-license::before {
  content: "\\f2c2";
}

.fa-id-card-clip::before {
  content: "\\f47f";
}

.fa-id-card-alt::before {
  content: "\\f47f";
}

.fa-igloo::before {
  content: "\\f7ae";
}

.fa-image::before {
  content: "\\f03e";
}

.fa-image-landscape::before {
  content: "\\e1b5";
}

.fa-landscape::before {
  content: "\\e1b5";
}

.fa-image-polaroid::before {
  content: "\\f8c4";
}

.fa-image-polaroid-user::before {
  content: "\\e1b6";
}

.fa-image-portrait::before {
  content: "\\f3e0";
}

.fa-portrait::before {
  content: "\\f3e0";
}

.fa-image-slash::before {
  content: "\\e1b7";
}

.fa-image-user::before {
  content: "\\e1b8";
}

.fa-images::before {
  content: "\\f302";
}

.fa-images-user::before {
  content: "\\e1b9";
}

.fa-inbox::before {
  content: "\\f01c";
}

.fa-inbox-full::before {
  content: "\\e1ba";
}

.fa-inbox-in::before {
  content: "\\f310";
}

.fa-inbox-arrow-down::before {
  content: "\\f310";
}

.fa-inbox-out::before {
  content: "\\f311";
}

.fa-inbox-arrow-up::before {
  content: "\\f311";
}

.fa-inboxes::before {
  content: "\\e1bb";
}

.fa-indent::before {
  content: "\\f03c";
}

.fa-indian-rupee-sign::before {
  content: "\\e1bc";
}

.fa-indian-rupee::before {
  content: "\\e1bc";
}

.fa-inr::before {
  content: "\\e1bc";
}

.fa-industry::before {
  content: "\\f275";
}

.fa-industry-windows::before {
  content: "\\f3b3";
}

.fa-industry-alt::before {
  content: "\\f3b3";
}

.fa-infinity::before {
  content: "\\f534";
}

.fa-info::before {
  content: "\\f129";
}

.fa-inhaler::before {
  content: "\\f5f9";
}

.fa-input-numeric::before {
  content: "\\e1bd";
}

.fa-input-pipe::before {
  content: "\\e1be";
}

.fa-input-text::before {
  content: "\\e1bf";
}

.fa-integral::before {
  content: "\\f667";
}

.fa-intersection::before {
  content: "\\f668";
}

.fa-island-tropical::before {
  content: "\\f811";
}

.fa-island-tree-palm::before {
  content: "\\f811";
}

.fa-italic::before {
  content: "\\f033";
}

.fa-j::before {
  content: "J";
}

.fa-jack-o-lantern::before {
  content: "\\f30e";
}

.fa-jedi::before {
  content: "\\f669";
}

.fa-jet-fighter::before {
  content: "\\f0fb";
}

.fa-fighter-jet::before {
  content: "\\f0fb";
}

.fa-joint::before {
  content: "\\f595";
}

.fa-joystick::before {
  content: "\\f8c5";
}

.fa-jug::before {
  content: "\\f8c6";
}

.fa-k::before {
  content: "K";
}

.fa-kaaba::before {
  content: "\\f66b";
}

.fa-kazoo::before {
  content: "\\f8c7";
}

.fa-kerning::before {
  content: "\\f86f";
}

.fa-key::before {
  content: "\\f084";
}

.fa-key-skeleton::before {
  content: "\\f6f3";
}

.fa-key-skeleton-left-right::before {
  content: "\\e3b4";
}

.fa-keyboard::before {
  content: "\\f11c";
}

.fa-keyboard-brightness::before {
  content: "\\e1c0";
}

.fa-keyboard-brightness-low::before {
  content: "\\e1c1";
}

.fa-keyboard-down::before {
  content: "\\e1c2";
}

.fa-keyboard-left::before {
  content: "\\e1c3";
}

.fa-keynote::before {
  content: "\\f66c";
}

.fa-khanda::before {
  content: "\\f66d";
}

.fa-kidneys::before {
  content: "\\f5fb";
}

.fa-kip-sign::before {
  content: "\\e1c4";
}

.fa-kit-medical::before {
  content: "\\f479";
}

.fa-first-aid::before {
  content: "\\f479";
}

.fa-kite::before {
  content: "\\f6f4";
}

.fa-kiwi-bird::before {
  content: "\\f535";
}

.fa-kiwi-fruit::before {
  content: "\\e30c";
}

.fa-knife::before {
  content: "\\f2e4";
}

.fa-utensil-knife::before {
  content: "\\f2e4";
}

.fa-knife-kitchen::before {
  content: "\\f6f5";
}

.fa-l::before {
  content: "L";
}

.fa-lacrosse-stick::before {
  content: "\\e3b5";
}

.fa-lacrosse-stick-ball::before {
  content: "\\e3b6";
}

.fa-lambda::before {
  content: "\\f66e";
}

.fa-lamp::before {
  content: "\\f4ca";
}

.fa-lamp-desk::before {
  content: "\\e014";
}

.fa-lamp-floor::before {
  content: "\\e015";
}

.fa-lamp-street::before {
  content: "\\e1c5";
}

.fa-landmark::before {
  content: "\\f66f";
}

.fa-landmark-dome::before {
  content: "\\f752";
}

.fa-landmark-alt::before {
  content: "\\f752";
}

.fa-language::before {
  content: "\\f1ab";
}

.fa-laptop::before {
  content: "\\f109";
}

.fa-laptop-arrow-down::before {
  content: "\\e1c6";
}

.fa-laptop-code::before {
  content: "\\f5fc";
}

.fa-laptop-medical::before {
  content: "\\f812";
}

.fa-laptop-mobile::before {
  content: "\\f87a";
}

.fa-phone-laptop::before {
  content: "\\f87a";
}

.fa-laptop-slash::before {
  content: "\\e1c7";
}

.fa-lari-sign::before {
  content: "\\e1c8";
}

.fa-lasso::before {
  content: "\\f8c8";
}

.fa-lasso-sparkles::before {
  content: "\\e1c9";
}

.fa-layer-group::before {
  content: "\\f5fd";
}

.fa-layer-minus::before {
  content: "\\f5fe";
}

.fa-layer-group-minus::before {
  content: "\\f5fe";
}

.fa-layer-plus::before {
  content: "\\f5ff";
}

.fa-layer-group-plus::before {
  content: "\\f5ff";
}

.fa-leaf::before {
  content: "\\f06c";
}

.fa-leaf-heart::before {
  content: "\\f4cb";
}

.fa-leaf-maple::before {
  content: "\\f6f6";
}

.fa-leaf-oak::before {
  content: "\\f6f7";
}

.fa-leafy-green::before {
  content: "\\e41d";
}

.fa-left::before {
  content: "\\f355";
}

.fa-arrow-alt-left::before {
  content: "\\f355";
}

.fa-left-from-line::before {
  content: "\\f348";
}

.fa-arrow-alt-from-right::before {
  content: "\\f348";
}

.fa-left-long::before {
  content: "\\f30a";
}

.fa-long-arrow-alt-left::before {
  content: "\\f30a";
}

.fa-left-long-to-line::before {
  content: "\\e41e";
}

.fa-left-right::before {
  content: "\\f337";
}

.fa-arrows-alt-h::before {
  content: "\\f337";
}

.fa-left-to-line::before {
  content: "\\f34b";
}

.fa-arrow-alt-to-left::before {
  content: "\\f34b";
}

.fa-lemon::before {
  content: "\\f094";
}

.fa-less-than::before {
  content: "\\<";
}

.fa-less-than-equal::before {
  content: "\\f537";
}

.fa-life-ring::before {
  content: "\\f1cd";
}

.fa-light-ceiling::before {
  content: "\\e016";
}

.fa-light-emergency::before {
  content: "\\e41f";
}

.fa-light-emergency-on::before {
  content: "\\e420";
}

.fa-light-switch::before {
  content: "\\e017";
}

.fa-light-switch-off::before {
  content: "\\e018";
}

.fa-light-switch-on::before {
  content: "\\e019";
}

.fa-lightbulb::before {
  content: "\\f0eb";
}

.fa-lightbulb-dollar::before {
  content: "\\f670";
}

.fa-lightbulb-exclamation::before {
  content: "\\f671";
}

.fa-lightbulb-exclamation-on::before {
  content: "\\e1ca";
}

.fa-lightbulb-on::before {
  content: "\\f672";
}

.fa-lightbulb-slash::before {
  content: "\\f673";
}

.fa-lights-holiday::before {
  content: "\\f7b2";
}

.fa-line-columns::before {
  content: "\\f870";
}

.fa-line-height::before {
  content: "\\f871";
}

.fa-link::before {
  content: "\\f0c1";
}

.fa-chain::before {
  content: "\\f0c1";
}

.fa-link-horizontal::before {
  content: "\\e1cb";
}

.fa-chain-horizontal::before {
  content: "\\e1cb";
}

.fa-link-horizontal-slash::before {
  content: "\\e1cc";
}

.fa-chain-horizontal-slash::before {
  content: "\\e1cc";
}

.fa-link-simple::before {
  content: "\\e1cd";
}

.fa-link-simple-slash::before {
  content: "\\e1ce";
}

.fa-link-slash::before {
  content: "\\f127";
}

.fa-chain-broken::before {
  content: "\\f127";
}

.fa-chain-slash::before {
  content: "\\f127";
}

.fa-unlink::before {
  content: "\\f127";
}

.fa-lips::before {
  content: "\\f600";
}

.fa-lira-sign::before {
  content: "\\f195";
}

.fa-list::before {
  content: "\\f03a";
}

.fa-list-squares::before {
  content: "\\f03a";
}

.fa-list-check::before {
  content: "\\f0ae";
}

.fa-tasks::before {
  content: "\\f0ae";
}

.fa-list-dropdown::before {
  content: "\\e1cf";
}

.fa-list-music::before {
  content: "\\f8c9";
}

.fa-list-ol::before {
  content: "\\f0cb";
}

.fa-list-1-2::before {
  content: "\\f0cb";
}

.fa-list-numeric::before {
  content: "\\f0cb";
}

.fa-list-radio::before {
  content: "\\e1d0";
}

.fa-list-timeline::before {
  content: "\\e1d1";
}

.fa-list-tree::before {
  content: "\\e1d2";
}

.fa-list-ul::before {
  content: "\\f0ca";
}

.fa-list-dots::before {
  content: "\\f0ca";
}

.fa-litecoin-sign::before {
  content: "\\e1d3";
}

.fa-loader::before {
  content: "\\e1d4";
}

.fa-lobster::before {
  content: "\\e421";
}

.fa-location-arrow::before {
  content: "\\f124";
}

.fa-location-check::before {
  content: "\\f606";
}

.fa-map-marker-check::before {
  content: "\\f606";
}

.fa-location-crosshairs::before {
  content: "\\f601";
}

.fa-location::before {
  content: "\\f601";
}

.fa-location-crosshairs-slash::before {
  content: "\\f603";
}

.fa-location-slash::before {
  content: "\\f603";
}

.fa-location-dot::before {
  content: "\\f3c5";
}

.fa-map-marker-alt::before {
  content: "\\f3c5";
}

.fa-location-dot-slash::before {
  content: "\\f605";
}

.fa-map-marker-alt-slash::before {
  content: "\\f605";
}

.fa-location-exclamation::before {
  content: "\\f608";
}

.fa-map-marker-exclamation::before {
  content: "\\f608";
}

.fa-location-minus::before {
  content: "\\f609";
}

.fa-map-marker-minus::before {
  content: "\\f609";
}

.fa-location-pen::before {
  content: "\\f607";
}

.fa-map-marker-edit::before {
  content: "\\f607";
}

.fa-location-pin::before {
  content: "\\f041";
}

.fa-map-marker::before {
  content: "\\f041";
}

.fa-location-pin-slash::before {
  content: "\\f60c";
}

.fa-map-marker-slash::before {
  content: "\\f60c";
}

.fa-location-plus::before {
  content: "\\f60a";
}

.fa-map-marker-plus::before {
  content: "\\f60a";
}

.fa-location-question::before {
  content: "\\f60b";
}

.fa-map-marker-question::before {
  content: "\\f60b";
}

.fa-location-smile::before {
  content: "\\f60d";
}

.fa-map-marker-smile::before {
  content: "\\f60d";
}

.fa-location-xmark::before {
  content: "\\f60e";
}

.fa-map-marker-times::before {
  content: "\\f60e";
}

.fa-map-marker-xmark::before {
  content: "\\f60e";
}

.fa-lock::before {
  content: "\\f023";
}

.fa-lock-a::before {
  content: "\\e422";
}

.fa-lock-hashtag::before {
  content: "\\e423";
}

.fa-lock-keyhole::before {
  content: "\\f30d";
}

.fa-lock-alt::before {
  content: "\\f30d";
}

.fa-lock-keyhole-open::before {
  content: "\\f3c2";
}

.fa-lock-open-alt::before {
  content: "\\f3c2";
}

.fa-lock-open::before {
  content: "\\f3c1";
}

.fa-lollipop::before {
  content: "\\e424";
}

.fa-lollypop::before {
  content: "\\e424";
}

.fa-loveseat::before {
  content: "\\f4cc";
}

.fa-couch-small::before {
  content: "\\f4cc";
}

.fa-luchador-mask::before {
  content: "\\f455";
}

.fa-luchador::before {
  content: "\\f455";
}

.fa-mask-luchador::before {
  content: "\\f455";
}

.fa-lungs::before {
  content: "\\f604";
}

.fa-lungs-virus::before {
  content: "\\e067";
}

.fa-m::before {
  content: "M";
}

.fa-mace::before {
  content: "\\f6f8";
}

.fa-magnet::before {
  content: "\\f076";
}

.fa-magnifying-glass::before {
  content: "\\f002";
}

.fa-search::before {
  content: "\\f002";
}

.fa-magnifying-glass-dollar::before {
  content: "\\f688";
}

.fa-search-dollar::before {
  content: "\\f688";
}

.fa-magnifying-glass-location::before {
  content: "\\f689";
}

.fa-search-location::before {
  content: "\\f689";
}

.fa-magnifying-glass-minus::before {
  content: "\\f010";
}

.fa-search-minus::before {
  content: "\\f010";
}

.fa-magnifying-glass-plus::before {
  content: "\\f00e";
}

.fa-search-plus::before {
  content: "\\f00e";
}

.fa-mailbox::before {
  content: "\\f813";
}

.fa-manat-sign::before {
  content: "\\e1d5";
}

.fa-mandolin::before {
  content: "\\f6f9";
}

.fa-mango::before {
  content: "\\e30f";
}

.fa-manhole::before {
  content: "\\e1d6";
}

.fa-map::before {
  content: "\\f279";
}

.fa-map-location::before {
  content: "\\f59f";
}

.fa-map-marked::before {
  content: "\\f59f";
}

.fa-map-location-dot::before {
  content: "\\f5a0";
}

.fa-map-marked-alt::before {
  content: "\\f5a0";
}

.fa-map-pin::before {
  content: "\\f276";
}

.fa-marker::before {
  content: "\\f5a1";
}

.fa-mars::before {
  content: "\\f222";
}

.fa-mars-and-venus::before {
  content: "\\f224";
}

.fa-mars-double::before {
  content: "\\f227";
}

.fa-mars-stroke::before {
  content: "\\f229";
}

.fa-mars-stroke-right::before {
  content: "\\f22b";
}

.fa-mars-stroke-h::before {
  content: "\\f22b";
}

.fa-mars-stroke-up::before {
  content: "\\f22a";
}

.fa-mars-stroke-v::before {
  content: "\\f22a";
}

.fa-martini-glass::before {
  content: "\\f57b";
}

.fa-glass-martini-alt::before {
  content: "\\f57b";
}

.fa-martini-glass-citrus::before {
  content: "\\f561";
}

.fa-cocktail::before {
  content: "\\f561";
}

.fa-martini-glass-empty::before {
  content: "\\f000";
}

.fa-glass-martini::before {
  content: "\\f000";
}

.fa-mask::before {
  content: "\\f6fa";
}

.fa-mask-face::before {
  content: "\\e1d7";
}

.fa-mask-snorkel::before {
  content: "\\e3b7";
}

.fa-masks-theater::before {
  content: "\\f630";
}

.fa-theater-masks::before {
  content: "\\f630";
}

.fa-maximize::before {
  content: "\\f31e";
}

.fa-expand-arrows-alt::before {
  content: "\\f31e";
}

.fa-meat::before {
  content: "\\f814";
}

.fa-medal::before {
  content: "\\f5a2";
}

.fa-megaphone::before {
  content: "\\f675";
}

.fa-melon::before {
  content: "\\e310";
}

.fa-melon-slice::before {
  content: "\\e311";
}

.fa-memo::before {
  content: "\\e1d8";
}

.fa-memo-circle-check::before {
  content: "\\e1d9";
}

.fa-memo-pad::before {
  content: "\\e1da";
}

.fa-memory::before {
  content: "\\f538";
}

.fa-menorah::before {
  content: "\\f676";
}

.fa-mercury::before {
  content: "\\f223";
}

.fa-message::before {
  content: "\\f27a";
}

.fa-comment-alt::before {
  content: "\\f27a";
}

.fa-message-arrow-down::before {
  content: "\\e1db";
}

.fa-comment-alt-arrow-down::before {
  content: "\\e1db";
}

.fa-message-arrow-up::before {
  content: "\\e1dc";
}

.fa-comment-alt-arrow-up::before {
  content: "\\e1dc";
}

.fa-message-arrow-up-right::before {
  content: "\\e1dd";
}

.fa-message-bot::before {
  content: "\\e3b8";
}

.fa-message-captions::before {
  content: "\\e1de";
}

.fa-comment-alt-captions::before {
  content: "\\e1de";
}

.fa-message-check::before {
  content: "\\f4a2";
}

.fa-comment-alt-check::before {
  content: "\\f4a2";
}

.fa-message-code::before {
  content: "\\e1df";
}

.fa-message-dollar::before {
  content: "\\f650";
}

.fa-comment-alt-dollar::before {
  content: "\\f650";
}

.fa-message-dots::before {
  content: "\\f4a3";
}

.fa-comment-alt-dots::before {
  content: "\\f4a3";
}

.fa-messaging::before {
  content: "\\f4a3";
}

.fa-message-exclamation::before {
  content: "\\f4a5";
}

.fa-comment-alt-exclamation::before {
  content: "\\f4a5";
}

.fa-message-image::before {
  content: "\\e1e0";
}

.fa-comment-alt-image::before {
  content: "\\e1e0";
}

.fa-message-lines::before {
  content: "\\f4a6";
}

.fa-comment-alt-lines::before {
  content: "\\f4a6";
}

.fa-message-medical::before {
  content: "\\f7f4";
}

.fa-comment-alt-medical::before {
  content: "\\f7f4";
}

.fa-message-middle::before {
  content: "\\e1e1";
}

.fa-comment-middle-alt::before {
  content: "\\e1e1";
}

.fa-message-middle-top::before {
  content: "\\e1e2";
}

.fa-comment-middle-top-alt::before {
  content: "\\e1e2";
}

.fa-message-minus::before {
  content: "\\f4a7";
}

.fa-comment-alt-minus::before {
  content: "\\f4a7";
}

.fa-message-music::before {
  content: "\\f8af";
}

.fa-comment-alt-music::before {
  content: "\\f8af";
}

.fa-message-pen::before {
  content: "\\f4a4";
}

.fa-comment-alt-edit::before {
  content: "\\f4a4";
}

.fa-message-edit::before {
  content: "\\f4a4";
}

.fa-message-plus::before {
  content: "\\f4a8";
}

.fa-comment-alt-plus::before {
  content: "\\f4a8";
}

.fa-message-question::before {
  content: "\\e1e3";
}

.fa-message-quote::before {
  content: "\\e1e4";
}

.fa-comment-alt-quote::before {
  content: "\\e1e4";
}

.fa-message-slash::before {
  content: "\\f4a9";
}

.fa-comment-alt-slash::before {
  content: "\\f4a9";
}

.fa-message-smile::before {
  content: "\\f4aa";
}

.fa-comment-alt-smile::before {
  content: "\\f4aa";
}

.fa-message-sms::before {
  content: "\\e1e5";
}

.fa-message-text::before {
  content: "\\e1e6";
}

.fa-comment-alt-text::before {
  content: "\\e1e6";
}

.fa-message-xmark::before {
  content: "\\f4ab";
}

.fa-comment-alt-times::before {
  content: "\\f4ab";
}

.fa-message-times::before {
  content: "\\f4ab";
}

.fa-messages::before {
  content: "\\f4b6";
}

.fa-comments-alt::before {
  content: "\\f4b6";
}

.fa-messages-dollar::before {
  content: "\\f652";
}

.fa-comments-alt-dollar::before {
  content: "\\f652";
}

.fa-messages-question::before {
  content: "\\e1e7";
}

.fa-meteor::before {
  content: "\\f753";
}

.fa-meter::before {
  content: "\\e1e8";
}

.fa-meter-bolt::before {
  content: "\\e1e9";
}

.fa-meter-droplet::before {
  content: "\\e1ea";
}

.fa-meter-fire::before {
  content: "\\e1eb";
}

.fa-microchip::before {
  content: "\\f2db";
}

.fa-microchip-ai::before {
  content: "\\e1ec";
}

.fa-microphone::before {
  content: "\\f130";
}

.fa-microphone-lines::before {
  content: "\\f3c9";
}

.fa-microphone-alt::before {
  content: "\\f3c9";
}

.fa-microphone-lines-slash::before {
  content: "\\f539";
}

.fa-microphone-alt-slash::before {
  content: "\\f539";
}

.fa-microphone-slash::before {
  content: "\\f131";
}

.fa-microphone-stand::before {
  content: "\\f8cb";
}

.fa-microscope::before {
  content: "\\f610";
}

.fa-microwave::before {
  content: "\\e01b";
}

.fa-mill-sign::before {
  content: "\\e1ed";
}

.fa-minimize::before {
  content: "\\f78c";
}

.fa-compress-arrows-alt::before {
  content: "\\f78c";
}

.fa-minus::before {
  content: "\\f068";
}

.fa-subtract::before {
  content: "\\f068";
}

.fa-mistletoe::before {
  content: "\\f7b4";
}

.fa-mitten::before {
  content: "\\f7b5";
}

.fa-mobile::before {
  content: "\\f3ce";
}

.fa-mobile-android::before {
  content: "\\f3ce";
}

.fa-mobile-phone::before {
  content: "\\f3ce";
}

.fa-mobile-button::before {
  content: "\\f10b";
}

.fa-mobile-notch::before {
  content: "\\e1ee";
}

.fa-mobile-iphone::before {
  content: "\\e1ee";
}

.fa-mobile-screen::before {
  content: "\\f3cf";
}

.fa-mobile-android-alt::before {
  content: "\\f3cf";
}

.fa-mobile-screen-button::before {
  content: "\\f3cd";
}

.fa-mobile-alt::before {
  content: "\\f3cd";
}

.fa-mobile-signal::before {
  content: "\\e1ef";
}

.fa-mobile-signal-out::before {
  content: "\\e1f0";
}

.fa-money-bill::before {
  content: "\\f0d6";
}

.fa-money-bill-1::before {
  content: "\\f3d1";
}

.fa-money-bill-alt::before {
  content: "\\f3d1";
}

.fa-money-bill-1-wave::before {
  content: "\\f53b";
}

.fa-money-bill-wave-alt::before {
  content: "\\f53b";
}

.fa-money-bill-simple::before {
  content: "\\e1f1";
}

.fa-money-bill-simple-wave::before {
  content: "\\e1f2";
}

.fa-money-bill-wave::before {
  content: "\\f53a";
}

.fa-money-bills::before {
  content: "\\e1f3";
}

.fa-money-bills-simple::before {
  content: "\\e1f4";
}

.fa-money-bills-alt::before {
  content: "\\e1f4";
}

.fa-money-check::before {
  content: "\\f53c";
}

.fa-money-check-dollar::before {
  content: "\\f53d";
}

.fa-money-check-alt::before {
  content: "\\f53d";
}

.fa-money-check-dollar-pen::before {
  content: "\\f873";
}

.fa-money-check-edit-alt::before {
  content: "\\f873";
}

.fa-money-check-pen::before {
  content: "\\f872";
}

.fa-money-check-edit::before {
  content: "\\f872";
}

.fa-money-from-bracket::before {
  content: "\\e312";
}

.fa-money-simple-from-bracket::before {
  content: "\\e313";
}

.fa-monitor-waveform::before {
  content: "\\f611";
}

.fa-monitor-heart-rate::before {
  content: "\\f611";
}

.fa-monkey::before {
  content: "\\f6fb";
}

.fa-monument::before {
  content: "\\f5a6";
}

.fa-moon::before {
  content: "\\f186";
}

.fa-moon-cloud::before {
  content: "\\f754";
}

.fa-moon-over-sun::before {
  content: "\\f74a";
}

.fa-eclipse-alt::before {
  content: "\\f74a";
}

.fa-moon-stars::before {
  content: "\\f755";
}

.fa-moped::before {
  content: "\\e3b9";
}

.fa-mortar-pestle::before {
  content: "\\f5a7";
}

.fa-mosque::before {
  content: "\\f678";
}

.fa-motorcycle::before {
  content: "\\f21c";
}

.fa-mountain::before {
  content: "\\f6fc";
}

.fa-mountains::before {
  content: "\\f6fd";
}

.fa-mp3-player::before {
  content: "\\f8ce";
}

.fa-mug::before {
  content: "\\f874";
}

.fa-mug-hot::before {
  content: "\\f7b6";
}

.fa-mug-marshmallows::before {
  content: "\\f7b7";
}

.fa-mug-saucer::before {
  content: "\\f0f4";
}

.fa-coffee::before {
  content: "\\f0f4";
}

.fa-mug-tea::before {
  content: "\\f875";
}

.fa-mug-tea-saucer::before {
  content: "\\e1f5";
}

.fa-mushroom::before {
  content: "\\e425";
}

.fa-music::before {
  content: "\\f001";
}

.fa-music-note::before {
  content: "\\f8cf";
}

.fa-music-alt::before {
  content: "\\f8cf";
}

.fa-music-note-slash::before {
  content: "\\f8d0";
}

.fa-music-alt-slash::before {
  content: "\\f8d0";
}

.fa-music-slash::before {
  content: "\\f8d1";
}

.fa-n::before {
  content: "N";
}

.fa-naira-sign::before {
  content: "\\e1f6";
}

.fa-narwhal::before {
  content: "\\f6fe";
}

.fa-nesting-dolls::before {
  content: "\\e3ba";
}

.fa-network-wired::before {
  content: "\\f6ff";
}

.fa-neuter::before {
  content: "\\f22c";
}

.fa-newspaper::before {
  content: "\\f1ea";
}

.fa-nfc::before {
  content: "\\e1f7";
}

.fa-nfc-lock::before {
  content: "\\e1f8";
}

.fa-nfc-magnifying-glass::before {
  content: "\\e1f9";
}

.fa-nfc-pen::before {
  content: "\\e1fa";
}

.fa-nfc-signal::before {
  content: "\\e1fb";
}

.fa-nfc-slash::before {
  content: "\\e1fc";
}

.fa-nfc-trash::before {
  content: "\\e1fd";
}

.fa-not-equal::before {
  content: "\\f53e";
}

.fa-notdef::before {
  content: "\\e1fe";
}

.fa-note::before {
  content: "\\e1ff";
}

.fa-note-medical::before {
  content: "\\e200";
}

.fa-note-sticky::before {
  content: "\\f249";
}

.fa-sticky-note::before {
  content: "\\f249";
}

.fa-notebook::before {
  content: "\\e201";
}

.fa-notes::before {
  content: "\\e202";
}

.fa-notes-medical::before {
  content: "\\f481";
}

.fa-o::before {
  content: "O";
}

.fa-object-group::before {
  content: "\\f247";
}

.fa-object-ungroup::before {
  content: "\\f248";
}

.fa-objects-align-bottom::before {
  content: "\\e3bb";
}

.fa-objects-align-center-horizontal::before {
  content: "\\e3bc";
}

.fa-objects-align-center-vertical::before {
  content: "\\e3bd";
}

.fa-objects-align-left::before {
  content: "\\e3be";
}

.fa-objects-align-right::before {
  content: "\\e3bf";
}

.fa-objects-align-top::before {
  content: "\\e3c0";
}

.fa-objects-column::before {
  content: "\\e3c1";
}

.fa-octagon::before {
  content: "\\f306";
}

.fa-octagon-check::before {
  content: "\\e426";
}

.fa-octagon-divide::before {
  content: "\\e203";
}

.fa-octagon-exclamation::before {
  content: "\\e204";
}

.fa-octagon-minus::before {
  content: "\\f308";
}

.fa-minus-octagon::before {
  content: "\\f308";
}

.fa-octagon-plus::before {
  content: "\\f301";
}

.fa-plus-octagon::before {
  content: "\\f301";
}

.fa-octagon-xmark::before {
  content: "\\f2f0";
}

.fa-times-octagon::before {
  content: "\\f2f0";
}

.fa-xmark-octagon::before {
  content: "\\f2f0";
}

.fa-oil-can::before {
  content: "\\f613";
}

.fa-oil-can-drip::before {
  content: "\\e205";
}

.fa-oil-temperature::before {
  content: "\\f614";
}

.fa-oil-temp::before {
  content: "\\f614";
}

.fa-olive::before {
  content: "\\e316";
}

.fa-olive-branch::before {
  content: "\\e317";
}

.fa-om::before {
  content: "\\f679";
}

.fa-omega::before {
  content: "\\f67a";
}

.fa-onion::before {
  content: "\\e427";
}

.fa-option::before {
  content: "\\e318";
}

.fa-ornament::before {
  content: "\\f7b8";
}

.fa-otter::before {
  content: "\\f700";
}

.fa-outdent::before {
  content: "\\f03b";
}

.fa-dedent::before {
  content: "\\f03b";
}

.fa-outlet::before {
  content: "\\e01c";
}

.fa-oven::before {
  content: "\\e01d";
}

.fa-overline::before {
  content: "\\f876";
}

.fa-p::before {
  content: "P";
}

.fa-page::before {
  content: "\\e428";
}

.fa-page-caret-down::before {
  content: "\\e429";
}

.fa-file-caret-down::before {
  content: "\\e429";
}

.fa-page-caret-up::before {
  content: "\\e42a";
}

.fa-file-caret-up::before {
  content: "\\e42a";
}

.fa-pager::before {
  content: "\\f815";
}

.fa-paint-brush::before {
  content: "\\f1fc";
}

.fa-paint-brush-fine::before {
  content: "\\f5a9";
}

.fa-paint-brush-alt::before {
  content: "\\f5a9";
}

.fa-paint-roller::before {
  content: "\\f5aa";
}

.fa-paintbrush-pencil::before {
  content: "\\e206";
}

.fa-palette::before {
  content: "\\f53f";
}

.fa-pallet::before {
  content: "\\f482";
}

.fa-pallet-box::before {
  content: "\\e208";
}

.fa-pallet-boxes::before {
  content: "\\f483";
}

.fa-palette-boxes::before {
  content: "\\f483";
}

.fa-pallet-alt::before {
  content: "\\f483";
}

.fa-pan-food::before {
  content: "\\e42b";
}

.fa-pan-frying::before {
  content: "\\e42c";
}

.fa-pancakes::before {
  content: "\\e42d";
}

.fa-panel-ews::before {
  content: "\\e42e";
}

.fa-panel-fire::before {
  content: "\\e42f";
}

.fa-panorama::before {
  content: "\\e209";
}

.fa-paper-plane::before {
  content: "\\f1d8";
}

.fa-paper-plane-top::before {
  content: "\\e20a";
}

.fa-paper-plane-alt::before {
  content: "\\e20a";
}

.fa-send::before {
  content: "\\e20a";
}

.fa-paperclip::before {
  content: "\\f0c6";
}

.fa-paperclip-vertical::before {
  content: "\\e3c2";
}

.fa-parachute-box::before {
  content: "\\f4cd";
}

.fa-paragraph::before {
  content: "\\f1dd";
}

.fa-paragraph-left::before {
  content: "\\f878";
}

.fa-paragraph-rtl::before {
  content: "\\f878";
}

.fa-party-bell::before {
  content: "\\e31a";
}

.fa-party-horn::before {
  content: "\\e31b";
}

.fa-passport::before {
  content: "\\f5ab";
}

.fa-paste::before {
  content: "\\f0ea";
}

.fa-file-clipboard::before {
  content: "\\f0ea";
}

.fa-pause::before {
  content: "\\f04c";
}

.fa-paw::before {
  content: "\\f1b0";
}

.fa-paw-claws::before {
  content: "\\f702";
}

.fa-paw-simple::before {
  content: "\\f701";
}

.fa-paw-alt::before {
  content: "\\f701";
}

.fa-peace::before {
  content: "\\f67c";
}

.fa-peach::before {
  content: "\\e20b";
}

.fa-peanut::before {
  content: "\\e430";
}

.fa-peanuts::before {
  content: "\\e431";
}

.fa-peapod::before {
  content: "\\e31c";
}

.fa-pear::before {
  content: "\\e20c";
}

.fa-pedestal::before {
  content: "\\e20d";
}

.fa-pegasus::before {
  content: "\\f703";
}

.fa-pen::before {
  content: "\\f304";
}

.fa-pen-circle::before {
  content: "\\e20e";
}

.fa-pen-clip::before {
  content: "\\f305";
}

.fa-pen-alt::before {
  content: "\\f305";
}

.fa-pen-clip-slash::before {
  content: "\\e20f";
}

.fa-pen-alt-slash::before {
  content: "\\e20f";
}

.fa-pen-fancy::before {
  content: "\\f5ac";
}

.fa-pen-fancy-slash::before {
  content: "\\e210";
}

.fa-pen-field::before {
  content: "\\e211";
}

.fa-pen-line::before {
  content: "\\e212";
}

.fa-pen-nib::before {
  content: "\\f5ad";
}

.fa-pen-paintbrush::before {
  content: "\\f618";
}

.fa-pencil-paintbrush::before {
  content: "\\f618";
}

.fa-pen-ruler::before {
  content: "\\f5ae";
}

.fa-pencil-ruler::before {
  content: "\\f5ae";
}

.fa-pen-slash::before {
  content: "\\e213";
}

.fa-pen-swirl::before {
  content: "\\e214";
}

.fa-pen-to-square::before {
  content: "\\f044";
}

.fa-edit::before {
  content: "\\f044";
}

.fa-pencil::before {
  content: "\\f303";
}

.fa-pencil-alt::before {
  content: "\\f303";
}

.fa-pencil-slash::before {
  content: "\\e215";
}

.fa-people::before {
  content: "\\e216";
}

.fa-people-arrows-left-right::before {
  content: "\\e068";
}

.fa-people-arrows::before {
  content: "\\e068";
}

.fa-people-carry-box::before {
  content: "\\f4ce";
}

.fa-people-carry::before {
  content: "\\f4ce";
}

.fa-people-dress::before {
  content: "\\e217";
}

.fa-people-dress-simple::before {
  content: "\\e218";
}

.fa-people-pants::before {
  content: "\\e219";
}

.fa-people-pants-simple::before {
  content: "\\e21a";
}

.fa-people-simple::before {
  content: "\\e21b";
}

.fa-pepper::before {
  content: "\\e432";
}

.fa-pepper-hot::before {
  content: "\\f816";
}

.fa-percent::before {
  content: "\\%";
}

.fa-percentage::before {
  content: "\\%";
}

.fa-period::before {
  content: "\\.";
}

.fa-person::before {
  content: "\\f183";
}

.fa-male::before {
  content: "\\f183";
}

.fa-person-biking::before {
  content: "\\f84a";
}

.fa-biking::before {
  content: "\\f84a";
}

.fa-person-biking-mountain::before {
  content: "\\f84b";
}

.fa-biking-mountain::before {
  content: "\\f84b";
}

.fa-person-booth::before {
  content: "\\f756";
}

.fa-person-carry-box::before {
  content: "\\f4cf";
}

.fa-person-carry::before {
  content: "\\f4cf";
}

.fa-person-digging::before {
  content: "\\f85e";
}

.fa-digging::before {
  content: "\\f85e";
}

.fa-person-dolly::before {
  content: "\\f4d0";
}

.fa-person-dolly-empty::before {
  content: "\\f4d1";
}

.fa-person-dots-from-line::before {
  content: "\\f470";
}

.fa-diagnoses::before {
  content: "\\f470";
}

.fa-person-dress::before {
  content: "\\f182";
}

.fa-female::before {
  content: "\\f182";
}

.fa-person-dress-simple::before {
  content: "\\e21c";
}

.fa-person-from-portal::before {
  content: "\\e023";
}

.fa-portal-exit::before {
  content: "\\e023";
}

.fa-person-hiking::before {
  content: "\\f6ec";
}

.fa-hiking::before {
  content: "\\f6ec";
}

.fa-person-pinball::before {
  content: "\\e21d";
}

.fa-person-praying::before {
  content: "\\f683";
}

.fa-pray::before {
  content: "\\f683";
}

.fa-person-pregnant::before {
  content: "\\e31e";
}

.fa-person-running::before {
  content: "\\f70c";
}

.fa-running::before {
  content: "\\f70c";
}

.fa-person-seat::before {
  content: "\\e21e";
}

.fa-person-seat-reclined::before {
  content: "\\e21f";
}

.fa-person-sign::before {
  content: "\\f757";
}

.fa-person-simple::before {
  content: "\\e220";
}

.fa-person-skating::before {
  content: "\\f7c5";
}

.fa-skating::before {
  content: "\\f7c5";
}

.fa-person-ski-jumping::before {
  content: "\\f7c7";
}

.fa-ski-jump::before {
  content: "\\f7c7";
}

.fa-person-ski-lift::before {
  content: "\\f7c8";
}

.fa-ski-lift::before {
  content: "\\f7c8";
}

.fa-person-skiing::before {
  content: "\\f7c9";
}

.fa-skiing::before {
  content: "\\f7c9";
}

.fa-person-skiing-nordic::before {
  content: "\\f7ca";
}

.fa-skiing-nordic::before {
  content: "\\f7ca";
}

.fa-person-sledding::before {
  content: "\\f7cb";
}

.fa-sledding::before {
  content: "\\f7cb";
}

.fa-person-snowboarding::before {
  content: "\\f7ce";
}

.fa-snowboarding::before {
  content: "\\f7ce";
}

.fa-person-snowmobiling::before {
  content: "\\f7d1";
}

.fa-snowmobile::before {
  content: "\\f7d1";
}

.fa-person-swimming::before {
  content: "\\f5c4";
}

.fa-swimmer::before {
  content: "\\f5c4";
}

.fa-person-to-door::before {
  content: "\\e433";
}

.fa-person-to-portal::before {
  content: "\\e022";
}

.fa-portal-enter::before {
  content: "\\e022";
}

.fa-person-walking::before {
  content: "\\f554";
}

.fa-walking::before {
  content: "\\f554";
}

.fa-person-walking-with-cane::before {
  content: "\\f29d";
}

.fa-blind::before {
  content: "\\f29d";
}

.fa-peseta-sign::before {
  content: "\\e221";
}

.fa-peso-sign::before {
  content: "\\e222";
}

.fa-phone::before {
  content: "\\f095";
}

.fa-phone-arrow-down-left::before {
  content: "\\e223";
}

.fa-phone-arrow-down::before {
  content: "\\e223";
}

.fa-phone-incoming::before {
  content: "\\e223";
}

.fa-phone-arrow-up-right::before {
  content: "\\e224";
}

.fa-phone-arrow-up::before {
  content: "\\e224";
}

.fa-phone-outgoing::before {
  content: "\\e224";
}

.fa-phone-flip::before {
  content: "\\f879";
}

.fa-phone-alt::before {
  content: "\\f879";
}

.fa-phone-hangup::before {
  content: "\\e225";
}

.fa-phone-intercom::before {
  content: "\\e434";
}

.fa-phone-missed::before {
  content: "\\e226";
}

.fa-phone-office::before {
  content: "\\f67d";
}

.fa-phone-plus::before {
  content: "\\f4d2";
}

.fa-phone-rotary::before {
  content: "\\f8d3";
}

.fa-phone-slash::before {
  content: "\\f3dd";
}

.fa-phone-volume::before {
  content: "\\f2a0";
}

.fa-volume-control-phone::before {
  content: "\\f2a0";
}

.fa-phone-xmark::before {
  content: "\\e227";
}

.fa-photo-film::before {
  content: "\\f87c";
}

.fa-photo-video::before {
  content: "\\f87c";
}

.fa-photo-film-music::before {
  content: "\\e228";
}

.fa-pi::before {
  content: "\\f67e";
}

.fa-piano::before {
  content: "\\f8d4";
}

.fa-piano-keyboard::before {
  content: "\\f8d5";
}

.fa-pickleball::before {
  content: "\\e435";
}

.fa-pie::before {
  content: "\\f705";
}

.fa-pig::before {
  content: "\\f706";
}

.fa-piggy-bank::before {
  content: "\\f4d3";
}

.fa-pills::before {
  content: "\\f484";
}

.fa-pinata::before {
  content: "\\e3c3";
}

.fa-pinball::before {
  content: "\\e229";
}

.fa-pineapple::before {
  content: "\\e31f";
}

.fa-pipe::before {
  content: "\\|";
}

.fa-pipe-circle-check::before {
  content: "\\e436";
}

.fa-pipe-collar::before {
  content: "\\e437";
}

.fa-pipe-section::before {
  content: "\\e438";
}

.fa-pipe-smoking::before {
  content: "\\e3c4";
}

.fa-pipe-valve::before {
  content: "\\e439";
}

.fa-pizza::before {
  content: "\\f817";
}

.fa-pizza-slice::before {
  content: "\\f818";
}

.fa-place-of-worship::before {
  content: "\\f67f";
}

.fa-plane::before {
  content: "\\f072";
}

.fa-plane-arrival::before {
  content: "\\f5af";
}

.fa-plane-departure::before {
  content: "\\f5b0";
}

.fa-plane-engines::before {
  content: "\\f3de";
}

.fa-plane-alt::before {
  content: "\\f3de";
}

.fa-plane-prop::before {
  content: "\\e22b";
}

.fa-plane-slash::before {
  content: "\\e069";
}

.fa-plane-tail::before {
  content: "\\e22c";
}

.fa-plane-up::before {
  content: "\\e22d";
}

.fa-plane-up-slash::before {
  content: "\\e22e";
}

.fa-planet-moon::before {
  content: "\\e01f";
}

.fa-planet-ringed::before {
  content: "\\e020";
}

.fa-plate-utensils::before {
  content: "\\e43b";
}

.fa-play::before {
  content: "\\f04b";
}

.fa-play-pause::before {
  content: "\\e22f";
}

.fa-plug::before {
  content: "\\f1e6";
}

.fa-plus::before {
  content: "\\+";
}

.fa-add::before {
  content: "\\+";
}

.fa-plus-minus::before {
  content: "\\e43c";
}

.fa-podcast::before {
  content: "\\f2ce";
}

.fa-podium::before {
  content: "\\f680";
}

.fa-podium-star::before {
  content: "\\f758";
}

.fa-police-box::before {
  content: "\\e021";
}

.fa-poll-people::before {
  content: "\\f759";
}

.fa-pompebled::before {
  content: "\\e43d";
}

.fa-poo::before {
  content: "\\f2fe";
}

.fa-poo-storm::before {
  content: "\\f75a";
}

.fa-poo-bolt::before {
  content: "\\f75a";
}

.fa-pool-8-ball::before {
  content: "\\e3c5";
}

.fa-poop::before {
  content: "\\f619";
}

.fa-popcorn::before {
  content: "\\f819";
}

.fa-popsicle::before {
  content: "\\e43e";
}

.fa-pot-food::before {
  content: "\\e43f";
}

.fa-potato::before {
  content: "\\e440";
}

.fa-power-off::before {
  content: "\\f011";
}

.fa-prescription::before {
  content: "\\f5b1";
}

.fa-prescription-bottle::before {
  content: "\\f485";
}

.fa-prescription-bottle-medical::before {
  content: "\\f486";
}

.fa-prescription-bottle-alt::before {
  content: "\\f486";
}

.fa-presentation-screen::before {
  content: "\\f685";
}

.fa-presentation::before {
  content: "\\f685";
}

.fa-pretzel::before {
  content: "\\e441";
}

.fa-print::before {
  content: "\\f02f";
}

.fa-print-magnifying-glass::before {
  content: "\\f81a";
}

.fa-print-search::before {
  content: "\\f81a";
}

.fa-print-slash::before {
  content: "\\f686";
}

.fa-projector::before {
  content: "\\f8d6";
}

.fa-pump::before {
  content: "\\e442";
}

.fa-pump-medical::before {
  content: "\\e06a";
}

.fa-pump-soap::before {
  content: "\\e06b";
}

.fa-pumpkin::before {
  content: "\\f707";
}

.fa-puzzle::before {
  content: "\\e443";
}

.fa-puzzle-piece::before {
  content: "\\f12e";
}

.fa-puzzle-piece-simple::before {
  content: "\\e231";
}

.fa-puzzle-piece-alt::before {
  content: "\\e231";
}

.fa-q::before {
  content: "Q";
}

.fa-qrcode::before {
  content: "\\f029";
}

.fa-question::before {
  content: "\\?";
}

.fa-quidditch::before {
  content: "\\f458";
}

.fa-broom-ball::before {
  content: "\\f458";
}

.fa-quidditch-broom-ball::before {
  content: "\\f458";
}

.fa-quote-left::before {
  content: "\\f10d";
}

.fa-quote-left-alt::before {
  content: "\\f10d";
}

.fa-quote-right::before {
  content: "\\f10e";
}

.fa-quote-right-alt::before {
  content: "\\f10e";
}

.fa-quotes::before {
  content: "\\e234";
}

.fa-r::before {
  content: "R";
}

.fa-rabbit::before {
  content: "\\f708";
}

.fa-rabbit-running::before {
  content: "\\f709";
}

.fa-rabbit-fast::before {
  content: "\\f709";
}

.fa-racquet::before {
  content: "\\f45a";
}

.fa-radar::before {
  content: "\\e024";
}

.fa-radiation::before {
  content: "\\f7b9";
}

.fa-radio::before {
  content: "\\f8d7";
}

.fa-radio-tuner::before {
  content: "\\f8d8";
}

.fa-radio-alt::before {
  content: "\\f8d8";
}

.fa-rainbow::before {
  content: "\\f75b";
}

.fa-raindrops::before {
  content: "\\f75c";
}

.fa-ram::before {
  content: "\\f70a";
}

.fa-ramp-loading::before {
  content: "\\f4d4";
}

.fa-raygun::before {
  content: "\\e025";
}

.fa-receipt::before {
  content: "\\f543";
}

.fa-record-vinyl::before {
  content: "\\f8d9";
}

.fa-rectangle::before {
  content: "\\f2fa";
}

.fa-rectangle-landscape::before {
  content: "\\f2fa";
}

.fa-rectangle-ad::before {
  content: "\\f641";
}

.fa-ad::before {
  content: "\\f641";
}

.fa-rectangle-barcode::before {
  content: "\\f463";
}

.fa-barcode-alt::before {
  content: "\\f463";
}

.fa-rectangle-code::before {
  content: "\\e322";
}

.fa-rectangle-list::before {
  content: "\\f022";
}

.fa-list-alt::before {
  content: "\\f022";
}

.fa-rectangle-pro::before {
  content: "\\e235";
}

.fa-pro::before {
  content: "\\e235";
}

.fa-rectangle-terminal::before {
  content: "\\e236";
}

.fa-rectangle-vertical::before {
  content: "\\f2fb";
}

.fa-rectangle-portrait::before {
  content: "\\f2fb";
}

.fa-rectangle-vertical-history::before {
  content: "\\e237";
}

.fa-rectangle-wide::before {
  content: "\\f2fc";
}

.fa-rectangle-xmark::before {
  content: "\\f410";
}

.fa-rectangle-times::before {
  content: "\\f410";
}

.fa-times-rectangle::before {
  content: "\\f410";
}

.fa-window-close::before {
  content: "\\f410";
}

.fa-rectangles-mixed::before {
  content: "\\e323";
}

.fa-recycle::before {
  content: "\\f1b8";
}

.fa-reel::before {
  content: "\\e238";
}

.fa-refrigerator::before {
  content: "\\e026";
}

.fa-registered::before {
  content: "\\f25d";
}

.fa-repeat::before {
  content: "\\f363";
}

.fa-repeat-1::before {
  content: "\\f365";
}

.fa-reply::before {
  content: "\\f3e5";
}

.fa-mail-reply::before {
  content: "\\f3e5";
}

.fa-reply-all::before {
  content: "\\f122";
}

.fa-mail-reply-all::before {
  content: "\\f122";
}

.fa-reply-clock::before {
  content: "\\e239";
}

.fa-reply-time::before {
  content: "\\e239";
}

.fa-republican::before {
  content: "\\f75e";
}

.fa-restroom::before {
  content: "\\f7bd";
}

.fa-restroom-simple::before {
  content: "\\e23a";
}

.fa-retweet::before {
  content: "\\f079";
}

.fa-rhombus::before {
  content: "\\e23b";
}

.fa-ribbon::before {
  content: "\\f4d6";
}

.fa-right::before {
  content: "\\f356";
}

.fa-arrow-alt-right::before {
  content: "\\f356";
}

.fa-right-from-bracket::before {
  content: "\\f2f5";
}

.fa-sign-out-alt::before {
  content: "\\f2f5";
}

.fa-right-from-line::before {
  content: "\\f347";
}

.fa-arrow-alt-from-left::before {
  content: "\\f347";
}

.fa-right-left::before {
  content: "\\f362";
}

.fa-exchange-alt::before {
  content: "\\f362";
}

.fa-right-long::before {
  content: "\\f30b";
}

.fa-long-arrow-alt-right::before {
  content: "\\f30b";
}

.fa-right-long-to-line::before {
  content: "\\e444";
}

.fa-right-to-bracket::before {
  content: "\\f2f6";
}

.fa-sign-in-alt::before {
  content: "\\f2f6";
}

.fa-right-to-line::before {
  content: "\\f34c";
}

.fa-arrow-alt-to-right::before {
  content: "\\f34c";
}

.fa-ring::before {
  content: "\\f70b";
}

.fa-rings-wedding::before {
  content: "\\f81b";
}

.fa-road::before {
  content: "\\f018";
}

.fa-robot::before {
  content: "\\f544";
}

.fa-robot-astromech::before {
  content: "\\e2d2";
}

.fa-rocket::before {
  content: "\\f135";
}

.fa-rocket-launch::before {
  content: "\\e027";
}

.fa-roller-coaster::before {
  content: "\\e324";
}

.fa-rotate::before {
  content: "\\f2f1";
}

.fa-sync-alt::before {
  content: "\\f2f1";
}

.fa-rotate-exclamation::before {
  content: "\\e23c";
}

.fa-rotate-left::before {
  content: "\\f2ea";
}

.fa-rotate-back::before {
  content: "\\f2ea";
}

.fa-rotate-backward::before {
  content: "\\f2ea";
}

.fa-undo-alt::before {
  content: "\\f2ea";
}

.fa-rotate-right::before {
  content: "\\f2f9";
}

.fa-redo-alt::before {
  content: "\\f2f9";
}

.fa-rotate-forward::before {
  content: "\\f2f9";
}

.fa-route::before {
  content: "\\f4d7";
}

.fa-route-highway::before {
  content: "\\f61a";
}

.fa-route-interstate::before {
  content: "\\f61b";
}

.fa-router::before {
  content: "\\f8da";
}

.fa-rss::before {
  content: "\\f09e";
}

.fa-feed::before {
  content: "\\f09e";
}

.fa-ruble-sign::before {
  content: "\\f158";
}

.fa-rouble::before {
  content: "\\f158";
}

.fa-rub::before {
  content: "\\f158";
}

.fa-ruble::before {
  content: "\\f158";
}

.fa-rugby-ball::before {
  content: "\\e3c6";
}

.fa-ruler::before {
  content: "\\f545";
}

.fa-ruler-combined::before {
  content: "\\f546";
}

.fa-ruler-horizontal::before {
  content: "\\f547";
}

.fa-ruler-triangle::before {
  content: "\\f61c";
}

.fa-ruler-vertical::before {
  content: "\\f548";
}

.fa-rupee-sign::before {
  content: "\\f156";
}

.fa-rupee::before {
  content: "\\f156";
}

.fa-rupiah-sign::before {
  content: "\\e23d";
}

.fa-rv::before {
  content: "\\f7be";
}

.fa-s::before {
  content: "S";
}

.fa-sack::before {
  content: "\\f81c";
}

.fa-sack-dollar::before {
  content: "\\f81d";
}

.fa-sailboat::before {
  content: "\\e445";
}

.fa-salad::before {
  content: "\\f81e";
}

.fa-bowl-salad::before {
  content: "\\f81e";
}

.fa-salt-shaker::before {
  content: "\\e446";
}

.fa-sandwich::before {
  content: "\\f81f";
}

.fa-satellite::before {
  content: "\\f7bf";
}

.fa-satellite-dish::before {
  content: "\\f7c0";
}

.fa-sausage::before {
  content: "\\f820";
}

.fa-saxophone::before {
  content: "\\f8dc";
}

.fa-saxophone-fire::before {
  content: "\\f8db";
}

.fa-sax-hot::before {
  content: "\\f8db";
}

.fa-scale-balanced::before {
  content: "\\f24e";
}

.fa-balance-scale::before {
  content: "\\f24e";
}

.fa-scale-unbalanced::before {
  content: "\\f515";
}

.fa-balance-scale-left::before {
  content: "\\f515";
}

.fa-scale-unbalanced-flip::before {
  content: "\\f516";
}

.fa-balance-scale-right::before {
  content: "\\f516";
}

.fa-scalpel::before {
  content: "\\f61d";
}

.fa-scalpel-line-dashed::before {
  content: "\\f61e";
}

.fa-scalpel-path::before {
  content: "\\f61e";
}

.fa-scanner::before {
  content: "\\f8f3";
}

.fa-scanner-image::before {
  content: "\\f8f3";
}

.fa-scanner-gun::before {
  content: "\\f488";
}

.fa-scanner-keyboard::before {
  content: "\\f489";
}

.fa-scanner-touchscreen::before {
  content: "\\f48a";
}

.fa-scarecrow::before {
  content: "\\f70d";
}

.fa-scarf::before {
  content: "\\f7c1";
}

.fa-school::before {
  content: "\\f549";
}

.fa-scissors::before {
  content: "\\f0c4";
}

.fa-cut::before {
  content: "\\f0c4";
}

.fa-screen-users::before {
  content: "\\f63d";
}

.fa-users-class::before {
  content: "\\f63d";
}

.fa-screencast::before {
  content: "\\e23e";
}

.fa-screwdriver::before {
  content: "\\f54a";
}

.fa-screwdriver-wrench::before {
  content: "\\f7d9";
}

.fa-tools::before {
  content: "\\f7d9";
}

.fa-scribble::before {
  content: "\\e23f";
}

.fa-scroll::before {
  content: "\\f70e";
}

.fa-scroll-old::before {
  content: "\\f70f";
}

.fa-scroll-torah::before {
  content: "\\f6a0";
}

.fa-torah::before {
  content: "\\f6a0";
}

.fa-scrubber::before {
  content: "\\f2f8";
}

.fa-scythe::before {
  content: "\\f710";
}

.fa-sd-card::before {
  content: "\\f7c2";
}

.fa-sd-cards::before {
  content: "\\e240";
}

.fa-seal::before {
  content: "\\e241";
}

.fa-seal-exclamation::before {
  content: "\\e242";
}

.fa-seal-question::before {
  content: "\\e243";
}

.fa-seat-airline::before {
  content: "\\e244";
}

.fa-section::before {
  content: "\\e447";
}

.fa-seedling::before {
  content: "\\f4d8";
}

.fa-sprout::before {
  content: "\\f4d8";
}

.fa-semicolon::before {
  content: "\\;";
}

.fa-send-back::before {
  content: "\\f87e";
}

.fa-send-backward::before {
  content: "\\f87f";
}

.fa-sensor::before {
  content: "\\e028";
}

.fa-sensor-cloud::before {
  content: "\\e02c";
}

.fa-sensor-smoke::before {
  content: "\\e02c";
}

.fa-sensor-fire::before {
  content: "\\e02a";
}

.fa-sensor-on::before {
  content: "\\e02b";
}

.fa-sensor-triangle-exclamation::before {
  content: "\\e029";
}

.fa-sensor-alert::before {
  content: "\\e029";
}

.fa-server::before {
  content: "\\f233";
}

.fa-shapes::before {
  content: "\\f61f";
}

.fa-triangle-circle-square::before {
  content: "\\f61f";
}

.fa-share::before {
  content: "\\f064";
}

.fa-arrow-turn-right::before {
  content: "\\f064";
}

.fa-mail-forward::before {
  content: "\\f064";
}

.fa-share-all::before {
  content: "\\f367";
}

.fa-arrows-turn-right::before {
  content: "\\f367";
}

.fa-share-from-square::before {
  content: "\\f14d";
}

.fa-share-square::before {
  content: "\\f14d";
}

.fa-share-nodes::before {
  content: "\\f1e0";
}

.fa-share-alt::before {
  content: "\\f1e0";
}

.fa-sheep::before {
  content: "\\f711";
}

.fa-shekel-sign::before {
  content: "\\f20b";
}

.fa-ils::before {
  content: "\\f20b";
}

.fa-shekel::before {
  content: "\\f20b";
}

.fa-sheqel::before {
  content: "\\f20b";
}

.fa-sheqel-sign::before {
  content: "\\f20b";
}

.fa-shelves::before {
  content: "\\f480";
}

.fa-inventory::before {
  content: "\\f480";
}

.fa-shelves-empty::before {
  content: "\\e246";
}

.fa-shield::before {
  content: "\\f132";
}

.fa-shield-blank::before {
  content: "\\f3ed";
}

.fa-shield-alt::before {
  content: "\\f3ed";
}

.fa-shield-check::before {
  content: "\\f2f7";
}

.fa-shield-cross::before {
  content: "\\f712";
}

.fa-shield-exclamation::before {
  content: "\\e247";
}

.fa-shield-keyhole::before {
  content: "\\e248";
}

.fa-shield-minus::before {
  content: "\\e249";
}

.fa-shield-plus::before {
  content: "\\e24a";
}

.fa-shield-slash::before {
  content: "\\e24b";
}

.fa-shield-virus::before {
  content: "\\e06c";
}

.fa-shield-xmark::before {
  content: "\\e24c";
}

.fa-shield-times::before {
  content: "\\e24c";
}

.fa-ship::before {
  content: "\\f21a";
}

.fa-shirt::before {
  content: "\\f553";
}

.fa-t-shirt::before {
  content: "\\f553";
}

.fa-tshirt::before {
  content: "\\f553";
}

.fa-shirt-long-sleeve::before {
  content: "\\e3c7";
}

.fa-shirt-running::before {
  content: "\\e3c8";
}

.fa-shirt-tank-top::before {
  content: "\\e3c9";
}

.fa-shish-kebab::before {
  content: "\\f821";
}

.fa-shoe-prints::before {
  content: "\\f54b";
}

.fa-shop::before {
  content: "\\f54f";
}

.fa-store-alt::before {
  content: "\\f54f";
}

.fa-shop-slash::before {
  content: "\\e070";
}

.fa-store-alt-slash::before {
  content: "\\e070";
}

.fa-shovel::before {
  content: "\\f713";
}

.fa-shovel-snow::before {
  content: "\\f7c3";
}

.fa-shower::before {
  content: "\\f2cc";
}

.fa-shower-down::before {
  content: "\\e24d";
}

.fa-shower-alt::before {
  content: "\\e24d";
}

.fa-shredder::before {
  content: "\\f68a";
}

.fa-shrimp::before {
  content: "\\e448";
}

.fa-shuffle::before {
  content: "\\f074";
}

.fa-random::before {
  content: "\\f074";
}

.fa-shutters::before {
  content: "\\e449";
}

.fa-shuttle-space::before {
  content: "\\f197";
}

.fa-space-shuttle::before {
  content: "\\f197";
}

.fa-shuttlecock::before {
  content: "\\f45b";
}

.fa-sickle::before {
  content: "\\f822";
}

.fa-sidebar::before {
  content: "\\e24e";
}

.fa-sidebar-flip::before {
  content: "\\e24f";
}

.fa-sigma::before {
  content: "\\f68b";
}

.fa-sign-hanging::before {
  content: "\\f4d9";
}

.fa-sign::before {
  content: "\\f4d9";
}

.fa-signal::before {
  content: "\\f012";
}

.fa-signal-5::before {
  content: "\\f012";
}

.fa-signal-perfect::before {
  content: "\\f012";
}

.fa-signal-bars::before {
  content: "\\f690";
}

.fa-signal-alt::before {
  content: "\\f690";
}

.fa-signal-alt-4::before {
  content: "\\f690";
}

.fa-signal-bars-strong::before {
  content: "\\f690";
}

.fa-signal-bars-fair::before {
  content: "\\f692";
}

.fa-signal-alt-2::before {
  content: "\\f692";
}

.fa-signal-bars-good::before {
  content: "\\f693";
}

.fa-signal-alt-3::before {
  content: "\\f693";
}

.fa-signal-bars-slash::before {
  content: "\\f694";
}

.fa-signal-alt-slash::before {
  content: "\\f694";
}

.fa-signal-bars-weak::before {
  content: "\\f691";
}

.fa-signal-alt-1::before {
  content: "\\f691";
}

.fa-signal-fair::before {
  content: "\\f68d";
}

.fa-signal-2::before {
  content: "\\f68d";
}

.fa-signal-good::before {
  content: "\\f68e";
}

.fa-signal-3::before {
  content: "\\f68e";
}

.fa-signal-slash::before {
  content: "\\f695";
}

.fa-signal-stream::before {
  content: "\\f8dd";
}

.fa-signal-stream-slash::before {
  content: "\\e250";
}

.fa-signal-strong::before {
  content: "\\f68f";
}

.fa-signal-4::before {
  content: "\\f68f";
}

.fa-signal-weak::before {
  content: "\\f68c";
}

.fa-signal-1::before {
  content: "\\f68c";
}

.fa-signature::before {
  content: "\\f5b7";
}

.fa-signature-lock::before {
  content: "\\e3ca";
}

.fa-signature-slash::before {
  content: "\\e3cb";
}

.fa-signs-post::before {
  content: "\\f277";
}

.fa-map-signs::before {
  content: "\\f277";
}

.fa-sim-card::before {
  content: "\\f7c4";
}

.fa-sim-cards::before {
  content: "\\e251";
}

.fa-sink::before {
  content: "\\e06d";
}

.fa-siren::before {
  content: "\\e02d";
}

.fa-siren-on::before {
  content: "\\e02e";
}

.fa-sitemap::before {
  content: "\\f0e8";
}

.fa-skeleton::before {
  content: "\\f620";
}

.fa-ski-boot::before {
  content: "\\e3cc";
}

.fa-ski-boot-ski::before {
  content: "\\e3cd";
}

.fa-skull::before {
  content: "\\f54c";
}

.fa-skull-cow::before {
  content: "\\f8de";
}

.fa-skull-crossbones::before {
  content: "\\f714";
}

.fa-slash::before {
  content: "\\f715";
}

.fa-slash-back::before {
  content: "\\\\";
}

.fa-slash-forward::before {
  content: "\\/";
}

.fa-sleigh::before {
  content: "\\f7cc";
}

.fa-slider::before {
  content: "\\e252";
}

.fa-sliders::before {
  content: "\\f1de";
}

.fa-sliders-h::before {
  content: "\\f1de";
}

.fa-sliders-simple::before {
  content: "\\e253";
}

.fa-sliders-up::before {
  content: "\\f3f1";
}

.fa-sliders-v::before {
  content: "\\f3f1";
}

.fa-slot-machine::before {
  content: "\\e3ce";
}

.fa-smog::before {
  content: "\\f75f";
}

.fa-smoke::before {
  content: "\\f760";
}

.fa-smoking::before {
  content: "\\f48d";
}

.fa-snake::before {
  content: "\\f716";
}

.fa-snooze::before {
  content: "\\f880";
}

.fa-zzz::before {
  content: "\\f880";
}

.fa-snow-blowing::before {
  content: "\\f761";
}

.fa-snowflake::before {
  content: "\\f2dc";
}

.fa-snowflakes::before {
  content: "\\f7cf";
}

.fa-snowman::before {
  content: "\\f7d0";
}

.fa-snowman-head::before {
  content: "\\f79b";
}

.fa-frosty-head::before {
  content: "\\f79b";
}

.fa-snowplow::before {
  content: "\\f7d2";
}

.fa-soap::before {
  content: "\\e06e";
}

.fa-socks::before {
  content: "\\f696";
}

.fa-solar-panel::before {
  content: "\\f5ba";
}

.fa-solar-system::before {
  content: "\\e02f";
}

.fa-sort::before {
  content: "\\f0dc";
}

.fa-unsorted::before {
  content: "\\f0dc";
}

.fa-sort-down::before {
  content: "\\f0dd";
}

.fa-sort-desc::before {
  content: "\\f0dd";
}

.fa-sort-up::before {
  content: "\\f0de";
}

.fa-sort-asc::before {
  content: "\\f0de";
}

.fa-spa::before {
  content: "\\f5bb";
}

.fa-space-station-moon::before {
  content: "\\e033";
}

.fa-space-station-moon-construction::before {
  content: "\\e034";
}

.fa-space-station-moon-alt::before {
  content: "\\e034";
}

.fa-spade::before {
  content: "\\f2f4";
}

.fa-spaghetti-monster-flying::before {
  content: "\\f67b";
}

.fa-pastafarianism::before {
  content: "\\f67b";
}

.fa-sparkles::before {
  content: "\\f890";
}

.fa-speaker::before {
  content: "\\f8df";
}

.fa-speakers::before {
  content: "\\f8e0";
}

.fa-spell-check::before {
  content: "\\f891";
}

.fa-spider::before {
  content: "\\f717";
}

.fa-spider-black-widow::before {
  content: "\\f718";
}

.fa-spider-web::before {
  content: "\\f719";
}

.fa-spinner::before {
  content: "\\f110";
}

.fa-spinner-third::before {
  content: "\\f3f4";
}

.fa-split::before {
  content: "\\e254";
}

.fa-splotch::before {
  content: "\\f5bc";
}

.fa-spoon::before {
  content: "\\f2e5";
}

.fa-utensil-spoon::before {
  content: "\\f2e5";
}

.fa-sportsball::before {
  content: "\\e44b";
}

.fa-spray-can::before {
  content: "\\f5bd";
}

.fa-spray-can-sparkles::before {
  content: "\\f5d0";
}

.fa-air-freshener::before {
  content: "\\f5d0";
}

.fa-sprinkler::before {
  content: "\\e035";
}

.fa-sprinkler-ceiling::before {
  content: "\\e44c";
}

.fa-square::before {
  content: "\\f0c8";
}

.fa-square-0::before {
  content: "\\e255";
}

.fa-square-1::before {
  content: "\\e256";
}

.fa-square-2::before {
  content: "\\e257";
}

.fa-square-3::before {
  content: "\\e258";
}

.fa-square-4::before {
  content: "\\e259";
}

.fa-square-5::before {
  content: "\\e25a";
}

.fa-square-6::before {
  content: "\\e25b";
}

.fa-square-7::before {
  content: "\\e25c";
}

.fa-square-8::before {
  content: "\\e25d";
}

.fa-square-9::before {
  content: "\\e25e";
}

.fa-square-a::before {
  content: "\\e25f";
}

.fa-square-a-lock::before {
  content: "\\e44d";
}

.fa-square-ampersand::before {
  content: "\\e260";
}

.fa-square-arrow-down::before {
  content: "\\f339";
}

.fa-arrow-square-down::before {
  content: "\\f339";
}

.fa-square-arrow-down-left::before {
  content: "\\e261";
}

.fa-square-arrow-down-right::before {
  content: "\\e262";
}

.fa-square-arrow-left::before {
  content: "\\f33a";
}

.fa-arrow-square-left::before {
  content: "\\f33a";
}

.fa-square-arrow-right::before {
  content: "\\f33b";
}

.fa-arrow-square-right::before {
  content: "\\f33b";
}

.fa-square-arrow-up::before {
  content: "\\f33c";
}

.fa-arrow-square-up::before {
  content: "\\f33c";
}

.fa-square-arrow-up-left::before {
  content: "\\e263";
}

.fa-square-arrow-up-right::before {
  content: "\\f14c";
}

.fa-external-link-square::before {
  content: "\\f14c";
}

.fa-square-b::before {
  content: "\\e264";
}

.fa-square-bolt::before {
  content: "\\e265";
}

.fa-square-c::before {
  content: "\\e266";
}

.fa-square-caret-down::before {
  content: "\\f150";
}

.fa-caret-square-down::before {
  content: "\\f150";
}

.fa-square-caret-left::before {
  content: "\\f191";
}

.fa-caret-square-left::before {
  content: "\\f191";
}

.fa-square-caret-right::before {
  content: "\\f152";
}

.fa-caret-square-right::before {
  content: "\\f152";
}

.fa-square-caret-up::before {
  content: "\\f151";
}

.fa-caret-square-up::before {
  content: "\\f151";
}

.fa-square-check::before {
  content: "\\f14a";
}

.fa-check-square::before {
  content: "\\f14a";
}

.fa-square-chevron-down::before {
  content: "\\f329";
}

.fa-chevron-square-down::before {
  content: "\\f329";
}

.fa-square-chevron-left::before {
  content: "\\f32a";
}

.fa-chevron-square-left::before {
  content: "\\f32a";
}

.fa-square-chevron-right::before {
  content: "\\f32b";
}

.fa-chevron-square-right::before {
  content: "\\f32b";
}

.fa-square-chevron-up::before {
  content: "\\f32c";
}

.fa-chevron-square-up::before {
  content: "\\f32c";
}

.fa-square-code::before {
  content: "\\e267";
}

.fa-square-d::before {
  content: "\\e268";
}

.fa-square-dashed::before {
  content: "\\e269";
}

.fa-square-divide::before {
  content: "\\e26a";
}

.fa-square-dollar::before {
  content: "\\f2e9";
}

.fa-dollar-square::before {
  content: "\\f2e9";
}

.fa-usd-square::before {
  content: "\\f2e9";
}

.fa-square-down::before {
  content: "\\f350";
}

.fa-arrow-alt-square-down::before {
  content: "\\f350";
}

.fa-square-down-left::before {
  content: "\\e26b";
}

.fa-square-down-right::before {
  content: "\\e26c";
}

.fa-square-e::before {
  content: "\\e26d";
}

.fa-square-ellipsis::before {
  content: "\\e26e";
}

.fa-square-ellipsis-vertical::before {
  content: "\\e26f";
}

.fa-square-envelope::before {
  content: "\\f199";
}

.fa-envelope-square::before {
  content: "\\f199";
}

.fa-square-exclamation::before {
  content: "\\f321";
}

.fa-exclamation-square::before {
  content: "\\f321";
}

.fa-square-f::before {
  content: "\\e270";
}

.fa-square-fragile::before {
  content: "\\f49b";
}

.fa-box-fragile::before {
  content: "\\f49b";
}

.fa-square-wine-glass-crack::before {
  content: "\\f49b";
}

.fa-square-full::before {
  content: "\\f45c";
}

.fa-square-g::before {
  content: "\\e271";
}

.fa-square-h::before {
  content: "\\f0fd";
}

.fa-h-square::before {
  content: "\\f0fd";
}

.fa-square-heart::before {
  content: "\\f4c8";
}

.fa-heart-square::before {
  content: "\\f4c8";
}

.fa-square-i::before {
  content: "\\e272";
}

.fa-square-info::before {
  content: "\\f30f";
}

.fa-info-square::before {
  content: "\\f30f";
}

.fa-square-j::before {
  content: "\\e273";
}

.fa-square-k::before {
  content: "\\e274";
}

.fa-square-l::before {
  content: "\\e275";
}

.fa-square-left::before {
  content: "\\f351";
}

.fa-arrow-alt-square-left::before {
  content: "\\f351";
}

.fa-square-m::before {
  content: "\\e276";
}

.fa-square-minus::before {
  content: "\\f146";
}

.fa-minus-square::before {
  content: "\\f146";
}

.fa-square-n::before {
  content: "\\e277";
}

.fa-square-o::before {
  content: "\\e278";
}

.fa-square-p::before {
  content: "\\e279";
}

.fa-square-parking::before {
  content: "\\f540";
}

.fa-parking::before {
  content: "\\f540";
}

.fa-square-parking-slash::before {
  content: "\\f617";
}

.fa-parking-slash::before {
  content: "\\f617";
}

.fa-square-pen::before {
  content: "\\f14b";
}

.fa-pen-square::before {
  content: "\\f14b";
}

.fa-pencil-square::before {
  content: "\\f14b";
}

.fa-square-phone::before {
  content: "\\f098";
}

.fa-phone-square::before {
  content: "\\f098";
}

.fa-square-phone-flip::before {
  content: "\\f87b";
}

.fa-phone-square-alt::before {
  content: "\\f87b";
}

.fa-square-phone-hangup::before {
  content: "\\e27a";
}

.fa-phone-square-down::before {
  content: "\\e27a";
}

.fa-square-plus::before {
  content: "\\f0fe";
}

.fa-plus-square::before {
  content: "\\f0fe";
}

.fa-square-poll-horizontal::before {
  content: "\\f682";
}

.fa-poll-h::before {
  content: "\\f682";
}

.fa-square-poll-vertical::before {
  content: "\\f681";
}

.fa-poll::before {
  content: "\\f681";
}

.fa-square-q::before {
  content: "\\e27b";
}

.fa-square-quarters::before {
  content: "\\e44e";
}

.fa-square-question::before {
  content: "\\f2fd";
}

.fa-question-square::before {
  content: "\\f2fd";
}

.fa-square-quote::before {
  content: "\\e329";
}

.fa-square-r::before {
  content: "\\e27c";
}

.fa-square-right::before {
  content: "\\f352";
}

.fa-arrow-alt-square-right::before {
  content: "\\f352";
}

.fa-square-ring::before {
  content: "\\e44f";
}

.fa-square-root::before {
  content: "\\f697";
}

.fa-square-root-variable::before {
  content: "\\f698";
}

.fa-square-root-alt::before {
  content: "\\f698";
}

.fa-square-rss::before {
  content: "\\f143";
}

.fa-rss-square::before {
  content: "\\f143";
}

.fa-square-s::before {
  content: "\\e27d";
}

.fa-square-share-nodes::before {
  content: "\\f1e1";
}

.fa-share-alt-square::before {
  content: "\\f1e1";
}

.fa-square-sliders::before {
  content: "\\f3f0";
}

.fa-sliders-h-square::before {
  content: "\\f3f0";
}

.fa-square-sliders-vertical::before {
  content: "\\f3f2";
}

.fa-sliders-v-square::before {
  content: "\\f3f2";
}

.fa-square-small::before {
  content: "\\e27e";
}

.fa-square-star::before {
  content: "\\e27f";
}

.fa-square-t::before {
  content: "\\e280";
}

.fa-square-terminal::before {
  content: "\\e32a";
}

.fa-square-this-way-up::before {
  content: "\\f49f";
}

.fa-box-up::before {
  content: "\\f49f";
}

.fa-square-u::before {
  content: "\\e281";
}

.fa-square-up::before {
  content: "\\f353";
}

.fa-arrow-alt-square-up::before {
  content: "\\f353";
}

.fa-square-up-left::before {
  content: "\\e282";
}

.fa-square-up-right::before {
  content: "\\f360";
}

.fa-external-link-square-alt::before {
  content: "\\f360";
}

.fa-square-user::before {
  content: "\\e283";
}

.fa-square-v::before {
  content: "\\e284";
}

.fa-square-w::before {
  content: "\\e285";
}

.fa-square-x::before {
  content: "\\e286";
}

.fa-square-xmark::before {
  content: "\\f2d3";
}

.fa-times-square::before {
  content: "\\f2d3";
}

.fa-xmark-square::before {
  content: "\\f2d3";
}

.fa-square-y::before {
  content: "\\e287";
}

.fa-square-z::before {
  content: "\\e288";
}

.fa-squid::before {
  content: "\\e450";
}

.fa-squirrel::before {
  content: "\\f71a";
}

.fa-staff::before {
  content: "\\f71b";
}

.fa-stairs::before {
  content: "\\e289";
}

.fa-stamp::before {
  content: "\\f5bf";
}

.fa-standard-definition::before {
  content: "\\e28a";
}

.fa-rectangle-sd::before {
  content: "\\e28a";
}

.fa-star::before {
  content: "\\f005";
}

.fa-star-and-crescent::before {
  content: "\\f699";
}

.fa-star-christmas::before {
  content: "\\f7d4";
}

.fa-star-exclamation::before {
  content: "\\f2f3";
}

.fa-star-half::before {
  content: "\\f089";
}

.fa-star-half-stroke::before {
  content: "\\f5c0";
}

.fa-star-half-alt::before {
  content: "\\f5c0";
}

.fa-star-of-david::before {
  content: "\\f69a";
}

.fa-star-of-life::before {
  content: "\\f621";
}

.fa-star-sharp::before {
  content: "\\e28b";
}

.fa-star-sharp-half::before {
  content: "\\e28c";
}

.fa-star-sharp-half-stroke::before {
  content: "\\e28d";
}

.fa-star-sharp-half-alt::before {
  content: "\\e28d";
}

.fa-star-shooting::before {
  content: "\\e036";
}

.fa-starfighter::before {
  content: "\\e037";
}

.fa-starfighter-twin-ion-engine::before {
  content: "\\e038";
}

.fa-starfighter-alt::before {
  content: "\\e038";
}

.fa-starfighter-twin-ion-engine-advanced::before {
  content: "\\e28e";
}

.fa-starfighter-alt-advanced::before {
  content: "\\e28e";
}

.fa-stars::before {
  content: "\\f762";
}

.fa-starship::before {
  content: "\\e039";
}

.fa-starship-freighter::before {
  content: "\\e03a";
}

.fa-steak::before {
  content: "\\f824";
}

.fa-steering-wheel::before {
  content: "\\f622";
}

.fa-sterling-sign::before {
  content: "\\f154";
}

.fa-gbp::before {
  content: "\\f154";
}

.fa-pound-sign::before {
  content: "\\f154";
}

.fa-stethoscope::before {
  content: "\\f0f1";
}

.fa-stocking::before {
  content: "\\f7d5";
}

.fa-stomach::before {
  content: "\\f623";
}

.fa-stop::before {
  content: "\\f04d";
}

.fa-stopwatch::before {
  content: "\\f2f2";
}

.fa-stopwatch-20::before {
  content: "\\e06f";
}

.fa-store::before {
  content: "\\f54e";
}

.fa-store-slash::before {
  content: "\\e071";
}

.fa-strawberry::before {
  content: "\\e32b";
}

.fa-street-view::before {
  content: "\\f21d";
}

.fa-stretcher::before {
  content: "\\f825";
}

.fa-strikethrough::before {
  content: "\\f0cc";
}

.fa-stroopwafel::before {
  content: "\\f551";
}

.fa-subscript::before {
  content: "\\f12c";
}

.fa-suitcase::before {
  content: "\\f0f2";
}

.fa-suitcase-medical::before {
  content: "\\f0fa";
}

.fa-medkit::before {
  content: "\\f0fa";
}

.fa-suitcase-rolling::before {
  content: "\\f5c1";
}

.fa-sun::before {
  content: "\\f185";
}

.fa-sun-bright::before {
  content: "\\e28f";
}

.fa-sun-alt::before {
  content: "\\e28f";
}

.fa-sun-cloud::before {
  content: "\\f763";
}

.fa-sun-dust::before {
  content: "\\f764";
}

.fa-sun-haze::before {
  content: "\\f765";
}

.fa-sunglasses::before {
  content: "\\f892";
}

.fa-sunrise::before {
  content: "\\f766";
}

.fa-sunset::before {
  content: "\\f767";
}

.fa-superscript::before {
  content: "\\f12b";
}

.fa-swatchbook::before {
  content: "\\f5c3";
}

.fa-sword::before {
  content: "\\f71c";
}

.fa-sword-laser::before {
  content: "\\e03b";
}

.fa-sword-laser-alt::before {
  content: "\\e03c";
}

.fa-swords::before {
  content: "\\f71d";
}

.fa-swords-laser::before {
  content: "\\e03d";
}

.fa-symbols::before {
  content: "\\f86e";
}

.fa-icons-alt::before {
  content: "\\f86e";
}

.fa-synagogue::before {
  content: "\\f69b";
}

.fa-syringe::before {
  content: "\\f48e";
}

.fa-t::before {
  content: "T";
}

.fa-table::before {
  content: "\\f0ce";
}

.fa-table-cells::before {
  content: "\\f00a";
}

.fa-th::before {
  content: "\\f00a";
}

.fa-table-cells-large::before {
  content: "\\f009";
}

.fa-th-large::before {
  content: "\\f009";
}

.fa-table-columns::before {
  content: "\\f0db";
}

.fa-columns::before {
  content: "\\f0db";
}

.fa-table-layout::before {
  content: "\\e290";
}

.fa-table-list::before {
  content: "\\f00b";
}

.fa-th-list::before {
  content: "\\f00b";
}

.fa-table-picnic::before {
  content: "\\e32d";
}

.fa-table-pivot::before {
  content: "\\e291";
}

.fa-table-rows::before {
  content: "\\e292";
}

.fa-rows::before {
  content: "\\e292";
}

.fa-table-tennis-paddle-ball::before {
  content: "\\f45d";
}

.fa-ping-pong-paddle-ball::before {
  content: "\\f45d";
}

.fa-table-tennis::before {
  content: "\\f45d";
}

.fa-table-tree::before {
  content: "\\e293";
}

.fa-tablet::before {
  content: "\\f3fb";
}

.fa-tablet-android::before {
  content: "\\f3fb";
}

.fa-tablet-button::before {
  content: "\\f10a";
}

.fa-tablet-rugged::before {
  content: "\\f48f";
}

.fa-tablet-screen::before {
  content: "\\f3fc";
}

.fa-tablet-android-alt::before {
  content: "\\f3fc";
}

.fa-tablet-screen-button::before {
  content: "\\f3fa";
}

.fa-tablet-alt::before {
  content: "\\f3fa";
}

.fa-tablets::before {
  content: "\\f490";
}

.fa-tachograph-digital::before {
  content: "\\f566";
}

.fa-digital-tachograph::before {
  content: "\\f566";
}

.fa-taco::before {
  content: "\\f826";
}

.fa-tag::before {
  content: "\\f02b";
}

.fa-tags::before {
  content: "\\f02c";
}

.fa-tally::before {
  content: "\\f69c";
}

.fa-tally-5::before {
  content: "\\f69c";
}

.fa-tally-1::before {
  content: "\\e294";
}

.fa-tally-2::before {
  content: "\\e295";
}

.fa-tally-3::before {
  content: "\\e296";
}

.fa-tally-4::before {
  content: "\\e297";
}

.fa-tamale::before {
  content: "\\e451";
}

.fa-tank-water::before {
  content: "\\e452";
}

.fa-tape::before {
  content: "\\f4db";
}

.fa-taxi::before {
  content: "\\f1ba";
}

.fa-cab::before {
  content: "\\f1ba";
}

.fa-taxi-bus::before {
  content: "\\e298";
}

.fa-teddy-bear::before {
  content: "\\e3cf";
}

.fa-teeth::before {
  content: "\\f62e";
}

.fa-teeth-open::before {
  content: "\\f62f";
}

.fa-telescope::before {
  content: "\\e03e";
}

.fa-temperature-arrow-down::before {
  content: "\\e03f";
}

.fa-temperature-down::before {
  content: "\\e03f";
}

.fa-temperature-arrow-up::before {
  content: "\\e040";
}

.fa-temperature-up::before {
  content: "\\e040";
}

.fa-temperature-empty::before {
  content: "\\f2cb";
}

.fa-temperature-0::before {
  content: "\\f2cb";
}

.fa-thermometer-0::before {
  content: "\\f2cb";
}

.fa-thermometer-empty::before {
  content: "\\f2cb";
}

.fa-temperature-full::before {
  content: "\\f2c7";
}

.fa-temperature-4::before {
  content: "\\f2c7";
}

.fa-thermometer-4::before {
  content: "\\f2c7";
}

.fa-thermometer-full::before {
  content: "\\f2c7";
}

.fa-temperature-half::before {
  content: "\\f2c9";
}

.fa-temperature-2::before {
  content: "\\f2c9";
}

.fa-thermometer-2::before {
  content: "\\f2c9";
}

.fa-thermometer-half::before {
  content: "\\f2c9";
}

.fa-temperature-high::before {
  content: "\\f769";
}

.fa-temperature-list::before {
  content: "\\e299";
}

.fa-temperature-low::before {
  content: "\\f76b";
}

.fa-temperature-quarter::before {
  content: "\\f2ca";
}

.fa-temperature-1::before {
  content: "\\f2ca";
}

.fa-thermometer-1::before {
  content: "\\f2ca";
}

.fa-thermometer-quarter::before {
  content: "\\f2ca";
}

.fa-temperature-snow::before {
  content: "\\f768";
}

.fa-temperature-frigid::before {
  content: "\\f768";
}

.fa-temperature-sun::before {
  content: "\\f76a";
}

.fa-temperature-hot::before {
  content: "\\f76a";
}

.fa-temperature-three-quarters::before {
  content: "\\f2c8";
}

.fa-temperature-3::before {
  content: "\\f2c8";
}

.fa-thermometer-3::before {
  content: "\\f2c8";
}

.fa-thermometer-three-quarters::before {
  content: "\\f2c8";
}

.fa-tenge-sign::before {
  content: "\\f7d7";
}

.fa-tenge::before {
  content: "\\f7d7";
}

.fa-tennis-ball::before {
  content: "\\f45e";
}

.fa-terminal::before {
  content: "\\f120";
}

.fa-text::before {
  content: "\\f893";
}

.fa-text-height::before {
  content: "\\f034";
}

.fa-text-size::before {
  content: "\\f894";
}

.fa-text-slash::before {
  content: "\\f87d";
}

.fa-remove-format::before {
  content: "\\f87d";
}

.fa-text-width::before {
  content: "\\f035";
}

.fa-thermometer::before {
  content: "\\f491";
}

.fa-theta::before {
  content: "\\f69e";
}

.fa-thought-bubble::before {
  content: "\\e32e";
}

.fa-thumbs-down::before {
  content: "\\f165";
}

.fa-thumbs-up::before {
  content: "\\f164";
}

.fa-thumbtack::before {
  content: "\\f08d";
}

.fa-thumb-tack::before {
  content: "\\f08d";
}

.fa-tick::before {
  content: "\\e32f";
}

.fa-ticket::before {
  content: "\\f145";
}

.fa-ticket-airline::before {
  content: "\\e29a";
}

.fa-ticket-simple::before {
  content: "\\f3ff";
}

.fa-ticket-alt::before {
  content: "\\f3ff";
}

.fa-tickets-airline::before {
  content: "\\e29b";
}

.fa-tilde::before {
  content: "\\~";
}

.fa-timeline::before {
  content: "\\e29c";
}

.fa-timeline-arrow::before {
  content: "\\e29d";
}

.fa-timer::before {
  content: "\\e29e";
}

.fa-tire::before {
  content: "\\f631";
}

.fa-tire-flat::before {
  content: "\\f632";
}

.fa-tire-pressure-warning::before {
  content: "\\f633";
}

.fa-tire-rugged::before {
  content: "\\f634";
}

.fa-toggle-off::before {
  content: "\\f204";
}

.fa-toggle-on::before {
  content: "\\f205";
}

.fa-toilet::before {
  content: "\\f7d8";
}

.fa-toilet-paper::before {
  content: "\\f71e";
}

.fa-toilet-paper-blank::before {
  content: "\\f71f";
}

.fa-toilet-paper-alt::before {
  content: "\\f71f";
}

.fa-toilet-paper-blank-under::before {
  content: "\\e29f";
}

.fa-toilet-paper-reverse-alt::before {
  content: "\\e29f";
}

.fa-toilet-paper-slash::before {
  content: "\\e072";
}

.fa-toilet-paper-under::before {
  content: "\\e2a0";
}

.fa-toilet-paper-reverse::before {
  content: "\\e2a0";
}

.fa-toilet-paper-under-slash::before {
  content: "\\e2a1";
}

.fa-toilet-paper-reverse-slash::before {
  content: "\\e2a1";
}

.fa-tomato::before {
  content: "\\e330";
}

.fa-tombstone::before {
  content: "\\f720";
}

.fa-tombstone-blank::before {
  content: "\\f721";
}

.fa-tombstone-alt::before {
  content: "\\f721";
}

.fa-toolbox::before {
  content: "\\f552";
}

.fa-tooth::before {
  content: "\\f5c9";
}

.fa-toothbrush::before {
  content: "\\f635";
}

.fa-torii-gate::before {
  content: "\\f6a1";
}

.fa-tornado::before {
  content: "\\f76f";
}

.fa-tower-broadcast::before {
  content: "\\f519";
}

.fa-broadcast-tower::before {
  content: "\\f519";
}

.fa-tower-control::before {
  content: "\\e2a2";
}

.fa-tractor::before {
  content: "\\f722";
}

.fa-trademark::before {
  content: "\\f25c";
}

.fa-traffic-cone::before {
  content: "\\f636";
}

.fa-traffic-light::before {
  content: "\\f637";
}

.fa-traffic-light-go::before {
  content: "\\f638";
}

.fa-traffic-light-slow::before {
  content: "\\f639";
}

.fa-traffic-light-stop::before {
  content: "\\f63a";
}

.fa-trailer::before {
  content: "\\e041";
}

.fa-train::before {
  content: "\\f238";
}

.fa-train-subway::before {
  content: "\\f239";
}

.fa-subway::before {
  content: "\\f239";
}

.fa-train-subway-tunnel::before {
  content: "\\e2a3";
}

.fa-subway-tunnel::before {
  content: "\\e2a3";
}

.fa-train-track::before {
  content: "\\e453";
}

.fa-train-tram::before {
  content: "\\f7da";
}

.fa-tram::before {
  content: "\\f7da";
}

.fa-train-tunnel::before {
  content: "\\e454";
}

.fa-transformer-bolt::before {
  content: "\\e2a4";
}

.fa-transgender::before {
  content: "\\f225";
}

.fa-transgender-alt::before {
  content: "\\f225";
}

.fa-transporter::before {
  content: "\\e042";
}

.fa-transporter-1::before {
  content: "\\e043";
}

.fa-transporter-2::before {
  content: "\\e044";
}

.fa-transporter-3::before {
  content: "\\e045";
}

.fa-transporter-4::before {
  content: "\\e2a5";
}

.fa-transporter-5::before {
  content: "\\e2a6";
}

.fa-transporter-6::before {
  content: "\\e2a7";
}

.fa-transporter-7::before {
  content: "\\e2a8";
}

.fa-transporter-empty::before {
  content: "\\e046";
}

.fa-trash::before {
  content: "\\f1f8";
}

.fa-trash-arrow-up::before {
  content: "\\f829";
}

.fa-trash-restore::before {
  content: "\\f829";
}

.fa-trash-can::before {
  content: "\\f2ed";
}

.fa-trash-alt::before {
  content: "\\f2ed";
}

.fa-trash-can-arrow-up::before {
  content: "\\f82a";
}

.fa-trash-restore-alt::before {
  content: "\\f82a";
}

.fa-trash-can-check::before {
  content: "\\e2a9";
}

.fa-trash-can-clock::before {
  content: "\\e2aa";
}

.fa-trash-can-list::before {
  content: "\\e2ab";
}

.fa-trash-can-plus::before {
  content: "\\e2ac";
}

.fa-trash-can-slash::before {
  content: "\\e2ad";
}

.fa-trash-alt-slash::before {
  content: "\\e2ad";
}

.fa-trash-can-undo::before {
  content: "\\f896";
}

.fa-trash-can-arrow-turn-left::before {
  content: "\\f896";
}

.fa-trash-undo-alt::before {
  content: "\\f896";
}

.fa-trash-can-xmark::before {
  content: "\\e2ae";
}

.fa-trash-check::before {
  content: "\\e2af";
}

.fa-trash-clock::before {
  content: "\\e2b0";
}

.fa-trash-list::before {
  content: "\\e2b1";
}

.fa-trash-plus::before {
  content: "\\e2b2";
}

.fa-trash-slash::before {
  content: "\\e2b3";
}

.fa-trash-undo::before {
  content: "\\f895";
}

.fa-trash-arrow-turn-left::before {
  content: "\\f895";
}

.fa-trash-xmark::before {
  content: "\\e2b4";
}

.fa-treasure-chest::before {
  content: "\\f723";
}

.fa-tree::before {
  content: "\\f1bb";
}

.fa-tree-christmas::before {
  content: "\\f7db";
}

.fa-tree-deciduous::before {
  content: "\\f400";
}

.fa-tree-alt::before {
  content: "\\f400";
}

.fa-tree-decorated::before {
  content: "\\f7dc";
}

.fa-tree-large::before {
  content: "\\f7dd";
}

.fa-tree-palm::before {
  content: "\\f82b";
}

.fa-trees::before {
  content: "\\f724";
}

.fa-triangle::before {
  content: "\\f2ec";
}

.fa-triangle-exclamation::before {
  content: "\\f071";
}

.fa-exclamation-triangle::before {
  content: "\\f071";
}

.fa-warning::before {
  content: "\\f071";
}

.fa-triangle-instrument::before {
  content: "\\f8e2";
}

.fa-triangle-music::before {
  content: "\\f8e2";
}

.fa-triangle-person-digging::before {
  content: "\\f85d";
}

.fa-construction::before {
  content: "\\f85d";
}

.fa-trophy::before {
  content: "\\f091";
}

.fa-trophy-star::before {
  content: "\\f2eb";
}

.fa-trophy-alt::before {
  content: "\\f2eb";
}

.fa-truck::before {
  content: "\\f0d1";
}

.fa-truck-bolt::before {
  content: "\\e3d0";
}

.fa-truck-clock::before {
  content: "\\f48c";
}

.fa-shipping-timed::before {
  content: "\\f48c";
}

.fa-truck-container::before {
  content: "\\f4dc";
}

.fa-truck-container-empty::before {
  content: "\\e2b5";
}

.fa-truck-fast::before {
  content: "\\f48b";
}

.fa-shipping-fast::before {
  content: "\\f48b";
}

.fa-truck-flatbed::before {
  content: "\\e2b6";
}

.fa-truck-front::before {
  content: "\\e2b7";
}

.fa-truck-medical::before {
  content: "\\f0f9";
}

.fa-ambulance::before {
  content: "\\f0f9";
}

.fa-truck-monster::before {
  content: "\\f63b";
}

.fa-truck-moving::before {
  content: "\\f4df";
}

.fa-truck-pickup::before {
  content: "\\f63c";
}

.fa-truck-plow::before {
  content: "\\f7de";
}

.fa-truck-ramp::before {
  content: "\\f4e0";
}

.fa-truck-ramp-box::before {
  content: "\\f4de";
}

.fa-truck-loading::before {
  content: "\\f4de";
}

.fa-truck-ramp-couch::before {
  content: "\\f4dd";
}

.fa-truck-couch::before {
  content: "\\f4dd";
}

.fa-truck-tow::before {
  content: "\\e2b8";
}

.fa-trumpet::before {
  content: "\\f8e3";
}

.fa-tty::before {
  content: "\\f1e4";
}

.fa-teletype::before {
  content: "\\f1e4";
}

.fa-tty-answer::before {
  content: "\\e2b9";
}

.fa-teletype-answer::before {
  content: "\\e2b9";
}

.fa-tugrik-sign::before {
  content: "\\e2ba";
}

.fa-turkey::before {
  content: "\\f725";
}

.fa-turkish-lira-sign::before {
  content: "\\e2bb";
}

.fa-try::before {
  content: "\\e2bb";
}

.fa-turkish-lira::before {
  content: "\\e2bb";
}

.fa-turn-down::before {
  content: "\\f3be";
}

.fa-level-down-alt::before {
  content: "\\f3be";
}

.fa-turn-down-left::before {
  content: "\\e331";
}

.fa-turn-down-right::before {
  content: "\\e455";
}

.fa-turn-up::before {
  content: "\\f3bf";
}

.fa-level-up-alt::before {
  content: "\\f3bf";
}

.fa-turntable::before {
  content: "\\f8e4";
}

.fa-turtle::before {
  content: "\\f726";
}

.fa-tv::before {
  content: "\\f26c";
}

.fa-television::before {
  content: "\\f26c";
}

.fa-tv-alt::before {
  content: "\\f26c";
}

.fa-tv-music::before {
  content: "\\f8e6";
}

.fa-tv-retro::before {
  content: "\\f401";
}

.fa-typewriter::before {
  content: "\\f8e7";
}

.fa-u::before {
  content: "U";
}

.fa-ufo::before {
  content: "\\e047";
}

.fa-ufo-beam::before {
  content: "\\e048";
}

.fa-umbrella::before {
  content: "\\f0e9";
}

.fa-umbrella-beach::before {
  content: "\\f5ca";
}

.fa-umbrella-simple::before {
  content: "\\e2bc";
}

.fa-umbrella-alt::before {
  content: "\\e2bc";
}

.fa-underline::before {
  content: "\\f0cd";
}

.fa-unicorn::before {
  content: "\\f727";
}

.fa-uniform-martial-arts::before {
  content: "\\e3d1";
}

.fa-union::before {
  content: "\\f6a2";
}

.fa-universal-access::before {
  content: "\\f29a";
}

.fa-unlock::before {
  content: "\\f09c";
}

.fa-unlock-keyhole::before {
  content: "\\f13e";
}

.fa-unlock-alt::before {
  content: "\\f13e";
}

.fa-up::before {
  content: "\\f357";
}

.fa-arrow-alt-up::before {
  content: "\\f357";
}

.fa-up-down::before {
  content: "\\f338";
}

.fa-arrows-alt-v::before {
  content: "\\f338";
}

.fa-up-down-left-right::before {
  content: "\\f0b2";
}

.fa-arrows-alt::before {
  content: "\\f0b2";
}

.fa-up-from-dotted-line::before {
  content: "\\e456";
}

.fa-up-from-line::before {
  content: "\\f346";
}

.fa-arrow-alt-from-bottom::before {
  content: "\\f346";
}

.fa-up-left::before {
  content: "\\e2bd";
}

.fa-up-long::before {
  content: "\\f30c";
}

.fa-long-arrow-alt-up::before {
  content: "\\f30c";
}

.fa-up-right::before {
  content: "\\e2be";
}

.fa-up-right-and-down-left-from-center::before {
  content: "\\f424";
}

.fa-expand-alt::before {
  content: "\\f424";
}

.fa-up-right-from-square::before {
  content: "\\f35d";
}

.fa-external-link-alt::before {
  content: "\\f35d";
}

.fa-up-to-dotted-line::before {
  content: "\\e457";
}

.fa-up-to-line::before {
  content: "\\f34d";
}

.fa-arrow-alt-to-top::before {
  content: "\\f34d";
}

.fa-upload::before {
  content: "\\f093";
}

.fa-usb-drive::before {
  content: "\\f8e9";
}

.fa-user::before {
  content: "\\f007";
}

.fa-user-alien::before {
  content: "\\e04a";
}

.fa-user-astronaut::before {
  content: "\\f4fb";
}

.fa-user-bounty-hunter::before {
  content: "\\e2bf";
}

.fa-user-check::before {
  content: "\\f4fc";
}

.fa-user-chef::before {
  content: "\\e3d2";
}

.fa-user-clock::before {
  content: "\\f4fd";
}

.fa-user-cowboy::before {
  content: "\\f8ea";
}

.fa-user-crown::before {
  content: "\\f6a4";
}

.fa-user-doctor::before {
  content: "\\f0f0";
}

.fa-user-md::before {
  content: "\\f0f0";
}

.fa-user-doctor-hair::before {
  content: "\\e458";
}

.fa-user-doctor-hair-long::before {
  content: "\\e459";
}

.fa-user-doctor-message::before {
  content: "\\f82e";
}

.fa-user-md-chat::before {
  content: "\\f82e";
}

.fa-user-gear::before {
  content: "\\f4fe";
}

.fa-user-cog::before {
  content: "\\f4fe";
}

.fa-user-graduate::before {
  content: "\\f501";
}

.fa-user-group::before {
  content: "\\f500";
}

.fa-user-friends::before {
  content: "\\f500";
}

.fa-user-group-crown::before {
  content: "\\f6a5";
}

.fa-users-crown::before {
  content: "\\f6a5";
}

.fa-user-hair::before {
  content: "\\e45a";
}

.fa-user-hair-buns::before {
  content: "\\e3d3";
}

.fa-user-hair-long::before {
  content: "\\e45b";
}

.fa-user-hair-mullet::before {
  content: "\\e45c";
}

.fa-business-front::before {
  content: "\\e45c";
}

.fa-party-back::before {
  content: "\\e45c";
}

.fa-trian-balbot::before {
  content: "\\e45c";
}

.fa-user-headset::before {
  content: "\\f82d";
}

.fa-user-helmet-safety::before {
  content: "\\f82c";
}

.fa-user-construction::before {
  content: "\\f82c";
}

.fa-user-hard-hat::before {
  content: "\\f82c";
}

.fa-user-injured::before {
  content: "\\f728";
}

.fa-user-large::before {
  content: "\\f406";
}

.fa-user-alt::before {
  content: "\\f406";
}

.fa-user-large-slash::before {
  content: "\\f4fa";
}

.fa-user-alt-slash::before {
  content: "\\f4fa";
}

.fa-user-lock::before {
  content: "\\f502";
}

.fa-user-minus::before {
  content: "\\f503";
}

.fa-user-music::before {
  content: "\\f8eb";
}

.fa-user-ninja::before {
  content: "\\f504";
}

.fa-user-nurse::before {
  content: "\\f82f";
}

.fa-user-nurse-hair::before {
  content: "\\e45d";
}

.fa-user-nurse-hair-long::before {
  content: "\\e45e";
}

.fa-user-pen::before {
  content: "\\f4ff";
}

.fa-user-edit::before {
  content: "\\f4ff";
}

.fa-user-pilot::before {
  content: "\\e2c0";
}

.fa-user-pilot-tie::before {
  content: "\\e2c1";
}

.fa-user-plus::before {
  content: "\\f234";
}

.fa-user-police::before {
  content: "\\e333";
}

.fa-user-police-tie::before {
  content: "\\e334";
}

.fa-user-robot::before {
  content: "\\e04b";
}

.fa-user-secret::before {
  content: "\\f21b";
}

.fa-user-shakespeare::before {
  content: "\\e2c2";
}

.fa-user-shield::before {
  content: "\\f505";
}

.fa-user-slash::before {
  content: "\\f506";
}

.fa-user-tag::before {
  content: "\\f507";
}

.fa-user-tie::before {
  content: "\\f508";
}

.fa-user-tie-hair::before {
  content: "\\e45f";
}

.fa-user-tie-hair-long::before {
  content: "\\e460";
}

.fa-user-unlock::before {
  content: "\\e058";
}

.fa-user-visor::before {
  content: "\\e04c";
}

.fa-user-vneck::before {
  content: "\\e461";
}

.fa-user-vneck-hair::before {
  content: "\\e462";
}

.fa-user-vneck-hair-long::before {
  content: "\\e463";
}

.fa-user-xmark::before {
  content: "\\f235";
}

.fa-user-times::before {
  content: "\\f235";
}

.fa-users::before {
  content: "\\f0c0";
}

.fa-group::before {
  content: "\\f0c0";
}

.fa-users-gear::before {
  content: "\\f509";
}

.fa-users-cog::before {
  content: "\\f509";
}

.fa-users-medical::before {
  content: "\\f830";
}

.fa-users-slash::before {
  content: "\\e073";
}

.fa-utensils::before {
  content: "\\f2e7";
}

.fa-cutlery::before {
  content: "\\f2e7";
}

.fa-utensils-slash::before {
  content: "\\e464";
}

.fa-utility-pole::before {
  content: "\\e2c3";
}

.fa-utility-pole-double::before {
  content: "\\e2c4";
}

.fa-v::before {
  content: "V";
}

.fa-vacuum::before {
  content: "\\e04d";
}

.fa-vacuum-robot::before {
  content: "\\e04e";
}

.fa-value-absolute::before {
  content: "\\f6a6";
}

.fa-van-shuttle::before {
  content: "\\f5b6";
}

.fa-shuttle-van::before {
  content: "\\f5b6";
}

.fa-vault::before {
  content: "\\e2c5";
}

.fa-vector-circle::before {
  content: "\\e2c6";
}

.fa-vector-polygon::before {
  content: "\\e2c7";
}

.fa-vector-square::before {
  content: "\\f5cb";
}

.fa-vent-damper::before {
  content: "\\e465";
}

.fa-venus::before {
  content: "\\f221";
}

.fa-venus-double::before {
  content: "\\f226";
}

.fa-venus-mars::before {
  content: "\\f228";
}

.fa-vest::before {
  content: "\\e085";
}

.fa-vest-patches::before {
  content: "\\e086";
}

.fa-vial::before {
  content: "\\f492";
}

.fa-vials::before {
  content: "\\f493";
}

.fa-video::before {
  content: "\\f03d";
}

.fa-video-camera::before {
  content: "\\f03d";
}

.fa-video-arrow-down-left::before {
  content: "\\e2c8";
}

.fa-video-arrow-up-right::before {
  content: "\\e2c9";
}

.fa-video-plus::before {
  content: "\\f4e1";
}

.fa-video-slash::before {
  content: "\\f4e2";
}

.fa-vihara::before {
  content: "\\f6a7";
}

.fa-violin::before {
  content: "\\f8ed";
}

.fa-virus::before {
  content: "\\e074";
}

.fa-virus-slash::before {
  content: "\\e075";
}

.fa-viruses::before {
  content: "\\e076";
}

.fa-voicemail::before {
  content: "\\f897";
}

.fa-volcano::before {
  content: "\\f770";
}

.fa-volleyball::before {
  content: "\\f45f";
}

.fa-volleyball-ball::before {
  content: "\\f45f";
}

.fa-volume::before {
  content: "\\f6a8";
}

.fa-volume-medium::before {
  content: "\\f6a8";
}

.fa-volume-high::before {
  content: "\\f028";
}

.fa-volume-up::before {
  content: "\\f028";
}

.fa-volume-low::before {
  content: "\\f027";
}

.fa-volume-down::before {
  content: "\\f027";
}

.fa-volume-off::before {
  content: "\\f026";
}

.fa-volume-slash::before {
  content: "\\f2e2";
}

.fa-volume-xmark::before {
  content: "\\f6a9";
}

.fa-volume-mute::before {
  content: "\\f6a9";
}

.fa-volume-times::before {
  content: "\\f6a9";
}

.fa-vr-cardboard::before {
  content: "\\f729";
}

.fa-w::before {
  content: "W";
}

.fa-waffle::before {
  content: "\\e466";
}

.fa-wagon-covered::before {
  content: "\\f8ee";
}

.fa-walker::before {
  content: "\\f831";
}

.fa-walkie-talkie::before {
  content: "\\f8ef";
}

.fa-wallet::before {
  content: "\\f555";
}

.fa-wand::before {
  content: "\\f72a";
}

.fa-wand-magic::before {
  content: "\\f0d0";
}

.fa-magic::before {
  content: "\\f0d0";
}

.fa-wand-magic-sparkles::before {
  content: "\\e2ca";
}

.fa-magic-wand-sparkles::before {
  content: "\\e2ca";
}

.fa-wand-sparkles::before {
  content: "\\f72b";
}

.fa-warehouse::before {
  content: "\\f494";
}

.fa-warehouse-full::before {
  content: "\\f495";
}

.fa-warehouse-alt::before {
  content: "\\f495";
}

.fa-washing-machine::before {
  content: "\\f898";
}

.fa-washer::before {
  content: "\\f898";
}

.fa-watch::before {
  content: "\\f2e1";
}

.fa-watch-apple::before {
  content: "\\e2cb";
}

.fa-watch-calculator::before {
  content: "\\f8f0";
}

.fa-watch-fitness::before {
  content: "\\f63e";
}

.fa-watch-smart::before {
  content: "\\e2cc";
}

.fa-water::before {
  content: "\\f773";
}

.fa-water-arrow-down::before {
  content: "\\f774";
}

.fa-water-lower::before {
  content: "\\f774";
}

.fa-water-arrow-up::before {
  content: "\\f775";
}

.fa-water-rise::before {
  content: "\\f775";
}

.fa-water-ladder::before {
  content: "\\f5c5";
}

.fa-ladder-water::before {
  content: "\\f5c5";
}

.fa-swimming-pool::before {
  content: "\\f5c5";
}

.fa-watermelon-slice::before {
  content: "\\e337";
}

.fa-wave-pulse::before {
  content: "\\f5f8";
}

.fa-heart-rate::before {
  content: "\\f5f8";
}

.fa-wave-sine::before {
  content: "\\f899";
}

.fa-wave-square::before {
  content: "\\f83e";
}

.fa-wave-triangle::before {
  content: "\\f89a";
}

.fa-waveform::before {
  content: "\\f8f1";
}

.fa-waveform-lines::before {
  content: "\\f8f2";
}

.fa-weight-hanging::before {
  content: "\\f5cd";
}

.fa-weight-scale::before {
  content: "\\f496";
}

.fa-weight::before {
  content: "\\f496";
}

.fa-whale::before {
  content: "\\f72c";
}

.fa-wheat::before {
  content: "\\f72d";
}

.fa-wheat-awn::before {
  content: "\\e2cd";
}

.fa-wheat-alt::before {
  content: "\\e2cd";
}

.fa-wheat-awn-slash::before {
  content: "\\e338";
}

.fa-wheat-slash::before {
  content: "\\e339";
}

.fa-wheelchair::before {
  content: "\\f193";
}

.fa-wheelchair-move::before {
  content: "\\e2ce";
}

.fa-wheelchair-alt::before {
  content: "\\e2ce";
}

.fa-whiskey-glass::before {
  content: "\\f7a0";
}

.fa-glass-whiskey::before {
  content: "\\f7a0";
}

.fa-whiskey-glass-ice::before {
  content: "\\f7a1";
}

.fa-glass-whiskey-rocks::before {
  content: "\\f7a1";
}

.fa-whistle::before {
  content: "\\f460";
}

.fa-wifi::before {
  content: "\\f1eb";
}

.fa-wifi-3::before {
  content: "\\f1eb";
}

.fa-wifi-strong::before {
  content: "\\f1eb";
}

.fa-wifi-exclamation::before {
  content: "\\e2cf";
}

.fa-wifi-fair::before {
  content: "\\f6ab";
}

.fa-wifi-2::before {
  content: "\\f6ab";
}

.fa-wifi-slash::before {
  content: "\\f6ac";
}

.fa-wifi-weak::before {
  content: "\\f6aa";
}

.fa-wifi-1::before {
  content: "\\f6aa";
}

.fa-wind::before {
  content: "\\f72e";
}

.fa-wind-turbine::before {
  content: "\\f89b";
}

.fa-wind-warning::before {
  content: "\\f776";
}

.fa-wind-circle-exclamation::before {
  content: "\\f776";
}

.fa-window::before {
  content: "\\f40e";
}

.fa-window-flip::before {
  content: "\\f40f";
}

.fa-window-alt::before {
  content: "\\f40f";
}

.fa-window-frame::before {
  content: "\\e04f";
}

.fa-window-frame-open::before {
  content: "\\e050";
}

.fa-window-maximize::before {
  content: "\\f2d0";
}

.fa-window-minimize::before {
  content: "\\f2d1";
}

.fa-window-restore::before {
  content: "\\f2d2";
}

.fa-windsock::before {
  content: "\\f777";
}

.fa-wine-bottle::before {
  content: "\\f72f";
}

.fa-wine-glass::before {
  content: "\\f4e3";
}

.fa-wine-glass-crack::before {
  content: "\\f4bb";
}

.fa-fragile::before {
  content: "\\f4bb";
}

.fa-wine-glass-empty::before {
  content: "\\f5ce";
}

.fa-wine-glass-alt::before {
  content: "\\f5ce";
}

.fa-won-sign::before {
  content: "\\f159";
}

.fa-krw::before {
  content: "\\f159";
}

.fa-won::before {
  content: "\\f159";
}

.fa-wreath::before {
  content: "\\f7e2";
}

.fa-wrench::before {
  content: "\\f0ad";
}

.fa-wrench-simple::before {
  content: "\\e2d1";
}

.fa-x::before {
  content: "X";
}

.fa-x-ray::before {
  content: "\\f497";
}

.fa-xmark::before {
  content: "\\f00d";
}

.fa-close::before {
  content: "\\f00d";
}

.fa-multiply::before {
  content: "\\f00d";
}

.fa-remove::before {
  content: "\\f00d";
}

.fa-times::before {
  content: "\\f00d";
}

.fa-xmark-to-slot::before {
  content: "\\f771";
}

.fa-times-to-slot::before {
  content: "\\f771";
}

.fa-vote-nay::before {
  content: "\\f771";
}

.fa-y::before {
  content: "Y";
}

.fa-yen-sign::before {
  content: "\\f157";
}

.fa-cny::before {
  content: "\\f157";
}

.fa-jpy::before {
  content: "\\f157";
}

.fa-rmb::before {
  content: "\\f157";
}

.fa-yen::before {
  content: "\\f157";
}

.fa-yin-yang::before {
  content: "\\f6ad";
}

.fa-z::before {
  content: "Z";
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/*!
 * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 */
@font-face {
  font-family: "Font Awesome 6 Brands";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
.fab,
.fa-brands {
  font-family: "Font Awesome 6 Brands";
  font-weight: 400;
}

.fa-42-group:before {
  content: "\\e080";
}

.fa-innosoft:before {
  content: "\\e080";
}

.fa-500px:before {
  content: "\\f26e";
}

.fa-accessible-icon:before {
  content: "\\f368";
}

.fa-accusoft:before {
  content: "\\f369";
}

.fa-acquisitions-incorporated:before {
  content: "\\f6af";
}

.fa-adn:before {
  content: "\\f170";
}

.fa-adversal:before {
  content: "\\f36a";
}

.fa-affiliatetheme:before {
  content: "\\f36b";
}

.fa-airbnb:before {
  content: "\\f834";
}

.fa-algolia:before {
  content: "\\f36c";
}

.fa-alipay:before {
  content: "\\f642";
}

.fa-amazon:before {
  content: "\\f270";
}

.fa-amazon-pay:before {
  content: "\\f42c";
}

.fa-amilia:before {
  content: "\\f36d";
}

.fa-android:before {
  content: "\\f17b";
}

.fa-angellist:before {
  content: "\\f209";
}

.fa-angrycreative:before {
  content: "\\f36e";
}

.fa-angular:before {
  content: "\\f420";
}

.fa-app-store:before {
  content: "\\f36f";
}

.fa-app-store-ios:before {
  content: "\\f370";
}

.fa-apper:before {
  content: "\\f371";
}

.fa-apple:before {
  content: "\\f179";
}

.fa-apple-pay:before {
  content: "\\f415";
}

.fa-artstation:before {
  content: "\\f77a";
}

.fa-asymmetrik:before {
  content: "\\f372";
}

.fa-atlassian:before {
  content: "\\f77b";
}

.fa-audible:before {
  content: "\\f373";
}

.fa-autoprefixer:before {
  content: "\\f41c";
}

.fa-avianex:before {
  content: "\\f374";
}

.fa-aviato:before {
  content: "\\f421";
}

.fa-aws:before {
  content: "\\f375";
}

.fa-bandcamp:before {
  content: "\\f2d5";
}

.fa-battle-net:before {
  content: "\\f835";
}

.fa-behance:before {
  content: "\\f1b4";
}

.fa-behance-square:before {
  content: "\\f1b5";
}

.fa-bilibili:before {
  content: "\\e3d9";
}

.fa-bimobject:before {
  content: "\\f378";
}

.fa-bitbucket:before {
  content: "\\f171";
}

.fa-bitcoin:before {
  content: "\\f379";
}

.fa-bity:before {
  content: "\\f37a";
}

.fa-black-tie:before {
  content: "\\f27e";
}

.fa-blackberry:before {
  content: "\\f37b";
}

.fa-blogger:before {
  content: "\\f37c";
}

.fa-blogger-b:before {
  content: "\\f37d";
}

.fa-bluetooth:before {
  content: "\\f293";
}

.fa-bluetooth-b:before {
  content: "\\f294";
}

.fa-bootstrap:before {
  content: "\\f836";
}

.fa-bots:before {
  content: "\\e340";
}

.fa-btc:before {
  content: "\\f15a";
}

.fa-buffer:before {
  content: "\\f837";
}

.fa-buromobelexperte:before {
  content: "\\f37f";
}

.fa-buy-n-large:before {
  content: "\\f8a6";
}

.fa-buysellads:before {
  content: "\\f20d";
}

.fa-canadian-maple-leaf:before {
  content: "\\f785";
}

.fa-cc-amazon-pay:before {
  content: "\\f42d";
}

.fa-cc-amex:before {
  content: "\\f1f3";
}

.fa-cc-apple-pay:before {
  content: "\\f416";
}

.fa-cc-diners-club:before {
  content: "\\f24c";
}

.fa-cc-discover:before {
  content: "\\f1f2";
}

.fa-cc-jcb:before {
  content: "\\f24b";
}

.fa-cc-mastercard:before {
  content: "\\f1f1";
}

.fa-cc-paypal:before {
  content: "\\f1f4";
}

.fa-cc-stripe:before {
  content: "\\f1f5";
}

.fa-cc-visa:before {
  content: "\\f1f0";
}

.fa-centercode:before {
  content: "\\f380";
}

.fa-centos:before {
  content: "\\f789";
}

.fa-chrome:before {
  content: "\\f268";
}

.fa-chromecast:before {
  content: "\\f838";
}

.fa-cloudflare:before {
  content: "\\e07d";
}

.fa-cloudscale:before {
  content: "\\f383";
}

.fa-cloudsmith:before {
  content: "\\f384";
}

.fa-cloudversify:before {
  content: "\\f385";
}

.fa-cmplid:before {
  content: "\\e360";
}

.fa-codepen:before {
  content: "\\f1cb";
}

.fa-codiepie:before {
  content: "\\f284";
}

.fa-confluence:before {
  content: "\\f78d";
}

.fa-connectdevelop:before {
  content: "\\f20e";
}

.fa-contao:before {
  content: "\\f26d";
}

.fa-cotton-bureau:before {
  content: "\\f89e";
}

.fa-cpanel:before {
  content: "\\f388";
}

.fa-creative-commons:before {
  content: "\\f25e";
}

.fa-creative-commons-by:before {
  content: "\\f4e7";
}

.fa-creative-commons-nc:before {
  content: "\\f4e8";
}

.fa-creative-commons-nc-eu:before {
  content: "\\f4e9";
}

.fa-creative-commons-nc-jp:before {
  content: "\\f4ea";
}

.fa-creative-commons-nd:before {
  content: "\\f4eb";
}

.fa-creative-commons-pd:before {
  content: "\\f4ec";
}

.fa-creative-commons-pd-alt:before {
  content: "\\f4ed";
}

.fa-creative-commons-remix:before {
  content: "\\f4ee";
}

.fa-creative-commons-sa:before {
  content: "\\f4ef";
}

.fa-creative-commons-sampling:before {
  content: "\\f4f0";
}

.fa-creative-commons-sampling-plus:before {
  content: "\\f4f1";
}

.fa-creative-commons-share:before {
  content: "\\f4f2";
}

.fa-creative-commons-zero:before {
  content: "\\f4f3";
}

.fa-critical-role:before {
  content: "\\f6c9";
}

.fa-css3:before {
  content: "\\f13c";
}

.fa-css3-alt:before {
  content: "\\f38b";
}

.fa-cuttlefish:before {
  content: "\\f38c";
}

.fa-d-and-d:before {
  content: "\\f38d";
}

.fa-d-and-d-beyond:before {
  content: "\\f6ca";
}

.fa-dailymotion:before {
  content: "\\e052";
}

.fa-dashcube:before {
  content: "\\f210";
}

.fa-deezer:before {
  content: "\\e077";
}

.fa-delicious:before {
  content: "\\f1a5";
}

.fa-deploydog:before {
  content: "\\f38e";
}

.fa-deskpro:before {
  content: "\\f38f";
}

.fa-dev:before {
  content: "\\f6cc";
}

.fa-deviantart:before {
  content: "\\f1bd";
}

.fa-dhl:before {
  content: "\\f790";
}

.fa-diaspora:before {
  content: "\\f791";
}

.fa-digg:before {
  content: "\\f1a6";
}

.fa-digital-ocean:before {
  content: "\\f391";
}

.fa-discord:before {
  content: "\\f392";
}

.fa-discourse:before {
  content: "\\f393";
}

.fa-dochub:before {
  content: "\\f394";
}

.fa-docker:before {
  content: "\\f395";
}

.fa-draft2digital:before {
  content: "\\f396";
}

.fa-dribbble:before {
  content: "\\f17d";
}

.fa-dribbble-square:before {
  content: "\\f397";
}

.fa-dropbox:before {
  content: "\\f16b";
}

.fa-drupal:before {
  content: "\\f1a9";
}

.fa-dyalog:before {
  content: "\\f399";
}

.fa-earlybirds:before {
  content: "\\f39a";
}

.fa-ebay:before {
  content: "\\f4f4";
}

.fa-edge:before {
  content: "\\f282";
}

.fa-edge-legacy:before {
  content: "\\e078";
}

.fa-elementor:before {
  content: "\\f430";
}

.fa-ello:before {
  content: "\\f5f1";
}

.fa-ember:before {
  content: "\\f423";
}

.fa-empire:before {
  content: "\\f1d1";
}

.fa-envira:before {
  content: "\\f299";
}

.fa-erlang:before {
  content: "\\f39d";
}

.fa-ethereum:before {
  content: "\\f42e";
}

.fa-etsy:before {
  content: "\\f2d7";
}

.fa-evernote:before {
  content: "\\f839";
}

.fa-expeditedssl:before {
  content: "\\f23e";
}

.fa-facebook:before {
  content: "\\f09a";
}

.fa-facebook-f:before {
  content: "\\f39e";
}

.fa-facebook-messenger:before {
  content: "\\f39f";
}

.fa-facebook-square:before {
  content: "\\f082";
}

.fa-fantasy-flight-games:before {
  content: "\\f6dc";
}

.fa-fedex:before {
  content: "\\f797";
}

.fa-fedora:before {
  content: "\\f798";
}

.fa-figma:before {
  content: "\\f799";
}

.fa-firefox:before {
  content: "\\f269";
}

.fa-firefox-browser:before {
  content: "\\e007";
}

.fa-first-order:before {
  content: "\\f2b0";
}

.fa-first-order-alt:before {
  content: "\\f50a";
}

.fa-firstdraft:before {
  content: "\\f3a1";
}

.fa-flickr:before {
  content: "\\f16e";
}

.fa-flipboard:before {
  content: "\\f44d";
}

.fa-fly:before {
  content: "\\f417";
}

.fa-font-awesome:before {
  content: "\\f2b4";
}

.fa-font-awesome-flag:before {
  content: "\\f2b4";
}

.fa-font-awesome-logo-full:before {
  content: "\\f2b4";
}

.fa-fonticons:before {
  content: "\\f280";
}

.fa-fonticons-fi:before {
  content: "\\f3a2";
}

.fa-fort-awesome:before {
  content: "\\f286";
}

.fa-fort-awesome-alt:before {
  content: "\\f3a3";
}

.fa-forumbee:before {
  content: "\\f211";
}

.fa-foursquare:before {
  content: "\\f180";
}

.fa-free-code-camp:before {
  content: "\\f2c5";
}

.fa-freebsd:before {
  content: "\\f3a4";
}

.fa-fulcrum:before {
  content: "\\f50b";
}

.fa-galactic-republic:before {
  content: "\\f50c";
}

.fa-galactic-senate:before {
  content: "\\f50d";
}

.fa-get-pocket:before {
  content: "\\f265";
}

.fa-gg:before {
  content: "\\f260";
}

.fa-gg-circle:before {
  content: "\\f261";
}

.fa-git:before {
  content: "\\f1d3";
}

.fa-git-alt:before {
  content: "\\f841";
}

.fa-git-square:before {
  content: "\\f1d2";
}

.fa-github:before {
  content: "\\f09b";
}

.fa-github-alt:before {
  content: "\\f113";
}

.fa-github-square:before {
  content: "\\f092";
}

.fa-gitkraken:before {
  content: "\\f3a6";
}

.fa-gitlab:before {
  content: "\\f296";
}

.fa-gitter:before {
  content: "\\f426";
}

.fa-glide:before {
  content: "\\f2a5";
}

.fa-glide-g:before {
  content: "\\f2a6";
}

.fa-gofore:before {
  content: "\\f3a7";
}

.fa-golang:before {
  content: "\\e40f";
}

.fa-goodreads:before {
  content: "\\f3a8";
}

.fa-goodreads-g:before {
  content: "\\f3a9";
}

.fa-google:before {
  content: "\\f1a0";
}

.fa-google-drive:before {
  content: "\\f3aa";
}

.fa-google-pay:before {
  content: "\\e079";
}

.fa-google-play:before {
  content: "\\f3ab";
}

.fa-google-plus:before {
  content: "\\f2b3";
}

.fa-google-plus-g:before {
  content: "\\f0d5";
}

.fa-google-plus-square:before {
  content: "\\f0d4";
}

.fa-google-wallet:before {
  content: "\\f1ee";
}

.fa-gratipay:before {
  content: "\\f184";
}

.fa-grav:before {
  content: "\\f2d6";
}

.fa-gripfire:before {
  content: "\\f3ac";
}

.fa-grunt:before {
  content: "\\f3ad";
}

.fa-guilded:before {
  content: "\\e07e";
}

.fa-gulp:before {
  content: "\\f3ae";
}

.fa-hacker-news:before {
  content: "\\f1d4";
}

.fa-hacker-news-square:before {
  content: "\\f3af";
}

.fa-hackerrank:before {
  content: "\\f5f7";
}

.fa-hips:before {
  content: "\\f452";
}

.fa-hire-a-helper:before {
  content: "\\f3b0";
}

.fa-hive:before {
  content: "\\e07f";
}

.fa-hooli:before {
  content: "\\f427";
}

.fa-hornbill:before {
  content: "\\f592";
}

.fa-hotjar:before {
  content: "\\f3b1";
}

.fa-houzz:before {
  content: "\\f27c";
}

.fa-html5:before {
  content: "\\f13b";
}

.fa-hubspot:before {
  content: "\\f3b2";
}

.fa-ideal:before {
  content: "\\e013";
}

.fa-imdb:before {
  content: "\\f2d8";
}

.fa-instagram:before {
  content: "\\f16d";
}

.fa-instagram-square:before {
  content: "\\e055";
}

.fa-instalod:before {
  content: "\\e081";
}

.fa-intercom:before {
  content: "\\f7af";
}

.fa-internet-explorer:before {
  content: "\\f26b";
}

.fa-invision:before {
  content: "\\f7b0";
}

.fa-ioxhost:before {
  content: "\\f208";
}

.fa-itch-io:before {
  content: "\\f83a";
}

.fa-itunes:before {
  content: "\\f3b4";
}

.fa-itunes-note:before {
  content: "\\f3b5";
}

.fa-java:before {
  content: "\\f4e4";
}

.fa-jedi-order:before {
  content: "\\f50e";
}

.fa-jenkins:before {
  content: "\\f3b6";
}

.fa-jira:before {
  content: "\\f7b1";
}

.fa-joget:before {
  content: "\\f3b7";
}

.fa-joomla:before {
  content: "\\f1aa";
}

.fa-js:before {
  content: "\\f3b8";
}

.fa-js-square:before {
  content: "\\f3b9";
}

.fa-jsfiddle:before {
  content: "\\f1cc";
}

.fa-kaggle:before {
  content: "\\f5fa";
}

.fa-keybase:before {
  content: "\\f4f5";
}

.fa-keycdn:before {
  content: "\\f3ba";
}

.fa-kickstarter:before {
  content: "\\f3bb";
}

.fa-kickstarter-k:before {
  content: "\\f3bc";
}

.fa-korvue:before {
  content: "\\f42f";
}

.fa-laravel:before {
  content: "\\f3bd";
}

.fa-lastfm:before {
  content: "\\f202";
}

.fa-lastfm-square:before {
  content: "\\f203";
}

.fa-leanpub:before {
  content: "\\f212";
}

.fa-less:before {
  content: "\\f41d";
}

.fa-line:before {
  content: "\\f3c0";
}

.fa-linkedin:before {
  content: "\\f08c";
}

.fa-linkedin-in:before {
  content: "\\f0e1";
}

.fa-linode:before {
  content: "\\f2b8";
}

.fa-linux:before {
  content: "\\f17c";
}

.fa-lyft:before {
  content: "\\f3c3";
}

.fa-magento:before {
  content: "\\f3c4";
}

.fa-mailchimp:before {
  content: "\\f59e";
}

.fa-mandalorian:before {
  content: "\\f50f";
}

.fa-markdown:before {
  content: "\\f60f";
}

.fa-mastodon:before {
  content: "\\f4f6";
}

.fa-maxcdn:before {
  content: "\\f136";
}

.fa-mdb:before {
  content: "\\f8ca";
}

.fa-medapps:before {
  content: "\\f3c6";
}

.fa-medium:before {
  content: "\\f23a";
}

.fa-medium-m:before {
  content: "\\f23a";
}

.fa-medrt:before {
  content: "\\f3c8";
}

.fa-meetup:before {
  content: "\\f2e0";
}

.fa-megaport:before {
  content: "\\f5a3";
}

.fa-mendeley:before {
  content: "\\f7b3";
}

.fa-microblog:before {
  content: "\\e01a";
}

.fa-microsoft:before {
  content: "\\f3ca";
}

.fa-mix:before {
  content: "\\f3cb";
}

.fa-mixcloud:before {
  content: "\\f289";
}

.fa-mixer:before {
  content: "\\e056";
}

.fa-mizuni:before {
  content: "\\f3cc";
}

.fa-modx:before {
  content: "\\f285";
}

.fa-monero:before {
  content: "\\f3d0";
}

.fa-napster:before {
  content: "\\f3d2";
}

.fa-neos:before {
  content: "\\f612";
}

.fa-nimblr:before {
  content: "\\f5a8";
}

.fa-node:before {
  content: "\\f419";
}

.fa-node-js:before {
  content: "\\f3d3";
}

.fa-npm:before {
  content: "\\f3d4";
}

.fa-ns8:before {
  content: "\\f3d5";
}

.fa-nutritionix:before {
  content: "\\f3d6";
}

.fa-octopus-deploy:before {
  content: "\\e082";
}

.fa-odnoklassniki:before {
  content: "\\f263";
}

.fa-odnoklassniki-square:before {
  content: "\\f264";
}

.fa-old-republic:before {
  content: "\\f510";
}

.fa-opencart:before {
  content: "\\f23d";
}

.fa-openid:before {
  content: "\\f19b";
}

.fa-opera:before {
  content: "\\f26a";
}

.fa-optin-monster:before {
  content: "\\f23c";
}

.fa-orcid:before {
  content: "\\f8d2";
}

.fa-osi:before {
  content: "\\f41a";
}

.fa-page4:before {
  content: "\\f3d7";
}

.fa-pagelines:before {
  content: "\\f18c";
}

.fa-palfed:before {
  content: "\\f3d8";
}

.fa-patreon:before {
  content: "\\f3d9";
}

.fa-paypal:before {
  content: "\\f1ed";
}

.fa-penny-arcade:before {
  content: "\\f704";
}

.fa-perbyte:before {
  content: "\\e083";
}

.fa-periscope:before {
  content: "\\f3da";
}

.fa-phabricator:before {
  content: "\\f3db";
}

.fa-phoenix-framework:before {
  content: "\\f3dc";
}

.fa-phoenix-squadron:before {
  content: "\\f511";
}

.fa-php:before {
  content: "\\f457";
}

.fa-pied-piper:before {
  content: "\\f2ae";
}

.fa-pied-piper-alt:before {
  content: "\\f1a8";
}

.fa-pied-piper-hat:before {
  content: "\\f4e5";
}

.fa-pied-piper-pp:before {
  content: "\\f1a7";
}

.fa-pied-piper-square:before {
  content: "\\e01e";
}

.fa-pinterest:before {
  content: "\\f0d2";
}

.fa-pinterest-p:before {
  content: "\\f231";
}

.fa-pinterest-square:before {
  content: "\\f0d3";
}

.fa-pix:before {
  content: "\\e43a";
}

.fa-playstation:before {
  content: "\\f3df";
}

.fa-product-hunt:before {
  content: "\\f288";
}

.fa-pushed:before {
  content: "\\f3e1";
}

.fa-python:before {
  content: "\\f3e2";
}

.fa-qq:before {
  content: "\\f1d6";
}

.fa-quinscape:before {
  content: "\\f459";
}

.fa-quora:before {
  content: "\\f2c4";
}

.fa-r-project:before {
  content: "\\f4f7";
}

.fa-raspberry-pi:before {
  content: "\\f7bb";
}

.fa-ravelry:before {
  content: "\\f2d9";
}

.fa-react:before {
  content: "\\f41b";
}

.fa-reacteurope:before {
  content: "\\f75d";
}

.fa-readme:before {
  content: "\\f4d5";
}

.fa-rebel:before {
  content: "\\f1d0";
}

.fa-red-river:before {
  content: "\\f3e3";
}

.fa-reddit:before {
  content: "\\f1a1";
}

.fa-reddit-alien:before {
  content: "\\f281";
}

.fa-reddit-square:before {
  content: "\\f1a2";
}

.fa-redhat:before {
  content: "\\f7bc";
}

.fa-renren:before {
  content: "\\f18b";
}

.fa-replyd:before {
  content: "\\f3e6";
}

.fa-researchgate:before {
  content: "\\f4f8";
}

.fa-resolving:before {
  content: "\\f3e7";
}

.fa-rev:before {
  content: "\\f5b2";
}

.fa-rocketchat:before {
  content: "\\f3e8";
}

.fa-rockrms:before {
  content: "\\f3e9";
}

.fa-rust:before {
  content: "\\e07a";
}

.fa-safari:before {
  content: "\\f267";
}

.fa-salesforce:before {
  content: "\\f83b";
}

.fa-sass:before {
  content: "\\f41e";
}

.fa-schlix:before {
  content: "\\f3ea";
}

.fa-scribd:before {
  content: "\\f28a";
}

.fa-searchengin:before {
  content: "\\f3eb";
}

.fa-sellcast:before {
  content: "\\f2da";
}

.fa-sellsy:before {
  content: "\\f213";
}

.fa-servicestack:before {
  content: "\\f3ec";
}

.fa-shirtsinbulk:before {
  content: "\\f214";
}

.fa-shopify:before {
  content: "\\e057";
}

.fa-shopware:before {
  content: "\\f5b5";
}

.fa-simplybuilt:before {
  content: "\\f215";
}

.fa-sistrix:before {
  content: "\\f3ee";
}

.fa-sith:before {
  content: "\\f512";
}

.fa-sitrox:before {
  content: "\\e44a";
}

.fa-sketch:before {
  content: "\\f7c6";
}

.fa-skyatlas:before {
  content: "\\f216";
}

.fa-skype:before {
  content: "\\f17e";
}

.fa-slack:before {
  content: "\\f198";
}

.fa-slack-hash:before {
  content: "\\f198";
}

.fa-slideshare:before {
  content: "\\f1e7";
}

.fa-snapchat:before {
  content: "\\f2ab";
}

.fa-snapchat-ghost:before {
  content: "\\f2ab";
}

.fa-snapchat-square:before {
  content: "\\f2ad";
}

.fa-soundcloud:before {
  content: "\\f1be";
}

.fa-sourcetree:before {
  content: "\\f7d3";
}

.fa-speakap:before {
  content: "\\f3f3";
}

.fa-speaker-deck:before {
  content: "\\f83c";
}

.fa-spotify:before {
  content: "\\f1bc";
}

.fa-square-font-awesome:before {
  content: "\\f425";
}

.fa-square-font-awesome-stroke:before {
  content: "\\f35c";
}

.fa-font-awesome-alt:before {
  content: "\\f35c";
}

.fa-squarespace:before {
  content: "\\f5be";
}

.fa-stack-exchange:before {
  content: "\\f18d";
}

.fa-stack-overflow:before {
  content: "\\f16c";
}

.fa-stackpath:before {
  content: "\\f842";
}

.fa-staylinked:before {
  content: "\\f3f5";
}

.fa-steam:before {
  content: "\\f1b6";
}

.fa-steam-square:before {
  content: "\\f1b7";
}

.fa-steam-symbol:before {
  content: "\\f3f6";
}

.fa-sticker-mule:before {
  content: "\\f3f7";
}

.fa-strava:before {
  content: "\\f428";
}

.fa-stripe:before {
  content: "\\f429";
}

.fa-stripe-s:before {
  content: "\\f42a";
}

.fa-studiovinari:before {
  content: "\\f3f8";
}

.fa-stumbleupon:before {
  content: "\\f1a4";
}

.fa-stumbleupon-circle:before {
  content: "\\f1a3";
}

.fa-superpowers:before {
  content: "\\f2dd";
}

.fa-supple:before {
  content: "\\f3f9";
}

.fa-suse:before {
  content: "\\f7d6";
}

.fa-swift:before {
  content: "\\f8e1";
}

.fa-symfony:before {
  content: "\\f83d";
}

.fa-teamspeak:before {
  content: "\\f4f9";
}

.fa-telegram:before {
  content: "\\f2c6";
}

.fa-telegram-plane:before {
  content: "\\f2c6";
}

.fa-tencent-weibo:before {
  content: "\\f1d5";
}

.fa-the-red-yeti:before {
  content: "\\f69d";
}

.fa-themeco:before {
  content: "\\f5c6";
}

.fa-themeisle:before {
  content: "\\f2b2";
}

.fa-think-peaks:before {
  content: "\\f731";
}

.fa-tiktok:before {
  content: "\\e07b";
}

.fa-trade-federation:before {
  content: "\\f513";
}

.fa-trello:before {
  content: "\\f181";
}

.fa-tumblr:before {
  content: "\\f173";
}

.fa-tumblr-square:before {
  content: "\\f174";
}

.fa-twitch:before {
  content: "\\f1e8";
}

.fa-twitter:before {
  content: "\\f099";
}

.fa-twitter-square:before {
  content: "\\f081";
}

.fa-typo3:before {
  content: "\\f42b";
}

.fa-uber:before {
  content: "\\f402";
}

.fa-ubuntu:before {
  content: "\\f7df";
}

.fa-uikit:before {
  content: "\\f403";
}

.fa-umbraco:before {
  content: "\\f8e8";
}

.fa-uncharted:before {
  content: "\\e084";
}

.fa-uniregistry:before {
  content: "\\f404";
}

.fa-unity:before {
  content: "\\e049";
}

.fa-unsplash:before {
  content: "\\e07c";
}

.fa-untappd:before {
  content: "\\f405";
}

.fa-ups:before {
  content: "\\f7e0";
}

.fa-usb:before {
  content: "\\f287";
}

.fa-usps:before {
  content: "\\f7e1";
}

.fa-ussunnah:before {
  content: "\\f407";
}

.fa-vaadin:before {
  content: "\\f408";
}

.fa-viacoin:before {
  content: "\\f237";
}

.fa-viadeo:before {
  content: "\\f2a9";
}

.fa-viadeo-square:before {
  content: "\\f2aa";
}

.fa-viber:before {
  content: "\\f409";
}

.fa-vimeo:before {
  content: "\\f40a";
}

.fa-vimeo-square:before {
  content: "\\f194";
}

.fa-vimeo-v:before {
  content: "\\f27d";
}

.fa-vine:before {
  content: "\\f1ca";
}

.fa-vk:before {
  content: "\\f189";
}

.fa-vnv:before {
  content: "\\f40b";
}

.fa-vuejs:before {
  content: "\\f41f";
}

.fa-watchman-monitoring:before {
  content: "\\e087";
}

.fa-waze:before {
  content: "\\f83f";
}

.fa-weebly:before {
  content: "\\f5cc";
}

.fa-weibo:before {
  content: "\\f18a";
}

.fa-weixin:before {
  content: "\\f1d7";
}

.fa-whatsapp:before {
  content: "\\f232";
}

.fa-whatsapp-square:before {
  content: "\\f40c";
}

.fa-whmcs:before {
  content: "\\f40d";
}

.fa-wikipedia-w:before {
  content: "\\f266";
}

.fa-windows:before {
  content: "\\f17a";
}

.fa-wirsindhandwerk:before {
  content: "\\e2d0";
}

.fa-wsh:before {
  content: "\\e2d0";
}

.fa-wix:before {
  content: "\\f5cf";
}

.fa-wizards-of-the-coast:before {
  content: "\\f730";
}

.fa-wodu:before {
  content: "\\e088";
}

.fa-wolf-pack-battalion:before {
  content: "\\f514";
}

.fa-wordpress:before {
  content: "\\f19a";
}

.fa-wordpress-simple:before {
  content: "\\f411";
}

.fa-wpbeginner:before {
  content: "\\f297";
}

.fa-wpexplorer:before {
  content: "\\f2de";
}

.fa-wpforms:before {
  content: "\\f298";
}

.fa-wpressr:before {
  content: "\\f3e4";
}

.fa-xbox:before {
  content: "\\f412";
}

.fa-xing:before {
  content: "\\f168";
}

.fa-xing-square:before {
  content: "\\f169";
}

.fa-y-combinator:before {
  content: "\\f23b";
}

.fa-yahoo:before {
  content: "\\f19e";
}

.fa-yammer:before {
  content: "\\f840";
}

.fa-yandex:before {
  content: "\\f413";
}

.fa-yandex-international:before {
  content: "\\f414";
}

.fa-yarn:before {
  content: "\\f7e3";
}

.fa-yelp:before {
  content: "\\f1e9";
}

.fa-yoast:before {
  content: "\\f2b1";
}

.fa-youtube:before {
  content: "\\f167";
}

.fa-youtube-square:before {
  content: "\\f431";
}

.fa-zhihu:before {
  content: "\\f63f";
}

/*!
 * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 */
@font-face {
  font-family: "Font Awesome 6 Pro";
  font-style: normal;
  font-weight: 900;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
.fas,
.fa-solid {
  font-family: "Font Awesome 6 Pro";
  font-weight: 900;
}

/*!
 * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 */
@font-face {
  font-family: "Font Awesome 6 Pro";
  font-style: normal;
  font-weight: 300;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
.fal,
.fa-light {
  font-family: "Font Awesome 6 Pro";
  font-weight: 300;
}

/*!
 * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 */
@font-face {
  font-family: "Font Awesome 6 Pro";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
.far,
.fa-regular {
  font-family: "Font Awesome 6 Pro";
  font-weight: 400;
}

/*!
 * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 */
@font-face {
  font-family: "Font Awesome 6 Pro";
  font-style: normal;
  font-weight: 100;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
.fat,
.fa-thin {
  font-family: "Font Awesome 6 Pro";
  font-weight: 100;
}

@font-face {
  font-family: "Inter";
  font-weight: 100 900;
  font-display: swap;
  font-style: normal;
  font-named-instance: "Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2");
}
@font-face {
  font-family: "Soehne";
  font-weight: 200;
  src: url("https://cdn.paylix.gg/static/fonts/soehne-extraleicht.woff2");
}
@font-face {
  font-family: "Soehne";
  font-weight: 300;
  src: url("https://cdn.paylix.gg/static/fonts/soehne-leicht.woff2");
}
@font-face {
  font-family: "Soehne";
  font-weight: 400;
  src: url("https://cdn.paylix.gg/static/fonts/soehne-buch.woff2");
}
@font-face {
  font-family: "Soehne";
  font-weight: 500;
  src: url("https://cdn.paylix.gg/static/fonts/soehne-kraftig.woff2");
}
@font-face {
  font-family: "Soehne";
  font-weight: 600;
  src: url("https://cdn.paylix.gg/static/fonts/soehne-halbfett.woff2");
}
@font-face {
  font-family: "Soehne";
  font-weight: 700;
  src: url("https://cdn.paylix.gg/static/fonts/soehne-dreiviertelfett.woff2");
}
@font-face {
  font-family: "Soehne";
  font-weight: 800;
  src: url("https://cdn.paylix.gg/static/fonts/soehne-fett.woff2");
}
@font-face {
  font-family: "Soehne";
  font-weight: 900;
  src: url("https://cdn.paylix.gg/static/fonts/soehne-extrafett.woff2");
}
html {
  width: 100vw;
  margin-left: 0;
  background-color: white;
  overflow-x: hidden;
}
html.embed {
  background-color: transparent !important;
}
html.embed #app {
  background-color: transparent !important;
}

* {
  box-sizing: border-box;
}

h1, .h1 {
  margin-top: 0;
}

h2, .h2 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

h4, .h4 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

h6, .h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

h5, .h5 {
  font-size: 1.25rem;
}

body {
  transition: background 0.9s;
  background-color: rgba(0, 0, 0, 0);
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  font-family: "Inter", sans-serif !important;
  margin: 0;
}

*::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: transparent;
}
*::-webkit-scrollbar-track {
  background-color: transparent;
}
*::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
}

.uppercase {
  text-transform: lowercase;
}
.uppercase:first-letter {
  text-transform: uppercase;
}

@media (max-width: 375px) {
  .g-recaptcha {
    margin: 0 auto;
    transform: scale(0.98);
    -webkit-transform: scale(0.98);
    transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
  }
}
@media (max-width: 360px) {
  .g-recaptcha {
    margin: 0 auto;
    transform: scale(0.92);
    -webkit-transform: scale(0.92);
    transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
  }
}
@media (max-width: 320px) {
  .g-recaptcha {
    margin: 0 auto;
    transform: scale(0.8);
    -webkit-transform: scale(0.8);
    transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
  }
}
.selectable {
  -webkit-user-select: text;
  -khtml-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

.underline {
  text-decoration: underline !important;
}

.transparent-bg {
  background-color: transparent;
}

.cursor-pointer {
  cursor: pointer;
}

.notransition * {
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  -ms-transition: none !important;
  transition: none !important;
}

a {
  color: #6a32e6;
  text-decoration: none;
  background-color: transparent;
}

.is-invalid ~ .invalid-feedback {
  display: block;
}

h4, .h4 {
  font-size: 18px;
}

.flag-icon {
  position: relative;
  display: inline-block;
  width: 3rem;
  height: 2rem;
  line-height: 1em;
  border-radius: 0.25rem;
  object-fit: cover;
}
.flag-icon:before {
  content: " ";
}

.flag-icon {
  position: relative;
  display: inline-block;
  width: 1.3333333333em;
  line-height: 1em;
  object-fit: cover;
}
.flag-icon:before {
  content: " ";
}

.text-green {
  color: #28a745 !important;
}

.text-gold {
  color: gold !important;
}

.text-grey {
  color: dimgrey !important;
}

.text-red {
  color: #dc3545 !important;
}

.grecaptcha-badge {
  visibility: hidden;
}

.unselectable {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-drag: none;
  user-select: none;
}

.overflow-hidden {
  overflow: hidden;
}

.overflow-scroll {
  overflow: scroll;
}

.notransition * {
  -webkit-transition: none;
  -moz-transition: none;
  -o-transition: none;
  transition: none;
}

hr {
  width: 100%;
}

.button {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  user-select: none;
  border: 1px solid rgba(0, 0, 0, 0);
  line-height: 1.5;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  padding: 0 20px;
  white-space: nowrap;
  background-color: var(--purple6);
  font-family: "Inter", sans-serif !important;
}
.button:hover {
  opacity: 0.9;
}
.button:disabled {
  opacity: 0.7;
  cursor: default;
}
.button.thin {
  min-height: 30px;
  font-size: 12px;
  padding: 0 10px;
  border-radius: 6px;
}

.button-ghost {
  background: rgba(0, 0, 0, 0);
  border-color: var(--black1);
  border-radius: 0.5rem;
  color: var(--black9);
}
.button-ghost:hover {
  background: var(--black1);
}

.w-90 {
  width: 90% !important;
}

.w-80 {
  width: 80% !important;
}

.w-70 {
  width: 70% !important;
}

.w-60 {
  width: 60%;
}

.w-50 {
  width: 50%;
}

.w-40 {
  width: 40%;
}

.w-30 {
  width: 30% !important;
}

.w-20 {
  width: 20%;
}

.w-10 {
  width: 10%;
}

.purple-color {
  color: var(--purple6) !important;
}

.text-nowrap {
  white-space: nowrap;
}

.w-max {
  width: max-content !important;
}

.link-like {
  color: var(--purple6);
  text-decoration: underline;
  cursor: pointer;
}

.screen-title {
  margin-top: 0.5rem;
  margin-bottom: 0;
  font-size: 1.5rem !important;
  white-space: nowrap;
  align-items: center;
  display: flex;
  margin-right: 1.5rem;
  width: auto;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  line-height: 29px;
  color: var(--black9) !important;
}
.screen-title + div {
  width: auto;
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 768px) {
  .screen-title {
    font-weight: 500;
    font-size: 1.5rem !important;
  }
}
.screen-title-container {
  display: flex;
}
@media (max-width: 768px) {
  .screen-title-container {
    flex-wrap: wrap;
  }
}
.screen-note {
  margin: 1rem 0;
  font-size: 0.8rem;
  line-height: 1.2rem;
  color: var(--black9);
}
@media (max-width: 768px) {
  .screen-note {
    margin: 0.5rem 0;
  }
}
.screen-header {
  padding: 1.5rem 0;
  align-items: flex-end;
  justify-content: space-between;
  display: flex;
  position: relative;
}
@media (max-width: 768px) {
  .screen-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 1rem 0;
  }
}
.screen-filters {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap-reverse;
  gap: 0.75rem;
}
.screen-filters-button {
  margin-left: 1rem;
}
@media (max-width: 768px) {
  .screen-filters-button {
    margin-left: 0;
  }
}
@media (max-width: 768px) {
  .screen-filters {
    width: 100%;
    margin-top: 0.25rem;
    display: flex;
    flex-direction: column;
  }
}
@media (max-width: 768px) {
  .screen-filters .paylixecommerce-date-picker {
    width: 100%;
    justify-content: center;
  }
}
.screen-select {
  max-width: 30%;
}
.screen-select.long {
  max-width: 50%;
}

@media (max-width: 768px) {
  .screen-title {
    font-weight: 500;
    font-size: 1.5rem !important;
  }
  .screen-title-container {
    flex-wrap: wrap;
  }
  .screen-note {
    margin: 0.5rem 0;
  }
  .screen-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 1rem 0;
  }
  .screen-filters {
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 0.25rem;
    display: flex;
    flex-direction: column;
  }
  .screen-filters-button {
    margin-left: 0;
  }
  .screen-filters .paylixecommerce-date-picker {
    width: 100%;
    justify-content: center;
  }
}
.dark .paylixecommerce-select {
  background-color: var(--black1);
}
.dark .paylixecommerce-label {
  color: var(--black);
}
.dark .paylixecommerce-input {
  background-color: var(--black1);
}
.dark textarea.paylixecommerce-input {
  background-color: var(--black1);
}
.dark .react-mde .mde-textarea-wrapper textarea.mde-text {
  background-color: var(--black1);
  border-color: var(--black6);
  border-bottom: none;
  border-right: none;
  border-left: none;
}
.dark .react-mde .mde-header {
  background-color: var(--black1);
}
.dark .switcher input:checked + .switcher-slider::before {
  background: var(--black);
}
.dark .switcher .switcher-slider {
  background: var(--black3);
}

.paylixecommerce-note {
  display: block;
  align-items: end;
  margin-top: 0.75rem;
  margin-bottom: 0;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: var(--black5);
}
@media (max-width: 768px) {
  .paylixecommerce-note {
    font-weight: 400;
  }
}
.paylixecommerce-note b {
  color: var(--black9) !important;
  font-weight: 600 !important;
}
.paylixecommerce-note a {
  color: var(--purple6) !important;
  font-weight: 600 !important;
}

.paylixecommerce-note-big {
  display: block;
  align-items: end;
  margin-top: 0.75rem;
  margin-bottom: 0;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: var(--black5);
}
.paylixecommerce-note-big b {
  color: var(--black9) !important;
  font-weight: 500 !important;
}
.paylixecommerce-note-big a {
  color: var(--purple6) !important;
  font-weight: 600 !important;
}

.d-block {
  display: block;
}

.paylixecommerce-label {
  margin-bottom: 0.75rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 17px;
  color: var(--black5);
  display: flex;
  align-items: center;
}

.paylixecommerce-input-visible {
  position: absolute;
  right: 1rem;
  bottom: 0.6rem;
  cursor: pointer;
}

.paylixecommerce-input-prefix {
  position: absolute;
  height: 40px;
  bottom: 0;
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 1rem;
  font-weight: bold;
  color: var(--black9);
  top: 29px;
  right: 0;
  border-left: 1px solid var(--black2);
}
.paylixecommerce-input-prefix + div input {
  padding-right: 2.5rem;
}

.paylixecommerce-select {
  cursor: pointer;
  padding: 0 2rem 0 14px;
  height: 40px;
  max-height: 40px;
  width: 100%;
  transition: border 0.3s ease;
  outline: none;
  border-radius: 0.5rem;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  margin: 0;
  color: var(--black9);
  border: 1px solid var(--black2);
  box-shadow: inset 0 1px 2px rgba(16, 24, 40, 0.05);
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-position-x: calc(100% - 1rem);
  background-position-y: 0.5rem;
}
.paylixecommerce-select[disabled] {
  background: var(--black0);
  border-color: var(--black2);
  cursor: default;
}
.paylixecommerce-select:active {
  border-color: var(--purple6);
}
.paylixecommerce-select:focus {
  border-color: var(--purple6);
}
.paylixecommerce-select:hover {
  border-color: var(--purple6);
}
.paylixecommerce-select::-ms-expand {
  display: none;
}
.paylixecommerce-select.is-invalid {
  border: 1px solid var(--red6) !important;
}
.paylixecommerce-select.is-invalid:hover {
  border-color: var(--red6) !important;
}
.paylixecommerce-select.is-invalid:focus {
  border-color: var(--red6) !important;
}

.switcher {
  width: 2.75rem;
  min-width: 2.75rem;
  height: 1.5rem;
  margin: 0 0 0 1rem;
}
.switcher-label {
  cursor: pointer;
  width: calc(100% - 3.75rem);
}
.switcher-label .paylixecommerce-note {
  font-weight: 400;
  margin: 0;
}
.switcher.left {
  margin-right: 0;
}
.switcher-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
}
.switcher-container.withBorder {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--black1);
}
.switcher-container.right .switcher {
  margin-left: 0;
  margin-right: 1rem;
}
.switcher-container.right .switcher-label {
  width: calc(100% - 3.75rem);
}
.switcher input {
  display: none;
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
  width: 50px;
}
.switcher input:checked ~ .switcher-slider::before {
  transform: translateX(19px);
}
.switcher input:checked + .switcher-slider {
  background-color: var(--purple6);
  border-color: var(--purple6);
}
.switcher input:checked + .switcher-slider::before {
  border-color: var(--purple6);
}
.switcher .switcher-slider {
  background-color: var(--black1);
  border: none;
  border-radius: 50em;
  font-size: 12px;
  position: relative;
  display: block;
  height: inherit;
  cursor: pointer;
  transition: 0.15s ease-out;
}
.switcher .switcher-slider:before {
  width: 20px;
  height: 20px;
  top: 2px;
  border-radius: 100%;
  position: absolute;
  left: 2px;
  box-sizing: border-box;
  content: "";
  background-color: var(--white);
  border: 1px solid var(--black1);
  transition: 0.15s ease-out;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
}
.switcher .switcher-slider span {
  border-radius: 50em;
  font-size: 12px;
  background-color: var(--black0);
  border: none;
  position: relative;
  display: block;
  height: inherit;
  cursor: pointer;
  transition: 0.15s ease-out;
}

.paylixecommerce-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 1px solid var(--black2);
  box-shadow: inset 0 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 0.5rem;
  background: var(--white);
  width: 100%;
  padding: 0 14px;
  transition: border 0.3s ease !important;
  height: 40px;
  max-height: 40px;
  outline: none;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
}
.paylixecommerce-input.textarea {
  height: auto;
  max-height: none;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid var(--black2);
  box-shadow: inset 0 1px 2px rgba(16, 24, 40, 0.05);
  min-height: 80px;
}
.paylixecommerce-input.is-invalid {
  border: 1px solid var(--red6) !important;
}
.paylixecommerce-input.is-invalid:hover {
  border-color: var(--red6) !important;
}
.paylixecommerce-input.is-invalid:focus {
  border-color: var(--red6) !important;
}
.paylixecommerce-input:active {
  border-color: var(--purple6);
}
.paylixecommerce-input:focus {
  border-color: var(--purple6);
}
.paylixecommerce-input:hover {
  border-color: var(--purple6) !important;
}
.paylixecommerce-input::placeholder {
  color: var(--black3);
}
.paylixecommerce-input[disabled] {
  background: var(--black0);
  border-color: var(--black2);
}
.paylixecommerce-input[disabled]:focus {
  border-color: var(--black2);
}

.paylixecommerce-checkbox {
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid rgba(0, 0, 0, 0);
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
  cursor: pointer;
  font-weight: 500;
  margin-bottom: 1rem;
  margin-right: 1.5rem;
}
.paylixecommerce-checkbox input {
  box-sizing: border-box;
  padding: 0;
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.paylixecommerce-checkbox input:not(:disabled):active ~ label::before {
  color: #fff;
  background-color: var(--black0);
  border-color: var(--black3);
}
.paylixecommerce-checkbox input:focus ~ label::before {
  border-color: var(--purple6);
  box-shadow: 0 0 0 0.2rem rgba(97, 59, 234, 0.25);
}
.paylixecommerce-checkbox input:checked ~ label::before {
  color: #fff;
  border-color: var(--purple6);
  background-color: var(--purple6);
}
.paylixecommerce-checkbox input:checked ~ label {
  color: var(--black9);
}
.paylixecommerce-checkbox input:checked ~ label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) !important;
  border: 1px solid var(--purple6);
}
.paylixecommerce-checkbox label {
  position: relative;
  margin-bottom: 0;
  font-weight: 400;
}
.paylixecommerce-checkbox label:before {
  position: absolute;
  cursor: pointer;
  display: block;
  pointer-events: none;
  content: "";
  background-color: var(--white);
  top: 50%;
  transform: translateY(-50%);
  border-radius: 2px;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 18px;
  height: 18px;
  left: -1.75rem;
  border: 1px solid var(--black5) !important;
}
.paylixecommerce-checkbox label:after {
  top: 50%;
  cursor: pointer;
  transform: translateY(-50%);
  position: absolute;
  display: block;
  content: "";
  background: no-repeat 50%/50% 50%;
  width: 18px;
  height: 18px;
  left: -1.75rem;
  border-radius: 2px;
}

.is-invalid .react-mde textarea {
  border: 1px solid var(--red6) !important;
}
.is-invalid .react-mde textarea:focus {
  border-color: var(--red6) !important;
}

.react-mde {
  border: none;
  border-radius: 0.5rem;
}
.react-mde .grip {
  border-top: none;
  background: var(--black9);
}
.react-mde ul.mde-header-group {
  padding: 0 0.5rem;
  margin: 0.5rem 0;
}
.react-mde ul.mde-header-group li {
  display: flex !important;
  align-items: center;
}
.react-mde .mde-header {
  background: var(--white);
  border: 1px solid var(--black2);
  border-radius: 0.5rem 0.5rem 0 0;
  border-bottom: none;
}
.react-mde .mde-header svg path {
  fill: var(--black5);
}
.react-mde .mde-header i {
  color: var(--black5);
}
.react-mde .mde-header .mde-tabs button {
  border: none;
  text-align: center;
  margin: 0.5rem;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 0 1rem;
  text-align: center;
  font-family: "Inter" !important;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  line-height: 18px;
  box-sizing: border-box;
  user-select: none;
  border: none;
  color: var(--white);
  background-color: var(--black9);
  font-weight: 600;
  height: 1.75rem;
  font-size: 0.813rem;
}
.react-mde .mde-header .mde-tabs button.selected {
  display: none;
}
.react-mde .mde-textarea-wrapper textarea.mde-text {
  padding: 1rem !important;
  border: 1px solid var(--black2);
  border-radius: 0 0 0.5rem 0.5rem;
  box-shadow: inset 0px 1px 2px rgba(16, 24, 40, 0.05);
  height: 100px;
  font-size: 14px;
  background: var(--white);
  color: var(--black9) !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.react-mde .mde-textarea-wrapper textarea.mde-text:focus {
  outline: none;
  border-color: var(--purple6);
}

.invalid-feedback {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: var(--red6);
}

.paylixecommerce-text, div.mde-preview div.mde-preview-content {
  color: var(--black6);
}
.paylixecommerce-text h1, .paylixecommerce-text .h1, div.mde-preview div.mde-preview-content h1, div.mde-preview div.mde-preview-content .h1 {
  font-size: 1.6rem;
  line-height: 3rem;
}
.paylixecommerce-text h2, .paylixecommerce-text .h2, div.mde-preview div.mde-preview-content h2, div.mde-preview div.mde-preview-content .h2 {
  font-size: 1.4rem;
  line-height: 2.5rem;
}
.paylixecommerce-text h3, .paylixecommerce-text .h3, div.mde-preview div.mde-preview-content h3, div.mde-preview div.mde-preview-content .h3 {
  font-size: 1.3rem;
  line-height: 2.4rem;
}
.paylixecommerce-text h4, .paylixecommerce-text .h4, div.mde-preview div.mde-preview-content h4, div.mde-preview div.mde-preview-content .h4 {
  font-size: 1.1rem;
  line-height: 2rem;
}
.paylixecommerce-text h6, .paylixecommerce-text .h6, div.mde-preview div.mde-preview-content h6, div.mde-preview div.mde-preview-content .h6 {
  font-weight: 500;
}
.paylixecommerce-text p, div.mde-preview div.mde-preview-content p {
  font-size: 0.9rem;
  margin: 0;
  line-height: 1.2rem;
  margin-bottom: 0.6rem;
  color: var(--black9);
}
.paylixecommerce-text input[type=checkbox], div.mde-preview div.mde-preview-content input[type=checkbox] {
  width: 30px;
  height: 20px;
  cursor: pointer;
  font-size: 21px;
  visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem -2rem;
  transform: scale(1.25);
}
.paylixecommerce-text input[type=checkbox]:after, div.mde-preview div.mde-preview-content input[type=checkbox]:after {
  content: " ";
  background-color: #fff;
  display: inline-block;
  margin-left: 10px;
  padding-bottom: 5px;
  color: #221d3e;
  width: 17px;
  height: 17px;
  visibility: visible;
  border: 2px solid #181432;
  padding-left: 3px;
  border-radius: 2px;
}
.paylixecommerce-text input[type=checkbox]:checked:after, div.mde-preview div.mde-preview-content input[type=checkbox]:checked:after {
  content: "x";
  font-weight: bold;
  font-size: 0.8rem;
  color: #181432;
  position: relative;
  padding-bottom: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: left;
  cursor: pointer;
}
.paylixecommerce-text pre, div.mde-preview div.mde-preview-content pre {
  padding: 1rem;
  border-radius: 2px;
  margin-top: 1rem;
  overflow: auto;
  display: block;
  line-height: 1rem;
}
.paylixecommerce-text ul, .paylixecommerce-text ol, div.mde-preview div.mde-preview-content ul, div.mde-preview div.mde-preview-content ol {
  line-height: 1.5rem;
  padding-left: 1.5rem;
}
.paylixecommerce-text ol, div.mde-preview div.mde-preview-content ol {
  list-style: auto;
  padding-top: 0.5rem;
}
.paylixecommerce-text img, div.mde-preview div.mde-preview-content img {
  max-width: 100%;
  border-radius: 0.5rem;
}

.dark .edit-modal .info-table {
  background: var(--white);
  border: 1px solid var(--black2);
}
.dark .edit-modal .info-table .info-table-header {
  background: var(--black1);
}
.dark .edit-modal .info-table .info-table-body > div:not(.paylixecommerce-table-container) {
  border-color: var(--black2);
}
.dark .edit-modal .info-table.table .info-table-header {
  background: var(--black1);
  border-bottom-color: var(--black0);
}
.dark .edit-modal .info-table.table .info-table-header .screen-search input {
  background: var(--black0);
}
.dark .edit-modal .info-table.table .info-table-body {
  background-color: var(--black1);
  border-radius: 0 0 0.5rem 0.5rem;
}
.dark .info-table {
  background: var(--white);
  border-color: transparent;
}
.dark .info-table .info-table-header {
  background: var(--black1);
}
.dark .info-table .info-table-body > div:not(.paylixecommerce-table-container) {
  border-color: var(--black1);
}
.dark .info-table.table .info-table-header {
  background: var(--black1);
  border-bottom-color: var(--black0);
}
.dark .info-table.table .info-table-header .screen-search input {
  background: var(--black0);
}
.dark .info-table.table .info-table-body {
  background-color: var(--black1);
  border-radius: 0 0 0.5rem 0.5rem;
}

.info-table {
  display: flex !important;
  flex-direction: column;
  width: 100%;
  background: var(--white);
  border-radius: 0.5rem;
  border: 1px solid var(--black1);
  margin-bottom: 1rem;
  margin-top: 0;
}
.info-table.table .paylixecommerce-table-container {
  padding: 0;
  box-shadow: none;
}
.info-table.table .paylixecommerce-table-container .paylixecommerce-table {
  padding: 0;
  box-shadow: none;
}
.info-table.table .paylixecommerce-table-container .paylixecommerce-table table thead th {
  padding: 0.5rem 0.75rem;
}
.info-table.table .paylixecommerce-table-container .paylixecommerce-table table tbody tr td {
  border-top-color: var(--black1) !important;
}
.info-table.table .paylixecommerce-table-container .paylixecommerce-table-container {
  padding: 0;
}
.info-table.with-shadow {
  box-shadow: 0px 1px 3px rgba(7, 14, 35, 0.06), 0px 2px 8px -1px rgba(7, 14, 35, 0.05);
  border: none;
}
.info-table.collapsed .info-table-header {
  border-bottom: none;
  border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
}
.info-table-header {
  padding: 1.25rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: var(--black9);
  cursor: pointer;
  border-radius: 0.5rem 0.5rem 0 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--black1);
}
.info-table-body > div:not(.paylixecommerce-table-container) {
  display: flex;
  width: 100%;
  border-top: 1px solid var(--black1);
  padding: 1rem 1.25rem;
  justify-content: space-between;
  color: var(--black4);
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  border-radius: 0 0 0.5rem 0.5rem;
}
.info-table-body > div:not(.paylixecommerce-table-container):first-child {
  border-top: none;
}
.info-table-body > div:not(.paylixecommerce-table-container) span:first-child {
  width: 30%;
}
.info-table-body > div:not(.paylixecommerce-table-container) span:last-child {
  width: 70%;
  text-align: right;
  color: var(--black9);
  word-break: break-word;
}

@media (max-width: 768px) {
  .info-table.table .paylixecommerce-table-container .paylixecommerce-table table thead th {
    padding: 0.5rem 0.75rem;
  }
  .info-table-header {
    padding: 1rem;
  }
  .info-table-body > div:not(.paylixecommerce-table-container) {
    padding: 0.75rem 1rem;
  }
}
.is-invalid-select > div:first-of-type {
  border: 1px solid var(--red6) !important;
}
.is-invalid-select > div:first-of-type:hover {
  border-color: var(--red6) !important;
}
.is-invalid-select > div:first-of-type:focus {
  border-color: var(--red6) !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.flex-column {
  flex-direction: column !important;
}

.d-none {
  display: none !important;
}

.d-flex {
  display: flex !important;
}

.gap-1 {
  gap: 0.25rem;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-3 {
  gap: 0.75rem;
}

.gap-4 {
  gap: 1rem;
}

.gap-5 {
  gap: 1.25rem;
}

.gap-6 {
  gap: 1.5rem;
}

.d-inline {
  display: inline-flex !important;
}

.align-items-center {
  align-items: center !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.p-1 {
  padding: 0.25rem;
}

.p-2 {
  padding: 0.5rem;
}

.p-3 {
  padding: 1rem;
}

.p-4 {
  padding: 1.5rem;
}

.p-5 {
  padding: 1.5rem;
}

.p-0 {
  padding: 0;
}

.m-1 {
  margin: 0.25rem;
}

.m-2 {
  margin: 0.5rem;
}

.m-3 {
  margin: 1rem;
}

.m-4 {
  margin: 1.5rem;
}

.m-5 {
  margin: 1.5rem;
}

.m-0 {
  margin: 0;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.m-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.mr-0 {
  margin-right: 0 !important;
}

.mr-1 {
  margin-right: 0.25rem !important;
}

.mr-2 {
  margin-right: 0.5rem !important;
}

.mr-3 {
  margin-right: 1rem !important;
}

.mr-4 {
  margin-right: 1.5rem !important;
}

.mr-5 {
  margin-right: 3rem !important;
}

.ml-0 {
  margin-left: 0 !important;
}

.ml-1 {
  margin-left: 0.25rem !important;
}

.ml-2 {
  margin-left: 0.5rem !important;
}

.ml-3 {
  margin-left: 1rem !important;
}

.ml-4 {
  margin-left: 1.5rem !important;
}

.ml-5 {
  margin-left: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ml-auto {
  margin-left: auto;
}

.mr-auto {
  margin-right: auto;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pr-0 {
  padding-right: 0 !important;
}

.pr-1 {
  padding-right: 0.25rem !important;
}

.pr-2 {
  padding-right: 0.5rem !important;
}

.pr-3 {
  padding-right: 1rem !important;
}

.pr-4 {
  padding-right: 1.5rem !important;
}

.pr-5 {
  padding-right: 3rem !important;
}

.pl-0 {
  padding-left: 0 !important;
}

.pl-1 {
  padding-left: 0.25rem !important;
}

.pl-2 {
  padding-left: 0.5rem !important;
}

.pl-3 {
  padding-left: 1rem !important;
}

.pl-4 {
  padding-left: 1.5rem !important;
}

.pl-5 {
  padding-left: 3rem !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.d-none {
  display: none !important;
}

.d-flex {
  display: flex !important;
}

.gap-1 {
  gap: 0.25rem;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-3 {
  gap: 0.75rem;
}

.gap-4 {
  gap: 1rem;
}

.gap-5 {
  gap: 1.25rem;
}

.gap-6 {
  gap: 1.5rem;
}

.d-inline {
  display: inline-flex !important;
}

h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h3, .h3 {
  font-size: 1.75rem;
}

h6, .h6 {
  font-size: 1rem;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid var(--black1);
}

small, .small {
  font-size: 80%;
  font-weight: 400;
}

a {
  color: #6a3ce2;
  text-decoration: none;
  background-color: rgba(0, 0, 0, 0);
}
a:hover {
  text-decoration: none;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

html {
  --black9: #121417;
  --black8: #1B1F23;
  --black7: #262A30;
  --black6: #454C56;
  --black5: #555D67;
  --black4: #777F89;
  --black3: #A2AAB4;
  --black2: #DFE5E9;
  --black1: #E8EDF0;
  --black0: #F5F7F8;
  --white: white;
  --black: #121417;
  --purple9: #43248E;
  --purple8: #5129AE;
  --purple7: #6132cf;
  --purple6: #6a3ce2;
  --purple5: #8164ee;
  --purple4: #a191f4;
  --purple3: #c0b9f9;
  --purple2: #dbd8fc;
  --purple1: #eceafd;
  --purple0: #f4f4fe;
  --red9: #381E1D;
  --red8: #60211F;
  --red7: #A53E3E;
  --red6: #D24242;
  --red5: #E85757;
  --red4: #f87171;
  --red3: #fca5a5;
  --red2: #fecaca;
  --red1: #fee2e2;
  --red0: #fef2f2;
  --orange9: #35241E;
  --orange8: #753621;
  --orange7: #BC542A;
  --orange6: #E16727;
  --orange5: #F17C2A;
  --orange4: #F69546;
  --orange3: #FCB871;
  --orange2: #fed7aa;
  --orange1: #F9ECDB;
  --orange0: #fff7ed;
  --green9: #143120;
  --green8: #166534;
  --green7: #15803d;
  --green6: #239F51;
  --green5: #35C068;
  --green4: #66DB91;
  --green3: #8CEDAF;
  --green2: #bbf7d0;
  --green1: #E3F5E9;
  --green0: #f0fdf4;
  --pink9: #701338;
  --pink8: #9D174D;
  --pink7: #BE185D;
  --pink6: #DB2777;
  --pink5: #EC4899;
  --pink4: #F472B6;
  --pink3: #F9A8D4;
  --pink2: #FBCFE8;
  --pink1: #FCE7F3;
  --pink0: #FDF2F8;
  --blue9: #1E3A8A;
  --blue8: #1E40AF;
  --blue7: #1D4ED8;
  --blue6: #2563EB;
  --blue5: #3B82F6;
  --blue4: #60A5FA;
  --blue3: #93C5FD;
  --blue2: #BFDBFE;
  --blue1: #DBEAFE;
  --blue0: #EFF6FF;
  --cyan9: #164E63;
  --cyan8: #155E75;
  --cyan7: #0E7490;
  --cyan6: #0891B2;
  --cyan5: #06B6D4;
  --cyan4: #22D3EE;
  --cyan3: #67E8F9;
  --cyan2: #A5F3FC;
  --cyan1: #D4F6F9;
  --cyan0: #EEF7F8;
}

.black9 {
  color: #121417;
  --black9: #121417;
}

.black8 {
  color: #1B1F23;
  --black8: #1B1F23;
}

.black7 {
  color: #32373E;
  --black7: #32373E;
}

.black6 {
  color: #454C56;
  --black6: #454C56;
}

.black5 {
  color: #555D67;
  --black5: #555D67;
}

.black4 {
  color: #777F89;
  --black4: #777F89;
}

.black3 {
  color: #A2AAB4;
  --black3: #A2AAB4;
}

.black2 {
  color: #CBD2D8;
  --black2: #CBD2D8;
}

.black1 {
  color: #E8EDF0;
  --black1: #E8EDF0;
}

.black0 {
  color: #F5F7F8;
  --black0: #F5F7F8;
}

.white {
  color: white;
  --white: #000000;
}

.purple9 {
  color: #43248E;
  --purple9: #43248E;
}

.purple8 {
  color: #5129AE;
  --purple8: #5129AE;
}

.purple7 {
  color: #6132cf;
  --purple7: #6132cf;
}

.purple6 {
  color: #6a3ce2;
  --purple6: #6a3ce2;
}

.purple5 {
  color: #8164ee;
  --purple5: #8164ee;
}

.purple4 {
  color: #a191f4;
  --purple4: #a191f4;
}

.purple3 {
  color: #c0b9f9;
  --purple3: #c0b9f9;
}

.purple2 {
  color: #dbd8fc;
  --purple2: #dbd8fc;
}

.purple1 {
  color: #eceafd;
  --purple1: #eceafd;
}

.purple0 {
  color: #f4f4fe;
  --purple0: #f4f4fe;
}

.red9 {
  color: #7f1d1d;
  --red9: #7f1d1d;
}

.red8 {
  color: #991b1b;
  --red8: #991b1b;
}

.red7 {
  color: #b91c1c;
  --red7: #b91c1c;
}

.red6 {
  color: #dc2626;
  --red6: #dc2626;
}

.red5 {
  color: #ef4444;
  --red5: #ef4444;
}

.red4 {
  color: #f87171;
  --red4: #f87171;
}

.red3 {
  color: #fca5a5;
  --red3: #fca5a5;
}

.red2 {
  color: #fecaca;
  --red2: #fecaca;
}

.red1 {
  color: #fee2e2;
  --red1: #fee2e2;
}

.red0 {
  color: #fef2f2;
  --red0: #fef2f2;
}

.orange9 {
  color: #7c2d12;
  --orange9: #7c2d12;
}

.orange8 {
  color: #9a3412;
  --orange8: #9a3412;
}

.orange7 {
  color: #c2410c;
  --orange7: #c2410c;
}

.orange6 {
  color: #ea580c;
  --orange6: #ea580c;
}

.orange5 {
  color: #f97316;
  --orange5: #f97316;
}

.orange4 {
  color: #fb923c;
  --orange4: #fb923c;
}

.orange3 {
  color: #fdba74;
  --orange3: #fdba74;
}

.orange2 {
  color: #fed7aa;
  --orange2: #fed7aa;
}

.orange1 {
  color: #ffedd5;
  --orange1: #ffedd5;
}

.orange0 {
  color: #fff7ed;
  --orange0: #fff7ed;
}

.green9 {
  color: #0B321B;
  --green9: #0B321B;
}

.green8 {
  color: #166534;
  --green8: #166534;
}

.green7 {
  color: #15803d;
  --green7: #15803d;
}

.green6 {
  color: #16a34a;
  --green6: #16a34a;
}

.green5 {
  color: #22c55e;
  --green5: #22c55e;
}

.green4 {
  color: #4ade80;
  --green4: #4ade80;
}

.green3 {
  color: #86efac;
  --green3: #86efac;
}

.green2 {
  color: #bbf7d0;
  --green2: #bbf7d0;
}

.green1 {
  color: #dcfce7;
  --green1: #dcfce7;
}

.green0 {
  color: #f0fdf4;
  --green0: #f0fdf4;
}

.font {
  font-family: "Inter";
  font-style: normal;
  color: var(--black9);
}

.font-normal {
  font-weight: 500;
  --font-normal: 500;
}

.font-thin {
  font-weight: 400;
  --font-thin: 400;
}

.font-size-7 {
  font-size: 40px;
  line-height: 48px;
}

.font-size-6 {
  font-size: 32px;
  line-height: 39px;
}

.font-size-5 {
  font-size: 24px;
  line-height: 29px;
}

.font-size-4 {
  font-size: 18px;
  line-height: 22px;
}

.font-size-3 {
  font-size: 16px;
  line-height: 19px;
}

.font-size-2 {
  font-size: 14px;
  line-height: 17px;
}

.font-size-1 {
  font-size: 13px;
  line-height: 16px;
}

.font-size-0 {
  font-size: 12px;
  line-height: 15px;
}

html {
  width: 100vw;
  overflow-x: hidden;
  background-color: white;
  margin-left: 0;
}
html body {
  min-width: 100vw;
  max-width: 100vw;
  overflow-x: hidden;
  font-family: "Inter", sans-serif !important;
  transition: background 0.9s;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  background-color: white !important;
}
html body button.large {
  height: 2.5rem;
}
html body a:hover {
  transition: color 0.3s ease;
  color: var(--purple9);
}

.main {
  transition: margin-left 0.3s ease;
  margin-left: 240px;
}
.main .container {
  max-width: 1280px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

#app > div:not(.Toastify) {
  height: 100%;
  display: flex;
  flex-direction: column;
}

#app > div .auth-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 0 auto;
  background: var(--black0);
  padding: 5rem 0 4rem 0;
  overflow: auto;
  flex-direction: column;
}
#app > div footer {
  flex-shrink: 0;
}

a {
  color: var(--purple6);
}

html *, html :before, html :after {
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
  border-color: transparent;
}
html img, html svg {
  display: inline;
}
html .table {
  display: initial;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/auth/app.scss","webpack://./client/assets/scss/bootstrap.scss","webpack://./client/assets/scss/_root.scss","webpack://./client/assets/scss/_reboot.scss","webpack://./client/assets/scss/_variables.scss","webpack://./client/assets/scss/_type.scss","webpack://./client/assets/scss/_buttons.scss","webpack://./client/assets/scss/_transitions.scss","webpack://./client/assets/scss/_button-group.scss","webpack://./client/assets/scss/_pagination.scss","webpack://./client/assets/scss/_spinners.scss","webpack://./client/assets/fontawesome/scss/fontawesome.scss","webpack://./client/assets/fontawesome/scss/_core.scss","webpack://./client/assets/fontawesome/scss/_sizing.scss","webpack://./client/assets/fontawesome/scss/_mixins.scss","webpack://./client/assets/fontawesome/scss/_fixed-width.scss","webpack://./client/assets/fontawesome/scss/_variables.scss","webpack://./client/assets/fontawesome/scss/_list.scss","webpack://./client/assets/fontawesome/scss/_bordered-pulled.scss","webpack://./client/assets/fontawesome/scss/_animated.scss","webpack://./client/assets/fontawesome/scss/_rotated-flipped.scss","webpack://./client/assets/fontawesome/scss/_stacked.scss","webpack://./client/assets/fontawesome/scss/_icons.scss","webpack://./client/assets/fontawesome/scss/_screen-reader.scss","webpack://./client/assets/fontawesome/scss/brands.scss","webpack://./client/assets/fontawesome/scss/solid.scss","webpack://./client/assets/fontawesome/scss/light.scss","webpack://./client/assets/fontawesome/scss/regular.scss","webpack://./client/assets/fontawesome/scss/thin.scss","webpack://./client/assets/NEW/_font.scss","webpack://./client/assets/NEW/_basic.scss","webpack://./client/assets/NEW/_screen.scss","webpack://./client/assets/NEW/_fields.scss","webpack://./client/assets/NEW/_sizing.scss","webpack://./client/entrypoints/dashboard/styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;EAAA;ACAA;EAGI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAKF,qNAAA;EACA,yGAAA;EACA,yFAAA;AFmBF;;AGlBA;;;EAGE,sBAAA;AHqBF;;AGRI;EAJJ;IAKM,uBAAA;EHYJ;AACF;;AGAA;EACE,SAAA;EACA,sCCgX4B;ED/W5B,gBC2X4B;ED1X5B,gBCkY4B;EDjY5B,cCjCS;EDmCT,sBC5CS;ED6CT,8BAAA;EACA,6CAAA;AHEF;;AGOA;EACE,cAAA;EACA,cCkb4B;EDjb5B,8BAAA;EACA,SAAA;EACA,aCib4B;AJrb9B;;AGOA;EACE,WC0R4B;AJ9R9B;;AGcA;EACE,aAAA;EACA,qBCuX4B;EDpX5B,gBCuX4B;EDtX5B,gBCuX4B;AJpY9B;;AG+CA;EACE,aAAA;EACA,mBCgL0B;AJ5N5B;;AGuDA;;EAEE,iCAAA;EACA,YAAA;EACA,8BAAA;AHpDF;;AG0DA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AHvDF;;AG6DA;;EAEE,kBAAA;AH1DF;;AG6DA;;;EAGE,aAAA;EACA,mBAAA;AH1DF;;AG6DA;;;;EAIE,gBAAA;AH1DF;;AG6DA;EACE,gBCgQ4B;AJ1T9B;;AG+DA;EACE,qBAAA;EACA,cAAA;AH5DF;;AGkEA;EACE,gBAAA;AH/DF;;AGuEA;;EAEE,mBCyO4B;AJ7S9B;;AGmFA;EACE,cCqS4B;EDpS5B,yBC4S4B;AJ5X9B;;AGyFA;;EAEE,kBAAA;EACA,cAAA;EACA,wBAAA;AHtFF;;AGyFA;EAAM,eAAA;AHrFN;;AGsFA;EAAM,WAAA;AHlFN;;AGuFA;EACE,cCxMQ;EDyMR,0BCiDwC;AJrI1C;AGsFE;EACE,cCgDsC;AJpI1C;;AG+FE;EAEE,cAAA;EACA,qBAAA;AH7FJ;;AGoGA;;;;EAIE,qCCqJ4B;EDpJ5B,+BAAA;EACA,2BAAA;AHjGF;;AGwGA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AHrGF;AGyGE;EACE,cAAA;EACA,kBAAA;AHvGJ;;AG2GA;EACE,cC1PQ;ED2PR,qBAAA;AHxGF;AG2GE;EACE,cAAA;AHzGJ;;AGkHA;EACE,gBAAA;AH/GF;;AGqHA;;EAEE,sBAAA;AHlHF;;AG0HA;EACE,oBAAA;EACA,yBAAA;AHvHF;;AG0HA;EACE,mBCoM4B;EDnM5B,sBCmM4B;EDlM5B,cC5TS;ED6TT,gBAAA;AHvHF;;AG8HA;EAEE,mBAAA;EACA,gCAAA;AH5HF;;AG+HA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AH5HF;;AGoIA;EACE,qBAAA;AHjIF;;AGuIA;EAEE,gBAAA;AHrIF;;AG6IA;EACE,UAAA;AH1IF;;AG+IA;;;;;EAKE,SAAA;EACA,oBAAA;EACA,oBAAA;AH5IF;;AGgJA;;EAEE,oBAAA;AH7IF;;AGkJA;EACE,eAAA;AH/IF;;AGkJA;EAGE,iBAAA;AHjJF;AGoJE;EACE,UAAA;AHlJJ;;AGyJA;EACE,aAAA;AHtJF;;AG8JA;;;;EAIE,0BAAA;AH3JF;AG8JI;;;;EACE,eAAA;AHzJN;;AGgKA;EACE,UAAA;EACA,kBAAA;AH7JF;;AGkKA;EACE,gBAAA;AH/JF;;AGyKA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AHtKF;;AG8KA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBC0B4B;EDxB5B,oBAAA;AH5KF;AG8KE;EACE,WAAA;AH5KJ;;AGmLA;;;;;;;EAOE,UAAA;AHhLF;;AGmLA;EACE,YAAA;AHhLF;;AGyLA;EACE,oBAAA;EACA,6BAAA;AHtLF;;AG8LA;;;;;;;CAAA;AAWA;EACE,wBAAA;AH9LF;;AGmMA;EACE,UAAA;AHhMF;;AGsMA;EACE,aAAA;AHnMF;;AGyMA;EACE,aAAA;EACA,0BAAA;AHtMF;;AG2MA;EACE,qBAAA;AHxMF;;AG6MA;EACE,SAAA;AH1MF;;AGiNA;EACE,kBAAA;EACA,eAAA;AH9MF;;AGsNA;EACE,wBAAA;AHnNF;;AG2NA;EACE,wBAAA;AHxNF;;AK3VA;EACE,gBDsc4B;AJxG9B;;AKzVE;EACE,gBD0bkB;ECzblB,gBD2a0B;AJ/E9B;;AK9VE;EACE,gBD0bkB;ECzblB,gBD2a0B;AJ1E9B;;AKnWE;EACE,gBD0bkB;ECzblB,gBD2a0B;AJrE9B;;AKxWE;EACE,gBD0bkB;ECzblB,gBD2a0B;AJhE9B;;AK7WE;EACE,gBD0bkB;ECzblB,gBD2a0B;AJ3D9B;;AKlXE;EACE,gBD0bkB;ECzblB,gBD2a0B;AJtD9B;;AKrWA;EACE,yBAAA;ALwWF;;AKpWA;EACE,mBD+LO;AJwKT;AKrWE;EACE,gBAAA;ALuWJ;;AKnWA;EACE,iBAAA;EACA,mBDsLO;ECrLP,cDtDS;AJ4ZX;AKpWE;EACE,aAAA;ALsWJ;;AMzaA;EACE,qBAAA;EAEA,gBFoa4B;EEna5B,gBF2a4B;EE1a5B,cFQS;EEPT,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;AN0aF;AMxaE;EACE,cFHO;AJ6aX;AMtaE;EAEE,UAAA;EACA,kDFojB4B;AJ7IhC;AM7ZE;EAGE,oBAAA;EACA,aF8kB0B;AJjL9B;;AM/YA;EACE,gBFmX4B;EElX5B,cFnBQ;EEoBR,0BFsOwC;AJ4K1C;AMhZE;EACE,cFqOsC;AJ6K1C;AM1YE;EAEE,cFzDO;AJocX;;AOjdE;EACE,UAAA;APodJ;;AO/cE;EACE,aAAA;APkdJ;;AO9cA;EACE,SAAA;EACA,gBAAA;APidF;;AQ9dA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ARieF;AQ/dE;;EACE,kBAAA;EACA,cAAA;ARkeJ;AQ7dE;;;;;;;;;;;;EAME,UAAA;ARqeJ;;AQheA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ARmeF;AQjeE;EACE,WAAA;ARmeJ;;AQ7dE;;EAEE,iBAAA;ARgeJ;;AQhdA;EACE,wBAAA;EACA,uBAAA;ARmdF;AQjdE;EAGE,cAAA;ARidJ;AQ9cE;EACE,eAAA;ARgdJ;;AQ5cA;EACE,uBAAA;EACA,sBAAA;AR+cF;;AQ5cA;EACE,sBAAA;EACA,qBAAA;AR+cF;;AQvcA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AR0cF;AQxcE;;EAEE,WAAA;AR0cJ;AQvcE;;EAEE,gBAAA;ARycJ;;AS1iBA;EACE,aAAA;AT6iBF;;AS1iBA;EACE,kBAAA;EACA,cAAA;EACA,cL+BQ;EK9BR,qBAAA;EACA,sBLDS;EKET,yBAAA;AT6iBF;AS3iBE;EACE,UAAA;EACA,cLoRsC;EKlRtC,yBLNO;EKOP,qBLNO;AJkjBX;ASziBE;EACE,UAAA;EACA,cL4QsC;EK3QtC,yBLbO;EKcP,ULqgCgC;EKpgChC,kDLsjB4B;AJXhC;;AStiBE;EACE,iBLw/BgC;AJ/cpC;AStiBE;EACE,UAAA;EACA,WL5BO;EK6BP,qBLCM;AJuiBV;ASriBE;EACE,cL3BO;EK4BP,oBAAA;EACA,sBLnCO;EKoCP,qBLjCO;AJwkBX;;AU9kBA;EACE;IAAK,0CAAA;EVklBL;AACF;AU/kBA;EACE,qBAAA;EACA,WNqxCwB;EMpxCxB,YNoxCwB;EMnxCxB,wBNqxCwB;EMpxCxB,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;AVglBF;;AU7kBA;EACE,WNgxCwB;EM/wCxB,YN+wCwB;EM9wCxB,mBNgxCwB;AJhsB1B;;AUxkBA;EACE;IACE,mBAAA;EV2kBF;EUzkBA;IACE,UAAA;IACA,eAAA;EV2kBF;AACF;AUvkBA;EACE,qBAAA;EACA,WNmvCwB;EMlvCxB,YNkvCwB;EMjvCxB,wBNmvCwB;EMlvCxB,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;AVwkBF;;AUrkBA;EACE,WN8uCwB;EM7uCxB,YN6uCwB;AJrqB1B;;AUpkBE;EACE;;IAEE,wBAAA;EVukBJ;AACF;AWzoBA;;;EAAA;ACGA;EACE,yDAAA;EACA,iCAAA;AZ4oBF;;AYzoBA;;;;;;;;;;;;;EAaE,kCAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;AZ4oBF;;AalqBE;EACE,cAAA;AbqqBJ;;AatqBE;EACE,cAAA;AbyqBJ;;Aa1qBE;EACE,cAAA;Ab6qBJ;;Aa9qBE;EACE,cAAA;AbirBJ;;AalrBE;EACE,cAAA;AbqrBJ;;AatrBE;EACE,cAAA;AbyrBJ;;Aa1rBE;EACE,cAAA;Ab6rBJ;;Aa9rBE;EACE,cAAA;AbisBJ;;AalsBE;EACE,cAAA;AbqsBJ;;AatsBE;EACE,eAAA;AbysBJ;;AansBE;ECIA,kBAAA;EACA,kBAAA;EACA,uBAAA;AdmsBF;;AazsBE;ECIA,iBAAA;EACA,2BAAA;EACA,uBAAA;AdysBF;;Aa/sBE;ECIA,kBAAA;EACA,2BAAA;EACA,8BAAA;Ad+sBF;;AartBE;ECIA,iBAAA;EACA,mBAAA;EACA,wBAAA;AdqtBF;;Aa3tBE;ECIA,gBAAA;EACA,2BAAA;EACA,wBAAA;Ad2tBF;;AajuBE;ECIA,cAAA;EACA,sBAAA;EACA,yBAAA;AdiuBF;;AehvBA;EACE,kBAAA;EACA,aCIwB;AhB+uB1B;;AiBrvBA;EACE,qBAAA;EACA,uCAAA;EACA,eAAA;AjBwvBF;AiBtvBE;EAAO,kBAAA;AjByvBT;;AiBtvBA;EACE,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,oBAAA;AjByvBF;;AkBtwBA;EACE,0CAAA;EACA,6CAAA;EACA,2CAAA;EACA,4CAAA;EACA,sDAAA;AlBywBF;;AkBtwBA;EACE,WAAA;EACA,0CAAA;AlBywBF;;AkBtwBA;EACE,YAAA;EACA,yCAAA;AlBywBF;;AmBxxBA;EACE,uBAAA;EACA,6CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,kEAAA;AnB2xBF;;AmBxxBA;EACE,uBAAA;EACA,6CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,mFAAA;AnB2xBF;;AmBxxBA;EACE,wBAAA;EACA,6CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,mFAAA;AnB2xBF;;AmBxxBA;EACE,uBAAA;EACA,6CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,kEAAA;AnB2xBF;;AmBxxBA;EACE,uBAAA;EACA,6CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,6DAAA;AnB2xBF;;AmBxxBA;EACE,iCAAA;AnB2xBF;;AmBxxBA;;EAEE,uBAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,+DAAA;AnB2xBF;;AmBrxBA;EACE;;;;;;;IAOE,qBAAA;IACA,uBAAA;IACA,4BAAA;IACA,oBAAA;IACA,uBAAA;EnBwxBF;AACF;AmBrxBA;EACE;IAAU,mBAAA;EnBwxBV;EmBvxBA;IAAM,4CAAA;EnB0xBN;AACF;AmBxxBA;EACE;IAAM,oCAAA;EnB2xBN;AACF;AmBzxBA;EACE;IACE,qCAAA;IACA,mBAAA;EnB2xBF;EmBzxBA;IACE,UAAA;IACA,8CAAA;EnB2xBF;AACF;AmBxxBA;EACE;IACE,iHAAA;EnB0xBF;AACF;AmBvxBA;EACE;IAAK,uBAAA;EnB0xBL;EmBzxBA;IAAO,yBAAA;EnB4xBP;AACF;AoBt4BA;EACE,wBAAA;ApBw4BF;;AoBr4BA;EACE,yBAAA;ApBw4BF;;AoBr4BA;EACE,yBAAA;ApBw4BF;;AoBr4BA;EACE,uBAAA;ApBw4BF;;AoBr4BA;EACE,uBAAA;ApBw4BF;;AoBr4BA;;EAEE,wBAAA;ApBw4BF;;AoBr4BA;EACE,+CAAA;ApBw4BF;;AqBl6BA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBLmCwB;EKlCxB,YLmCwB;AhBk4B1B;;AqBl6BA;;EAEE,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,sCAAA;ArBq6BF;;AqBl6BA;EACE,oBAAA;ArBq6BF;;AqBl6BA;EACE,cAAA;ArBq6BF;;AqBl6BA;EACE,8BAAA;ArBq6BF;;AsBh8BA;gEAAA;AAIE;EAAsC,eAAA;AtBk8BxC;;AsBl8BE;EAAsC,eAAA;AtBs8BxC;;AsBt8BE;EAAsC,eAAA;AtB08BxC;;AsB18BE;EAAsC,eAAA;AtB88BxC;;AsB98BE;EAAsC,eAAA;AtBk9BxC;;AsBl9BE;EAAsC,eAAA;AtBs9BxC;;AsBt9BE;EAAsC,eAAA;AtB09BxC;;AsB19BE;EAAsC,eAAA;AtB89BxC;;AsB99BE;EAAsC,eAAA;AtBk+BxC;;AsBl+BE;EAAsC,eAAA;AtBs+BxC;;AsBt+BE;EAAsC,gBAAA;AtB0+BxC;;AsB1+BE;EAAsC,YAAA;AtB8+BxC;;AsB9+BE;EAAsC,gBAAA;AtBk/BxC;;AsBl/BE;EAAsC,aAAA;AtBs/BxC;;AsBt/BE;EAAsC,gBAAA;AtB0/BxC;;AsB1/BE;EAAsC,gBAAA;AtB8/BxC;;AsB9/BE;EAAsC,gBAAA;AtBkgCxC;;AsBlgCE;EAAsC,gBAAA;AtBsgCxC;;AsBtgCE;EAAsC,gBAAA;AtB0gCxC;;AsB1gCE;EAAsC,gBAAA;AtB8gCxC;;AsB9gCE;EAAsC,gBAAA;AtBkhCxC;;AsBlhCE;EAAsC,gBAAA;AtBshCxC;;AsBthCE;EAAsC,gBAAA;AtB0hCxC;;AsB1hCE;EAAsC,gBAAA;AtB8hCxC;;AsB9hCE;EAAsC,gBAAA;AtBkiCxC;;AsBliCE;EAAsC,gBAAA;AtBsiCxC;;AsBtiCE;EAAsC,gBAAA;AtB0iCxC;;AsB1iCE;EAAsC,gBAAA;AtB8iCxC;;AsB9iCE;EAAsC,gBAAA;AtBkjCxC;;AsBljCE;EAAsC,gBAAA;AtBsjCxC;;AsBtjCE;EAAsC,gBAAA;AtB0jCxC;;AsB1jCE;EAAsC,gBAAA;AtB8jCxC;;AsB9jCE;EAAsC,gBAAA;AtBkkCxC;;AsBlkCE;EAAsC,gBAAA;AtBskCxC;;AsBtkCE;EAAsC,gBAAA;AtB0kCxC;;AsB1kCE;EAAsC,gBAAA;AtB8kCxC;;AsB9kCE;EAAsC,gBAAA;AtBklCxC;;AsBllCE;EAAsC,gBAAA;AtBslCxC;;AsBtlCE;EAAsC,gBAAA;AtB0lCxC;;AsB1lCE;EAAsC,aAAA;AtB8lCxC;;AsB9lCE;EAAsC,gBAAA;AtBkmCxC;;AsBlmCE;EAAsC,gBAAA;AtBsmCxC;;AsBtmCE;EAAsC,gBAAA;AtB0mCxC;;AsB1mCE;EAAsC,gBAAA;AtB8mCxC;;AsB9mCE;EAAsC,gBAAA;AtBknCxC;;AsBlnCE;EAAsC,gBAAA;AtBsnCxC;;AsBtnCE;EAAsC,gBAAA;AtB0nCxC;;AsB1nCE;EAAsC,gBAAA;AtB8nCxC;;AsB9nCE;EAAsC,gBAAA;AtBkoCxC;;AsBloCE;EAAsC,gBAAA;AtBsoCxC;;AsBtoCE;EAAsC,gBAAA;AtB0oCxC;;AsB1oCE;EAAsC,gBAAA;AtB8oCxC;;AsB9oCE;EAAsC,gBAAA;AtBkpCxC;;AsBlpCE;EAAsC,gBAAA;AtBspCxC;;AsBtpCE;EAAsC,gBAAA;AtB0pCxC;;AsB1pCE;EAAsC,gBAAA;AtB8pCxC;;AsB9pCE;EAAsC,gBAAA;AtBkqCxC;;AsBlqCE;EAAsC,gBAAA;AtBsqCxC;;AsBtqCE;EAAsC,aAAA;AtB0qCxC;;AsB1qCE;EAAsC,gBAAA;AtB8qCxC;;AsB9qCE;EAAsC,gBAAA;AtBkrCxC;;AsBlrCE;EAAsC,gBAAA;AtBsrCxC;;AsBtrCE;EAAsC,gBAAA;AtB0rCxC;;AsB1rCE;EAAsC,gBAAA;AtB8rCxC;;AsB9rCE;EAAsC,gBAAA;AtBksCxC;;AsBlsCE;EAAsC,gBAAA;AtBssCxC;;AsBtsCE;EAAsC,gBAAA;AtB0sCxC;;AsB1sCE;EAAsC,gBAAA;AtB8sCxC;;AsB9sCE;EAAsC,gBAAA;AtBktCxC;;AsBltCE;EAAsC,gBAAA;AtBstCxC;;AsBttCE;EAAsC,gBAAA;AtB0tCxC;;AsB1tCE;EAAsC,gBAAA;AtB8tCxC;;AsB9tCE;EAAsC,gBAAA;AtBkuCxC;;AsBluCE;EAAsC,gBAAA;AtBsuCxC;;AsBtuCE;EAAsC,gBAAA;AtB0uCxC;;AsB1uCE;EAAsC,gBAAA;AtB8uCxC;;AsB9uCE;EAAsC,gBAAA;AtBkvCxC;;AsBlvCE;EAAsC,gBAAA;AtBsvCxC;;AsBtvCE;EAAsC,gBAAA;AtB0vCxC;;AsB1vCE;EAAsC,gBAAA;AtB8vCxC;;AsB9vCE;EAAsC,gBAAA;AtBkwCxC;;AsBlwCE;EAAsC,gBAAA;AtBswCxC;;AsBtwCE;EAAsC,gBAAA;AtB0wCxC;;AsB1wCE;EAAsC,gBAAA;AtB8wCxC;;AsB9wCE;EAAsC,gBAAA;AtBkxCxC;;AsBlxCE;EAAsC,gBAAA;AtBsxCxC;;AsBtxCE;EAAsC,gBAAA;AtB0xCxC;;AsB1xCE;EAAsC,gBAAA;AtB8xCxC;;AsB9xCE;EAAsC,gBAAA;AtBkyCxC;;AsBlyCE;EAAsC,gBAAA;AtBsyCxC;;AsBtyCE;EAAsC,gBAAA;AtB0yCxC;;AsB1yCE;EAAsC,gBAAA;AtB8yCxC;;AsB9yCE;EAAsC,gBAAA;AtBkzCxC;;AsBlzCE;EAAsC,gBAAA;AtBszCxC;;AsBtzCE;EAAsC,gBAAA;AtB0zCxC;;AsB1zCE;EAAsC,gBAAA;AtB8zCxC;;AsB9zCE;EAAsC,gBAAA;AtBk0CxC;;AsBl0CE;EAAsC,gBAAA;AtBs0CxC;;AsBt0CE;EAAsC,gBAAA;AtB00CxC;;AsB10CE;EAAsC,gBAAA;AtB80CxC;;AsB90CE;EAAsC,gBAAA;AtBk1CxC;;AsBl1CE;EAAsC,gBAAA;AtBs1CxC;;AsBt1CE;EAAsC,gBAAA;AtB01CxC;;AsB11CE;EAAsC,gBAAA;AtB81CxC;;AsB91CE;EAAsC,gBAAA;AtBk2CxC;;AsBl2CE;EAAsC,gBAAA;AtBs2CxC;;AsBt2CE;EAAsC,gBAAA;AtB02CxC;;AsB12CE;EAAsC,gBAAA;AtB82CxC;;AsB92CE;EAAsC,gBAAA;AtBk3CxC;;AsBl3CE;EAAsC,gBAAA;AtBs3CxC;;AsBt3CE;EAAsC,gBAAA;AtB03CxC;;AsB13CE;EAAsC,gBAAA;AtB83CxC;;AsB93CE;EAAsC,gBAAA;AtBk4CxC;;AsBl4CE;EAAsC,gBAAA;AtBs4CxC;;AsBt4CE;EAAsC,gBAAA;AtB04CxC;;AsB14CE;EAAsC,gBAAA;AtB84CxC;;AsB94CE;EAAsC,gBAAA;AtBk5CxC;;AsBl5CE;EAAsC,gBAAA;AtBs5CxC;;AsBt5CE;EAAsC,gBAAA;AtB05CxC;;AsB15CE;EAAsC,gBAAA;AtB85CxC;;AsB95CE;EAAsC,gBAAA;AtBk6CxC;;AsBl6CE;EAAsC,gBAAA;AtBs6CxC;;AsBt6CE;EAAsC,gBAAA;AtB06CxC;;AsB16CE;EAAsC,gBAAA;AtB86CxC;;AsB96CE;EAAsC,gBAAA;AtBk7CxC;;AsBl7CE;EAAsC,gBAAA;AtBs7CxC;;AsBt7CE;EAAsC,gBAAA;AtB07CxC;;AsB17CE;EAAsC,gBAAA;AtB87CxC;;AsB97CE;EAAsC,gBAAA;AtBk8CxC;;AsBl8CE;EAAsC,gBAAA;AtBs8CxC;;AsBt8CE;EAAsC,gBAAA;AtB08CxC;;AsB18CE;EAAsC,gBAAA;AtB88CxC;;AsB98CE;EAAsC,gBAAA;AtBk9CxC;;AsBl9CE;EAAsC,gBAAA;AtBs9CxC;;AsBt9CE;EAAsC,gBAAA;AtB09CxC;;AsB19CE;EAAsC,gBAAA;AtB89CxC;;AsB99CE;EAAsC,gBAAA;AtBk+CxC;;AsBl+CE;EAAsC,gBAAA;AtBs+CxC;;AsBt+CE;EAAsC,gBAAA;AtB0+CxC;;AsB1+CE;EAAsC,gBAAA;AtB8+CxC;;AsB9+CE;EAAsC,gBAAA;AtBk/CxC;;AsBl/CE;EAAsC,gBAAA;AtBs/CxC;;AsBt/CE;EAAsC,gBAAA;AtB0/CxC;;AsB1/CE;EAAsC,gBAAA;AtB8/CxC;;AsB9/CE;EAAsC,gBAAA;AtBkgDxC;;AsBlgDE;EAAsC,gBAAA;AtBsgDxC;;AsBtgDE;EAAsC,gBAAA;AtB0gDxC;;AsB1gDE;EAAsC,gBAAA;AtB8gDxC;;AsB9gDE;EAAsC,gBAAA;AtBkhDxC;;AsBlhDE;EAAsC,gBAAA;AtBshDxC;;AsBthDE;EAAsC,gBAAA;AtB0hDxC;;AsB1hDE;EAAsC,gBAAA;AtB8hDxC;;AsB9hDE;EAAsC,gBAAA;AtBkiDxC;;AsBliDE;EAAsC,gBAAA;AtBsiDxC;;AsBtiDE;EAAsC,gBAAA;AtB0iDxC;;AsB1iDE;EAAsC,gBAAA;AtB8iDxC;;AsB9iDE;EAAsC,gBAAA;AtBkjDxC;;AsBljDE;EAAsC,gBAAA;AtBsjDxC;;AsBtjDE;EAAsC,gBAAA;AtB0jDxC;;AsB1jDE;EAAsC,gBAAA;AtB8jDxC;;AsB9jDE;EAAsC,gBAAA;AtBkkDxC;;AsBlkDE;EAAsC,gBAAA;AtBskDxC;;AsBtkDE;EAAsC,gBAAA;AtB0kDxC;;AsB1kDE;EAAsC,gBAAA;AtB8kDxC;;AsB9kDE;EAAsC,gBAAA;AtBklDxC;;AsBllDE;EAAsC,gBAAA;AtBslDxC;;AsBtlDE;EAAsC,gBAAA;AtB0lDxC;;AsB1lDE;EAAsC,gBAAA;AtB8lDxC;;AsB9lDE;EAAsC,gBAAA;AtBkmDxC;;AsBlmDE;EAAsC,gBAAA;AtBsmDxC;;AsBtmDE;EAAsC,gBAAA;AtB0mDxC;;AsB1mDE;EAAsC,gBAAA;AtB8mDxC;;AsB9mDE;EAAsC,gBAAA;AtBknDxC;;AsBlnDE;EAAsC,gBAAA;AtBsnDxC;;AsBtnDE;EAAsC,gBAAA;AtB0nDxC;;AsB1nDE;EAAsC,gBAAA;AtB8nDxC;;AsB9nDE;EAAsC,gBAAA;AtBkoDxC;;AsBloDE;EAAsC,gBAAA;AtBsoDxC;;AsBtoDE;EAAsC,gBAAA;AtB0oDxC;;AsB1oDE;EAAsC,gBAAA;AtB8oDxC;;AsB9oDE;EAAsC,gBAAA;AtBkpDxC;;AsBlpDE;EAAsC,gBAAA;AtBspDxC;;AsBtpDE;EAAsC,gBAAA;AtB0pDxC;;AsB1pDE;EAAsC,gBAAA;AtB8pDxC;;AsB9pDE;EAAsC,gBAAA;AtBkqDxC;;AsBlqDE;EAAsC,gBAAA;AtBsqDxC;;AsBtqDE;EAAsC,gBAAA;AtB0qDxC;;AsB1qDE;EAAsC,gBAAA;AtB8qDxC;;AsB9qDE;EAAsC,gBAAA;AtBkrDxC;;AsBlrDE;EAAsC,gBAAA;AtBsrDxC;;AsBtrDE;EAAsC,gBAAA;AtB0rDxC;;AsB1rDE;EAAsC,gBAAA;AtB8rDxC;;AsB9rDE;EAAsC,gBAAA;AtBksDxC;;AsBlsDE;EAAsC,gBAAA;AtBssDxC;;AsBtsDE;EAAsC,gBAAA;AtB0sDxC;;AsB1sDE;EAAsC,gBAAA;AtB8sDxC;;AsB9sDE;EAAsC,gBAAA;AtBktDxC;;AsBltDE;EAAsC,gBAAA;AtBstDxC;;AsBttDE;EAAsC,gBAAA;AtB0tDxC;;AsB1tDE;EAAsC,gBAAA;AtB8tDxC;;AsB9tDE;EAAsC,gBAAA;AtBkuDxC;;AsBluDE;EAAsC,gBAAA;AtBsuDxC;;AsBtuDE;EAAsC,gBAAA;AtB0uDxC;;AsB1uDE;EAAsC,gBAAA;AtB8uDxC;;AsB9uDE;EAAsC,gBAAA;AtBkvDxC;;AsBlvDE;EAAsC,gBAAA;AtBsvDxC;;AsBtvDE;EAAsC,gBAAA;AtB0vDxC;;AsB1vDE;EAAsC,gBAAA;AtB8vDxC;;AsB9vDE;EAAsC,gBAAA;AtBkwDxC;;AsBlwDE;EAAsC,aAAA;AtBswDxC;;AsBtwDE;EAAsC,aAAA;AtB0wDxC;;AsB1wDE;EAAsC,gBAAA;AtB8wDxC;;AsB9wDE;EAAsC,gBAAA;AtBkxDxC;;AsBlxDE;EAAsC,gBAAA;AtBsxDxC;;AsBtxDE;EAAsC,gBAAA;AtB0xDxC;;AsB1xDE;EAAsC,gBAAA;AtB8xDxC;;AsB9xDE;EAAsC,gBAAA;AtBkyDxC;;AsBlyDE;EAAsC,gBAAA;AtBsyDxC;;AsBtyDE;EAAsC,gBAAA;AtB0yDxC;;AsB1yDE;EAAsC,gBAAA;AtB8yDxC;;AsB9yDE;EAAsC,gBAAA;AtBkzDxC;;AsBlzDE;EAAsC,gBAAA;AtBszDxC;;AsBtzDE;EAAsC,YAAA;AtB0zDxC;;AsB1zDE;EAAsC,gBAAA;AtB8zDxC;;AsB9zDE;EAAsC,gBAAA;AtBk0DxC;;AsBl0DE;EAAsC,gBAAA;AtBs0DxC;;AsBt0DE;EAAsC,gBAAA;AtB00DxC;;AsB10DE;EAAsC,gBAAA;AtB80DxC;;AsB90DE;EAAsC,gBAAA;AtBk1DxC;;AsBl1DE;EAAsC,gBAAA;AtBs1DxC;;AsBt1DE;EAAsC,gBAAA;AtB01DxC;;AsB11DE;EAAsC,gBAAA;AtB81DxC;;AsB91DE;EAAsC,gBAAA;AtBk2DxC;;AsBl2DE;EAAsC,gBAAA;AtBs2DxC;;AsBt2DE;EAAsC,gBAAA;AtB02DxC;;AsB12DE;EAAsC,gBAAA;AtB82DxC;;AsB92DE;EAAsC,gBAAA;AtBk3DxC;;AsBl3DE;EAAsC,gBAAA;AtBs3DxC;;AsBt3DE;EAAsC,gBAAA;AtB03DxC;;AsB13DE;EAAsC,gBAAA;AtB83DxC;;AsB93DE;EAAsC,gBAAA;AtBk4DxC;;AsBl4DE;EAAsC,gBAAA;AtBs4DxC;;AsBt4DE;EAAsC,gBAAA;AtB04DxC;;AsB14DE;EAAsC,gBAAA;AtB84DxC;;AsB94DE;EAAsC,gBAAA;AtBk5DxC;;AsBl5DE;EAAsC,gBAAA;AtBs5DxC;;AsBt5DE;EAAsC,gBAAA;AtB05DxC;;AsB15DE;EAAsC,gBAAA;AtB85DxC;;AsB95DE;EAAsC,gBAAA;AtBk6DxC;;AsBl6DE;EAAsC,gBAAA;AtBs6DxC;;AsBt6DE;EAAsC,gBAAA;AtB06DxC;;AsB16DE;EAAsC,gBAAA;AtB86DxC;;AsB96DE;EAAsC,gBAAA;AtBk7DxC;;AsBl7DE;EAAsC,gBAAA;AtBs7DxC;;AsBt7DE;EAAsC,gBAAA;AtB07DxC;;AsB17DE;EAAsC,gBAAA;AtB87DxC;;AsB97DE;EAAsC,gBAAA;AtBk8DxC;;AsBl8DE;EAAsC,gBAAA;AtBs8DxC;;AsBt8DE;EAAsC,gBAAA;AtB08DxC;;AsB18DE;EAAsC,gBAAA;AtB88DxC;;AsB98DE;EAAsC,gBAAA;AtBk9DxC;;AsBl9DE;EAAsC,gBAAA;AtBs9DxC;;AsBt9DE;EAAsC,gBAAA;AtB09DxC;;AsB19DE;EAAsC,gBAAA;AtB89DxC;;AsB99DE;EAAsC,gBAAA;AtBk+DxC;;AsBl+DE;EAAsC,gBAAA;AtBs+DxC;;AsBt+DE;EAAsC,gBAAA;AtB0+DxC;;AsB1+DE;EAAsC,gBAAA;AtB8+DxC;;AsB9+DE;EAAsC,gBAAA;AtBk/DxC;;AsBl/DE;EAAsC,gBAAA;AtBs/DxC;;AsBt/DE;EAAsC,gBAAA;AtB0/DxC;;AsB1/DE;EAAsC,gBAAA;AtB8/DxC;;AsB9/DE;EAAsC,gBAAA;AtBkgExC;;AsBlgEE;EAAsC,gBAAA;AtBsgExC;;AsBtgEE;EAAsC,gBAAA;AtB0gExC;;AsB1gEE;EAAsC,gBAAA;AtB8gExC;;AsB9gEE;EAAsC,gBAAA;AtBkhExC;;AsBlhEE;EAAsC,gBAAA;AtBshExC;;AsBthEE;EAAsC,gBAAA;AtB0hExC;;AsB1hEE;EAAsC,gBAAA;AtB8hExC;;AsB9hEE;EAAsC,gBAAA;AtBkiExC;;AsBliEE;EAAsC,gBAAA;AtBsiExC;;AsBtiEE;EAAsC,gBAAA;AtB0iExC;;AsB1iEE;EAAsC,gBAAA;AtB8iExC;;AsB9iEE;EAAsC,gBAAA;AtBkjExC;;AsBljEE;EAAsC,gBAAA;AtBsjExC;;AsBtjEE;EAAsC,gBAAA;AtB0jExC;;AsB1jEE;EAAsC,gBAAA;AtB8jExC;;AsB9jEE;EAAsC,gBAAA;AtBkkExC;;AsBlkEE;EAAsC,gBAAA;AtBskExC;;AsBtkEE;EAAsC,gBAAA;AtB0kExC;;AsB1kEE;EAAsC,gBAAA;AtB8kExC;;AsB9kEE;EAAsC,gBAAA;AtBklExC;;AsBllEE;EAAsC,gBAAA;AtBslExC;;AsBtlEE;EAAsC,gBAAA;AtB0lExC;;AsB1lEE;EAAsC,gBAAA;AtB8lExC;;AsB9lEE;EAAsC,gBAAA;AtBkmExC;;AsBlmEE;EAAsC,gBAAA;AtBsmExC;;AsBtmEE;EAAsC,gBAAA;AtB0mExC;;AsB1mEE;EAAsC,gBAAA;AtB8mExC;;AsB9mEE;EAAsC,gBAAA;AtBknExC;;AsBlnEE;EAAsC,gBAAA;AtBsnExC;;AsBtnEE;EAAsC,gBAAA;AtB0nExC;;AsB1nEE;EAAsC,gBAAA;AtB8nExC;;AsB9nEE;EAAsC,gBAAA;AtBkoExC;;AsBloEE;EAAsC,gBAAA;AtBsoExC;;AsBtoEE;EAAsC,gBAAA;AtB0oExC;;AsB1oEE;EAAsC,gBAAA;AtB8oExC;;AsB9oEE;EAAsC,gBAAA;AtBkpExC;;AsBlpEE;EAAsC,gBAAA;AtBspExC;;AsBtpEE;EAAsC,gBAAA;AtB0pExC;;AsB1pEE;EAAsC,gBAAA;AtB8pExC;;AsB9pEE;EAAsC,gBAAA;AtBkqExC;;AsBlqEE;EAAsC,gBAAA;AtBsqExC;;AsBtqEE;EAAsC,gBAAA;AtB0qExC;;AsB1qEE;EAAsC,gBAAA;AtB8qExC;;AsB9qEE;EAAsC,gBAAA;AtBkrExC;;AsBlrEE;EAAsC,gBAAA;AtBsrExC;;AsBtrEE;EAAsC,gBAAA;AtB0rExC;;AsB1rEE;EAAsC,gBAAA;AtB8rExC;;AsB9rEE;EAAsC,gBAAA;AtBksExC;;AsBlsEE;EAAsC,gBAAA;AtBssExC;;AsBtsEE;EAAsC,gBAAA;AtB0sExC;;AsB1sEE;EAAsC,gBAAA;AtB8sExC;;AsB9sEE;EAAsC,gBAAA;AtBktExC;;AsBltEE;EAAsC,gBAAA;AtBstExC;;AsBttEE;EAAsC,gBAAA;AtB0tExC;;AsB1tEE;EAAsC,gBAAA;AtB8tExC;;AsB9tEE;EAAsC,gBAAA;AtBkuExC;;AsBluEE;EAAsC,gBAAA;AtBsuExC;;AsBtuEE;EAAsC,gBAAA;AtB0uExC;;AsB1uEE;EAAsC,gBAAA;AtB8uExC;;AsB9uEE;EAAsC,gBAAA;AtBkvExC;;AsBlvEE;EAAsC,gBAAA;AtBsvExC;;AsBtvEE;EAAsC,gBAAA;AtB0vExC;;AsB1vEE;EAAsC,gBAAA;AtB8vExC;;AsB9vEE;EAAsC,gBAAA;AtBkwExC;;AsBlwEE;EAAsC,gBAAA;AtBswExC;;AsBtwEE;EAAsC,gBAAA;AtB0wExC;;AsB1wEE;EAAsC,gBAAA;AtB8wExC;;AsB9wEE;EAAsC,gBAAA;AtBkxExC;;AsBlxEE;EAAsC,gBAAA;AtBsxExC;;AsBtxEE;EAAsC,gBAAA;AtB0xExC;;AsB1xEE;EAAsC,gBAAA;AtB8xExC;;AsB9xEE;EAAsC,gBAAA;AtBkyExC;;AsBlyEE;EAAsC,gBAAA;AtBsyExC;;AsBtyEE;EAAsC,gBAAA;AtB0yExC;;AsB1yEE;EAAsC,gBAAA;AtB8yExC;;AsB9yEE;EAAsC,gBAAA;AtBkzExC;;AsBlzEE;EAAsC,gBAAA;AtBszExC;;AsBtzEE;EAAsC,gBAAA;AtB0zExC;;AsB1zEE;EAAsC,gBAAA;AtB8zExC;;AsB9zEE;EAAsC,gBAAA;AtBk0ExC;;AsBl0EE;EAAsC,gBAAA;AtBs0ExC;;AsBt0EE;EAAsC,gBAAA;AtB00ExC;;AsB10EE;EAAsC,gBAAA;AtB80ExC;;AsB90EE;EAAsC,gBAAA;AtBk1ExC;;AsBl1EE;EAAsC,gBAAA;AtBs1ExC;;AsBt1EE;EAAsC,gBAAA;AtB01ExC;;AsB11EE;EAAsC,gBAAA;AtB81ExC;;AsB91EE;EAAsC,gBAAA;AtBk2ExC;;AsBl2EE;EAAsC,gBAAA;AtBs2ExC;;AsBt2EE;EAAsC,gBAAA;AtB02ExC;;AsB12EE;EAAsC,gBAAA;AtB82ExC;;AsB92EE;EAAsC,gBAAA;AtBk3ExC;;AsBl3EE;EAAsC,gBAAA;AtBs3ExC;;AsBt3EE;EAAsC,gBAAA;AtB03ExC;;AsB13EE;EAAsC,gBAAA;AtB83ExC;;AsB93EE;EAAsC,gBAAA;AtBk4ExC;;AsBl4EE;EAAsC,gBAAA;AtBs4ExC;;AsBt4EE;EAAsC,gBAAA;AtB04ExC;;AsB14EE;EAAsC,gBAAA;AtB84ExC;;AsB94EE;EAAsC,gBAAA;AtBk5ExC;;AsBl5EE;EAAsC,gBAAA;AtBs5ExC;;AsBt5EE;EAAsC,gBAAA;AtB05ExC;;AsB15EE;EAAsC,gBAAA;AtB85ExC;;AsB95EE;EAAsC,gBAAA;AtBk6ExC;;AsBl6EE;EAAsC,gBAAA;AtBs6ExC;;AsBt6EE;EAAsC,gBAAA;AtB06ExC;;AsB16EE;EAAsC,gBAAA;AtB86ExC;;AsB96EE;EAAsC,gBAAA;AtBk7ExC;;AsBl7EE;EAAsC,gBAAA;AtBs7ExC;;AsBt7EE;EAAsC,gBAAA;AtB07ExC;;AsB17EE;EAAsC,gBAAA;AtB87ExC;;AsB97EE;EAAsC,gBAAA;AtBk8ExC;;AsBl8EE;EAAsC,gBAAA;AtBs8ExC;;AsBt8EE;EAAsC,gBAAA;AtB08ExC;;AsB18EE;EAAsC,gBAAA;AtB88ExC;;AsB98EE;EAAsC,gBAAA;AtBk9ExC;;AsBl9EE;EAAsC,gBAAA;AtBs9ExC;;AsBt9EE;EAAsC,gBAAA;AtB09ExC;;AsB19EE;EAAsC,gBAAA;AtB89ExC;;AsB99EE;EAAsC,gBAAA;AtBk+ExC;;AsBl+EE;EAAsC,gBAAA;AtBs+ExC;;AsBt+EE;EAAsC,gBAAA;AtB0+ExC;;AsB1+EE;EAAsC,gBAAA;AtB8+ExC;;AsB9+EE;EAAsC,gBAAA;AtBk/ExC;;AsBl/EE;EAAsC,gBAAA;AtBs/ExC;;AsBt/EE;EAAsC,gBAAA;AtB0/ExC;;AsB1/EE;EAAsC,gBAAA;AtB8/ExC;;AsB9/EE;EAAsC,gBAAA;AtBkgFxC;;AsBlgFE;EAAsC,gBAAA;AtBsgFxC;;AsBtgFE;EAAsC,gBAAA;AtB0gFxC;;AsB1gFE;EAAsC,gBAAA;AtB8gFxC;;AsB9gFE;EAAsC,gBAAA;AtBkhFxC;;AsBlhFE;EAAsC,gBAAA;AtBshFxC;;AsBthFE;EAAsC,gBAAA;AtB0hFxC;;AsB1hFE;EAAsC,gBAAA;AtB8hFxC;;AsB9hFE;EAAsC,gBAAA;AtBkiFxC;;AsBliFE;EAAsC,gBAAA;AtBsiFxC;;AsBtiFE;EAAsC,gBAAA;AtB0iFxC;;AsB1iFE;EAAsC,gBAAA;AtB8iFxC;;AsB9iFE;EAAsC,gBAAA;AtBkjFxC;;AsBljFE;EAAsC,gBAAA;AtBsjFxC;;AsBtjFE;EAAsC,gBAAA;AtB0jFxC;;AsB1jFE;EAAsC,gBAAA;AtB8jFxC;;AsB9jFE;EAAsC,gBAAA;AtBkkFxC;;AsBlkFE;EAAsC,gBAAA;AtBskFxC;;AsBtkFE;EAAsC,gBAAA;AtB0kFxC;;AsB1kFE;EAAsC,gBAAA;AtB8kFxC;;AsB9kFE;EAAsC,gBAAA;AtBklFxC;;AsBllFE;EAAsC,gBAAA;AtBslFxC;;AsBtlFE;EAAsC,gBAAA;AtB0lFxC;;AsB1lFE;EAAsC,gBAAA;AtB8lFxC;;AsB9lFE;EAAsC,gBAAA;AtBkmFxC;;AsBlmFE;EAAsC,gBAAA;AtBsmFxC;;AsBtmFE;EAAsC,gBAAA;AtB0mFxC;;AsB1mFE;EAAsC,gBAAA;AtB8mFxC;;AsB9mFE;EAAsC,gBAAA;AtBknFxC;;AsBlnFE;EAAsC,gBAAA;AtBsnFxC;;AsBtnFE;EAAsC,gBAAA;AtB0nFxC;;AsB1nFE;EAAsC,gBAAA;AtB8nFxC;;AsB9nFE;EAAsC,gBAAA;AtBkoFxC;;AsBloFE;EAAsC,gBAAA;AtBsoFxC;;AsBtoFE;EAAsC,gBAAA;AtB0oFxC;;AsB1oFE;EAAsC,gBAAA;AtB8oFxC;;AsB9oFE;EAAsC,gBAAA;AtBkpFxC;;AsBlpFE;EAAsC,gBAAA;AtBspFxC;;AsBtpFE;EAAsC,gBAAA;AtB0pFxC;;AsB1pFE;EAAsC,gBAAA;AtB8pFxC;;AsB9pFE;EAAsC,gBAAA;AtBkqFxC;;AsBlqFE;EAAsC,gBAAA;AtBsqFxC;;AsBtqFE;EAAsC,gBAAA;AtB0qFxC;;AsB1qFE;EAAsC,gBAAA;AtB8qFxC;;AsB9qFE;EAAsC,gBAAA;AtBkrFxC;;AsBlrFE;EAAsC,gBAAA;AtBsrFxC;;AsBtrFE;EAAsC,gBAAA;AtB0rFxC;;AsB1rFE;EAAsC,gBAAA;AtB8rFxC;;AsB9rFE;EAAsC,gBAAA;AtBksFxC;;AsBlsFE;EAAsC,gBAAA;AtBssFxC;;AsBtsFE;EAAsC,gBAAA;AtB0sFxC;;AsB1sFE;EAAsC,gBAAA;AtB8sFxC;;AsB9sFE;EAAsC,gBAAA;AtBktFxC;;AsBltFE;EAAsC,gBAAA;AtBstFxC;;AsBttFE;EAAsC,gBAAA;AtB0tFxC;;AsB1tFE;EAAsC,gBAAA;AtB8tFxC;;AsB9tFE;EAAsC,gBAAA;AtBkuFxC;;AsBluFE;EAAsC,aAAA;AtBsuFxC;;AsBtuFE;EAAsC,aAAA;AtB0uFxC;;AsB1uFE;EAAsC,aAAA;AtB8uFxC;;AsB9uFE;EAAsC,aAAA;AtBkvFxC;;AsBlvFE;EAAsC,aAAA;AtBsvFxC;;AsBtvFE;EAAsC,aAAA;AtB0vFxC;;AsB1vFE;EAAsC,aAAA;AtB8vFxC;;AsB9vFE;EAAsC,aAAA;AtBkwFxC;;AsBlwFE;EAAsC,aAAA;AtBswFxC;;AsBtwFE;EAAsC,aAAA;AtB0wFxC;;AsB1wFE;EAAsC,gBAAA;AtB8wFxC;;AsB9wFE;EAAsC,gBAAA;AtBkxFxC;;AsBlxFE;EAAsC,gBAAA;AtBsxFxC;;AsBtxFE;EAAsC,gBAAA;AtB0xFxC;;AsB1xFE;EAAsC,gBAAA;AtB8xFxC;;AsB9xFE;EAAsC,gBAAA;AtBkyFxC;;AsBlyFE;EAAsC,gBAAA;AtBsyFxC;;AsBtyFE;EAAsC,gBAAA;AtB0yFxC;;AsB1yFE;EAAsC,gBAAA;AtB8yFxC;;AsB9yFE;EAAsC,gBAAA;AtBkzFxC;;AsBlzFE;EAAsC,gBAAA;AtBszFxC;;AsBtzFE;EAAsC,gBAAA;AtB0zFxC;;AsB1zFE;EAAsC,gBAAA;AtB8zFxC;;AsB9zFE;EAAsC,gBAAA;AtBk0FxC;;AsBl0FE;EAAsC,gBAAA;AtBs0FxC;;AsBt0FE;EAAsC,gBAAA;AtB00FxC;;AsB10FE;EAAsC,gBAAA;AtB80FxC;;AsB90FE;EAAsC,gBAAA;AtBk1FxC;;AsBl1FE;EAAsC,gBAAA;AtBs1FxC;;AsBt1FE;EAAsC,gBAAA;AtB01FxC;;AsB11FE;EAAsC,gBAAA;AtB81FxC;;AsB91FE;EAAsC,gBAAA;AtBk2FxC;;AsBl2FE;EAAsC,gBAAA;AtBs2FxC;;AsBt2FE;EAAsC,gBAAA;AtB02FxC;;AsB12FE;EAAsC,gBAAA;AtB82FxC;;AsB92FE;EAAsC,gBAAA;AtBk3FxC;;AsBl3FE;EAAsC,gBAAA;AtBs3FxC;;AsBt3FE;EAAsC,gBAAA;AtB03FxC;;AsB13FE;EAAsC,gBAAA;AtB83FxC;;AsB93FE;EAAsC,gBAAA;AtBk4FxC;;AsBl4FE;EAAsC,gBAAA;AtBs4FxC;;AsBt4FE;EAAsC,gBAAA;AtB04FxC;;AsB14FE;EAAsC,gBAAA;AtB84FxC;;AsB94FE;EAAsC,gBAAA;AtBk5FxC;;AsBl5FE;EAAsC,gBAAA;AtBs5FxC;;AsBt5FE;EAAsC,gBAAA;AtB05FxC;;AsB15FE;EAAsC,gBAAA;AtB85FxC;;AsB95FE;EAAsC,gBAAA;AtBk6FxC;;AsBl6FE;EAAsC,gBAAA;AtBs6FxC;;AsBt6FE;EAAsC,gBAAA;AtB06FxC;;AsB16FE;EAAsC,gBAAA;AtB86FxC;;AsB96FE;EAAsC,gBAAA;AtBk7FxC;;AsBl7FE;EAAsC,gBAAA;AtBs7FxC;;AsBt7FE;EAAsC,gBAAA;AtB07FxC;;AsB17FE;EAAsC,gBAAA;AtB87FxC;;AsB97FE;EAAsC,gBAAA;AtBk8FxC;;AsBl8FE;EAAsC,gBAAA;AtBs8FxC;;AsBt8FE;EAAsC,gBAAA;AtB08FxC;;AsB18FE;EAAsC,gBAAA;AtB88FxC;;AsB98FE;EAAsC,gBAAA;AtBk9FxC;;AsBl9FE;EAAsC,YAAA;AtBs9FxC;;AsBt9FE;EAAsC,gBAAA;AtB09FxC;;AsB19FE;EAAsC,gBAAA;AtB89FxC;;AsB99FE;EAAsC,gBAAA;AtBk+FxC;;AsBl+FE;EAAsC,gBAAA;AtBs+FxC;;AsBt+FE;EAAsC,gBAAA;AtB0+FxC;;AsB1+FE;EAAsC,gBAAA;AtB8+FxC;;AsB9+FE;EAAsC,gBAAA;AtBk/FxC;;AsBl/FE;EAAsC,gBAAA;AtBs/FxC;;AsBt/FE;EAAsC,gBAAA;AtB0/FxC;;AsB1/FE;EAAsC,gBAAA;AtB8/FxC;;AsB9/FE;EAAsC,gBAAA;AtBkgGxC;;AsBlgGE;EAAsC,gBAAA;AtBsgGxC;;AsBtgGE;EAAsC,gBAAA;AtB0gGxC;;AsB1gGE;EAAsC,gBAAA;AtB8gGxC;;AsB9gGE;EAAsC,gBAAA;AtBkhGxC;;AsBlhGE;EAAsC,gBAAA;AtBshGxC;;AsBthGE;EAAsC,gBAAA;AtB0hGxC;;AsB1hGE;EAAsC,gBAAA;AtB8hGxC;;AsB9hGE;EAAsC,gBAAA;AtBkiGxC;;AsBliGE;EAAsC,gBAAA;AtBsiGxC;;AsBtiGE;EAAsC,gBAAA;AtB0iGxC;;AsB1iGE;EAAsC,gBAAA;AtB8iGxC;;AsB9iGE;EAAsC,gBAAA;AtBkjGxC;;AsBljGE;EAAsC,gBAAA;AtBsjGxC;;AsBtjGE;EAAsC,gBAAA;AtB0jGxC;;AsB1jGE;EAAsC,gBAAA;AtB8jGxC;;AsB9jGE;EAAsC,gBAAA;AtBkkGxC;;AsBlkGE;EAAsC,gBAAA;AtBskGxC;;AsBtkGE;EAAsC,gBAAA;AtB0kGxC;;AsB1kGE;EAAsC,gBAAA;AtB8kGxC;;AsB9kGE;EAAsC,gBAAA;AtBklGxC;;AsBllGE;EAAsC,gBAAA;AtBslGxC;;AsBtlGE;EAAsC,gBAAA;AtB0lGxC;;AsB1lGE;EAAsC,gBAAA;AtB8lGxC;;AsB9lGE;EAAsC,gBAAA;AtBkmGxC;;AsBlmGE;EAAsC,gBAAA;AtBsmGxC;;AsBtmGE;EAAsC,gBAAA;AtB0mGxC;;AsB1mGE;EAAsC,gBAAA;AtB8mGxC;;AsB9mGE;EAAsC,gBAAA;AtBknGxC;;AsBlnGE;EAAsC,gBAAA;AtBsnGxC;;AsBtnGE;EAAsC,gBAAA;AtB0nGxC;;AsB1nGE;EAAsC,gBAAA;AtB8nGxC;;AsB9nGE;EAAsC,gBAAA;AtBkoGxC;;AsBloGE;EAAsC,gBAAA;AtBsoGxC;;AsBtoGE;EAAsC,gBAAA;AtB0oGxC;;AsB1oGE;EAAsC,gBAAA;AtB8oGxC;;AsB9oGE;EAAsC,gBAAA;AtBkpGxC;;AsBlpGE;EAAsC,gBAAA;AtBspGxC;;AsBtpGE;EAAsC,gBAAA;AtB0pGxC;;AsB1pGE;EAAsC,gBAAA;AtB8pGxC;;AsB9pGE;EAAsC,gBAAA;AtBkqGxC;;AsBlqGE;EAAsC,gBAAA;AtBsqGxC;;AsBtqGE;EAAsC,gBAAA;AtB0qGxC;;AsB1qGE;EAAsC,gBAAA;AtB8qGxC;;AsB9qGE;EAAsC,gBAAA;AtBkrGxC;;AsBlrGE;EAAsC,gBAAA;AtBsrGxC;;AsBtrGE;EAAsC,gBAAA;AtB0rGxC;;AsB1rGE;EAAsC,gBAAA;AtB8rGxC;;AsB9rGE;EAAsC,gBAAA;AtBksGxC;;AsBlsGE;EAAsC,gBAAA;AtBssGxC;;AsBtsGE;EAAsC,gBAAA;AtB0sGxC;;AsB1sGE;EAAsC,gBAAA;AtB8sGxC;;AsB9sGE;EAAsC,gBAAA;AtBktGxC;;AsBltGE;EAAsC,gBAAA;AtBstGxC;;AsBttGE;EAAsC,gBAAA;AtB0tGxC;;AsB1tGE;EAAsC,gBAAA;AtB8tGxC;;AsB9tGE;EAAsC,gBAAA;AtBkuGxC;;AsBluGE;EAAsC,gBAAA;AtBsuGxC;;AsBtuGE;EAAsC,gBAAA;AtB0uGxC;;AsB1uGE;EAAsC,gBAAA;AtB8uGxC;;AsB9uGE;EAAsC,gBAAA;AtBkvGxC;;AsBlvGE;EAAsC,gBAAA;AtBsvGxC;;AsBtvGE;EAAsC,gBAAA;AtB0vGxC;;AsB1vGE;EAAsC,gBAAA;AtB8vGxC;;AsB9vGE;EAAsC,gBAAA;AtBkwGxC;;AsBlwGE;EAAsC,gBAAA;AtBswGxC;;AsBtwGE;EAAsC,gBAAA;AtB0wGxC;;AsB1wGE;EAAsC,gBAAA;AtB8wGxC;;AsB9wGE;EAAsC,gBAAA;AtBkxGxC;;AsBlxGE;EAAsC,gBAAA;AtBsxGxC;;AsBtxGE;EAAsC,gBAAA;AtB0xGxC;;AsB1xGE;EAAsC,gBAAA;AtB8xGxC;;AsB9xGE;EAAsC,gBAAA;AtBkyGxC;;AsBlyGE;EAAsC,gBAAA;AtBsyGxC;;AsBtyGE;EAAsC,gBAAA;AtB0yGxC;;AsB1yGE;EAAsC,gBAAA;AtB8yGxC;;AsB9yGE;EAAsC,gBAAA;AtBkzGxC;;AsBlzGE;EAAsC,gBAAA;AtBszGxC;;AsBtzGE;EAAsC,gBAAA;AtB0zGxC;;AsB1zGE;EAAsC,gBAAA;AtB8zGxC;;AsB9zGE;EAAsC,gBAAA;AtBk0GxC;;AsBl0GE;EAAsC,gBAAA;AtBs0GxC;;AsBt0GE;EAAsC,gBAAA;AtB00GxC;;AsB10GE;EAAsC,gBAAA;AtB80GxC;;AsB90GE;EAAsC,gBAAA;AtBk1GxC;;AsBl1GE;EAAsC,gBAAA;AtBs1GxC;;AsBt1GE;EAAsC,gBAAA;AtB01GxC;;AsB11GE;EAAsC,gBAAA;AtB81GxC;;AsB91GE;EAAsC,gBAAA;AtBk2GxC;;AsBl2GE;EAAsC,gBAAA;AtBs2GxC;;AsBt2GE;EAAsC,gBAAA;AtB02GxC;;AsB12GE;EAAsC,gBAAA;AtB82GxC;;AsB92GE;EAAsC,gBAAA;AtBk3GxC;;AsBl3GE;EAAsC,gBAAA;AtBs3GxC;;AsBt3GE;EAAsC,gBAAA;AtB03GxC;;AsB13GE;EAAsC,gBAAA;AtB83GxC;;AsB93GE;EAAsC,gBAAA;AtBk4GxC;;AsBl4GE;EAAsC,gBAAA;AtBs4GxC;;AsBt4GE;EAAsC,gBAAA;AtB04GxC;;AsB14GE;EAAsC,gBAAA;AtB84GxC;;AsB94GE;EAAsC,gBAAA;AtBk5GxC;;AsBl5GE;EAAsC,gBAAA;AtBs5GxC;;AsBt5GE;EAAsC,gBAAA;AtB05GxC;;AsB15GE;EAAsC,gBAAA;AtB85GxC;;AsB95GE;EAAsC,gBAAA;AtBk6GxC;;AsBl6GE;EAAsC,gBAAA;AtBs6GxC;;AsBt6GE;EAAsC,gBAAA;AtB06GxC;;AsB16GE;EAAsC,gBAAA;AtB86GxC;;AsB96GE;EAAsC,gBAAA;AtBk7GxC;;AsBl7GE;EAAsC,gBAAA;AtBs7GxC;;AsBt7GE;EAAsC,gBAAA;AtB07GxC;;AsB17GE;EAAsC,gBAAA;AtB87GxC;;AsB97GE;EAAsC,gBAAA;AtBk8GxC;;AsBl8GE;EAAsC,gBAAA;AtBs8GxC;;AsBt8GE;EAAsC,gBAAA;AtB08GxC;;AsB18GE;EAAsC,gBAAA;AtB88GxC;;AsB98GE;EAAsC,gBAAA;AtBk9GxC;;AsBl9GE;EAAsC,gBAAA;AtBs9GxC;;AsBt9GE;EAAsC,gBAAA;AtB09GxC;;AsB19GE;EAAsC,gBAAA;AtB89GxC;;AsB99GE;EAAsC,gBAAA;AtBk+GxC;;AsBl+GE;EAAsC,gBAAA;AtBs+GxC;;AsBt+GE;EAAsC,gBAAA;AtB0+GxC;;AsB1+GE;EAAsC,gBAAA;AtB8+GxC;;AsB9+GE;EAAsC,gBAAA;AtBk/GxC;;AsBl/GE;EAAsC,gBAAA;AtBs/GxC;;AsBt/GE;EAAsC,gBAAA;AtB0/GxC;;AsB1/GE;EAAsC,gBAAA;AtB8/GxC;;AsB9/GE;EAAsC,gBAAA;AtBkgHxC;;AsBlgHE;EAAsC,gBAAA;AtBsgHxC;;AsBtgHE;EAAsC,gBAAA;AtB0gHxC;;AsB1gHE;EAAsC,gBAAA;AtB8gHxC;;AsB9gHE;EAAsC,gBAAA;AtBkhHxC;;AsBlhHE;EAAsC,gBAAA;AtBshHxC;;AsBthHE;EAAsC,gBAAA;AtB0hHxC;;AsB1hHE;EAAsC,gBAAA;AtB8hHxC;;AsB9hHE;EAAsC,gBAAA;AtBkiHxC;;AsBliHE;EAAsC,gBAAA;AtBsiHxC;;AsBtiHE;EAAsC,gBAAA;AtB0iHxC;;AsB1iHE;EAAsC,gBAAA;AtB8iHxC;;AsB9iHE;EAAsC,gBAAA;AtBkjHxC;;AsBljHE;EAAsC,gBAAA;AtBsjHxC;;AsBtjHE;EAAsC,gBAAA;AtB0jHxC;;AsB1jHE;EAAsC,gBAAA;AtB8jHxC;;AsB9jHE;EAAsC,gBAAA;AtBkkHxC;;AsBlkHE;EAAsC,gBAAA;AtBskHxC;;AsBtkHE;EAAsC,gBAAA;AtB0kHxC;;AsB1kHE;EAAsC,gBAAA;AtB8kHxC;;AsB9kHE;EAAsC,gBAAA;AtBklHxC;;AsBllHE;EAAsC,gBAAA;AtBslHxC;;AsBtlHE;EAAsC,gBAAA;AtB0lHxC;;AsB1lHE;EAAsC,gBAAA;AtB8lHxC;;AsB9lHE;EAAsC,gBAAA;AtBkmHxC;;AsBlmHE;EAAsC,gBAAA;AtBsmHxC;;AsBtmHE;EAAsC,gBAAA;AtB0mHxC;;AsB1mHE;EAAsC,gBAAA;AtB8mHxC;;AsB9mHE;EAAsC,gBAAA;AtBknHxC;;AsBlnHE;EAAsC,gBAAA;AtBsnHxC;;AsBtnHE;EAAsC,gBAAA;AtB0nHxC;;AsB1nHE;EAAsC,gBAAA;AtB8nHxC;;AsB9nHE;EAAsC,gBAAA;AtBkoHxC;;AsBloHE;EAAsC,gBAAA;AtBsoHxC;;AsBtoHE;EAAsC,gBAAA;AtB0oHxC;;AsB1oHE;EAAsC,gBAAA;AtB8oHxC;;AsB9oHE;EAAsC,gBAAA;AtBkpHxC;;AsBlpHE;EAAsC,gBAAA;AtBspHxC;;AsBtpHE;EAAsC,gBAAA;AtB0pHxC;;AsB1pHE;EAAsC,gBAAA;AtB8pHxC;;AsB9pHE;EAAsC,gBAAA;AtBkqHxC;;AsBlqHE;EAAsC,gBAAA;AtBsqHxC;;AsBtqHE;EAAsC,gBAAA;AtB0qHxC;;AsB1qHE;EAAsC,gBAAA;AtB8qHxC;;AsB9qHE;EAAsC,gBAAA;AtBkrHxC;;AsBlrHE;EAAsC,gBAAA;AtBsrHxC;;AsBtrHE;EAAsC,gBAAA;AtB0rHxC;;AsB1rHE;EAAsC,gBAAA;AtB8rHxC;;AsB9rHE;EAAsC,gBAAA;AtBksHxC;;AsBlsHE;EAAsC,gBAAA;AtBssHxC;;AsBtsHE;EAAsC,gBAAA;AtB0sHxC;;AsB1sHE;EAAsC,gBAAA;AtB8sHxC;;AsB9sHE;EAAsC,gBAAA;AtBktHxC;;AsBltHE;EAAsC,gBAAA;AtBstHxC;;AsBttHE;EAAsC,gBAAA;AtB0tHxC;;AsB1tHE;EAAsC,gBAAA;AtB8tHxC;;AsB9tHE;EAAsC,gBAAA;AtBkuHxC;;AsBluHE;EAAsC,gBAAA;AtBsuHxC;;AsBtuHE;EAAsC,gBAAA;AtB0uHxC;;AsB1uHE;EAAsC,gBAAA;AtB8uHxC;;AsB9uHE;EAAsC,gBAAA;AtBkvHxC;;AsBlvHE;EAAsC,gBAAA;AtBsvHxC;;AsBtvHE;EAAsC,gBAAA;AtB0vHxC;;AsB1vHE;EAAsC,gBAAA;AtB8vHxC;;AsB9vHE;EAAsC,gBAAA;AtBkwHxC;;AsBlwHE;EAAsC,gBAAA;AtBswHxC;;AsBtwHE;EAAsC,gBAAA;AtB0wHxC;;AsB1wHE;EAAsC,gBAAA;AtB8wHxC;;AsB9wHE;EAAsC,gBAAA;AtBkxHxC;;AsBlxHE;EAAsC,gBAAA;AtBsxHxC;;AsBtxHE;EAAsC,gBAAA;AtB0xHxC;;AsB1xHE;EAAsC,gBAAA;AtB8xHxC;;AsB9xHE;EAAsC,gBAAA;AtBkyHxC;;AsBlyHE;EAAsC,gBAAA;AtBsyHxC;;AsBtyHE;EAAsC,gBAAA;AtB0yHxC;;AsB1yHE;EAAsC,gBAAA;AtB8yHxC;;AsB9yHE;EAAsC,gBAAA;AtBkzHxC;;AsBlzHE;EAAsC,gBAAA;AtBszHxC;;AsBtzHE;EAAsC,gBAAA;AtB0zHxC;;AsB1zHE;EAAsC,gBAAA;AtB8zHxC;;AsB9zHE;EAAsC,gBAAA;AtBk0HxC;;AsBl0HE;EAAsC,gBAAA;AtBs0HxC;;AsBt0HE;EAAsC,gBAAA;AtB00HxC;;AsB10HE;EAAsC,gBAAA;AtB80HxC;;AsB90HE;EAAsC,gBAAA;AtBk1HxC;;AsBl1HE;EAAsC,gBAAA;AtBs1HxC;;AsBt1HE;EAAsC,gBAAA;AtB01HxC;;AsB11HE;EAAsC,gBAAA;AtB81HxC;;AsB91HE;EAAsC,gBAAA;AtBk2HxC;;AsBl2HE;EAAsC,gBAAA;AtBs2HxC;;AsBt2HE;EAAsC,gBAAA;AtB02HxC;;AsB12HE;EAAsC,gBAAA;AtB82HxC;;AsB92HE;EAAsC,gBAAA;AtBk3HxC;;AsBl3HE;EAAsC,gBAAA;AtBs3HxC;;AsBt3HE;EAAsC,gBAAA;AtB03HxC;;AsB13HE;EAAsC,gBAAA;AtB83HxC;;AsB93HE;EAAsC,gBAAA;AtBk4HxC;;AsBl4HE;EAAsC,gBAAA;AtBs4HxC;;AsBt4HE;EAAsC,gBAAA;AtB04HxC;;AsB14HE;EAAsC,gBAAA;AtB84HxC;;AsB94HE;EAAsC,gBAAA;AtBk5HxC;;AsBl5HE;EAAsC,gBAAA;AtBs5HxC;;AsBt5HE;EAAsC,gBAAA;AtB05HxC;;AsB15HE;EAAsC,gBAAA;AtB85HxC;;AsB95HE;EAAsC,gBAAA;AtBk6HxC;;AsBl6HE;EAAsC,gBAAA;AtBs6HxC;;AsBt6HE;EAAsC,gBAAA;AtB06HxC;;AsB16HE;EAAsC,gBAAA;AtB86HxC;;AsB96HE;EAAsC,gBAAA;AtBk7HxC;;AsBl7HE;EAAsC,gBAAA;AtBs7HxC;;AsBt7HE;EAAsC,gBAAA;AtB07HxC;;AsB17HE;EAAsC,gBAAA;AtB87HxC;;AsB97HE;EAAsC,gBAAA;AtBk8HxC;;AsBl8HE;EAAsC,gBAAA;AtBs8HxC;;AsBt8HE;EAAsC,gBAAA;AtB08HxC;;AsB18HE;EAAsC,gBAAA;AtB88HxC;;AsB98HE;EAAsC,gBAAA;AtBk9HxC;;AsBl9HE;EAAsC,gBAAA;AtBs9HxC;;AsBt9HE;EAAsC,gBAAA;AtB09HxC;;AsB19HE;EAAsC,gBAAA;AtB89HxC;;AsB99HE;EAAsC,gBAAA;AtBk+HxC;;AsBl+HE;EAAsC,gBAAA;AtBs+HxC;;AsBt+HE;EAAsC,gBAAA;AtB0+HxC;;AsB1+HE;EAAsC,gBAAA;AtB8+HxC;;AsB9+HE;EAAsC,gBAAA;AtBk/HxC;;AsBl/HE;EAAsC,gBAAA;AtBs/HxC;;AsBt/HE;EAAsC,gBAAA;AtB0/HxC;;AsB1/HE;EAAsC,gBAAA;AtB8/HxC;;AsB9/HE;EAAsC,gBAAA;AtBkgIxC;;AsBlgIE;EAAsC,gBAAA;AtBsgIxC;;AsBtgIE;EAAsC,gBAAA;AtB0gIxC;;AsB1gIE;EAAsC,gBAAA;AtB8gIxC;;AsB9gIE;EAAsC,gBAAA;AtBkhIxC;;AsBlhIE;EAAsC,gBAAA;AtBshIxC;;AsBthIE;EAAsC,gBAAA;AtB0hIxC;;AsB1hIE;EAAsC,gBAAA;AtB8hIxC;;AsB9hIE;EAAsC,gBAAA;AtBkiIxC;;AsBliIE;EAAsC,gBAAA;AtBsiIxC;;AsBtiIE;EAAsC,gBAAA;AtB0iIxC;;AsB1iIE;EAAsC,gBAAA;AtB8iIxC;;AsB9iIE;EAAsC,gBAAA;AtBkjIxC;;AsBljIE;EAAsC,gBAAA;AtBsjIxC;;AsBtjIE;EAAsC,gBAAA;AtB0jIxC;;AsB1jIE;EAAsC,gBAAA;AtB8jIxC;;AsB9jIE;EAAsC,gBAAA;AtBkkIxC;;AsBlkIE;EAAsC,gBAAA;AtBskIxC;;AsBtkIE;EAAsC,gBAAA;AtB0kIxC;;AsB1kIE;EAAsC,gBAAA;AtB8kIxC;;AsB9kIE;EAAsC,gBAAA;AtBklIxC;;AsBllIE;EAAsC,gBAAA;AtBslIxC;;AsBtlIE;EAAsC,gBAAA;AtB0lIxC;;AsB1lIE;EAAsC,gBAAA;AtB8lIxC;;AsB9lIE;EAAsC,gBAAA;AtBkmIxC;;AsBlmIE;EAAsC,gBAAA;AtBsmIxC;;AsBtmIE;EAAsC,gBAAA;AtB0mIxC;;AsB1mIE;EAAsC,gBAAA;AtB8mIxC;;AsB9mIE;EAAsC,gBAAA;AtBknIxC;;AsBlnIE;EAAsC,gBAAA;AtBsnIxC;;AsBtnIE;EAAsC,gBAAA;AtB0nIxC;;AsB1nIE;EAAsC,gBAAA;AtB8nIxC;;AsB9nIE;EAAsC,gBAAA;AtBkoIxC;;AsBloIE;EAAsC,gBAAA;AtBsoIxC;;AsBtoIE;EAAsC,gBAAA;AtB0oIxC;;AsB1oIE;EAAsC,gBAAA;AtB8oIxC;;AsB9oIE;EAAsC,gBAAA;AtBkpIxC;;AsBlpIE;EAAsC,gBAAA;AtBspIxC;;AsBtpIE;EAAsC,gBAAA;AtB0pIxC;;AsB1pIE;EAAsC,gBAAA;AtB8pIxC;;AsB9pIE;EAAsC,gBAAA;AtBkqIxC;;AsBlqIE;EAAsC,gBAAA;AtBsqIxC;;AsBtqIE;EAAsC,gBAAA;AtB0qIxC;;AsB1qIE;EAAsC,gBAAA;AtB8qIxC;;AsB9qIE;EAAsC,gBAAA;AtBkrIxC;;AsBlrIE;EAAsC,gBAAA;AtBsrIxC;;AsBtrIE;EAAsC,gBAAA;AtB0rIxC;;AsB1rIE;EAAsC,gBAAA;AtB8rIxC;;AsB9rIE;EAAsC,gBAAA;AtBksIxC;;AsBlsIE;EAAsC,gBAAA;AtBssIxC;;AsBtsIE;EAAsC,gBAAA;AtB0sIxC;;AsB1sIE;EAAsC,gBAAA;AtB8sIxC;;AsB9sIE;EAAsC,gBAAA;AtBktIxC;;AsBltIE;EAAsC,gBAAA;AtBstIxC;;AsBttIE;EAAsC,gBAAA;AtB0tIxC;;AsB1tIE;EAAsC,gBAAA;AtB8tIxC;;AsB9tIE;EAAsC,gBAAA;AtBkuIxC;;AsBluIE;EAAsC,gBAAA;AtBsuIxC;;AsBtuIE;EAAsC,gBAAA;AtB0uIxC;;AsB1uIE;EAAsC,gBAAA;AtB8uIxC;;AsB9uIE;EAAsC,gBAAA;AtBkvIxC;;AsBlvIE;EAAsC,gBAAA;AtBsvIxC;;AsBtvIE;EAAsC,gBAAA;AtB0vIxC;;AsB1vIE;EAAsC,gBAAA;AtB8vIxC;;AsB9vIE;EAAsC,gBAAA;AtBkwIxC;;AsBlwIE;EAAsC,gBAAA;AtBswIxC;;AsBtwIE;EAAsC,gBAAA;AtB0wIxC;;AsB1wIE;EAAsC,gBAAA;AtB8wIxC;;AsB9wIE;EAAsC,gBAAA;AtBkxIxC;;AsBlxIE;EAAsC,gBAAA;AtBsxIxC;;AsBtxIE;EAAsC,gBAAA;AtB0xIxC;;AsB1xIE;EAAsC,gBAAA;AtB8xIxC;;AsB9xIE;EAAsC,gBAAA;AtBkyIxC;;AsBlyIE;EAAsC,gBAAA;AtBsyIxC;;AsBtyIE;EAAsC,gBAAA;AtB0yIxC;;AsB1yIE;EAAsC,gBAAA;AtB8yIxC;;AsB9yIE;EAAsC,gBAAA;AtBkzIxC;;AsBlzIE;EAAsC,gBAAA;AtBszIxC;;AsBtzIE;EAAsC,gBAAA;AtB0zIxC;;AsB1zIE;EAAsC,gBAAA;AtB8zIxC;;AsB9zIE;EAAsC,gBAAA;AtBk0IxC;;AsBl0IE;EAAsC,gBAAA;AtBs0IxC;;AsBt0IE;EAAsC,gBAAA;AtB00IxC;;AsB10IE;EAAsC,gBAAA;AtB80IxC;;AsB90IE;EAAsC,gBAAA;AtBk1IxC;;AsBl1IE;EAAsC,gBAAA;AtBs1IxC;;AsBt1IE;EAAsC,gBAAA;AtB01IxC;;AsB11IE;EAAsC,gBAAA;AtB81IxC;;AsB91IE;EAAsC,gBAAA;AtBk2IxC;;AsBl2IE;EAAsC,gBAAA;AtBs2IxC;;AsBt2IE;EAAsC,gBAAA;AtB02IxC;;AsB12IE;EAAsC,gBAAA;AtB82IxC;;AsB92IE;EAAsC,gBAAA;AtBk3IxC;;AsBl3IE;EAAsC,gBAAA;AtBs3IxC;;AsBt3IE;EAAsC,gBAAA;AtB03IxC;;AsB13IE;EAAsC,gBAAA;AtB83IxC;;AsB93IE;EAAsC,gBAAA;AtBk4IxC;;AsBl4IE;EAAsC,gBAAA;AtBs4IxC;;AsBt4IE;EAAsC,gBAAA;AtB04IxC;;AsB14IE;EAAsC,gBAAA;AtB84IxC;;AsB94IE;EAAsC,gBAAA;AtBk5IxC;;AsBl5IE;EAAsC,gBAAA;AtBs5IxC;;AsBt5IE;EAAsC,gBAAA;AtB05IxC;;AsB15IE;EAAsC,gBAAA;AtB85IxC;;AsB95IE;EAAsC,gBAAA;AtBk6IxC;;AsBl6IE;EAAsC,gBAAA;AtBs6IxC;;AsBt6IE;EAAsC,gBAAA;AtB06IxC;;AsB16IE;EAAsC,gBAAA;AtB86IxC;;AsB96IE;EAAsC,gBAAA;AtBk7IxC;;AsBl7IE;EAAsC,gBAAA;AtBs7IxC;;AsBt7IE;EAAsC,gBAAA;AtB07IxC;;AsB17IE;EAAsC,gBAAA;AtB87IxC;;AsB97IE;EAAsC,gBAAA;AtBk8IxC;;AsBl8IE;EAAsC,gBAAA;AtBs8IxC;;AsBt8IE;EAAsC,gBAAA;AtB08IxC;;AsB18IE;EAAsC,gBAAA;AtB88IxC;;AsB98IE;EAAsC,gBAAA;AtBk9IxC;;AsBl9IE;EAAsC,gBAAA;AtBs9IxC;;AsBt9IE;EAAsC,gBAAA;AtB09IxC;;AsB19IE;EAAsC,gBAAA;AtB89IxC;;AsB99IE;EAAsC,gBAAA;AtBk+IxC;;AsBl+IE;EAAsC,gBAAA;AtBs+IxC;;AsBt+IE;EAAsC,gBAAA;AtB0+IxC;;AsB1+IE;EAAsC,gBAAA;AtB8+IxC;;AsB9+IE;EAAsC,gBAAA;AtBk/IxC;;AsBl/IE;EAAsC,gBAAA;AtBs/IxC;;AsBt/IE;EAAsC,gBAAA;AtB0/IxC;;AsB1/IE;EAAsC,gBAAA;AtB8/IxC;;AsB9/IE;EAAsC,gBAAA;AtBkgJxC;;AsBlgJE;EAAsC,gBAAA;AtBsgJxC;;AsBtgJE;EAAsC,gBAAA;AtB0gJxC;;AsB1gJE;EAAsC,gBAAA;AtB8gJxC;;AsB9gJE;EAAsC,gBAAA;AtBkhJxC;;AsBlhJE;EAAsC,gBAAA;AtBshJxC;;AsBthJE;EAAsC,gBAAA;AtB0hJxC;;AsB1hJE;EAAsC,gBAAA;AtB8hJxC;;AsB9hJE;EAAsC,gBAAA;AtBkiJxC;;AsBliJE;EAAsC,gBAAA;AtBsiJxC;;AsBtiJE;EAAsC,gBAAA;AtB0iJxC;;AsB1iJE;EAAsC,gBAAA;AtB8iJxC;;AsB9iJE;EAAsC,gBAAA;AtBkjJxC;;AsBljJE;EAAsC,gBAAA;AtBsjJxC;;AsBtjJE;EAAsC,gBAAA;AtB0jJxC;;AsB1jJE;EAAsC,gBAAA;AtB8jJxC;;AsB9jJE;EAAsC,gBAAA;AtBkkJxC;;AsBlkJE;EAAsC,gBAAA;AtBskJxC;;AsBtkJE;EAAsC,gBAAA;AtB0kJxC;;AsB1kJE;EAAsC,gBAAA;AtB8kJxC;;AsB9kJE;EAAsC,gBAAA;AtBklJxC;;AsBllJE;EAAsC,gBAAA;AtBslJxC;;AsBtlJE;EAAsC,gBAAA;AtB0lJxC;;AsB1lJE;EAAsC,gBAAA;AtB8lJxC;;AsB9lJE;EAAsC,gBAAA;AtBkmJxC;;AsBlmJE;EAAsC,gBAAA;AtBsmJxC;;AsBtmJE;EAAsC,gBAAA;AtB0mJxC;;AsB1mJE;EAAsC,gBAAA;AtB8mJxC;;AsB9mJE;EAAsC,gBAAA;AtBknJxC;;AsBlnJE;EAAsC,gBAAA;AtBsnJxC;;AsBtnJE;EAAsC,gBAAA;AtB0nJxC;;AsB1nJE;EAAsC,gBAAA;AtB8nJxC;;AsB9nJE;EAAsC,gBAAA;AtBkoJxC;;AsBloJE;EAAsC,gBAAA;AtBsoJxC;;AsBtoJE;EAAsC,gBAAA;AtB0oJxC;;AsB1oJE;EAAsC,gBAAA;AtB8oJxC;;AsB9oJE;EAAsC,gBAAA;AtBkpJxC;;AsBlpJE;EAAsC,gBAAA;AtBspJxC;;AsBtpJE;EAAsC,gBAAA;AtB0pJxC;;AsB1pJE;EAAsC,gBAAA;AtB8pJxC;;AsB9pJE;EAAsC,gBAAA;AtBkqJxC;;AsBlqJE;EAAsC,gBAAA;AtBsqJxC;;AsBtqJE;EAAsC,gBAAA;AtB0qJxC;;AsB1qJE;EAAsC,gBAAA;AtB8qJxC;;AsB9qJE;EAAsC,gBAAA;AtBkrJxC;;AsBlrJE;EAAsC,gBAAA;AtBsrJxC;;AsBtrJE;EAAsC,gBAAA;AtB0rJxC;;AsB1rJE;EAAsC,gBAAA;AtB8rJxC;;AsB9rJE;EAAsC,gBAAA;AtBksJxC;;AsBlsJE;EAAsC,gBAAA;AtBssJxC;;AsBtsJE;EAAsC,gBAAA;AtB0sJxC;;AsB1sJE;EAAsC,gBAAA;AtB8sJxC;;AsB9sJE;EAAsC,gBAAA;AtBktJxC;;AsBltJE;EAAsC,gBAAA;AtBstJxC;;AsBttJE;EAAsC,gBAAA;AtB0tJxC;;AsB1tJE;EAAsC,gBAAA;AtB8tJxC;;AsB9tJE;EAAsC,gBAAA;AtBkuJxC;;AsBluJE;EAAsC,gBAAA;AtBsuJxC;;AsBtuJE;EAAsC,gBAAA;AtB0uJxC;;AsB1uJE;EAAsC,gBAAA;AtB8uJxC;;AsB9uJE;EAAsC,gBAAA;AtBkvJxC;;AsBlvJE;EAAsC,gBAAA;AtBsvJxC;;AsBtvJE;EAAsC,gBAAA;AtB0vJxC;;AsB1vJE;EAAsC,gBAAA;AtB8vJxC;;AsB9vJE;EAAsC,gBAAA;AtBkwJxC;;AsBlwJE;EAAsC,gBAAA;AtBswJxC;;AsBtwJE;EAAsC,gBAAA;AtB0wJxC;;AsB1wJE;EAAsC,gBAAA;AtB8wJxC;;AsB9wJE;EAAsC,gBAAA;AtBkxJxC;;AsBlxJE;EAAsC,gBAAA;AtBsxJxC;;AsBtxJE;EAAsC,gBAAA;AtB0xJxC;;AsB1xJE;EAAsC,gBAAA;AtB8xJxC;;AsB9xJE;EAAsC,gBAAA;AtBkyJxC;;AsBlyJE;EAAsC,gBAAA;AtBsyJxC;;AsBtyJE;EAAsC,gBAAA;AtB0yJxC;;AsB1yJE;EAAsC,gBAAA;AtB8yJxC;;AsB9yJE;EAAsC,gBAAA;AtBkzJxC;;AsBlzJE;EAAsC,gBAAA;AtBszJxC;;AsBtzJE;EAAsC,gBAAA;AtB0zJxC;;AsB1zJE;EAAsC,gBAAA;AtB8zJxC;;AsB9zJE;EAAsC,gBAAA;AtBk0JxC;;AsBl0JE;EAAsC,gBAAA;AtBs0JxC;;AsBt0JE;EAAsC,gBAAA;AtB00JxC;;AsB10JE;EAAsC,gBAAA;AtB80JxC;;AsB90JE;EAAsC,gBAAA;AtBk1JxC;;AsBl1JE;EAAsC,gBAAA;AtBs1JxC;;AsBt1JE;EAAsC,gBAAA;AtB01JxC;;AsB11JE;EAAsC,gBAAA;AtB81JxC;;AsB91JE;EAAsC,gBAAA;AtBk2JxC;;AsBl2JE;EAAsC,gBAAA;AtBs2JxC;;AsBt2JE;EAAsC,gBAAA;AtB02JxC;;AsB12JE;EAAsC,gBAAA;AtB82JxC;;AsB92JE;EAAsC,gBAAA;AtBk3JxC;;AsBl3JE;EAAsC,gBAAA;AtBs3JxC;;AsBt3JE;EAAsC,gBAAA;AtB03JxC;;AsB13JE;EAAsC,gBAAA;AtB83JxC;;AsB93JE;EAAsC,gBAAA;AtBk4JxC;;AsBl4JE;EAAsC,gBAAA;AtBs4JxC;;AsBt4JE;EAAsC,gBAAA;AtB04JxC;;AsB14JE;EAAsC,aAAA;AtB84JxC;;AsB94JE;EAAsC,gBAAA;AtBk5JxC;;AsBl5JE;EAAsC,gBAAA;AtBs5JxC;;AsBt5JE;EAAsC,gBAAA;AtB05JxC;;AsB15JE;EAAsC,aAAA;AtB85JxC;;AsB95JE;EAAsC,gBAAA;AtBk6JxC;;AsBl6JE;EAAsC,gBAAA;AtBs6JxC;;AsBt6JE;EAAsC,gBAAA;AtB06JxC;;AsB16JE;EAAsC,gBAAA;AtB86JxC;;AsB96JE;EAAsC,gBAAA;AtBk7JxC;;AsBl7JE;EAAsC,gBAAA;AtBs7JxC;;AsBt7JE;EAAsC,gBAAA;AtB07JxC;;AsB17JE;EAAsC,gBAAA;AtB87JxC;;AsB97JE;EAAsC,gBAAA;AtBk8JxC;;AsBl8JE;EAAsC,gBAAA;AtBs8JxC;;AsBt8JE;EAAsC,gBAAA;AtB08JxC;;AsB18JE;EAAsC,gBAAA;AtB88JxC;;AsB98JE;EAAsC,gBAAA;AtBk9JxC;;AsBl9JE;EAAsC,gBAAA;AtBs9JxC;;AsBt9JE;EAAsC,gBAAA;AtB09JxC;;AsB19JE;EAAsC,gBAAA;AtB89JxC;;AsB99JE;EAAsC,gBAAA;AtBk+JxC;;AsBl+JE;EAAsC,gBAAA;AtBs+JxC;;AsBt+JE;EAAsC,gBAAA;AtB0+JxC;;AsB1+JE;EAAsC,gBAAA;AtB8+JxC;;AsB9+JE;EAAsC,gBAAA;AtBk/JxC;;AsBl/JE;EAAsC,gBAAA;AtBs/JxC;;AsBt/JE;EAAsC,gBAAA;AtB0/JxC;;AsB1/JE;EAAsC,gBAAA;AtB8/JxC;;AsB9/JE;EAAsC,gBAAA;AtBkgKxC;;AsBlgKE;EAAsC,gBAAA;AtBsgKxC;;AsBtgKE;EAAsC,gBAAA;AtB0gKxC;;AsB1gKE;EAAsC,gBAAA;AtB8gKxC;;AsB9gKE;EAAsC,gBAAA;AtBkhKxC;;AsBlhKE;EAAsC,gBAAA;AtBshKxC;;AsBthKE;EAAsC,gBAAA;AtB0hKxC;;AsB1hKE;EAAsC,gBAAA;AtB8hKxC;;AsB9hKE;EAAsC,gBAAA;AtBkiKxC;;AsBliKE;EAAsC,gBAAA;AtBsiKxC;;AsBtiKE;EAAsC,gBAAA;AtB0iKxC;;AsB1iKE;EAAsC,gBAAA;AtB8iKxC;;AsB9iKE;EAAsC,gBAAA;AtBkjKxC;;AsBljKE;EAAsC,gBAAA;AtBsjKxC;;AsBtjKE;EAAsC,gBAAA;AtB0jKxC;;AsB1jKE;EAAsC,gBAAA;AtB8jKxC;;AsB9jKE;EAAsC,gBAAA;AtBkkKxC;;AsBlkKE;EAAsC,gBAAA;AtBskKxC;;AsBtkKE;EAAsC,gBAAA;AtB0kKxC;;AsB1kKE;EAAsC,gBAAA;AtB8kKxC;;AsB9kKE;EAAsC,gBAAA;AtBklKxC;;AsBllKE;EAAsC,gBAAA;AtBslKxC;;AsBtlKE;EAAsC,gBAAA;AtB0lKxC;;AsB1lKE;EAAsC,gBAAA;AtB8lKxC;;AsB9lKE;EAAsC,gBAAA;AtBkmKxC;;AsBlmKE;EAAsC,gBAAA;AtBsmKxC;;AsBtmKE;EAAsC,gBAAA;AtB0mKxC;;AsB1mKE;EAAsC,gBAAA;AtB8mKxC;;AsB9mKE;EAAsC,gBAAA;AtBknKxC;;AsBlnKE;EAAsC,gBAAA;AtBsnKxC;;AsBtnKE;EAAsC,gBAAA;AtB0nKxC;;AsB1nKE;EAAsC,gBAAA;AtB8nKxC;;AsB9nKE;EAAsC,gBAAA;AtBkoKxC;;AsBloKE;EAAsC,gBAAA;AtBsoKxC;;AsBtoKE;EAAsC,gBAAA;AtB0oKxC;;AsB1oKE;EAAsC,gBAAA;AtB8oKxC;;AsB9oKE;EAAsC,gBAAA;AtBkpKxC;;AsBlpKE;EAAsC,gBAAA;AtBspKxC;;AsBtpKE;EAAsC,gBAAA;AtB0pKxC;;AsB1pKE;EAAsC,gBAAA;AtB8pKxC;;AsB9pKE;EAAsC,gBAAA;AtBkqKxC;;AsBlqKE;EAAsC,gBAAA;AtBsqKxC;;AsBtqKE;EAAsC,gBAAA;AtB0qKxC;;AsB1qKE;EAAsC,gBAAA;AtB8qKxC;;AsB9qKE;EAAsC,gBAAA;AtBkrKxC;;AsBlrKE;EAAsC,gBAAA;AtBsrKxC;;AsBtrKE;EAAsC,gBAAA;AtB0rKxC;;AsB1rKE;EAAsC,gBAAA;AtB8rKxC;;AsB9rKE;EAAsC,gBAAA;AtBksKxC;;AsBlsKE;EAAsC,gBAAA;AtBssKxC;;AsBtsKE;EAAsC,gBAAA;AtB0sKxC;;AsB1sKE;EAAsC,gBAAA;AtB8sKxC;;AsB9sKE;EAAsC,gBAAA;AtBktKxC;;AsBltKE;EAAsC,gBAAA;AtBstKxC;;AsBttKE;EAAsC,gBAAA;AtB0tKxC;;AsB1tKE;EAAsC,gBAAA;AtB8tKxC;;AsB9tKE;EAAsC,gBAAA;AtBkuKxC;;AsBluKE;EAAsC,gBAAA;AtBsuKxC;;AsBtuKE;EAAsC,gBAAA;AtB0uKxC;;AsB1uKE;EAAsC,gBAAA;AtB8uKxC;;AsB9uKE;EAAsC,gBAAA;AtBkvKxC;;AsBlvKE;EAAsC,gBAAA;AtBsvKxC;;AsBtvKE;EAAsC,gBAAA;AtB0vKxC;;AsB1vKE;EAAsC,gBAAA;AtB8vKxC;;AsB9vKE;EAAsC,gBAAA;AtBkwKxC;;AsBlwKE;EAAsC,gBAAA;AtBswKxC;;AsBtwKE;EAAsC,gBAAA;AtB0wKxC;;AsB1wKE;EAAsC,gBAAA;AtB8wKxC;;AsB9wKE;EAAsC,gBAAA;AtBkxKxC;;AsBlxKE;EAAsC,gBAAA;AtBsxKxC;;AsBtxKE;EAAsC,gBAAA;AtB0xKxC;;AsB1xKE;EAAsC,gBAAA;AtB8xKxC;;AsB9xKE;EAAsC,gBAAA;AtBkyKxC;;AsBlyKE;EAAsC,gBAAA;AtBsyKxC;;AsBtyKE;EAAsC,gBAAA;AtB0yKxC;;AsB1yKE;EAAsC,YAAA;AtB8yKxC;;AsB9yKE;EAAsC,gBAAA;AtBkzKxC;;AsBlzKE;EAAsC,gBAAA;AtBszKxC;;AsBtzKE;EAAsC,gBAAA;AtB0zKxC;;AsB1zKE;EAAsC,gBAAA;AtB8zKxC;;AsB9zKE;EAAsC,gBAAA;AtBk0KxC;;AsBl0KE;EAAsC,gBAAA;AtBs0KxC;;AsBt0KE;EAAsC,gBAAA;AtB00KxC;;AsB10KE;EAAsC,gBAAA;AtB80KxC;;AsB90KE;EAAsC,gBAAA;AtBk1KxC;;AsBl1KE;EAAsC,gBAAA;AtBs1KxC;;AsBt1KE;EAAsC,gBAAA;AtB01KxC;;AsB11KE;EAAsC,gBAAA;AtB81KxC;;AsB91KE;EAAsC,gBAAA;AtBk2KxC;;AsBl2KE;EAAsC,gBAAA;AtBs2KxC;;AsBt2KE;EAAsC,gBAAA;AtB02KxC;;AsB12KE;EAAsC,gBAAA;AtB82KxC;;AsB92KE;EAAsC,gBAAA;AtBk3KxC;;AsBl3KE;EAAsC,gBAAA;AtBs3KxC;;AsBt3KE;EAAsC,gBAAA;AtB03KxC;;AsB13KE;EAAsC,gBAAA;AtB83KxC;;AsB93KE;EAAsC,gBAAA;AtBk4KxC;;AsBl4KE;EAAsC,gBAAA;AtBs4KxC;;AsBt4KE;EAAsC,gBAAA;AtB04KxC;;AsB14KE;EAAsC,gBAAA;AtB84KxC;;AsB94KE;EAAsC,gBAAA;AtBk5KxC;;AsBl5KE;EAAsC,gBAAA;AtBs5KxC;;AsBt5KE;EAAsC,gBAAA;AtB05KxC;;AsB15KE;EAAsC,gBAAA;AtB85KxC;;AsB95KE;EAAsC,gBAAA;AtBk6KxC;;AsBl6KE;EAAsC,gBAAA;AtBs6KxC;;AsBt6KE;EAAsC,gBAAA;AtB06KxC;;AsB16KE;EAAsC,gBAAA;AtB86KxC;;AsB96KE;EAAsC,gBAAA;AtBk7KxC;;AsBl7KE;EAAsC,gBAAA;AtBs7KxC;;AsBt7KE;EAAsC,gBAAA;AtB07KxC;;AsB17KE;EAAsC,gBAAA;AtB87KxC;;AsB97KE;EAAsC,gBAAA;AtBk8KxC;;AsBl8KE;EAAsC,gBAAA;AtBs8KxC;;AsBt8KE;EAAsC,gBAAA;AtB08KxC;;AsB18KE;EAAsC,gBAAA;AtB88KxC;;AsB98KE;EAAsC,gBAAA;AtBk9KxC;;AsBl9KE;EAAsC,gBAAA;AtBs9KxC;;AsBt9KE;EAAsC,gBAAA;AtB09KxC;;AsB19KE;EAAsC,gBAAA;AtB89KxC;;AsB99KE;EAAsC,gBAAA;AtBk+KxC;;AsBl+KE;EAAsC,gBAAA;AtBs+KxC;;AsBt+KE;EAAsC,gBAAA;AtB0+KxC;;AsB1+KE;EAAsC,gBAAA;AtB8+KxC;;AsB9+KE;EAAsC,gBAAA;AtBk/KxC;;AsBl/KE;EAAsC,gBAAA;AtBs/KxC;;AsBt/KE;EAAsC,gBAAA;AtB0/KxC;;AsB1/KE;EAAsC,gBAAA;AtB8/KxC;;AsB9/KE;EAAsC,gBAAA;AtBkgLxC;;AsBlgLE;EAAsC,gBAAA;AtBsgLxC;;AsBtgLE;EAAsC,gBAAA;AtB0gLxC;;AsB1gLE;EAAsC,gBAAA;AtB8gLxC;;AsB9gLE;EAAsC,gBAAA;AtBkhLxC;;AsBlhLE;EAAsC,gBAAA;AtBshLxC;;AsBthLE;EAAsC,gBAAA;AtB0hLxC;;AsB1hLE;EAAsC,aAAA;AtB8hLxC;;AsB9hLE;EAAsC,gBAAA;AtBkiLxC;;AsBliLE;EAAsC,gBAAA;AtBsiLxC;;AsBtiLE;EAAsC,gBAAA;AtB0iLxC;;AsB1iLE;EAAsC,gBAAA;AtB8iLxC;;AsB9iLE;EAAsC,gBAAA;AtBkjLxC;;AsBljLE;EAAsC,aAAA;AtBsjLxC;;AsBtjLE;EAAsC,aAAA;AtB0jLxC;;AsB1jLE;EAAsC,aAAA;AtB8jLxC;;AsB9jLE;EAAsC,gBAAA;AtBkkLxC;;AsBlkLE;EAAsC,gBAAA;AtBskLxC;;AsBtkLE;EAAsC,gBAAA;AtB0kLxC;;AsB1kLE;EAAsC,gBAAA;AtB8kLxC;;AsB9kLE;EAAsC,gBAAA;AtBklLxC;;AsBllLE;EAAsC,gBAAA;AtBslLxC;;AsBtlLE;EAAsC,gBAAA;AtB0lLxC;;AsB1lLE;EAAsC,gBAAA;AtB8lLxC;;AsB9lLE;EAAsC,gBAAA;AtBkmLxC;;AsBlmLE;EAAsC,gBAAA;AtBsmLxC;;AsBtmLE;EAAsC,gBAAA;AtB0mLxC;;AsB1mLE;EAAsC,gBAAA;AtB8mLxC;;AsB9mLE;EAAsC,gBAAA;AtBknLxC;;AsBlnLE;EAAsC,gBAAA;AtBsnLxC;;AsBtnLE;EAAsC,gBAAA;AtB0nLxC;;AsB1nLE;EAAsC,gBAAA;AtB8nLxC;;AsB9nLE;EAAsC,gBAAA;AtBkoLxC;;AsBloLE;EAAsC,gBAAA;AtBsoLxC;;AsBtoLE;EAAsC,gBAAA;AtB0oLxC;;AsB1oLE;EAAsC,gBAAA;AtB8oLxC;;AsB9oLE;EAAsC,gBAAA;AtBkpLxC;;AsBlpLE;EAAsC,gBAAA;AtBspLxC;;AsBtpLE;EAAsC,gBAAA;AtB0pLxC;;AsB1pLE;EAAsC,gBAAA;AtB8pLxC;;AsB9pLE;EAAsC,gBAAA;AtBkqLxC;;AsBlqLE;EAAsC,gBAAA;AtBsqLxC;;AsBtqLE;EAAsC,gBAAA;AtB0qLxC;;AsB1qLE;EAAsC,gBAAA;AtB8qLxC;;AsB9qLE;EAAsC,gBAAA;AtBkrLxC;;AsBlrLE;EAAsC,gBAAA;AtBsrLxC;;AsBtrLE;EAAsC,gBAAA;AtB0rLxC;;AsB1rLE;EAAsC,gBAAA;AtB8rLxC;;AsB9rLE;EAAsC,gBAAA;AtBksLxC;;AsBlsLE;EAAsC,gBAAA;AtBssLxC;;AsBtsLE;EAAsC,gBAAA;AtB0sLxC;;AsB1sLE;EAAsC,gBAAA;AtB8sLxC;;AsB9sLE;EAAsC,gBAAA;AtBktLxC;;AsBltLE;EAAsC,gBAAA;AtBstLxC;;AsBttLE;EAAsC,gBAAA;AtB0tLxC;;AsB1tLE;EAAsC,gBAAA;AtB8tLxC;;AsB9tLE;EAAsC,gBAAA;AtBkuLxC;;AsBluLE;EAAsC,gBAAA;AtBsuLxC;;AsBtuLE;EAAsC,gBAAA;AtB0uLxC;;AsB1uLE;EAAsC,gBAAA;AtB8uLxC;;AsB9uLE;EAAsC,gBAAA;AtBkvLxC;;AsBlvLE;EAAsC,gBAAA;AtBsvLxC;;AsBtvLE;EAAsC,gBAAA;AtB0vLxC;;AsB1vLE;EAAsC,gBAAA;AtB8vLxC;;AsB9vLE;EAAsC,gBAAA;AtBkwLxC;;AsBlwLE;EAAsC,gBAAA;AtBswLxC;;AsBtwLE;EAAsC,gBAAA;AtB0wLxC;;AsB1wLE;EAAsC,gBAAA;AtB8wLxC;;AsB9wLE;EAAsC,gBAAA;AtBkxLxC;;AsBlxLE;EAAsC,YAAA;AtBsxLxC;;AsBtxLE;EAAsC,gBAAA;AtB0xLxC;;AsB1xLE;EAAsC,gBAAA;AtB8xLxC;;AsB9xLE;EAAsC,gBAAA;AtBkyLxC;;AsBlyLE;EAAsC,gBAAA;AtBsyLxC;;AsBtyLE;EAAsC,gBAAA;AtB0yLxC;;AsB1yLE;EAAsC,gBAAA;AtB8yLxC;;AsB9yLE;EAAsC,gBAAA;AtBkzLxC;;AsBlzLE;EAAsC,gBAAA;AtBszLxC;;AsBtzLE;EAAsC,gBAAA;AtB0zLxC;;AsB1zLE;EAAsC,gBAAA;AtB8zLxC;;AsB9zLE;EAAsC,gBAAA;AtBk0LxC;;AsBl0LE;EAAsC,gBAAA;AtBs0LxC;;AsBt0LE;EAAsC,gBAAA;AtB00LxC;;AsB10LE;EAAsC,gBAAA;AtB80LxC;;AsB90LE;EAAsC,gBAAA;AtBk1LxC;;AsBl1LE;EAAsC,gBAAA;AtBs1LxC;;AsBt1LE;EAAsC,gBAAA;AtB01LxC;;AsB11LE;EAAsC,gBAAA;AtB81LxC;;AsB91LE;EAAsC,gBAAA;AtBk2LxC;;AsBl2LE;EAAsC,gBAAA;AtBs2LxC;;AsBt2LE;EAAsC,gBAAA;AtB02LxC;;AsB12LE;EAAsC,gBAAA;AtB82LxC;;AsB92LE;EAAsC,gBAAA;AtBk3LxC;;AsBl3LE;EAAsC,gBAAA;AtBs3LxC;;AsBt3LE;EAAsC,gBAAA;AtB03LxC;;AsB13LE;EAAsC,gBAAA;AtB83LxC;;AsB93LE;EAAsC,gBAAA;AtBk4LxC;;AsBl4LE;EAAsC,gBAAA;AtBs4LxC;;AsBt4LE;EAAsC,gBAAA;AtB04LxC;;AsB14LE;EAAsC,gBAAA;AtB84LxC;;AsB94LE;EAAsC,gBAAA;AtBk5LxC;;AsBl5LE;EAAsC,gBAAA;AtBs5LxC;;AsBt5LE;EAAsC,gBAAA;AtB05LxC;;AsB15LE;EAAsC,gBAAA;AtB85LxC;;AsB95LE;EAAsC,gBAAA;AtBk6LxC;;AsBl6LE;EAAsC,gBAAA;AtBs6LxC;;AsBt6LE;EAAsC,gBAAA;AtB06LxC;;AsB16LE;EAAsC,gBAAA;AtB86LxC;;AsB96LE;EAAsC,gBAAA;AtBk7LxC;;AsBl7LE;EAAsC,gBAAA;AtBs7LxC;;AsBt7LE;EAAsC,gBAAA;AtB07LxC;;AsB17LE;EAAsC,gBAAA;AtB87LxC;;AsB97LE;EAAsC,gBAAA;AtBk8LxC;;AsBl8LE;EAAsC,gBAAA;AtBs8LxC;;AsBt8LE;EAAsC,gBAAA;AtB08LxC;;AsB18LE;EAAsC,aAAA;AtB88LxC;;AsB98LE;EAAsC,gBAAA;AtBk9LxC;;AsBl9LE;EAAsC,gBAAA;AtBs9LxC;;AsBt9LE;EAAsC,gBAAA;AtB09LxC;;AsB19LE;EAAsC,gBAAA;AtB89LxC;;AsB99LE;EAAsC,gBAAA;AtBk+LxC;;AsBl+LE;EAAsC,gBAAA;AtBs+LxC;;AsBt+LE;EAAsC,aAAA;AtB0+LxC;;AsB1+LE;EAAsC,gBAAA;AtB8+LxC;;AsB9+LE;EAAsC,gBAAA;AtBk/LxC;;AsBl/LE;EAAsC,gBAAA;AtBs/LxC;;AsBt/LE;EAAsC,gBAAA;AtB0/LxC;;AsB1/LE;EAAsC,gBAAA;AtB8/LxC;;AsB9/LE;EAAsC,gBAAA;AtBkgMxC;;AsBlgME;EAAsC,gBAAA;AtBsgMxC;;AsBtgME;EAAsC,gBAAA;AtB0gMxC;;AsB1gME;EAAsC,gBAAA;AtB8gMxC;;AsB9gME;EAAsC,gBAAA;AtBkhMxC;;AsBlhME;EAAsC,gBAAA;AtBshMxC;;AsBthME;EAAsC,gBAAA;AtB0hMxC;;AsB1hME;EAAsC,gBAAA;AtB8hMxC;;AsB9hME;EAAsC,YAAA;AtBkiMxC;;AsBliME;EAAsC,gBAAA;AtBsiMxC;;AsBtiME;EAAsC,gBAAA;AtB0iMxC;;AsB1iME;EAAsC,gBAAA;AtB8iMxC;;AsB9iME;EAAsC,gBAAA;AtBkjMxC;;AsBljME;EAAsC,gBAAA;AtBsjMxC;;AsBtjME;EAAsC,gBAAA;AtB0jMxC;;AsB1jME;EAAsC,gBAAA;AtB8jMxC;;AsB9jME;EAAsC,gBAAA;AtBkkMxC;;AsBlkME;EAAsC,gBAAA;AtBskMxC;;AsBtkME;EAAsC,gBAAA;AtB0kMxC;;AsB1kME;EAAsC,gBAAA;AtB8kMxC;;AsB9kME;EAAsC,gBAAA;AtBklMxC;;AsBllME;EAAsC,gBAAA;AtBslMxC;;AsBtlME;EAAsC,gBAAA;AtB0lMxC;;AsB1lME;EAAsC,gBAAA;AtB8lMxC;;AsB9lME;EAAsC,gBAAA;AtBkmMxC;;AsBlmME;EAAsC,gBAAA;AtBsmMxC;;AsBtmME;EAAsC,gBAAA;AtB0mMxC;;AsB1mME;EAAsC,gBAAA;AtB8mMxC;;AsB9mME;EAAsC,gBAAA;AtBknMxC;;AsBlnME;EAAsC,gBAAA;AtBsnMxC;;AsBtnME;EAAsC,gBAAA;AtB0nMxC;;AsB1nME;EAAsC,gBAAA;AtB8nMxC;;AsB9nME;EAAsC,gBAAA;AtBkoMxC;;AsBloME;EAAsC,gBAAA;AtBsoMxC;;AsBtoME;EAAsC,gBAAA;AtB0oMxC;;AsB1oME;EAAsC,gBAAA;AtB8oMxC;;AsB9oME;EAAsC,gBAAA;AtBkpMxC;;AsBlpME;EAAsC,gBAAA;AtBspMxC;;AsBtpME;EAAsC,gBAAA;AtB0pMxC;;AsB1pME;EAAsC,gBAAA;AtB8pMxC;;AsB9pME;EAAsC,gBAAA;AtBkqMxC;;AsBlqME;EAAsC,gBAAA;AtBsqMxC;;AsBtqME;EAAsC,gBAAA;AtB0qMxC;;AsB1qME;EAAsC,gBAAA;AtB8qMxC;;AsB9qME;EAAsC,gBAAA;AtBkrMxC;;AsBlrME;EAAsC,gBAAA;AtBsrMxC;;AsBtrME;EAAsC,gBAAA;AtB0rMxC;;AsB1rME;EAAsC,gBAAA;AtB8rMxC;;AsB9rME;EAAsC,gBAAA;AtBksMxC;;AsBlsME;EAAsC,gBAAA;AtBssMxC;;AsBtsME;EAAsC,gBAAA;AtB0sMxC;;AsB1sME;EAAsC,gBAAA;AtB8sMxC;;AsB9sME;EAAsC,gBAAA;AtBktMxC;;AsBltME;EAAsC,gBAAA;AtBstMxC;;AsBttME;EAAsC,gBAAA;AtB0tMxC;;AsB1tME;EAAsC,gBAAA;AtB8tMxC;;AsB9tME;EAAsC,gBAAA;AtBkuMxC;;AsBluME;EAAsC,gBAAA;AtBsuMxC;;AsBtuME;EAAsC,gBAAA;AtB0uMxC;;AsB1uME;EAAsC,gBAAA;AtB8uMxC;;AsB9uME;EAAsC,gBAAA;AtBkvMxC;;AsBlvME;EAAsC,gBAAA;AtBsvMxC;;AsBtvME;EAAsC,gBAAA;AtB0vMxC;;AsB1vME;EAAsC,gBAAA;AtB8vMxC;;AsB9vME;EAAsC,gBAAA;AtBkwMxC;;AsBlwME;EAAsC,gBAAA;AtBswMxC;;AsBtwME;EAAsC,gBAAA;AtB0wMxC;;AsB1wME;EAAsC,gBAAA;AtB8wMxC;;AsB9wME;EAAsC,gBAAA;AtBkxMxC;;AsBlxME;EAAsC,gBAAA;AtBsxMxC;;AsBtxME;EAAsC,gBAAA;AtB0xMxC;;AsB1xME;EAAsC,gBAAA;AtB8xMxC;;AsB9xME;EAAsC,gBAAA;AtBkyMxC;;AsBlyME;EAAsC,gBAAA;AtBsyMxC;;AsBtyME;EAAsC,gBAAA;AtB0yMxC;;AsB1yME;EAAsC,gBAAA;AtB8yMxC;;AsB9yME;EAAsC,gBAAA;AtBkzMxC;;AsBlzME;EAAsC,gBAAA;AtBszMxC;;AsBtzME;EAAsC,gBAAA;AtB0zMxC;;AsB1zME;EAAsC,gBAAA;AtB8zMxC;;AsB9zME;EAAsC,gBAAA;AtBk0MxC;;AsBl0ME;EAAsC,gBAAA;AtBs0MxC;;AsBt0ME;EAAsC,gBAAA;AtB00MxC;;AsB10ME;EAAsC,gBAAA;AtB80MxC;;AsB90ME;EAAsC,gBAAA;AtBk1MxC;;AsBl1ME;EAAsC,gBAAA;AtBs1MxC;;AsBt1ME;EAAsC,gBAAA;AtB01MxC;;AsB11ME;EAAsC,gBAAA;AtB81MxC;;AsB91ME;EAAsC,gBAAA;AtBk2MxC;;AsBl2ME;EAAsC,gBAAA;AtBs2MxC;;AsBt2ME;EAAsC,gBAAA;AtB02MxC;;AsB12ME;EAAsC,gBAAA;AtB82MxC;;AsB92ME;EAAsC,gBAAA;AtBk3MxC;;AsBl3ME;EAAsC,gBAAA;AtBs3MxC;;AsBt3ME;EAAsC,gBAAA;AtB03MxC;;AsB13ME;EAAsC,gBAAA;AtB83MxC;;AsB93ME;EAAsC,gBAAA;AtBk4MxC;;AsBl4ME;EAAsC,gBAAA;AtBs4MxC;;AsBt4ME;EAAsC,gBAAA;AtB04MxC;;AsB14ME;EAAsC,gBAAA;AtB84MxC;;AsB94ME;EAAsC,gBAAA;AtBk5MxC;;AsBl5ME;EAAsC,gBAAA;AtBs5MxC;;AsBt5ME;EAAsC,gBAAA;AtB05MxC;;AsB15ME;EAAsC,gBAAA;AtB85MxC;;AsB95ME;EAAsC,gBAAA;AtBk6MxC;;AsBl6ME;EAAsC,gBAAA;AtBs6MxC;;AsBt6ME;EAAsC,gBAAA;AtB06MxC;;AsB16ME;EAAsC,gBAAA;AtB86MxC;;AsB96ME;EAAsC,gBAAA;AtBk7MxC;;AsBl7ME;EAAsC,gBAAA;AtBs7MxC;;AsBt7ME;EAAsC,gBAAA;AtB07MxC;;AsB17ME;EAAsC,gBAAA;AtB87MxC;;AsB97ME;EAAsC,gBAAA;AtBk8MxC;;AsBl8ME;EAAsC,gBAAA;AtBs8MxC;;AsBt8ME;EAAsC,gBAAA;AtB08MxC;;AsB18ME;EAAsC,gBAAA;AtB88MxC;;AsB98ME;EAAsC,gBAAA;AtBk9MxC;;AsBl9ME;EAAsC,gBAAA;AtBs9MxC;;AsBt9ME;EAAsC,gBAAA;AtB09MxC;;AsB19ME;EAAsC,gBAAA;AtB89MxC;;AsB99ME;EAAsC,gBAAA;AtBk+MxC;;AsBl+ME;EAAsC,gBAAA;AtBs+MxC;;AsBt+ME;EAAsC,gBAAA;AtB0+MxC;;AsB1+ME;EAAsC,gBAAA;AtB8+MxC;;AsB9+ME;EAAsC,gBAAA;AtBk/MxC;;AsBl/ME;EAAsC,gBAAA;AtBs/MxC;;AsBt/ME;EAAsC,gBAAA;AtB0/MxC;;AsB1/ME;EAAsC,gBAAA;AtB8/MxC;;AsB9/ME;EAAsC,gBAAA;AtBkgNxC;;AsBlgNE;EAAsC,gBAAA;AtBsgNxC;;AsBtgNE;EAAsC,gBAAA;AtB0gNxC;;AsB1gNE;EAAsC,gBAAA;AtB8gNxC;;AsB9gNE;EAAsC,gBAAA;AtBkhNxC;;AsBlhNE;EAAsC,gBAAA;AtBshNxC;;AsBthNE;EAAsC,gBAAA;AtB0hNxC;;AsB1hNE;EAAsC,gBAAA;AtB8hNxC;;AsB9hNE;EAAsC,gBAAA;AtBkiNxC;;AsBliNE;EAAsC,gBAAA;AtBsiNxC;;AsBtiNE;EAAsC,gBAAA;AtB0iNxC;;AsB1iNE;EAAsC,gBAAA;AtB8iNxC;;AsB9iNE;EAAsC,gBAAA;AtBkjNxC;;AsBljNE;EAAsC,gBAAA;AtBsjNxC;;AsBtjNE;EAAsC,gBAAA;AtB0jNxC;;AsB1jNE;EAAsC,gBAAA;AtB8jNxC;;AsB9jNE;EAAsC,gBAAA;AtBkkNxC;;AsBlkNE;EAAsC,gBAAA;AtBskNxC;;AsBtkNE;EAAsC,gBAAA;AtB0kNxC;;AsB1kNE;EAAsC,gBAAA;AtB8kNxC;;AsB9kNE;EAAsC,gBAAA;AtBklNxC;;AsBllNE;EAAsC,gBAAA;AtBslNxC;;AsBtlNE;EAAsC,gBAAA;AtB0lNxC;;AsB1lNE;EAAsC,gBAAA;AtB8lNxC;;AsB9lNE;EAAsC,gBAAA;AtBkmNxC;;AsBlmNE;EAAsC,gBAAA;AtBsmNxC;;AsBtmNE;EAAsC,gBAAA;AtB0mNxC;;AsB1mNE;EAAsC,gBAAA;AtB8mNxC;;AsB9mNE;EAAsC,gBAAA;AtBknNxC;;AsBlnNE;EAAsC,gBAAA;AtBsnNxC;;AsBtnNE;EAAsC,gBAAA;AtB0nNxC;;AsB1nNE;EAAsC,gBAAA;AtB8nNxC;;AsB9nNE;EAAsC,gBAAA;AtBkoNxC;;AsBloNE;EAAsC,gBAAA;AtBsoNxC;;AsBtoNE;EAAsC,gBAAA;AtB0oNxC;;AsB1oNE;EAAsC,gBAAA;AtB8oNxC;;AsB9oNE;EAAsC,gBAAA;AtBkpNxC;;AsBlpNE;EAAsC,gBAAA;AtBspNxC;;AsBtpNE;EAAsC,gBAAA;AtB0pNxC;;AsB1pNE;EAAsC,gBAAA;AtB8pNxC;;AsB9pNE;EAAsC,gBAAA;AtBkqNxC;;AsBlqNE;EAAsC,gBAAA;AtBsqNxC;;AsBtqNE;EAAsC,gBAAA;AtB0qNxC;;AsB1qNE;EAAsC,gBAAA;AtB8qNxC;;AsB9qNE;EAAsC,gBAAA;AtBkrNxC;;AsBlrNE;EAAsC,gBAAA;AtBsrNxC;;AsBtrNE;EAAsC,gBAAA;AtB0rNxC;;AsB1rNE;EAAsC,gBAAA;AtB8rNxC;;AsB9rNE;EAAsC,gBAAA;AtBksNxC;;AsBlsNE;EAAsC,gBAAA;AtBssNxC;;AsBtsNE;EAAsC,gBAAA;AtB0sNxC;;AsB1sNE;EAAsC,gBAAA;AtB8sNxC;;AsB9sNE;EAAsC,gBAAA;AtBktNxC;;AsBltNE;EAAsC,gBAAA;AtBstNxC;;AsBttNE;EAAsC,gBAAA;AtB0tNxC;;AsB1tNE;EAAsC,gBAAA;AtB8tNxC;;AsB9tNE;EAAsC,gBAAA;AtBkuNxC;;AsBluNE;EAAsC,gBAAA;AtBsuNxC;;AsBtuNE;EAAsC,gBAAA;AtB0uNxC;;AsB1uNE;EAAsC,gBAAA;AtB8uNxC;;AsB9uNE;EAAsC,gBAAA;AtBkvNxC;;AsBlvNE;EAAsC,gBAAA;AtBsvNxC;;AsBtvNE;EAAsC,gBAAA;AtB0vNxC;;AsB1vNE;EAAsC,gBAAA;AtB8vNxC;;AsB9vNE;EAAsC,gBAAA;AtBkwNxC;;AsBlwNE;EAAsC,gBAAA;AtBswNxC;;AsBtwNE;EAAsC,gBAAA;AtB0wNxC;;AsB1wNE;EAAsC,gBAAA;AtB8wNxC;;AsB9wNE;EAAsC,gBAAA;AtBkxNxC;;AsBlxNE;EAAsC,gBAAA;AtBsxNxC;;AsBtxNE;EAAsC,gBAAA;AtB0xNxC;;AsB1xNE;EAAsC,gBAAA;AtB8xNxC;;AsB9xNE;EAAsC,gBAAA;AtBkyNxC;;AsBlyNE;EAAsC,gBAAA;AtBsyNxC;;AsBtyNE;EAAsC,gBAAA;AtB0yNxC;;AsB1yNE;EAAsC,gBAAA;AtB8yNxC;;AsB9yNE;EAAsC,gBAAA;AtBkzNxC;;AsBlzNE;EAAsC,gBAAA;AtBszNxC;;AsBtzNE;EAAsC,gBAAA;AtB0zNxC;;AsB1zNE;EAAsC,gBAAA;AtB8zNxC;;AsB9zNE;EAAsC,gBAAA;AtBk0NxC;;AsBl0NE;EAAsC,gBAAA;AtBs0NxC;;AsBt0NE;EAAsC,gBAAA;AtB00NxC;;AsB10NE;EAAsC,gBAAA;AtB80NxC;;AsB90NE;EAAsC,gBAAA;AtBk1NxC;;AsBl1NE;EAAsC,gBAAA;AtBs1NxC;;AsBt1NE;EAAsC,gBAAA;AtB01NxC;;AsB11NE;EAAsC,gBAAA;AtB81NxC;;AsB91NE;EAAsC,gBAAA;AtBk2NxC;;AsBl2NE;EAAsC,gBAAA;AtBs2NxC;;AsBt2NE;EAAsC,gBAAA;AtB02NxC;;AsB12NE;EAAsC,gBAAA;AtB82NxC;;AsB92NE;EAAsC,gBAAA;AtBk3NxC;;AsBl3NE;EAAsC,gBAAA;AtBs3NxC;;AsBt3NE;EAAsC,gBAAA;AtB03NxC;;AsB13NE;EAAsC,gBAAA;AtB83NxC;;AsB93NE;EAAsC,gBAAA;AtBk4NxC;;AsBl4NE;EAAsC,gBAAA;AtBs4NxC;;AsBt4NE;EAAsC,gBAAA;AtB04NxC;;AsB14NE;EAAsC,gBAAA;AtB84NxC;;AsB94NE;EAAsC,gBAAA;AtBk5NxC;;AsBl5NE;EAAsC,gBAAA;AtBs5NxC;;AsBt5NE;EAAsC,gBAAA;AtB05NxC;;AsB15NE;EAAsC,gBAAA;AtB85NxC;;AsB95NE;EAAsC,gBAAA;AtBk6NxC;;AsBl6NE;EAAsC,gBAAA;AtBs6NxC;;AsBt6NE;EAAsC,gBAAA;AtB06NxC;;AsB16NE;EAAsC,gBAAA;AtB86NxC;;AsB96NE;EAAsC,gBAAA;AtBk7NxC;;AsBl7NE;EAAsC,gBAAA;AtBs7NxC;;AsBt7NE;EAAsC,gBAAA;AtB07NxC;;AsB17NE;EAAsC,gBAAA;AtB87NxC;;AsB97NE;EAAsC,gBAAA;AtBk8NxC;;AsBl8NE;EAAsC,gBAAA;AtBs8NxC;;AsBt8NE;EAAsC,gBAAA;AtB08NxC;;AsB18NE;EAAsC,gBAAA;AtB88NxC;;AsB98NE;EAAsC,gBAAA;AtBk9NxC;;AsBl9NE;EAAsC,gBAAA;AtBs9NxC;;AsBt9NE;EAAsC,gBAAA;AtB09NxC;;AsB19NE;EAAsC,gBAAA;AtB89NxC;;AsB99NE;EAAsC,gBAAA;AtBk+NxC;;AsBl+NE;EAAsC,gBAAA;AtBs+NxC;;AsBt+NE;EAAsC,gBAAA;AtB0+NxC;;AsB1+NE;EAAsC,gBAAA;AtB8+NxC;;AsB9+NE;EAAsC,gBAAA;AtBk/NxC;;AsBl/NE;EAAsC,gBAAA;AtBs/NxC;;AsBt/NE;EAAsC,gBAAA;AtB0/NxC;;AsB1/NE;EAAsC,gBAAA;AtB8/NxC;;AsB9/NE;EAAsC,gBAAA;AtBkgOxC;;AsBlgOE;EAAsC,gBAAA;AtBsgOxC;;AsBtgOE;EAAsC,gBAAA;AtB0gOxC;;AsB1gOE;EAAsC,gBAAA;AtB8gOxC;;AsB9gOE;EAAsC,gBAAA;AtBkhOxC;;AsBlhOE;EAAsC,gBAAA;AtBshOxC;;AsBthOE;EAAsC,gBAAA;AtB0hOxC;;AsB1hOE;EAAsC,gBAAA;AtB8hOxC;;AsB9hOE;EAAsC,gBAAA;AtBkiOxC;;AsBliOE;EAAsC,gBAAA;AtBsiOxC;;AsBtiOE;EAAsC,gBAAA;AtB0iOxC;;AsB1iOE;EAAsC,gBAAA;AtB8iOxC;;AsB9iOE;EAAsC,gBAAA;AtBkjOxC;;AsBljOE;EAAsC,gBAAA;AtBsjOxC;;AsBtjOE;EAAsC,gBAAA;AtB0jOxC;;AsB1jOE;EAAsC,gBAAA;AtB8jOxC;;AsB9jOE;EAAsC,gBAAA;AtBkkOxC;;AsBlkOE;EAAsC,gBAAA;AtBskOxC;;AsBtkOE;EAAsC,gBAAA;AtB0kOxC;;AsB1kOE;EAAsC,gBAAA;AtB8kOxC;;AsB9kOE;EAAsC,gBAAA;AtBklOxC;;AsBllOE;EAAsC,gBAAA;AtBslOxC;;AsBtlOE;EAAsC,gBAAA;AtB0lOxC;;AsB1lOE;EAAsC,gBAAA;AtB8lOxC;;AsB9lOE;EAAsC,gBAAA;AtBkmOxC;;AsBlmOE;EAAsC,gBAAA;AtBsmOxC;;AsBtmOE;EAAsC,gBAAA;AtB0mOxC;;AsB1mOE;EAAsC,gBAAA;AtB8mOxC;;AsB9mOE;EAAsC,gBAAA;AtBknOxC;;AsBlnOE;EAAsC,gBAAA;AtBsnOxC;;AsBtnOE;EAAsC,gBAAA;AtB0nOxC;;AsB1nOE;EAAsC,gBAAA;AtB8nOxC;;AsB9nOE;EAAsC,gBAAA;AtBkoOxC;;AsBloOE;EAAsC,gBAAA;AtBsoOxC;;AsBtoOE;EAAsC,gBAAA;AtB0oOxC;;AsB1oOE;EAAsC,gBAAA;AtB8oOxC;;AsB9oOE;EAAsC,gBAAA;AtBkpOxC;;AsBlpOE;EAAsC,gBAAA;AtBspOxC;;AsBtpOE;EAAsC,gBAAA;AtB0pOxC;;AsB1pOE;EAAsC,gBAAA;AtB8pOxC;;AsB9pOE;EAAsC,gBAAA;AtBkqOxC;;AsBlqOE;EAAsC,gBAAA;AtBsqOxC;;AsBtqOE;EAAsC,gBAAA;AtB0qOxC;;AsB1qOE;EAAsC,gBAAA;AtB8qOxC;;AsB9qOE;EAAsC,gBAAA;AtBkrOxC;;AsBlrOE;EAAsC,gBAAA;AtBsrOxC;;AsBtrOE;EAAsC,gBAAA;AtB0rOxC;;AsB1rOE;EAAsC,gBAAA;AtB8rOxC;;AsB9rOE;EAAsC,gBAAA;AtBksOxC;;AsBlsOE;EAAsC,gBAAA;AtBssOxC;;AsBtsOE;EAAsC,gBAAA;AtB0sOxC;;AsB1sOE;EAAsC,gBAAA;AtB8sOxC;;AsB9sOE;EAAsC,gBAAA;AtBktOxC;;AsBltOE;EAAsC,gBAAA;AtBstOxC;;AsBttOE;EAAsC,gBAAA;AtB0tOxC;;AsB1tOE;EAAsC,gBAAA;AtB8tOxC;;AsB9tOE;EAAsC,gBAAA;AtBkuOxC;;AsBluOE;EAAsC,gBAAA;AtBsuOxC;;AsBtuOE;EAAsC,gBAAA;AtB0uOxC;;AsB1uOE;EAAsC,gBAAA;AtB8uOxC;;AsB9uOE;EAAsC,gBAAA;AtBkvOxC;;AsBlvOE;EAAsC,gBAAA;AtBsvOxC;;AsBtvOE;EAAsC,gBAAA;AtB0vOxC;;AsB1vOE;EAAsC,gBAAA;AtB8vOxC;;AsB9vOE;EAAsC,gBAAA;AtBkwOxC;;AsBlwOE;EAAsC,gBAAA;AtBswOxC;;AsBtwOE;EAAsC,gBAAA;AtB0wOxC;;AsB1wOE;EAAsC,gBAAA;AtB8wOxC;;AsB9wOE;EAAsC,gBAAA;AtBkxOxC;;AsBlxOE;EAAsC,gBAAA;AtBsxOxC;;AsBtxOE;EAAsC,gBAAA;AtB0xOxC;;AsB1xOE;EAAsC,gBAAA;AtB8xOxC;;AsB9xOE;EAAsC,gBAAA;AtBkyOxC;;AsBlyOE;EAAsC,gBAAA;AtBsyOxC;;AsBtyOE;EAAsC,gBAAA;AtB0yOxC;;AsB1yOE;EAAsC,gBAAA;AtB8yOxC;;AsB9yOE;EAAsC,gBAAA;AtBkzOxC;;AsBlzOE;EAAsC,gBAAA;AtBszOxC;;AsBtzOE;EAAsC,gBAAA;AtB0zOxC;;AsB1zOE;EAAsC,gBAAA;AtB8zOxC;;AsB9zOE;EAAsC,YAAA;AtBk0OxC;;AsBl0OE;EAAsC,gBAAA;AtBs0OxC;;AsBt0OE;EAAsC,gBAAA;AtB00OxC;;AsB10OE;EAAsC,gBAAA;AtB80OxC;;AsB90OE;EAAsC,gBAAA;AtBk1OxC;;AsBl1OE;EAAsC,gBAAA;AtBs1OxC;;AsBt1OE;EAAsC,gBAAA;AtB01OxC;;AsB11OE;EAAsC,gBAAA;AtB81OxC;;AsB91OE;EAAsC,gBAAA;AtBk2OxC;;AsBl2OE;EAAsC,gBAAA;AtBs2OxC;;AsBt2OE;EAAsC,gBAAA;AtB02OxC;;AsB12OE;EAAsC,gBAAA;AtB82OxC;;AsB92OE;EAAsC,gBAAA;AtBk3OxC;;AsBl3OE;EAAsC,gBAAA;AtBs3OxC;;AsBt3OE;EAAsC,gBAAA;AtB03OxC;;AsB13OE;EAAsC,gBAAA;AtB83OxC;;AsB93OE;EAAsC,gBAAA;AtBk4OxC;;AsBl4OE;EAAsC,gBAAA;AtBs4OxC;;AsBt4OE;EAAsC,gBAAA;AtB04OxC;;AsB14OE;EAAsC,gBAAA;AtB84OxC;;AsB94OE;EAAsC,gBAAA;AtBk5OxC;;AsBl5OE;EAAsC,gBAAA;AtBs5OxC;;AsBt5OE;EAAsC,gBAAA;AtB05OxC;;AsB15OE;EAAsC,gBAAA;AtB85OxC;;AsB95OE;EAAsC,gBAAA;AtBk6OxC;;AsBl6OE;EAAsC,gBAAA;AtBs6OxC;;AsBt6OE;EAAsC,gBAAA;AtB06OxC;;AsB16OE;EAAsC,gBAAA;AtB86OxC;;AsB96OE;EAAsC,gBAAA;AtBk7OxC;;AsBl7OE;EAAsC,gBAAA;AtBs7OxC;;AsBt7OE;EAAsC,gBAAA;AtB07OxC;;AsB17OE;EAAsC,gBAAA;AtB87OxC;;AsB97OE;EAAsC,gBAAA;AtBk8OxC;;AsBl8OE;EAAsC,gBAAA;AtBs8OxC;;AsBt8OE;EAAsC,gBAAA;AtB08OxC;;AsB18OE;EAAsC,gBAAA;AtB88OxC;;AsB98OE;EAAsC,gBAAA;AtBk9OxC;;AsBl9OE;EAAsC,gBAAA;AtBs9OxC;;AsBt9OE;EAAsC,gBAAA;AtB09OxC;;AsB19OE;EAAsC,gBAAA;AtB89OxC;;AsB99OE;EAAsC,gBAAA;AtBk+OxC;;AsBl+OE;EAAsC,gBAAA;AtBs+OxC;;AsBt+OE;EAAsC,gBAAA;AtB0+OxC;;AsB1+OE;EAAsC,gBAAA;AtB8+OxC;;AsB9+OE;EAAsC,gBAAA;AtBk/OxC;;AsBl/OE;EAAsC,gBAAA;AtBs/OxC;;AsBt/OE;EAAsC,gBAAA;AtB0/OxC;;AsB1/OE;EAAsC,gBAAA;AtB8/OxC;;AsB9/OE;EAAsC,gBAAA;AtBkgPxC;;AsBlgPE;EAAsC,gBAAA;AtBsgPxC;;AsBtgPE;EAAsC,gBAAA;AtB0gPxC;;AsB1gPE;EAAsC,gBAAA;AtB8gPxC;;AsB9gPE;EAAsC,gBAAA;AtBkhPxC;;AsBlhPE;EAAsC,gBAAA;AtBshPxC;;AsBthPE;EAAsC,gBAAA;AtB0hPxC;;AsB1hPE;EAAsC,gBAAA;AtB8hPxC;;AsB9hPE;EAAsC,gBAAA;AtBkiPxC;;AsBliPE;EAAsC,gBAAA;AtBsiPxC;;AsBtiPE;EAAsC,gBAAA;AtB0iPxC;;AsB1iPE;EAAsC,gBAAA;AtB8iPxC;;AsB9iPE;EAAsC,gBAAA;AtBkjPxC;;AsBljPE;EAAsC,gBAAA;AtBsjPxC;;AsBtjPE;EAAsC,gBAAA;AtB0jPxC;;AsB1jPE;EAAsC,gBAAA;AtB8jPxC;;AsB9jPE;EAAsC,gBAAA;AtBkkPxC;;AsBlkPE;EAAsC,gBAAA;AtBskPxC;;AsBtkPE;EAAsC,gBAAA;AtB0kPxC;;AsB1kPE;EAAsC,gBAAA;AtB8kPxC;;AsB9kPE;EAAsC,gBAAA;AtBklPxC;;AsBllPE;EAAsC,gBAAA;AtBslPxC;;AsBtlPE;EAAsC,gBAAA;AtB0lPxC;;AsB1lPE;EAAsC,gBAAA;AtB8lPxC;;AsB9lPE;EAAsC,gBAAA;AtBkmPxC;;AsBlmPE;EAAsC,gBAAA;AtBsmPxC;;AsBtmPE;EAAsC,gBAAA;AtB0mPxC;;AsB1mPE;EAAsC,gBAAA;AtB8mPxC;;AsB9mPE;EAAsC,gBAAA;AtBknPxC;;AsBlnPE;EAAsC,gBAAA;AtBsnPxC;;AsBtnPE;EAAsC,aAAA;AtB0nPxC;;AsB1nPE;EAAsC,gBAAA;AtB8nPxC;;AsB9nPE;EAAsC,gBAAA;AtBkoPxC;;AsBloPE;EAAsC,gBAAA;AtBsoPxC;;AsBtoPE;EAAsC,gBAAA;AtB0oPxC;;AsB1oPE;EAAsC,gBAAA;AtB8oPxC;;AsB9oPE;EAAsC,gBAAA;AtBkpPxC;;AsBlpPE;EAAsC,gBAAA;AtBspPxC;;AsBtpPE;EAAsC,gBAAA;AtB0pPxC;;AsB1pPE;EAAsC,gBAAA;AtB8pPxC;;AsB9pPE;EAAsC,gBAAA;AtBkqPxC;;AsBlqPE;EAAsC,gBAAA;AtBsqPxC;;AsBtqPE;EAAsC,gBAAA;AtB0qPxC;;AsB1qPE;EAAsC,gBAAA;AtB8qPxC;;AsB9qPE;EAAsC,gBAAA;AtBkrPxC;;AsBlrPE;EAAsC,gBAAA;AtBsrPxC;;AsBtrPE;EAAsC,gBAAA;AtB0rPxC;;AsB1rPE;EAAsC,gBAAA;AtB8rPxC;;AsB9rPE;EAAsC,gBAAA;AtBksPxC;;AsBlsPE;EAAsC,gBAAA;AtBssPxC;;AsBtsPE;EAAsC,gBAAA;AtB0sPxC;;AsB1sPE;EAAsC,gBAAA;AtB8sPxC;;AsB9sPE;EAAsC,gBAAA;AtBktPxC;;AsBltPE;EAAsC,gBAAA;AtBstPxC;;AsBttPE;EAAsC,YAAA;AtB0tPxC;;AsB1tPE;EAAsC,gBAAA;AtB8tPxC;;AsB9tPE;EAAsC,gBAAA;AtBkuPxC;;AsBluPE;EAAsC,gBAAA;AtBsuPxC;;AsBtuPE;EAAsC,gBAAA;AtB0uPxC;;AsB1uPE;EAAsC,gBAAA;AtB8uPxC;;AsB9uPE;EAAsC,gBAAA;AtBkvPxC;;AsBlvPE;EAAsC,gBAAA;AtBsvPxC;;AsBtvPE;EAAsC,gBAAA;AtB0vPxC;;AsB1vPE;EAAsC,gBAAA;AtB8vPxC;;AsB9vPE;EAAsC,gBAAA;AtBkwPxC;;AsBlwPE;EAAsC,gBAAA;AtBswPxC;;AsBtwPE;EAAsC,gBAAA;AtB0wPxC;;AsB1wPE;EAAsC,gBAAA;AtB8wPxC;;AsB9wPE;EAAsC,gBAAA;AtBkxPxC;;AsBlxPE;EAAsC,gBAAA;AtBsxPxC;;AsBtxPE;EAAsC,gBAAA;AtB0xPxC;;AsB1xPE;EAAsC,gBAAA;AtB8xPxC;;AsB9xPE;EAAsC,gBAAA;AtBkyPxC;;AsBlyPE;EAAsC,gBAAA;AtBsyPxC;;AsBtyPE;EAAsC,gBAAA;AtB0yPxC;;AsB1yPE;EAAsC,gBAAA;AtB8yPxC;;AsB9yPE;EAAsC,gBAAA;AtBkzPxC;;AsBlzPE;EAAsC,gBAAA;AtBszPxC;;AsBtzPE;EAAsC,gBAAA;AtB0zPxC;;AsB1zPE;EAAsC,gBAAA;AtB8zPxC;;AsB9zPE;EAAsC,gBAAA;AtBk0PxC;;AsBl0PE;EAAsC,gBAAA;AtBs0PxC;;AsBt0PE;EAAsC,gBAAA;AtB00PxC;;AsB10PE;EAAsC,gBAAA;AtB80PxC;;AsB90PE;EAAsC,gBAAA;AtBk1PxC;;AsBl1PE;EAAsC,gBAAA;AtBs1PxC;;AsBt1PE;EAAsC,gBAAA;AtB01PxC;;AsB11PE;EAAsC,gBAAA;AtB81PxC;;AsB91PE;EAAsC,gBAAA;AtBk2PxC;;AsBl2PE;EAAsC,gBAAA;AtBs2PxC;;AsBt2PE;EAAsC,gBAAA;AtB02PxC;;AsB12PE;EAAsC,gBAAA;AtB82PxC;;AsB92PE;EAAsC,gBAAA;AtBk3PxC;;AsBl3PE;EAAsC,gBAAA;AtBs3PxC;;AsBt3PE;EAAsC,gBAAA;AtB03PxC;;AsB13PE;EAAsC,gBAAA;AtB83PxC;;AsB93PE;EAAsC,gBAAA;AtBk4PxC;;AsBl4PE;EAAsC,gBAAA;AtBs4PxC;;AsBt4PE;EAAsC,gBAAA;AtB04PxC;;AsB14PE;EAAsC,gBAAA;AtB84PxC;;AsB94PE;EAAsC,gBAAA;AtBk5PxC;;AsBl5PE;EAAsC,gBAAA;AtBs5PxC;;AsBt5PE;EAAsC,gBAAA;AtB05PxC;;AsB15PE;EAAsC,gBAAA;AtB85PxC;;AsB95PE;EAAsC,gBAAA;AtBk6PxC;;AsBl6PE;EAAsC,gBAAA;AtBs6PxC;;AsBt6PE;EAAsC,gBAAA;AtB06PxC;;AsB16PE;EAAsC,gBAAA;AtB86PxC;;AsB96PE;EAAsC,gBAAA;AtBk7PxC;;AsBl7PE;EAAsC,gBAAA;AtBs7PxC;;AsBt7PE;EAAsC,gBAAA;AtB07PxC;;AsB17PE;EAAsC,gBAAA;AtB87PxC;;AsB97PE;EAAsC,gBAAA;AtBk8PxC;;AsBl8PE;EAAsC,gBAAA;AtBs8PxC;;AsBt8PE;EAAsC,gBAAA;AtB08PxC;;AsB18PE;EAAsC,gBAAA;AtB88PxC;;AsB98PE;EAAsC,gBAAA;AtBk9PxC;;AsBl9PE;EAAsC,gBAAA;AtBs9PxC;;AsBt9PE;EAAsC,gBAAA;AtB09PxC;;AsB19PE;EAAsC,gBAAA;AtB89PxC;;AsB99PE;EAAsC,gBAAA;AtBk+PxC;;AsBl+PE;EAAsC,gBAAA;AtBs+PxC;;AsBt+PE;EAAsC,gBAAA;AtB0+PxC;;AsB1+PE;EAAsC,gBAAA;AtB8+PxC;;AsB9+PE;EAAsC,gBAAA;AtBk/PxC;;AsBl/PE;EAAsC,gBAAA;AtBs/PxC;;AsBt/PE;EAAsC,gBAAA;AtB0/PxC;;AsB1/PE;EAAsC,gBAAA;AtB8/PxC;;AsB9/PE;EAAsC,gBAAA;AtBkgQxC;;AsBlgQE;EAAsC,gBAAA;AtBsgQxC;;AsBtgQE;EAAsC,gBAAA;AtB0gQxC;;AsB1gQE;EAAsC,gBAAA;AtB8gQxC;;AsB9gQE;EAAsC,gBAAA;AtBkhQxC;;AsBlhQE;EAAsC,gBAAA;AtBshQxC;;AsBthQE;EAAsC,gBAAA;AtB0hQxC;;AsB1hQE;EAAsC,gBAAA;AtB8hQxC;;AsB9hQE;EAAsC,aAAA;AtBkiQxC;;AsBliQE;EAAsC,gBAAA;AtBsiQxC;;AsBtiQE;EAAsC,gBAAA;AtB0iQxC;;AsB1iQE;EAAsC,gBAAA;AtB8iQxC;;AsB9iQE;EAAsC,gBAAA;AtBkjQxC;;AsBljQE;EAAsC,gBAAA;AtBsjQxC;;AsBtjQE;EAAsC,gBAAA;AtB0jQxC;;AsB1jQE;EAAsC,gBAAA;AtB8jQxC;;AsB9jQE;EAAsC,gBAAA;AtBkkQxC;;AsBlkQE;EAAsC,gBAAA;AtBskQxC;;AsBtkQE;EAAsC,gBAAA;AtB0kQxC;;AsB1kQE;EAAsC,gBAAA;AtB8kQxC;;AsB9kQE;EAAsC,gBAAA;AtBklQxC;;AsBllQE;EAAsC,gBAAA;AtBslQxC;;AsBtlQE;EAAsC,gBAAA;AtB0lQxC;;AsB1lQE;EAAsC,gBAAA;AtB8lQxC;;AsB9lQE;EAAsC,gBAAA;AtBkmQxC;;AsBlmQE;EAAsC,gBAAA;AtBsmQxC;;AsBtmQE;EAAsC,gBAAA;AtB0mQxC;;AsB1mQE;EAAsC,gBAAA;AtB8mQxC;;AsB9mQE;EAAsC,gBAAA;AtBknQxC;;AsBlnQE;EAAsC,gBAAA;AtBsnQxC;;AsBtnQE;EAAsC,gBAAA;AtB0nQxC;;AsB1nQE;EAAsC,gBAAA;AtB8nQxC;;AsB9nQE;EAAsC,gBAAA;AtBkoQxC;;AsBloQE;EAAsC,gBAAA;AtBsoQxC;;AsBtoQE;EAAsC,gBAAA;AtB0oQxC;;AsB1oQE;EAAsC,gBAAA;AtB8oQxC;;AsB9oQE;EAAsC,gBAAA;AtBkpQxC;;AsBlpQE;EAAsC,gBAAA;AtBspQxC;;AsBtpQE;EAAsC,gBAAA;AtB0pQxC;;AsB1pQE;EAAsC,gBAAA;AtB8pQxC;;AsB9pQE;EAAsC,gBAAA;AtBkqQxC;;AsBlqQE;EAAsC,gBAAA;AtBsqQxC;;AsBtqQE;EAAsC,gBAAA;AtB0qQxC;;AsB1qQE;EAAsC,gBAAA;AtB8qQxC;;AsB9qQE;EAAsC,gBAAA;AtBkrQxC;;AsBlrQE;EAAsC,gBAAA;AtBsrQxC;;AsBtrQE;EAAsC,gBAAA;AtB0rQxC;;AsB1rQE;EAAsC,gBAAA;AtB8rQxC;;AsB9rQE;EAAsC,gBAAA;AtBksQxC;;AsBlsQE;EAAsC,gBAAA;AtBssQxC;;AsBtsQE;EAAsC,gBAAA;AtB0sQxC;;AsB1sQE;EAAsC,gBAAA;AtB8sQxC;;AsB9sQE;EAAsC,gBAAA;AtBktQxC;;AsBltQE;EAAsC,gBAAA;AtBstQxC;;AsBttQE;EAAsC,gBAAA;AtB0tQxC;;AsB1tQE;EAAsC,gBAAA;AtB8tQxC;;AsB9tQE;EAAsC,gBAAA;AtBkuQxC;;AsBluQE;EAAsC,gBAAA;AtBsuQxC;;AsBtuQE;EAAsC,gBAAA;AtB0uQxC;;AsB1uQE;EAAsC,gBAAA;AtB8uQxC;;AsB9uQE;EAAsC,gBAAA;AtBkvQxC;;AsBlvQE;EAAsC,gBAAA;AtBsvQxC;;AsBtvQE;EAAsC,gBAAA;AtB0vQxC;;AsB1vQE;EAAsC,gBAAA;AtB8vQxC;;AsB9vQE;EAAsC,gBAAA;AtBkwQxC;;AsBlwQE;EAAsC,gBAAA;AtBswQxC;;AsBtwQE;EAAsC,gBAAA;AtB0wQxC;;AsB1wQE;EAAsC,gBAAA;AtB8wQxC;;AsB9wQE;EAAsC,gBAAA;AtBkxQxC;;AsBlxQE;EAAsC,gBAAA;AtBsxQxC;;AsBtxQE;EAAsC,gBAAA;AtB0xQxC;;AsB1xQE;EAAsC,gBAAA;AtB8xQxC;;AsB9xQE;EAAsC,gBAAA;AtBkyQxC;;AsBlyQE;EAAsC,gBAAA;AtBsyQxC;;AsBtyQE;EAAsC,gBAAA;AtB0yQxC;;AsB1yQE;EAAsC,gBAAA;AtB8yQxC;;AsB9yQE;EAAsC,gBAAA;AtBkzQxC;;AsBlzQE;EAAsC,gBAAA;AtBszQxC;;AsBtzQE;EAAsC,gBAAA;AtB0zQxC;;AsB1zQE;EAAsC,gBAAA;AtB8zQxC;;AsB9zQE;EAAsC,gBAAA;AtBk0QxC;;AsBl0QE;EAAsC,gBAAA;AtBs0QxC;;AsBt0QE;EAAsC,gBAAA;AtB00QxC;;AsB10QE;EAAsC,gBAAA;AtB80QxC;;AsB90QE;EAAsC,gBAAA;AtBk1QxC;;AsBl1QE;EAAsC,gBAAA;AtBs1QxC;;AsBt1QE;EAAsC,gBAAA;AtB01QxC;;AsB11QE;EAAsC,gBAAA;AtB81QxC;;AsB91QE;EAAsC,gBAAA;AtBk2QxC;;AsBl2QE;EAAsC,gBAAA;AtBs2QxC;;AsBt2QE;EAAsC,gBAAA;AtB02QxC;;AsB12QE;EAAsC,gBAAA;AtB82QxC;;AsB92QE;EAAsC,gBAAA;AtBk3QxC;;AsBl3QE;EAAsC,gBAAA;AtBs3QxC;;AsBt3QE;EAAsC,gBAAA;AtB03QxC;;AsB13QE;EAAsC,gBAAA;AtB83QxC;;AsB93QE;EAAsC,gBAAA;AtBk4QxC;;AsBl4QE;EAAsC,gBAAA;AtBs4QxC;;AsBt4QE;EAAsC,gBAAA;AtB04QxC;;AsB14QE;EAAsC,gBAAA;AtB84QxC;;AsB94QE;EAAsC,gBAAA;AtBk5QxC;;AsBl5QE;EAAsC,gBAAA;AtBs5QxC;;AsBt5QE;EAAsC,gBAAA;AtB05QxC;;AsB15QE;EAAsC,gBAAA;AtB85QxC;;AsB95QE;EAAsC,gBAAA;AtBk6QxC;;AsBl6QE;EAAsC,gBAAA;AtBs6QxC;;AsBt6QE;EAAsC,gBAAA;AtB06QxC;;AsB16QE;EAAsC,gBAAA;AtB86QxC;;AsB96QE;EAAsC,gBAAA;AtBk7QxC;;AsBl7QE;EAAsC,gBAAA;AtBs7QxC;;AsBt7QE;EAAsC,gBAAA;AtB07QxC;;AsB17QE;EAAsC,gBAAA;AtB87QxC;;AsB97QE;EAAsC,gBAAA;AtBk8QxC;;AsBl8QE;EAAsC,gBAAA;AtBs8QxC;;AsBt8QE;EAAsC,gBAAA;AtB08QxC;;AsB18QE;EAAsC,gBAAA;AtB88QxC;;AsB98QE;EAAsC,gBAAA;AtBk9QxC;;AsBl9QE;EAAsC,gBAAA;AtBs9QxC;;AsBt9QE;EAAsC,gBAAA;AtB09QxC;;AsB19QE;EAAsC,gBAAA;AtB89QxC;;AsB99QE;EAAsC,gBAAA;AtBk+QxC;;AsBl+QE;EAAsC,gBAAA;AtBs+QxC;;AsBt+QE;EAAsC,gBAAA;AtB0+QxC;;AsB1+QE;EAAsC,gBAAA;AtB8+QxC;;AsB9+QE;EAAsC,gBAAA;AtBk/QxC;;AsBl/QE;EAAsC,gBAAA;AtBs/QxC;;AsBt/QE;EAAsC,gBAAA;AtB0/QxC;;AsB1/QE;EAAsC,gBAAA;AtB8/QxC;;AsB9/QE;EAAsC,gBAAA;AtBkgRxC;;AsBlgRE;EAAsC,gBAAA;AtBsgRxC;;AsBtgRE;EAAsC,gBAAA;AtB0gRxC;;AsB1gRE;EAAsC,gBAAA;AtB8gRxC;;AsB9gRE;EAAsC,gBAAA;AtBkhRxC;;AsBlhRE;EAAsC,gBAAA;AtBshRxC;;AsBthRE;EAAsC,gBAAA;AtB0hRxC;;AsB1hRE;EAAsC,aAAA;AtB8hRxC;;AsB9hRE;EAAsC,YAAA;AtBkiRxC;;AsBliRE;EAAsC,gBAAA;AtBsiRxC;;AsBtiRE;EAAsC,gBAAA;AtB0iRxC;;AsB1iRE;EAAsC,gBAAA;AtB8iRxC;;AsB9iRE;EAAsC,gBAAA;AtBkjRxC;;AsBljRE;EAAsC,gBAAA;AtBsjRxC;;AsBtjRE;EAAsC,gBAAA;AtB0jRxC;;AsB1jRE;EAAsC,gBAAA;AtB8jRxC;;AsB9jRE;EAAsC,gBAAA;AtBkkRxC;;AsBlkRE;EAAsC,gBAAA;AtBskRxC;;AsBtkRE;EAAsC,gBAAA;AtB0kRxC;;AsB1kRE;EAAsC,gBAAA;AtB8kRxC;;AsB9kRE;EAAsC,gBAAA;AtBklRxC;;AsBllRE;EAAsC,gBAAA;AtBslRxC;;AsBtlRE;EAAsC,gBAAA;AtB0lRxC;;AsB1lRE;EAAsC,gBAAA;AtB8lRxC;;AsB9lRE;EAAsC,gBAAA;AtBkmRxC;;AsBlmRE;EAAsC,gBAAA;AtBsmRxC;;AsBtmRE;EAAsC,gBAAA;AtB0mRxC;;AsB1mRE;EAAsC,gBAAA;AtB8mRxC;;AsB9mRE;EAAsC,gBAAA;AtBknRxC;;AsBlnRE;EAAsC,gBAAA;AtBsnRxC;;AsBtnRE;EAAsC,gBAAA;AtB0nRxC;;AsB1nRE;EAAsC,gBAAA;AtB8nRxC;;AsB9nRE;EAAsC,gBAAA;AtBkoRxC;;AsBloRE;EAAsC,gBAAA;AtBsoRxC;;AsBtoRE;EAAsC,gBAAA;AtB0oRxC;;AsB1oRE;EAAsC,gBAAA;AtB8oRxC;;AsB9oRE;EAAsC,gBAAA;AtBkpRxC;;AsBlpRE;EAAsC,gBAAA;AtBspRxC;;AsBtpRE;EAAsC,gBAAA;AtB0pRxC;;AsB1pRE;EAAsC,gBAAA;AtB8pRxC;;AsB9pRE;EAAsC,gBAAA;AtBkqRxC;;AsBlqRE;EAAsC,gBAAA;AtBsqRxC;;AsBtqRE;EAAsC,gBAAA;AtB0qRxC;;AsB1qRE;EAAsC,gBAAA;AtB8qRxC;;AsB9qRE;EAAsC,gBAAA;AtBkrRxC;;AsBlrRE;EAAsC,gBAAA;AtBsrRxC;;AsBtrRE;EAAsC,gBAAA;AtB0rRxC;;AsB1rRE;EAAsC,gBAAA;AtB8rRxC;;AsB9rRE;EAAsC,gBAAA;AtBksRxC;;AsBlsRE;EAAsC,gBAAA;AtBssRxC;;AsBtsRE;EAAsC,gBAAA;AtB0sRxC;;AsB1sRE;EAAsC,gBAAA;AtB8sRxC;;AsB9sRE;EAAsC,gBAAA;AtBktRxC;;AsBltRE;EAAsC,gBAAA;AtBstRxC;;AsBttRE;EAAsC,gBAAA;AtB0tRxC;;AsB1tRE;EAAsC,gBAAA;AtB8tRxC;;AsB9tRE;EAAsC,gBAAA;AtBkuRxC;;AsBluRE;EAAsC,YAAA;AtBsuRxC;;AsBtuRE;EAAsC,gBAAA;AtB0uRxC;;AsB1uRE;EAAsC,gBAAA;AtB8uRxC;;AsB9uRE;EAAsC,gBAAA;AtBkvRxC;;AsBlvRE;EAAsC,gBAAA;AtBsvRxC;;AsBtvRE;EAAsC,gBAAA;AtB0vRxC;;AsB1vRE;EAAsC,gBAAA;AtB8vRxC;;AsB9vRE;EAAsC,gBAAA;AtBkwRxC;;AsBlwRE;EAAsC,YAAA;AtBswRxC;;AsBtwRE;EAAsC,gBAAA;AtB0wRxC;;AsB1wRE;EAAsC,gBAAA;AtB8wRxC;;AsB9wRE;EAAsC,gBAAA;AtBkxRxC;;AsBlxRE;EAAsC,gBAAA;AtBsxRxC;;AsBtxRE;EAAsC,gBAAA;AtB0xRxC;;AsB1xRE;EAAsC,gBAAA;AtB8xRxC;;AsB9xRE;EAAsC,gBAAA;AtBkyRxC;;AsBlyRE;EAAsC,gBAAA;AtBsyRxC;;AsBtyRE;EAAsC,gBAAA;AtB0yRxC;;AsB1yRE;EAAsC,gBAAA;AtB8yRxC;;AsB9yRE;EAAsC,gBAAA;AtBkzRxC;;AsBlzRE;EAAsC,gBAAA;AtBszRxC;;AsBtzRE;EAAsC,gBAAA;AtB0zRxC;;AsB1zRE;EAAsC,gBAAA;AtB8zRxC;;AsB9zRE;EAAsC,gBAAA;AtBk0RxC;;AsBl0RE;EAAsC,gBAAA;AtBs0RxC;;AsBt0RE;EAAsC,gBAAA;AtB00RxC;;AsB10RE;EAAsC,gBAAA;AtB80RxC;;AsB90RE;EAAsC,gBAAA;AtBk1RxC;;AsBl1RE;EAAsC,gBAAA;AtBs1RxC;;AsBt1RE;EAAsC,gBAAA;AtB01RxC;;AsB11RE;EAAsC,gBAAA;AtB81RxC;;AsB91RE;EAAsC,gBAAA;AtBk2RxC;;AsBl2RE;EAAsC,YAAA;AtBs2RxC;;AsBt2RE;EAAsC,gBAAA;AtB02RxC;;AsB12RE;EAAsC,gBAAA;AtB82RxC;;AsB92RE;EAAsC,gBAAA;AtBk3RxC;;AsBl3RE;EAAsC,gBAAA;AtBs3RxC;;AsBt3RE;EAAsC,gBAAA;AtB03RxC;;AsB13RE;EAAsC,gBAAA;AtB83RxC;;AsB93RE;EAAsC,gBAAA;AtBk4RxC;;AsBl4RE;EAAsC,gBAAA;AtBs4RxC;;AsBt4RE;EAAsC,gBAAA;AtB04RxC;;AsB14RE;EAAsC,gBAAA;AtB84RxC;;AsB94RE;EAAsC,gBAAA;AtBk5RxC;;AsBl5RE;EAAsC,gBAAA;AtBs5RxC;;AsBt5RE;EAAsC,gBAAA;AtB05RxC;;AsB15RE;EAAsC,gBAAA;AtB85RxC;;AsB95RE;EAAsC,gBAAA;AtBk6RxC;;AsBl6RE;EAAsC,gBAAA;AtBs6RxC;;AsBt6RE;EAAsC,gBAAA;AtB06RxC;;AsB16RE;EAAsC,gBAAA;AtB86RxC;;AsB96RE;EAAsC,gBAAA;AtBk7RxC;;AsBl7RE;EAAsC,gBAAA;AtBs7RxC;;AsBt7RE;EAAsC,gBAAA;AtB07RxC;;AsB17RE;EAAsC,gBAAA;AtB87RxC;;AsB97RE;EAAsC,gBAAA;AtBk8RxC;;AsBl8RE;EAAsC,gBAAA;AtBs8RxC;;AsBt8RE;EAAsC,gBAAA;AtB08RxC;;AsB18RE;EAAsC,gBAAA;AtB88RxC;;AsB98RE;EAAsC,gBAAA;AtBk9RxC;;AsBl9RE;EAAsC,gBAAA;AtBs9RxC;;AsBt9RE;EAAsC,gBAAA;AtB09RxC;;AsB19RE;EAAsC,gBAAA;AtB89RxC;;AsB99RE;EAAsC,gBAAA;AtBk+RxC;;AsBl+RE;EAAsC,gBAAA;AtBs+RxC;;AsBt+RE;EAAsC,gBAAA;AtB0+RxC;;AsB1+RE;EAAsC,gBAAA;AtB8+RxC;;AsB9+RE;EAAsC,gBAAA;AtBk/RxC;;AsBl/RE;EAAsC,gBAAA;AtBs/RxC;;AsBt/RE;EAAsC,gBAAA;AtB0/RxC;;AsB1/RE;EAAsC,gBAAA;AtB8/RxC;;AsB9/RE;EAAsC,gBAAA;AtBkgSxC;;AsBlgSE;EAAsC,gBAAA;AtBsgSxC;;AsBtgSE;EAAsC,gBAAA;AtB0gSxC;;AsB1gSE;EAAsC,gBAAA;AtB8gSxC;;AsB9gSE;EAAsC,gBAAA;AtBkhSxC;;AsBlhSE;EAAsC,aAAA;AtBshSxC;;AsBthSE;EAAsC,gBAAA;AtB0hSxC;;AsB1hSE;EAAsC,gBAAA;AtB8hSxC;;AsB9hSE;EAAsC,gBAAA;AtBkiSxC;;AsBliSE;EAAsC,gBAAA;AtBsiSxC;;AsBtiSE;EAAsC,gBAAA;AtB0iSxC;;AsB1iSE;EAAsC,gBAAA;AtB8iSxC;;AsB9iSE;EAAsC,gBAAA;AtBkjSxC;;AsBljSE;EAAsC,gBAAA;AtBsjSxC;;AsBtjSE;EAAsC,gBAAA;AtB0jSxC;;AsB1jSE;EAAsC,gBAAA;AtB8jSxC;;AsB9jSE;EAAsC,gBAAA;AtBkkSxC;;AsBlkSE;EAAsC,gBAAA;AtBskSxC;;AsBtkSE;EAAsC,gBAAA;AtB0kSxC;;AsB1kSE;EAAsC,gBAAA;AtB8kSxC;;AsB9kSE;EAAsC,gBAAA;AtBklSxC;;AsBllSE;EAAsC,gBAAA;AtBslSxC;;AsBtlSE;EAAsC,gBAAA;AtB0lSxC;;AsB1lSE;EAAsC,gBAAA;AtB8lSxC;;AsB9lSE;EAAsC,gBAAA;AtBkmSxC;;AsBlmSE;EAAsC,gBAAA;AtBsmSxC;;AsBtmSE;EAAsC,gBAAA;AtB0mSxC;;AsB1mSE;EAAsC,gBAAA;AtB8mSxC;;AsB9mSE;EAAsC,gBAAA;AtBknSxC;;AsBlnSE;EAAsC,gBAAA;AtBsnSxC;;AsBtnSE;EAAsC,gBAAA;AtB0nSxC;;AsB1nSE;EAAsC,gBAAA;AtB8nSxC;;AsB9nSE;EAAsC,gBAAA;AtBkoSxC;;AsBloSE;EAAsC,gBAAA;AtBsoSxC;;AsBtoSE;EAAsC,gBAAA;AtB0oSxC;;AsB1oSE;EAAsC,gBAAA;AtB8oSxC;;AsB9oSE;EAAsC,gBAAA;AtBkpSxC;;AsBlpSE;EAAsC,gBAAA;AtBspSxC;;AsBtpSE;EAAsC,gBAAA;AtB0pSxC;;AsB1pSE;EAAsC,gBAAA;AtB8pSxC;;AsB9pSE;EAAsC,gBAAA;AtBkqSxC;;AsBlqSE;EAAsC,gBAAA;AtBsqSxC;;AsBtqSE;EAAsC,gBAAA;AtB0qSxC;;AsB1qSE;EAAsC,gBAAA;AtB8qSxC;;AsB9qSE;EAAsC,gBAAA;AtBkrSxC;;AsBlrSE;EAAsC,gBAAA;AtBsrSxC;;AsBtrSE;EAAsC,gBAAA;AtB0rSxC;;AsB1rSE;EAAsC,gBAAA;AtB8rSxC;;AsB9rSE;EAAsC,gBAAA;AtBksSxC;;AsBlsSE;EAAsC,gBAAA;AtBssSxC;;AsBtsSE;EAAsC,gBAAA;AtB0sSxC;;AsB1sSE;EAAsC,gBAAA;AtB8sSxC;;AsB9sSE;EAAsC,gBAAA;AtBktSxC;;AsBltSE;EAAsC,gBAAA;AtBstSxC;;AsBttSE;EAAsC,gBAAA;AtB0tSxC;;AsB1tSE;EAAsC,gBAAA;AtB8tSxC;;AsB9tSE;EAAsC,gBAAA;AtBkuSxC;;AsBluSE;EAAsC,gBAAA;AtBsuSxC;;AsBtuSE;EAAsC,gBAAA;AtB0uSxC;;AsB1uSE;EAAsC,gBAAA;AtB8uSxC;;AsB9uSE;EAAsC,gBAAA;AtBkvSxC;;AsBlvSE;EAAsC,gBAAA;AtBsvSxC;;AsBtvSE;EAAsC,gBAAA;AtB0vSxC;;AsB1vSE;EAAsC,gBAAA;AtB8vSxC;;AsB9vSE;EAAsC,gBAAA;AtBkwSxC;;AsBlwSE;EAAsC,gBAAA;AtBswSxC;;AsBtwSE;EAAsC,gBAAA;AtB0wSxC;;AsB1wSE;EAAsC,gBAAA;AtB8wSxC;;AsB9wSE;EAAsC,gBAAA;AtBkxSxC;;AsBlxSE;EAAsC,gBAAA;AtBsxSxC;;AsBtxSE;EAAsC,gBAAA;AtB0xSxC;;AsB1xSE;EAAsC,gBAAA;AtB8xSxC;;AsB9xSE;EAAsC,gBAAA;AtBkySxC;;AsBlySE;EAAsC,gBAAA;AtBsySxC;;AsBtySE;EAAsC,gBAAA;AtB0ySxC;;AsB1ySE;EAAsC,gBAAA;AtB8ySxC;;AsB9ySE;EAAsC,gBAAA;AtBkzSxC;;AsBlzSE;EAAsC,gBAAA;AtBszSxC;;AsBtzSE;EAAsC,gBAAA;AtB0zSxC;;AsB1zSE;EAAsC,gBAAA;AtB8zSxC;;AsB9zSE;EAAsC,gBAAA;AtBk0SxC;;AsBl0SE;EAAsC,gBAAA;AtBs0SxC;;AsBt0SE;EAAsC,gBAAA;AtB00SxC;;AsB10SE;EAAsC,gBAAA;AtB80SxC;;AsB90SE;EAAsC,gBAAA;AtBk1SxC;;AsBl1SE;EAAsC,gBAAA;AtBs1SxC;;AsBt1SE;EAAsC,gBAAA;AtB01SxC;;AsB11SE;EAAsC,gBAAA;AtB81SxC;;AsB91SE;EAAsC,gBAAA;AtBk2SxC;;AsBl2SE;EAAsC,gBAAA;AtBs2SxC;;AsBt2SE;EAAsC,gBAAA;AtB02SxC;;AsB12SE;EAAsC,gBAAA;AtB82SxC;;AsB92SE;EAAsC,gBAAA;AtBk3SxC;;AsBl3SE;EAAsC,gBAAA;AtBs3SxC;;AsBt3SE;EAAsC,gBAAA;AtB03SxC;;AsB13SE;EAAsC,gBAAA;AtB83SxC;;AsB93SE;EAAsC,gBAAA;AtBk4SxC;;AsBl4SE;EAAsC,gBAAA;AtBs4SxC;;AsBt4SE;EAAsC,gBAAA;AtB04SxC;;AsB14SE;EAAsC,gBAAA;AtB84SxC;;AsB94SE;EAAsC,gBAAA;AtBk5SxC;;AsBl5SE;EAAsC,YAAA;AtBs5SxC;;AsBt5SE;EAAsC,gBAAA;AtB05SxC;;AsB15SE;EAAsC,gBAAA;AtB85SxC;;AsB95SE;EAAsC,gBAAA;AtBk6SxC;;AsBl6SE;EAAsC,gBAAA;AtBs6SxC;;AsBt6SE;EAAsC,gBAAA;AtB06SxC;;AsB16SE;EAAsC,gBAAA;AtB86SxC;;AsB96SE;EAAsC,gBAAA;AtBk7SxC;;AsBl7SE;EAAsC,gBAAA;AtBs7SxC;;AsBt7SE;EAAsC,gBAAA;AtB07SxC;;AsB17SE;EAAsC,gBAAA;AtB87SxC;;AsB97SE;EAAsC,gBAAA;AtBk8SxC;;AsBl8SE;EAAsC,gBAAA;AtBs8SxC;;AsBt8SE;EAAsC,gBAAA;AtB08SxC;;AsB18SE;EAAsC,gBAAA;AtB88SxC;;AsB98SE;EAAsC,gBAAA;AtBk9SxC;;AsBl9SE;EAAsC,gBAAA;AtBs9SxC;;AsBt9SE;EAAsC,gBAAA;AtB09SxC;;AsB19SE;EAAsC,gBAAA;AtB89SxC;;AsB99SE;EAAsC,gBAAA;AtBk+SxC;;AsBl+SE;EAAsC,gBAAA;AtBs+SxC;;AsBt+SE;EAAsC,gBAAA;AtB0+SxC;;AsB1+SE;EAAsC,gBAAA;AtB8+SxC;;AsB9+SE;EAAsC,gBAAA;AtBk/SxC;;AsBl/SE;EAAsC,gBAAA;AtBs/SxC;;AsBt/SE;EAAsC,gBAAA;AtB0/SxC;;AsB1/SE;EAAsC,gBAAA;AtB8/SxC;;AsB9/SE;EAAsC,gBAAA;AtBkgTxC;;AsBlgTE;EAAsC,gBAAA;AtBsgTxC;;AsBtgTE;EAAsC,gBAAA;AtB0gTxC;;AsB1gTE;EAAsC,gBAAA;AtB8gTxC;;AsB9gTE;EAAsC,gBAAA;AtBkhTxC;;AsBlhTE;EAAsC,gBAAA;AtBshTxC;;AsBthTE;EAAsC,gBAAA;AtB0hTxC;;AsB1hTE;EAAsC,gBAAA;AtB8hTxC;;AsB9hTE;EAAsC,gBAAA;AtBkiTxC;;AsBliTE;EAAsC,gBAAA;AtBsiTxC;;AsBtiTE;EAAsC,gBAAA;AtB0iTxC;;AsB1iTE;EAAsC,gBAAA;AtB8iTxC;;AsB9iTE;EAAsC,gBAAA;AtBkjTxC;;AsBljTE;EAAsC,gBAAA;AtBsjTxC;;AsBtjTE;EAAsC,gBAAA;AtB0jTxC;;AsB1jTE;EAAsC,gBAAA;AtB8jTxC;;AsB9jTE;EAAsC,gBAAA;AtBkkTxC;;AsBlkTE;EAAsC,gBAAA;AtBskTxC;;AsBtkTE;EAAsC,gBAAA;AtB0kTxC;;AsB1kTE;EAAsC,gBAAA;AtB8kTxC;;AsB9kTE;EAAsC,gBAAA;AtBklTxC;;AsBllTE;EAAsC,gBAAA;AtBslTxC;;AsBtlTE;EAAsC,gBAAA;AtB0lTxC;;AsB1lTE;EAAsC,gBAAA;AtB8lTxC;;AsB9lTE;EAAsC,gBAAA;AtBkmTxC;;AsBlmTE;EAAsC,gBAAA;AtBsmTxC;;AsBtmTE;EAAsC,gBAAA;AtB0mTxC;;AsB1mTE;EAAsC,gBAAA;AtB8mTxC;;AsB9mTE;EAAsC,gBAAA;AtBknTxC;;AsBlnTE;EAAsC,gBAAA;AtBsnTxC;;AsBtnTE;EAAsC,gBAAA;AtB0nTxC;;AsB1nTE;EAAsC,gBAAA;AtB8nTxC;;AsB9nTE;EAAsC,gBAAA;AtBkoTxC;;AsBloTE;EAAsC,gBAAA;AtBsoTxC;;AsBtoTE;EAAsC,gBAAA;AtB0oTxC;;AsB1oTE;EAAsC,gBAAA;AtB8oTxC;;AsB9oTE;EAAsC,gBAAA;AtBkpTxC;;AsBlpTE;EAAsC,gBAAA;AtBspTxC;;AsBtpTE;EAAsC,gBAAA;AtB0pTxC;;AsB1pTE;EAAsC,gBAAA;AtB8pTxC;;AsB9pTE;EAAsC,gBAAA;AtBkqTxC;;AsBlqTE;EAAsC,gBAAA;AtBsqTxC;;AsBtqTE;EAAsC,gBAAA;AtB0qTxC;;AsB1qTE;EAAsC,gBAAA;AtB8qTxC;;AsB9qTE;EAAsC,gBAAA;AtBkrTxC;;AsBlrTE;EAAsC,gBAAA;AtBsrTxC;;AsBtrTE;EAAsC,gBAAA;AtB0rTxC;;AsB1rTE;EAAsC,gBAAA;AtB8rTxC;;AsB9rTE;EAAsC,gBAAA;AtBksTxC;;AsBlsTE;EAAsC,gBAAA;AtBssTxC;;AsBtsTE;EAAsC,gBAAA;AtB0sTxC;;AsB1sTE;EAAsC,gBAAA;AtB8sTxC;;AsB9sTE;EAAsC,gBAAA;AtBktTxC;;AsBltTE;EAAsC,gBAAA;AtBstTxC;;AsBttTE;EAAsC,gBAAA;AtB0tTxC;;AsB1tTE;EAAsC,gBAAA;AtB8tTxC;;AsB9tTE;EAAsC,gBAAA;AtBkuTxC;;AsBluTE;EAAsC,gBAAA;AtBsuTxC;;AsBtuTE;EAAsC,gBAAA;AtB0uTxC;;AsB1uTE;EAAsC,gBAAA;AtB8uTxC;;AsB9uTE;EAAsC,gBAAA;AtBkvTxC;;AsBlvTE;EAAsC,gBAAA;AtBsvTxC;;AsBtvTE;EAAsC,gBAAA;AtB0vTxC;;AsB1vTE;EAAsC,gBAAA;AtB8vTxC;;AsB9vTE;EAAsC,gBAAA;AtBkwTxC;;AsBlwTE;EAAsC,gBAAA;AtBswTxC;;AsBtwTE;EAAsC,gBAAA;AtB0wTxC;;AsB1wTE;EAAsC,gBAAA;AtB8wTxC;;AsB9wTE;EAAsC,gBAAA;AtBkxTxC;;AsBlxTE;EAAsC,gBAAA;AtBsxTxC;;AsBtxTE;EAAsC,gBAAA;AtB0xTxC;;AsB1xTE;EAAsC,gBAAA;AtB8xTxC;;AsB9xTE;EAAsC,gBAAA;AtBkyTxC;;AsBlyTE;EAAsC,gBAAA;AtBsyTxC;;AsBtyTE;EAAsC,gBAAA;AtB0yTxC;;AsB1yTE;EAAsC,gBAAA;AtB8yTxC;;AsB9yTE;EAAsC,gBAAA;AtBkzTxC;;AsBlzTE;EAAsC,gBAAA;AtBszTxC;;AsBtzTE;EAAsC,gBAAA;AtB0zTxC;;AsB1zTE;EAAsC,gBAAA;AtB8zTxC;;AsB9zTE;EAAsC,gBAAA;AtBk0TxC;;AsBl0TE;EAAsC,gBAAA;AtBs0TxC;;AsBt0TE;EAAsC,gBAAA;AtB00TxC;;AsB10TE;EAAsC,gBAAA;AtB80TxC;;AsB90TE;EAAsC,gBAAA;AtBk1TxC;;AsBl1TE;EAAsC,gBAAA;AtBs1TxC;;AsBt1TE;EAAsC,gBAAA;AtB01TxC;;AsB11TE;EAAsC,gBAAA;AtB81TxC;;AsB91TE;EAAsC,gBAAA;AtBk2TxC;;AsBl2TE;EAAsC,gBAAA;AtBs2TxC;;AsBt2TE;EAAsC,gBAAA;AtB02TxC;;AsB12TE;EAAsC,gBAAA;AtB82TxC;;AsB92TE;EAAsC,gBAAA;AtBk3TxC;;AsBl3TE;EAAsC,gBAAA;AtBs3TxC;;AsBt3TE;EAAsC,gBAAA;AtB03TxC;;AsB13TE;EAAsC,gBAAA;AtB83TxC;;AsB93TE;EAAsC,gBAAA;AtBk4TxC;;AsBl4TE;EAAsC,gBAAA;AtBs4TxC;;AsBt4TE;EAAsC,gBAAA;AtB04TxC;;AsB14TE;EAAsC,gBAAA;AtB84TxC;;AsB94TE;EAAsC,gBAAA;AtBk5TxC;;AsBl5TE;EAAsC,gBAAA;AtBs5TxC;;AsBt5TE;EAAsC,gBAAA;AtB05TxC;;AsB15TE;EAAsC,gBAAA;AtB85TxC;;AsB95TE;EAAsC,gBAAA;AtBk6TxC;;AsBl6TE;EAAsC,gBAAA;AtBs6TxC;;AsBt6TE;EAAsC,gBAAA;AtB06TxC;;AsB16TE;EAAsC,gBAAA;AtB86TxC;;AsB96TE;EAAsC,gBAAA;AtBk7TxC;;AsBl7TE;EAAsC,gBAAA;AtBs7TxC;;AsBt7TE;EAAsC,gBAAA;AtB07TxC;;AsB17TE;EAAsC,gBAAA;AtB87TxC;;AsB97TE;EAAsC,gBAAA;AtBk8TxC;;AsBl8TE;EAAsC,gBAAA;AtBs8TxC;;AsBt8TE;EAAsC,gBAAA;AtB08TxC;;AsB18TE;EAAsC,gBAAA;AtB88TxC;;AsB98TE;EAAsC,gBAAA;AtBk9TxC;;AsBl9TE;EAAsC,gBAAA;AtBs9TxC;;AsBt9TE;EAAsC,gBAAA;AtB09TxC;;AsB19TE;EAAsC,gBAAA;AtB89TxC;;AsB99TE;EAAsC,gBAAA;AtBk+TxC;;AsBl+TE;EAAsC,gBAAA;AtBs+TxC;;AsBt+TE;EAAsC,gBAAA;AtB0+TxC;;AsB1+TE;EAAsC,gBAAA;AtB8+TxC;;AsB9+TE;EAAsC,gBAAA;AtBk/TxC;;AsBl/TE;EAAsC,gBAAA;AtBs/TxC;;AsBt/TE;EAAsC,gBAAA;AtB0/TxC;;AsB1/TE;EAAsC,gBAAA;AtB8/TxC;;AsB9/TE;EAAsC,gBAAA;AtBkgUxC;;AsBlgUE;EAAsC,gBAAA;AtBsgUxC;;AsBtgUE;EAAsC,gBAAA;AtB0gUxC;;AsB1gUE;EAAsC,gBAAA;AtB8gUxC;;AsB9gUE;EAAsC,gBAAA;AtBkhUxC;;AsBlhUE;EAAsC,gBAAA;AtBshUxC;;AsBthUE;EAAsC,gBAAA;AtB0hUxC;;AsB1hUE;EAAsC,gBAAA;AtB8hUxC;;AsB9hUE;EAAsC,gBAAA;AtBkiUxC;;AsBliUE;EAAsC,gBAAA;AtBsiUxC;;AsBtiUE;EAAsC,gBAAA;AtB0iUxC;;AsB1iUE;EAAsC,gBAAA;AtB8iUxC;;AsB9iUE;EAAsC,gBAAA;AtBkjUxC;;AsBljUE;EAAsC,gBAAA;AtBsjUxC;;AsBtjUE;EAAsC,gBAAA;AtB0jUxC;;AsB1jUE;EAAsC,gBAAA;AtB8jUxC;;AsB9jUE;EAAsC,gBAAA;AtBkkUxC;;AsBlkUE;EAAsC,gBAAA;AtBskUxC;;AsBtkUE;EAAsC,gBAAA;AtB0kUxC;;AsB1kUE;EAAsC,gBAAA;AtB8kUxC;;AsB9kUE;EAAsC,gBAAA;AtBklUxC;;AsBllUE;EAAsC,gBAAA;AtBslUxC;;AsBtlUE;EAAsC,gBAAA;AtB0lUxC;;AsB1lUE;EAAsC,gBAAA;AtB8lUxC;;AsB9lUE;EAAsC,gBAAA;AtBkmUxC;;AsBlmUE;EAAsC,gBAAA;AtBsmUxC;;AsBtmUE;EAAsC,gBAAA;AtB0mUxC;;AsB1mUE;EAAsC,gBAAA;AtB8mUxC;;AsB9mUE;EAAsC,gBAAA;AtBknUxC;;AsBlnUE;EAAsC,gBAAA;AtBsnUxC;;AsBtnUE;EAAsC,gBAAA;AtB0nUxC;;AsB1nUE;EAAsC,gBAAA;AtB8nUxC;;AsB9nUE;EAAsC,gBAAA;AtBkoUxC;;AsBloUE;EAAsC,gBAAA;AtBsoUxC;;AsBtoUE;EAAsC,gBAAA;AtB0oUxC;;AsB1oUE;EAAsC,gBAAA;AtB8oUxC;;AsB9oUE;EAAsC,gBAAA;AtBkpUxC;;AsBlpUE;EAAsC,gBAAA;AtBspUxC;;AsBtpUE;EAAsC,gBAAA;AtB0pUxC;;AsB1pUE;EAAsC,gBAAA;AtB8pUxC;;AsB9pUE;EAAsC,gBAAA;AtBkqUxC;;AsBlqUE;EAAsC,gBAAA;AtBsqUxC;;AsBtqUE;EAAsC,gBAAA;AtB0qUxC;;AsB1qUE;EAAsC,gBAAA;AtB8qUxC;;AsB9qUE;EAAsC,YAAA;AtBkrUxC;;AsBlrUE;EAAsC,gBAAA;AtBsrUxC;;AsBtrUE;EAAsC,gBAAA;AtB0rUxC;;AsB1rUE;EAAsC,gBAAA;AtB8rUxC;;AsB9rUE;EAAsC,gBAAA;AtBksUxC;;AsBlsUE;EAAsC,gBAAA;AtBssUxC;;AsBtsUE;EAAsC,gBAAA;AtB0sUxC;;AsB1sUE;EAAsC,gBAAA;AtB8sUxC;;AsB9sUE;EAAsC,gBAAA;AtBktUxC;;AsBltUE;EAAsC,gBAAA;AtBstUxC;;AsBttUE;EAAsC,gBAAA;AtB0tUxC;;AsB1tUE;EAAsC,gBAAA;AtB8tUxC;;AsB9tUE;EAAsC,gBAAA;AtBkuUxC;;AsBluUE;EAAsC,gBAAA;AtBsuUxC;;AsBtuUE;EAAsC,gBAAA;AtB0uUxC;;AsB1uUE;EAAsC,gBAAA;AtB8uUxC;;AsB9uUE;EAAsC,gBAAA;AtBkvUxC;;AsBlvUE;EAAsC,gBAAA;AtBsvUxC;;AsBtvUE;EAAsC,gBAAA;AtB0vUxC;;AsB1vUE;EAAsC,gBAAA;AtB8vUxC;;AsB9vUE;EAAsC,gBAAA;AtBkwUxC;;AsBlwUE;EAAsC,gBAAA;AtBswUxC;;AsBtwUE;EAAsC,gBAAA;AtB0wUxC;;AsB1wUE;EAAsC,YAAA;AtB8wUxC;;AsB9wUE;EAAsC,gBAAA;AtBkxUxC;;AsBlxUE;EAAsC,gBAAA;AtBsxUxC;;AsBtxUE;EAAsC,gBAAA;AtB0xUxC;;AsB1xUE;EAAsC,gBAAA;AtB8xUxC;;AsB9xUE;EAAsC,gBAAA;AtBkyUxC;;AsBlyUE;EAAsC,gBAAA;AtBsyUxC;;AsBtyUE;EAAsC,gBAAA;AtB0yUxC;;AsB1yUE;EAAsC,gBAAA;AtB8yUxC;;AsB9yUE;EAAsC,gBAAA;AtBkzUxC;;AsBlzUE;EAAsC,gBAAA;AtBszUxC;;AsBtzUE;EAAsC,gBAAA;AtB0zUxC;;AsB1zUE;EAAsC,gBAAA;AtB8zUxC;;AsB9zUE;EAAsC,gBAAA;AtBk0UxC;;AsBl0UE;EAAsC,gBAAA;AtBs0UxC;;AsBt0UE;EAAsC,gBAAA;AtB00UxC;;AsB10UE;EAAsC,gBAAA;AtB80UxC;;AsB90UE;EAAsC,gBAAA;AtBk1UxC;;AsBl1UE;EAAsC,gBAAA;AtBs1UxC;;AsBt1UE;EAAsC,gBAAA;AtB01UxC;;AsB11UE;EAAsC,gBAAA;AtB81UxC;;AsB91UE;EAAsC,gBAAA;AtBk2UxC;;AsBl2UE;EAAsC,gBAAA;AtBs2UxC;;AsBt2UE;EAAsC,gBAAA;AtB02UxC;;AsB12UE;EAAsC,gBAAA;AtB82UxC;;AsB92UE;EAAsC,gBAAA;AtBk3UxC;;AsBl3UE;EAAsC,gBAAA;AtBs3UxC;;AsBt3UE;EAAsC,gBAAA;AtB03UxC;;AsB13UE;EAAsC,gBAAA;AtB83UxC;;AsB93UE;EAAsC,gBAAA;AtBk4UxC;;AsBl4UE;EAAsC,gBAAA;AtBs4UxC;;AsBt4UE;EAAsC,gBAAA;AtB04UxC;;AsB14UE;EAAsC,gBAAA;AtB84UxC;;AsB94UE;EAAsC,gBAAA;AtBk5UxC;;AsBl5UE;EAAsC,gBAAA;AtBs5UxC;;AsBt5UE;EAAsC,gBAAA;AtB05UxC;;AsB15UE;EAAsC,gBAAA;AtB85UxC;;AsB95UE;EAAsC,gBAAA;AtBk6UxC;;AsBl6UE;EAAsC,YAAA;AtBs6UxC;;AsBt6UE;EAAsC,gBAAA;AtB06UxC;;AsB16UE;EAAsC,gBAAA;AtB86UxC;;AsB96UE;EAAsC,gBAAA;AtBk7UxC;;AsBl7UE;EAAsC,gBAAA;AtBs7UxC;;AsBt7UE;EAAsC,gBAAA;AtB07UxC;;AsB17UE;EAAsC,gBAAA;AtB87UxC;;AsB97UE;EAAsC,gBAAA;AtBk8UxC;;AsBl8UE;EAAsC,gBAAA;AtBs8UxC;;AsBt8UE;EAAsC,gBAAA;AtB08UxC;;AsB18UE;EAAsC,gBAAA;AtB88UxC;;AsB98UE;EAAsC,gBAAA;AtBk9UxC;;AsBl9UE;EAAsC,gBAAA;AtBs9UxC;;AsBt9UE;EAAsC,gBAAA;AtB09UxC;;AsB19UE;EAAsC,gBAAA;AtB89UxC;;AsB99UE;EAAsC,gBAAA;AtBk+UxC;;AsBl+UE;EAAsC,gBAAA;AtBs+UxC;;AsBt+UE;EAAsC,gBAAA;AtB0+UxC;;AsB1+UE;EAAsC,gBAAA;AtB8+UxC;;AsB9+UE;EAAsC,gBAAA;AtBk/UxC;;AsBl/UE;EAAsC,gBAAA;AtBs/UxC;;AsBt/UE;EAAsC,gBAAA;AtB0/UxC;;AsB1/UE;EAAsC,gBAAA;AtB8/UxC;;AsB9/UE;EAAsC,gBAAA;AtBkgVxC;;AsBlgVE;EAAsC,gBAAA;AtBsgVxC;;AsBtgVE;EAAsC,gBAAA;AtB0gVxC;;AsB1gVE;EAAsC,gBAAA;AtB8gVxC;;AsB9gVE;EAAsC,gBAAA;AtBkhVxC;;AsBlhVE;EAAsC,gBAAA;AtBshVxC;;AsBthVE;EAAsC,gBAAA;AtB0hVxC;;AsB1hVE;EAAsC,gBAAA;AtB8hVxC;;AsB9hVE;EAAsC,gBAAA;AtBkiVxC;;AsBliVE;EAAsC,gBAAA;AtBsiVxC;;AsBtiVE;EAAsC,gBAAA;AtB0iVxC;;AsB1iVE;EAAsC,gBAAA;AtB8iVxC;;AsB9iVE;EAAsC,gBAAA;AtBkjVxC;;AsBljVE;EAAsC,gBAAA;AtBsjVxC;;AsBtjVE;EAAsC,gBAAA;AtB0jVxC;;AsB1jVE;EAAsC,gBAAA;AtB8jVxC;;AsB9jVE;EAAsC,gBAAA;AtBkkVxC;;AsBlkVE;EAAsC,gBAAA;AtBskVxC;;AsBtkVE;EAAsC,gBAAA;AtB0kVxC;;AsB1kVE;EAAsC,gBAAA;AtB8kVxC;;AsB9kVE;EAAsC,gBAAA;AtBklVxC;;AsBllVE;EAAsC,gBAAA;AtBslVxC;;AsBtlVE;EAAsC,gBAAA;AtB0lVxC;;AsB1lVE;EAAsC,gBAAA;AtB8lVxC;;AsB9lVE;EAAsC,gBAAA;AtBkmVxC;;AsBlmVE;EAAsC,gBAAA;AtBsmVxC;;AsBtmVE;EAAsC,gBAAA;AtB0mVxC;;AsB1mVE;EAAsC,gBAAA;AtB8mVxC;;AsB9mVE;EAAsC,gBAAA;AtBknVxC;;AsBlnVE;EAAsC,gBAAA;AtBsnVxC;;AsBtnVE;EAAsC,gBAAA;AtB0nVxC;;AsB1nVE;EAAsC,gBAAA;AtB8nVxC;;AsB9nVE;EAAsC,gBAAA;AtBkoVxC;;AsBloVE;EAAsC,gBAAA;AtBsoVxC;;AsBtoVE;EAAsC,gBAAA;AtB0oVxC;;AsB1oVE;EAAsC,gBAAA;AtB8oVxC;;AsB9oVE;EAAsC,gBAAA;AtBkpVxC;;AsBlpVE;EAAsC,gBAAA;AtBspVxC;;AsBtpVE;EAAsC,gBAAA;AtB0pVxC;;AsB1pVE;EAAsC,gBAAA;AtB8pVxC;;AsB9pVE;EAAsC,gBAAA;AtBkqVxC;;AsBlqVE;EAAsC,gBAAA;AtBsqVxC;;AsBtqVE;EAAsC,gBAAA;AtB0qVxC;;AsB1qVE;EAAsC,gBAAA;AtB8qVxC;;AsB9qVE;EAAsC,gBAAA;AtBkrVxC;;AsBlrVE;EAAsC,gBAAA;AtBsrVxC;;AsBtrVE;EAAsC,gBAAA;AtB0rVxC;;AsB1rVE;EAAsC,gBAAA;AtB8rVxC;;AsB9rVE;EAAsC,gBAAA;AtBksVxC;;AsBlsVE;EAAsC,gBAAA;AtBssVxC;;AsBtsVE;EAAsC,gBAAA;AtB0sVxC;;AsB1sVE;EAAsC,gBAAA;AtB8sVxC;;AsB9sVE;EAAsC,gBAAA;AtBktVxC;;AsBltVE;EAAsC,gBAAA;AtBstVxC;;AsBttVE;EAAsC,gBAAA;AtB0tVxC;;AsB1tVE;EAAsC,gBAAA;AtB8tVxC;;AsB9tVE;EAAsC,gBAAA;AtBkuVxC;;AsBluVE;EAAsC,gBAAA;AtBsuVxC;;AsBtuVE;EAAsC,gBAAA;AtB0uVxC;;AsB1uVE;EAAsC,gBAAA;AtB8uVxC;;AsB9uVE;EAAsC,gBAAA;AtBkvVxC;;AsBlvVE;EAAsC,gBAAA;AtBsvVxC;;AsBtvVE;EAAsC,gBAAA;AtB0vVxC;;AsB1vVE;EAAsC,aAAA;AtB8vVxC;;AsB9vVE;EAAsC,aAAA;AtBkwVxC;;AsBlwVE;EAAsC,aAAA;AtBswVxC;;AsBtwVE;EAAsC,gBAAA;AtB0wVxC;;AsB1wVE;EAAsC,gBAAA;AtB8wVxC;;AsB9wVE;EAAsC,gBAAA;AtBkxVxC;;AsBlxVE;EAAsC,gBAAA;AtBsxVxC;;AsBtxVE;EAAsC,gBAAA;AtB0xVxC;;AsB1xVE;EAAsC,gBAAA;AtB8xVxC;;AsB9xVE;EAAsC,gBAAA;AtBkyVxC;;AsBlyVE;EAAsC,gBAAA;AtBsyVxC;;AsBtyVE;EAAsC,gBAAA;AtB0yVxC;;AsB1yVE;EAAsC,gBAAA;AtB8yVxC;;AsB9yVE;EAAsC,gBAAA;AtBkzVxC;;AsBlzVE;EAAsC,gBAAA;AtBszVxC;;AsBtzVE;EAAsC,gBAAA;AtB0zVxC;;AsB1zVE;EAAsC,gBAAA;AtB8zVxC;;AsB9zVE;EAAsC,gBAAA;AtBk0VxC;;AsBl0VE;EAAsC,gBAAA;AtBs0VxC;;AsBt0VE;EAAsC,gBAAA;AtB00VxC;;AsB10VE;EAAsC,gBAAA;AtB80VxC;;AsB90VE;EAAsC,gBAAA;AtBk1VxC;;AsBl1VE;EAAsC,gBAAA;AtBs1VxC;;AsBt1VE;EAAsC,gBAAA;AtB01VxC;;AsB11VE;EAAsC,gBAAA;AtB81VxC;;AsB91VE;EAAsC,gBAAA;AtBk2VxC;;AsBl2VE;EAAsC,gBAAA;AtBs2VxC;;AsBt2VE;EAAsC,gBAAA;AtB02VxC;;AsB12VE;EAAsC,gBAAA;AtB82VxC;;AsB92VE;EAAsC,gBAAA;AtBk3VxC;;AsBl3VE;EAAsC,gBAAA;AtBs3VxC;;AsBt3VE;EAAsC,gBAAA;AtB03VxC;;AsB13VE;EAAsC,gBAAA;AtB83VxC;;AsB93VE;EAAsC,gBAAA;AtBk4VxC;;AsBl4VE;EAAsC,gBAAA;AtBs4VxC;;AsBt4VE;EAAsC,gBAAA;AtB04VxC;;AsB14VE;EAAsC,gBAAA;AtB84VxC;;AsB94VE;EAAsC,gBAAA;AtBk5VxC;;AsBl5VE;EAAsC,gBAAA;AtBs5VxC;;AsBt5VE;EAAsC,gBAAA;AtB05VxC;;AsB15VE;EAAsC,gBAAA;AtB85VxC;;AsB95VE;EAAsC,gBAAA;AtBk6VxC;;AsBl6VE;EAAsC,gBAAA;AtBs6VxC;;AsBt6VE;EAAsC,gBAAA;AtB06VxC;;AsB16VE;EAAsC,gBAAA;AtB86VxC;;AsB96VE;EAAsC,gBAAA;AtBk7VxC;;AsBl7VE;EAAsC,gBAAA;AtBs7VxC;;AsBt7VE;EAAsC,gBAAA;AtB07VxC;;AsB17VE;EAAsC,gBAAA;AtB87VxC;;AsB97VE;EAAsC,gBAAA;AtBk8VxC;;AsBl8VE;EAAsC,gBAAA;AtBs8VxC;;AsBt8VE;EAAsC,gBAAA;AtB08VxC;;AsB18VE;EAAsC,gBAAA;AtB88VxC;;AsB98VE;EAAsC,gBAAA;AtBk9VxC;;AsBl9VE;EAAsC,gBAAA;AtBs9VxC;;AsBt9VE;EAAsC,gBAAA;AtB09VxC;;AsB19VE;EAAsC,gBAAA;AtB89VxC;;AsB99VE;EAAsC,gBAAA;AtBk+VxC;;AsBl+VE;EAAsC,gBAAA;AtBs+VxC;;AsBt+VE;EAAsC,gBAAA;AtB0+VxC;;AsB1+VE;EAAsC,gBAAA;AtB8+VxC;;AsB9+VE;EAAsC,gBAAA;AtBk/VxC;;AsBl/VE;EAAsC,gBAAA;AtBs/VxC;;AsBt/VE;EAAsC,gBAAA;AtB0/VxC;;AsB1/VE;EAAsC,gBAAA;AtB8/VxC;;AsB9/VE;EAAsC,gBAAA;AtBkgWxC;;AsBlgWE;EAAsC,gBAAA;AtBsgWxC;;AsBtgWE;EAAsC,gBAAA;AtB0gWxC;;AsB1gWE;EAAsC,gBAAA;AtB8gWxC;;AsB9gWE;EAAsC,gBAAA;AtBkhWxC;;AsBlhWE;EAAsC,gBAAA;AtBshWxC;;AsBthWE;EAAsC,gBAAA;AtB0hWxC;;AsB1hWE;EAAsC,gBAAA;AtB8hWxC;;AsB9hWE;EAAsC,gBAAA;AtBkiWxC;;AsBliWE;EAAsC,gBAAA;AtBsiWxC;;AsBtiWE;EAAsC,gBAAA;AtB0iWxC;;AsB1iWE;EAAsC,gBAAA;AtB8iWxC;;AsB9iWE;EAAsC,gBAAA;AtBkjWxC;;AsBljWE;EAAsC,gBAAA;AtBsjWxC;;AsBtjWE;EAAsC,gBAAA;AtB0jWxC;;AsB1jWE;EAAsC,gBAAA;AtB8jWxC;;AsB9jWE;EAAsC,gBAAA;AtBkkWxC;;AsBlkWE;EAAsC,gBAAA;AtBskWxC;;AsBtkWE;EAAsC,gBAAA;AtB0kWxC;;AsB1kWE;EAAsC,gBAAA;AtB8kWxC;;AsB9kWE;EAAsC,gBAAA;AtBklWxC;;AsBllWE;EAAsC,gBAAA;AtBslWxC;;AsBtlWE;EAAsC,gBAAA;AtB0lWxC;;AsB1lWE;EAAsC,gBAAA;AtB8lWxC;;AsB9lWE;EAAsC,gBAAA;AtBkmWxC;;AsBlmWE;EAAsC,gBAAA;AtBsmWxC;;AsBtmWE;EAAsC,gBAAA;AtB0mWxC;;AsB1mWE;EAAsC,gBAAA;AtB8mWxC;;AsB9mWE;EAAsC,gBAAA;AtBknWxC;;AsBlnWE;EAAsC,gBAAA;AtBsnWxC;;AsBtnWE;EAAsC,aAAA;AtB0nWxC;;AsB1nWE;EAAsC,gBAAA;AtB8nWxC;;AsB9nWE;EAAsC,gBAAA;AtBkoWxC;;AsBloWE;EAAsC,gBAAA;AtBsoWxC;;AsBtoWE;EAAsC,gBAAA;AtB0oWxC;;AsB1oWE;EAAsC,gBAAA;AtB8oWxC;;AsB9oWE;EAAsC,gBAAA;AtBkpWxC;;AsBlpWE;EAAsC,gBAAA;AtBspWxC;;AsBtpWE;EAAsC,gBAAA;AtB0pWxC;;AsB1pWE;EAAsC,gBAAA;AtB8pWxC;;AsB9pWE;EAAsC,gBAAA;AtBkqWxC;;AsBlqWE;EAAsC,gBAAA;AtBsqWxC;;AsBtqWE;EAAsC,gBAAA;AtB0qWxC;;AsB1qWE;EAAsC,gBAAA;AtB8qWxC;;AsB9qWE;EAAsC,gBAAA;AtBkrWxC;;AsBlrWE;EAAsC,gBAAA;AtBsrWxC;;AsBtrWE;EAAsC,gBAAA;AtB0rWxC;;AsB1rWE;EAAsC,gBAAA;AtB8rWxC;;AsB9rWE;EAAsC,gBAAA;AtBksWxC;;AsBlsWE;EAAsC,gBAAA;AtBssWxC;;AsBtsWE;EAAsC,gBAAA;AtB0sWxC;;AsB1sWE;EAAsC,gBAAA;AtB8sWxC;;AsB9sWE;EAAsC,gBAAA;AtBktWxC;;AsBltWE;EAAsC,gBAAA;AtBstWxC;;AsBttWE;EAAsC,gBAAA;AtB0tWxC;;AsB1tWE;EAAsC,aAAA;AtB8tWxC;;AsB9tWE;EAAsC,aAAA;AtBkuWxC;;AsBluWE;EAAsC,gBAAA;AtBsuWxC;;AsBtuWE;EAAsC,gBAAA;AtB0uWxC;;AsB1uWE;EAAsC,gBAAA;AtB8uWxC;;AsB9uWE;EAAsC,gBAAA;AtBkvWxC;;AsBlvWE;EAAsC,gBAAA;AtBsvWxC;;AsBtvWE;EAAsC,gBAAA;AtB0vWxC;;AsB1vWE;EAAsC,gBAAA;AtB8vWxC;;AsB9vWE;EAAsC,gBAAA;AtBkwWxC;;AsBlwWE;EAAsC,gBAAA;AtBswWxC;;AsBtwWE;EAAsC,gBAAA;AtB0wWxC;;AsB1wWE;EAAsC,gBAAA;AtB8wWxC;;AsB9wWE;EAAsC,gBAAA;AtBkxWxC;;AsBlxWE;EAAsC,gBAAA;AtBsxWxC;;AsBtxWE;EAAsC,gBAAA;AtB0xWxC;;AsB1xWE;EAAsC,gBAAA;AtB8xWxC;;AsB9xWE;EAAsC,gBAAA;AtBkyWxC;;AsBlyWE;EAAsC,gBAAA;AtBsyWxC;;AsBtyWE;EAAsC,gBAAA;AtB0yWxC;;AsB1yWE;EAAsC,gBAAA;AtB8yWxC;;AsB9yWE;EAAsC,gBAAA;AtBkzWxC;;AsBlzWE;EAAsC,gBAAA;AtBszWxC;;AsBtzWE;EAAsC,gBAAA;AtB0zWxC;;AsB1zWE;EAAsC,gBAAA;AtB8zWxC;;AsB9zWE;EAAsC,gBAAA;AtBk0WxC;;AsBl0WE;EAAsC,gBAAA;AtBs0WxC;;AsBt0WE;EAAsC,gBAAA;AtB00WxC;;AsB10WE;EAAsC,gBAAA;AtB80WxC;;AsB90WE;EAAsC,gBAAA;AtBk1WxC;;AsBl1WE;EAAsC,gBAAA;AtBs1WxC;;AsBt1WE;EAAsC,gBAAA;AtB01WxC;;AsB11WE;EAAsC,gBAAA;AtB81WxC;;AsB91WE;EAAsC,gBAAA;AtBk2WxC;;AsBl2WE;EAAsC,gBAAA;AtBs2WxC;;AsBt2WE;EAAsC,gBAAA;AtB02WxC;;AsB12WE;EAAsC,gBAAA;AtB82WxC;;AsB92WE;EAAsC,gBAAA;AtBk3WxC;;AsBl3WE;EAAsC,gBAAA;AtBs3WxC;;AsBt3WE;EAAsC,YAAA;AtB03WxC;;AsB13WE;EAAsC,gBAAA;AtB83WxC;;AsB93WE;EAAsC,aAAA;AtBk4WxC;;AsBl4WE;EAAsC,gBAAA;AtBs4WxC;;AsBt4WE;EAAsC,gBAAA;AtB04WxC;;AsB14WE;EAAsC,gBAAA;AtB84WxC;;AsB94WE;EAAsC,gBAAA;AtBk5WxC;;AsBl5WE;EAAsC,gBAAA;AtBs5WxC;;AsBt5WE;EAAsC,gBAAA;AtB05WxC;;AsB15WE;EAAsC,gBAAA;AtB85WxC;;AsB95WE;EAAsC,gBAAA;AtBk6WxC;;AsBl6WE;EAAsC,YAAA;AtBs6WxC;;AsBt6WE;EAAsC,gBAAA;AtB06WxC;;AsB16WE;EAAsC,gBAAA;AtB86WxC;;AsB96WE;EAAsC,gBAAA;AtBk7WxC;;AsBl7WE;EAAsC,gBAAA;AtBs7WxC;;AsBt7WE;EAAsC,gBAAA;AtB07WxC;;AsB17WE;EAAsC,gBAAA;AtB87WxC;;AsB97WE;EAAsC,gBAAA;AtBk8WxC;;AsBl8WE;EAAsC,gBAAA;AtBs8WxC;;AsBt8WE;EAAsC,gBAAA;AtB08WxC;;AsB18WE;EAAsC,gBAAA;AtB88WxC;;AsB98WE;EAAsC,gBAAA;AtBk9WxC;;AsBl9WE;EAAsC,gBAAA;AtBs9WxC;;AsBt9WE;EAAsC,gBAAA;AtB09WxC;;AsB19WE;EAAsC,gBAAA;AtB89WxC;;AsB99WE;EAAsC,gBAAA;AtBk+WxC;;AsBl+WE;EAAsC,gBAAA;AtBs+WxC;;AsBt+WE;EAAsC,gBAAA;AtB0+WxC;;AsB1+WE;EAAsC,gBAAA;AtB8+WxC;;AsB9+WE;EAAsC,gBAAA;AtBk/WxC;;AsBl/WE;EAAsC,gBAAA;AtBs/WxC;;AsBt/WE;EAAsC,gBAAA;AtB0/WxC;;AsB1/WE;EAAsC,gBAAA;AtB8/WxC;;AsB9/WE;EAAsC,gBAAA;AtBkgXxC;;AsBlgXE;EAAsC,gBAAA;AtBsgXxC;;AsBtgXE;EAAsC,gBAAA;AtB0gXxC;;AsB1gXE;EAAsC,gBAAA;AtB8gXxC;;AsB9gXE;EAAsC,gBAAA;AtBkhXxC;;AsBlhXE;EAAsC,gBAAA;AtBshXxC;;AsBthXE;EAAsC,gBAAA;AtB0hXxC;;AsB1hXE;EAAsC,gBAAA;AtB8hXxC;;AsB9hXE;EAAsC,gBAAA;AtBkiXxC;;AsBliXE;EAAsC,gBAAA;AtBsiXxC;;AsBtiXE;EAAsC,gBAAA;AtB0iXxC;;AsB1iXE;EAAsC,gBAAA;AtB8iXxC;;AsB9iXE;EAAsC,gBAAA;AtBkjXxC;;AsBljXE;EAAsC,gBAAA;AtBsjXxC;;AsBtjXE;EAAsC,gBAAA;AtB0jXxC;;AsB1jXE;EAAsC,gBAAA;AtB8jXxC;;AsB9jXE;EAAsC,gBAAA;AtBkkXxC;;AsBlkXE;EAAsC,gBAAA;AtBskXxC;;AsBtkXE;EAAsC,gBAAA;AtB0kXxC;;AsB1kXE;EAAsC,gBAAA;AtB8kXxC;;AsB9kXE;EAAsC,gBAAA;AtBklXxC;;AsBllXE;EAAsC,gBAAA;AtBslXxC;;AsBtlXE;EAAsC,gBAAA;AtB0lXxC;;AsB1lXE;EAAsC,gBAAA;AtB8lXxC;;AsB9lXE;EAAsC,gBAAA;AtBkmXxC;;AsBlmXE;EAAsC,gBAAA;AtBsmXxC;;AsBtmXE;EAAsC,gBAAA;AtB0mXxC;;AsB1mXE;EAAsC,gBAAA;AtB8mXxC;;AsB9mXE;EAAsC,gBAAA;AtBknXxC;;AsBlnXE;EAAsC,gBAAA;AtBsnXxC;;AsBtnXE;EAAsC,gBAAA;AtB0nXxC;;AsB1nXE;EAAsC,gBAAA;AtB8nXxC;;AsB9nXE;EAAsC,gBAAA;AtBkoXxC;;AsBloXE;EAAsC,gBAAA;AtBsoXxC;;AsBtoXE;EAAsC,gBAAA;AtB0oXxC;;AsB1oXE;EAAsC,gBAAA;AtB8oXxC;;AsB9oXE;EAAsC,gBAAA;AtBkpXxC;;AsBlpXE;EAAsC,gBAAA;AtBspXxC;;AsBtpXE;EAAsC,gBAAA;AtB0pXxC;;AsB1pXE;EAAsC,gBAAA;AtB8pXxC;;AsB9pXE;EAAsC,gBAAA;AtBkqXxC;;AsBlqXE;EAAsC,gBAAA;AtBsqXxC;;AsBtqXE;EAAsC,gBAAA;AtB0qXxC;;AsB1qXE;EAAsC,gBAAA;AtB8qXxC;;AsB9qXE;EAAsC,gBAAA;AtBkrXxC;;AsBlrXE;EAAsC,gBAAA;AtBsrXxC;;AsBtrXE;EAAsC,gBAAA;AtB0rXxC;;AsB1rXE;EAAsC,gBAAA;AtB8rXxC;;AsB9rXE;EAAsC,gBAAA;AtBksXxC;;AsBlsXE;EAAsC,gBAAA;AtBssXxC;;AsBtsXE;EAAsC,gBAAA;AtB0sXxC;;AsB1sXE;EAAsC,gBAAA;AtB8sXxC;;AsB9sXE;EAAsC,gBAAA;AtBktXxC;;AsBltXE;EAAsC,gBAAA;AtBstXxC;;AsBttXE;EAAsC,gBAAA;AtB0tXxC;;AsB1tXE;EAAsC,gBAAA;AtB8tXxC;;AsB9tXE;EAAsC,gBAAA;AtBkuXxC;;AsBluXE;EAAsC,gBAAA;AtBsuXxC;;AsBtuXE;EAAsC,gBAAA;AtB0uXxC;;AsB1uXE;EAAsC,gBAAA;AtB8uXxC;;AsB9uXE;EAAsC,gBAAA;AtBkvXxC;;AsBlvXE;EAAsC,gBAAA;AtBsvXxC;;AsBtvXE;EAAsC,gBAAA;AtB0vXxC;;AsB1vXE;EAAsC,gBAAA;AtB8vXxC;;AsB9vXE;EAAsC,gBAAA;AtBkwXxC;;AsBlwXE;EAAsC,gBAAA;AtBswXxC;;AsBtwXE;EAAsC,gBAAA;AtB0wXxC;;AsB1wXE;EAAsC,gBAAA;AtB8wXxC;;AsB9wXE;EAAsC,gBAAA;AtBkxXxC;;AsBlxXE;EAAsC,gBAAA;AtBsxXxC;;AsBtxXE;EAAsC,gBAAA;AtB0xXxC;;AsB1xXE;EAAsC,gBAAA;AtB8xXxC;;AsB9xXE;EAAsC,gBAAA;AtBkyXxC;;AsBlyXE;EAAsC,gBAAA;AtBsyXxC;;AsBtyXE;EAAsC,gBAAA;AtB0yXxC;;AsB1yXE;EAAsC,gBAAA;AtB8yXxC;;AsB9yXE;EAAsC,gBAAA;AtBkzXxC;;AsBlzXE;EAAsC,gBAAA;AtBszXxC;;AsBtzXE;EAAsC,gBAAA;AtB0zXxC;;AsB1zXE;EAAsC,gBAAA;AtB8zXxC;;AsB9zXE;EAAsC,gBAAA;AtBk0XxC;;AsBl0XE;EAAsC,gBAAA;AtBs0XxC;;AsBt0XE;EAAsC,gBAAA;AtB00XxC;;AsB10XE;EAAsC,gBAAA;AtB80XxC;;AsB90XE;EAAsC,gBAAA;AtBk1XxC;;AsBl1XE;EAAsC,gBAAA;AtBs1XxC;;AsBt1XE;EAAsC,YAAA;AtB01XxC;;AsB11XE;EAAsC,gBAAA;AtB81XxC;;AsB91XE;EAAsC,gBAAA;AtBk2XxC;;AsBl2XE;EAAsC,gBAAA;AtBs2XxC;;AsBt2XE;EAAsC,gBAAA;AtB02XxC;;AsB12XE;EAAsC,gBAAA;AtB82XxC;;AsB92XE;EAAsC,gBAAA;AtBk3XxC;;AsBl3XE;EAAsC,gBAAA;AtBs3XxC;;AsBt3XE;EAAsC,gBAAA;AtB03XxC;;AsB13XE;EAAsC,gBAAA;AtB83XxC;;AsB93XE;EAAsC,gBAAA;AtBk4XxC;;AsBl4XE;EAAsC,gBAAA;AtBs4XxC;;AsBt4XE;EAAsC,gBAAA;AtB04XxC;;AsB14XE;EAAsC,gBAAA;AtB84XxC;;AsB94XE;EAAsC,gBAAA;AtBk5XxC;;AsBl5XE;EAAsC,gBAAA;AtBs5XxC;;AsBt5XE;EAAsC,gBAAA;AtB05XxC;;AsB15XE;EAAsC,gBAAA;AtB85XxC;;AsB95XE;EAAsC,gBAAA;AtBk6XxC;;AsBl6XE;EAAsC,gBAAA;AtBs6XxC;;AsBt6XE;EAAsC,gBAAA;AtB06XxC;;AsB16XE;EAAsC,gBAAA;AtB86XxC;;AsB96XE;EAAsC,gBAAA;AtBk7XxC;;AsBl7XE;EAAsC,gBAAA;AtBs7XxC;;AsBt7XE;EAAsC,gBAAA;AtB07XxC;;AsB17XE;EAAsC,gBAAA;AtB87XxC;;AsB97XE;EAAsC,gBAAA;AtBk8XxC;;AsBl8XE;EAAsC,gBAAA;AtBs8XxC;;AsBt8XE;EAAsC,gBAAA;AtB08XxC;;AsB18XE;EAAsC,gBAAA;AtB88XxC;;AsB98XE;EAAsC,gBAAA;AtBk9XxC;;AsBl9XE;EAAsC,gBAAA;AtBs9XxC;;AsBt9XE;EAAsC,gBAAA;AtB09XxC;;AsB19XE;EAAsC,gBAAA;AtB89XxC;;AsB99XE;EAAsC,gBAAA;AtBk+XxC;;AsBl+XE;EAAsC,gBAAA;AtBs+XxC;;AsBt+XE;EAAsC,gBAAA;AtB0+XxC;;AsB1+XE;EAAsC,gBAAA;AtB8+XxC;;AsB9+XE;EAAsC,gBAAA;AtBk/XxC;;AsBl/XE;EAAsC,gBAAA;AtBs/XxC;;AsBt/XE;EAAsC,gBAAA;AtB0/XxC;;AsB1/XE;EAAsC,gBAAA;AtB8/XxC;;AsB9/XE;EAAsC,gBAAA;AtBkgYxC;;AsBlgYE;EAAsC,gBAAA;AtBsgYxC;;AsBtgYE;EAAsC,gBAAA;AtB0gYxC;;AsB1gYE;EAAsC,gBAAA;AtB8gYxC;;AsB9gYE;EAAsC,gBAAA;AtBkhYxC;;AsBlhYE;EAAsC,gBAAA;AtBshYxC;;AsBthYE;EAAsC,gBAAA;AtB0hYxC;;AsB1hYE;EAAsC,gBAAA;AtB8hYxC;;AsB9hYE;EAAsC,gBAAA;AtBkiYxC;;AsBliYE;EAAsC,gBAAA;AtBsiYxC;;AsBtiYE;EAAsC,gBAAA;AtB0iYxC;;AsB1iYE;EAAsC,gBAAA;AtB8iYxC;;AsB9iYE;EAAsC,gBAAA;AtBkjYxC;;AsBljYE;EAAsC,aAAA;AtBsjYxC;;AsBtjYE;EAAsC,gBAAA;AtB0jYxC;;AsB1jYE;EAAsC,gBAAA;AtB8jYxC;;AsB9jYE;EAAsC,gBAAA;AtBkkYxC;;AsBlkYE;EAAsC,gBAAA;AtBskYxC;;AsBtkYE;EAAsC,gBAAA;AtB0kYxC;;AsB1kYE;EAAsC,gBAAA;AtB8kYxC;;AsB9kYE;EAAsC,gBAAA;AtBklYxC;;AsBllYE;EAAsC,gBAAA;AtBslYxC;;AsBtlYE;EAAsC,gBAAA;AtB0lYxC;;AsB1lYE;EAAsC,gBAAA;AtB8lYxC;;AsB9lYE;EAAsC,gBAAA;AtBkmYxC;;AsBlmYE;EAAsC,gBAAA;AtBsmYxC;;AsBtmYE;EAAsC,gBAAA;AtB0mYxC;;AsB1mYE;EAAsC,gBAAA;AtB8mYxC;;AsB9mYE;EAAsC,gBAAA;AtBknYxC;;AsBlnYE;EAAsC,gBAAA;AtBsnYxC;;AsBtnYE;EAAsC,gBAAA;AtB0nYxC;;AsB1nYE;EAAsC,gBAAA;AtB8nYxC;;AsB9nYE;EAAsC,gBAAA;AtBkoYxC;;AsBloYE;EAAsC,gBAAA;AtBsoYxC;;AsBtoYE;EAAsC,gBAAA;AtB0oYxC;;AsB1oYE;EAAsC,gBAAA;AtB8oYxC;;AsB9oYE;EAAsC,gBAAA;AtBkpYxC;;AsBlpYE;EAAsC,gBAAA;AtBspYxC;;AsBtpYE;EAAsC,gBAAA;AtB0pYxC;;AsB1pYE;EAAsC,gBAAA;AtB8pYxC;;AsB9pYE;EAAsC,gBAAA;AtBkqYxC;;AsBlqYE;EAAsC,gBAAA;AtBsqYxC;;AsBtqYE;EAAsC,gBAAA;AtB0qYxC;;AsB1qYE;EAAsC,gBAAA;AtB8qYxC;;AsB9qYE;EAAsC,gBAAA;AtBkrYxC;;AsBlrYE;EAAsC,gBAAA;AtBsrYxC;;AsBtrYE;EAAsC,gBAAA;AtB0rYxC;;AsB1rYE;EAAsC,gBAAA;AtB8rYxC;;AsB9rYE;EAAsC,gBAAA;AtBksYxC;;AsBlsYE;EAAsC,gBAAA;AtBssYxC;;AsBtsYE;EAAsC,gBAAA;AtB0sYxC;;AsB1sYE;EAAsC,gBAAA;AtB8sYxC;;AsB9sYE;EAAsC,gBAAA;AtBktYxC;;AsBltYE;EAAsC,gBAAA;AtBstYxC;;AsBttYE;EAAsC,gBAAA;AtB0tYxC;;AsB1tYE;EAAsC,gBAAA;AtB8tYxC;;AsB9tYE;EAAsC,gBAAA;AtBkuYxC;;AsBluYE;EAAsC,gBAAA;AtBsuYxC;;AsBtuYE;EAAsC,gBAAA;AtB0uYxC;;AsB1uYE;EAAsC,gBAAA;AtB8uYxC;;AsB9uYE;EAAsC,gBAAA;AtBkvYxC;;AsBlvYE;EAAsC,gBAAA;AtBsvYxC;;AsBtvYE;EAAsC,gBAAA;AtB0vYxC;;AsB1vYE;EAAsC,gBAAA;AtB8vYxC;;AsB9vYE;EAAsC,gBAAA;AtBkwYxC;;AsBlwYE;EAAsC,gBAAA;AtBswYxC;;AsBtwYE;EAAsC,gBAAA;AtB0wYxC;;AsB1wYE;EAAsC,gBAAA;AtB8wYxC;;AsB9wYE;EAAsC,gBAAA;AtBkxYxC;;AsBlxYE;EAAsC,gBAAA;AtBsxYxC;;AsBtxYE;EAAsC,gBAAA;AtB0xYxC;;AsB1xYE;EAAsC,gBAAA;AtB8xYxC;;AsB9xYE;EAAsC,gBAAA;AtBkyYxC;;AsBlyYE;EAAsC,gBAAA;AtBsyYxC;;AsBtyYE;EAAsC,gBAAA;AtB0yYxC;;AsB1yYE;EAAsC,gBAAA;AtB8yYxC;;AsB9yYE;EAAsC,gBAAA;AtBkzYxC;;AsBlzYE;EAAsC,gBAAA;AtBszYxC;;AsBtzYE;EAAsC,gBAAA;AtB0zYxC;;AsB1zYE;EAAsC,gBAAA;AtB8zYxC;;AsB9zYE;EAAsC,gBAAA;AtBk0YxC;;AsBl0YE;EAAsC,gBAAA;AtBs0YxC;;AsBt0YE;EAAsC,gBAAA;AtB00YxC;;AsB10YE;EAAsC,gBAAA;AtB80YxC;;AsB90YE;EAAsC,gBAAA;AtBk1YxC;;AsBl1YE;EAAsC,gBAAA;AtBs1YxC;;AsBt1YE;EAAsC,gBAAA;AtB01YxC;;AsB11YE;EAAsC,gBAAA;AtB81YxC;;AsB91YE;EAAsC,gBAAA;AtBk2YxC;;AsBl2YE;EAAsC,gBAAA;AtBs2YxC;;AsBt2YE;EAAsC,gBAAA;AtB02YxC;;AsB12YE;EAAsC,gBAAA;AtB82YxC;;AsB92YE;EAAsC,gBAAA;AtBk3YxC;;AsBl3YE;EAAsC,gBAAA;AtBs3YxC;;AsBt3YE;EAAsC,gBAAA;AtB03YxC;;AsB13YE;EAAsC,gBAAA;AtB83YxC;;AsB93YE;EAAsC,gBAAA;AtBk4YxC;;AsBl4YE;EAAsC,gBAAA;AtBs4YxC;;AsBt4YE;EAAsC,gBAAA;AtB04YxC;;AsB14YE;EAAsC,gBAAA;AtB84YxC;;AsB94YE;EAAsC,gBAAA;AtBk5YxC;;AsBl5YE;EAAsC,gBAAA;AtBs5YxC;;AsBt5YE;EAAsC,gBAAA;AtB05YxC;;AsB15YE;EAAsC,gBAAA;AtB85YxC;;AsB95YE;EAAsC,gBAAA;AtBk6YxC;;AsBl6YE;EAAsC,gBAAA;AtBs6YxC;;AsBt6YE;EAAsC,gBAAA;AtB06YxC;;AsB16YE;EAAsC,gBAAA;AtB86YxC;;AsB96YE;EAAsC,gBAAA;AtBk7YxC;;AsBl7YE;EAAsC,gBAAA;AtBs7YxC;;AsBt7YE;EAAsC,gBAAA;AtB07YxC;;AsB17YE;EAAsC,gBAAA;AtB87YxC;;AsB97YE;EAAsC,gBAAA;AtBk8YxC;;AsBl8YE;EAAsC,gBAAA;AtBs8YxC;;AsBt8YE;EAAsC,gBAAA;AtB08YxC;;AsB18YE;EAAsC,gBAAA;AtB88YxC;;AsB98YE;EAAsC,gBAAA;AtBk9YxC;;AsBl9YE;EAAsC,gBAAA;AtBs9YxC;;AsBt9YE;EAAsC,gBAAA;AtB09YxC;;AsB19YE;EAAsC,gBAAA;AtB89YxC;;AsB99YE;EAAsC,gBAAA;AtBk+YxC;;AsBl+YE;EAAsC,gBAAA;AtBs+YxC;;AsBt+YE;EAAsC,gBAAA;AtB0+YxC;;AsB1+YE;EAAsC,gBAAA;AtB8+YxC;;AsB9+YE;EAAsC,gBAAA;AtBk/YxC;;AsBl/YE;EAAsC,gBAAA;AtBs/YxC;;AsBt/YE;EAAsC,gBAAA;AtB0/YxC;;AsB1/YE;EAAsC,gBAAA;AtB8/YxC;;AsB9/YE;EAAsC,gBAAA;AtBkgZxC;;AsBlgZE;EAAsC,gBAAA;AtBsgZxC;;AsBtgZE;EAAsC,gBAAA;AtB0gZxC;;AsB1gZE;EAAsC,gBAAA;AtB8gZxC;;AsB9gZE;EAAsC,gBAAA;AtBkhZxC;;AsBlhZE;EAAsC,aAAA;AtBshZxC;;AsBthZE;EAAsC,aAAA;AtB0hZxC;;AsB1hZE;EAAsC,gBAAA;AtB8hZxC;;AsB9hZE;EAAsC,gBAAA;AtBkiZxC;;AsBliZE;EAAsC,gBAAA;AtBsiZxC;;AsBtiZE;EAAsC,gBAAA;AtB0iZxC;;AsB1iZE;EAAsC,gBAAA;AtB8iZxC;;AsB9iZE;EAAsC,gBAAA;AtBkjZxC;;AsBljZE;EAAsC,gBAAA;AtBsjZxC;;AsBtjZE;EAAsC,gBAAA;AtB0jZxC;;AsB1jZE;EAAsC,gBAAA;AtB8jZxC;;AsB9jZE;EAAsC,gBAAA;AtBkkZxC;;AsBlkZE;EAAsC,gBAAA;AtBskZxC;;AsBtkZE;EAAsC,gBAAA;AtB0kZxC;;AsB1kZE;EAAsC,gBAAA;AtB8kZxC;;AsB9kZE;EAAsC,gBAAA;AtBklZxC;;AsBllZE;EAAsC,gBAAA;AtBslZxC;;AsBtlZE;EAAsC,gBAAA;AtB0lZxC;;AsB1lZE;EAAsC,gBAAA;AtB8lZxC;;AsB9lZE;EAAsC,gBAAA;AtBkmZxC;;AsBlmZE;EAAsC,gBAAA;AtBsmZxC;;AsBtmZE;EAAsC,gBAAA;AtB0mZxC;;AsB1mZE;EAAsC,gBAAA;AtB8mZxC;;AsB9mZE;EAAsC,gBAAA;AtBknZxC;;AsBlnZE;EAAsC,gBAAA;AtBsnZxC;;AsBtnZE;EAAsC,gBAAA;AtB0nZxC;;AsB1nZE;EAAsC,gBAAA;AtB8nZxC;;AsB9nZE;EAAsC,gBAAA;AtBkoZxC;;AsBloZE;EAAsC,gBAAA;AtBsoZxC;;AsBtoZE;EAAsC,gBAAA;AtB0oZxC;;AsB1oZE;EAAsC,gBAAA;AtB8oZxC;;AsB9oZE;EAAsC,gBAAA;AtBkpZxC;;AsBlpZE;EAAsC,gBAAA;AtBspZxC;;AsBtpZE;EAAsC,gBAAA;AtB0pZxC;;AsB1pZE;EAAsC,gBAAA;AtB8pZxC;;AsB9pZE;EAAsC,gBAAA;AtBkqZxC;;AsBlqZE;EAAsC,gBAAA;AtBsqZxC;;AsBtqZE;EAAsC,gBAAA;AtB0qZxC;;AsB1qZE;EAAsC,gBAAA;AtB8qZxC;;AsB9qZE;EAAsC,gBAAA;AtBkrZxC;;AsBlrZE;EAAsC,gBAAA;AtBsrZxC;;AsBtrZE;EAAsC,gBAAA;AtB0rZxC;;AsB1rZE;EAAsC,gBAAA;AtB8rZxC;;AsB9rZE;EAAsC,gBAAA;AtBksZxC;;AsBlsZE;EAAsC,gBAAA;AtBssZxC;;AsBtsZE;EAAsC,gBAAA;AtB0sZxC;;AsB1sZE;EAAsC,gBAAA;AtB8sZxC;;AsB9sZE;EAAsC,gBAAA;AtBktZxC;;AsBltZE;EAAsC,gBAAA;AtBstZxC;;AsBttZE;EAAsC,gBAAA;AtB0tZxC;;AsB1tZE;EAAsC,gBAAA;AtB8tZxC;;AsB9tZE;EAAsC,gBAAA;AtBkuZxC;;AsBluZE;EAAsC,gBAAA;AtBsuZxC;;AsBtuZE;EAAsC,gBAAA;AtB0uZxC;;AsB1uZE;EAAsC,gBAAA;AtB8uZxC;;AsB9uZE;EAAsC,gBAAA;AtBkvZxC;;AsBlvZE;EAAsC,gBAAA;AtBsvZxC;;AsBtvZE;EAAsC,gBAAA;AtB0vZxC;;AsB1vZE;EAAsC,gBAAA;AtB8vZxC;;AsB9vZE;EAAsC,gBAAA;AtBkwZxC;;AsBlwZE;EAAsC,gBAAA;AtBswZxC;;AsBtwZE;EAAsC,gBAAA;AtB0wZxC;;AsB1wZE;EAAsC,gBAAA;AtB8wZxC;;AsB9wZE;EAAsC,gBAAA;AtBkxZxC;;AsBlxZE;EAAsC,gBAAA;AtBsxZxC;;AsBtxZE;EAAsC,gBAAA;AtB0xZxC;;AsB1xZE;EAAsC,gBAAA;AtB8xZxC;;AsB9xZE;EAAsC,gBAAA;AtBkyZxC;;AsBlyZE;EAAsC,gBAAA;AtBsyZxC;;AsBtyZE;EAAsC,gBAAA;AtB0yZxC;;AsB1yZE;EAAsC,gBAAA;AtB8yZxC;;AsB9yZE;EAAsC,gBAAA;AtBkzZxC;;AsBlzZE;EAAsC,gBAAA;AtBszZxC;;AsBtzZE;EAAsC,gBAAA;AtB0zZxC;;AsB1zZE;EAAsC,gBAAA;AtB8zZxC;;AsB9zZE;EAAsC,gBAAA;AtBk0ZxC;;AsBl0ZE;EAAsC,gBAAA;AtBs0ZxC;;AsBt0ZE;EAAsC,gBAAA;AtB00ZxC;;AsB10ZE;EAAsC,gBAAA;AtB80ZxC;;AsB90ZE;EAAsC,gBAAA;AtBk1ZxC;;AsBl1ZE;EAAsC,gBAAA;AtBs1ZxC;;AsBt1ZE;EAAsC,gBAAA;AtB01ZxC;;AsB11ZE;EAAsC,gBAAA;AtB81ZxC;;AsB91ZE;EAAsC,gBAAA;AtBk2ZxC;;AsBl2ZE;EAAsC,gBAAA;AtBs2ZxC;;AsBt2ZE;EAAsC,gBAAA;AtB02ZxC;;AsB12ZE;EAAsC,gBAAA;AtB82ZxC;;AsB92ZE;EAAsC,gBAAA;AtBk3ZxC;;AsBl3ZE;EAAsC,gBAAA;AtBs3ZxC;;AsBt3ZE;EAAsC,gBAAA;AtB03ZxC;;AsB13ZE;EAAsC,gBAAA;AtB83ZxC;;AsB93ZE;EAAsC,gBAAA;AtBk4ZxC;;AsBl4ZE;EAAsC,gBAAA;AtBs4ZxC;;AsBt4ZE;EAAsC,gBAAA;AtB04ZxC;;AsB14ZE;EAAsC,gBAAA;AtB84ZxC;;AsB94ZE;EAAsC,gBAAA;AtBk5ZxC;;AsBl5ZE;EAAsC,gBAAA;AtBs5ZxC;;AsBt5ZE;EAAsC,gBAAA;AtB05ZxC;;AsB15ZE;EAAsC,gBAAA;AtB85ZxC;;AsB95ZE;EAAsC,gBAAA;AtBk6ZxC;;AsBl6ZE;EAAsC,gBAAA;AtBs6ZxC;;AsBt6ZE;EAAsC,gBAAA;AtB06ZxC;;AsB16ZE;EAAsC,gBAAA;AtB86ZxC;;AsB96ZE;EAAsC,gBAAA;AtBk7ZxC;;AsBl7ZE;EAAsC,gBAAA;AtBs7ZxC;;AsBt7ZE;EAAsC,gBAAA;AtB07ZxC;;AsB17ZE;EAAsC,gBAAA;AtB87ZxC;;AsB97ZE;EAAsC,gBAAA;AtBk8ZxC;;AsBl8ZE;EAAsC,gBAAA;AtBs8ZxC;;AsBt8ZE;EAAsC,gBAAA;AtB08ZxC;;AsB18ZE;EAAsC,gBAAA;AtB88ZxC;;AsB98ZE;EAAsC,gBAAA;AtBk9ZxC;;AsBl9ZE;EAAsC,gBAAA;AtBs9ZxC;;AsBt9ZE;EAAsC,gBAAA;AtB09ZxC;;AsB19ZE;EAAsC,gBAAA;AtB89ZxC;;AsB99ZE;EAAsC,gBAAA;AtBk+ZxC;;AsBl+ZE;EAAsC,gBAAA;AtBs+ZxC;;AsBt+ZE;EAAsC,gBAAA;AtB0+ZxC;;AsB1+ZE;EAAsC,gBAAA;AtB8+ZxC;;AsB9+ZE;EAAsC,gBAAA;AtBk/ZxC;;AsBl/ZE;EAAsC,gBAAA;AtBs/ZxC;;AsBt/ZE;EAAsC,gBAAA;AtB0/ZxC;;AsB1/ZE;EAAsC,gBAAA;AtB8/ZxC;;AsB9/ZE;EAAsC,gBAAA;AtBkgaxC;;AsBlgaE;EAAsC,gBAAA;AtBsgaxC;;AsBtgaE;EAAsC,gBAAA;AtB0gaxC;;AsB1gaE;EAAsC,gBAAA;AtB8gaxC;;AsB9gaE;EAAsC,gBAAA;AtBkhaxC;;AsBlhaE;EAAsC,gBAAA;AtBshaxC;;AsBthaE;EAAsC,gBAAA;AtB0haxC;;AsB1haE;EAAsC,gBAAA;AtB8haxC;;AsB9haE;EAAsC,gBAAA;AtBkiaxC;;AsBliaE;EAAsC,gBAAA;AtBsiaxC;;AsBtiaE;EAAsC,gBAAA;AtB0iaxC;;AsB1iaE;EAAsC,gBAAA;AtB8iaxC;;AsB9iaE;EAAsC,gBAAA;AtBkjaxC;;AsBljaE;EAAsC,gBAAA;AtBsjaxC;;AsBtjaE;EAAsC,gBAAA;AtB0jaxC;;AsB1jaE;EAAsC,gBAAA;AtB8jaxC;;AsB9jaE;EAAsC,gBAAA;AtBkkaxC;;AsBlkaE;EAAsC,gBAAA;AtBskaxC;;AsBtkaE;EAAsC,gBAAA;AtB0kaxC;;AsB1kaE;EAAsC,gBAAA;AtB8kaxC;;AsB9kaE;EAAsC,gBAAA;AtBklaxC;;AsBllaE;EAAsC,gBAAA;AtBslaxC;;AsBtlaE;EAAsC,gBAAA;AtB0laxC;;AsB1laE;EAAsC,gBAAA;AtB8laxC;;AsB9laE;EAAsC,gBAAA;AtBkmaxC;;AsBlmaE;EAAsC,gBAAA;AtBsmaxC;;AsBtmaE;EAAsC,gBAAA;AtB0maxC;;AsB1maE;EAAsC,gBAAA;AtB8maxC;;AsB9maE;EAAsC,gBAAA;AtBknaxC;;AsBlnaE;EAAsC,gBAAA;AtBsnaxC;;AsBtnaE;EAAsC,gBAAA;AtB0naxC;;AsB1naE;EAAsC,gBAAA;AtB8naxC;;AsB9naE;EAAsC,gBAAA;AtBkoaxC;;AsBloaE;EAAsC,gBAAA;AtBsoaxC;;AsBtoaE;EAAsC,gBAAA;AtB0oaxC;;AsB1oaE;EAAsC,gBAAA;AtB8oaxC;;AsB9oaE;EAAsC,gBAAA;AtBkpaxC;;AsBlpaE;EAAsC,gBAAA;AtBspaxC;;AsBtpaE;EAAsC,gBAAA;AtB0paxC;;AsB1paE;EAAsC,gBAAA;AtB8paxC;;AsB9paE;EAAsC,gBAAA;AtBkqaxC;;AsBlqaE;EAAsC,gBAAA;AtBsqaxC;;AsBtqaE;EAAsC,gBAAA;AtB0qaxC;;AsB1qaE;EAAsC,gBAAA;AtB8qaxC;;AsB9qaE;EAAsC,gBAAA;AtBkraxC;;AsBlraE;EAAsC,gBAAA;AtBsraxC;;AsBtraE;EAAsC,gBAAA;AtB0raxC;;AsB1raE;EAAsC,gBAAA;AtB8raxC;;AsB9raE;EAAsC,gBAAA;AtBksaxC;;AsBlsaE;EAAsC,gBAAA;AtBssaxC;;AsBtsaE;EAAsC,gBAAA;AtB0saxC;;AsB1saE;EAAsC,gBAAA;AtB8saxC;;AsB9saE;EAAsC,gBAAA;AtBktaxC;;AsBltaE;EAAsC,gBAAA;AtBstaxC;;AsBttaE;EAAsC,gBAAA;AtB0taxC;;AsB1taE;EAAsC,gBAAA;AtB8taxC;;AsB9taE;EAAsC,gBAAA;AtBkuaxC;;AsBluaE;EAAsC,gBAAA;AtBsuaxC;;AsBtuaE;EAAsC,gBAAA;AtB0uaxC;;AsB1uaE;EAAsC,gBAAA;AtB8uaxC;;AsB9uaE;EAAsC,gBAAA;AtBkvaxC;;AsBlvaE;EAAsC,gBAAA;AtBsvaxC;;AsBtvaE;EAAsC,gBAAA;AtB0vaxC;;AsB1vaE;EAAsC,gBAAA;AtB8vaxC;;AsB9vaE;EAAsC,gBAAA;AtBkwaxC;;AsBlwaE;EAAsC,gBAAA;AtBswaxC;;AsBtwaE;EAAsC,gBAAA;AtB0waxC;;AsB1waE;EAAsC,gBAAA;AtB8waxC;;AsB9waE;EAAsC,gBAAA;AtBkxaxC;;AsBlxaE;EAAsC,gBAAA;AtBsxaxC;;AsBtxaE;EAAsC,gBAAA;AtB0xaxC;;AsB1xaE;EAAsC,gBAAA;AtB8xaxC;;AsB9xaE;EAAsC,gBAAA;AtBkyaxC;;AsBlyaE;EAAsC,gBAAA;AtBsyaxC;;AsBtyaE;EAAsC,gBAAA;AtB0yaxC;;AsB1yaE;EAAsC,gBAAA;AtB8yaxC;;AsB9yaE;EAAsC,gBAAA;AtBkzaxC;;AsBlzaE;EAAsC,gBAAA;AtBszaxC;;AsBtzaE;EAAsC,gBAAA;AtB0zaxC;;AsB1zaE;EAAsC,gBAAA;AtB8zaxC;;AsB9zaE;EAAsC,gBAAA;AtBk0axC;;AsBl0aE;EAAsC,gBAAA;AtBs0axC;;AsBt0aE;EAAsC,gBAAA;AtB00axC;;AsB10aE;EAAsC,gBAAA;AtB80axC;;AsB90aE;EAAsC,gBAAA;AtBk1axC;;AsBl1aE;EAAsC,gBAAA;AtBs1axC;;AsBt1aE;EAAsC,gBAAA;AtB01axC;;AsB11aE;EAAsC,gBAAA;AtB81axC;;AsB91aE;EAAsC,gBAAA;AtBk2axC;;AsBl2aE;EAAsC,gBAAA;AtBs2axC;;AsBt2aE;EAAsC,gBAAA;AtB02axC;;AsB12aE;EAAsC,gBAAA;AtB82axC;;AsB92aE;EAAsC,gBAAA;AtBk3axC;;AsBl3aE;EAAsC,gBAAA;AtBs3axC;;AsBt3aE;EAAsC,gBAAA;AtB03axC;;AsB13aE;EAAsC,gBAAA;AtB83axC;;AsB93aE;EAAsC,gBAAA;AtBk4axC;;AsBl4aE;EAAsC,gBAAA;AtBs4axC;;AsBt4aE;EAAsC,gBAAA;AtB04axC;;AsB14aE;EAAsC,gBAAA;AtB84axC;;AsB94aE;EAAsC,gBAAA;AtBk5axC;;AsBl5aE;EAAsC,gBAAA;AtBs5axC;;AsBt5aE;EAAsC,gBAAA;AtB05axC;;AsB15aE;EAAsC,gBAAA;AtB85axC;;AsB95aE;EAAsC,gBAAA;AtBk6axC;;AsBl6aE;EAAsC,gBAAA;AtBs6axC;;AsBt6aE;EAAsC,gBAAA;AtB06axC;;AsB16aE;EAAsC,gBAAA;AtB86axC;;AsB96aE;EAAsC,gBAAA;AtBk7axC;;AsBl7aE;EAAsC,gBAAA;AtBs7axC;;AsBt7aE;EAAsC,gBAAA;AtB07axC;;AsB17aE;EAAsC,gBAAA;AtB87axC;;AsB97aE;EAAsC,gBAAA;AtBk8axC;;AsBl8aE;EAAsC,gBAAA;AtBs8axC;;AsBt8aE;EAAsC,gBAAA;AtB08axC;;AsB18aE;EAAsC,gBAAA;AtB88axC;;AsB98aE;EAAsC,gBAAA;AtBk9axC;;AsBl9aE;EAAsC,gBAAA;AtBs9axC;;AsBt9aE;EAAsC,gBAAA;AtB09axC;;AsB19aE;EAAsC,gBAAA;AtB89axC;;AsB99aE;EAAsC,gBAAA;AtBk+axC;;AsBl+aE;EAAsC,gBAAA;AtBs+axC;;AsBt+aE;EAAsC,gBAAA;AtB0+axC;;AsB1+aE;EAAsC,gBAAA;AtB8+axC;;AsB9+aE;EAAsC,gBAAA;AtBk/axC;;AsBl/aE;EAAsC,gBAAA;AtBs/axC;;AsBt/aE;EAAsC,gBAAA;AtB0/axC;;AsB1/aE;EAAsC,gBAAA;AtB8/axC;;AsB9/aE;EAAsC,gBAAA;AtBkgbxC;;AsBlgbE;EAAsC,gBAAA;AtBsgbxC;;AsBtgbE;EAAsC,gBAAA;AtB0gbxC;;AsB1gbE;EAAsC,gBAAA;AtB8gbxC;;AsB9gbE;EAAsC,gBAAA;AtBkhbxC;;AsBlhbE;EAAsC,gBAAA;AtBshbxC;;AsBthbE;EAAsC,gBAAA;AtB0hbxC;;AsB1hbE;EAAsC,gBAAA;AtB8hbxC;;AsB9hbE;EAAsC,gBAAA;AtBkibxC;;AsBlibE;EAAsC,gBAAA;AtBsibxC;;AsBtibE;EAAsC,gBAAA;AtB0ibxC;;AsB1ibE;EAAsC,gBAAA;AtB8ibxC;;AsB9ibE;EAAsC,gBAAA;AtBkjbxC;;AsBljbE;EAAsC,gBAAA;AtBsjbxC;;AsBtjbE;EAAsC,gBAAA;AtB0jbxC;;AsB1jbE;EAAsC,gBAAA;AtB8jbxC;;AsB9jbE;EAAsC,gBAAA;AtBkkbxC;;AsBlkbE;EAAsC,gBAAA;AtBskbxC;;AsBtkbE;EAAsC,gBAAA;AtB0kbxC;;AsB1kbE;EAAsC,gBAAA;AtB8kbxC;;AsB9kbE;EAAsC,gBAAA;AtBklbxC;;AsBllbE;EAAsC,gBAAA;AtBslbxC;;AsBtlbE;EAAsC,gBAAA;AtB0lbxC;;AsB1lbE;EAAsC,gBAAA;AtB8lbxC;;AsB9lbE;EAAsC,gBAAA;AtBkmbxC;;AsBlmbE;EAAsC,gBAAA;AtBsmbxC;;AsBtmbE;EAAsC,gBAAA;AtB0mbxC;;AsB1mbE;EAAsC,gBAAA;AtB8mbxC;;AsB9mbE;EAAsC,gBAAA;AtBknbxC;;AsBlnbE;EAAsC,gBAAA;AtBsnbxC;;AsBtnbE;EAAsC,gBAAA;AtB0nbxC;;AsB1nbE;EAAsC,YAAA;AtB8nbxC;;AsB9nbE;EAAsC,gBAAA;AtBkobxC;;AsBlobE;EAAsC,gBAAA;AtBsobxC;;AsBtobE;EAAsC,gBAAA;AtB0obxC;;AsB1obE;EAAsC,gBAAA;AtB8obxC;;AsB9obE;EAAsC,gBAAA;AtBkpbxC;;AsBlpbE;EAAsC,gBAAA;AtBspbxC;;AsBtpbE;EAAsC,gBAAA;AtB0pbxC;;AsB1pbE;EAAsC,gBAAA;AtB8pbxC;;AsB9pbE;EAAsC,gBAAA;AtBkqbxC;;AsBlqbE;EAAsC,gBAAA;AtBsqbxC;;AsBtqbE;EAAsC,gBAAA;AtB0qbxC;;AsB1qbE;EAAsC,gBAAA;AtB8qbxC;;AsB9qbE;EAAsC,gBAAA;AtBkrbxC;;AsBlrbE;EAAsC,gBAAA;AtBsrbxC;;AsBtrbE;EAAsC,gBAAA;AtB0rbxC;;AsB1rbE;EAAsC,gBAAA;AtB8rbxC;;AsB9rbE;EAAsC,gBAAA;AtBksbxC;;AsBlsbE;EAAsC,gBAAA;AtBssbxC;;AsBtsbE;EAAsC,gBAAA;AtB0sbxC;;AsB1sbE;EAAsC,gBAAA;AtB8sbxC;;AsB9sbE;EAAsC,gBAAA;AtBktbxC;;AsBltbE;EAAsC,gBAAA;AtBstbxC;;AsBttbE;EAAsC,gBAAA;AtB0tbxC;;AsB1tbE;EAAsC,gBAAA;AtB8tbxC;;AsB9tbE;EAAsC,gBAAA;AtBkubxC;;AsBlubE;EAAsC,gBAAA;AtBsubxC;;AsBtubE;EAAsC,gBAAA;AtB0ubxC;;AsB1ubE;EAAsC,gBAAA;AtB8ubxC;;AsB9ubE;EAAsC,gBAAA;AtBkvbxC;;AsBlvbE;EAAsC,gBAAA;AtBsvbxC;;AsBtvbE;EAAsC,gBAAA;AtB0vbxC;;AsB1vbE;EAAsC,gBAAA;AtB8vbxC;;AsB9vbE;EAAsC,gBAAA;AtBkwbxC;;AsBlwbE;EAAsC,gBAAA;AtBswbxC;;AsBtwbE;EAAsC,gBAAA;AtB0wbxC;;AsB1wbE;EAAsC,gBAAA;AtB8wbxC;;AsB9wbE;EAAsC,gBAAA;AtBkxbxC;;AsBlxbE;EAAsC,gBAAA;AtBsxbxC;;AsBtxbE;EAAsC,gBAAA;AtB0xbxC;;AsB1xbE;EAAsC,gBAAA;AtB8xbxC;;AsB9xbE;EAAsC,gBAAA;AtBkybxC;;AsBlybE;EAAsC,gBAAA;AtBsybxC;;AsBtybE;EAAsC,gBAAA;AtB0ybxC;;AsB1ybE;EAAsC,gBAAA;AtB8ybxC;;AsB9ybE;EAAsC,gBAAA;AtBkzbxC;;AsBlzbE;EAAsC,gBAAA;AtBszbxC;;AsBtzbE;EAAsC,gBAAA;AtB0zbxC;;AsB1zbE;EAAsC,gBAAA;AtB8zbxC;;AsB9zbE;EAAsC,gBAAA;AtBk0bxC;;AsBl0bE;EAAsC,gBAAA;AtBs0bxC;;AsBt0bE;EAAsC,gBAAA;AtB00bxC;;AsB10bE;EAAsC,gBAAA;AtB80bxC;;AsB90bE;EAAsC,gBAAA;AtBk1bxC;;AsBl1bE;EAAsC,gBAAA;AtBs1bxC;;AsBt1bE;EAAsC,gBAAA;AtB01bxC;;AsB11bE;EAAsC,gBAAA;AtB81bxC;;AsB91bE;EAAsC,gBAAA;AtBk2bxC;;AsBl2bE;EAAsC,gBAAA;AtBs2bxC;;AsBt2bE;EAAsC,gBAAA;AtB02bxC;;AsB12bE;EAAsC,gBAAA;AtB82bxC;;AsB92bE;EAAsC,gBAAA;AtBk3bxC;;AsBl3bE;EAAsC,gBAAA;AtBs3bxC;;AsBt3bE;EAAsC,gBAAA;AtB03bxC;;AsB13bE;EAAsC,gBAAA;AtB83bxC;;AsB93bE;EAAsC,gBAAA;AtBk4bxC;;AsBl4bE;EAAsC,gBAAA;AtBs4bxC;;AsBt4bE;EAAsC,gBAAA;AtB04bxC;;AsB14bE;EAAsC,gBAAA;AtB84bxC;;AsB94bE;EAAsC,gBAAA;AtBk5bxC;;AsBl5bE;EAAsC,gBAAA;AtBs5bxC;;AsBt5bE;EAAsC,gBAAA;AtB05bxC;;AsB15bE;EAAsC,gBAAA;AtB85bxC;;AsB95bE;EAAsC,gBAAA;AtBk6bxC;;AsBl6bE;EAAsC,gBAAA;AtBs6bxC;;AsBt6bE;EAAsC,gBAAA;AtB06bxC;;AsB16bE;EAAsC,gBAAA;AtB86bxC;;AsB96bE;EAAsC,gBAAA;AtBk7bxC;;AsBl7bE;EAAsC,gBAAA;AtBs7bxC;;AsBt7bE;EAAsC,gBAAA;AtB07bxC;;AsB17bE;EAAsC,gBAAA;AtB87bxC;;AsB97bE;EAAsC,gBAAA;AtBk8bxC;;AsBl8bE;EAAsC,gBAAA;AtBs8bxC;;AsBt8bE;EAAsC,gBAAA;AtB08bxC;;AsB18bE;EAAsC,gBAAA;AtB88bxC;;AsB98bE;EAAsC,gBAAA;AtBk9bxC;;AsBl9bE;EAAsC,gBAAA;AtBs9bxC;;AsBt9bE;EAAsC,gBAAA;AtB09bxC;;AsB19bE;EAAsC,gBAAA;AtB89bxC;;AsB99bE;EAAsC,gBAAA;AtBk+bxC;;AsBl+bE;EAAsC,gBAAA;AtBs+bxC;;AsBt+bE;EAAsC,gBAAA;AtB0+bxC;;AsB1+bE;EAAsC,gBAAA;AtB8+bxC;;AsB9+bE;EAAsC,gBAAA;AtBk/bxC;;AsBl/bE;EAAsC,gBAAA;AtBs/bxC;;AsBt/bE;EAAsC,gBAAA;AtB0/bxC;;AsB1/bE;EAAsC,gBAAA;AtB8/bxC;;AsB9/bE;EAAsC,gBAAA;AtBkgcxC;;AsBlgcE;EAAsC,gBAAA;AtBsgcxC;;AsBtgcE;EAAsC,gBAAA;AtB0gcxC;;AsB1gcE;EAAsC,gBAAA;AtB8gcxC;;AsB9gcE;EAAsC,gBAAA;AtBkhcxC;;AsBlhcE;EAAsC,gBAAA;AtBshcxC;;AsBthcE;EAAsC,aAAA;AtB0hcxC;;AsB1hcE;EAAsC,gBAAA;AtB8hcxC;;AsB9hcE;EAAsC,gBAAA;AtBkicxC;;AsBlicE;EAAsC,gBAAA;AtBsicxC;;AsBticE;EAAsC,gBAAA;AtB0icxC;;AsB1icE;EAAsC,gBAAA;AtB8icxC;;AsB9icE;EAAsC,gBAAA;AtBkjcxC;;AsBljcE;EAAsC,gBAAA;AtBsjcxC;;AsBtjcE;EAAsC,gBAAA;AtB0jcxC;;AsB1jcE;EAAsC,gBAAA;AtB8jcxC;;AsB9jcE;EAAsC,gBAAA;AtBkkcxC;;AsBlkcE;EAAsC,gBAAA;AtBskcxC;;AsBtkcE;EAAsC,gBAAA;AtB0kcxC;;AsB1kcE;EAAsC,gBAAA;AtB8kcxC;;AsB9kcE;EAAsC,gBAAA;AtBklcxC;;AsBllcE;EAAsC,gBAAA;AtBslcxC;;AsBtlcE;EAAsC,gBAAA;AtB0lcxC;;AsB1lcE;EAAsC,gBAAA;AtB8lcxC;;AsB9lcE;EAAsC,gBAAA;AtBkmcxC;;AsBlmcE;EAAsC,gBAAA;AtBsmcxC;;AsBtmcE;EAAsC,gBAAA;AtB0mcxC;;AsB1mcE;EAAsC,gBAAA;AtB8mcxC;;AsB9mcE;EAAsC,gBAAA;AtBkncxC;;AsBlncE;EAAsC,gBAAA;AtBsncxC;;AsBtncE;EAAsC,gBAAA;AtB0ncxC;;AsB1ncE;EAAsC,gBAAA;AtB8ncxC;;AsB9ncE;EAAsC,gBAAA;AtBkocxC;;AsBlocE;EAAsC,gBAAA;AtBsocxC;;AsBtocE;EAAsC,gBAAA;AtB0ocxC;;AsB1ocE;EAAsC,gBAAA;AtB8ocxC;;AsB9ocE;EAAsC,gBAAA;AtBkpcxC;;AsBlpcE;EAAsC,gBAAA;AtBspcxC;;AsBtpcE;EAAsC,gBAAA;AtB0pcxC;;AsB1pcE;EAAsC,gBAAA;AtB8pcxC;;AsB9pcE;EAAsC,gBAAA;AtBkqcxC;;AsBlqcE;EAAsC,gBAAA;AtBsqcxC;;AsBtqcE;EAAsC,gBAAA;AtB0qcxC;;AsB1qcE;EAAsC,gBAAA;AtB8qcxC;;AsB9qcE;EAAsC,gBAAA;AtBkrcxC;;AsBlrcE;EAAsC,gBAAA;AtBsrcxC;;AsBtrcE;EAAsC,gBAAA;AtB0rcxC;;AsB1rcE;EAAsC,gBAAA;AtB8rcxC;;AsB9rcE;EAAsC,gBAAA;AtBkscxC;;AsBlscE;EAAsC,gBAAA;AtBsscxC;;AsBtscE;EAAsC,gBAAA;AtB0scxC;;AsB1scE;EAAsC,gBAAA;AtB8scxC;;AsB9scE;EAAsC,gBAAA;AtBktcxC;;AsBltcE;EAAsC,gBAAA;AtBstcxC;;AsBttcE;EAAsC,gBAAA;AtB0tcxC;;AsB1tcE;EAAsC,gBAAA;AtB8tcxC;;AsB9tcE;EAAsC,gBAAA;AtBkucxC;;AsBlucE;EAAsC,gBAAA;AtBsucxC;;AsBtucE;EAAsC,gBAAA;AtB0ucxC;;AsB1ucE;EAAsC,gBAAA;AtB8ucxC;;AsB9ucE;EAAsC,gBAAA;AtBkvcxC;;AsBlvcE;EAAsC,gBAAA;AtBsvcxC;;AsBtvcE;EAAsC,gBAAA;AtB0vcxC;;AsB1vcE;EAAsC,gBAAA;AtB8vcxC;;AsB9vcE;EAAsC,gBAAA;AtBkwcxC;;AsBlwcE;EAAsC,gBAAA;AtBswcxC;;AsBtwcE;EAAsC,gBAAA;AtB0wcxC;;AsB1wcE;EAAsC,gBAAA;AtB8wcxC;;AsB9wcE;EAAsC,gBAAA;AtBkxcxC;;AsBlxcE;EAAsC,gBAAA;AtBsxcxC;;AsBtxcE;EAAsC,gBAAA;AtB0xcxC;;AsB1xcE;EAAsC,gBAAA;AtB8xcxC;;AsB9xcE;EAAsC,gBAAA;AtBkycxC;;AsBlycE;EAAsC,gBAAA;AtBsycxC;;AsBtycE;EAAsC,gBAAA;AtB0ycxC;;AsB1ycE;EAAsC,gBAAA;AtB8ycxC;;AsB9ycE;EAAsC,gBAAA;AtBkzcxC;;AsBlzcE;EAAsC,gBAAA;AtBszcxC;;AsBtzcE;EAAsC,gBAAA;AtB0zcxC;;AsB1zcE;EAAsC,gBAAA;AtB8zcxC;;AsB9zcE;EAAsC,gBAAA;AtBk0cxC;;AsBl0cE;EAAsC,gBAAA;AtBs0cxC;;AsBt0cE;EAAsC,gBAAA;AtB00cxC;;AsB10cE;EAAsC,gBAAA;AtB80cxC;;AsB90cE;EAAsC,gBAAA;AtBk1cxC;;AsBl1cE;EAAsC,gBAAA;AtBs1cxC;;AsBt1cE;EAAsC,gBAAA;AtB01cxC;;AsB11cE;EAAsC,gBAAA;AtB81cxC;;AsB91cE;EAAsC,gBAAA;AtBk2cxC;;AsBl2cE;EAAsC,gBAAA;AtBs2cxC;;AsBt2cE;EAAsC,gBAAA;AtB02cxC;;AsB12cE;EAAsC,gBAAA;AtB82cxC;;AsB92cE;EAAsC,gBAAA;AtBk3cxC;;AsBl3cE;EAAsC,gBAAA;AtBs3cxC;;AsBt3cE;EAAsC,gBAAA;AtB03cxC;;AsB13cE;EAAsC,gBAAA;AtB83cxC;;AsB93cE;EAAsC,gBAAA;AtBk4cxC;;AsBl4cE;EAAsC,gBAAA;AtBs4cxC;;AsBt4cE;EAAsC,gBAAA;AtB04cxC;;AsB14cE;EAAsC,gBAAA;AtB84cxC;;AsB94cE;EAAsC,gBAAA;AtBk5cxC;;AsBl5cE;EAAsC,gBAAA;AtBs5cxC;;AsBt5cE;EAAsC,gBAAA;AtB05cxC;;AsB15cE;EAAsC,gBAAA;AtB85cxC;;AsB95cE;EAAsC,gBAAA;AtBk6cxC;;AsBl6cE;EAAsC,gBAAA;AtBs6cxC;;AsBt6cE;EAAsC,gBAAA;AtB06cxC;;AsB16cE;EAAsC,gBAAA;AtB86cxC;;AsB96cE;EAAsC,gBAAA;AtBk7cxC;;AsBl7cE;EAAsC,gBAAA;AtBs7cxC;;AsBt7cE;EAAsC,gBAAA;AtB07cxC;;AsB17cE;EAAsC,gBAAA;AtB87cxC;;AsB97cE;EAAsC,gBAAA;AtBk8cxC;;AsBl8cE;EAAsC,gBAAA;AtBs8cxC;;AsBt8cE;EAAsC,gBAAA;AtB08cxC;;AsB18cE;EAAsC,gBAAA;AtB88cxC;;AsB98cE;EAAsC,gBAAA;AtBk9cxC;;AsBl9cE;EAAsC,gBAAA;AtBs9cxC;;AsBt9cE;EAAsC,gBAAA;AtB09cxC;;AsB19cE;EAAsC,gBAAA;AtB89cxC;;AsB99cE;EAAsC,gBAAA;AtBk+cxC;;AsBl+cE;EAAsC,gBAAA;AtBs+cxC;;AsBt+cE;EAAsC,gBAAA;AtB0+cxC;;AsB1+cE;EAAsC,gBAAA;AtB8+cxC;;AsB9+cE;EAAsC,gBAAA;AtBk/cxC;;AsBl/cE;EAAsC,gBAAA;AtBs/cxC;;AsBt/cE;EAAsC,gBAAA;AtB0/cxC;;AsB1/cE;EAAsC,gBAAA;AtB8/cxC;;AsB9/cE;EAAsC,gBAAA;AtBkgdxC;;AsBlgdE;EAAsC,gBAAA;AtBsgdxC;;AsBtgdE;EAAsC,gBAAA;AtB0gdxC;;AsB1gdE;EAAsC,gBAAA;AtB8gdxC;;AsB9gdE;EAAsC,gBAAA;AtBkhdxC;;AsBlhdE;EAAsC,gBAAA;AtBshdxC;;AsBthdE;EAAsC,gBAAA;AtB0hdxC;;AsB1hdE;EAAsC,gBAAA;AtB8hdxC;;AsB9hdE;EAAsC,gBAAA;AtBkidxC;;AsBlidE;EAAsC,gBAAA;AtBsidxC;;AsBtidE;EAAsC,gBAAA;AtB0idxC;;AsB1idE;EAAsC,gBAAA;AtB8idxC;;AsB9idE;EAAsC,gBAAA;AtBkjdxC;;AsBljdE;EAAsC,gBAAA;AtBsjdxC;;AsBtjdE;EAAsC,gBAAA;AtB0jdxC;;AsB1jdE;EAAsC,gBAAA;AtB8jdxC;;AsB9jdE;EAAsC,gBAAA;AtBkkdxC;;AsBlkdE;EAAsC,gBAAA;AtBskdxC;;AsBtkdE;EAAsC,gBAAA;AtB0kdxC;;AsB1kdE;EAAsC,gBAAA;AtB8kdxC;;AsB9kdE;EAAsC,gBAAA;AtBkldxC;;AsBlldE;EAAsC,gBAAA;AtBsldxC;;AsBtldE;EAAsC,gBAAA;AtB0ldxC;;AsB1ldE;EAAsC,gBAAA;AtB8ldxC;;AsB9ldE;EAAsC,gBAAA;AtBkmdxC;;AsBlmdE;EAAsC,gBAAA;AtBsmdxC;;AsBtmdE;EAAsC,gBAAA;AtB0mdxC;;AsB1mdE;EAAsC,gBAAA;AtB8mdxC;;AsB9mdE;EAAsC,gBAAA;AtBkndxC;;AsBlndE;EAAsC,gBAAA;AtBsndxC;;AsBtndE;EAAsC,gBAAA;AtB0ndxC;;AsB1ndE;EAAsC,YAAA;AtB8ndxC;;AsB9ndE;EAAsC,gBAAA;AtBkodxC;;AsBlodE;EAAsC,gBAAA;AtBsodxC;;AsBtodE;EAAsC,gBAAA;AtB0odxC;;AsB1odE;EAAsC,gBAAA;AtB8odxC;;AsB9odE;EAAsC,gBAAA;AtBkpdxC;;AsBlpdE;EAAsC,gBAAA;AtBspdxC;;AsBtpdE;EAAsC,gBAAA;AtB0pdxC;;AsB1pdE;EAAsC,gBAAA;AtB8pdxC;;AsB9pdE;EAAsC,gBAAA;AtBkqdxC;;AsBlqdE;EAAsC,gBAAA;AtBsqdxC;;AsBtqdE;EAAsC,gBAAA;AtB0qdxC;;AsB1qdE;EAAsC,gBAAA;AtB8qdxC;;AsB9qdE;EAAsC,gBAAA;AtBkrdxC;;AsBlrdE;EAAsC,gBAAA;AtBsrdxC;;AsBtrdE;EAAsC,gBAAA;AtB0rdxC;;AsB1rdE;EAAsC,gBAAA;AtB8rdxC;;AsB9rdE;EAAsC,gBAAA;AtBksdxC;;AsBlsdE;EAAsC,gBAAA;AtBssdxC;;AsBtsdE;EAAsC,gBAAA;AtB0sdxC;;AsB1sdE;EAAsC,gBAAA;AtB8sdxC;;AsB9sdE;EAAsC,gBAAA;AtBktdxC;;AsBltdE;EAAsC,gBAAA;AtBstdxC;;AsBttdE;EAAsC,gBAAA;AtB0tdxC;;AsB1tdE;EAAsC,gBAAA;AtB8tdxC;;AsB9tdE;EAAsC,gBAAA;AtBkudxC;;AsBludE;EAAsC,gBAAA;AtBsudxC;;AsBtudE;EAAsC,gBAAA;AtB0udxC;;AsB1udE;EAAsC,gBAAA;AtB8udxC;;AsB9udE;EAAsC,gBAAA;AtBkvdxC;;AsBlvdE;EAAsC,gBAAA;AtBsvdxC;;AsBtvdE;EAAsC,gBAAA;AtB0vdxC;;AsB1vdE;EAAsC,gBAAA;AtB8vdxC;;AsB9vdE;EAAsC,gBAAA;AtBkwdxC;;AsBlwdE;EAAsC,gBAAA;AtBswdxC;;AsBtwdE;EAAsC,gBAAA;AtB0wdxC;;AsB1wdE;EAAsC,gBAAA;AtB8wdxC;;AsB9wdE;EAAsC,gBAAA;AtBkxdxC;;AsBlxdE;EAAsC,gBAAA;AtBsxdxC;;AsBtxdE;EAAsC,gBAAA;AtB0xdxC;;AsB1xdE;EAAsC,gBAAA;AtB8xdxC;;AsB9xdE;EAAsC,gBAAA;AtBkydxC;;AsBlydE;EAAsC,gBAAA;AtBsydxC;;AsBtydE;EAAsC,gBAAA;AtB0ydxC;;AsB1ydE;EAAsC,gBAAA;AtB8ydxC;;AsB9ydE;EAAsC,gBAAA;AtBkzdxC;;AsBlzdE;EAAsC,gBAAA;AtBszdxC;;AsBtzdE;EAAsC,gBAAA;AtB0zdxC;;AsB1zdE;EAAsC,gBAAA;AtB8zdxC;;AsB9zdE;EAAsC,gBAAA;AtBk0dxC;;AsBl0dE;EAAsC,gBAAA;AtBs0dxC;;AsBt0dE;EAAsC,gBAAA;AtB00dxC;;AsB10dE;EAAsC,gBAAA;AtB80dxC;;AsB90dE;EAAsC,gBAAA;AtBk1dxC;;AsBl1dE;EAAsC,gBAAA;AtBs1dxC;;AsBt1dE;EAAsC,gBAAA;AtB01dxC;;AsB11dE;EAAsC,gBAAA;AtB81dxC;;AsB91dE;EAAsC,gBAAA;AtBk2dxC;;AsBl2dE;EAAsC,gBAAA;AtBs2dxC;;AsBt2dE;EAAsC,gBAAA;AtB02dxC;;AsB12dE;EAAsC,gBAAA;AtB82dxC;;AsB92dE;EAAsC,gBAAA;AtBk3dxC;;AsBl3dE;EAAsC,gBAAA;AtBs3dxC;;AsBt3dE;EAAsC,gBAAA;AtB03dxC;;AsB13dE;EAAsC,gBAAA;AtB83dxC;;AsB93dE;EAAsC,gBAAA;AtBk4dxC;;AsBl4dE;EAAsC,gBAAA;AtBs4dxC;;AsBt4dE;EAAsC,gBAAA;AtB04dxC;;AsB14dE;EAAsC,gBAAA;AtB84dxC;;AsB94dE;EAAsC,gBAAA;AtBk5dxC;;AsBl5dE;EAAsC,gBAAA;AtBs5dxC;;AsBt5dE;EAAsC,gBAAA;AtB05dxC;;AsB15dE;EAAsC,gBAAA;AtB85dxC;;AsB95dE;EAAsC,gBAAA;AtBk6dxC;;AsBl6dE;EAAsC,gBAAA;AtBs6dxC;;AsBt6dE;EAAsC,gBAAA;AtB06dxC;;AsB16dE;EAAsC,gBAAA;AtB86dxC;;AsB96dE;EAAsC,gBAAA;AtBk7dxC;;AsBl7dE;EAAsC,gBAAA;AtBs7dxC;;AsBt7dE;EAAsC,gBAAA;AtB07dxC;;AsB17dE;EAAsC,gBAAA;AtB87dxC;;AsB97dE;EAAsC,gBAAA;AtBk8dxC;;AsBl8dE;EAAsC,gBAAA;AtBs8dxC;;AsBt8dE;EAAsC,gBAAA;AtB08dxC;;AsB18dE;EAAsC,gBAAA;AtB88dxC;;AsB98dE;EAAsC,gBAAA;AtBk9dxC;;AsBl9dE;EAAsC,gBAAA;AtBs9dxC;;AsBt9dE;EAAsC,gBAAA;AtB09dxC;;AsB19dE;EAAsC,gBAAA;AtB89dxC;;AsB99dE;EAAsC,gBAAA;AtBk+dxC;;AsBl+dE;EAAsC,gBAAA;AtBs+dxC;;AsBt+dE;EAAsC,gBAAA;AtB0+dxC;;AsB1+dE;EAAsC,gBAAA;AtB8+dxC;;AsB9+dE;EAAsC,gBAAA;AtBk/dxC;;AsBl/dE;EAAsC,gBAAA;AtBs/dxC;;AsBt/dE;EAAsC,gBAAA;AtB0/dxC;;AsB1/dE;EAAsC,gBAAA;AtB8/dxC;;AsB9/dE;EAAsC,gBAAA;AtBkgexC;;AsBlgeE;EAAsC,gBAAA;AtBsgexC;;AsBtgeE;EAAsC,gBAAA;AtB0gexC;;AsB1geE;EAAsC,gBAAA;AtB8gexC;;AsB9geE;EAAsC,gBAAA;AtBkhexC;;AsBlheE;EAAsC,gBAAA;AtBshexC;;AsBtheE;EAAsC,gBAAA;AtB0hexC;;AsB1heE;EAAsC,gBAAA;AtB8hexC;;AsB9heE;EAAsC,gBAAA;AtBkiexC;;AsBlieE;EAAsC,gBAAA;AtBsiexC;;AsBtieE;EAAsC,gBAAA;AtB0iexC;;AsB1ieE;EAAsC,gBAAA;AtB8iexC;;AsB9ieE;EAAsC,gBAAA;AtBkjexC;;AsBljeE;EAAsC,gBAAA;AtBsjexC;;AsBtjeE;EAAsC,gBAAA;AtB0jexC;;AsB1jeE;EAAsC,gBAAA;AtB8jexC;;AsB9jeE;EAAsC,gBAAA;AtBkkexC;;AsBlkeE;EAAsC,gBAAA;AtBskexC;;AsBtkeE;EAAsC,gBAAA;AtB0kexC;;AsB1keE;EAAsC,YAAA;AtB8kexC;;AsB9keE;EAAsC,gBAAA;AtBklexC;;AsBlleE;EAAsC,gBAAA;AtBslexC;;AsBtleE;EAAsC,gBAAA;AtB0lexC;;AsB1leE;EAAsC,gBAAA;AtB8lexC;;AsB9leE;EAAsC,gBAAA;AtBkmexC;;AsBlmeE;EAAsC,gBAAA;AtBsmexC;;AsBtmeE;EAAsC,gBAAA;AtB0mexC;;AsB1meE;EAAsC,gBAAA;AtB8mexC;;AsB9meE;EAAsC,gBAAA;AtBknexC;;AsBlneE;EAAsC,gBAAA;AtBsnexC;;AsBtneE;EAAsC,gBAAA;AtB0nexC;;AsB1neE;EAAsC,gBAAA;AtB8nexC;;AsB9neE;EAAsC,gBAAA;AtBkoexC;;AsBloeE;EAAsC,gBAAA;AtBsoexC;;AsBtoeE;EAAsC,gBAAA;AtB0oexC;;AsB1oeE;EAAsC,gBAAA;AtB8oexC;;AsB9oeE;EAAsC,gBAAA;AtBkpexC;;AsBlpeE;EAAsC,gBAAA;AtBspexC;;AsBtpeE;EAAsC,gBAAA;AtB0pexC;;AsB1peE;EAAsC,gBAAA;AtB8pexC;;AsB9peE;EAAsC,gBAAA;AtBkqexC;;AsBlqeE;EAAsC,gBAAA;AtBsqexC;;AsBtqeE;EAAsC,gBAAA;AtB0qexC;;AsB1qeE;EAAsC,gBAAA;AtB8qexC;;AsB9qeE;EAAsC,gBAAA;AtBkrexC;;AsBlreE;EAAsC,gBAAA;AtBsrexC;;AsBtreE;EAAsC,gBAAA;AtB0rexC;;AsB1reE;EAAsC,gBAAA;AtB8rexC;;AsB9reE;EAAsC,gBAAA;AtBksexC;;AsBlseE;EAAsC,gBAAA;AtBssexC;;AsBtseE;EAAsC,gBAAA;AtB0sexC;;AsB1seE;EAAsC,gBAAA;AtB8sexC;;AsB9seE;EAAsC,gBAAA;AtBktexC;;AsBlteE;EAAsC,gBAAA;AtBstexC;;AsBtteE;EAAsC,gBAAA;AtB0texC;;AsB1teE;EAAsC,gBAAA;AtB8texC;;AsB9teE;EAAsC,gBAAA;AtBkuexC;;AsBlueE;EAAsC,gBAAA;AtBsuexC;;AsBtueE;EAAsC,gBAAA;AtB0uexC;;AsB1ueE;EAAsC,gBAAA;AtB8uexC;;AsB9ueE;EAAsC,gBAAA;AtBkvexC;;AsBlveE;EAAsC,gBAAA;AtBsvexC;;AsBtveE;EAAsC,gBAAA;AtB0vexC;;AsB1veE;EAAsC,gBAAA;AtB8vexC;;AsB9veE;EAAsC,YAAA;AtBkwexC;;AsBlweE;EAAsC,gBAAA;AtBswexC;;AsBtweE;EAAsC,gBAAA;AtB0wexC;;AsB1weE;EAAsC,gBAAA;AtB8wexC;;AsB9weE;EAAsC,gBAAA;AtBkxexC;;AsBlxeE;EAAsC,gBAAA;AtBsxexC;;AsBtxeE;EAAsC,gBAAA;AtB0xexC;;AsB1xeE;EAAsC,gBAAA;AtB8xexC;;AsB9xeE;EAAsC,gBAAA;AtBkyexC;;AsBlyeE;EAAsC,gBAAA;AtBsyexC;;AsBtyeE;EAAsC,gBAAA;AtB0yexC;;AsB1yeE;EAAsC,gBAAA;AtB8yexC;;AsB9yeE;EAAsC,gBAAA;AtBkzexC;;AsBlzeE;EAAsC,gBAAA;AtBszexC;;AsBtzeE;EAAsC,gBAAA;AtB0zexC;;AsB1zeE;EAAsC,gBAAA;AtB8zexC;;AsB9zeE;EAAsC,gBAAA;AtBk0exC;;AsBl0eE;EAAsC,gBAAA;AtBs0exC;;AsBt0eE;EAAsC,gBAAA;AtB00exC;;AsB10eE;EAAsC,gBAAA;AtB80exC;;AsB90eE;EAAsC,gBAAA;AtBk1exC;;AsBl1eE;EAAsC,gBAAA;AtBs1exC;;AsBt1eE;EAAsC,gBAAA;AtB01exC;;AsB11eE;EAAsC,gBAAA;AtB81exC;;AsB91eE;EAAsC,gBAAA;AtBk2exC;;AsBl2eE;EAAsC,gBAAA;AtBs2exC;;AsBt2eE;EAAsC,gBAAA;AtB02exC;;AsB12eE;EAAsC,gBAAA;AtB82exC;;AsB92eE;EAAsC,gBAAA;AtBk3exC;;AsBl3eE;EAAsC,gBAAA;AtBs3exC;;AsBt3eE;EAAsC,gBAAA;AtB03exC;;AsB13eE;EAAsC,gBAAA;AtB83exC;;AsB93eE;EAAsC,gBAAA;AtBk4exC;;AsBl4eE;EAAsC,gBAAA;AtBs4exC;;AsBt4eE;EAAsC,gBAAA;AtB04exC;;AsB14eE;EAAsC,gBAAA;AtB84exC;;AsB94eE;EAAsC,gBAAA;AtBk5exC;;AsBl5eE;EAAsC,gBAAA;AtBs5exC;;AsBt5eE;EAAsC,gBAAA;AtB05exC;;AsB15eE;EAAsC,gBAAA;AtB85exC;;AsB95eE;EAAsC,gBAAA;AtBk6exC;;AsBl6eE;EAAsC,gBAAA;AtBs6exC;;AsBt6eE;EAAsC,gBAAA;AtB06exC;;AsB16eE;EAAsC,gBAAA;AtB86exC;;AsB96eE;EAAsC,gBAAA;AtBk7exC;;AsBl7eE;EAAsC,gBAAA;AtBs7exC;;AsBt7eE;EAAsC,gBAAA;AtB07exC;;AsB17eE;EAAsC,gBAAA;AtB87exC;;AsB97eE;EAAsC,gBAAA;AtBk8exC;;AsBl8eE;EAAsC,gBAAA;AtBs8exC;;AsBt8eE;EAAsC,gBAAA;AtB08exC;;AsB18eE;EAAsC,gBAAA;AtB88exC;;AsB98eE;EAAsC,gBAAA;AtBk9exC;;AsBl9eE;EAAsC,gBAAA;AtBs9exC;;AsBt9eE;EAAsC,gBAAA;AtB09exC;;AsB19eE;EAAsC,gBAAA;AtB89exC;;AsB99eE;EAAsC,gBAAA;AtBk+exC;;AsBl+eE;EAAsC,gBAAA;AtBs+exC;;AsBt+eE;EAAsC,gBAAA;AtB0+exC;;AsB1+eE;EAAsC,gBAAA;AtB8+exC;;AsB9+eE;EAAsC,gBAAA;AtBk/exC;;AsBl/eE;EAAsC,gBAAA;AtBs/exC;;AsBt/eE;EAAsC,gBAAA;AtB0/exC;;AsB1/eE;EAAsC,gBAAA;AtB8/exC;;AsB9/eE;EAAsC,gBAAA;AtBkgfxC;;AsBlgfE;EAAsC,gBAAA;AtBsgfxC;;AsBtgfE;EAAsC,gBAAA;AtB0gfxC;;AsB1gfE;EAAsC,gBAAA;AtB8gfxC;;AsB9gfE;EAAsC,gBAAA;AtBkhfxC;;AsBlhfE;EAAsC,gBAAA;AtBshfxC;;AsBthfE;EAAsC,gBAAA;AtB0hfxC;;AsB1hfE;EAAsC,gBAAA;AtB8hfxC;;AsB9hfE;EAAsC,gBAAA;AtBkifxC;;AsBlifE;EAAsC,gBAAA;AtBsifxC;;AsBtifE;EAAsC,gBAAA;AtB0ifxC;;AsB1ifE;EAAsC,gBAAA;AtB8ifxC;;AsB9ifE;EAAsC,gBAAA;AtBkjfxC;;AsBljfE;EAAsC,gBAAA;AtBsjfxC;;AsBtjfE;EAAsC,gBAAA;AtB0jfxC;;AsB1jfE;EAAsC,gBAAA;AtB8jfxC;;AsB9jfE;EAAsC,gBAAA;AtBkkfxC;;AsBlkfE;EAAsC,gBAAA;AtBskfxC;;AsBtkfE;EAAsC,gBAAA;AtB0kfxC;;AsB1kfE;EAAsC,gBAAA;AtB8kfxC;;AsB9kfE;EAAsC,gBAAA;AtBklfxC;;AsBllfE;EAAsC,gBAAA;AtBslfxC;;AsBtlfE;EAAsC,gBAAA;AtB0lfxC;;AsB1lfE;EAAsC,gBAAA;AtB8lfxC;;AsB9lfE;EAAsC,gBAAA;AtBkmfxC;;AsBlmfE;EAAsC,YAAA;AtBsmfxC;;AsBtmfE;EAAsC,gBAAA;AtB0mfxC;;AsB1mfE;EAAsC,gBAAA;AtB8mfxC;;AsB9mfE;EAAsC,gBAAA;AtBknfxC;;AsBlnfE;EAAsC,gBAAA;AtBsnfxC;;AsBtnfE;EAAsC,gBAAA;AtB0nfxC;;AsB1nfE;EAAsC,gBAAA;AtB8nfxC;;AsB9nfE;EAAsC,gBAAA;AtBkofxC;;AsBlofE;EAAsC,gBAAA;AtBsofxC;;AsBtofE;EAAsC,gBAAA;AtB0ofxC;;AsB1ofE;EAAsC,YAAA;AtB8ofxC;;AsB9ofE;EAAsC,gBAAA;AtBkpfxC;;AsBlpfE;EAAsC,gBAAA;AtBspfxC;;AsBtpfE;EAAsC,gBAAA;AtB0pfxC;;AsB1pfE;EAAsC,gBAAA;AtB8pfxC;;AsB9pfE;EAAsC,gBAAA;AtBkqfxC;;AsBlqfE;EAAsC,gBAAA;AtBsqfxC;;AsBtqfE;EAAsC,YAAA;AtB0qfxC;;AuB7qfA;;ETqBE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;Ad6pfF;;AcxpfE;;EAbA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;Ad0qfF;;AwB3sfA;;;EAAA;AAOA;EACE,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBRoCwB;EQnCxB,wHAAA;AxB2sfF;AwBvsfA;;EAEE,oCAAA;EACA,gBAAA;AxBysfF;;AwBrsfE;EAAqC,gBAAA;AxBysfvC;;AwBzsfE;EAAqC,gBAAA;AxB6sfvC;;AwB7sfE;EAAqC,gBAAA;AxBitfvC;;AwBjtfE;EAAqC,gBAAA;AxBqtfvC;;AwBrtfE;EAAqC,gBAAA;AxBytfvC;;AwBztfE;EAAqC,gBAAA;AxB6tfvC;;AwB7tfE;EAAqC,gBAAA;AxBiufvC;;AwBjufE;EAAqC,gBAAA;AxBqufvC;;AwBrufE;EAAqC,gBAAA;AxByufvC;;AwBzufE;EAAqC,gBAAA;AxB6ufvC;;AwB7ufE;EAAqC,gBAAA;AxBivfvC;;AwBjvfE;EAAqC,gBAAA;AxBqvfvC;;AwBrvfE;EAAqC,gBAAA;AxByvfvC;;AwBzvfE;EAAqC,gBAAA;AxB6vfvC;;AwB7vfE;EAAqC,gBAAA;AxBiwfvC;;AwBjwfE;EAAqC,gBAAA;AxBqwfvC;;AwBrwfE;EAAqC,gBAAA;AxBywfvC;;AwBzwfE;EAAqC,gBAAA;AxB6wfvC;;AwB7wfE;EAAqC,gBAAA;AxBixfvC;;AwBjxfE;EAAqC,gBAAA;AxBqxfvC;;AwBrxfE;EAAqC,gBAAA;AxByxfvC;;AwBzxfE;EAAqC,gBAAA;AxB6xfvC;;AwB7xfE;EAAqC,gBAAA;AxBiyfvC;;AwBjyfE;EAAqC,gBAAA;AxBqyfvC;;AwBryfE;EAAqC,gBAAA;AxByyfvC;;AwBzyfE;EAAqC,gBAAA;AxB6yfvC;;AwB7yfE;EAAqC,gBAAA;AxBizfvC;;AwBjzfE;EAAqC,gBAAA;AxBqzfvC;;AwBrzfE;EAAqC,gBAAA;AxByzfvC;;AwBzzfE;EAAqC,gBAAA;AxB6zfvC;;AwB7zfE;EAAqC,gBAAA;AxBi0fvC;;AwBj0fE;EAAqC,gBAAA;AxBq0fvC;;AwBr0fE;EAAqC,gBAAA;AxBy0fvC;;AwBz0fE;EAAqC,gBAAA;AxB60fvC;;AwB70fE;EAAqC,gBAAA;AxBi1fvC;;AwBj1fE;EAAqC,gBAAA;AxBq1fvC;;AwBr1fE;EAAqC,gBAAA;AxBy1fvC;;AwBz1fE;EAAqC,gBAAA;AxB61fvC;;AwB71fE;EAAqC,gBAAA;AxBi2fvC;;AwBj2fE;EAAqC,gBAAA;AxBq2fvC;;AwBr2fE;EAAqC,gBAAA;AxBy2fvC;;AwBz2fE;EAAqC,gBAAA;AxB62fvC;;AwB72fE;EAAqC,gBAAA;AxBi3fvC;;AwBj3fE;EAAqC,gBAAA;AxBq3fvC;;AwBr3fE;EAAqC,gBAAA;AxBy3fvC;;AwBz3fE;EAAqC,gBAAA;AxB63fvC;;AwB73fE;EAAqC,gBAAA;AxBi4fvC;;AwBj4fE;EAAqC,gBAAA;AxBq4fvC;;AwBr4fE;EAAqC,gBAAA;AxBy4fvC;;AwBz4fE;EAAqC,gBAAA;AxB64fvC;;AwB74fE;EAAqC,gBAAA;AxBi5fvC;;AwBj5fE;EAAqC,gBAAA;AxBq5fvC;;AwBr5fE;EAAqC,gBAAA;AxBy5fvC;;AwBz5fE;EAAqC,gBAAA;AxB65fvC;;AwB75fE;EAAqC,gBAAA;AxBi6fvC;;AwBj6fE;EAAqC,gBAAA;AxBq6fvC;;AwBr6fE;EAAqC,gBAAA;AxBy6fvC;;AwBz6fE;EAAqC,gBAAA;AxB66fvC;;AwB76fE;EAAqC,gBAAA;AxBi7fvC;;AwBj7fE;EAAqC,gBAAA;AxBq7fvC;;AwBr7fE;EAAqC,gBAAA;AxBy7fvC;;AwBz7fE;EAAqC,gBAAA;AxB67fvC;;AwB77fE;EAAqC,gBAAA;AxBi8fvC;;AwBj8fE;EAAqC,gBAAA;AxBq8fvC;;AwBr8fE;EAAqC,gBAAA;AxBy8fvC;;AwBz8fE;EAAqC,gBAAA;AxB68fvC;;AwB78fE;EAAqC,gBAAA;AxBi9fvC;;AwBj9fE;EAAqC,gBAAA;AxBq9fvC;;AwBr9fE;EAAqC,gBAAA;AxBy9fvC;;AwBz9fE;EAAqC,gBAAA;AxB69fvC;;AwB79fE;EAAqC,gBAAA;AxBi+fvC;;AwBj+fE;EAAqC,gBAAA;AxBq+fvC;;AwBr+fE;EAAqC,gBAAA;AxBy+fvC;;AwBz+fE;EAAqC,gBAAA;AxB6+fvC;;AwB7+fE;EAAqC,gBAAA;AxBi/fvC;;AwBj/fE;EAAqC,gBAAA;AxBq/fvC;;AwBr/fE;EAAqC,gBAAA;AxBy/fvC;;AwBz/fE;EAAqC,gBAAA;AxB6/fvC;;AwB7/fE;EAAqC,gBAAA;AxBiggBvC;;AwBjggBE;EAAqC,gBAAA;AxBqggBvC;;AwBrggBE;EAAqC,gBAAA;AxByggBvC;;AwBzggBE;EAAqC,gBAAA;AxB6ggBvC;;AwB7ggBE;EAAqC,gBAAA;AxBihgBvC;;AwBjhgBE;EAAqC,gBAAA;AxBqhgBvC;;AwBrhgBE;EAAqC,gBAAA;AxByhgBvC;;AwBzhgBE;EAAqC,gBAAA;AxB6hgBvC;;AwB7hgBE;EAAqC,gBAAA;AxBiigBvC;;AwBjigBE;EAAqC,gBAAA;AxBqigBvC;;AwBrigBE;EAAqC,gBAAA;AxByigBvC;;AwBzigBE;EAAqC,gBAAA;AxB6igBvC;;AwB7igBE;EAAqC,gBAAA;AxBijgBvC;;AwBjjgBE;EAAqC,gBAAA;AxBqjgBvC;;AwBrjgBE;EAAqC,gBAAA;AxByjgBvC;;AwBzjgBE;EAAqC,gBAAA;AxB6jgBvC;;AwB7jgBE;EAAqC,gBAAA;AxBikgBvC;;AwBjkgBE;EAAqC,gBAAA;AxBqkgBvC;;AwBrkgBE;EAAqC,gBAAA;AxBykgBvC;;AwBzkgBE;EAAqC,gBAAA;AxB6kgBvC;;AwB7kgBE;EAAqC,gBAAA;AxBilgBvC;;AwBjlgBE;EAAqC,gBAAA;AxBqlgBvC;;AwBrlgBE;EAAqC,gBAAA;AxBylgBvC;;AwBzlgBE;EAAqC,gBAAA;AxB6lgBvC;;AwB7lgBE;EAAqC,gBAAA;AxBimgBvC;;AwBjmgBE;EAAqC,gBAAA;AxBqmgBvC;;AwBrmgBE;EAAqC,gBAAA;AxBymgBvC;;AwBzmgBE;EAAqC,gBAAA;AxB6mgBvC;;AwB7mgBE;EAAqC,gBAAA;AxBingBvC;;AwBjngBE;EAAqC,gBAAA;AxBqngBvC;;AwBrngBE;EAAqC,gBAAA;AxByngBvC;;AwBzngBE;EAAqC,gBAAA;AxB6ngBvC;;AwB7ngBE;EAAqC,gBAAA;AxBiogBvC;;AwBjogBE;EAAqC,gBAAA;AxBqogBvC;;AwBrogBE;EAAqC,gBAAA;AxByogBvC;;AwBzogBE;EAAqC,gBAAA;AxB6ogBvC;;AwB7ogBE;EAAqC,gBAAA;AxBipgBvC;;AwBjpgBE;EAAqC,gBAAA;AxBqpgBvC;;AwBrpgBE;EAAqC,gBAAA;AxBypgBvC;;AwBzpgBE;EAAqC,gBAAA;AxB6pgBvC;;AwB7pgBE;EAAqC,gBAAA;AxBiqgBvC;;AwBjqgBE;EAAqC,gBAAA;AxBqqgBvC;;AwBrqgBE;EAAqC,gBAAA;AxByqgBvC;;AwBzqgBE;EAAqC,gBAAA;AxB6qgBvC;;AwB7qgBE;EAAqC,gBAAA;AxBirgBvC;;AwBjrgBE;EAAqC,gBAAA;AxBqrgBvC;;AwBrrgBE;EAAqC,gBAAA;AxByrgBvC;;AwBzrgBE;EAAqC,gBAAA;AxB6rgBvC;;AwB7rgBE;EAAqC,gBAAA;AxBisgBvC;;AwBjsgBE;EAAqC,gBAAA;AxBqsgBvC;;AwBrsgBE;EAAqC,gBAAA;AxBysgBvC;;AwBzsgBE;EAAqC,gBAAA;AxB6sgBvC;;AwB7sgBE;EAAqC,gBAAA;AxBitgBvC;;AwBjtgBE;EAAqC,gBAAA;AxBqtgBvC;;AwBrtgBE;EAAqC,gBAAA;AxBytgBvC;;AwBztgBE;EAAqC,gBAAA;AxB6tgBvC;;AwB7tgBE;EAAqC,gBAAA;AxBiugBvC;;AwBjugBE;EAAqC,gBAAA;AxBqugBvC;;AwBrugBE;EAAqC,gBAAA;AxByugBvC;;AwBzugBE;EAAqC,gBAAA;AxB6ugBvC;;AwB7ugBE;EAAqC,gBAAA;AxBivgBvC;;AwBjvgBE;EAAqC,gBAAA;AxBqvgBvC;;AwBrvgBE;EAAqC,gBAAA;AxByvgBvC;;AwBzvgBE;EAAqC,gBAAA;AxB6vgBvC;;AwB7vgBE;EAAqC,gBAAA;AxBiwgBvC;;AwBjwgBE;EAAqC,gBAAA;AxBqwgBvC;;AwBrwgBE;EAAqC,gBAAA;AxBywgBvC;;AwBzwgBE;EAAqC,gBAAA;AxB6wgBvC;;AwB7wgBE;EAAqC,gBAAA;AxBixgBvC;;AwBjxgBE;EAAqC,gBAAA;AxBqxgBvC;;AwBrxgBE;EAAqC,gBAAA;AxByxgBvC;;AwBzxgBE;EAAqC,gBAAA;AxB6xgBvC;;AwB7xgBE;EAAqC,gBAAA;AxBiygBvC;;AwBjygBE;EAAqC,gBAAA;AxBqygBvC;;AwBrygBE;EAAqC,gBAAA;AxByygBvC;;AwBzygBE;EAAqC,gBAAA;AxB6ygBvC;;AwB7ygBE;EAAqC,gBAAA;AxBizgBvC;;AwBjzgBE;EAAqC,gBAAA;AxBqzgBvC;;AwBrzgBE;EAAqC,gBAAA;AxByzgBvC;;AwBzzgBE;EAAqC,gBAAA;AxB6zgBvC;;AwB7zgBE;EAAqC,gBAAA;AxBi0gBvC;;AwBj0gBE;EAAqC,gBAAA;AxBq0gBvC;;AwBr0gBE;EAAqC,gBAAA;AxBy0gBvC;;AwBz0gBE;EAAqC,gBAAA;AxB60gBvC;;AwB70gBE;EAAqC,gBAAA;AxBi1gBvC;;AwBj1gBE;EAAqC,gBAAA;AxBq1gBvC;;AwBr1gBE;EAAqC,gBAAA;AxBy1gBvC;;AwBz1gBE;EAAqC,gBAAA;AxB61gBvC;;AwB71gBE;EAAqC,gBAAA;AxBi2gBvC;;AwBj2gBE;EAAqC,gBAAA;AxBq2gBvC;;AwBr2gBE;EAAqC,gBAAA;AxBy2gBvC;;AwBz2gBE;EAAqC,gBAAA;AxB62gBvC;;AwB72gBE;EAAqC,gBAAA;AxBi3gBvC;;AwBj3gBE;EAAqC,gBAAA;AxBq3gBvC;;AwBr3gBE;EAAqC,gBAAA;AxBy3gBvC;;AwBz3gBE;EAAqC,gBAAA;AxB63gBvC;;AwB73gBE;EAAqC,gBAAA;AxBi4gBvC;;AwBj4gBE;EAAqC,gBAAA;AxBq4gBvC;;AwBr4gBE;EAAqC,gBAAA;AxBy4gBvC;;AwBz4gBE;EAAqC,gBAAA;AxB64gBvC;;AwB74gBE;EAAqC,gBAAA;AxBi5gBvC;;AwBj5gBE;EAAqC,gBAAA;AxBq5gBvC;;AwBr5gBE;EAAqC,gBAAA;AxBy5gBvC;;AwBz5gBE;EAAqC,gBAAA;AxB65gBvC;;AwB75gBE;EAAqC,gBAAA;AxBi6gBvC;;AwBj6gBE;EAAqC,gBAAA;AxBq6gBvC;;AwBr6gBE;EAAqC,gBAAA;AxBy6gBvC;;AwBz6gBE;EAAqC,gBAAA;AxB66gBvC;;AwB76gBE;EAAqC,gBAAA;AxBi7gBvC;;AwBj7gBE;EAAqC,gBAAA;AxBq7gBvC;;AwBr7gBE;EAAqC,gBAAA;AxBy7gBvC;;AwBz7gBE;EAAqC,gBAAA;AxB67gBvC;;AwB77gBE;EAAqC,gBAAA;AxBi8gBvC;;AwBj8gBE;EAAqC,gBAAA;AxBq8gBvC;;AwBr8gBE;EAAqC,gBAAA;AxBy8gBvC;;AwBz8gBE;EAAqC,gBAAA;AxB68gBvC;;AwB78gBE;EAAqC,gBAAA;AxBi9gBvC;;AwBj9gBE;EAAqC,gBAAA;AxBq9gBvC;;AwBr9gBE;EAAqC,gBAAA;AxBy9gBvC;;AwBz9gBE;EAAqC,gBAAA;AxB69gBvC;;AwB79gBE;EAAqC,gBAAA;AxBi+gBvC;;AwBj+gBE;EAAqC,gBAAA;AxBq+gBvC;;AwBr+gBE;EAAqC,gBAAA;AxBy+gBvC;;AwBz+gBE;EAAqC,gBAAA;AxB6+gBvC;;AwB7+gBE;EAAqC,gBAAA;AxBi/gBvC;;AwBj/gBE;EAAqC,gBAAA;AxBq/gBvC;;AwBr/gBE;EAAqC,gBAAA;AxBy/gBvC;;AwBz/gBE;EAAqC,gBAAA;AxB6/gBvC;;AwB7/gBE;EAAqC,gBAAA;AxBighBvC;;AwBjghBE;EAAqC,gBAAA;AxBqghBvC;;AwBrghBE;EAAqC,gBAAA;AxByghBvC;;AwBzghBE;EAAqC,gBAAA;AxB6ghBvC;;AwB7ghBE;EAAqC,gBAAA;AxBihhBvC;;AwBjhhBE;EAAqC,gBAAA;AxBqhhBvC;;AwBrhhBE;EAAqC,gBAAA;AxByhhBvC;;AwBzhhBE;EAAqC,gBAAA;AxB6hhBvC;;AwB7hhBE;EAAqC,gBAAA;AxBiihBvC;;AwBjihBE;EAAqC,gBAAA;AxBqihBvC;;AwBrihBE;EAAqC,gBAAA;AxByihBvC;;AwBzihBE;EAAqC,gBAAA;AxB6ihBvC;;AwB7ihBE;EAAqC,gBAAA;AxBijhBvC;;AwBjjhBE;EAAqC,gBAAA;AxBqjhBvC;;AwBrjhBE;EAAqC,gBAAA;AxByjhBvC;;AwBzjhBE;EAAqC,gBAAA;AxB6jhBvC;;AwB7jhBE;EAAqC,gBAAA;AxBikhBvC;;AwBjkhBE;EAAqC,gBAAA;AxBqkhBvC;;AwBrkhBE;EAAqC,gBAAA;AxBykhBvC;;AwBzkhBE;EAAqC,gBAAA;AxB6khBvC;;AwB7khBE;EAAqC,gBAAA;AxBilhBvC;;AwBjlhBE;EAAqC,gBAAA;AxBqlhBvC;;AwBrlhBE;EAAqC,gBAAA;AxBylhBvC;;AwBzlhBE;EAAqC,gBAAA;AxB6lhBvC;;AwB7lhBE;EAAqC,gBAAA;AxBimhBvC;;AwBjmhBE;EAAqC,gBAAA;AxBqmhBvC;;AwBrmhBE;EAAqC,gBAAA;AxBymhBvC;;AwBzmhBE;EAAqC,gBAAA;AxB6mhBvC;;AwB7mhBE;EAAqC,gBAAA;AxBinhBvC;;AwBjnhBE;EAAqC,gBAAA;AxBqnhBvC;;AwBrnhBE;EAAqC,gBAAA;AxBynhBvC;;AwBznhBE;EAAqC,gBAAA;AxB6nhBvC;;AwB7nhBE;EAAqC,gBAAA;AxBiohBvC;;AwBjohBE;EAAqC,gBAAA;AxBqohBvC;;AwBrohBE;EAAqC,gBAAA;AxByohBvC;;AwBzohBE;EAAqC,gBAAA;AxB6ohBvC;;AwB7ohBE;EAAqC,gBAAA;AxBiphBvC;;AwBjphBE;EAAqC,gBAAA;AxBqphBvC;;AwBrphBE;EAAqC,gBAAA;AxByphBvC;;AwBzphBE;EAAqC,gBAAA;AxB6phBvC;;AwB7phBE;EAAqC,gBAAA;AxBiqhBvC;;AwBjqhBE;EAAqC,gBAAA;AxBqqhBvC;;AwBrqhBE;EAAqC,gBAAA;AxByqhBvC;;AwBzqhBE;EAAqC,gBAAA;AxB6qhBvC;;AwB7qhBE;EAAqC,gBAAA;AxBirhBvC;;AwBjrhBE;EAAqC,gBAAA;AxBqrhBvC;;AwBrrhBE;EAAqC,gBAAA;AxByrhBvC;;AwBzrhBE;EAAqC,gBAAA;AxB6rhBvC;;AwB7rhBE;EAAqC,gBAAA;AxBishBvC;;AwBjshBE;EAAqC,gBAAA;AxBqshBvC;;AwBrshBE;EAAqC,gBAAA;AxByshBvC;;AwBzshBE;EAAqC,gBAAA;AxB6shBvC;;AwB7shBE;EAAqC,gBAAA;AxBithBvC;;AwBjthBE;EAAqC,gBAAA;AxBqthBvC;;AwBrthBE;EAAqC,gBAAA;AxBythBvC;;AwBzthBE;EAAqC,gBAAA;AxB6thBvC;;AwB7thBE;EAAqC,gBAAA;AxBiuhBvC;;AwBjuhBE;EAAqC,gBAAA;AxBquhBvC;;AwBruhBE;EAAqC,gBAAA;AxByuhBvC;;AwBzuhBE;EAAqC,gBAAA;AxB6uhBvC;;AwB7uhBE;EAAqC,gBAAA;AxBivhBvC;;AwBjvhBE;EAAqC,gBAAA;AxBqvhBvC;;AwBrvhBE;EAAqC,gBAAA;AxByvhBvC;;AwBzvhBE;EAAqC,gBAAA;AxB6vhBvC;;AwB7vhBE;EAAqC,gBAAA;AxBiwhBvC;;AwBjwhBE;EAAqC,gBAAA;AxBqwhBvC;;AwBrwhBE;EAAqC,gBAAA;AxBywhBvC;;AwBzwhBE;EAAqC,gBAAA;AxB6whBvC;;AwB7whBE;EAAqC,gBAAA;AxBixhBvC;;AwBjxhBE;EAAqC,gBAAA;AxBqxhBvC;;AwBrxhBE;EAAqC,gBAAA;AxByxhBvC;;AwBzxhBE;EAAqC,gBAAA;AxB6xhBvC;;AwB7xhBE;EAAqC,gBAAA;AxBiyhBvC;;AwBjyhBE;EAAqC,gBAAA;AxBqyhBvC;;AwBryhBE;EAAqC,gBAAA;AxByyhBvC;;AwBzyhBE;EAAqC,gBAAA;AxB6yhBvC;;AwB7yhBE;EAAqC,gBAAA;AxBizhBvC;;AwBjzhBE;EAAqC,gBAAA;AxBqzhBvC;;AwBrzhBE;EAAqC,gBAAA;AxByzhBvC;;AwBzzhBE;EAAqC,gBAAA;AxB6zhBvC;;AwB7zhBE;EAAqC,gBAAA;AxBi0hBvC;;AwBj0hBE;EAAqC,gBAAA;AxBq0hBvC;;AwBr0hBE;EAAqC,gBAAA;AxBy0hBvC;;AwBz0hBE;EAAqC,gBAAA;AxB60hBvC;;AwB70hBE;EAAqC,gBAAA;AxBi1hBvC;;AwBj1hBE;EAAqC,gBAAA;AxBq1hBvC;;AwBr1hBE;EAAqC,gBAAA;AxBy1hBvC;;AwBz1hBE;EAAqC,gBAAA;AxB61hBvC;;AwB71hBE;EAAqC,gBAAA;AxBi2hBvC;;AwBj2hBE;EAAqC,gBAAA;AxBq2hBvC;;AwBr2hBE;EAAqC,gBAAA;AxBy2hBvC;;AwBz2hBE;EAAqC,gBAAA;AxB62hBvC;;AwB72hBE;EAAqC,gBAAA;AxBi3hBvC;;AwBj3hBE;EAAqC,gBAAA;AxBq3hBvC;;AwBr3hBE;EAAqC,gBAAA;AxBy3hBvC;;AwBz3hBE;EAAqC,gBAAA;AxB63hBvC;;AwB73hBE;EAAqC,gBAAA;AxBi4hBvC;;AwBj4hBE;EAAqC,gBAAA;AxBq4hBvC;;AwBr4hBE;EAAqC,gBAAA;AxBy4hBvC;;AwBz4hBE;EAAqC,gBAAA;AxB64hBvC;;AwB74hBE;EAAqC,gBAAA;AxBi5hBvC;;AwBj5hBE;EAAqC,gBAAA;AxBq5hBvC;;AwBr5hBE;EAAqC,gBAAA;AxBy5hBvC;;AwBz5hBE;EAAqC,gBAAA;AxB65hBvC;;AwB75hBE;EAAqC,gBAAA;AxBi6hBvC;;AwBj6hBE;EAAqC,gBAAA;AxBq6hBvC;;AwBr6hBE;EAAqC,gBAAA;AxBy6hBvC;;AwBz6hBE;EAAqC,gBAAA;AxB66hBvC;;AwB76hBE;EAAqC,gBAAA;AxBi7hBvC;;AwBj7hBE;EAAqC,gBAAA;AxBq7hBvC;;AwBr7hBE;EAAqC,gBAAA;AxBy7hBvC;;AwBz7hBE;EAAqC,gBAAA;AxB67hBvC;;AwB77hBE;EAAqC,gBAAA;AxBi8hBvC;;AwBj8hBE;EAAqC,gBAAA;AxBq8hBvC;;AwBr8hBE;EAAqC,gBAAA;AxBy8hBvC;;AwBz8hBE;EAAqC,gBAAA;AxB68hBvC;;AwB78hBE;EAAqC,gBAAA;AxBi9hBvC;;AwBj9hBE;EAAqC,gBAAA;AxBq9hBvC;;AwBr9hBE;EAAqC,gBAAA;AxBy9hBvC;;AwBz9hBE;EAAqC,gBAAA;AxB69hBvC;;AwB79hBE;EAAqC,gBAAA;AxBi+hBvC;;AwBj+hBE;EAAqC,gBAAA;AxBq+hBvC;;AwBr+hBE;EAAqC,gBAAA;AxBy+hBvC;;AwBz+hBE;EAAqC,gBAAA;AxB6+hBvC;;AwB7+hBE;EAAqC,gBAAA;AxBi/hBvC;;AwBj/hBE;EAAqC,gBAAA;AxBq/hBvC;;AwBr/hBE;EAAqC,gBAAA;AxBy/hBvC;;AwBz/hBE;EAAqC,gBAAA;AxB6/hBvC;;AwB7/hBE;EAAqC,gBAAA;AxBigiBvC;;AwBjgiBE;EAAqC,gBAAA;AxBqgiBvC;;AwBrgiBE;EAAqC,gBAAA;AxBygiBvC;;AwBzgiBE;EAAqC,gBAAA;AxB6giBvC;;AwB7giBE;EAAqC,gBAAA;AxBihiBvC;;AwBjhiBE;EAAqC,gBAAA;AxBqhiBvC;;AwBrhiBE;EAAqC,gBAAA;AxByhiBvC;;AwBzhiBE;EAAqC,gBAAA;AxB6hiBvC;;AwB7hiBE;EAAqC,gBAAA;AxBiiiBvC;;AwBjiiBE;EAAqC,gBAAA;AxBqiiBvC;;AwBriiBE;EAAqC,gBAAA;AxByiiBvC;;AwBziiBE;EAAqC,gBAAA;AxB6iiBvC;;AwB7iiBE;EAAqC,gBAAA;AxBijiBvC;;AwBjjiBE;EAAqC,gBAAA;AxBqjiBvC;;AwBrjiBE;EAAqC,gBAAA;AxByjiBvC;;AwBzjiBE;EAAqC,gBAAA;AxB6jiBvC;;AwB7jiBE;EAAqC,gBAAA;AxBikiBvC;;AwBjkiBE;EAAqC,gBAAA;AxBqkiBvC;;AwBrkiBE;EAAqC,gBAAA;AxBykiBvC;;AwBzkiBE;EAAqC,gBAAA;AxB6kiBvC;;AwB7kiBE;EAAqC,gBAAA;AxBiliBvC;;AwBjliBE;EAAqC,gBAAA;AxBqliBvC;;AwBrliBE;EAAqC,gBAAA;AxByliBvC;;AwBzliBE;EAAqC,gBAAA;AxB6liBvC;;AwB7liBE;EAAqC,gBAAA;AxBimiBvC;;AwBjmiBE;EAAqC,gBAAA;AxBqmiBvC;;AwBrmiBE;EAAqC,gBAAA;AxBymiBvC;;AwBzmiBE;EAAqC,gBAAA;AxB6miBvC;;AwB7miBE;EAAqC,gBAAA;AxBiniBvC;;AwBjniBE;EAAqC,gBAAA;AxBqniBvC;;AwBrniBE;EAAqC,gBAAA;AxByniBvC;;AwBzniBE;EAAqC,gBAAA;AxB6niBvC;;AwB7niBE;EAAqC,gBAAA;AxBioiBvC;;AwBjoiBE;EAAqC,gBAAA;AxBqoiBvC;;AwBroiBE;EAAqC,gBAAA;AxByoiBvC;;AwBzoiBE;EAAqC,gBAAA;AxB6oiBvC;;AwB7oiBE;EAAqC,gBAAA;AxBipiBvC;;AwBjpiBE;EAAqC,gBAAA;AxBqpiBvC;;AwBrpiBE;EAAqC,gBAAA;AxBypiBvC;;AwBzpiBE;EAAqC,gBAAA;AxB6piBvC;;AwB7piBE;EAAqC,gBAAA;AxBiqiBvC;;AwBjqiBE;EAAqC,gBAAA;AxBqqiBvC;;AwBrqiBE;EAAqC,gBAAA;AxByqiBvC;;AwBzqiBE;EAAqC,gBAAA;AxB6qiBvC;;AwB7qiBE;EAAqC,gBAAA;AxBiriBvC;;AwBjriBE;EAAqC,gBAAA;AxBqriBvC;;AwBrriBE;EAAqC,gBAAA;AxByriBvC;;AwBzriBE;EAAqC,gBAAA;AxB6riBvC;;AwB7riBE;EAAqC,gBAAA;AxBisiBvC;;AwBjsiBE;EAAqC,gBAAA;AxBqsiBvC;;AwBrsiBE;EAAqC,gBAAA;AxBysiBvC;;AwBzsiBE;EAAqC,gBAAA;AxB6siBvC;;AwB7siBE;EAAqC,gBAAA;AxBitiBvC;;AwBjtiBE;EAAqC,gBAAA;AxBqtiBvC;;AwBrtiBE;EAAqC,gBAAA;AxBytiBvC;;AwBztiBE;EAAqC,gBAAA;AxB6tiBvC;;AwB7tiBE;EAAqC,gBAAA;AxBiuiBvC;;AwBjuiBE;EAAqC,gBAAA;AxBquiBvC;;AwBruiBE;EAAqC,gBAAA;AxByuiBvC;;AwBzuiBE;EAAqC,gBAAA;AxB6uiBvC;;AwB7uiBE;EAAqC,gBAAA;AxBiviBvC;;AwBjviBE;EAAqC,gBAAA;AxBqviBvC;;AwBrviBE;EAAqC,gBAAA;AxByviBvC;;AwBzviBE;EAAqC,gBAAA;AxB6viBvC;;AwB7viBE;EAAqC,gBAAA;AxBiwiBvC;;AwBjwiBE;EAAqC,gBAAA;AxBqwiBvC;;AwBrwiBE;EAAqC,gBAAA;AxBywiBvC;;AwBzwiBE;EAAqC,gBAAA;AxB6wiBvC;;AwB7wiBE;EAAqC,gBAAA;AxBixiBvC;;AwBjxiBE;EAAqC,gBAAA;AxBqxiBvC;;AwBrxiBE;EAAqC,gBAAA;AxByxiBvC;;AwBzxiBE;EAAqC,gBAAA;AxB6xiBvC;;AwB7xiBE;EAAqC,gBAAA;AxBiyiBvC;;AwBjyiBE;EAAqC,gBAAA;AxBqyiBvC;;AwBryiBE;EAAqC,gBAAA;AxByyiBvC;;AwBzyiBE;EAAqC,gBAAA;AxB6yiBvC;;AwB7yiBE;EAAqC,gBAAA;AxBiziBvC;;AwBjziBE;EAAqC,gBAAA;AxBqziBvC;;AwBrziBE;EAAqC,gBAAA;AxByziBvC;;AwBzziBE;EAAqC,gBAAA;AxB6ziBvC;;AwB7ziBE;EAAqC,gBAAA;AxBi0iBvC;;AwBj0iBE;EAAqC,gBAAA;AxBq0iBvC;;AwBr0iBE;EAAqC,gBAAA;AxBy0iBvC;;AwBz0iBE;EAAqC,gBAAA;AxB60iBvC;;AwB70iBE;EAAqC,gBAAA;AxBi1iBvC;;AwBj1iBE;EAAqC,gBAAA;AxBq1iBvC;;AwBr1iBE;EAAqC,gBAAA;AxBy1iBvC;;AwBz1iBE;EAAqC,gBAAA;AxB61iBvC;;AwB71iBE;EAAqC,gBAAA;AxBi2iBvC;;AwBj2iBE;EAAqC,gBAAA;AxBq2iBvC;;AwBr2iBE;EAAqC,gBAAA;AxBy2iBvC;;AwBz2iBE;EAAqC,gBAAA;AxB62iBvC;;AwB72iBE;EAAqC,gBAAA;AxBi3iBvC;;AwBj3iBE;EAAqC,gBAAA;AxBq3iBvC;;AwBr3iBE;EAAqC,gBAAA;AxBy3iBvC;;AwBz3iBE;EAAqC,gBAAA;AxB63iBvC;;AwB73iBE;EAAqC,gBAAA;AxBi4iBvC;;AwBj4iBE;EAAqC,gBAAA;AxBq4iBvC;;AwBr4iBE;EAAqC,gBAAA;AxBy4iBvC;;AwBz4iBE;EAAqC,gBAAA;AxB64iBvC;;AwB74iBE;EAAqC,gBAAA;AxBi5iBvC;;AwBj5iBE;EAAqC,gBAAA;AxBq5iBvC;;AwBr5iBE;EAAqC,gBAAA;AxBy5iBvC;;AwBz5iBE;EAAqC,gBAAA;AxB65iBvC;;AwB75iBE;EAAqC,gBAAA;AxBi6iBvC;;AwBj6iBE;EAAqC,gBAAA;AxBq6iBvC;;AwBr6iBE;EAAqC,gBAAA;AxBy6iBvC;;AwBz6iBE;EAAqC,gBAAA;AxB66iBvC;;AwB76iBE;EAAqC,gBAAA;AxBi7iBvC;;AwBj7iBE;EAAqC,gBAAA;AxBq7iBvC;;AwBr7iBE;EAAqC,gBAAA;AxBy7iBvC;;AwBz7iBE;EAAqC,gBAAA;AxB67iBvC;;AwB77iBE;EAAqC,gBAAA;AxBi8iBvC;;AwBj8iBE;EAAqC,gBAAA;AxBq8iBvC;;AwBr8iBE;EAAqC,gBAAA;AxBy8iBvC;;AwBz8iBE;EAAqC,gBAAA;AxB68iBvC;;AwB78iBE;EAAqC,gBAAA;AxBi9iBvC;;AwBj9iBE;EAAqC,gBAAA;AxBq9iBvC;;AwBr9iBE;EAAqC,gBAAA;AxBy9iBvC;;AwBz9iBE;EAAqC,gBAAA;AxB69iBvC;;AwB79iBE;EAAqC,gBAAA;AxBi+iBvC;;AwBj+iBE;EAAqC,gBAAA;AxBq+iBvC;;AwBr+iBE;EAAqC,gBAAA;AxBy+iBvC;;AwBz+iBE;EAAqC,gBAAA;AxB6+iBvC;;AwB7+iBE;EAAqC,gBAAA;AxBi/iBvC;;AwBj/iBE;EAAqC,gBAAA;AxBq/iBvC;;AwBr/iBE;EAAqC,gBAAA;AxBy/iBvC;;AwBz/iBE;EAAqC,gBAAA;AxB6/iBvC;;AwB7/iBE;EAAqC,gBAAA;AxBigjBvC;;AwBjgjBE;EAAqC,gBAAA;AxBqgjBvC;;AwBrgjBE;EAAqC,gBAAA;AxBygjBvC;;AwBzgjBE;EAAqC,gBAAA;AxB6gjBvC;;AwB7gjBE;EAAqC,gBAAA;AxBihjBvC;;AwBjhjBE;EAAqC,gBAAA;AxBqhjBvC;;AyB5ijBA;;;EAAA;AAOA;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBToCwB;ESnCxB,wHAAA;AzB4ijBF;AyBxijBA;;EAEE,iCAAA;EACA,gBAAA;AzB0ijBF;;A0B7jjBA;;;EAAA;AAOA;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBVoCwB;EUnCxB,wHAAA;A1B6jjBF;A0BzjjBA;;EAEE,iCAAA;EACA,gBAAA;A1B2jjBF;;A2B9kjBA;;;EAAA;AAOA;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBXoCwB;EWnCxB,wHAAA;A3B8kjBF;A2B1kjBA;;EAEE,iCAAA;EACA,gBAAA;A3B4kjBF;;A4B/ljBA;;;EAAA;AAOA;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBZoCwB;EYnCxB,wHAAA;A5B+ljBF;A4B3ljBA;;EAEE,iCAAA;EACA,gBAAA;A5B6ljBF;;A6B9mjBA;EACE,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,6DAAA;A7BinjBF;A6B9mjBA;EACE,qBAAA;EACA,gBAAA;EACA,uEAAA;A7BgnjBF;A6B7mjBA;EACE,qBAAA;EACA,gBAAA;EACA,kEAAA;A7B+mjBF;A6B5mjBA;EACE,qBAAA;EACA,gBAAA;EACA,gEAAA;A7B8mjBF;A6B3mjBA;EACE,qBAAA;EACA,gBAAA;EACA,mEAAA;A7B6mjBF;A6B1mjBA;EACE,qBAAA;EACA,gBAAA;EACA,oEAAA;A7B4mjBF;A6BzmjBA;EACE,qBAAA;EACA,gBAAA;EACA,2EAAA;A7B2mjBF;A6BxmjBA;EACE,qBAAA;EACA,gBAAA;EACA,gEAAA;A7B0mjBF;A6BvmjBA;EACE,qBAAA;EACA,gBAAA;EACA,qEAAA;A7BymjBF;A8BjqjBA;EACE,YAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;A9BmqjBF;A8BjqjBE;EACE,wCAAA;A9BmqjBJ;A8BjqjBI;EACE,wCAAA;A9BmqjBN;;A8B7pjBA;EACE,sBAAA;A9BgqjBF;;A8B7pjBA;EACE,aAAA;A9BgqjBF;;A8B7pjBA;EACE,aAAA;EACA,qBAAA;A9BgqjBF;;A8B7pjBA;EACE,aAAA;EACA,qBAAA;A9BgqjBF;;A8B7pjBA;EACE,aAAA;EACA,qBAAA;A9BgqjBF;;A8B7pjBA;EACE,kBAAA;A9BgqjBF;;A8B7pjBA;EACE,2BAAA;EACA,kCAAA;EACA,eAAA;EACA,mCAAA;EACA,2CAAA;EACA,SAAA;A9BgqjBF;;A8B5pjBA;EACE,UAAA;EACA,WAAA;EACA,6BAAA;A9B+pjBF;A8B7pjBE;EACE,6BAAA;A9B+pjBJ;A8B5pjBE;EACE,oCAAA;A9B8pjBJ;;A8B1pjBA;EACE,yBAAA;A9B6pjBF;A8B3pjBE;EACE,yBAAA;A9B6pjBJ;;A8BzpjBA;EACE;IACE,cAAA;IACA,sBAAA;IACA,8BAAA;IACA,qBAAA;IACA,6BAAA;E9B4pjBF;AACF;A8BzpjBA;EACE;IACE,cAAA;IACA,sBAAA;IACA,8BAAA;IACA,qBAAA;IACA,6BAAA;E9B2pjBF;AACF;A8BxpjBA;EACE;IACE,cAAA;IACA,qBAAA;IACA,6BAAA;IACA,qBAAA;IACA,6BAAA;E9B0pjBF;AACF;A8BvpjBA;EACE,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;A9BypjBF;;A8BrpjBA;EACE,qCAAA;A9BwpjBF;;A8BrpjBA;EACE,6BAAA;A9BwpjBF;;A8BrpjBA;EACE,eAAA;A9BwpjBF;;A8BppjBA;EACE,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;A9BupjBF;;A8BppjBA;EACE,cAAA;EACA,qBAAA;EACA,6BAAA;A9BupjBF;;A8BppjBA;EACE,cAAA;A9BupjBF;;A8BppjBA;EACE,eAAA;A9BupjBF;;A8BnpjBA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;A9BspjBF;A8BppjBE;EACE,YAAA;A9BspjBJ;;A8BlpjBA;EACE,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;A9BqpjBF;A8BnpjBE;EACE,YAAA;A9BqpjBJ;;A8BjpjBA;EACE,yBAAA;A9BopjBF;;A8BjpjBA;EACE,sBAAA;A9BopjBF;;A8BjpjBA;EACE,yBAAA;A9BopjBF;;A8BjpjBA;EACE,yBAAA;A9BopjBF;;A8BjpjBA;EACE,kBAAA;A9BopjBF;;A8BjpjBA;EACE,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;A9BopjBF;;A8BjpjBA;EACE,gBAAA;A9BopjBF;;A8BjpjBA;EACE,gBAAA;A9BopjBF;;A8BjpjBA;EACE,wBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;A9BopjBF;;A8BjpjBA;EACE,WAAA;A9BopjBF;;A8B/ojBA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,kCAAA;EACA,gBAAA;EACA,qIAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EAEA,mBAAA;EACA,gCAAA;EACA,2CAAA;A9BipjBF;A8B/ojBE;EACE,YAAA;A9BipjBJ;A8B9ojBE;EACE,YAAA;EACA,eAAA;A9BgpjBJ;A8B7ojBE;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;A9B+ojBJ;;A8B3ojBA;EACE,4BAAA;EACA,2BAAA;EACA,qBAAA;EACA,oBAAA;A9B8ojBF;A8B5ojBE;EACE,yBAAA;A9B8ojBJ;;A8BzojBA;EACE,qBAAA;A9B4ojBF;;A8B1ojBA;EACE,qBAAA;A9B6ojBF;;A8B3ojBA;EACE,qBAAA;A9B8ojBF;;A8B5ojBA;EACE,UAAA;A9B+ojBF;;A8B7ojBA;EACE,UAAA;A9BgpjBF;;A8B9ojBA;EACE,UAAA;A9BipjBF;;A8B/ojBA;EACE,qBAAA;A9BkpjBF;;A8BhpjBA;EACE,UAAA;A9BmpjBF;;A8BjpjBA;EACE,UAAA;A9BopjBF;;A8B/ojBA;EACE,gCAAA;A9BkpjBF;;A8B/ojBA;EACE,mBAAA;A9BkpjBF;;A8B/ojBA;EACE,6BAAA;A9BkpjBF;;A8B/ojBA;EACE,qBAAA;EACA,0BAAA;EACA,eAAA;A9BkpjBF;;A+B98jBE;EACE,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;A/Bi9jBJ;A+B/8jBI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;A/Bi9jBN;A+B98jBI;EArBF;IAsBI,gBAAA;IACA,4BAAA;E/Bi9jBJ;AACF;A+B/8jBI;EACE,aAAA;A/Bi9jBN;A+B/8jBM;EAHF;IAII,eAAA;E/Bk9jBN;AACF;A+B98jBE;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;A/Bg9jBJ;A+B98jBI;EANF;IAOI,gBAAA;E/Bi9jBJ;AACF;A+B98jBE;EACE,iBAAA;EACA,qBAAA;EACA,8BAAA;EACA,aAAA;EACA,kBAAA;A/Bg9jBJ;A+B98jBI;EAPF;IAQI,sBAAA;IACA,uBAAA;IACA,eAAA;E/Bi9jBJ;AACF;A+B98jBE;EACE,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,YAAA;A/Bg9jBJ;A+B98jBI;EACE,iBAAA;A/Bg9jBN;A+B98jBM;EAHF;IAII,cAAA;E/Bi9jBN;AACF;A+B98jBI;EAdF;IAeI,WAAA;IACA,mBAAA;IACA,aAAA;IACA,sBAAA;E/Bi9jBJ;AACF;A+B98jBM;EADF;IAEI,WAAA;IACA,uBAAA;E/Bi9jBN;AACF;A+B78jBE;EACE,cAAA;A/B+8jBJ;A+B78jBI;EACE,cAAA;A/B+8jBN;;A+Bz8jBA;EAGI;IACE,gBAAA;IACA,4BAAA;E/B08jBJ;E+Bp8jBI;IACE,eAAA;E/Bs8jBN;E+Bl8jBE;IACE,gBAAA;E/Bo8jBJ;E+Bj8jBE;IACE,sBAAA;IACA,uBAAA;IACA,eAAA;E/Bm8jBJ;E+Bh8jBE;IACE,WAAA;IACA,gBAAA;IACA,sBAAA;IACA,aAAA;IACA,sBAAA;E/Bk8jBJ;E+B57jBI;IACE,cAAA;E/B87jBN;E+B37jBI;IACE,WAAA;IACA,uBAAA;E/B67jBN;AACF;AgC5kkBE;EACE,+BAAA;AhC8kkBJ;AgC1kkBE;EACE,mBAAA;AhC4kkBJ;AgCzkkBE;EACE,+BAAA;AhC2kkBJ;AgCvkkBE;EACE,+BAAA;AhCykkBJ;AgCnkkBM;EACE,+BAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AhCqkkBR;AgCjkkBI;EACE,+BAAA;AhCmkkBN;AgC7jkBE;EACE,wBAAA;AhC+jkBJ;AgC5jkBE;EACE,yBAAA;AhC8jkBJ;;AgCvjkBA;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AhC0jkBF;AgCxjkBE;EAZF;IAaI,gBAAA;EhC2jkBF;AACF;AgCzjkBE;EACE,+BAAA;EACA,2BAAA;AhC2jkBJ;AgCzjkBE;EACE,gCAAA;EACA,2BAAA;AhC2jkBJ;;AgCvjkBA;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AhC0jkBF;AgCxjkBE;EACE,+BAAA;EACA,2BAAA;AhC0jkBJ;AgCxjkBE;EACE,gCAAA;EACA,2BAAA;AhC0jkBJ;;AgCtjkBA;EACE,cAAA;AhCyjkBF;;AgCrjkBA;EACE,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EAEA,mBAAA;AhCujkBF;;AgCpjkBA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AhCujkBF;;AgCpjkBA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,SAAA;EACA,QAAA;EACA,oCAAA;AhCujkBF;AgCrjkBE;EACE,qBAAA;AhCujkBJ;;AgCnjkBA;EACE,eAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,4BAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,SAAA;EACA,oBAAA;EACA,+BAAA;EACA,kDAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,wBAAA;EACA,qBAAA;EACA,uBAAA;EACA,0DAAA;EACA,4BAAA;EACA,wCAAA;EACA,6BAAA;AhCqjkBF;AgCnjkBE;EACE,yBAAA;EACA,2BAAA;EACA,eAAA;AhCqjkBJ;AgCljkBE;EACE,4BAAA;AhCojkBJ;AgCljkBE;EACE,4BAAA;AhCojkBJ;AgCljkBE;EACE,4BAAA;AhCojkBJ;AgCjjkBE;EACE,aAAA;AhCmjkBJ;AgChjkBE;EACE,wCAAA;AhCkjkBJ;AgChjkBI;EACE,oCAAA;AhCkjkBN;AgChjkBI;EACE,oCAAA;AhCkjkBN;;AgC5ikBA;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AhC+ikBF;AgC7ikBE;EACE,eAAA;EACA,2BAAA;AhC+ikBJ;AgC7ikBI;EACE,gBAAA;EACA,SAAA;AhC+ikBN;AgC3ikBE;EACE,eAAA;AhC6ikBJ;AgC1ikBE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;AhC4ikBJ;AgC1ikBI;EACE,mBAAA;EACA,oBAAA;EACA,sCAAA;AhC4ikBN;AgCxikBM;EACE,cAAA;EACA,kBAAA;AhC0ikBR;AgCxikBQ;EACE,2BAAA;AhC0ikBV;AgCpikBE;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;AhCsikBJ;AgCpikBI;EACE,2BAAA;AhCsikBN;AgCpikBI;EACE,gCAAA;EACA,4BAAA;AhCsikBN;AgCpikBM;EACE,4BAAA;AhCsikBR;AgCjikBE;EACE,+BAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,0BAAA;AhCmikBJ;AgCjikBI;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,8BAAA;EACA,+BAAA;EACA,0BAAA;EACA,2CAAA;AhCmikBN;AgChikBI;EACE,mBAAA;EACA,eAAA;EACA,+BAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,0BAAA;AhCkikBN;;AgC7hkBA;EACE,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,+BAAA;EACA,kDAAA;EACA,qBAAA;EACA,wBAAA;EACA,WAAA;EACA,eAAA;EACA,uCAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EAEA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AhC+hkBF;AgC7hkBE;EACE,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,+BAAA;EACA,kDAAA;EACA,gBAAA;AhC+hkBJ;AgC5hkBE;EACE,wCAAA;AhC8hkBJ;AgC5hkBI;EACE,oCAAA;AhC8hkBN;AgC5hkBI;EACE,oCAAA;AhC8hkBN;AgC1hkBE;EACE,4BAAA;AhC4hkBJ;AgC1hkBE;EACE,4BAAA;AhC4hkBJ;AgC1hkBE;EACE,uCAAA;AhC4hkBJ;AgCzhkBE;EACE,oBAAA;AhC2hkBJ;AgCxhkBE;EACE,yBAAA;EACA,2BAAA;AhC0hkBJ;AgCxhkBI;EACE,2BAAA;AhC0hkBN;;AgCrhkBA;EACE,kCAAA;EACA,kCAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AhCwhkBF;AgCthkBE;EACE,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AhCwhkBJ;AgCthkBI;EACE,WAAA;EACA,+BAAA;EACA,2BAAA;AhCwhkBN;AgCrhkBI;EACE,4BAAA;EACA,gDAAA;AhCuhkBN;AgCphkBI;EACE,WAAA;EACA,4BAAA;EACA,gCAAA;AhCshkBN;AgCnhkBI;EACE,oBAAA;AhCqhkBN;AgClhkBI;EACE,qEAAA;EACA,gCAAA;AhCohkBN;AgChhkBE;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;AhCkhkBJ;AgCzgkBI;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,WAAA;EACA,8BAAA;EACA,QAAA;EACA,2BAAA;EACA,kBAAA;EACA,4GAAA;EAEA,WAAA;EACA,YAAA;EACA,cAAA;EACA,0CAAA;AhC0gkBN;AgCvgkBI;EACE,QAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,iCAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AhCygkBN;;AgClgkBE;EACE,wCAAA;AhCqgkBJ;AgCpgkBI;EACE,oCAAA;AhCsgkBN;;AgCjgkBA;EACE,YAAA;EACA,qBAAA;AhCogkBF;AgClgkBE;EACE,gBAAA;EACA,yBAAA;AhCogkBJ;AgCjgkBE;EACE,iBAAA;EACA,gBAAA;AhCmgkBJ;AgCjgkBI;EACE,wBAAA;EACA,mBAAA;AhCmgkBN;AgC//jBE;EACE,wBAAA;EACA,+BAAA;EACA,gCAAA;EACA,mBAAA;AhCigkBJ;AgC9/jBM;EACE,mBAAA;AhCggkBR;AgC5/jBI;EACE,oBAAA;AhC8/jBN;AgC1/jBM;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kDAAA;EACA,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AhC4/jBR;AgCz/jBQ;EACE,aAAA;AhC2/jBV;AgCp/jBI;EACE,wBAAA;EACA,+BAAA;EACA,gCAAA;EACA,oDAAA;EACA,aAAA;EACA,eAAA;EACA,wBAAA;EACA,+BAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;AhCs/jBN;AgCp/jBI;EACI,aAAA;EACA,4BAAA;AhCs/jBR;;AgC9+jBA;EACE,WAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AhCi/jBF;;AgC9+jBA;EACE,oBAAA;AhCi/jBF;AgC/+jBE;EACE,iBAAA;EACA,iBAAA;AhCi/jBJ;AgC/+jBE;EACE,iBAAA;EACA,mBAAA;AhCi/jBJ;AgC/+jBE;EACE,iBAAA;EACA,mBAAA;AhCi/jBJ;AgC/+jBE;EACE,iBAAA;EACA,iBAAA;AhCi/jBJ;AgC/+jBE;EACE,gBAAA;AhCi/jBJ;AgC9+jBE;EACE,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;AhCg/jBJ;AgC7+jBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;AhC++jBJ;AgC7+jBI;EACE,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AhC++jBN;AgC5+jBI;EACE,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AhC8+jBN;AgC1+jBE;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;AhC4+jBJ;AgCz+jBE;EACE,mBAAA;EACA,oBAAA;AhC2+jBJ;AgCp+jBE;EACE,gBAAA;EACA,mBAAA;AhCs+jBJ;AgCn+jBE;EACE,eAAA;EACA,qBAAA;AhCq+jBJ;;AgC79jBI;EACE,wBAAA;EACA,+BAAA;AhCg+jBN;AgC99jBM;EACE,yBAAA;AhCg+jBR;AgC99jBM;EACE,2BAAA;AhCg+jBR;AgC59jBQ;EACE,yBAAA;EACA,kCAAA;AhC89jBV;AgC59jBU;EACE,yBAAA;AhC89jBZ;AgC39jBQ;EACE,+BAAA;EACA,gCAAA;AhC69jBV;AgCt9jBE;EACE,wBAAA;EACA,yBAAA;AhCw9jBJ;AgCt9jBI;EACE,yBAAA;AhCw9jBN;AgCt9jBI;EACE,2BAAA;AhCw9jBN;AgCp9jBM;EACE,yBAAA;EACA,kCAAA;AhCs9jBR;AgCp9jBQ;EACE,yBAAA;AhCs9jBV;AgCn9jBM;EACE,+BAAA;EACA,gCAAA;AhCq9jBR;;AgC/8jBA;EACE,wBAAA;EACA,sBAAA;EACA,WAAA;EACA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,mBAAA;EACA,aAAA;AhCk9jBF;AgC/8jBI;EACE,UAAA;EACA,gBAAA;AhCi9jBN;AgC/8jBM;EACE,UAAA;EACA,gBAAA;AhCi9jBR;AgC98jBU;EACE,uBAAA;AhCg9jBZ;AgC98jBU;EACE,0CAAA;AhCg9jBZ;AgC58jBQ;EACE,UAAA;AhC88jBV;AgCx8jBE;EACE,qFAAA;EACA,YAAA;AhC08jBJ;AgCt8jBI;EACE,mBAAA;EACA,0CAAA;AhCw8jBN;AgCp8jBE;EACE,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gCAAA;EAEA,aAAA;EACA,8BAAA;EACA,sCAAA;AhCq8jBJ;AgCj8jBI;EACE,aAAA;EACA,WAAA;EACA,mCAAA;EACA,qBAAA;EACA,8BAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;AhCm8jBN;AgCj8jBM;EACE,gBAAA;AhCm8jBR;AgCh8jBM;EACE,UAAA;AhCk8jBR;AgC/7jBM;EACE,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;AhCi8jBR;;AgC37jBA;EAUY;IACE,uBAAA;EhCq7jBZ;EgC95jBE;IACE,aAAA;EhCg6jBJ;EgC55jBI;IACE,qBAAA;EhC85jBN;AACF;AgC54jBA;EACE,wCAAA;AhC84jBF;AgC54jBE;EACE,oCAAA;AhC84jBJ;AgC54jBE;EACE,oCAAA;AhC84jBJ;;AiCxxlBA;EAAU,0BAAA;AjC4xlBV;;AiC3xlBA;EAAU,2BAAA;AjC+xlBV;;AiC5xlBA;EAAc,2BAAA;AjCgylBd;;AiC/xlBA;EAAc,4BAAA;AjCmylBd;;AiCjylBA;EAAU,uBAAA;AjCqylBV;;AiCpylBA;EAAU,wBAAA;AjCwylBV;;AiCtylBA;EACE,iCAAA;AjCyylBF;;AiCtylBA;EACE,wBAAA;AjCyylBF;;AiCvylBA;EACE,wBAAA;AjC0ylBF;;AiCxylBA;EACE,YAAA;AjC2ylBF;;AiCzylBA;EACE,WAAA;AjC4ylBF;;AiC1ylBA;EACE,YAAA;AjC6ylBF;;AiC3ylBA;EACE,SAAA;AjC8ylBF;;AiC5ylBA;EACE,YAAA;AjC+ylBF;;AiC7ylBA;EACE,WAAA;AjCgzlBF;;AiC7ylBA;EACE,+BAAA;AjCgzlBF;;AiC7ylBA;EACE,8BAAA;AjCgzlBF;;AiC7ylBA;EACE,kCAAA;AjCgzlBF;;AiC7ylBA;EACE,yCAAA;AjCgzlBF;;AiC7ylBA;EACE,sCAAA;AjCgzlBF;;AiC7ylBA;EACE,oCAAA;AjCgzlBF;;AiC7ylBA;EACE,wBAAA;EACA,2BAAA;AjCgzlBF;;AiC9ylBA;EACE,8BAAA;EACA,iCAAA;AjCizlBF;;AiC/ylBA;EACE,6BAAA;EACA,gCAAA;AjCkzlBF;;AiChzlBA;EACE,2BAAA;EACA,8BAAA;AjCmzlBF;;AiCjzlBA;EACE,6BAAA;EACA,gCAAA;AjCozlBF;;AiClzlBA;EACE,2BAAA;EACA,8BAAA;AjCqzlBF;;AiCjzlBA;EACE,0BAAA;EACA,yBAAA;AjCozlBF;;AiClzlBA;EACE,gCAAA;EACA,+BAAA;AjCqzlBF;;AiCnzlBA;EACE,+BAAA;EACA,8BAAA;AjCszlBF;;AiCpzlBA;EACE,6BAAA;EACA,4BAAA;AjCuzlBF;;AiCrzlBA;EACE,+BAAA;EACA,8BAAA;AjCwzlBF;;AiCtzlBA;EACE,6BAAA;EACA,4BAAA;AjCyzlBF;;AiCrzlBA;EACE,yBAAA;EACA,4BAAA;AjCwzlBF;;AiCtzlBA;EACE,+BAAA;EACA,kCAAA;AjCyzlBF;;AiCvzlBA;EACE,8BAAA;EACA,iCAAA;AjC0zlBF;;AiCxzlBA;EACE,4BAAA;EACA,+BAAA;AjC2zlBF;;AiCzzlBA;EACE,8BAAA;EACA,iCAAA;AjC4zlBF;;AiC1zlBA;EACE,4BAAA;EACA,+BAAA;AjC6zlBF;;AiCzzlBA;EACE,2BAAA;EACA,0BAAA;AjC4zlBF;;AiC1zlBA;EACE,iCAAA;EACA,gCAAA;AjC6zlBF;;AiC3zlBA;EACE,gCAAA;EACA,+BAAA;AjC8zlBF;;AiC5zlBA;EACE,8BAAA;EACA,6BAAA;AjC+zlBF;;AiC7zlBA;EACE,gCAAA;EACA,+BAAA;AjCg0lBF;;AiC9zlBA;EACE,8BAAA;EACA,6BAAA;AjCi0lBF;;AiC/zlBA;EACE,gBAAA;AjCk0lBF;;AiCh0lBA;EACE,eAAA;AjCm0lBF;;AiCj0lBA;EACE,aAAA;AjCo0lBF;;AiCl0lBA;EACE,eAAA;AjCq0lBF;;AiCn0lBA;EACE,eAAA;AjCs0lBF;;AiCp0lBA;EACE,UAAA;AjCu0lBF;;AiCp0lBA;EACE,eAAA;AjCu0lBF;;AiCr0lBA;EACE,cAAA;AjCw0lBF;;AiCt0lBA;EACE,YAAA;AjCy0lBF;;AiCv0lBA;EACE,cAAA;AjC00lBF;;AiCx0lBA;EACE,cAAA;AjC20lBF;;AiCz0lBA;EACE,SAAA;AjC40lBF;;AiCx0lBA;EACE,2BAAA;AjC20lBF;;AiCz0lBA;EACE,iCAAA;AjC40lBF;;AiC10lBA;EACE,gCAAA;AjC60lBF;;AiC30lBA;EACE,8BAAA;AjC80lBF;;AiC50lBA;EACE,gCAAA;AjC+0lBF;;AiC70lBA;EACE,8BAAA;AjCg1lBF;;AiC50lBA;EACE,wBAAA;AjC+0lBF;;AiC70lBA;EACE,8BAAA;AjCg1lBF;;AiC90lBA;EACE,6BAAA;AjCi1lBF;;AiC/0lBA;EACE,2BAAA;AjCk1lBF;;AiCh1lBA;EACE,6BAAA;AjCm1lBF;;AiCj1lBA;EACE,2BAAA;AjCo1lBF;;AiCh1lBA;EACE,wBAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;AjCm1lBF;;AiCj1lBA;EACE,0BAAA;AjCo1lBF;;AiCl1lBA;EACE,gCAAA;AjCq1lBF;;AiCn1lBA;EACE,+BAAA;AjCs1lBF;;AiCp1lBA;EACE,6BAAA;AjCu1lBF;;AiCr1lBA;EACE,+BAAA;AjCw1lBF;;AiCt1lBA;EACE,6BAAA;AjCy1lBF;;AiCr1lBA;EACE,yBAAA;AjCw1lBF;;AiCt1lBA;EACE,+BAAA;AjCy1lBF;;AiCv1lBA;EACE,8BAAA;AjC01lBF;;AiCx1lBA;EACE,4BAAA;AjC21lBF;;AiCz1lBA;EACE,8BAAA;AjC41lBF;;AiC11lBA;EACE,4BAAA;AjC61lBF;;AiCz1lBA;EACE,4BAAA;AjC41lBF;;AiC11lBA;EACE,kCAAA;AjC61lBF;;AiC31lBA;EACE,iCAAA;AjC81lBF;;AiC51lBA;EACE,+BAAA;AjC+1lBF;;AiC71lBA;EACE,iCAAA;AjCg2lBF;;AiC91lBA;EACE,+BAAA;AjCi2lBF;;AiC91lBA;EACE,iBAAA;AjCi2lBF;;AiC/1lBA;EACE,kBAAA;AjCk2lBF;;AiCh2lBA;EACE,iBAAA;EACA,kBAAA;AjCm2lBF;;AiCj2lBA;EACE,yBAAA;AjCo2lBF;;AiCl2lBA;EACE,+BAAA;AjCq2lBF;;AiCn2lBA;EACE,8BAAA;AjCs2lBF;;AiCp2lBA;EACE,4BAAA;AjCu2lBF;;AiCr2lBA;EACE,8BAAA;AjCw2lBF;;AiCt2lBA;EACE,4BAAA;AjCy2lBF;;AiCr2lBA;EACE,2BAAA;AjCw2lBF;;AiCt2lBA;EACE,iCAAA;AjCy2lBF;;AiCv2lBA;EACE,gCAAA;AjC02lBF;;AiCx2lBA;EACE,8BAAA;AjC22lBF;;AiCz2lBA;EACE,gCAAA;AjC42lBF;;AiC12lBA;EACE,8BAAA;AjC62lBF;;AiCz2lBA;EACE,0BAAA;AjC42lBF;;AiC12lBA;EACE,gCAAA;AjC62lBF;;AiC32lBA;EACE,+BAAA;AjC82lBF;;AiC52lBA;EACE,6BAAA;AjC+2lBF;;AiC72lBA;EACE,+BAAA;AjCg3lBF;;AiC92lBA;EACE,6BAAA;AjCi3lBF;;AiC72lBA;EACE,6BAAA;AjCg3lBF;;AiC72lBA;EACE,6BAAA;AjCg3lBF;;AiC72lBA;EACE,wBAAA;AjCg3lBF;;AiC92lBA;EACE,wBAAA;AjCi3lBF;;AiC/2lBA;EACE,YAAA;AjCk3lBF;;AiCh3lBA;EACE,WAAA;AjCm3lBF;;AiCj3lBA;EACE,YAAA;AjCo3lBF;;AiCl3lBA;EACE,SAAA;AjCq3lBF;;AiCn3lBA;EACE,YAAA;AjCs3lBF;;AiCp3lBA;EACE,WAAA;AjCu3lBF;;AiCp3lBA;EACE,+BAAA;AjCu3lBF;;AiCp3lBA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;AjCu3lBF;;AiCp3lBA;EACE,kBAAA;AjCu3lBF;;AiCp3lBA;EACE,eAAA;AjCu3lBF;;AiCp3lBA;EACE,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,mCAAA;AjCu3lBF;;AiCp3lBA;EACE,cAAA;EACA,gBAAA;AjCu3lBF;;AiCh3lBA;EACE,cAAA;EACA,qBAAA;EACA,kCAAA;AjCm3lBF;AiCj3lBE;EACE,qBAAA;AjCm3lBJ;;AiC/2lBA;EAAuB,8BAAA;AjCm3lBvB;;AiCl3lBA;EAAuB,iCAAA;AjCs3lBvB;;AiCr3lBA;EAAuB,sCAAA;AjCy3lBvB;;AiCx3lBA;EAAuB,yCAAA;AjC43lBvB;;AiC13lBA;EAAqB,0BAAA;AjC83lBrB;;AiC73lBA;EAAqB,4BAAA;AjCi4lBrB;;AiCh4lBA;EAAqB,kCAAA;AjCo4lBrB;;AiCn4lBA;EAAqB,yBAAA;AjCu4lBrB;;AiCr4lBA;EAA2B,sCAAA;AjCy4lB3B;;AiCx4lBA;EAA2B,oCAAA;AjC44lB3B;;AiC34lBA;EAA2B,kCAAA;AjC+4lB3B;;AiC94lBA;EAA2B,yCAAA;AjCk5lB3B;;AiCj5lBA;EAA2B,wCAAA;AjCq5lB3B;;AiCn5lBA;EAAwB,kCAAA;AjCu5lBxB;;AiCt5lBA;EAAwB,gCAAA;AjC05lBxB;;AiCz5lBA;EAAwB,8BAAA;AjC65lBxB;;AiC55lBA;EAAwB,gCAAA;AjCg6lBxB;;AiC/5lBA;EAAwB,+BAAA;AjCm6lBxB;;AiCj6lBA;EAAyB,oCAAA;AjCq6lBzB;;AiCp6lBA;EAAyB,kCAAA;AjCw6lBzB;;AiCv6lBA;EAAyB,gCAAA;AjC26lBzB;;AiC16lBA;EAAyB,uCAAA;AjC86lBzB;;AiC76lBA;EAAyB,sCAAA;AjCi7lBzB;;AiCh7lBA;EAAyB,iCAAA;AjCo7lBzB;;AiCl7lBA;EAAuB,2BAAA;AjCs7lBvB;;AiCr7lBA;EAAuB,iCAAA;AjCy7lBvB;;AiCx7lBA;EAAuB,+BAAA;AjC47lBvB;;AiC37lBA;EAAuB,6BAAA;AjC+7lBvB;;AiC97lBA;EAAuB,+BAAA;AjCk8lBvB;;AiCj8lBA;EAAuB,8BAAA;AjCq8lBvB;;AiCn8lBA;EACE,sBAAA;AjCs8lBF;;AiCp8lBA;EACE,sBAAA;AjCu8lBF;;AkCv7mBA;EACI,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EAEA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EAEA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EAEA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AlCm7mBJ;;AkCh7mBA;EACE,cAAA;EACA,iBAAA;AlCm7mBF;;AkCj7mBA;EACE,cAAA;EACA,iBAAA;AlCo7mBF;;AkCl7mBA;EACE,cAAA;EACA,iBAAA;AlCq7mBF;;AkCn7mBA;EACE,cAAA;EACA,iBAAA;AlCs7mBF;;AkCp7mBA;EACE,cAAA;EACA,iBAAA;AlCu7mBF;;AkCr7mBA;EACE,cAAA;EACA,iBAAA;AlCw7mBF;;AkCt7mBA;EACE,cAAA;EACA,iBAAA;AlCy7mBF;;AkCv7mBA;EACE,cAAA;EACA,iBAAA;AlC07mBF;;AkCx7mBA;EACE,cAAA;EACA,iBAAA;AlC27mBF;;AkCz7mBA;EACE,cAAA;EACA,iBAAA;AlC47mBF;;AkCz7mBA;EACE,YAAA;EACA,gBAAA;AlC47mBF;;AkCx7mBA;EACE,cAAA;EACA,kBAAA;AlC27mBF;;AkCz7mBA;EACE,cAAA;EACA,kBAAA;AlC47mBF;;AkC17mBA;EACE,cAAA;EACA,kBAAA;AlC67mBF;;AkC37mBA;EACE,cAAA;EACA,kBAAA;AlC87mBF;;AkC57mBA;EACE,cAAA;EACA,kBAAA;AlC+7mBF;;AkC77mBA;EACE,cAAA;EACA,kBAAA;AlCg8mBF;;AkC97mBA;EACE,cAAA;EACA,kBAAA;AlCi8mBF;;AkC/7mBA;EACE,cAAA;EACA,kBAAA;AlCk8mBF;;AkCh8mBA;EACE,cAAA;EACA,kBAAA;AlCm8mBF;;AkCj8mBA;EACE,cAAA;EACA,kBAAA;AlCo8mBF;;AkCh8mBA;EACE,cAAA;EACA,eAAA;AlCm8mBF;;AkCj8mBA;EACE,cAAA;EACA,eAAA;AlCo8mBF;;AkCl8mBA;EACE,cAAA;EACA,eAAA;AlCq8mBF;;AkCn8mBA;EACE,cAAA;EACA,eAAA;AlCs8mBF;;AkCp8mBA;EACE,cAAA;EACA,eAAA;AlCu8mBF;;AkCr8mBA;EACE,cAAA;EACA,eAAA;AlCw8mBF;;AkCt8mBA;EACE,cAAA;EACA,eAAA;AlCy8mBF;;AkCv8mBA;EACE,cAAA;EACA,eAAA;AlC08mBF;;AkCx8mBA;EACE,cAAA;EACA,eAAA;AlC28mBF;;AkCz8mBA;EACE,cAAA;EACA,eAAA;AlC48mBF;;AkCx8mBA;EACE,cAAA;EACA,kBAAA;AlC28mBF;;AkCz8mBA;EACE,cAAA;EACA,kBAAA;AlC48mBF;;AkC18mBA;EACE,cAAA;EACA,kBAAA;AlC68mBF;;AkC38mBA;EACE,cAAA;EACA,kBAAA;AlC88mBF;;AkC58mBA;EACE,cAAA;EACA,kBAAA;AlC+8mBF;;AkC78mBA;EACE,cAAA;EACA,kBAAA;AlCg9mBF;;AkC98mBA;EACE,cAAA;EACA,kBAAA;AlCi9mBF;;AkC/8mBA;EACE,cAAA;EACA,kBAAA;AlCk9mBF;;AkCh9mBA;EACE,cAAA;EACA,kBAAA;AlCm9mBF;;AkCj9mBA;EACE,cAAA;EACA,kBAAA;AlCo9mBF;;AkC/8mBA;EACE,cAAA;EACA,iBAAA;AlCk9mBF;;AkCh9mBA;EACE,cAAA;EACA,iBAAA;AlCm9mBF;;AkCj9mBA;EACE,cAAA;EACA,iBAAA;AlCo9mBF;;AkCl9mBA;EACE,cAAA;EACA,iBAAA;AlCq9mBF;;AkCn9mBA;EACE,cAAA;EACA,iBAAA;AlCs9mBF;;AkCp9mBA;EACE,cAAA;EACA,iBAAA;AlCu9mBF;;AkCr9mBA;EACE,cAAA;EACA,iBAAA;AlCw9mBF;;AkCt9mBA;EACE,cAAA;EACA,iBAAA;AlCy9mBF;;AkCv9mBA;EACE,cAAA;EACA,iBAAA;AlC09mBF;;AkCx9mBA;EACE,cAAA;EACA,iBAAA;AlC29mBF;;AkCt9mBA;EACE,oBAAA;EACA,kBAAA;EACA,oBAAA;AlCy9mBF;;AkCt9mBA;EACE,gBAAA;EACA,kBAAA;AlCy9mBF;;AkCv9mBA;EACE,gBAAA;EACA,gBAAA;AlC09mBF;;AkCt9mBA;EACE,eAAA;EACA,iBAAA;AlCy9mBF;;AkCv9mBA;EACE,eAAA;EACA,iBAAA;AlC09mBF;;AkCx9mBA;EACE,eAAA;EACA,iBAAA;AlC29mBF;;AkCz9mBA;EACE,eAAA;EACA,iBAAA;AlC49mBF;;AkC19mBA;EACE,eAAA;EACA,iBAAA;AlC69mBF;;AkC39mBA;EACE,eAAA;EACA,iBAAA;AlC89mBF;;AkC59mBA;EACE,eAAA;EACA,iBAAA;AlC+9mBF;;AkC79mBA;EACE,eAAA;EACA,iBAAA;AlCg+mBF;;AA1znBA;EACE,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;AA6znBF;AA3znBE;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,2BAAA;EACA,eAAA;EACA,mCAAA;EACA,kCAAA;AA6znBJ;AA3znBI;EACE,cAAA;AA6znBN;AAzznBM;EACE,2BAAA;EACA,qBAAA;AA2znBR;;AArznBA;EACE,iCAAA;EACA,kBAAA;AAwznBF;AAtznBE;EACE,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAwznBJ;;AApznBA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAuznBF;;AAnznBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,sBAAA;AAsznBJ;AAnznBE;EACE,cAAA;AAqznBJ;;AAjznBA;EACE,qBAAA;AAoznBF;;AA/ynBE;EACE,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AAkznBJ;AA/ynBE;EACE,eAAA;AAiznBJ;AA9ynBE;EACE,gBAAA;AAgznBJ","sourcesContent":["@import \"../../assets/scss/bootstrap\";\n@import '../../assets/NEW/font';\n@import '../../assets/NEW/basic';\n@import '../../assets/NEW/screen';\n@import \"../../assets/NEW/fields\";\n@import '../../assets/NEW/sizing';\n@import \"../dashboard/styles.scss\";\n@import \"../../../node_modules/@paylixecommerce/shared/dist/cjs/assets/style.css\";\n\nhtml {\n  width: 100vw;\n  overflow-x: hidden;\n  background-color: white;\n  margin-left: 0;\n\n  body {\n    min-width: 100vw;\n    max-width: 100vw;\n    overflow-x: hidden;\n    font-family: \"Inter\", sans-serif !important;\n    transition: background .9s;\n    font-size: 14px;\n    -webkit-font-smoothing: antialiased;\n    background-color: white !important;\n\n    button.large {\n      height: 2.5rem;\n    }\n\n    a {\n      &:hover {\n        transition: color .3s ease;\n        color: var(--purple9);\n      }\n    }\n  }\n}\n\n.main {\n  transition: margin-left .3s ease;\n  margin-left: 240px;\n\n  .container {\n    max-width: 1280px;\n    width: 100%;\n    padding-right: 15px;\n    padding-left: 15px;\n    margin-right: auto;\n    margin-left: auto;\n  }\n}\n\n#app>div:not(.Toastify) {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n#app > div {\n  .auth-screen {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 1 0 auto;\n    background: var(--black0);\n    padding: 5rem 0 4rem 0;\n    overflow: auto;\n    flex-direction: column;\n  }\n\n  footer {\n    flex-shrink: 0;\n  }\n}\n\na {\n  color: var(--purple6);\n}\n\n\nhtml {\n  *, :before, :after {\n    box-sizing: border-box;\n    border-width: 0;\n    border-style: solid;\n    border-color: transparent;\n  }\n\n  img, svg {\n    display: inline;\n  }\n\n  .table {\n    display: initial;\n  }\n\n}\n","/*!\n * Bootstrap v5.0.2 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n\n// scss-docs-start import-stack\n// Configuration\n@import \"functions\";\n@import \"variables\";\n@import \"utilities\";\n\n// Layout & components\n@import \"root\";\n@import \"reboot\";\n@import \"type\";\n@import \"buttons\";\n@import \"transitions\";\n@import \"button-group\";\n@import \"pagination\";\n@import \"spinners\";\n",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$variable-prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$variable-prefix}#{$color}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$variable-prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$variable-prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$variable-prefix}gradient: #{$gradient};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  font-size: $font-size-root;\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\nbody {\n  margin: 0;\n  font-family: $font-family-base;\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: $body-text-align;\n  background-color: $body-bg;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba($black, 0);\n}\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n// 2. Set correct height and prevent the `size` attribute to make the `hr` look like an input field\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  background-color: currentColor;\n  border: 0;\n  opacity: $hr-opacity;\n}\n\nhr:not([size]) {\n  height: $hr-height; // 2\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1 {\n  @extend %heading;\n}\n\nh2 {\n  @extend %heading;\n}\n\nh3 {\n  @extend %heading;\n}\n\nh4 {\n  @extend %heading;\n}\n\nh5 {\n  @extend %heading;\n}\n\nh6 {\n  @extend %heading;\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-bs-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-bs-original-title] { // 1\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  text-decoration-skip-ink: none; // 4\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  direction: ltr #{\"/* rtl:ignore */\"};\n  unicode-bidi: bidi-override;\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow in Chrome from inputs built with datalists.\n// See https://stackoverflow.com/a/54997118\n\n[list]::-webkit-calendar-picker-indicator {\n  display: none;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. Correct the outline style in Safari.\n// 2. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n\n[type=\"search\"] {\n  outline-offset: -2px; // 1\n  -webkit-appearance: textfield; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n*::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n*::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// Inherit font family and line height for file input buttons\n\n*::file-selector-button {\n  font: inherit;\n}\n\n// 1. Change font properties to `inherit`\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::-webkit-file-upload-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n// fusv-enable\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n$body-text-align:           null !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n$gutters: $spacers !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width * .5 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n\n$border-color:                $gray-300 !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .25rem !default;\n$border-radius-sm:            .2rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$variable-prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$variable-prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n$hr-height:                   $border-width !default;\n$hr-opacity:                  .25 !default;\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    transparent !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba($black, $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba($black, $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba($black, $table-hover-bg-factor) !default;\n\n$table-border-factor:         .1 !default;\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-striped-order:         odd !default;\n\n$table-group-separator-color: currentColor !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         .25rem !default;\n$input-btn-focus-color-opacity: .25 !default;\n$input-btn-focus-color:         rgba($component-active-bg, $input-btn-focus-color-opacity) !default;\n$input-btn-focus-blur:          0 !default;\n$input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              $link-color !default;\n$btn-link-hover-color:        $link-hover-color !default;\n$btn-link-disabled-color:     $gray-600 !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       $text-muted !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           $body-color !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      $box-shadow-inset !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 1px solid rgba($black, .25) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba(0, 0, 0, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $gray-200 !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $border-radius !default;\n$form-select-box-shadow:          $box-shadow-inset !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             $gray-300 !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     $box-shadow-inset !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             $gray-500 !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             $input-group-addon-bg !default;\n$form-file-button-hover-bg:       shade-color($form-file-button-bg, 5%) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:            add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:       1.25 !default;\n$form-floating-padding-x:         $input-padding-x !default;\n$form-floating-padding-y:         1rem !default;\n$form-floating-input-padding-t:   1.625rem !default;\n$form-floating-input-padding-b:   .625rem !default;\n$form-floating-label-opacity:     .65 !default;\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": $form-feedback-valid-color,\n    \"icon\": $form-feedback-icon-valid\n  ),\n  \"invalid\": (\n    \"color\": $form-feedback-invalid-color,\n    \"icon\": $form-feedback-icon-invalid\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-offcanvas:                  1050 !default;\n$zindex-modal:                      1060 !default;\n// scss-docs-end zindex-stack\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    $link-color !default;\n$nav-link-hover-color:              $link-hover-color !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-theme-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .55) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n// scss-docs-end navbar-theme-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               $box-shadow !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         shade-color($gray-900, 10%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-radius:          $border-radius !default;\n$pagination-margin-start:           -$pagination-border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-color:            $link-hover-color !default;\n$pagination-focus-bg:               $gray-200 !default;\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n// scss-docs-end pagination-variables\n\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         $body-color !default;\n$accordion-bg:                            $body-bg !default;\n$accordion-border-width:                  $border-width !default;\n$accordion-border-color:                  rgba($black, .125) !default;\n$accordion-border-radius:                 $border-radius !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  $accordion-color !default;\n$accordion-button-bg:                     $accordion-bg !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%) !default;\n$accordion-button-active-color:           shade-color($primary, 10%) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $accordion-color !default;\n$accordion-icon-active-color:             $accordion-button-active-color !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       $box-shadow-sm !default;\n$modal-content-box-shadow-sm-up:    $box-shadow !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           $border-radius !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            $border-width !default;\n$alert-bg-scale:                -80% !default;\n$alert-border-scale:            -70% !default;\n$alert-color-scale:             40% !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               $box-shadow-inset !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  $gray-900 !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n$list-group-item-bg-scale:          -80% !default;\n$list-group-item-color-scale:       40% !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              $box-shadow-sm !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              $gray-600 !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $input-btn-focus-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                $modal-content-bg !default;\n$offcanvas-color:                   $modal-content-color !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         null !default;\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n\n.initialism {\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  line-height: $btn-line-height;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n\n  &:hover {\n    color: $body-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  .btn-check:focus + &,\n  &:focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  .btn-check:checked + &,\n  .btn-check:active + &,\n  &:active,\n  &.active {\n\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    pointer-events: none;\n    opacity: $btn-disabled-opacity;\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $btn-link-color;\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: $btn-link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n  }\n}\n",".fade {\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n}\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n}\n",".pagination {\n  display: flex;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    color: $pagination-focus-color;\n    background-color: $pagination-focus-bg;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n\n}\n\n","//\n// Rotating border\n//\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentColor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: $spinner-animation-speed linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentColor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: $spinner-animation-speed linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: $spinner-animation-speed * 2;\n    }\n  }\n}\n","/*!\n * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n// Font Awesome core compile (Web Fonts-based)\n// -------------------------\n\n@import 'functions';\n@import 'variables';\n@import 'mixins';\n@import 'core';\n@import 'sizing';\n@import 'fixed-width';\n@import 'list';\n@import 'bordered-pulled';\n@import 'animated';\n@import 'rotated-flipped';\n@import 'stacked';\n@import 'icons';\n@import 'screen-reader';\n","// base icon class definition\n// -------------------------\n\n.#{$fa-css-prefix} {\n  font-family: var(--#{$fa-css-prefix}-style-family, '#{$fa-style-family}');\n  font-weight: var(--#{$fa-css-prefix}-style, #{$fa-style});\n}\n\n.#{$fa-css-prefix},\n.fas,\n.fa-solid,\n.far,\n.fa-regular,\n.fal,\n.fa-light,\n.fat,\n.fa-thin,\n.fad,\n.fa-duotone,\n.fab,\n.fa-brands {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: var(--#{$fa-css-prefix}-display, #{$fa-display});\n  font-style: normal;\n  font-variant: normal;\n  line-height: 1;\n  text-rendering: auto;\n}\n\n%fa-icon {\n  @include fa-icon;\n}\n","// sizing icons\n// -------------------------\n\n// literal magnification scale\n@for $i from 1 through 10 {\n  .#{$fa-css-prefix}-#{$i}x {\n    font-size: $i * 1em;\n  }\n}\n\n// step-based scale (with alignment)\n@each $size, $value in $fa-sizes {\n  .#{$fa-css-prefix}-#{$size} {\n     @include fa-size($value);\n  }\n}\n","// mixins\n// --------------------------\n\n// base rendering for an icon\n@mixin fa-icon {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: normal;\n  line-height: 1;\n}\n\n// sets relative font-sizing and alignment (in _sizing)\n@mixin fa-size ($font-size) {\n  font-size: (divide($font-size, $fa-size-scale-base)) * 1em; // converts step in sizing scale into an em-based value that's relative to the scale's base\n  line-height: (divide(1, $font-size)) * 1em; // sets the line-height of the icon back to that of it's parent\n  vertical-align: ((divide(6, $font-size)) - (divide(3, 8))) * 1em; // vertically centers the icon taking into account the surrounding text's descender\n}\n\n// only display content to screen readers\n// see: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// see: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\n@mixin fa-sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n// use in conjunction with .sr-only to only display content when it's focused\n@mixin fa-sr-only-focusable() {\n  &:not(:focus) {\n    @include fa-sr-only();\n  }\n}\n","// fixed-width icons\n// -------------------------\n\n.#{$fa-css-prefix}-fw {\n  text-align: center;\n  width: $fa-fw-width;\n}\n","// variables\n// --------------------------\n\n$fa-css-prefix          : fa !default;\n$fa-style               : 900 !default;\n$fa-style-family        : \"Font Awesome 6 Pro\" !default;\n\n$fa-display             : inline-block !default;\n\n$fa-fw-width            : (divide(20em, 16));\n$fa-inverse             : #fff !default;\n\n$fa-border-color        : #eee !default;\n$fa-border-padding      : .2em .25em .15em !default;\n$fa-border-radius       : .1em !default;\n$fa-border-style        : solid !default;\n$fa-border-width        : .08em !default;\n\n$fa-size-scale-2xs      : 10 !default;\n$fa-size-scale-xs       : 12 !default;\n$fa-size-scale-sm       : 14 !default;\n$fa-size-scale-base     : 16 !default;\n$fa-size-scale-lg       : 20 !default;\n$fa-size-scale-xl       : 24 !default;\n$fa-size-scale-2xl      : 32 !default;\n\n$fa-sizes: (\n  \"2xs\"                 : $fa-size-scale-2xs,\n  \"xs\"                  : $fa-size-scale-xs,\n  \"sm\"                  : $fa-size-scale-sm,\n  \"lg\"                  : $fa-size-scale-lg,\n  \"xl\"                  : $fa-size-scale-xl,\n  \"2xl\"                 : $fa-size-scale-2xl\n) !default;\n\n$fa-li-width            : 2em !default;\n$fa-li-margin           : ($fa-li-width * divide(5, 4)) !default;\n\n$fa-pull-margin         : .3em !default;\n\n$fa-primary-opacity     : 1 !default;\n$fa-secondary-opacity   : .4 !default;\n\n$fa-stack-vertical-align: middle !default;\n$fa-stack-width         : ($fa-fw-width * 2) !default;\n$fa-stack-z-index       : auto !default;\n\n$fa-font-display        : block !default;\n$fa-font-path           : \"~assets/fontawesome/scss/webfonts\" !default;\n\n// convenience function used to set content property\n@function fa-content($fa-var) {\n  @return unquote(\"\\\"#{ $fa-var }\\\"\");\n}\n\n$fa-var-0: \\30;\n$fa-var-1: \\31;\n$fa-var-2: \\32;\n$fa-var-3: \\33;\n$fa-var-4: \\34;\n$fa-var-5: \\35;\n$fa-var-6: \\36;\n$fa-var-7: \\37;\n$fa-var-8: \\38;\n$fa-var-9: \\39;\n$fa-var-360-degrees: \\e2dc;\n$fa-var-a: \\41;\n$fa-var-abacus: \\f640;\n$fa-var-accent-grave: \\60;\n$fa-var-acorn: \\f6ae;\n$fa-var-address-book: \\f2b9;\n$fa-var-contact-book: \\f2b9;\n$fa-var-address-card: \\f2bb;\n$fa-var-contact-card: \\f2bb;\n$fa-var-vcard: \\f2bb;\n$fa-var-air-conditioner: \\f8f4;\n$fa-var-airplay: \\e089;\n$fa-var-alarm-clock: \\f34e;\n$fa-var-alarm-exclamation: \\f843;\n$fa-var-alarm-plus: \\f844;\n$fa-var-alarm-snooze: \\f845;\n$fa-var-album: \\f89f;\n$fa-var-album-collection: \\f8a0;\n$fa-var-alicorn: \\f6b0;\n$fa-var-alien: \\f8f5;\n$fa-var-alien-8bit: \\f8f6;\n$fa-var-alien-monster: \\f8f6;\n$fa-var-align-center: \\f037;\n$fa-var-align-justify: \\f039;\n$fa-var-align-left: \\f036;\n$fa-var-align-right: \\f038;\n$fa-var-align-slash: \\f846;\n$fa-var-alt: \\e08a;\n$fa-var-amp-guitar: \\f8a1;\n$fa-var-ampersand: \\26;\n$fa-var-anchor: \\f13d;\n$fa-var-angel: \\f779;\n$fa-var-angle: \\e08c;\n$fa-var-angle-90: \\e08d;\n$fa-var-angle-down: \\f107;\n$fa-var-angle-left: \\f104;\n$fa-var-angle-right: \\f105;\n$fa-var-angle-up: \\f106;\n$fa-var-angles-down: \\f103;\n$fa-var-angle-double-down: \\f103;\n$fa-var-angles-left: \\f100;\n$fa-var-angle-double-left: \\f100;\n$fa-var-angles-right: \\f101;\n$fa-var-angle-double-right: \\f101;\n$fa-var-angles-up: \\f102;\n$fa-var-angle-double-up: \\f102;\n$fa-var-ankh: \\f644;\n$fa-var-aperture: \\e2df;\n$fa-var-apostrophe: \\27;\n$fa-var-apple-core: \\e08f;\n$fa-var-apple-whole: \\f5d1;\n$fa-var-apple-alt: \\f5d1;\n$fa-var-archway: \\f557;\n$fa-var-arrow-down: \\f063;\n$fa-var-arrow-down-1-9: \\f162;\n$fa-var-sort-numeric-asc: \\f162;\n$fa-var-sort-numeric-down: \\f162;\n$fa-var-arrow-down-9-1: \\f886;\n$fa-var-sort-numeric-desc: \\f886;\n$fa-var-sort-numeric-down-alt: \\f886;\n$fa-var-arrow-down-a-z: \\f15d;\n$fa-var-sort-alpha-asc: \\f15d;\n$fa-var-sort-alpha-down: \\f15d;\n$fa-var-arrow-down-arrow-up: \\f883;\n$fa-var-sort-alt: \\f883;\n$fa-var-arrow-down-big-small: \\f88c;\n$fa-var-sort-size-down: \\f88c;\n$fa-var-arrow-down-from-dotted-line: \\e090;\n$fa-var-arrow-down-from-line: \\f345;\n$fa-var-arrow-from-top: \\f345;\n$fa-var-arrow-down-left: \\e091;\n$fa-var-arrow-down-left-and-arrow-up-right-to-center: \\e092;\n$fa-var-arrow-down-long: \\f175;\n$fa-var-long-arrow-down: \\f175;\n$fa-var-arrow-down-right: \\e093;\n$fa-var-arrow-down-short-wide: \\f884;\n$fa-var-sort-amount-desc: \\f884;\n$fa-var-sort-amount-down-alt: \\f884;\n$fa-var-arrow-down-small-big: \\f88d;\n$fa-var-sort-size-down-alt: \\f88d;\n$fa-var-arrow-down-square-triangle: \\f889;\n$fa-var-sort-shapes-down-alt: \\f889;\n$fa-var-arrow-down-to-bracket: \\e094;\n$fa-var-arrow-down-to-dotted-line: \\e095;\n$fa-var-arrow-down-to-line: \\f33d;\n$fa-var-arrow-to-bottom: \\f33d;\n$fa-var-arrow-down-to-square: \\e096;\n$fa-var-arrow-down-triangle-square: \\f888;\n$fa-var-sort-shapes-down: \\f888;\n$fa-var-arrow-down-wide-short: \\f160;\n$fa-var-sort-amount-asc: \\f160;\n$fa-var-sort-amount-down: \\f160;\n$fa-var-arrow-down-z-a: \\f881;\n$fa-var-sort-alpha-desc: \\f881;\n$fa-var-sort-alpha-down-alt: \\f881;\n$fa-var-arrow-left: \\f060;\n$fa-var-arrow-left-from-line: \\f344;\n$fa-var-arrow-from-right: \\f344;\n$fa-var-arrow-left-long: \\f177;\n$fa-var-long-arrow-left: \\f177;\n$fa-var-arrow-left-long-to-line: \\e3d4;\n$fa-var-arrow-left-to-line: \\f33e;\n$fa-var-arrow-to-left: \\f33e;\n$fa-var-arrow-pointer: \\f245;\n$fa-var-mouse-pointer: \\f245;\n$fa-var-arrow-right: \\f061;\n$fa-var-arrow-right-arrow-left: \\f0ec;\n$fa-var-exchange: \\f0ec;\n$fa-var-arrow-right-from-bracket: \\f08b;\n$fa-var-sign-out: \\f08b;\n$fa-var-arrow-right-from-line: \\f343;\n$fa-var-arrow-from-left: \\f343;\n$fa-var-arrow-right-long: \\f178;\n$fa-var-long-arrow-right: \\f178;\n$fa-var-arrow-right-long-to-line: \\e3d5;\n$fa-var-arrow-right-to-bracket: \\f090;\n$fa-var-sign-in: \\f090;\n$fa-var-arrow-right-to-line: \\f340;\n$fa-var-arrow-to-right: \\f340;\n$fa-var-arrow-rotate-left: \\f0e2;\n$fa-var-arrow-left-rotate: \\f0e2;\n$fa-var-arrow-rotate-back: \\f0e2;\n$fa-var-arrow-rotate-backward: \\f0e2;\n$fa-var-undo: \\f0e2;\n$fa-var-arrow-rotate-right: \\f01e;\n$fa-var-arrow-right-rotate: \\f01e;\n$fa-var-arrow-rotate-forward: \\f01e;\n$fa-var-redo: \\f01e;\n$fa-var-arrow-trend-down: \\e097;\n$fa-var-arrow-trend-up: \\e098;\n$fa-var-arrow-turn-down: \\f149;\n$fa-var-level-down: \\f149;\n$fa-var-arrow-turn-down-left: \\e2e1;\n$fa-var-arrow-turn-down-right: \\e3d6;\n$fa-var-arrow-turn-up: \\f148;\n$fa-var-level-up: \\f148;\n$fa-var-arrow-up: \\f062;\n$fa-var-arrow-up-1-9: \\f163;\n$fa-var-sort-numeric-up: \\f163;\n$fa-var-arrow-up-9-1: \\f887;\n$fa-var-sort-numeric-up-alt: \\f887;\n$fa-var-arrow-up-a-z: \\f15e;\n$fa-var-sort-alpha-up: \\f15e;\n$fa-var-arrow-up-arrow-down: \\e099;\n$fa-var-sort-up-down: \\e099;\n$fa-var-arrow-up-big-small: \\f88e;\n$fa-var-sort-size-up: \\f88e;\n$fa-var-arrow-up-from-bracket: \\e09a;\n$fa-var-arrow-up-from-dotted-line: \\e09b;\n$fa-var-arrow-up-from-line: \\f342;\n$fa-var-arrow-from-bottom: \\f342;\n$fa-var-arrow-up-from-square: \\e09c;\n$fa-var-arrow-up-left: \\e09d;\n$fa-var-arrow-up-left-from-circle: \\e09e;\n$fa-var-arrow-up-long: \\f176;\n$fa-var-long-arrow-up: \\f176;\n$fa-var-arrow-up-right: \\e09f;\n$fa-var-arrow-up-right-and-arrow-down-left-from-center: \\e0a0;\n$fa-var-arrow-up-right-from-square: \\f08e;\n$fa-var-external-link: \\f08e;\n$fa-var-arrow-up-short-wide: \\f885;\n$fa-var-sort-amount-up-alt: \\f885;\n$fa-var-arrow-up-small-big: \\f88f;\n$fa-var-sort-size-up-alt: \\f88f;\n$fa-var-arrow-up-square-triangle: \\f88b;\n$fa-var-sort-shapes-up-alt: \\f88b;\n$fa-var-arrow-up-to-dotted-line: \\e0a1;\n$fa-var-arrow-up-to-line: \\f341;\n$fa-var-arrow-to-top: \\f341;\n$fa-var-arrow-up-triangle-square: \\f88a;\n$fa-var-sort-shapes-up: \\f88a;\n$fa-var-arrow-up-wide-short: \\f161;\n$fa-var-sort-amount-up: \\f161;\n$fa-var-arrow-up-z-a: \\f882;\n$fa-var-sort-alpha-up-alt: \\f882;\n$fa-var-arrows-cross: \\e0a2;\n$fa-var-arrows-from-dotted-line: \\e0a3;\n$fa-var-arrows-from-line: \\e0a4;\n$fa-var-arrows-left-right: \\f07e;\n$fa-var-arrows-h: \\f07e;\n$fa-var-arrows-maximize: \\f31d;\n$fa-var-expand-arrows: \\f31d;\n$fa-var-arrows-minimize: \\e0a5;\n$fa-var-compress-arrows: \\e0a5;\n$fa-var-arrows-repeat: \\f364;\n$fa-var-repeat-alt: \\f364;\n$fa-var-arrows-repeat-1: \\f366;\n$fa-var-repeat-1-alt: \\f366;\n$fa-var-arrows-retweet: \\f361;\n$fa-var-retweet-alt: \\f361;\n$fa-var-arrows-rotate: \\f021;\n$fa-var-refresh: \\f021;\n$fa-var-sync: \\f021;\n$fa-var-arrows-to-dotted-line: \\e0a6;\n$fa-var-arrows-to-line: \\e0a7;\n$fa-var-arrows-up-down: \\f07d;\n$fa-var-arrows-v: \\f07d;\n$fa-var-arrows-up-down-left-right: \\f047;\n$fa-var-arrows: \\f047;\n$fa-var-asterisk: \\2a;\n$fa-var-at: \\40;\n$fa-var-atom: \\f5d2;\n$fa-var-atom-simple: \\f5d3;\n$fa-var-atom-alt: \\f5d3;\n$fa-var-audio-description: \\f29e;\n$fa-var-audio-description-slash: \\e0a8;\n$fa-var-austral-sign: \\e0a9;\n$fa-var-avocado: \\e0aa;\n$fa-var-award: \\f559;\n$fa-var-award-simple: \\e0ab;\n$fa-var-axe: \\f6b2;\n$fa-var-axe-battle: \\f6b3;\n$fa-var-b: \\42;\n$fa-var-baby: \\f77c;\n$fa-var-baby-carriage: \\f77d;\n$fa-var-carriage-baby: \\f77d;\n$fa-var-backpack: \\f5d4;\n$fa-var-backward: \\f04a;\n$fa-var-backward-fast: \\f049;\n$fa-var-fast-backward: \\f049;\n$fa-var-backward-step: \\f048;\n$fa-var-step-backward: \\f048;\n$fa-var-bacon: \\f7e5;\n$fa-var-bacteria: \\e059;\n$fa-var-bacterium: \\e05a;\n$fa-var-badge: \\f335;\n$fa-var-badge-check: \\f336;\n$fa-var-badge-dollar: \\f645;\n$fa-var-badge-percent: \\f646;\n$fa-var-badge-sheriff: \\f8a2;\n$fa-var-badger-honey: \\f6b4;\n$fa-var-badminton: \\e33a;\n$fa-var-bag-shopping: \\f290;\n$fa-var-shopping-bag: \\f290;\n$fa-var-bagel: \\e3d7;\n$fa-var-bags-shopping: \\f847;\n$fa-var-baguette: \\e3d8;\n$fa-var-bahai: \\f666;\n$fa-var-baht-sign: \\e0ac;\n$fa-var-ball-pile: \\f77e;\n$fa-var-balloon: \\e2e3;\n$fa-var-balloons: \\e2e4;\n$fa-var-ballot: \\f732;\n$fa-var-ballot-check: \\f733;\n$fa-var-ban: \\f05e;\n$fa-var-cancel: \\f05e;\n$fa-var-ban-bug: \\f7f9;\n$fa-var-debug: \\f7f9;\n$fa-var-ban-parking: \\f616;\n$fa-var-parking-circle-slash: \\f616;\n$fa-var-ban-smoking: \\f54d;\n$fa-var-smoking-ban: \\f54d;\n$fa-var-banana: \\e2e5;\n$fa-var-bandage: \\f462;\n$fa-var-band-aid: \\f462;\n$fa-var-bangladeshi-taka-sign: \\e2e6;\n$fa-var-banjo: \\f8a3;\n$fa-var-bank: \\f19c;\n$fa-var-institution: \\f19c;\n$fa-var-university: \\f19c;\n$fa-var-barcode: \\f02a;\n$fa-var-barcode-read: \\f464;\n$fa-var-barcode-scan: \\f465;\n$fa-var-bars: \\f0c9;\n$fa-var-navicon: \\f0c9;\n$fa-var-bars-filter: \\e0ad;\n$fa-var-bars-progress: \\f828;\n$fa-var-tasks-alt: \\f828;\n$fa-var-bars-sort: \\e0ae;\n$fa-var-bars-staggered: \\f550;\n$fa-var-reorder: \\f550;\n$fa-var-stream: \\f550;\n$fa-var-baseball: \\f433;\n$fa-var-baseball-ball: \\f433;\n$fa-var-baseball-bat-ball: \\f432;\n$fa-var-basket-shopping: \\f291;\n$fa-var-shopping-basket: \\f291;\n$fa-var-basket-shopping-simple: \\e0af;\n$fa-var-shopping-basket-alt: \\e0af;\n$fa-var-basketball: \\f434;\n$fa-var-basketball-ball: \\f434;\n$fa-var-basketball-hoop: \\f435;\n$fa-var-bat: \\f6b5;\n$fa-var-bath: \\f2cd;\n$fa-var-bathtub: \\f2cd;\n$fa-var-battery-bolt: \\f376;\n$fa-var-battery-empty: \\f244;\n$fa-var-battery-0: \\f244;\n$fa-var-battery-exclamation: \\e0b0;\n$fa-var-battery-full: \\f240;\n$fa-var-battery: \\f240;\n$fa-var-battery-5: \\f240;\n$fa-var-battery-half: \\f242;\n$fa-var-battery-3: \\f242;\n$fa-var-battery-low: \\e0b1;\n$fa-var-battery-1: \\e0b1;\n$fa-var-battery-quarter: \\f243;\n$fa-var-battery-2: \\f243;\n$fa-var-battery-slash: \\f377;\n$fa-var-battery-three-quarters: \\f241;\n$fa-var-battery-4: \\f241;\n$fa-var-bed: \\f236;\n$fa-var-bed-bunk: \\f8f8;\n$fa-var-bed-empty: \\f8f9;\n$fa-var-bed-front: \\f8f7;\n$fa-var-bed-alt: \\f8f7;\n$fa-var-bed-pulse: \\f487;\n$fa-var-procedures: \\f487;\n$fa-var-bee: \\e0b2;\n$fa-var-beer-mug: \\e0b3;\n$fa-var-beer-foam: \\e0b3;\n$fa-var-beer-mug-empty: \\f0fc;\n$fa-var-beer: \\f0fc;\n$fa-var-bell: \\f0f3;\n$fa-var-bell-concierge: \\f562;\n$fa-var-concierge-bell: \\f562;\n$fa-var-bell-exclamation: \\f848;\n$fa-var-bell-on: \\f8fa;\n$fa-var-bell-plus: \\f849;\n$fa-var-bell-school: \\f5d5;\n$fa-var-bell-school-slash: \\f5d6;\n$fa-var-bell-slash: \\f1f6;\n$fa-var-bells: \\f77f;\n$fa-var-bench-tree: \\e2e7;\n$fa-var-bezier-curve: \\f55b;\n$fa-var-bicycle: \\f206;\n$fa-var-binary: \\e33b;\n$fa-var-binary-circle-check: \\e33c;\n$fa-var-binary-lock: \\e33d;\n$fa-var-binary-slash: \\e33e;\n$fa-var-binoculars: \\f1e5;\n$fa-var-biohazard: \\f780;\n$fa-var-bitcoin-sign: \\e0b4;\n$fa-var-blanket: \\f498;\n$fa-var-blanket-fire: \\e3da;\n$fa-var-blender: \\f517;\n$fa-var-blender-phone: \\f6b6;\n$fa-var-blinds: \\f8fb;\n$fa-var-blinds-open: \\f8fc;\n$fa-var-blinds-raised: \\f8fd;\n$fa-var-block-brick: \\e3db;\n$fa-var-wall-brick: \\e3db;\n$fa-var-block-brick-fire: \\e3dc;\n$fa-var-firewall: \\e3dc;\n$fa-var-block-question: \\e3dd;\n$fa-var-block-quote: \\e0b5;\n$fa-var-blog: \\f781;\n$fa-var-blueberries: \\e2e8;\n$fa-var-bold: \\f032;\n$fa-var-bolt: \\f0e7;\n$fa-var-flash: \\f0e7;\n$fa-var-bolt-auto: \\e0b6;\n$fa-var-bolt-lightning: \\e0b7;\n$fa-var-bolt-slash: \\e0b8;\n$fa-var-bomb: \\f1e2;\n$fa-var-bone: \\f5d7;\n$fa-var-bone-break: \\f5d8;\n$fa-var-bong: \\f55c;\n$fa-var-book: \\f02d;\n$fa-var-book-arrow-right: \\e0b9;\n$fa-var-book-arrow-up: \\e0ba;\n$fa-var-book-atlas: \\f558;\n$fa-var-atlas: \\f558;\n$fa-var-book-bible: \\f647;\n$fa-var-bible: \\f647;\n$fa-var-book-blank: \\f5d9;\n$fa-var-book-alt: \\f5d9;\n$fa-var-book-bookmark: \\e0bb;\n$fa-var-book-circle-arrow-right: \\e0bc;\n$fa-var-book-circle-arrow-up: \\e0bd;\n$fa-var-book-copy: \\e0be;\n$fa-var-book-font: \\e0bf;\n$fa-var-book-heart: \\f499;\n$fa-var-book-journal-whills: \\f66a;\n$fa-var-journal-whills: \\f66a;\n$fa-var-book-medical: \\f7e6;\n$fa-var-book-open: \\f518;\n$fa-var-book-open-cover: \\e0c0;\n$fa-var-book-open-alt: \\e0c0;\n$fa-var-book-open-reader: \\f5da;\n$fa-var-book-reader: \\f5da;\n$fa-var-book-quran: \\f687;\n$fa-var-quran: \\f687;\n$fa-var-book-section: \\e0c1;\n$fa-var-book-law: \\e0c1;\n$fa-var-book-skull: \\f6b7;\n$fa-var-book-dead: \\f6b7;\n$fa-var-book-sparkles: \\f6b8;\n$fa-var-book-spells: \\f6b8;\n$fa-var-book-tanakh: \\f827;\n$fa-var-tanakh: \\f827;\n$fa-var-book-user: \\f7e7;\n$fa-var-bookmark: \\f02e;\n$fa-var-bookmark-slash: \\e0c2;\n$fa-var-books: \\f5db;\n$fa-var-books-medical: \\f7e8;\n$fa-var-boombox: \\f8a5;\n$fa-var-boot: \\f782;\n$fa-var-boot-heeled: \\e33f;\n$fa-var-booth-curtain: \\f734;\n$fa-var-border-all: \\f84c;\n$fa-var-border-bottom: \\f84d;\n$fa-var-border-bottom-right: \\f854;\n$fa-var-border-style-alt: \\f854;\n$fa-var-border-center-h: \\f89c;\n$fa-var-border-center-v: \\f89d;\n$fa-var-border-inner: \\f84e;\n$fa-var-border-left: \\f84f;\n$fa-var-border-none: \\f850;\n$fa-var-border-outer: \\f851;\n$fa-var-border-right: \\f852;\n$fa-var-border-top: \\f855;\n$fa-var-border-top-left: \\f853;\n$fa-var-border-style: \\f853;\n$fa-var-bow-arrow: \\f6b9;\n$fa-var-bowl-chopsticks: \\e2e9;\n$fa-var-bowl-chopsticks-noodles: \\e2ea;\n$fa-var-bowl-hot: \\f823;\n$fa-var-soup: \\f823;\n$fa-var-bowl-rice: \\e2eb;\n$fa-var-bowl-scoop: \\e3de;\n$fa-var-bowl-shaved-ice: \\e3de;\n$fa-var-bowl-scoops: \\e3df;\n$fa-var-bowl-spoon: \\e3e0;\n$fa-var-bowling-ball: \\f436;\n$fa-var-bowling-ball-pin: \\e0c3;\n$fa-var-bowling-pins: \\f437;\n$fa-var-box: \\f466;\n$fa-var-box-archive: \\f187;\n$fa-var-archive: \\f187;\n$fa-var-box-ballot: \\f735;\n$fa-var-box-check: \\f467;\n$fa-var-box-circle-check: \\e0c4;\n$fa-var-box-dollar: \\f4a0;\n$fa-var-box-usd: \\f4a0;\n$fa-var-box-heart: \\f49d;\n$fa-var-box-open: \\f49e;\n$fa-var-box-open-full: \\f49c;\n$fa-var-box-full: \\f49c;\n$fa-var-box-taped: \\f49a;\n$fa-var-box-alt: \\f49a;\n$fa-var-box-tissue: \\e05b;\n$fa-var-boxes-stacked: \\f468;\n$fa-var-boxes: \\f468;\n$fa-var-boxes-alt: \\f468;\n$fa-var-boxing-glove: \\f438;\n$fa-var-glove-boxing: \\f438;\n$fa-var-bracket-curly: \\7b;\n$fa-var-bracket-curly-left: \\7b;\n$fa-var-bracket-curly-right: \\7d;\n$fa-var-bracket-round: \\28;\n$fa-var-parenthesis: \\28;\n$fa-var-bracket-round-right: \\29;\n$fa-var-bracket-square: \\5b;\n$fa-var-bracket: \\5b;\n$fa-var-bracket-left: \\5b;\n$fa-var-bracket-square-right: \\5d;\n$fa-var-brackets-curly: \\f7ea;\n$fa-var-brackets-round: \\e0c5;\n$fa-var-parentheses: \\e0c5;\n$fa-var-brackets-square: \\f7e9;\n$fa-var-brackets: \\f7e9;\n$fa-var-braille: \\f2a1;\n$fa-var-brain: \\f5dc;\n$fa-var-brain-arrow-curved-right: \\f677;\n$fa-var-mind-share: \\f677;\n$fa-var-brain-circuit: \\e0c6;\n$fa-var-brake-warning: \\e0c7;\n$fa-var-bread-loaf: \\f7eb;\n$fa-var-bread-slice: \\f7ec;\n$fa-var-bread-slice-butter: \\e3e1;\n$fa-var-briefcase: \\f0b1;\n$fa-var-briefcase-arrow-right: \\e2f2;\n$fa-var-briefcase-blank: \\e0c8;\n$fa-var-briefcase-medical: \\f469;\n$fa-var-brightness: \\e0c9;\n$fa-var-brightness-low: \\e0ca;\n$fa-var-bring-forward: \\f856;\n$fa-var-bring-front: \\f857;\n$fa-var-broccoli: \\e3e2;\n$fa-var-broom: \\f51a;\n$fa-var-browser: \\f37e;\n$fa-var-browsers: \\e0cb;\n$fa-var-brush: \\f55d;\n$fa-var-bug: \\f188;\n$fa-var-building: \\f1ad;\n$fa-var-buildings: \\e0cc;\n$fa-var-bullhorn: \\f0a1;\n$fa-var-bullseye: \\f140;\n$fa-var-bullseye-arrow: \\f648;\n$fa-var-bullseye-pointer: \\f649;\n$fa-var-burger: \\f805;\n$fa-var-hamburger: \\f805;\n$fa-var-burger-cheese: \\f7f1;\n$fa-var-cheeseburger: \\f7f1;\n$fa-var-burger-fries: \\e0cd;\n$fa-var-burger-glass: \\e0ce;\n$fa-var-burger-lettuce: \\e3e3;\n$fa-var-burger-soda: \\f858;\n$fa-var-burrito: \\f7ed;\n$fa-var-bus: \\f207;\n$fa-var-bus-school: \\f5dd;\n$fa-var-bus-simple: \\f55e;\n$fa-var-bus-alt: \\f55e;\n$fa-var-business-time: \\f64a;\n$fa-var-briefcase-clock: \\f64a;\n$fa-var-butter: \\e3e4;\n$fa-var-c: \\43;\n$fa-var-cabinet-filing: \\f64b;\n$fa-var-cable-car: \\e0cf;\n$fa-var-cactus: \\f8a7;\n$fa-var-cake-candles: \\f1fd;\n$fa-var-birthday-cake: \\f1fd;\n$fa-var-cake-slice: \\e3e5;\n$fa-var-shortcake: \\e3e5;\n$fa-var-calculator: \\f1ec;\n$fa-var-calculator-simple: \\f64c;\n$fa-var-calculator-alt: \\f64c;\n$fa-var-calendar: \\f133;\n$fa-var-calendar-arrow-down: \\e0d0;\n$fa-var-calendar-download: \\e0d0;\n$fa-var-calendar-arrow-up: \\e0d1;\n$fa-var-calendar-upload: \\e0d1;\n$fa-var-calendar-check: \\f274;\n$fa-var-calendar-clock: \\e0d2;\n$fa-var-calendar-time: \\e0d2;\n$fa-var-calendar-day: \\f783;\n$fa-var-calendar-days: \\f073;\n$fa-var-calendar-alt: \\f073;\n$fa-var-calendar-exclamation: \\f334;\n$fa-var-calendar-heart: \\e0d3;\n$fa-var-calendar-image: \\e0d4;\n$fa-var-calendar-lines: \\e0d5;\n$fa-var-calendar-note: \\e0d5;\n$fa-var-calendar-minus: \\f272;\n$fa-var-calendar-pen: \\f333;\n$fa-var-calendar-edit: \\f333;\n$fa-var-calendar-plus: \\f271;\n$fa-var-calendar-range: \\e0d6;\n$fa-var-calendar-star: \\f736;\n$fa-var-calendar-week: \\f784;\n$fa-var-calendar-xmark: \\f273;\n$fa-var-calendar-times: \\f273;\n$fa-var-calendars: \\e0d7;\n$fa-var-camcorder: \\f8a8;\n$fa-var-video-handheld: \\f8a8;\n$fa-var-camera: \\f030;\n$fa-var-camera-alt: \\f030;\n$fa-var-camera-cctv: \\f8ac;\n$fa-var-cctv: \\f8ac;\n$fa-var-camera-movie: \\f8a9;\n$fa-var-camera-polaroid: \\f8aa;\n$fa-var-camera-retro: \\f083;\n$fa-var-camera-rotate: \\e0d8;\n$fa-var-camera-security: \\f8fe;\n$fa-var-camera-home: \\f8fe;\n$fa-var-camera-slash: \\e0d9;\n$fa-var-camera-viewfinder: \\e0da;\n$fa-var-camera-web: \\f832;\n$fa-var-webcam: \\f832;\n$fa-var-camera-web-slash: \\f833;\n$fa-var-webcam-slash: \\f833;\n$fa-var-campfire: \\f6ba;\n$fa-var-campground: \\f6bb;\n$fa-var-can-food: \\e3e6;\n$fa-var-candle-holder: \\f6bc;\n$fa-var-candy: \\e3e7;\n$fa-var-candy-bar: \\e3e8;\n$fa-var-chocolate-bar: \\e3e8;\n$fa-var-candy-cane: \\f786;\n$fa-var-candy-corn: \\f6bd;\n$fa-var-cannabis: \\f55f;\n$fa-var-capsules: \\f46b;\n$fa-var-car: \\f1b9;\n$fa-var-automobile: \\f1b9;\n$fa-var-car-battery: \\f5df;\n$fa-var-battery-car: \\f5df;\n$fa-var-car-bolt: \\e341;\n$fa-var-car-building: \\f859;\n$fa-var-car-bump: \\f5e0;\n$fa-var-car-bus: \\f85a;\n$fa-var-car-circle-bolt: \\e342;\n$fa-var-car-crash: \\f5e1;\n$fa-var-car-garage: \\f5e2;\n$fa-var-car-mirrors: \\e343;\n$fa-var-car-rear: \\f5de;\n$fa-var-car-alt: \\f5de;\n$fa-var-car-side: \\f5e4;\n$fa-var-car-side-bolt: \\e344;\n$fa-var-car-tilt: \\f5e5;\n$fa-var-car-wash: \\f5e6;\n$fa-var-car-wrench: \\f5e3;\n$fa-var-car-mechanic: \\f5e3;\n$fa-var-caravan: \\f8ff;\n$fa-var-caravan-simple: \\e000;\n$fa-var-caravan-alt: \\e000;\n$fa-var-card-club: \\e3e9;\n$fa-var-card-diamond: \\e3ea;\n$fa-var-card-heart: \\e3eb;\n$fa-var-card-spade: \\e3ec;\n$fa-var-cards: \\e3ed;\n$fa-var-caret-down: \\f0d7;\n$fa-var-caret-left: \\f0d9;\n$fa-var-caret-right: \\f0da;\n$fa-var-caret-up: \\f0d8;\n$fa-var-carrot: \\f787;\n$fa-var-cars: \\f85b;\n$fa-var-cart-arrow-down: \\f218;\n$fa-var-cart-arrow-up: \\e3ee;\n$fa-var-cart-circle-arrow-down: \\e3ef;\n$fa-var-cart-circle-arrow-up: \\e3f0;\n$fa-var-cart-circle-check: \\e3f1;\n$fa-var-cart-circle-exclamation: \\e3f2;\n$fa-var-cart-circle-plus: \\e3f3;\n$fa-var-cart-circle-xmark: \\e3f4;\n$fa-var-cart-flatbed: \\f474;\n$fa-var-dolly-flatbed: \\f474;\n$fa-var-cart-flatbed-boxes: \\f475;\n$fa-var-dolly-flatbed-alt: \\f475;\n$fa-var-cart-flatbed-empty: \\f476;\n$fa-var-dolly-flatbed-empty: \\f476;\n$fa-var-cart-flatbed-suitcase: \\f59d;\n$fa-var-luggage-cart: \\f59d;\n$fa-var-cart-minus: \\e0db;\n$fa-var-cart-plus: \\f217;\n$fa-var-cart-shopping: \\f07a;\n$fa-var-shopping-cart: \\f07a;\n$fa-var-cart-shopping-fast: \\e0dc;\n$fa-var-cart-xmark: \\e0dd;\n$fa-var-cash-register: \\f788;\n$fa-var-cassette-betamax: \\f8a4;\n$fa-var-betamax: \\f8a4;\n$fa-var-cassette-tape: \\f8ab;\n$fa-var-cassette-vhs: \\f8ec;\n$fa-var-vhs: \\f8ec;\n$fa-var-castle: \\e0de;\n$fa-var-cat: \\f6be;\n$fa-var-cat-space: \\e001;\n$fa-var-cauldron: \\f6bf;\n$fa-var-cedi-sign: \\e0df;\n$fa-var-cent-sign: \\e3f5;\n$fa-var-certificate: \\f0a3;\n$fa-var-chair: \\f6c0;\n$fa-var-chair-office: \\f6c1;\n$fa-var-chalkboard: \\f51b;\n$fa-var-blackboard: \\f51b;\n$fa-var-chalkboard-user: \\f51c;\n$fa-var-chalkboard-teacher: \\f51c;\n$fa-var-champagne-glass: \\f79e;\n$fa-var-glass-champagne: \\f79e;\n$fa-var-champagne-glasses: \\f79f;\n$fa-var-glass-cheers: \\f79f;\n$fa-var-charging-station: \\f5e7;\n$fa-var-chart-area: \\f1fe;\n$fa-var-area-chart: \\f1fe;\n$fa-var-chart-bar: \\f080;\n$fa-var-bar-chart: \\f080;\n$fa-var-chart-bullet: \\e0e1;\n$fa-var-chart-candlestick: \\e0e2;\n$fa-var-chart-column: \\e0e3;\n$fa-var-chart-gantt: \\e0e4;\n$fa-var-chart-line: \\f201;\n$fa-var-line-chart: \\f201;\n$fa-var-chart-line-down: \\f64d;\n$fa-var-chart-line-up: \\e0e5;\n$fa-var-chart-mixed: \\f643;\n$fa-var-analytics: \\f643;\n$fa-var-chart-network: \\f78a;\n$fa-var-chart-pie: \\f200;\n$fa-var-pie-chart: \\f200;\n$fa-var-chart-pie-simple: \\f64e;\n$fa-var-chart-pie-alt: \\f64e;\n$fa-var-chart-pyramid: \\e0e6;\n$fa-var-chart-radar: \\e0e7;\n$fa-var-chart-scatter: \\f7ee;\n$fa-var-chart-scatter-3d: \\e0e8;\n$fa-var-chart-scatter-bubble: \\e0e9;\n$fa-var-chart-tree-map: \\e0ea;\n$fa-var-chart-user: \\f6a3;\n$fa-var-user-chart: \\f6a3;\n$fa-var-chart-waterfall: \\e0eb;\n$fa-var-check: \\f00c;\n$fa-var-check-double: \\f560;\n$fa-var-check-to-slot: \\f772;\n$fa-var-vote-yea: \\f772;\n$fa-var-cheese: \\f7ef;\n$fa-var-cheese-swiss: \\f7f0;\n$fa-var-cherries: \\e0ec;\n$fa-var-chess: \\f439;\n$fa-var-chess-bishop: \\f43a;\n$fa-var-chess-bishop-piece: \\f43b;\n$fa-var-chess-bishop-alt: \\f43b;\n$fa-var-chess-board: \\f43c;\n$fa-var-chess-clock: \\f43d;\n$fa-var-chess-clock-flip: \\f43e;\n$fa-var-chess-clock-alt: \\f43e;\n$fa-var-chess-king: \\f43f;\n$fa-var-chess-king-piece: \\f440;\n$fa-var-chess-king-alt: \\f440;\n$fa-var-chess-knight: \\f441;\n$fa-var-chess-knight-piece: \\f442;\n$fa-var-chess-knight-alt: \\f442;\n$fa-var-chess-pawn: \\f443;\n$fa-var-chess-pawn-piece: \\f444;\n$fa-var-chess-pawn-alt: \\f444;\n$fa-var-chess-queen: \\f445;\n$fa-var-chess-queen-piece: \\f446;\n$fa-var-chess-queen-alt: \\f446;\n$fa-var-chess-rook: \\f447;\n$fa-var-chess-rook-piece: \\f448;\n$fa-var-chess-rook-alt: \\f448;\n$fa-var-chestnut: \\e3f6;\n$fa-var-chevron-down: \\f078;\n$fa-var-chevron-left: \\f053;\n$fa-var-chevron-right: \\f054;\n$fa-var-chevron-up: \\f077;\n$fa-var-chevrons-down: \\f322;\n$fa-var-chevron-double-down: \\f322;\n$fa-var-chevrons-left: \\f323;\n$fa-var-chevron-double-left: \\f323;\n$fa-var-chevrons-right: \\f324;\n$fa-var-chevron-double-right: \\f324;\n$fa-var-chevrons-up: \\f325;\n$fa-var-chevron-double-up: \\f325;\n$fa-var-child: \\f1ae;\n$fa-var-chimney: \\f78b;\n$fa-var-chopsticks: \\e3f7;\n$fa-var-church: \\f51d;\n$fa-var-circle: \\f111;\n$fa-var-circle-0: \\e0ed;\n$fa-var-circle-1: \\e0ee;\n$fa-var-circle-2: \\e0ef;\n$fa-var-circle-3: \\e0f0;\n$fa-var-circle-4: \\e0f1;\n$fa-var-circle-5: \\e0f2;\n$fa-var-circle-6: \\e0f3;\n$fa-var-circle-7: \\e0f4;\n$fa-var-circle-8: \\e0f5;\n$fa-var-circle-9: \\e0f6;\n$fa-var-circle-a: \\e0f7;\n$fa-var-circle-ampersand: \\e0f8;\n$fa-var-circle-arrow-down: \\f0ab;\n$fa-var-arrow-circle-down: \\f0ab;\n$fa-var-circle-arrow-down-left: \\e0f9;\n$fa-var-circle-arrow-down-right: \\e0fa;\n$fa-var-circle-arrow-left: \\f0a8;\n$fa-var-arrow-circle-left: \\f0a8;\n$fa-var-circle-arrow-right: \\f0a9;\n$fa-var-arrow-circle-right: \\f0a9;\n$fa-var-circle-arrow-up: \\f0aa;\n$fa-var-arrow-circle-up: \\f0aa;\n$fa-var-circle-arrow-up-left: \\e0fb;\n$fa-var-circle-arrow-up-right: \\e0fc;\n$fa-var-circle-b: \\e0fd;\n$fa-var-circle-bolt: \\e0fe;\n$fa-var-circle-book-open: \\e0ff;\n$fa-var-book-circle: \\e0ff;\n$fa-var-circle-bookmark: \\e100;\n$fa-var-bookmark-circle: \\e100;\n$fa-var-circle-c: \\e101;\n$fa-var-circle-calendar: \\e102;\n$fa-var-calendar-circle: \\e102;\n$fa-var-circle-camera: \\e103;\n$fa-var-camera-circle: \\e103;\n$fa-var-circle-caret-down: \\f32d;\n$fa-var-caret-circle-down: \\f32d;\n$fa-var-circle-caret-left: \\f32e;\n$fa-var-caret-circle-left: \\f32e;\n$fa-var-circle-caret-right: \\f330;\n$fa-var-caret-circle-right: \\f330;\n$fa-var-circle-caret-up: \\f331;\n$fa-var-caret-circle-up: \\f331;\n$fa-var-circle-check: \\f058;\n$fa-var-check-circle: \\f058;\n$fa-var-circle-chevron-down: \\f13a;\n$fa-var-chevron-circle-down: \\f13a;\n$fa-var-circle-chevron-left: \\f137;\n$fa-var-chevron-circle-left: \\f137;\n$fa-var-circle-chevron-right: \\f138;\n$fa-var-chevron-circle-right: \\f138;\n$fa-var-circle-chevron-up: \\f139;\n$fa-var-chevron-circle-up: \\f139;\n$fa-var-circle-d: \\e104;\n$fa-var-circle-dashed: \\e105;\n$fa-var-circle-divide: \\e106;\n$fa-var-circle-dollar: \\f2e8;\n$fa-var-dollar-circle: \\f2e8;\n$fa-var-usd-circle: \\f2e8;\n$fa-var-circle-dollar-to-slot: \\f4b9;\n$fa-var-donate: \\f4b9;\n$fa-var-circle-dot: \\f192;\n$fa-var-dot-circle: \\f192;\n$fa-var-circle-down: \\f358;\n$fa-var-arrow-alt-circle-down: \\f358;\n$fa-var-circle-down-left: \\e107;\n$fa-var-circle-down-right: \\e108;\n$fa-var-circle-e: \\e109;\n$fa-var-circle-ellipsis: \\e10a;\n$fa-var-circle-ellipsis-vertical: \\e10b;\n$fa-var-circle-envelope: \\e10c;\n$fa-var-envelope-circle: \\e10c;\n$fa-var-circle-exclamation: \\f06a;\n$fa-var-exclamation-circle: \\f06a;\n$fa-var-circle-exclamation-check: \\e10d;\n$fa-var-circle-f: \\e10e;\n$fa-var-circle-g: \\e10f;\n$fa-var-circle-h: \\f47e;\n$fa-var-hospital-symbol: \\f47e;\n$fa-var-circle-half: \\e110;\n$fa-var-circle-half-stroke: \\f042;\n$fa-var-adjust: \\f042;\n$fa-var-circle-heart: \\f4c7;\n$fa-var-heart-circle: \\f4c7;\n$fa-var-circle-i: \\e111;\n$fa-var-circle-info: \\f05a;\n$fa-var-info-circle: \\f05a;\n$fa-var-circle-j: \\e112;\n$fa-var-circle-k: \\e113;\n$fa-var-circle-l: \\e114;\n$fa-var-circle-left: \\f359;\n$fa-var-arrow-alt-circle-left: \\f359;\n$fa-var-circle-location-arrow: \\f602;\n$fa-var-location-circle: \\f602;\n$fa-var-circle-m: \\e115;\n$fa-var-circle-microphone: \\e116;\n$fa-var-microphone-circle: \\e116;\n$fa-var-circle-microphone-lines: \\e117;\n$fa-var-microphone-circle-alt: \\e117;\n$fa-var-circle-minus: \\f056;\n$fa-var-minus-circle: \\f056;\n$fa-var-circle-n: \\e118;\n$fa-var-circle-notch: \\f1ce;\n$fa-var-circle-o: \\e119;\n$fa-var-circle-p: \\e11a;\n$fa-var-circle-parking: \\f615;\n$fa-var-parking-circle: \\f615;\n$fa-var-circle-pause: \\f28b;\n$fa-var-pause-circle: \\f28b;\n$fa-var-circle-phone: \\e11b;\n$fa-var-phone-circle: \\e11b;\n$fa-var-circle-phone-flip: \\e11c;\n$fa-var-phone-circle-alt: \\e11c;\n$fa-var-circle-phone-hangup: \\e11d;\n$fa-var-phone-circle-down: \\e11d;\n$fa-var-circle-play: \\f144;\n$fa-var-play-circle: \\f144;\n$fa-var-circle-plus: \\f055;\n$fa-var-plus-circle: \\f055;\n$fa-var-circle-q: \\e11e;\n$fa-var-circle-quarter: \\e11f;\n$fa-var-circle-quarters: \\e3f8;\n$fa-var-circle-question: \\f059;\n$fa-var-question-circle: \\f059;\n$fa-var-circle-r: \\e120;\n$fa-var-circle-radiation: \\f7ba;\n$fa-var-radiation-alt: \\f7ba;\n$fa-var-circle-right: \\f35a;\n$fa-var-arrow-alt-circle-right: \\f35a;\n$fa-var-circle-s: \\e121;\n$fa-var-circle-small: \\e122;\n$fa-var-circle-sort: \\e030;\n$fa-var-sort-circle: \\e030;\n$fa-var-circle-sort-down: \\e031;\n$fa-var-sort-circle-down: \\e031;\n$fa-var-circle-sort-up: \\e032;\n$fa-var-sort-circle-up: \\e032;\n$fa-var-circle-star: \\e123;\n$fa-var-star-circle: \\e123;\n$fa-var-circle-stop: \\f28d;\n$fa-var-stop-circle: \\f28d;\n$fa-var-circle-t: \\e124;\n$fa-var-circle-three-quarters: \\e125;\n$fa-var-circle-trash: \\e126;\n$fa-var-trash-circle: \\e126;\n$fa-var-circle-u: \\e127;\n$fa-var-circle-up: \\f35b;\n$fa-var-arrow-alt-circle-up: \\f35b;\n$fa-var-circle-up-left: \\e128;\n$fa-var-circle-up-right: \\e129;\n$fa-var-circle-user: \\f2bd;\n$fa-var-user-circle: \\f2bd;\n$fa-var-circle-v: \\e12a;\n$fa-var-circle-video: \\e12b;\n$fa-var-video-circle: \\e12b;\n$fa-var-circle-w: \\e12c;\n$fa-var-circle-waveform-lines: \\e12d;\n$fa-var-waveform-circle: \\e12d;\n$fa-var-circle-x: \\e12e;\n$fa-var-circle-xmark: \\f057;\n$fa-var-times-circle: \\f057;\n$fa-var-xmark-circle: \\f057;\n$fa-var-circle-y: \\e12f;\n$fa-var-circle-z: \\e130;\n$fa-var-citrus: \\e2f4;\n$fa-var-citrus-slice: \\e2f5;\n$fa-var-city: \\f64f;\n$fa-var-clapperboard: \\e131;\n$fa-var-clapperboard-play: \\e132;\n$fa-var-clarinet: \\f8ad;\n$fa-var-claw-marks: \\f6c2;\n$fa-var-clipboard: \\f328;\n$fa-var-clipboard-check: \\f46c;\n$fa-var-clipboard-list: \\f46d;\n$fa-var-clipboard-list-check: \\f737;\n$fa-var-clipboard-medical: \\e133;\n$fa-var-clipboard-prescription: \\f5e8;\n$fa-var-clipboard-user: \\f7f3;\n$fa-var-clock: \\f017;\n$fa-var-clock-four: \\f017;\n$fa-var-clock-desk: \\e134;\n$fa-var-clock-eight: \\e345;\n$fa-var-clock-eight-thirty: \\e346;\n$fa-var-clock-eleven: \\e347;\n$fa-var-clock-eleven-thirty: \\e348;\n$fa-var-clock-five: \\e349;\n$fa-var-clock-five-thirty: \\e34a;\n$fa-var-clock-four-thirty: \\e34b;\n$fa-var-clock-nine: \\e34c;\n$fa-var-clock-nine-thirty: \\e34d;\n$fa-var-clock-one: \\e34e;\n$fa-var-clock-one-thirty: \\e34f;\n$fa-var-clock-rotate-left: \\f1da;\n$fa-var-history: \\f1da;\n$fa-var-clock-seven: \\e350;\n$fa-var-clock-seven-thirty: \\e351;\n$fa-var-clock-six: \\e352;\n$fa-var-clock-six-thirty: \\e353;\n$fa-var-clock-ten: \\e354;\n$fa-var-clock-ten-thirty: \\e355;\n$fa-var-clock-three: \\e356;\n$fa-var-clock-three-thirty: \\e357;\n$fa-var-clock-twelve: \\e358;\n$fa-var-clock-twelve-thirty: \\e359;\n$fa-var-clock-two: \\e35a;\n$fa-var-clock-two-thirty: \\e35b;\n$fa-var-clone: \\f24d;\n$fa-var-closed-captioning: \\f20a;\n$fa-var-closed-captioning-slash: \\e135;\n$fa-var-clothes-hanger: \\e136;\n$fa-var-cloud: \\f0c2;\n$fa-var-cloud-arrow-down: \\f0ed;\n$fa-var-cloud-download: \\f0ed;\n$fa-var-cloud-download-alt: \\f0ed;\n$fa-var-cloud-arrow-up: \\f0ee;\n$fa-var-cloud-upload: \\f0ee;\n$fa-var-cloud-upload-alt: \\f0ee;\n$fa-var-cloud-bolt: \\f76c;\n$fa-var-thunderstorm: \\f76c;\n$fa-var-cloud-bolt-moon: \\f76d;\n$fa-var-thunderstorm-moon: \\f76d;\n$fa-var-cloud-bolt-sun: \\f76e;\n$fa-var-thunderstorm-sun: \\f76e;\n$fa-var-cloud-check: \\e35c;\n$fa-var-cloud-drizzle: \\f738;\n$fa-var-cloud-fog: \\f74e;\n$fa-var-fog: \\f74e;\n$fa-var-cloud-hail: \\f739;\n$fa-var-cloud-hail-mixed: \\f73a;\n$fa-var-cloud-meatball: \\f73b;\n$fa-var-cloud-minus: \\e35d;\n$fa-var-cloud-moon: \\f6c3;\n$fa-var-cloud-moon-rain: \\f73c;\n$fa-var-cloud-music: \\f8ae;\n$fa-var-cloud-plus: \\e35e;\n$fa-var-cloud-rain: \\f73d;\n$fa-var-cloud-rainbow: \\f73e;\n$fa-var-cloud-showers: \\f73f;\n$fa-var-cloud-showers-heavy: \\f740;\n$fa-var-cloud-slash: \\e137;\n$fa-var-cloud-sleet: \\f741;\n$fa-var-cloud-snow: \\f742;\n$fa-var-cloud-sun: \\f6c4;\n$fa-var-cloud-sun-rain: \\f743;\n$fa-var-cloud-word: \\e138;\n$fa-var-cloud-xmark: \\e35f;\n$fa-var-clouds: \\f744;\n$fa-var-clouds-moon: \\f745;\n$fa-var-clouds-sun: \\f746;\n$fa-var-clover: \\e139;\n$fa-var-club: \\f327;\n$fa-var-coconut: \\e2f6;\n$fa-var-code: \\f121;\n$fa-var-code-branch: \\f126;\n$fa-var-code-commit: \\f386;\n$fa-var-code-compare: \\e13a;\n$fa-var-code-fork: \\e13b;\n$fa-var-code-merge: \\f387;\n$fa-var-code-pull-request: \\e13c;\n$fa-var-code-pull-request-closed: \\e3f9;\n$fa-var-code-pull-request-draft: \\e3fa;\n$fa-var-code-simple: \\e13d;\n$fa-var-coffee-bean: \\e13e;\n$fa-var-coffee-beans: \\e13f;\n$fa-var-coffee-pot: \\e002;\n$fa-var-coffin: \\f6c6;\n$fa-var-coffin-cross: \\e051;\n$fa-var-coin: \\f85c;\n$fa-var-coin-blank: \\e3fb;\n$fa-var-coin-front: \\e3fc;\n$fa-var-coin-vertical: \\e3fd;\n$fa-var-coins: \\f51e;\n$fa-var-colon: \\3a;\n$fa-var-colon-sign: \\e140;\n$fa-var-columns-3: \\e361;\n$fa-var-comet: \\e003;\n$fa-var-comma: \\2c;\n$fa-var-command: \\e142;\n$fa-var-comment: \\f075;\n$fa-var-comment-arrow-down: \\e143;\n$fa-var-comment-arrow-up: \\e144;\n$fa-var-comment-arrow-up-right: \\e145;\n$fa-var-comment-captions: \\e146;\n$fa-var-comment-check: \\f4ac;\n$fa-var-comment-code: \\e147;\n$fa-var-comment-dollar: \\f651;\n$fa-var-comment-dots: \\f4ad;\n$fa-var-commenting: \\f4ad;\n$fa-var-comment-exclamation: \\f4af;\n$fa-var-comment-image: \\e148;\n$fa-var-comment-lines: \\f4b0;\n$fa-var-comment-medical: \\f7f5;\n$fa-var-comment-middle: \\e149;\n$fa-var-comment-middle-top: \\e14a;\n$fa-var-comment-minus: \\f4b1;\n$fa-var-comment-music: \\f8b0;\n$fa-var-comment-pen: \\f4ae;\n$fa-var-comment-edit: \\f4ae;\n$fa-var-comment-plus: \\f4b2;\n$fa-var-comment-question: \\e14b;\n$fa-var-comment-quote: \\e14c;\n$fa-var-comment-slash: \\f4b3;\n$fa-var-comment-smile: \\f4b4;\n$fa-var-comment-sms: \\f7cd;\n$fa-var-sms: \\f7cd;\n$fa-var-comment-text: \\e14d;\n$fa-var-comment-xmark: \\f4b5;\n$fa-var-comment-times: \\f4b5;\n$fa-var-comments: \\f086;\n$fa-var-comments-dollar: \\f653;\n$fa-var-comments-question: \\e14e;\n$fa-var-comments-question-check: \\e14f;\n$fa-var-compact-disc: \\f51f;\n$fa-var-compass: \\f14e;\n$fa-var-compass-drafting: \\f568;\n$fa-var-drafting-compass: \\f568;\n$fa-var-compass-slash: \\f5e9;\n$fa-var-compress: \\f066;\n$fa-var-compress-wide: \\f326;\n$fa-var-computer-classic: \\f8b1;\n$fa-var-computer-mouse: \\f8cc;\n$fa-var-mouse: \\f8cc;\n$fa-var-computer-mouse-scrollwheel: \\f8cd;\n$fa-var-mouse-alt: \\f8cd;\n$fa-var-computer-speaker: \\f8b2;\n$fa-var-container-storage: \\f4b7;\n$fa-var-conveyor-belt: \\f46e;\n$fa-var-conveyor-belt-boxes: \\f46f;\n$fa-var-conveyor-belt-alt: \\f46f;\n$fa-var-conveyor-belt-empty: \\e150;\n$fa-var-cookie: \\f563;\n$fa-var-cookie-bite: \\f564;\n$fa-var-copy: \\f0c5;\n$fa-var-copyright: \\f1f9;\n$fa-var-corn: \\f6c7;\n$fa-var-corner: \\e3fe;\n$fa-var-couch: \\f4b8;\n$fa-var-cow: \\f6c8;\n$fa-var-cowbell: \\f8b3;\n$fa-var-cowbell-circle-plus: \\f8b4;\n$fa-var-cowbell-more: \\f8b4;\n$fa-var-crab: \\e3ff;\n$fa-var-crate-apple: \\f6b1;\n$fa-var-apple-crate: \\f6b1;\n$fa-var-crate-empty: \\e151;\n$fa-var-credit-card: \\f09d;\n$fa-var-credit-card-alt: \\f09d;\n$fa-var-credit-card-blank: \\f389;\n$fa-var-credit-card-front: \\f38a;\n$fa-var-creemee: \\e400;\n$fa-var-soft-serve: \\e400;\n$fa-var-cricket-bat-ball: \\f449;\n$fa-var-cricket: \\f449;\n$fa-var-croissant: \\f7f6;\n$fa-var-crop: \\f125;\n$fa-var-crop-simple: \\f565;\n$fa-var-crop-alt: \\f565;\n$fa-var-cross: \\f654;\n$fa-var-crosshairs: \\f05b;\n$fa-var-crow: \\f520;\n$fa-var-crown: \\f521;\n$fa-var-crutch: \\f7f7;\n$fa-var-crutches: \\f7f8;\n$fa-var-cruzeiro-sign: \\e152;\n$fa-var-crystal-ball: \\e362;\n$fa-var-cube: \\f1b2;\n$fa-var-cubes: \\f1b3;\n$fa-var-cucumber: \\e401;\n$fa-var-cup-straw: \\e363;\n$fa-var-cup-straw-swoosh: \\e364;\n$fa-var-cup-togo: \\f6c5;\n$fa-var-coffee-togo: \\f6c5;\n$fa-var-cupcake: \\e402;\n$fa-var-curling-stone: \\f44a;\n$fa-var-curling: \\f44a;\n$fa-var-custard: \\e403;\n$fa-var-d: \\44;\n$fa-var-dagger: \\f6cb;\n$fa-var-dash: \\e404;\n$fa-var-database: \\f1c0;\n$fa-var-deer: \\f78e;\n$fa-var-deer-rudolph: \\f78f;\n$fa-var-delete-left: \\f55a;\n$fa-var-backspace: \\f55a;\n$fa-var-delete-right: \\e154;\n$fa-var-democrat: \\f747;\n$fa-var-desktop: \\f390;\n$fa-var-desktop-alt: \\f390;\n$fa-var-desktop-arrow-down: \\e155;\n$fa-var-dharmachakra: \\f655;\n$fa-var-diagram-lean-canvas: \\e156;\n$fa-var-diagram-nested: \\e157;\n$fa-var-diagram-project: \\f542;\n$fa-var-project-diagram: \\f542;\n$fa-var-diagram-sankey: \\e158;\n$fa-var-diagram-venn: \\e15a;\n$fa-var-dial: \\e15b;\n$fa-var-dial-med-high: \\e15b;\n$fa-var-dial-high: \\e15c;\n$fa-var-dial-low: \\e15d;\n$fa-var-dial-max: \\e15e;\n$fa-var-dial-med: \\e15f;\n$fa-var-dial-med-low: \\e160;\n$fa-var-dial-min: \\e161;\n$fa-var-dial-off: \\e162;\n$fa-var-diamond: \\f219;\n$fa-var-diamond-exclamation: \\e405;\n$fa-var-diamond-turn-right: \\f5eb;\n$fa-var-directions: \\f5eb;\n$fa-var-dice: \\f522;\n$fa-var-dice-d10: \\f6cd;\n$fa-var-dice-d12: \\f6ce;\n$fa-var-dice-d20: \\f6cf;\n$fa-var-dice-d4: \\f6d0;\n$fa-var-dice-d6: \\f6d1;\n$fa-var-dice-d8: \\f6d2;\n$fa-var-dice-five: \\f523;\n$fa-var-dice-four: \\f524;\n$fa-var-dice-one: \\f525;\n$fa-var-dice-six: \\f526;\n$fa-var-dice-three: \\f527;\n$fa-var-dice-two: \\f528;\n$fa-var-diploma: \\f5ea;\n$fa-var-scroll-ribbon: \\f5ea;\n$fa-var-disc-drive: \\f8b5;\n$fa-var-disease: \\f7fa;\n$fa-var-display: \\e163;\n$fa-var-display-arrow-down: \\e164;\n$fa-var-display-code: \\e165;\n$fa-var-desktop-code: \\e165;\n$fa-var-display-medical: \\e166;\n$fa-var-desktop-medical: \\e166;\n$fa-var-display-slash: \\e2fa;\n$fa-var-desktop-slash: \\e2fa;\n$fa-var-distribute-spacing-horizontal: \\e365;\n$fa-var-distribute-spacing-vertical: \\e366;\n$fa-var-ditto: \\22;\n$fa-var-divide: \\f529;\n$fa-var-dna: \\f471;\n$fa-var-do-not-enter: \\f5ec;\n$fa-var-dog: \\f6d3;\n$fa-var-dog-leashed: \\f6d4;\n$fa-var-dollar-sign: \\24;\n$fa-var-dollar: \\24;\n$fa-var-usd: \\24;\n$fa-var-dolly: \\f472;\n$fa-var-dolly-box: \\f472;\n$fa-var-dolly-empty: \\f473;\n$fa-var-dolphin: \\e168;\n$fa-var-dong-sign: \\e169;\n$fa-var-donut: \\e406;\n$fa-var-doughnut: \\e406;\n$fa-var-door-closed: \\f52a;\n$fa-var-door-open: \\f52b;\n$fa-var-dove: \\f4ba;\n$fa-var-down: \\f354;\n$fa-var-arrow-alt-down: \\f354;\n$fa-var-down-from-dotted-line: \\e407;\n$fa-var-down-from-line: \\f349;\n$fa-var-arrow-alt-from-top: \\f349;\n$fa-var-down-left: \\e16a;\n$fa-var-down-left-and-up-right-to-center: \\f422;\n$fa-var-compress-alt: \\f422;\n$fa-var-down-long: \\f309;\n$fa-var-long-arrow-alt-down: \\f309;\n$fa-var-down-right: \\e16b;\n$fa-var-down-to-dotted-line: \\e408;\n$fa-var-down-to-line: \\f34a;\n$fa-var-arrow-alt-to-bottom: \\f34a;\n$fa-var-download: \\f019;\n$fa-var-dragon: \\f6d5;\n$fa-var-draw-circle: \\f5ed;\n$fa-var-draw-polygon: \\f5ee;\n$fa-var-draw-square: \\f5ef;\n$fa-var-dreidel: \\f792;\n$fa-var-drone: \\f85f;\n$fa-var-drone-front: \\f860;\n$fa-var-drone-alt: \\f860;\n$fa-var-droplet: \\f043;\n$fa-var-tint: \\f043;\n$fa-var-droplet-degree: \\f748;\n$fa-var-dewpoint: \\f748;\n$fa-var-droplet-percent: \\f750;\n$fa-var-humidity: \\f750;\n$fa-var-droplet-slash: \\f5c7;\n$fa-var-tint-slash: \\f5c7;\n$fa-var-drum: \\f569;\n$fa-var-drum-steelpan: \\f56a;\n$fa-var-drumstick: \\f6d6;\n$fa-var-drumstick-bite: \\f6d7;\n$fa-var-dryer: \\f861;\n$fa-var-dryer-heat: \\f862;\n$fa-var-dryer-alt: \\f862;\n$fa-var-duck: \\f6d8;\n$fa-var-dumbbell: \\f44b;\n$fa-var-dumpster: \\f793;\n$fa-var-dumpster-fire: \\f794;\n$fa-var-dungeon: \\f6d9;\n$fa-var-e: \\45;\n$fa-var-ear: \\f5f0;\n$fa-var-ear-deaf: \\f2a4;\n$fa-var-deaf: \\f2a4;\n$fa-var-deafness: \\f2a4;\n$fa-var-hard-of-hearing: \\f2a4;\n$fa-var-ear-listen: \\f2a2;\n$fa-var-assistive-listening-systems: \\f2a2;\n$fa-var-ear-muffs: \\f795;\n$fa-var-earth-africa: \\f57c;\n$fa-var-globe-africa: \\f57c;\n$fa-var-earth-americas: \\f57d;\n$fa-var-earth: \\f57d;\n$fa-var-globe-americas: \\f57d;\n$fa-var-earth-asia: \\f57e;\n$fa-var-globe-asia: \\f57e;\n$fa-var-earth-europa: \\f7a2;\n$fa-var-globe-europe: \\f7a2;\n$fa-var-eclipse: \\f749;\n$fa-var-egg: \\f7fb;\n$fa-var-egg-fried: \\f7fc;\n$fa-var-eggplant: \\e16c;\n$fa-var-eject: \\f052;\n$fa-var-elephant: \\f6da;\n$fa-var-elevator: \\e16d;\n$fa-var-ellipsis: \\f141;\n$fa-var-ellipsis-h: \\f141;\n$fa-var-ellipsis-stroke: \\f39b;\n$fa-var-ellipsis-h-alt: \\f39b;\n$fa-var-ellipsis-stroke-vertical: \\f39c;\n$fa-var-ellipsis-v-alt: \\f39c;\n$fa-var-ellipsis-vertical: \\f142;\n$fa-var-ellipsis-v: \\f142;\n$fa-var-empty-set: \\f656;\n$fa-var-engine: \\e16e;\n$fa-var-engine-warning: \\f5f2;\n$fa-var-engine-exclamation: \\f5f2;\n$fa-var-envelope: \\f0e0;\n$fa-var-envelope-dot: \\e16f;\n$fa-var-envelope-badge: \\e16f;\n$fa-var-envelope-open: \\f2b6;\n$fa-var-envelope-open-dollar: \\f657;\n$fa-var-envelope-open-text: \\f658;\n$fa-var-envelopes: \\e170;\n$fa-var-envelopes-bulk: \\f674;\n$fa-var-mail-bulk: \\f674;\n$fa-var-equals: \\3d;\n$fa-var-eraser: \\f12d;\n$fa-var-escalator: \\e171;\n$fa-var-ethernet: \\f796;\n$fa-var-euro-sign: \\f153;\n$fa-var-eur: \\f153;\n$fa-var-euro: \\f153;\n$fa-var-exclamation: \\21;\n$fa-var-expand: \\f065;\n$fa-var-expand-wide: \\f320;\n$fa-var-eye: \\f06e;\n$fa-var-eye-dropper: \\f1fb;\n$fa-var-eye-dropper-empty: \\f1fb;\n$fa-var-eyedropper: \\f1fb;\n$fa-var-eye-dropper-full: \\e172;\n$fa-var-eye-dropper-half: \\e173;\n$fa-var-eye-evil: \\f6db;\n$fa-var-eye-low-vision: \\f2a8;\n$fa-var-low-vision: \\f2a8;\n$fa-var-eye-slash: \\f070;\n$fa-var-eyes: \\e367;\n$fa-var-f: \\46;\n$fa-var-face-angry: \\f556;\n$fa-var-angry: \\f556;\n$fa-var-face-angry-horns: \\e368;\n$fa-var-face-anguished: \\e369;\n$fa-var-face-anxious-sweat: \\e36a;\n$fa-var-face-astonished: \\e36b;\n$fa-var-face-awesome: \\e409;\n$fa-var-gave-dandy: \\e409;\n$fa-var-face-confounded: \\e36c;\n$fa-var-face-confused: \\e36d;\n$fa-var-face-cowboy-hat: \\e36e;\n$fa-var-face-disappointed: \\e36f;\n$fa-var-face-disguise: \\e370;\n$fa-var-face-dizzy: \\f567;\n$fa-var-dizzy: \\f567;\n$fa-var-face-downcast-sweat: \\e371;\n$fa-var-face-drooling: \\e372;\n$fa-var-face-explode: \\e2fe;\n$fa-var-exploding-head: \\e2fe;\n$fa-var-face-expressionless: \\e373;\n$fa-var-face-eyes-xmarks: \\e374;\n$fa-var-face-fearful: \\e375;\n$fa-var-face-flushed: \\f579;\n$fa-var-flushed: \\f579;\n$fa-var-face-frown: \\f119;\n$fa-var-frown: \\f119;\n$fa-var-face-frown-open: \\f57a;\n$fa-var-frown-open: \\f57a;\n$fa-var-face-frown-slight: \\e376;\n$fa-var-face-glasses: \\e377;\n$fa-var-face-grimace: \\f57f;\n$fa-var-grimace: \\f57f;\n$fa-var-face-grin: \\f580;\n$fa-var-grin: \\f580;\n$fa-var-face-grin-beam: \\f582;\n$fa-var-grin-beam: \\f582;\n$fa-var-face-grin-beam-sweat: \\f583;\n$fa-var-grin-beam-sweat: \\f583;\n$fa-var-face-grin-hearts: \\f584;\n$fa-var-grin-hearts: \\f584;\n$fa-var-face-grin-squint: \\f585;\n$fa-var-grin-squint: \\f585;\n$fa-var-face-grin-squint-tears: \\f586;\n$fa-var-grin-squint-tears: \\f586;\n$fa-var-face-grin-stars: \\f587;\n$fa-var-grin-stars: \\f587;\n$fa-var-face-grin-tears: \\f588;\n$fa-var-grin-tears: \\f588;\n$fa-var-face-grin-tongue: \\f589;\n$fa-var-grin-tongue: \\f589;\n$fa-var-face-grin-tongue-squint: \\f58a;\n$fa-var-grin-tongue-squint: \\f58a;\n$fa-var-face-grin-tongue-wink: \\f58b;\n$fa-var-grin-tongue-wink: \\f58b;\n$fa-var-face-grin-wide: \\f581;\n$fa-var-grin-alt: \\f581;\n$fa-var-face-grin-wink: \\f58c;\n$fa-var-grin-wink: \\f58c;\n$fa-var-face-hand-over-mouth: \\e378;\n$fa-var-face-hand-yawn: \\e379;\n$fa-var-face-head-bandage: \\e37a;\n$fa-var-face-hushed: \\e37b;\n$fa-var-face-icicles: \\e37c;\n$fa-var-face-kiss: \\f596;\n$fa-var-kiss: \\f596;\n$fa-var-face-kiss-beam: \\f597;\n$fa-var-kiss-beam: \\f597;\n$fa-var-face-kiss-closed-eyes: \\e37d;\n$fa-var-face-kiss-wink-heart: \\f598;\n$fa-var-kiss-wink-heart: \\f598;\n$fa-var-face-laugh: \\f599;\n$fa-var-laugh: \\f599;\n$fa-var-face-laugh-beam: \\f59a;\n$fa-var-laugh-beam: \\f59a;\n$fa-var-face-laugh-squint: \\f59b;\n$fa-var-laugh-squint: \\f59b;\n$fa-var-face-laugh-wink: \\f59c;\n$fa-var-laugh-wink: \\f59c;\n$fa-var-face-lying: \\e37e;\n$fa-var-face-mask: \\e37f;\n$fa-var-face-meh: \\f11a;\n$fa-var-meh: \\f11a;\n$fa-var-face-meh-blank: \\f5a4;\n$fa-var-meh-blank: \\f5a4;\n$fa-var-face-monocle: \\e380;\n$fa-var-face-nauseated: \\e381;\n$fa-var-face-nose-steam: \\e382;\n$fa-var-face-party: \\e383;\n$fa-var-face-pensive: \\e384;\n$fa-var-face-persevering: \\e385;\n$fa-var-face-pleading: \\e386;\n$fa-var-face-pouting: \\e387;\n$fa-var-face-raised-eyebrow: \\e388;\n$fa-var-face-relieved: \\e389;\n$fa-var-face-rolling-eyes: \\f5a5;\n$fa-var-meh-rolling-eyes: \\f5a5;\n$fa-var-face-sad-cry: \\f5b3;\n$fa-var-sad-cry: \\f5b3;\n$fa-var-face-sad-sweat: \\e38a;\n$fa-var-face-sad-tear: \\f5b4;\n$fa-var-sad-tear: \\f5b4;\n$fa-var-face-scream: \\e38b;\n$fa-var-face-shush: \\e38c;\n$fa-var-face-sleeping: \\e38d;\n$fa-var-face-sleepy: \\e38e;\n$fa-var-face-smile: \\f118;\n$fa-var-smile: \\f118;\n$fa-var-face-smile-beam: \\f5b8;\n$fa-var-smile-beam: \\f5b8;\n$fa-var-face-smile-halo: \\e38f;\n$fa-var-face-smile-hearts: \\e390;\n$fa-var-face-smile-horns: \\e391;\n$fa-var-face-smile-plus: \\f5b9;\n$fa-var-smile-plus: \\f5b9;\n$fa-var-face-smile-relaxed: \\e392;\n$fa-var-face-smile-tear: \\e393;\n$fa-var-face-smile-tongue: \\e394;\n$fa-var-face-smile-upside-down: \\e395;\n$fa-var-face-smile-wink: \\f4da;\n$fa-var-smile-wink: \\f4da;\n$fa-var-face-smiling-hands: \\e396;\n$fa-var-face-smirking: \\e397;\n$fa-var-face-sunglasses: \\e398;\n$fa-var-face-surprise: \\f5c2;\n$fa-var-surprise: \\f5c2;\n$fa-var-face-swear: \\e399;\n$fa-var-face-thermometer: \\e39a;\n$fa-var-face-thinking: \\e39b;\n$fa-var-face-tired: \\f5c8;\n$fa-var-tired: \\f5c8;\n$fa-var-face-tissue: \\e39c;\n$fa-var-face-tongue-money: \\e39d;\n$fa-var-face-tongue-sweat: \\e39e;\n$fa-var-face-unamused: \\e39f;\n$fa-var-face-viewfinder: \\e2ff;\n$fa-var-face-vomit: \\e3a0;\n$fa-var-face-weary: \\e3a1;\n$fa-var-face-woozy: \\e3a2;\n$fa-var-face-worried: \\e3a3;\n$fa-var-face-zany: \\e3a4;\n$fa-var-face-zipper: \\e3a5;\n$fa-var-falafel: \\e40a;\n$fa-var-family: \\e300;\n$fa-var-family-dress: \\e301;\n$fa-var-family-pants: \\e302;\n$fa-var-fan: \\f863;\n$fa-var-fan-table: \\e004;\n$fa-var-farm: \\f864;\n$fa-var-barn-silo: \\f864;\n$fa-var-faucet: \\e005;\n$fa-var-faucet-drip: \\e006;\n$fa-var-fax: \\f1ac;\n$fa-var-feather: \\f52d;\n$fa-var-feather-pointed: \\f56b;\n$fa-var-feather-alt: \\f56b;\n$fa-var-fence: \\e303;\n$fa-var-ferris-wheel: \\e174;\n$fa-var-field-hockey-stick-ball: \\f44c;\n$fa-var-field-hockey: \\f44c;\n$fa-var-file: \\f15b;\n$fa-var-file-arrow-down: \\f56d;\n$fa-var-file-download: \\f56d;\n$fa-var-file-arrow-up: \\f574;\n$fa-var-file-upload: \\f574;\n$fa-var-file-audio: \\f1c7;\n$fa-var-file-binary: \\e175;\n$fa-var-file-certificate: \\f5f3;\n$fa-var-file-award: \\f5f3;\n$fa-var-file-chart-column: \\f659;\n$fa-var-file-chart-line: \\f659;\n$fa-var-file-chart-pie: \\f65a;\n$fa-var-file-check: \\f316;\n$fa-var-file-code: \\f1c9;\n$fa-var-file-contract: \\f56c;\n$fa-var-file-csv: \\f6dd;\n$fa-var-file-dashed-line: \\f877;\n$fa-var-page-break: \\f877;\n$fa-var-file-excel: \\f1c3;\n$fa-var-file-exclamation: \\f31a;\n$fa-var-file-export: \\f56e;\n$fa-var-arrow-right-from-file: \\f56e;\n$fa-var-file-heart: \\e176;\n$fa-var-file-image: \\f1c5;\n$fa-var-file-import: \\f56f;\n$fa-var-arrow-right-to-file: \\f56f;\n$fa-var-file-invoice: \\f570;\n$fa-var-file-invoice-dollar: \\f571;\n$fa-var-file-lines: \\f15c;\n$fa-var-file-alt: \\f15c;\n$fa-var-file-text: \\f15c;\n$fa-var-file-lock: \\e3a6;\n$fa-var-file-magnifying-glass: \\f865;\n$fa-var-file-search: \\f865;\n$fa-var-file-medical: \\f477;\n$fa-var-file-minus: \\f318;\n$fa-var-file-music: \\f8b6;\n$fa-var-file-pdf: \\f1c1;\n$fa-var-file-pen: \\f31c;\n$fa-var-file-edit: \\f31c;\n$fa-var-file-plus: \\f319;\n$fa-var-file-plus-minus: \\e177;\n$fa-var-file-powerpoint: \\f1c4;\n$fa-var-file-prescription: \\f572;\n$fa-var-file-signature: \\f573;\n$fa-var-file-slash: \\e3a7;\n$fa-var-file-spreadsheet: \\f65b;\n$fa-var-file-user: \\f65c;\n$fa-var-file-video: \\f1c8;\n$fa-var-file-waveform: \\f478;\n$fa-var-file-medical-alt: \\f478;\n$fa-var-file-word: \\f1c2;\n$fa-var-file-xmark: \\f317;\n$fa-var-file-times: \\f317;\n$fa-var-file-zipper: \\f1c6;\n$fa-var-file-archive: \\f1c6;\n$fa-var-files: \\e178;\n$fa-var-files-medical: \\f7fd;\n$fa-var-fill: \\f575;\n$fa-var-fill-drip: \\f576;\n$fa-var-film: \\f008;\n$fa-var-film-canister: \\f8b7;\n$fa-var-film-simple: \\f3a0;\n$fa-var-film-alt: \\f3a0;\n$fa-var-film-slash: \\e179;\n$fa-var-films: \\e17a;\n$fa-var-filter: \\f0b0;\n$fa-var-filter-circle-dollar: \\f662;\n$fa-var-funnel-dollar: \\f662;\n$fa-var-filter-circle-xmark: \\e17b;\n$fa-var-filter-list: \\e17c;\n$fa-var-filter-slash: \\e17d;\n$fa-var-filters: \\e17e;\n$fa-var-fingerprint: \\f577;\n$fa-var-fire: \\f06d;\n$fa-var-fire-extinguisher: \\f134;\n$fa-var-fire-flame: \\f6df;\n$fa-var-flame: \\f6df;\n$fa-var-fire-flame-curved: \\f7e4;\n$fa-var-fire-alt: \\f7e4;\n$fa-var-fire-flame-simple: \\f46a;\n$fa-var-burn: \\f46a;\n$fa-var-fire-hydrant: \\e17f;\n$fa-var-fire-smoke: \\f74b;\n$fa-var-fireplace: \\f79a;\n$fa-var-fish: \\f578;\n$fa-var-fish-bones: \\e304;\n$fa-var-fish-cooked: \\f7fe;\n$fa-var-fishing-rod: \\e3a8;\n$fa-var-flag: \\f024;\n$fa-var-flag-checkered: \\f11e;\n$fa-var-flag-pennant: \\f456;\n$fa-var-pennant: \\f456;\n$fa-var-flag-swallowtail: \\f74c;\n$fa-var-flag-alt: \\f74c;\n$fa-var-flag-usa: \\f74d;\n$fa-var-flashlight: \\f8b8;\n$fa-var-flask: \\f0c3;\n$fa-var-flask-round-poison: \\f6e0;\n$fa-var-flask-poison: \\f6e0;\n$fa-var-flask-round-potion: \\f6e1;\n$fa-var-flask-potion: \\f6e1;\n$fa-var-flatbread: \\e40b;\n$fa-var-flatbread-stuffed: \\e40c;\n$fa-var-floppy-disk: \\f0c7;\n$fa-var-save: \\f0c7;\n$fa-var-floppy-disk-circle-arrow-right: \\e180;\n$fa-var-save-circle-arrow-right: \\e180;\n$fa-var-floppy-disk-circle-xmark: \\e181;\n$fa-var-floppy-disk-times: \\e181;\n$fa-var-save-circle-xmark: \\e181;\n$fa-var-save-times: \\e181;\n$fa-var-floppy-disk-pen: \\e182;\n$fa-var-floppy-disks: \\e183;\n$fa-var-florin-sign: \\e184;\n$fa-var-flower: \\f7ff;\n$fa-var-flower-daffodil: \\f800;\n$fa-var-flower-tulip: \\f801;\n$fa-var-flute: \\f8b9;\n$fa-var-flux-capacitor: \\f8ba;\n$fa-var-flying-disc: \\e3a9;\n$fa-var-folder: \\f07b;\n$fa-var-folder-arrow-down: \\e053;\n$fa-var-folder-download: \\e053;\n$fa-var-folder-arrow-up: \\e054;\n$fa-var-folder-upload: \\e054;\n$fa-var-folder-blank: \\e185;\n$fa-var-folder-bookmark: \\e186;\n$fa-var-folder-gear: \\e187;\n$fa-var-folder-cog: \\e187;\n$fa-var-folder-grid: \\e188;\n$fa-var-folder-heart: \\e189;\n$fa-var-folder-image: \\e18a;\n$fa-var-folder-magnifying-glass: \\e18b;\n$fa-var-folder-search: \\e18b;\n$fa-var-folder-medical: \\e18c;\n$fa-var-folder-minus: \\f65d;\n$fa-var-folder-music: \\e18d;\n$fa-var-folder-open: \\f07c;\n$fa-var-folder-plus: \\f65e;\n$fa-var-folder-tree: \\f802;\n$fa-var-folder-user: \\e18e;\n$fa-var-folder-xmark: \\f65f;\n$fa-var-folder-times: \\f65f;\n$fa-var-folders: \\f660;\n$fa-var-fondue-pot: \\e40d;\n$fa-var-font: \\f031;\n$fa-var-font-case: \\f866;\n$fa-var-football: \\f44e;\n$fa-var-football-ball: \\f44e;\n$fa-var-football-helmet: \\f44f;\n$fa-var-fork: \\f2e3;\n$fa-var-utensil-fork: \\f2e3;\n$fa-var-fork-knife: \\f2e6;\n$fa-var-utensils-alt: \\f2e6;\n$fa-var-forklift: \\f47a;\n$fa-var-forward: \\f04e;\n$fa-var-forward-fast: \\f050;\n$fa-var-fast-forward: \\f050;\n$fa-var-forward-step: \\f051;\n$fa-var-step-forward: \\f051;\n$fa-var-franc-sign: \\e18f;\n$fa-var-french-fries: \\f803;\n$fa-var-frog: \\f52e;\n$fa-var-function: \\f661;\n$fa-var-futbol: \\f1e3;\n$fa-var-futbol-ball: \\f1e3;\n$fa-var-soccer-ball: \\f1e3;\n$fa-var-g: \\47;\n$fa-var-galaxy: \\e008;\n$fa-var-gallery-thumbnails: \\e3aa;\n$fa-var-game-board: \\f867;\n$fa-var-game-board-simple: \\f868;\n$fa-var-game-board-alt: \\f868;\n$fa-var-game-console-handheld: \\f8bb;\n$fa-var-gamepad: \\f11b;\n$fa-var-gamepad-modern: \\f8bc;\n$fa-var-gamepad-alt: \\f8bc;\n$fa-var-garage: \\e009;\n$fa-var-garage-car: \\e00a;\n$fa-var-garage-open: \\e00b;\n$fa-var-garlic: \\e40e;\n$fa-var-gas-pump: \\f52f;\n$fa-var-gas-pump-slash: \\f5f4;\n$fa-var-gauge: \\f625;\n$fa-var-dashboard: \\f625;\n$fa-var-gauge-high: \\f625;\n$fa-var-tachometer-alt: \\f625;\n$fa-var-tachometer-alt-fast: \\f625;\n$fa-var-gauge-low: \\f627;\n$fa-var-tachometer-alt-slow: \\f627;\n$fa-var-gauge-max: \\f626;\n$fa-var-tachometer-alt-fastest: \\f626;\n$fa-var-gauge-med: \\f624;\n$fa-var-tachometer-alt-average: \\f624;\n$fa-var-gauge-min: \\f628;\n$fa-var-tachometer-alt-slowest: \\f628;\n$fa-var-gauge-simple: \\f62a;\n$fa-var-gauge-simple-high: \\f62a;\n$fa-var-tachometer: \\f62a;\n$fa-var-gauge-simple-low: \\f62c;\n$fa-var-tachometer-slow: \\f62c;\n$fa-var-gauge-simple-max: \\f62b;\n$fa-var-tachometer-fastest: \\f62b;\n$fa-var-gauge-simple-med: \\f629;\n$fa-var-tachometer-average: \\f629;\n$fa-var-gauge-simple-min: \\f62d;\n$fa-var-tachometer-slowest: \\f62d;\n$fa-var-gavel: \\f0e3;\n$fa-var-legal: \\f0e3;\n$fa-var-gear: \\f013;\n$fa-var-cog: \\f013;\n$fa-var-gears: \\f085;\n$fa-var-cogs: \\f085;\n$fa-var-gem: \\f3a5;\n$fa-var-genderless: \\f22d;\n$fa-var-ghost: \\f6e2;\n$fa-var-gif: \\e190;\n$fa-var-gift: \\f06b;\n$fa-var-gift-card: \\f663;\n$fa-var-gifts: \\f79c;\n$fa-var-gingerbread-man: \\f79d;\n$fa-var-glass: \\f804;\n$fa-var-glass-citrus: \\f869;\n$fa-var-glass-empty: \\e191;\n$fa-var-glass-half: \\e192;\n$fa-var-glass-half-empty: \\e192;\n$fa-var-glass-half-full: \\e192;\n$fa-var-glasses: \\f530;\n$fa-var-glasses-round: \\f5f5;\n$fa-var-glasses-alt: \\f5f5;\n$fa-var-globe: \\f0ac;\n$fa-var-globe-snow: \\f7a3;\n$fa-var-globe-stand: \\f5f6;\n$fa-var-goal-net: \\e3ab;\n$fa-var-golf-ball-tee: \\f450;\n$fa-var-golf-ball: \\f450;\n$fa-var-golf-club: \\f451;\n$fa-var-golf-flag-hole: \\e3ac;\n$fa-var-gopuram: \\f664;\n$fa-var-graduation-cap: \\f19d;\n$fa-var-mortar-board: \\f19d;\n$fa-var-gramophone: \\f8bd;\n$fa-var-grapes: \\e306;\n$fa-var-grate: \\e193;\n$fa-var-grate-droplet: \\e194;\n$fa-var-greater-than: \\3e;\n$fa-var-greater-than-equal: \\f532;\n$fa-var-grid: \\e195;\n$fa-var-grid-3: \\e195;\n$fa-var-grid-2: \\e196;\n$fa-var-grid-2-plus: \\e197;\n$fa-var-grid-4: \\e198;\n$fa-var-grid-5: \\e199;\n$fa-var-grid-dividers: \\e3ad;\n$fa-var-grid-horizontal: \\e307;\n$fa-var-grip: \\f58d;\n$fa-var-grip-horizontal: \\f58d;\n$fa-var-grip-dots: \\e410;\n$fa-var-grip-dots-vertical: \\e411;\n$fa-var-grip-lines: \\f7a4;\n$fa-var-grip-lines-vertical: \\f7a5;\n$fa-var-grip-vertical: \\f58e;\n$fa-var-guarani-sign: \\e19a;\n$fa-var-guitar: \\f7a6;\n$fa-var-guitar-electric: \\f8be;\n$fa-var-guitars: \\f8bf;\n$fa-var-gun: \\e19b;\n$fa-var-gun-slash: \\e19c;\n$fa-var-gun-squirt: \\e19d;\n$fa-var-h: \\48;\n$fa-var-h1: \\f313;\n$fa-var-h2: \\f314;\n$fa-var-h3: \\f315;\n$fa-var-h4: \\f86a;\n$fa-var-h5: \\e412;\n$fa-var-h6: \\e413;\n$fa-var-hammer: \\f6e3;\n$fa-var-hammer-crash: \\e414;\n$fa-var-hammer-war: \\f6e4;\n$fa-var-hamsa: \\f665;\n$fa-var-hand: \\f256;\n$fa-var-hand-paper: \\f256;\n$fa-var-hand-back-fist: \\f255;\n$fa-var-hand-rock: \\f255;\n$fa-var-hand-back-point-down: \\e19e;\n$fa-var-hand-back-point-left: \\e19f;\n$fa-var-hand-back-point-ribbon: \\e1a0;\n$fa-var-hand-back-point-right: \\e1a1;\n$fa-var-hand-back-point-up: \\e1a2;\n$fa-var-hand-dots: \\f461;\n$fa-var-allergies: \\f461;\n$fa-var-hand-fingers-crossed: \\e1a3;\n$fa-var-hand-fist: \\f6de;\n$fa-var-fist-raised: \\f6de;\n$fa-var-hand-heart: \\f4bc;\n$fa-var-hand-holding: \\f4bd;\n$fa-var-hand-holding-box: \\f47b;\n$fa-var-hand-holding-dollar: \\f4c0;\n$fa-var-hand-holding-usd: \\f4c0;\n$fa-var-hand-holding-droplet: \\f4c1;\n$fa-var-hand-holding-water: \\f4c1;\n$fa-var-hand-holding-heart: \\f4be;\n$fa-var-hand-holding-magic: \\f6e5;\n$fa-var-hand-holding-medical: \\e05c;\n$fa-var-hand-holding-seedling: \\f4bf;\n$fa-var-hand-holding-skull: \\e1a4;\n$fa-var-hand-horns: \\e1a9;\n$fa-var-hand-lizard: \\f258;\n$fa-var-hand-love: \\e1a5;\n$fa-var-hand-middle-finger: \\f806;\n$fa-var-hand-peace: \\f25b;\n$fa-var-hand-point-down: \\f0a7;\n$fa-var-hand-point-left: \\f0a5;\n$fa-var-hand-point-ribbon: \\e1a6;\n$fa-var-hand-point-right: \\f0a4;\n$fa-var-hand-point-up: \\f0a6;\n$fa-var-hand-pointer: \\f25a;\n$fa-var-hand-scissors: \\f257;\n$fa-var-hand-sparkles: \\e05d;\n$fa-var-hand-spock: \\f259;\n$fa-var-hand-wave: \\e1a7;\n$fa-var-hands: \\f2a7;\n$fa-var-sign-language: \\f2a7;\n$fa-var-signing: \\f2a7;\n$fa-var-hands-asl-interpreting: \\f2a3;\n$fa-var-american-sign-language-interpreting: \\f2a3;\n$fa-var-asl-interpreting: \\f2a3;\n$fa-var-hands-american-sign-language-interpreting: \\f2a3;\n$fa-var-hands-bubbles: \\e05e;\n$fa-var-hands-wash: \\e05e;\n$fa-var-hands-clapping: \\e1a8;\n$fa-var-hands-holding: \\f4c2;\n$fa-var-hands-holding-diamond: \\f47c;\n$fa-var-hand-receiving: \\f47c;\n$fa-var-hands-holding-dollar: \\f4c5;\n$fa-var-hands-usd: \\f4c5;\n$fa-var-hands-holding-heart: \\f4c3;\n$fa-var-hands-heart: \\f4c3;\n$fa-var-hands-praying: \\f684;\n$fa-var-praying-hands: \\f684;\n$fa-var-handshake: \\f2b5;\n$fa-var-handshake-angle: \\f4c4;\n$fa-var-hands-helping: \\f4c4;\n$fa-var-handshake-simple: \\f4c6;\n$fa-var-handshake-alt: \\f4c6;\n$fa-var-handshake-simple-slash: \\e05f;\n$fa-var-handshake-alt-slash: \\e05f;\n$fa-var-handshake-slash: \\e060;\n$fa-var-hanukiah: \\f6e6;\n$fa-var-hard-drive: \\f0a0;\n$fa-var-hdd: \\f0a0;\n$fa-var-hashtag: \\23;\n$fa-var-hashtag-lock: \\e415;\n$fa-var-hat-chef: \\f86b;\n$fa-var-hat-cowboy: \\f8c0;\n$fa-var-hat-cowboy-side: \\f8c1;\n$fa-var-hat-santa: \\f7a7;\n$fa-var-hat-winter: \\f7a8;\n$fa-var-hat-witch: \\f6e7;\n$fa-var-hat-wizard: \\f6e8;\n$fa-var-head-side: \\f6e9;\n$fa-var-head-side-brain: \\f808;\n$fa-var-head-side-cough: \\e061;\n$fa-var-head-side-cough-slash: \\e062;\n$fa-var-head-side-goggles: \\f6ea;\n$fa-var-head-vr: \\f6ea;\n$fa-var-head-side-headphones: \\f8c2;\n$fa-var-head-side-heart: \\e1aa;\n$fa-var-head-side-mask: \\e063;\n$fa-var-head-side-medical: \\f809;\n$fa-var-head-side-virus: \\e064;\n$fa-var-heading: \\f1dc;\n$fa-var-header: \\f1dc;\n$fa-var-headphones: \\f025;\n$fa-var-headphones-simple: \\f58f;\n$fa-var-headphones-alt: \\f58f;\n$fa-var-headset: \\f590;\n$fa-var-heart: \\f004;\n$fa-var-heart-crack: \\f7a9;\n$fa-var-heart-broken: \\f7a9;\n$fa-var-heart-half: \\e1ab;\n$fa-var-heart-half-stroke: \\e1ac;\n$fa-var-heart-half-alt: \\e1ac;\n$fa-var-heart-pulse: \\f21e;\n$fa-var-heartbeat: \\f21e;\n$fa-var-heat: \\e00c;\n$fa-var-helicopter: \\f533;\n$fa-var-helmet-battle: \\f6eb;\n$fa-var-helmet-safety: \\f807;\n$fa-var-hard-hat: \\f807;\n$fa-var-hat-hard: \\f807;\n$fa-var-hexagon: \\f312;\n$fa-var-hexagon-check: \\e416;\n$fa-var-hexagon-divide: \\e1ad;\n$fa-var-hexagon-exclamation: \\e417;\n$fa-var-hexagon-minus: \\f307;\n$fa-var-minus-hexagon: \\f307;\n$fa-var-hexagon-plus: \\f300;\n$fa-var-plus-hexagon: \\f300;\n$fa-var-hexagon-xmark: \\f2ee;\n$fa-var-times-hexagon: \\f2ee;\n$fa-var-xmark-hexagon: \\f2ee;\n$fa-var-high-definition: \\e1ae;\n$fa-var-rectangle-hd: \\e1ae;\n$fa-var-highlighter: \\f591;\n$fa-var-highlighter-line: \\e1af;\n$fa-var-hippo: \\f6ed;\n$fa-var-hockey-mask: \\f6ee;\n$fa-var-hockey-puck: \\f453;\n$fa-var-hockey-stick-puck: \\e3ae;\n$fa-var-hockey-sticks: \\f454;\n$fa-var-holly-berry: \\f7aa;\n$fa-var-honey-pot: \\e418;\n$fa-var-hood-cloak: \\f6ef;\n$fa-var-horizontal-rule: \\f86c;\n$fa-var-horse: \\f6f0;\n$fa-var-horse-head: \\f7ab;\n$fa-var-horse-saddle: \\f8c3;\n$fa-var-hose: \\e419;\n$fa-var-hose-reel: \\e41a;\n$fa-var-hospital: \\f0f8;\n$fa-var-hospital-user: \\f80d;\n$fa-var-hospital-wide: \\f47d;\n$fa-var-hospital-alt: \\f47d;\n$fa-var-hospitals: \\f80e;\n$fa-var-hot-tub-person: \\f593;\n$fa-var-hot-tub: \\f593;\n$fa-var-hotdog: \\f80f;\n$fa-var-hotel: \\f594;\n$fa-var-hourglass: \\f254;\n$fa-var-hourglass-2: \\f254;\n$fa-var-hourglass-half: \\f254;\n$fa-var-hourglass-clock: \\e41b;\n$fa-var-hourglass-empty: \\f252;\n$fa-var-hourglass-end: \\f253;\n$fa-var-hourglass-3: \\f253;\n$fa-var-hourglass-start: \\f251;\n$fa-var-hourglass-1: \\f251;\n$fa-var-house: \\f015;\n$fa-var-home: \\f015;\n$fa-var-house-blank: \\f80a;\n$fa-var-home-blank: \\f80a;\n$fa-var-home-lg-alt: \\f80a;\n$fa-var-house-building: \\e1b1;\n$fa-var-house-chimney: \\e3af;\n$fa-var-home-lg: \\e3af;\n$fa-var-house-chimney-blank: \\e3b0;\n$fa-var-house-chimney-crack: \\f6f1;\n$fa-var-house-damage: \\f6f1;\n$fa-var-house-chimney-heart: \\e1b2;\n$fa-var-house-chimney-medical: \\f7f2;\n$fa-var-clinic-medical: \\f7f2;\n$fa-var-house-chimney-user: \\e065;\n$fa-var-house-chimney-window: \\e00d;\n$fa-var-house-crack: \\e3b1;\n$fa-var-house-day: \\e00e;\n$fa-var-house-flood: \\f74f;\n$fa-var-house-heart: \\f4c9;\n$fa-var-home-heart: \\f4c9;\n$fa-var-house-laptop: \\e066;\n$fa-var-laptop-house: \\e066;\n$fa-var-house-medical: \\e3b2;\n$fa-var-house-night: \\e010;\n$fa-var-house-person-leave: \\e00f;\n$fa-var-house-person-depart: \\e00f;\n$fa-var-house-person-return: \\e011;\n$fa-var-house-person-arrive: \\e011;\n$fa-var-house-signal: \\e012;\n$fa-var-house-tree: \\e1b3;\n$fa-var-house-turret: \\e1b4;\n$fa-var-house-user: \\e1b0;\n$fa-var-home-user: \\e1b0;\n$fa-var-house-window: \\e3b3;\n$fa-var-hryvnia-sign: \\f6f2;\n$fa-var-hryvnia: \\f6f2;\n$fa-var-hundred-points: \\e41c;\n$fa-var-100: \\e41c;\n$fa-var-hurricane: \\f751;\n$fa-var-hyphen: \\2d;\n$fa-var-i: \\49;\n$fa-var-i-cursor: \\f246;\n$fa-var-ice-cream: \\f810;\n$fa-var-ice-skate: \\f7ac;\n$fa-var-icicles: \\f7ad;\n$fa-var-icons: \\f86d;\n$fa-var-heart-music-camera-bolt: \\f86d;\n$fa-var-id-badge: \\f2c1;\n$fa-var-id-card: \\f2c2;\n$fa-var-drivers-license: \\f2c2;\n$fa-var-id-card-clip: \\f47f;\n$fa-var-id-card-alt: \\f47f;\n$fa-var-igloo: \\f7ae;\n$fa-var-image: \\f03e;\n$fa-var-image-landscape: \\e1b5;\n$fa-var-landscape: \\e1b5;\n$fa-var-image-polaroid: \\f8c4;\n$fa-var-image-polaroid-user: \\e1b6;\n$fa-var-image-portrait: \\f3e0;\n$fa-var-portrait: \\f3e0;\n$fa-var-image-slash: \\e1b7;\n$fa-var-image-user: \\e1b8;\n$fa-var-images: \\f302;\n$fa-var-images-user: \\e1b9;\n$fa-var-inbox: \\f01c;\n$fa-var-inbox-full: \\e1ba;\n$fa-var-inbox-in: \\f310;\n$fa-var-inbox-arrow-down: \\f310;\n$fa-var-inbox-out: \\f311;\n$fa-var-inbox-arrow-up: \\f311;\n$fa-var-inboxes: \\e1bb;\n$fa-var-indent: \\f03c;\n$fa-var-indian-rupee-sign: \\e1bc;\n$fa-var-indian-rupee: \\e1bc;\n$fa-var-inr: \\e1bc;\n$fa-var-industry: \\f275;\n$fa-var-industry-windows: \\f3b3;\n$fa-var-industry-alt: \\f3b3;\n$fa-var-infinity: \\f534;\n$fa-var-info: \\f129;\n$fa-var-inhaler: \\f5f9;\n$fa-var-input-numeric: \\e1bd;\n$fa-var-input-pipe: \\e1be;\n$fa-var-input-text: \\e1bf;\n$fa-var-integral: \\f667;\n$fa-var-intersection: \\f668;\n$fa-var-island-tropical: \\f811;\n$fa-var-island-tree-palm: \\f811;\n$fa-var-italic: \\f033;\n$fa-var-j: \\4a;\n$fa-var-jack-o-lantern: \\f30e;\n$fa-var-jedi: \\f669;\n$fa-var-jet-fighter: \\f0fb;\n$fa-var-fighter-jet: \\f0fb;\n$fa-var-joint: \\f595;\n$fa-var-joystick: \\f8c5;\n$fa-var-jug: \\f8c6;\n$fa-var-k: \\4b;\n$fa-var-kaaba: \\f66b;\n$fa-var-kazoo: \\f8c7;\n$fa-var-kerning: \\f86f;\n$fa-var-key: \\f084;\n$fa-var-key-skeleton: \\f6f3;\n$fa-var-key-skeleton-left-right: \\e3b4;\n$fa-var-keyboard: \\f11c;\n$fa-var-keyboard-brightness: \\e1c0;\n$fa-var-keyboard-brightness-low: \\e1c1;\n$fa-var-keyboard-down: \\e1c2;\n$fa-var-keyboard-left: \\e1c3;\n$fa-var-keynote: \\f66c;\n$fa-var-khanda: \\f66d;\n$fa-var-kidneys: \\f5fb;\n$fa-var-kip-sign: \\e1c4;\n$fa-var-kit-medical: \\f479;\n$fa-var-first-aid: \\f479;\n$fa-var-kite: \\f6f4;\n$fa-var-kiwi-bird: \\f535;\n$fa-var-kiwi-fruit: \\e30c;\n$fa-var-knife: \\f2e4;\n$fa-var-utensil-knife: \\f2e4;\n$fa-var-knife-kitchen: \\f6f5;\n$fa-var-l: \\4c;\n$fa-var-lacrosse-stick: \\e3b5;\n$fa-var-lacrosse-stick-ball: \\e3b6;\n$fa-var-lambda: \\f66e;\n$fa-var-lamp: \\f4ca;\n$fa-var-lamp-desk: \\e014;\n$fa-var-lamp-floor: \\e015;\n$fa-var-lamp-street: \\e1c5;\n$fa-var-landmark: \\f66f;\n$fa-var-landmark-dome: \\f752;\n$fa-var-landmark-alt: \\f752;\n$fa-var-language: \\f1ab;\n$fa-var-laptop: \\f109;\n$fa-var-laptop-arrow-down: \\e1c6;\n$fa-var-laptop-code: \\f5fc;\n$fa-var-laptop-medical: \\f812;\n$fa-var-laptop-mobile: \\f87a;\n$fa-var-phone-laptop: \\f87a;\n$fa-var-laptop-slash: \\e1c7;\n$fa-var-lari-sign: \\e1c8;\n$fa-var-lasso: \\f8c8;\n$fa-var-lasso-sparkles: \\e1c9;\n$fa-var-layer-group: \\f5fd;\n$fa-var-layer-minus: \\f5fe;\n$fa-var-layer-group-minus: \\f5fe;\n$fa-var-layer-plus: \\f5ff;\n$fa-var-layer-group-plus: \\f5ff;\n$fa-var-leaf: \\f06c;\n$fa-var-leaf-heart: \\f4cb;\n$fa-var-leaf-maple: \\f6f6;\n$fa-var-leaf-oak: \\f6f7;\n$fa-var-leafy-green: \\e41d;\n$fa-var-left: \\f355;\n$fa-var-arrow-alt-left: \\f355;\n$fa-var-left-from-line: \\f348;\n$fa-var-arrow-alt-from-right: \\f348;\n$fa-var-left-long: \\f30a;\n$fa-var-long-arrow-alt-left: \\f30a;\n$fa-var-left-long-to-line: \\e41e;\n$fa-var-left-right: \\f337;\n$fa-var-arrows-alt-h: \\f337;\n$fa-var-left-to-line: \\f34b;\n$fa-var-arrow-alt-to-left: \\f34b;\n$fa-var-lemon: \\f094;\n$fa-var-less-than: \\3c;\n$fa-var-less-than-equal: \\f537;\n$fa-var-life-ring: \\f1cd;\n$fa-var-light-ceiling: \\e016;\n$fa-var-light-emergency: \\e41f;\n$fa-var-light-emergency-on: \\e420;\n$fa-var-light-switch: \\e017;\n$fa-var-light-switch-off: \\e018;\n$fa-var-light-switch-on: \\e019;\n$fa-var-lightbulb: \\f0eb;\n$fa-var-lightbulb-dollar: \\f670;\n$fa-var-lightbulb-exclamation: \\f671;\n$fa-var-lightbulb-exclamation-on: \\e1ca;\n$fa-var-lightbulb-on: \\f672;\n$fa-var-lightbulb-slash: \\f673;\n$fa-var-lights-holiday: \\f7b2;\n$fa-var-line-columns: \\f870;\n$fa-var-line-height: \\f871;\n$fa-var-link: \\f0c1;\n$fa-var-chain: \\f0c1;\n$fa-var-link-horizontal: \\e1cb;\n$fa-var-chain-horizontal: \\e1cb;\n$fa-var-link-horizontal-slash: \\e1cc;\n$fa-var-chain-horizontal-slash: \\e1cc;\n$fa-var-link-simple: \\e1cd;\n$fa-var-link-simple-slash: \\e1ce;\n$fa-var-link-slash: \\f127;\n$fa-var-chain-broken: \\f127;\n$fa-var-chain-slash: \\f127;\n$fa-var-unlink: \\f127;\n$fa-var-lips: \\f600;\n$fa-var-lira-sign: \\f195;\n$fa-var-list: \\f03a;\n$fa-var-list-squares: \\f03a;\n$fa-var-list-check: \\f0ae;\n$fa-var-tasks: \\f0ae;\n$fa-var-list-dropdown: \\e1cf;\n$fa-var-list-music: \\f8c9;\n$fa-var-list-ol: \\f0cb;\n$fa-var-list-1-2: \\f0cb;\n$fa-var-list-numeric: \\f0cb;\n$fa-var-list-radio: \\e1d0;\n$fa-var-list-timeline: \\e1d1;\n$fa-var-list-tree: \\e1d2;\n$fa-var-list-ul: \\f0ca;\n$fa-var-list-dots: \\f0ca;\n$fa-var-litecoin-sign: \\e1d3;\n$fa-var-loader: \\e1d4;\n$fa-var-lobster: \\e421;\n$fa-var-location-arrow: \\f124;\n$fa-var-location-check: \\f606;\n$fa-var-map-marker-check: \\f606;\n$fa-var-location-crosshairs: \\f601;\n$fa-var-location: \\f601;\n$fa-var-location-crosshairs-slash: \\f603;\n$fa-var-location-slash: \\f603;\n$fa-var-location-dot: \\f3c5;\n$fa-var-map-marker-alt: \\f3c5;\n$fa-var-location-dot-slash: \\f605;\n$fa-var-map-marker-alt-slash: \\f605;\n$fa-var-location-exclamation: \\f608;\n$fa-var-map-marker-exclamation: \\f608;\n$fa-var-location-minus: \\f609;\n$fa-var-map-marker-minus: \\f609;\n$fa-var-location-pen: \\f607;\n$fa-var-map-marker-edit: \\f607;\n$fa-var-location-pin: \\f041;\n$fa-var-map-marker: \\f041;\n$fa-var-location-pin-slash: \\f60c;\n$fa-var-map-marker-slash: \\f60c;\n$fa-var-location-plus: \\f60a;\n$fa-var-map-marker-plus: \\f60a;\n$fa-var-location-question: \\f60b;\n$fa-var-map-marker-question: \\f60b;\n$fa-var-location-smile: \\f60d;\n$fa-var-map-marker-smile: \\f60d;\n$fa-var-location-xmark: \\f60e;\n$fa-var-map-marker-times: \\f60e;\n$fa-var-map-marker-xmark: \\f60e;\n$fa-var-lock: \\f023;\n$fa-var-lock-a: \\e422;\n$fa-var-lock-hashtag: \\e423;\n$fa-var-lock-keyhole: \\f30d;\n$fa-var-lock-alt: \\f30d;\n$fa-var-lock-keyhole-open: \\f3c2;\n$fa-var-lock-open-alt: \\f3c2;\n$fa-var-lock-open: \\f3c1;\n$fa-var-lollipop: \\e424;\n$fa-var-lollypop: \\e424;\n$fa-var-loveseat: \\f4cc;\n$fa-var-couch-small: \\f4cc;\n$fa-var-luchador-mask: \\f455;\n$fa-var-luchador: \\f455;\n$fa-var-mask-luchador: \\f455;\n$fa-var-lungs: \\f604;\n$fa-var-lungs-virus: \\e067;\n$fa-var-m: \\4d;\n$fa-var-mace: \\f6f8;\n$fa-var-magnet: \\f076;\n$fa-var-magnifying-glass: \\f002;\n$fa-var-search: \\f002;\n$fa-var-magnifying-glass-dollar: \\f688;\n$fa-var-search-dollar: \\f688;\n$fa-var-magnifying-glass-location: \\f689;\n$fa-var-search-location: \\f689;\n$fa-var-magnifying-glass-minus: \\f010;\n$fa-var-search-minus: \\f010;\n$fa-var-magnifying-glass-plus: \\f00e;\n$fa-var-search-plus: \\f00e;\n$fa-var-mailbox: \\f813;\n$fa-var-manat-sign: \\e1d5;\n$fa-var-mandolin: \\f6f9;\n$fa-var-mango: \\e30f;\n$fa-var-manhole: \\e1d6;\n$fa-var-map: \\f279;\n$fa-var-map-location: \\f59f;\n$fa-var-map-marked: \\f59f;\n$fa-var-map-location-dot: \\f5a0;\n$fa-var-map-marked-alt: \\f5a0;\n$fa-var-map-pin: \\f276;\n$fa-var-marker: \\f5a1;\n$fa-var-mars: \\f222;\n$fa-var-mars-and-venus: \\f224;\n$fa-var-mars-double: \\f227;\n$fa-var-mars-stroke: \\f229;\n$fa-var-mars-stroke-right: \\f22b;\n$fa-var-mars-stroke-h: \\f22b;\n$fa-var-mars-stroke-up: \\f22a;\n$fa-var-mars-stroke-v: \\f22a;\n$fa-var-martini-glass: \\f57b;\n$fa-var-glass-martini-alt: \\f57b;\n$fa-var-martini-glass-citrus: \\f561;\n$fa-var-cocktail: \\f561;\n$fa-var-martini-glass-empty: \\f000;\n$fa-var-glass-martini: \\f000;\n$fa-var-mask: \\f6fa;\n$fa-var-mask-face: \\e1d7;\n$fa-var-mask-snorkel: \\e3b7;\n$fa-var-masks-theater: \\f630;\n$fa-var-theater-masks: \\f630;\n$fa-var-maximize: \\f31e;\n$fa-var-expand-arrows-alt: \\f31e;\n$fa-var-meat: \\f814;\n$fa-var-medal: \\f5a2;\n$fa-var-megaphone: \\f675;\n$fa-var-melon: \\e310;\n$fa-var-melon-slice: \\e311;\n$fa-var-memo: \\e1d8;\n$fa-var-memo-circle-check: \\e1d9;\n$fa-var-memo-pad: \\e1da;\n$fa-var-memory: \\f538;\n$fa-var-menorah: \\f676;\n$fa-var-mercury: \\f223;\n$fa-var-message: \\f27a;\n$fa-var-comment-alt: \\f27a;\n$fa-var-message-arrow-down: \\e1db;\n$fa-var-comment-alt-arrow-down: \\e1db;\n$fa-var-message-arrow-up: \\e1dc;\n$fa-var-comment-alt-arrow-up: \\e1dc;\n$fa-var-message-arrow-up-right: \\e1dd;\n$fa-var-message-bot: \\e3b8;\n$fa-var-message-captions: \\e1de;\n$fa-var-comment-alt-captions: \\e1de;\n$fa-var-message-check: \\f4a2;\n$fa-var-comment-alt-check: \\f4a2;\n$fa-var-message-code: \\e1df;\n$fa-var-message-dollar: \\f650;\n$fa-var-comment-alt-dollar: \\f650;\n$fa-var-message-dots: \\f4a3;\n$fa-var-comment-alt-dots: \\f4a3;\n$fa-var-messaging: \\f4a3;\n$fa-var-message-exclamation: \\f4a5;\n$fa-var-comment-alt-exclamation: \\f4a5;\n$fa-var-message-image: \\e1e0;\n$fa-var-comment-alt-image: \\e1e0;\n$fa-var-message-lines: \\f4a6;\n$fa-var-comment-alt-lines: \\f4a6;\n$fa-var-message-medical: \\f7f4;\n$fa-var-comment-alt-medical: \\f7f4;\n$fa-var-message-middle: \\e1e1;\n$fa-var-comment-middle-alt: \\e1e1;\n$fa-var-message-middle-top: \\e1e2;\n$fa-var-comment-middle-top-alt: \\e1e2;\n$fa-var-message-minus: \\f4a7;\n$fa-var-comment-alt-minus: \\f4a7;\n$fa-var-message-music: \\f8af;\n$fa-var-comment-alt-music: \\f8af;\n$fa-var-message-pen: \\f4a4;\n$fa-var-comment-alt-edit: \\f4a4;\n$fa-var-message-edit: \\f4a4;\n$fa-var-message-plus: \\f4a8;\n$fa-var-comment-alt-plus: \\f4a8;\n$fa-var-message-question: \\e1e3;\n$fa-var-message-quote: \\e1e4;\n$fa-var-comment-alt-quote: \\e1e4;\n$fa-var-message-slash: \\f4a9;\n$fa-var-comment-alt-slash: \\f4a9;\n$fa-var-message-smile: \\f4aa;\n$fa-var-comment-alt-smile: \\f4aa;\n$fa-var-message-sms: \\e1e5;\n$fa-var-message-text: \\e1e6;\n$fa-var-comment-alt-text: \\e1e6;\n$fa-var-message-xmark: \\f4ab;\n$fa-var-comment-alt-times: \\f4ab;\n$fa-var-message-times: \\f4ab;\n$fa-var-messages: \\f4b6;\n$fa-var-comments-alt: \\f4b6;\n$fa-var-messages-dollar: \\f652;\n$fa-var-comments-alt-dollar: \\f652;\n$fa-var-messages-question: \\e1e7;\n$fa-var-meteor: \\f753;\n$fa-var-meter: \\e1e8;\n$fa-var-meter-bolt: \\e1e9;\n$fa-var-meter-droplet: \\e1ea;\n$fa-var-meter-fire: \\e1eb;\n$fa-var-microchip: \\f2db;\n$fa-var-microchip-ai: \\e1ec;\n$fa-var-microphone: \\f130;\n$fa-var-microphone-lines: \\f3c9;\n$fa-var-microphone-alt: \\f3c9;\n$fa-var-microphone-lines-slash: \\f539;\n$fa-var-microphone-alt-slash: \\f539;\n$fa-var-microphone-slash: \\f131;\n$fa-var-microphone-stand: \\f8cb;\n$fa-var-microscope: \\f610;\n$fa-var-microwave: \\e01b;\n$fa-var-mill-sign: \\e1ed;\n$fa-var-minimize: \\f78c;\n$fa-var-compress-arrows-alt: \\f78c;\n$fa-var-minus: \\f068;\n$fa-var-subtract: \\f068;\n$fa-var-mistletoe: \\f7b4;\n$fa-var-mitten: \\f7b5;\n$fa-var-mobile: \\f3ce;\n$fa-var-mobile-android: \\f3ce;\n$fa-var-mobile-phone: \\f3ce;\n$fa-var-mobile-button: \\f10b;\n$fa-var-mobile-notch: \\e1ee;\n$fa-var-mobile-iphone: \\e1ee;\n$fa-var-mobile-screen: \\f3cf;\n$fa-var-mobile-android-alt: \\f3cf;\n$fa-var-mobile-screen-button: \\f3cd;\n$fa-var-mobile-alt: \\f3cd;\n$fa-var-mobile-signal: \\e1ef;\n$fa-var-mobile-signal-out: \\e1f0;\n$fa-var-money-bill: \\f0d6;\n$fa-var-money-bill-1: \\f3d1;\n$fa-var-money-bill-alt: \\f3d1;\n$fa-var-money-bill-1-wave: \\f53b;\n$fa-var-money-bill-wave-alt: \\f53b;\n$fa-var-money-bill-simple: \\e1f1;\n$fa-var-money-bill-simple-wave: \\e1f2;\n$fa-var-money-bill-wave: \\f53a;\n$fa-var-money-bills: \\e1f3;\n$fa-var-money-bills-simple: \\e1f4;\n$fa-var-money-bills-alt: \\e1f4;\n$fa-var-money-check: \\f53c;\n$fa-var-money-check-dollar: \\f53d;\n$fa-var-money-check-alt: \\f53d;\n$fa-var-money-check-dollar-pen: \\f873;\n$fa-var-money-check-edit-alt: \\f873;\n$fa-var-money-check-pen: \\f872;\n$fa-var-money-check-edit: \\f872;\n$fa-var-money-from-bracket: \\e312;\n$fa-var-money-simple-from-bracket: \\e313;\n$fa-var-monitor-waveform: \\f611;\n$fa-var-monitor-heart-rate: \\f611;\n$fa-var-monkey: \\f6fb;\n$fa-var-monument: \\f5a6;\n$fa-var-moon: \\f186;\n$fa-var-moon-cloud: \\f754;\n$fa-var-moon-over-sun: \\f74a;\n$fa-var-eclipse-alt: \\f74a;\n$fa-var-moon-stars: \\f755;\n$fa-var-moped: \\e3b9;\n$fa-var-mortar-pestle: \\f5a7;\n$fa-var-mosque: \\f678;\n$fa-var-motorcycle: \\f21c;\n$fa-var-mountain: \\f6fc;\n$fa-var-mountains: \\f6fd;\n$fa-var-mp3-player: \\f8ce;\n$fa-var-mug: \\f874;\n$fa-var-mug-hot: \\f7b6;\n$fa-var-mug-marshmallows: \\f7b7;\n$fa-var-mug-saucer: \\f0f4;\n$fa-var-coffee: \\f0f4;\n$fa-var-mug-tea: \\f875;\n$fa-var-mug-tea-saucer: \\e1f5;\n$fa-var-mushroom: \\e425;\n$fa-var-music: \\f001;\n$fa-var-music-note: \\f8cf;\n$fa-var-music-alt: \\f8cf;\n$fa-var-music-note-slash: \\f8d0;\n$fa-var-music-alt-slash: \\f8d0;\n$fa-var-music-slash: \\f8d1;\n$fa-var-n: \\4e;\n$fa-var-naira-sign: \\e1f6;\n$fa-var-narwhal: \\f6fe;\n$fa-var-nesting-dolls: \\e3ba;\n$fa-var-network-wired: \\f6ff;\n$fa-var-neuter: \\f22c;\n$fa-var-newspaper: \\f1ea;\n$fa-var-nfc: \\e1f7;\n$fa-var-nfc-lock: \\e1f8;\n$fa-var-nfc-magnifying-glass: \\e1f9;\n$fa-var-nfc-pen: \\e1fa;\n$fa-var-nfc-signal: \\e1fb;\n$fa-var-nfc-slash: \\e1fc;\n$fa-var-nfc-trash: \\e1fd;\n$fa-var-not-equal: \\f53e;\n$fa-var-notdef: \\e1fe;\n$fa-var-note: \\e1ff;\n$fa-var-note-medical: \\e200;\n$fa-var-note-sticky: \\f249;\n$fa-var-sticky-note: \\f249;\n$fa-var-notebook: \\e201;\n$fa-var-notes: \\e202;\n$fa-var-notes-medical: \\f481;\n$fa-var-o: \\4f;\n$fa-var-object-group: \\f247;\n$fa-var-object-ungroup: \\f248;\n$fa-var-objects-align-bottom: \\e3bb;\n$fa-var-objects-align-center-horizontal: \\e3bc;\n$fa-var-objects-align-center-vertical: \\e3bd;\n$fa-var-objects-align-left: \\e3be;\n$fa-var-objects-align-right: \\e3bf;\n$fa-var-objects-align-top: \\e3c0;\n$fa-var-objects-column: \\e3c1;\n$fa-var-octagon: \\f306;\n$fa-var-octagon-check: \\e426;\n$fa-var-octagon-divide: \\e203;\n$fa-var-octagon-exclamation: \\e204;\n$fa-var-octagon-minus: \\f308;\n$fa-var-minus-octagon: \\f308;\n$fa-var-octagon-plus: \\f301;\n$fa-var-plus-octagon: \\f301;\n$fa-var-octagon-xmark: \\f2f0;\n$fa-var-times-octagon: \\f2f0;\n$fa-var-xmark-octagon: \\f2f0;\n$fa-var-oil-can: \\f613;\n$fa-var-oil-can-drip: \\e205;\n$fa-var-oil-temperature: \\f614;\n$fa-var-oil-temp: \\f614;\n$fa-var-olive: \\e316;\n$fa-var-olive-branch: \\e317;\n$fa-var-om: \\f679;\n$fa-var-omega: \\f67a;\n$fa-var-onion: \\e427;\n$fa-var-option: \\e318;\n$fa-var-ornament: \\f7b8;\n$fa-var-otter: \\f700;\n$fa-var-outdent: \\f03b;\n$fa-var-dedent: \\f03b;\n$fa-var-outlet: \\e01c;\n$fa-var-oven: \\e01d;\n$fa-var-overline: \\f876;\n$fa-var-p: \\50;\n$fa-var-page: \\e428;\n$fa-var-page-caret-down: \\e429;\n$fa-var-file-caret-down: \\e429;\n$fa-var-page-caret-up: \\e42a;\n$fa-var-file-caret-up: \\e42a;\n$fa-var-pager: \\f815;\n$fa-var-paint-brush: \\f1fc;\n$fa-var-paint-brush-fine: \\f5a9;\n$fa-var-paint-brush-alt: \\f5a9;\n$fa-var-paint-roller: \\f5aa;\n$fa-var-paintbrush-pencil: \\e206;\n$fa-var-palette: \\f53f;\n$fa-var-pallet: \\f482;\n$fa-var-pallet-box: \\e208;\n$fa-var-pallet-boxes: \\f483;\n$fa-var-palette-boxes: \\f483;\n$fa-var-pallet-alt: \\f483;\n$fa-var-pan-food: \\e42b;\n$fa-var-pan-frying: \\e42c;\n$fa-var-pancakes: \\e42d;\n$fa-var-panel-ews: \\e42e;\n$fa-var-panel-fire: \\e42f;\n$fa-var-panorama: \\e209;\n$fa-var-paper-plane: \\f1d8;\n$fa-var-paper-plane-top: \\e20a;\n$fa-var-paper-plane-alt: \\e20a;\n$fa-var-send: \\e20a;\n$fa-var-paperclip: \\f0c6;\n$fa-var-paperclip-vertical: \\e3c2;\n$fa-var-parachute-box: \\f4cd;\n$fa-var-paragraph: \\f1dd;\n$fa-var-paragraph-left: \\f878;\n$fa-var-paragraph-rtl: \\f878;\n$fa-var-party-bell: \\e31a;\n$fa-var-party-horn: \\e31b;\n$fa-var-passport: \\f5ab;\n$fa-var-paste: \\f0ea;\n$fa-var-file-clipboard: \\f0ea;\n$fa-var-pause: \\f04c;\n$fa-var-paw: \\f1b0;\n$fa-var-paw-claws: \\f702;\n$fa-var-paw-simple: \\f701;\n$fa-var-paw-alt: \\f701;\n$fa-var-peace: \\f67c;\n$fa-var-peach: \\e20b;\n$fa-var-peanut: \\e430;\n$fa-var-peanuts: \\e431;\n$fa-var-peapod: \\e31c;\n$fa-var-pear: \\e20c;\n$fa-var-pedestal: \\e20d;\n$fa-var-pegasus: \\f703;\n$fa-var-pen: \\f304;\n$fa-var-pen-circle: \\e20e;\n$fa-var-pen-clip: \\f305;\n$fa-var-pen-alt: \\f305;\n$fa-var-pen-clip-slash: \\e20f;\n$fa-var-pen-alt-slash: \\e20f;\n$fa-var-pen-fancy: \\f5ac;\n$fa-var-pen-fancy-slash: \\e210;\n$fa-var-pen-field: \\e211;\n$fa-var-pen-line: \\e212;\n$fa-var-pen-nib: \\f5ad;\n$fa-var-pen-paintbrush: \\f618;\n$fa-var-pencil-paintbrush: \\f618;\n$fa-var-pen-ruler: \\f5ae;\n$fa-var-pencil-ruler: \\f5ae;\n$fa-var-pen-slash: \\e213;\n$fa-var-pen-swirl: \\e214;\n$fa-var-pen-to-square: \\f044;\n$fa-var-edit: \\f044;\n$fa-var-pencil: \\f303;\n$fa-var-pencil-alt: \\f303;\n$fa-var-pencil-slash: \\e215;\n$fa-var-people: \\e216;\n$fa-var-people-arrows-left-right: \\e068;\n$fa-var-people-arrows: \\e068;\n$fa-var-people-carry-box: \\f4ce;\n$fa-var-people-carry: \\f4ce;\n$fa-var-people-dress: \\e217;\n$fa-var-people-dress-simple: \\e218;\n$fa-var-people-pants: \\e219;\n$fa-var-people-pants-simple: \\e21a;\n$fa-var-people-simple: \\e21b;\n$fa-var-pepper: \\e432;\n$fa-var-pepper-hot: \\f816;\n$fa-var-percent: \\25;\n$fa-var-percentage: \\25;\n$fa-var-period: \\2e;\n$fa-var-person: \\f183;\n$fa-var-male: \\f183;\n$fa-var-person-biking: \\f84a;\n$fa-var-biking: \\f84a;\n$fa-var-person-biking-mountain: \\f84b;\n$fa-var-biking-mountain: \\f84b;\n$fa-var-person-booth: \\f756;\n$fa-var-person-carry-box: \\f4cf;\n$fa-var-person-carry: \\f4cf;\n$fa-var-person-digging: \\f85e;\n$fa-var-digging: \\f85e;\n$fa-var-person-dolly: \\f4d0;\n$fa-var-person-dolly-empty: \\f4d1;\n$fa-var-person-dots-from-line: \\f470;\n$fa-var-diagnoses: \\f470;\n$fa-var-person-dress: \\f182;\n$fa-var-female: \\f182;\n$fa-var-person-dress-simple: \\e21c;\n$fa-var-person-from-portal: \\e023;\n$fa-var-portal-exit: \\e023;\n$fa-var-person-hiking: \\f6ec;\n$fa-var-hiking: \\f6ec;\n$fa-var-person-pinball: \\e21d;\n$fa-var-person-praying: \\f683;\n$fa-var-pray: \\f683;\n$fa-var-person-pregnant: \\e31e;\n$fa-var-person-running: \\f70c;\n$fa-var-running: \\f70c;\n$fa-var-person-seat: \\e21e;\n$fa-var-person-seat-reclined: \\e21f;\n$fa-var-person-sign: \\f757;\n$fa-var-person-simple: \\e220;\n$fa-var-person-skating: \\f7c5;\n$fa-var-skating: \\f7c5;\n$fa-var-person-ski-jumping: \\f7c7;\n$fa-var-ski-jump: \\f7c7;\n$fa-var-person-ski-lift: \\f7c8;\n$fa-var-ski-lift: \\f7c8;\n$fa-var-person-skiing: \\f7c9;\n$fa-var-skiing: \\f7c9;\n$fa-var-person-skiing-nordic: \\f7ca;\n$fa-var-skiing-nordic: \\f7ca;\n$fa-var-person-sledding: \\f7cb;\n$fa-var-sledding: \\f7cb;\n$fa-var-person-snowboarding: \\f7ce;\n$fa-var-snowboarding: \\f7ce;\n$fa-var-person-snowmobiling: \\f7d1;\n$fa-var-snowmobile: \\f7d1;\n$fa-var-person-swimming: \\f5c4;\n$fa-var-swimmer: \\f5c4;\n$fa-var-person-to-door: \\e433;\n$fa-var-person-to-portal: \\e022;\n$fa-var-portal-enter: \\e022;\n$fa-var-person-walking: \\f554;\n$fa-var-walking: \\f554;\n$fa-var-person-walking-with-cane: \\f29d;\n$fa-var-blind: \\f29d;\n$fa-var-peseta-sign: \\e221;\n$fa-var-peso-sign: \\e222;\n$fa-var-phone: \\f095;\n$fa-var-phone-arrow-down-left: \\e223;\n$fa-var-phone-arrow-down: \\e223;\n$fa-var-phone-incoming: \\e223;\n$fa-var-phone-arrow-up-right: \\e224;\n$fa-var-phone-arrow-up: \\e224;\n$fa-var-phone-outgoing: \\e224;\n$fa-var-phone-flip: \\f879;\n$fa-var-phone-alt: \\f879;\n$fa-var-phone-hangup: \\e225;\n$fa-var-phone-intercom: \\e434;\n$fa-var-phone-missed: \\e226;\n$fa-var-phone-office: \\f67d;\n$fa-var-phone-plus: \\f4d2;\n$fa-var-phone-rotary: \\f8d3;\n$fa-var-phone-slash: \\f3dd;\n$fa-var-phone-volume: \\f2a0;\n$fa-var-volume-control-phone: \\f2a0;\n$fa-var-phone-xmark: \\e227;\n$fa-var-photo-film: \\f87c;\n$fa-var-photo-video: \\f87c;\n$fa-var-photo-film-music: \\e228;\n$fa-var-pi: \\f67e;\n$fa-var-piano: \\f8d4;\n$fa-var-piano-keyboard: \\f8d5;\n$fa-var-pickleball: \\e435;\n$fa-var-pie: \\f705;\n$fa-var-pig: \\f706;\n$fa-var-piggy-bank: \\f4d3;\n$fa-var-pills: \\f484;\n$fa-var-pinata: \\e3c3;\n$fa-var-pinball: \\e229;\n$fa-var-pineapple: \\e31f;\n$fa-var-pipe: \\7c;\n$fa-var-pipe-circle-check: \\e436;\n$fa-var-pipe-collar: \\e437;\n$fa-var-pipe-section: \\e438;\n$fa-var-pipe-smoking: \\e3c4;\n$fa-var-pipe-valve: \\e439;\n$fa-var-pizza: \\f817;\n$fa-var-pizza-slice: \\f818;\n$fa-var-place-of-worship: \\f67f;\n$fa-var-plane: \\f072;\n$fa-var-plane-arrival: \\f5af;\n$fa-var-plane-departure: \\f5b0;\n$fa-var-plane-engines: \\f3de;\n$fa-var-plane-alt: \\f3de;\n$fa-var-plane-prop: \\e22b;\n$fa-var-plane-slash: \\e069;\n$fa-var-plane-tail: \\e22c;\n$fa-var-plane-up: \\e22d;\n$fa-var-plane-up-slash: \\e22e;\n$fa-var-planet-moon: \\e01f;\n$fa-var-planet-ringed: \\e020;\n$fa-var-plate-utensils: \\e43b;\n$fa-var-play: \\f04b;\n$fa-var-play-pause: \\e22f;\n$fa-var-plug: \\f1e6;\n$fa-var-plus: \\2b;\n$fa-var-add: \\2b;\n$fa-var-plus-minus: \\e43c;\n$fa-var-podcast: \\f2ce;\n$fa-var-podium: \\f680;\n$fa-var-podium-star: \\f758;\n$fa-var-police-box: \\e021;\n$fa-var-poll-people: \\f759;\n$fa-var-pompebled: \\e43d;\n$fa-var-poo: \\f2fe;\n$fa-var-poo-storm: \\f75a;\n$fa-var-poo-bolt: \\f75a;\n$fa-var-pool-8-ball: \\e3c5;\n$fa-var-poop: \\f619;\n$fa-var-popcorn: \\f819;\n$fa-var-popsicle: \\e43e;\n$fa-var-pot-food: \\e43f;\n$fa-var-potato: \\e440;\n$fa-var-power-off: \\f011;\n$fa-var-prescription: \\f5b1;\n$fa-var-prescription-bottle: \\f485;\n$fa-var-prescription-bottle-medical: \\f486;\n$fa-var-prescription-bottle-alt: \\f486;\n$fa-var-presentation-screen: \\f685;\n$fa-var-presentation: \\f685;\n$fa-var-pretzel: \\e441;\n$fa-var-print: \\f02f;\n$fa-var-print-magnifying-glass: \\f81a;\n$fa-var-print-search: \\f81a;\n$fa-var-print-slash: \\f686;\n$fa-var-projector: \\f8d6;\n$fa-var-pump: \\e442;\n$fa-var-pump-medical: \\e06a;\n$fa-var-pump-soap: \\e06b;\n$fa-var-pumpkin: \\f707;\n$fa-var-puzzle: \\e443;\n$fa-var-puzzle-piece: \\f12e;\n$fa-var-puzzle-piece-simple: \\e231;\n$fa-var-puzzle-piece-alt: \\e231;\n$fa-var-q: \\51;\n$fa-var-qrcode: \\f029;\n$fa-var-question: \\3f;\n$fa-var-quidditch: \\f458;\n$fa-var-broom-ball: \\f458;\n$fa-var-quidditch-broom-ball: \\f458;\n$fa-var-quote-left: \\f10d;\n$fa-var-quote-left-alt: \\f10d;\n$fa-var-quote-right: \\f10e;\n$fa-var-quote-right-alt: \\f10e;\n$fa-var-quotes: \\e234;\n$fa-var-r: \\52;\n$fa-var-rabbit: \\f708;\n$fa-var-rabbit-running: \\f709;\n$fa-var-rabbit-fast: \\f709;\n$fa-var-racquet: \\f45a;\n$fa-var-radar: \\e024;\n$fa-var-radiation: \\f7b9;\n$fa-var-radio: \\f8d7;\n$fa-var-radio-tuner: \\f8d8;\n$fa-var-radio-alt: \\f8d8;\n$fa-var-rainbow: \\f75b;\n$fa-var-raindrops: \\f75c;\n$fa-var-ram: \\f70a;\n$fa-var-ramp-loading: \\f4d4;\n$fa-var-raygun: \\e025;\n$fa-var-receipt: \\f543;\n$fa-var-record-vinyl: \\f8d9;\n$fa-var-rectangle: \\f2fa;\n$fa-var-rectangle-landscape: \\f2fa;\n$fa-var-rectangle-ad: \\f641;\n$fa-var-ad: \\f641;\n$fa-var-rectangle-barcode: \\f463;\n$fa-var-barcode-alt: \\f463;\n$fa-var-rectangle-code: \\e322;\n$fa-var-rectangle-list: \\f022;\n$fa-var-list-alt: \\f022;\n$fa-var-rectangle-pro: \\e235;\n$fa-var-pro: \\e235;\n$fa-var-rectangle-terminal: \\e236;\n$fa-var-rectangle-vertical: \\f2fb;\n$fa-var-rectangle-portrait: \\f2fb;\n$fa-var-rectangle-vertical-history: \\e237;\n$fa-var-rectangle-wide: \\f2fc;\n$fa-var-rectangle-xmark: \\f410;\n$fa-var-rectangle-times: \\f410;\n$fa-var-times-rectangle: \\f410;\n$fa-var-window-close: \\f410;\n$fa-var-rectangles-mixed: \\e323;\n$fa-var-recycle: \\f1b8;\n$fa-var-reel: \\e238;\n$fa-var-refrigerator: \\e026;\n$fa-var-registered: \\f25d;\n$fa-var-repeat: \\f363;\n$fa-var-repeat-1: \\f365;\n$fa-var-reply: \\f3e5;\n$fa-var-mail-reply: \\f3e5;\n$fa-var-reply-all: \\f122;\n$fa-var-mail-reply-all: \\f122;\n$fa-var-reply-clock: \\e239;\n$fa-var-reply-time: \\e239;\n$fa-var-republican: \\f75e;\n$fa-var-restroom: \\f7bd;\n$fa-var-restroom-simple: \\e23a;\n$fa-var-retweet: \\f079;\n$fa-var-rhombus: \\e23b;\n$fa-var-ribbon: \\f4d6;\n$fa-var-right: \\f356;\n$fa-var-arrow-alt-right: \\f356;\n$fa-var-right-from-bracket: \\f2f5;\n$fa-var-sign-out-alt: \\f2f5;\n$fa-var-right-from-line: \\f347;\n$fa-var-arrow-alt-from-left: \\f347;\n$fa-var-right-left: \\f362;\n$fa-var-exchange-alt: \\f362;\n$fa-var-right-long: \\f30b;\n$fa-var-long-arrow-alt-right: \\f30b;\n$fa-var-right-long-to-line: \\e444;\n$fa-var-right-to-bracket: \\f2f6;\n$fa-var-sign-in-alt: \\f2f6;\n$fa-var-right-to-line: \\f34c;\n$fa-var-arrow-alt-to-right: \\f34c;\n$fa-var-ring: \\f70b;\n$fa-var-rings-wedding: \\f81b;\n$fa-var-road: \\f018;\n$fa-var-robot: \\f544;\n$fa-var-robot-astromech: \\e2d2;\n$fa-var-rocket: \\f135;\n$fa-var-rocket-launch: \\e027;\n$fa-var-roller-coaster: \\e324;\n$fa-var-rotate: \\f2f1;\n$fa-var-sync-alt: \\f2f1;\n$fa-var-rotate-exclamation: \\e23c;\n$fa-var-rotate-left: \\f2ea;\n$fa-var-rotate-back: \\f2ea;\n$fa-var-rotate-backward: \\f2ea;\n$fa-var-undo-alt: \\f2ea;\n$fa-var-rotate-right: \\f2f9;\n$fa-var-redo-alt: \\f2f9;\n$fa-var-rotate-forward: \\f2f9;\n$fa-var-route: \\f4d7;\n$fa-var-route-highway: \\f61a;\n$fa-var-route-interstate: \\f61b;\n$fa-var-router: \\f8da;\n$fa-var-rss: \\f09e;\n$fa-var-feed: \\f09e;\n$fa-var-ruble-sign: \\f158;\n$fa-var-rouble: \\f158;\n$fa-var-rub: \\f158;\n$fa-var-ruble: \\f158;\n$fa-var-rugby-ball: \\e3c6;\n$fa-var-ruler: \\f545;\n$fa-var-ruler-combined: \\f546;\n$fa-var-ruler-horizontal: \\f547;\n$fa-var-ruler-triangle: \\f61c;\n$fa-var-ruler-vertical: \\f548;\n$fa-var-rupee-sign: \\f156;\n$fa-var-rupee: \\f156;\n$fa-var-rupiah-sign: \\e23d;\n$fa-var-rv: \\f7be;\n$fa-var-s: \\53;\n$fa-var-sack: \\f81c;\n$fa-var-sack-dollar: \\f81d;\n$fa-var-sailboat: \\e445;\n$fa-var-salad: \\f81e;\n$fa-var-bowl-salad: \\f81e;\n$fa-var-salt-shaker: \\e446;\n$fa-var-sandwich: \\f81f;\n$fa-var-satellite: \\f7bf;\n$fa-var-satellite-dish: \\f7c0;\n$fa-var-sausage: \\f820;\n$fa-var-saxophone: \\f8dc;\n$fa-var-saxophone-fire: \\f8db;\n$fa-var-sax-hot: \\f8db;\n$fa-var-scale-balanced: \\f24e;\n$fa-var-balance-scale: \\f24e;\n$fa-var-scale-unbalanced: \\f515;\n$fa-var-balance-scale-left: \\f515;\n$fa-var-scale-unbalanced-flip: \\f516;\n$fa-var-balance-scale-right: \\f516;\n$fa-var-scalpel: \\f61d;\n$fa-var-scalpel-line-dashed: \\f61e;\n$fa-var-scalpel-path: \\f61e;\n$fa-var-scanner: \\f8f3;\n$fa-var-scanner-image: \\f8f3;\n$fa-var-scanner-gun: \\f488;\n$fa-var-scanner-keyboard: \\f489;\n$fa-var-scanner-touchscreen: \\f48a;\n$fa-var-scarecrow: \\f70d;\n$fa-var-scarf: \\f7c1;\n$fa-var-school: \\f549;\n$fa-var-scissors: \\f0c4;\n$fa-var-cut: \\f0c4;\n$fa-var-screen-users: \\f63d;\n$fa-var-users-class: \\f63d;\n$fa-var-screencast: \\e23e;\n$fa-var-screwdriver: \\f54a;\n$fa-var-screwdriver-wrench: \\f7d9;\n$fa-var-tools: \\f7d9;\n$fa-var-scribble: \\e23f;\n$fa-var-scroll: \\f70e;\n$fa-var-scroll-old: \\f70f;\n$fa-var-scroll-torah: \\f6a0;\n$fa-var-torah: \\f6a0;\n$fa-var-scrubber: \\f2f8;\n$fa-var-scythe: \\f710;\n$fa-var-sd-card: \\f7c2;\n$fa-var-sd-cards: \\e240;\n$fa-var-seal: \\e241;\n$fa-var-seal-exclamation: \\e242;\n$fa-var-seal-question: \\e243;\n$fa-var-seat-airline: \\e244;\n$fa-var-section: \\e447;\n$fa-var-seedling: \\f4d8;\n$fa-var-sprout: \\f4d8;\n$fa-var-semicolon: \\3b;\n$fa-var-send-back: \\f87e;\n$fa-var-send-backward: \\f87f;\n$fa-var-sensor: \\e028;\n$fa-var-sensor-cloud: \\e02c;\n$fa-var-sensor-smoke: \\e02c;\n$fa-var-sensor-fire: \\e02a;\n$fa-var-sensor-on: \\e02b;\n$fa-var-sensor-triangle-exclamation: \\e029;\n$fa-var-sensor-alert: \\e029;\n$fa-var-server: \\f233;\n$fa-var-shapes: \\f61f;\n$fa-var-triangle-circle-square: \\f61f;\n$fa-var-share: \\f064;\n$fa-var-arrow-turn-right: \\f064;\n$fa-var-mail-forward: \\f064;\n$fa-var-share-all: \\f367;\n$fa-var-arrows-turn-right: \\f367;\n$fa-var-share-from-square: \\f14d;\n$fa-var-share-square: \\f14d;\n$fa-var-share-nodes: \\f1e0;\n$fa-var-share-alt: \\f1e0;\n$fa-var-sheep: \\f711;\n$fa-var-shekel-sign: \\f20b;\n$fa-var-ils: \\f20b;\n$fa-var-shekel: \\f20b;\n$fa-var-sheqel: \\f20b;\n$fa-var-sheqel-sign: \\f20b;\n$fa-var-shelves: \\f480;\n$fa-var-inventory: \\f480;\n$fa-var-shelves-empty: \\e246;\n$fa-var-shield: \\f132;\n$fa-var-shield-blank: \\f3ed;\n$fa-var-shield-alt: \\f3ed;\n$fa-var-shield-check: \\f2f7;\n$fa-var-shield-cross: \\f712;\n$fa-var-shield-exclamation: \\e247;\n$fa-var-shield-keyhole: \\e248;\n$fa-var-shield-minus: \\e249;\n$fa-var-shield-plus: \\e24a;\n$fa-var-shield-slash: \\e24b;\n$fa-var-shield-virus: \\e06c;\n$fa-var-shield-xmark: \\e24c;\n$fa-var-shield-times: \\e24c;\n$fa-var-ship: \\f21a;\n$fa-var-shirt: \\f553;\n$fa-var-t-shirt: \\f553;\n$fa-var-tshirt: \\f553;\n$fa-var-shirt-long-sleeve: \\e3c7;\n$fa-var-shirt-running: \\e3c8;\n$fa-var-shirt-tank-top: \\e3c9;\n$fa-var-shish-kebab: \\f821;\n$fa-var-shoe-prints: \\f54b;\n$fa-var-shop: \\f54f;\n$fa-var-store-alt: \\f54f;\n$fa-var-shop-slash: \\e070;\n$fa-var-store-alt-slash: \\e070;\n$fa-var-shovel: \\f713;\n$fa-var-shovel-snow: \\f7c3;\n$fa-var-shower: \\f2cc;\n$fa-var-shower-down: \\e24d;\n$fa-var-shower-alt: \\e24d;\n$fa-var-shredder: \\f68a;\n$fa-var-shrimp: \\e448;\n$fa-var-shuffle: \\f074;\n$fa-var-random: \\f074;\n$fa-var-shutters: \\e449;\n$fa-var-shuttle-space: \\f197;\n$fa-var-space-shuttle: \\f197;\n$fa-var-shuttlecock: \\f45b;\n$fa-var-sickle: \\f822;\n$fa-var-sidebar: \\e24e;\n$fa-var-sidebar-flip: \\e24f;\n$fa-var-sigma: \\f68b;\n$fa-var-sign-hanging: \\f4d9;\n$fa-var-sign: \\f4d9;\n$fa-var-signal: \\f012;\n$fa-var-signal-5: \\f012;\n$fa-var-signal-perfect: \\f012;\n$fa-var-signal-bars: \\f690;\n$fa-var-signal-alt: \\f690;\n$fa-var-signal-alt-4: \\f690;\n$fa-var-signal-bars-strong: \\f690;\n$fa-var-signal-bars-fair: \\f692;\n$fa-var-signal-alt-2: \\f692;\n$fa-var-signal-bars-good: \\f693;\n$fa-var-signal-alt-3: \\f693;\n$fa-var-signal-bars-slash: \\f694;\n$fa-var-signal-alt-slash: \\f694;\n$fa-var-signal-bars-weak: \\f691;\n$fa-var-signal-alt-1: \\f691;\n$fa-var-signal-fair: \\f68d;\n$fa-var-signal-2: \\f68d;\n$fa-var-signal-good: \\f68e;\n$fa-var-signal-3: \\f68e;\n$fa-var-signal-slash: \\f695;\n$fa-var-signal-stream: \\f8dd;\n$fa-var-signal-stream-slash: \\e250;\n$fa-var-signal-strong: \\f68f;\n$fa-var-signal-4: \\f68f;\n$fa-var-signal-weak: \\f68c;\n$fa-var-signal-1: \\f68c;\n$fa-var-signature: \\f5b7;\n$fa-var-signature-lock: \\e3ca;\n$fa-var-signature-slash: \\e3cb;\n$fa-var-signs-post: \\f277;\n$fa-var-map-signs: \\f277;\n$fa-var-sim-card: \\f7c4;\n$fa-var-sim-cards: \\e251;\n$fa-var-sink: \\e06d;\n$fa-var-siren: \\e02d;\n$fa-var-siren-on: \\e02e;\n$fa-var-sitemap: \\f0e8;\n$fa-var-skeleton: \\f620;\n$fa-var-ski-boot: \\e3cc;\n$fa-var-ski-boot-ski: \\e3cd;\n$fa-var-skull: \\f54c;\n$fa-var-skull-cow: \\f8de;\n$fa-var-skull-crossbones: \\f714;\n$fa-var-slash: \\f715;\n$fa-var-slash-back: \\5c;\n$fa-var-slash-forward: \\2f;\n$fa-var-sleigh: \\f7cc;\n$fa-var-slider: \\e252;\n$fa-var-sliders: \\f1de;\n$fa-var-sliders-h: \\f1de;\n$fa-var-sliders-simple: \\e253;\n$fa-var-sliders-up: \\f3f1;\n$fa-var-sliders-v: \\f3f1;\n$fa-var-slot-machine: \\e3ce;\n$fa-var-smog: \\f75f;\n$fa-var-smoke: \\f760;\n$fa-var-smoking: \\f48d;\n$fa-var-snake: \\f716;\n$fa-var-snooze: \\f880;\n$fa-var-zzz: \\f880;\n$fa-var-snow-blowing: \\f761;\n$fa-var-snowflake: \\f2dc;\n$fa-var-snowflakes: \\f7cf;\n$fa-var-snowman: \\f7d0;\n$fa-var-snowman-head: \\f79b;\n$fa-var-frosty-head: \\f79b;\n$fa-var-snowplow: \\f7d2;\n$fa-var-soap: \\e06e;\n$fa-var-socks: \\f696;\n$fa-var-solar-panel: \\f5ba;\n$fa-var-solar-system: \\e02f;\n$fa-var-sort: \\f0dc;\n$fa-var-unsorted: \\f0dc;\n$fa-var-sort-down: \\f0dd;\n$fa-var-sort-desc: \\f0dd;\n$fa-var-sort-up: \\f0de;\n$fa-var-sort-asc: \\f0de;\n$fa-var-spa: \\f5bb;\n$fa-var-space-station-moon: \\e033;\n$fa-var-space-station-moon-construction: \\e034;\n$fa-var-space-station-moon-alt: \\e034;\n$fa-var-spade: \\f2f4;\n$fa-var-spaghetti-monster-flying: \\f67b;\n$fa-var-pastafarianism: \\f67b;\n$fa-var-sparkles: \\f890;\n$fa-var-speaker: \\f8df;\n$fa-var-speakers: \\f8e0;\n$fa-var-spell-check: \\f891;\n$fa-var-spider: \\f717;\n$fa-var-spider-black-widow: \\f718;\n$fa-var-spider-web: \\f719;\n$fa-var-spinner: \\f110;\n$fa-var-spinner-third: \\f3f4;\n$fa-var-split: \\e254;\n$fa-var-splotch: \\f5bc;\n$fa-var-spoon: \\f2e5;\n$fa-var-utensil-spoon: \\f2e5;\n$fa-var-sportsball: \\e44b;\n$fa-var-spray-can: \\f5bd;\n$fa-var-spray-can-sparkles: \\f5d0;\n$fa-var-air-freshener: \\f5d0;\n$fa-var-sprinkler: \\e035;\n$fa-var-sprinkler-ceiling: \\e44c;\n$fa-var-square: \\f0c8;\n$fa-var-square-0: \\e255;\n$fa-var-square-1: \\e256;\n$fa-var-square-2: \\e257;\n$fa-var-square-3: \\e258;\n$fa-var-square-4: \\e259;\n$fa-var-square-5: \\e25a;\n$fa-var-square-6: \\e25b;\n$fa-var-square-7: \\e25c;\n$fa-var-square-8: \\e25d;\n$fa-var-square-9: \\e25e;\n$fa-var-square-a: \\e25f;\n$fa-var-square-a-lock: \\e44d;\n$fa-var-square-ampersand: \\e260;\n$fa-var-square-arrow-down: \\f339;\n$fa-var-arrow-square-down: \\f339;\n$fa-var-square-arrow-down-left: \\e261;\n$fa-var-square-arrow-down-right: \\e262;\n$fa-var-square-arrow-left: \\f33a;\n$fa-var-arrow-square-left: \\f33a;\n$fa-var-square-arrow-right: \\f33b;\n$fa-var-arrow-square-right: \\f33b;\n$fa-var-square-arrow-up: \\f33c;\n$fa-var-arrow-square-up: \\f33c;\n$fa-var-square-arrow-up-left: \\e263;\n$fa-var-square-arrow-up-right: \\f14c;\n$fa-var-external-link-square: \\f14c;\n$fa-var-square-b: \\e264;\n$fa-var-square-bolt: \\e265;\n$fa-var-square-c: \\e266;\n$fa-var-square-caret-down: \\f150;\n$fa-var-caret-square-down: \\f150;\n$fa-var-square-caret-left: \\f191;\n$fa-var-caret-square-left: \\f191;\n$fa-var-square-caret-right: \\f152;\n$fa-var-caret-square-right: \\f152;\n$fa-var-square-caret-up: \\f151;\n$fa-var-caret-square-up: \\f151;\n$fa-var-square-check: \\f14a;\n$fa-var-check-square: \\f14a;\n$fa-var-square-chevron-down: \\f329;\n$fa-var-chevron-square-down: \\f329;\n$fa-var-square-chevron-left: \\f32a;\n$fa-var-chevron-square-left: \\f32a;\n$fa-var-square-chevron-right: \\f32b;\n$fa-var-chevron-square-right: \\f32b;\n$fa-var-square-chevron-up: \\f32c;\n$fa-var-chevron-square-up: \\f32c;\n$fa-var-square-code: \\e267;\n$fa-var-square-d: \\e268;\n$fa-var-square-dashed: \\e269;\n$fa-var-square-divide: \\e26a;\n$fa-var-square-dollar: \\f2e9;\n$fa-var-dollar-square: \\f2e9;\n$fa-var-usd-square: \\f2e9;\n$fa-var-square-down: \\f350;\n$fa-var-arrow-alt-square-down: \\f350;\n$fa-var-square-down-left: \\e26b;\n$fa-var-square-down-right: \\e26c;\n$fa-var-square-e: \\e26d;\n$fa-var-square-ellipsis: \\e26e;\n$fa-var-square-ellipsis-vertical: \\e26f;\n$fa-var-square-envelope: \\f199;\n$fa-var-envelope-square: \\f199;\n$fa-var-square-exclamation: \\f321;\n$fa-var-exclamation-square: \\f321;\n$fa-var-square-f: \\e270;\n$fa-var-square-fragile: \\f49b;\n$fa-var-box-fragile: \\f49b;\n$fa-var-square-wine-glass-crack: \\f49b;\n$fa-var-square-full: \\f45c;\n$fa-var-square-g: \\e271;\n$fa-var-square-h: \\f0fd;\n$fa-var-h-square: \\f0fd;\n$fa-var-square-heart: \\f4c8;\n$fa-var-heart-square: \\f4c8;\n$fa-var-square-i: \\e272;\n$fa-var-square-info: \\f30f;\n$fa-var-info-square: \\f30f;\n$fa-var-square-j: \\e273;\n$fa-var-square-k: \\e274;\n$fa-var-square-l: \\e275;\n$fa-var-square-left: \\f351;\n$fa-var-arrow-alt-square-left: \\f351;\n$fa-var-square-m: \\e276;\n$fa-var-square-minus: \\f146;\n$fa-var-minus-square: \\f146;\n$fa-var-square-n: \\e277;\n$fa-var-square-o: \\e278;\n$fa-var-square-p: \\e279;\n$fa-var-square-parking: \\f540;\n$fa-var-parking: \\f540;\n$fa-var-square-parking-slash: \\f617;\n$fa-var-parking-slash: \\f617;\n$fa-var-square-pen: \\f14b;\n$fa-var-pen-square: \\f14b;\n$fa-var-pencil-square: \\f14b;\n$fa-var-square-phone: \\f098;\n$fa-var-phone-square: \\f098;\n$fa-var-square-phone-flip: \\f87b;\n$fa-var-phone-square-alt: \\f87b;\n$fa-var-square-phone-hangup: \\e27a;\n$fa-var-phone-square-down: \\e27a;\n$fa-var-square-plus: \\f0fe;\n$fa-var-plus-square: \\f0fe;\n$fa-var-square-poll-horizontal: \\f682;\n$fa-var-poll-h: \\f682;\n$fa-var-square-poll-vertical: \\f681;\n$fa-var-poll: \\f681;\n$fa-var-square-q: \\e27b;\n$fa-var-square-quarters: \\e44e;\n$fa-var-square-question: \\f2fd;\n$fa-var-question-square: \\f2fd;\n$fa-var-square-quote: \\e329;\n$fa-var-square-r: \\e27c;\n$fa-var-square-right: \\f352;\n$fa-var-arrow-alt-square-right: \\f352;\n$fa-var-square-ring: \\e44f;\n$fa-var-square-root: \\f697;\n$fa-var-square-root-variable: \\f698;\n$fa-var-square-root-alt: \\f698;\n$fa-var-square-rss: \\f143;\n$fa-var-rss-square: \\f143;\n$fa-var-square-s: \\e27d;\n$fa-var-square-share-nodes: \\f1e1;\n$fa-var-share-alt-square: \\f1e1;\n$fa-var-square-sliders: \\f3f0;\n$fa-var-sliders-h-square: \\f3f0;\n$fa-var-square-sliders-vertical: \\f3f2;\n$fa-var-sliders-v-square: \\f3f2;\n$fa-var-square-small: \\e27e;\n$fa-var-square-star: \\e27f;\n$fa-var-square-t: \\e280;\n$fa-var-square-terminal: \\e32a;\n$fa-var-square-this-way-up: \\f49f;\n$fa-var-box-up: \\f49f;\n$fa-var-square-u: \\e281;\n$fa-var-square-up: \\f353;\n$fa-var-arrow-alt-square-up: \\f353;\n$fa-var-square-up-left: \\e282;\n$fa-var-square-up-right: \\f360;\n$fa-var-external-link-square-alt: \\f360;\n$fa-var-square-user: \\e283;\n$fa-var-square-v: \\e284;\n$fa-var-square-w: \\e285;\n$fa-var-square-x: \\e286;\n$fa-var-square-xmark: \\f2d3;\n$fa-var-times-square: \\f2d3;\n$fa-var-xmark-square: \\f2d3;\n$fa-var-square-y: \\e287;\n$fa-var-square-z: \\e288;\n$fa-var-squid: \\e450;\n$fa-var-squirrel: \\f71a;\n$fa-var-staff: \\f71b;\n$fa-var-stairs: \\e289;\n$fa-var-stamp: \\f5bf;\n$fa-var-standard-definition: \\e28a;\n$fa-var-rectangle-sd: \\e28a;\n$fa-var-star: \\f005;\n$fa-var-star-and-crescent: \\f699;\n$fa-var-star-christmas: \\f7d4;\n$fa-var-star-exclamation: \\f2f3;\n$fa-var-star-half: \\f089;\n$fa-var-star-half-stroke: \\f5c0;\n$fa-var-star-half-alt: \\f5c0;\n$fa-var-star-of-david: \\f69a;\n$fa-var-star-of-life: \\f621;\n$fa-var-star-sharp: \\e28b;\n$fa-var-star-sharp-half: \\e28c;\n$fa-var-star-sharp-half-stroke: \\e28d;\n$fa-var-star-sharp-half-alt: \\e28d;\n$fa-var-star-shooting: \\e036;\n$fa-var-starfighter: \\e037;\n$fa-var-starfighter-twin-ion-engine: \\e038;\n$fa-var-starfighter-alt: \\e038;\n$fa-var-starfighter-twin-ion-engine-advanced: \\e28e;\n$fa-var-starfighter-alt-advanced: \\e28e;\n$fa-var-stars: \\f762;\n$fa-var-starship: \\e039;\n$fa-var-starship-freighter: \\e03a;\n$fa-var-steak: \\f824;\n$fa-var-steering-wheel: \\f622;\n$fa-var-sterling-sign: \\f154;\n$fa-var-gbp: \\f154;\n$fa-var-pound-sign: \\f154;\n$fa-var-stethoscope: \\f0f1;\n$fa-var-stocking: \\f7d5;\n$fa-var-stomach: \\f623;\n$fa-var-stop: \\f04d;\n$fa-var-stopwatch: \\f2f2;\n$fa-var-stopwatch-20: \\e06f;\n$fa-var-store: \\f54e;\n$fa-var-store-slash: \\e071;\n$fa-var-strawberry: \\e32b;\n$fa-var-street-view: \\f21d;\n$fa-var-stretcher: \\f825;\n$fa-var-strikethrough: \\f0cc;\n$fa-var-stroopwafel: \\f551;\n$fa-var-subscript: \\f12c;\n$fa-var-suitcase: \\f0f2;\n$fa-var-suitcase-medical: \\f0fa;\n$fa-var-medkit: \\f0fa;\n$fa-var-suitcase-rolling: \\f5c1;\n$fa-var-sun: \\f185;\n$fa-var-sun-bright: \\e28f;\n$fa-var-sun-alt: \\e28f;\n$fa-var-sun-cloud: \\f763;\n$fa-var-sun-dust: \\f764;\n$fa-var-sun-haze: \\f765;\n$fa-var-sunglasses: \\f892;\n$fa-var-sunrise: \\f766;\n$fa-var-sunset: \\f767;\n$fa-var-superscript: \\f12b;\n$fa-var-swatchbook: \\f5c3;\n$fa-var-sword: \\f71c;\n$fa-var-sword-laser: \\e03b;\n$fa-var-sword-laser-alt: \\e03c;\n$fa-var-swords: \\f71d;\n$fa-var-swords-laser: \\e03d;\n$fa-var-symbols: \\f86e;\n$fa-var-icons-alt: \\f86e;\n$fa-var-synagogue: \\f69b;\n$fa-var-syringe: \\f48e;\n$fa-var-t: \\54;\n$fa-var-table: \\f0ce;\n$fa-var-table-cells: \\f00a;\n$fa-var-th: \\f00a;\n$fa-var-table-cells-large: \\f009;\n$fa-var-th-large: \\f009;\n$fa-var-table-columns: \\f0db;\n$fa-var-columns: \\f0db;\n$fa-var-table-layout: \\e290;\n$fa-var-table-list: \\f00b;\n$fa-var-th-list: \\f00b;\n$fa-var-table-picnic: \\e32d;\n$fa-var-table-pivot: \\e291;\n$fa-var-table-rows: \\e292;\n$fa-var-rows: \\e292;\n$fa-var-table-tennis-paddle-ball: \\f45d;\n$fa-var-ping-pong-paddle-ball: \\f45d;\n$fa-var-table-tennis: \\f45d;\n$fa-var-table-tree: \\e293;\n$fa-var-tablet: \\f3fb;\n$fa-var-tablet-android: \\f3fb;\n$fa-var-tablet-button: \\f10a;\n$fa-var-tablet-rugged: \\f48f;\n$fa-var-tablet-screen: \\f3fc;\n$fa-var-tablet-android-alt: \\f3fc;\n$fa-var-tablet-screen-button: \\f3fa;\n$fa-var-tablet-alt: \\f3fa;\n$fa-var-tablets: \\f490;\n$fa-var-tachograph-digital: \\f566;\n$fa-var-digital-tachograph: \\f566;\n$fa-var-taco: \\f826;\n$fa-var-tag: \\f02b;\n$fa-var-tags: \\f02c;\n$fa-var-tally: \\f69c;\n$fa-var-tally-5: \\f69c;\n$fa-var-tally-1: \\e294;\n$fa-var-tally-2: \\e295;\n$fa-var-tally-3: \\e296;\n$fa-var-tally-4: \\e297;\n$fa-var-tamale: \\e451;\n$fa-var-tank-water: \\e452;\n$fa-var-tape: \\f4db;\n$fa-var-taxi: \\f1ba;\n$fa-var-cab: \\f1ba;\n$fa-var-taxi-bus: \\e298;\n$fa-var-teddy-bear: \\e3cf;\n$fa-var-teeth: \\f62e;\n$fa-var-teeth-open: \\f62f;\n$fa-var-telescope: \\e03e;\n$fa-var-temperature-arrow-down: \\e03f;\n$fa-var-temperature-down: \\e03f;\n$fa-var-temperature-arrow-up: \\e040;\n$fa-var-temperature-up: \\e040;\n$fa-var-temperature-empty: \\f2cb;\n$fa-var-temperature-0: \\f2cb;\n$fa-var-thermometer-0: \\f2cb;\n$fa-var-thermometer-empty: \\f2cb;\n$fa-var-temperature-full: \\f2c7;\n$fa-var-temperature-4: \\f2c7;\n$fa-var-thermometer-4: \\f2c7;\n$fa-var-thermometer-full: \\f2c7;\n$fa-var-temperature-half: \\f2c9;\n$fa-var-temperature-2: \\f2c9;\n$fa-var-thermometer-2: \\f2c9;\n$fa-var-thermometer-half: \\f2c9;\n$fa-var-temperature-high: \\f769;\n$fa-var-temperature-list: \\e299;\n$fa-var-temperature-low: \\f76b;\n$fa-var-temperature-quarter: \\f2ca;\n$fa-var-temperature-1: \\f2ca;\n$fa-var-thermometer-1: \\f2ca;\n$fa-var-thermometer-quarter: \\f2ca;\n$fa-var-temperature-snow: \\f768;\n$fa-var-temperature-frigid: \\f768;\n$fa-var-temperature-sun: \\f76a;\n$fa-var-temperature-hot: \\f76a;\n$fa-var-temperature-three-quarters: \\f2c8;\n$fa-var-temperature-3: \\f2c8;\n$fa-var-thermometer-3: \\f2c8;\n$fa-var-thermometer-three-quarters: \\f2c8;\n$fa-var-tenge-sign: \\f7d7;\n$fa-var-tenge: \\f7d7;\n$fa-var-tennis-ball: \\f45e;\n$fa-var-terminal: \\f120;\n$fa-var-text: \\f893;\n$fa-var-text-height: \\f034;\n$fa-var-text-size: \\f894;\n$fa-var-text-slash: \\f87d;\n$fa-var-remove-format: \\f87d;\n$fa-var-text-width: \\f035;\n$fa-var-thermometer: \\f491;\n$fa-var-theta: \\f69e;\n$fa-var-thought-bubble: \\e32e;\n$fa-var-thumbs-down: \\f165;\n$fa-var-thumbs-up: \\f164;\n$fa-var-thumbtack: \\f08d;\n$fa-var-thumb-tack: \\f08d;\n$fa-var-tick: \\e32f;\n$fa-var-ticket: \\f145;\n$fa-var-ticket-airline: \\e29a;\n$fa-var-ticket-simple: \\f3ff;\n$fa-var-ticket-alt: \\f3ff;\n$fa-var-tickets-airline: \\e29b;\n$fa-var-tilde: \\7e;\n$fa-var-timeline: \\e29c;\n$fa-var-timeline-arrow: \\e29d;\n$fa-var-timer: \\e29e;\n$fa-var-tire: \\f631;\n$fa-var-tire-flat: \\f632;\n$fa-var-tire-pressure-warning: \\f633;\n$fa-var-tire-rugged: \\f634;\n$fa-var-toggle-off: \\f204;\n$fa-var-toggle-on: \\f205;\n$fa-var-toilet: \\f7d8;\n$fa-var-toilet-paper: \\f71e;\n$fa-var-toilet-paper-blank: \\f71f;\n$fa-var-toilet-paper-alt: \\f71f;\n$fa-var-toilet-paper-blank-under: \\e29f;\n$fa-var-toilet-paper-reverse-alt: \\e29f;\n$fa-var-toilet-paper-slash: \\e072;\n$fa-var-toilet-paper-under: \\e2a0;\n$fa-var-toilet-paper-reverse: \\e2a0;\n$fa-var-toilet-paper-under-slash: \\e2a1;\n$fa-var-toilet-paper-reverse-slash: \\e2a1;\n$fa-var-tomato: \\e330;\n$fa-var-tombstone: \\f720;\n$fa-var-tombstone-blank: \\f721;\n$fa-var-tombstone-alt: \\f721;\n$fa-var-toolbox: \\f552;\n$fa-var-tooth: \\f5c9;\n$fa-var-toothbrush: \\f635;\n$fa-var-torii-gate: \\f6a1;\n$fa-var-tornado: \\f76f;\n$fa-var-tower-broadcast: \\f519;\n$fa-var-broadcast-tower: \\f519;\n$fa-var-tower-control: \\e2a2;\n$fa-var-tractor: \\f722;\n$fa-var-trademark: \\f25c;\n$fa-var-traffic-cone: \\f636;\n$fa-var-traffic-light: \\f637;\n$fa-var-traffic-light-go: \\f638;\n$fa-var-traffic-light-slow: \\f639;\n$fa-var-traffic-light-stop: \\f63a;\n$fa-var-trailer: \\e041;\n$fa-var-train: \\f238;\n$fa-var-train-subway: \\f239;\n$fa-var-subway: \\f239;\n$fa-var-train-subway-tunnel: \\e2a3;\n$fa-var-subway-tunnel: \\e2a3;\n$fa-var-train-track: \\e453;\n$fa-var-train-tram: \\f7da;\n$fa-var-tram: \\f7da;\n$fa-var-train-tunnel: \\e454;\n$fa-var-transformer-bolt: \\e2a4;\n$fa-var-transgender: \\f225;\n$fa-var-transgender-alt: \\f225;\n$fa-var-transporter: \\e042;\n$fa-var-transporter-1: \\e043;\n$fa-var-transporter-2: \\e044;\n$fa-var-transporter-3: \\e045;\n$fa-var-transporter-4: \\e2a5;\n$fa-var-transporter-5: \\e2a6;\n$fa-var-transporter-6: \\e2a7;\n$fa-var-transporter-7: \\e2a8;\n$fa-var-transporter-empty: \\e046;\n$fa-var-trash: \\f1f8;\n$fa-var-trash-arrow-up: \\f829;\n$fa-var-trash-restore: \\f829;\n$fa-var-trash-can: \\f2ed;\n$fa-var-trash-alt: \\f2ed;\n$fa-var-trash-can-arrow-up: \\f82a;\n$fa-var-trash-restore-alt: \\f82a;\n$fa-var-trash-can-check: \\e2a9;\n$fa-var-trash-can-clock: \\e2aa;\n$fa-var-trash-can-list: \\e2ab;\n$fa-var-trash-can-plus: \\e2ac;\n$fa-var-trash-can-slash: \\e2ad;\n$fa-var-trash-alt-slash: \\e2ad;\n$fa-var-trash-can-undo: \\f896;\n$fa-var-trash-can-arrow-turn-left: \\f896;\n$fa-var-trash-undo-alt: \\f896;\n$fa-var-trash-can-xmark: \\e2ae;\n$fa-var-trash-check: \\e2af;\n$fa-var-trash-clock: \\e2b0;\n$fa-var-trash-list: \\e2b1;\n$fa-var-trash-plus: \\e2b2;\n$fa-var-trash-slash: \\e2b3;\n$fa-var-trash-undo: \\f895;\n$fa-var-trash-arrow-turn-left: \\f895;\n$fa-var-trash-xmark: \\e2b4;\n$fa-var-treasure-chest: \\f723;\n$fa-var-tree: \\f1bb;\n$fa-var-tree-christmas: \\f7db;\n$fa-var-tree-deciduous: \\f400;\n$fa-var-tree-alt: \\f400;\n$fa-var-tree-decorated: \\f7dc;\n$fa-var-tree-large: \\f7dd;\n$fa-var-tree-palm: \\f82b;\n$fa-var-trees: \\f724;\n$fa-var-triangle: \\f2ec;\n$fa-var-triangle-exclamation: \\f071;\n$fa-var-exclamation-triangle: \\f071;\n$fa-var-warning: \\f071;\n$fa-var-triangle-instrument: \\f8e2;\n$fa-var-triangle-music: \\f8e2;\n$fa-var-triangle-person-digging: \\f85d;\n$fa-var-construction: \\f85d;\n$fa-var-trophy: \\f091;\n$fa-var-trophy-star: \\f2eb;\n$fa-var-trophy-alt: \\f2eb;\n$fa-var-truck: \\f0d1;\n$fa-var-truck-bolt: \\e3d0;\n$fa-var-truck-clock: \\f48c;\n$fa-var-shipping-timed: \\f48c;\n$fa-var-truck-container: \\f4dc;\n$fa-var-truck-container-empty: \\e2b5;\n$fa-var-truck-fast: \\f48b;\n$fa-var-shipping-fast: \\f48b;\n$fa-var-truck-flatbed: \\e2b6;\n$fa-var-truck-front: \\e2b7;\n$fa-var-truck-medical: \\f0f9;\n$fa-var-ambulance: \\f0f9;\n$fa-var-truck-monster: \\f63b;\n$fa-var-truck-moving: \\f4df;\n$fa-var-truck-pickup: \\f63c;\n$fa-var-truck-plow: \\f7de;\n$fa-var-truck-ramp: \\f4e0;\n$fa-var-truck-ramp-box: \\f4de;\n$fa-var-truck-loading: \\f4de;\n$fa-var-truck-ramp-couch: \\f4dd;\n$fa-var-truck-couch: \\f4dd;\n$fa-var-truck-tow: \\e2b8;\n$fa-var-trumpet: \\f8e3;\n$fa-var-tty: \\f1e4;\n$fa-var-teletype: \\f1e4;\n$fa-var-tty-answer: \\e2b9;\n$fa-var-teletype-answer: \\e2b9;\n$fa-var-tugrik-sign: \\e2ba;\n$fa-var-turkey: \\f725;\n$fa-var-turkish-lira-sign: \\e2bb;\n$fa-var-try: \\e2bb;\n$fa-var-turkish-lira: \\e2bb;\n$fa-var-turn-down: \\f3be;\n$fa-var-level-down-alt: \\f3be;\n$fa-var-turn-down-left: \\e331;\n$fa-var-turn-down-right: \\e455;\n$fa-var-turn-up: \\f3bf;\n$fa-var-level-up-alt: \\f3bf;\n$fa-var-turntable: \\f8e4;\n$fa-var-turtle: \\f726;\n$fa-var-tv: \\f26c;\n$fa-var-television: \\f26c;\n$fa-var-tv-alt: \\f26c;\n$fa-var-tv-music: \\f8e6;\n$fa-var-tv-retro: \\f401;\n$fa-var-typewriter: \\f8e7;\n$fa-var-u: \\55;\n$fa-var-ufo: \\e047;\n$fa-var-ufo-beam: \\e048;\n$fa-var-umbrella: \\f0e9;\n$fa-var-umbrella-beach: \\f5ca;\n$fa-var-umbrella-simple: \\e2bc;\n$fa-var-umbrella-alt: \\e2bc;\n$fa-var-underline: \\f0cd;\n$fa-var-unicorn: \\f727;\n$fa-var-uniform-martial-arts: \\e3d1;\n$fa-var-union: \\f6a2;\n$fa-var-universal-access: \\f29a;\n$fa-var-unlock: \\f09c;\n$fa-var-unlock-keyhole: \\f13e;\n$fa-var-unlock-alt: \\f13e;\n$fa-var-up: \\f357;\n$fa-var-arrow-alt-up: \\f357;\n$fa-var-up-down: \\f338;\n$fa-var-arrows-alt-v: \\f338;\n$fa-var-up-down-left-right: \\f0b2;\n$fa-var-arrows-alt: \\f0b2;\n$fa-var-up-from-dotted-line: \\e456;\n$fa-var-up-from-line: \\f346;\n$fa-var-arrow-alt-from-bottom: \\f346;\n$fa-var-up-left: \\e2bd;\n$fa-var-up-long: \\f30c;\n$fa-var-long-arrow-alt-up: \\f30c;\n$fa-var-up-right: \\e2be;\n$fa-var-up-right-and-down-left-from-center: \\f424;\n$fa-var-expand-alt: \\f424;\n$fa-var-up-right-from-square: \\f35d;\n$fa-var-external-link-alt: \\f35d;\n$fa-var-up-to-dotted-line: \\e457;\n$fa-var-up-to-line: \\f34d;\n$fa-var-arrow-alt-to-top: \\f34d;\n$fa-var-upload: \\f093;\n$fa-var-usb-drive: \\f8e9;\n$fa-var-user: \\f007;\n$fa-var-user-alien: \\e04a;\n$fa-var-user-astronaut: \\f4fb;\n$fa-var-user-bounty-hunter: \\e2bf;\n$fa-var-user-check: \\f4fc;\n$fa-var-user-chef: \\e3d2;\n$fa-var-user-clock: \\f4fd;\n$fa-var-user-cowboy: \\f8ea;\n$fa-var-user-crown: \\f6a4;\n$fa-var-user-doctor: \\f0f0;\n$fa-var-user-md: \\f0f0;\n$fa-var-user-doctor-hair: \\e458;\n$fa-var-user-doctor-hair-long: \\e459;\n$fa-var-user-doctor-message: \\f82e;\n$fa-var-user-md-chat: \\f82e;\n$fa-var-user-gear: \\f4fe;\n$fa-var-user-cog: \\f4fe;\n$fa-var-user-graduate: \\f501;\n$fa-var-user-group: \\f500;\n$fa-var-user-friends: \\f500;\n$fa-var-user-group-crown: \\f6a5;\n$fa-var-users-crown: \\f6a5;\n$fa-var-user-hair: \\e45a;\n$fa-var-user-hair-buns: \\e3d3;\n$fa-var-user-hair-long: \\e45b;\n$fa-var-user-hair-mullet: \\e45c;\n$fa-var-business-front: \\e45c;\n$fa-var-party-back: \\e45c;\n$fa-var-trian-balbot: \\e45c;\n$fa-var-user-headset: \\f82d;\n$fa-var-user-helmet-safety: \\f82c;\n$fa-var-user-construction: \\f82c;\n$fa-var-user-hard-hat: \\f82c;\n$fa-var-user-injured: \\f728;\n$fa-var-user-large: \\f406;\n$fa-var-user-alt: \\f406;\n$fa-var-user-large-slash: \\f4fa;\n$fa-var-user-alt-slash: \\f4fa;\n$fa-var-user-lock: \\f502;\n$fa-var-user-minus: \\f503;\n$fa-var-user-music: \\f8eb;\n$fa-var-user-ninja: \\f504;\n$fa-var-user-nurse: \\f82f;\n$fa-var-user-nurse-hair: \\e45d;\n$fa-var-user-nurse-hair-long: \\e45e;\n$fa-var-user-pen: \\f4ff;\n$fa-var-user-edit: \\f4ff;\n$fa-var-user-pilot: \\e2c0;\n$fa-var-user-pilot-tie: \\e2c1;\n$fa-var-user-plus: \\f234;\n$fa-var-user-police: \\e333;\n$fa-var-user-police-tie: \\e334;\n$fa-var-user-robot: \\e04b;\n$fa-var-user-secret: \\f21b;\n$fa-var-user-shakespeare: \\e2c2;\n$fa-var-user-shield: \\f505;\n$fa-var-user-slash: \\f506;\n$fa-var-user-tag: \\f507;\n$fa-var-user-tie: \\f508;\n$fa-var-user-tie-hair: \\e45f;\n$fa-var-user-tie-hair-long: \\e460;\n$fa-var-user-unlock: \\e058;\n$fa-var-user-visor: \\e04c;\n$fa-var-user-vneck: \\e461;\n$fa-var-user-vneck-hair: \\e462;\n$fa-var-user-vneck-hair-long: \\e463;\n$fa-var-user-xmark: \\f235;\n$fa-var-user-times: \\f235;\n$fa-var-users: \\f0c0;\n$fa-var-group: \\f0c0;\n$fa-var-users-gear: \\f509;\n$fa-var-users-cog: \\f509;\n$fa-var-users-medical: \\f830;\n$fa-var-users-slash: \\e073;\n$fa-var-utensils: \\f2e7;\n$fa-var-cutlery: \\f2e7;\n$fa-var-utensils-slash: \\e464;\n$fa-var-utility-pole: \\e2c3;\n$fa-var-utility-pole-double: \\e2c4;\n$fa-var-v: \\56;\n$fa-var-vacuum: \\e04d;\n$fa-var-vacuum-robot: \\e04e;\n$fa-var-value-absolute: \\f6a6;\n$fa-var-van-shuttle: \\f5b6;\n$fa-var-shuttle-van: \\f5b6;\n$fa-var-vault: \\e2c5;\n$fa-var-vector-circle: \\e2c6;\n$fa-var-vector-polygon: \\e2c7;\n$fa-var-vector-square: \\f5cb;\n$fa-var-vent-damper: \\e465;\n$fa-var-venus: \\f221;\n$fa-var-venus-double: \\f226;\n$fa-var-venus-mars: \\f228;\n$fa-var-vest: \\e085;\n$fa-var-vest-patches: \\e086;\n$fa-var-vial: \\f492;\n$fa-var-vials: \\f493;\n$fa-var-video: \\f03d;\n$fa-var-video-camera: \\f03d;\n$fa-var-video-arrow-down-left: \\e2c8;\n$fa-var-video-arrow-up-right: \\e2c9;\n$fa-var-video-plus: \\f4e1;\n$fa-var-video-slash: \\f4e2;\n$fa-var-vihara: \\f6a7;\n$fa-var-violin: \\f8ed;\n$fa-var-virus: \\e074;\n$fa-var-virus-slash: \\e075;\n$fa-var-viruses: \\e076;\n$fa-var-voicemail: \\f897;\n$fa-var-volcano: \\f770;\n$fa-var-volleyball: \\f45f;\n$fa-var-volleyball-ball: \\f45f;\n$fa-var-volume: \\f6a8;\n$fa-var-volume-medium: \\f6a8;\n$fa-var-volume-high: \\f028;\n$fa-var-volume-up: \\f028;\n$fa-var-volume-low: \\f027;\n$fa-var-volume-down: \\f027;\n$fa-var-volume-off: \\f026;\n$fa-var-volume-slash: \\f2e2;\n$fa-var-volume-xmark: \\f6a9;\n$fa-var-volume-mute: \\f6a9;\n$fa-var-volume-times: \\f6a9;\n$fa-var-vr-cardboard: \\f729;\n$fa-var-w: \\57;\n$fa-var-waffle: \\e466;\n$fa-var-wagon-covered: \\f8ee;\n$fa-var-walker: \\f831;\n$fa-var-walkie-talkie: \\f8ef;\n$fa-var-wallet: \\f555;\n$fa-var-wand: \\f72a;\n$fa-var-wand-magic: \\f0d0;\n$fa-var-magic: \\f0d0;\n$fa-var-wand-magic-sparkles: \\e2ca;\n$fa-var-magic-wand-sparkles: \\e2ca;\n$fa-var-wand-sparkles: \\f72b;\n$fa-var-warehouse: \\f494;\n$fa-var-warehouse-full: \\f495;\n$fa-var-warehouse-alt: \\f495;\n$fa-var-washing-machine: \\f898;\n$fa-var-washer: \\f898;\n$fa-var-watch: \\f2e1;\n$fa-var-watch-apple: \\e2cb;\n$fa-var-watch-calculator: \\f8f0;\n$fa-var-watch-fitness: \\f63e;\n$fa-var-watch-smart: \\e2cc;\n$fa-var-water: \\f773;\n$fa-var-water-arrow-down: \\f774;\n$fa-var-water-lower: \\f774;\n$fa-var-water-arrow-up: \\f775;\n$fa-var-water-rise: \\f775;\n$fa-var-water-ladder: \\f5c5;\n$fa-var-ladder-water: \\f5c5;\n$fa-var-swimming-pool: \\f5c5;\n$fa-var-watermelon-slice: \\e337;\n$fa-var-wave-pulse: \\f5f8;\n$fa-var-heart-rate: \\f5f8;\n$fa-var-wave-sine: \\f899;\n$fa-var-wave-square: \\f83e;\n$fa-var-wave-triangle: \\f89a;\n$fa-var-waveform: \\f8f1;\n$fa-var-waveform-lines: \\f8f2;\n$fa-var-weight-hanging: \\f5cd;\n$fa-var-weight-scale: \\f496;\n$fa-var-weight: \\f496;\n$fa-var-whale: \\f72c;\n$fa-var-wheat: \\f72d;\n$fa-var-wheat-awn: \\e2cd;\n$fa-var-wheat-alt: \\e2cd;\n$fa-var-wheat-awn-slash: \\e338;\n$fa-var-wheat-slash: \\e339;\n$fa-var-wheelchair: \\f193;\n$fa-var-wheelchair-move: \\e2ce;\n$fa-var-wheelchair-alt: \\e2ce;\n$fa-var-whiskey-glass: \\f7a0;\n$fa-var-glass-whiskey: \\f7a0;\n$fa-var-whiskey-glass-ice: \\f7a1;\n$fa-var-glass-whiskey-rocks: \\f7a1;\n$fa-var-whistle: \\f460;\n$fa-var-wifi: \\f1eb;\n$fa-var-wifi-3: \\f1eb;\n$fa-var-wifi-strong: \\f1eb;\n$fa-var-wifi-exclamation: \\e2cf;\n$fa-var-wifi-fair: \\f6ab;\n$fa-var-wifi-2: \\f6ab;\n$fa-var-wifi-slash: \\f6ac;\n$fa-var-wifi-weak: \\f6aa;\n$fa-var-wifi-1: \\f6aa;\n$fa-var-wind: \\f72e;\n$fa-var-wind-turbine: \\f89b;\n$fa-var-wind-warning: \\f776;\n$fa-var-wind-circle-exclamation: \\f776;\n$fa-var-window: \\f40e;\n$fa-var-window-flip: \\f40f;\n$fa-var-window-alt: \\f40f;\n$fa-var-window-frame: \\e04f;\n$fa-var-window-frame-open: \\e050;\n$fa-var-window-maximize: \\f2d0;\n$fa-var-window-minimize: \\f2d1;\n$fa-var-window-restore: \\f2d2;\n$fa-var-windsock: \\f777;\n$fa-var-wine-bottle: \\f72f;\n$fa-var-wine-glass: \\f4e3;\n$fa-var-wine-glass-crack: \\f4bb;\n$fa-var-fragile: \\f4bb;\n$fa-var-wine-glass-empty: \\f5ce;\n$fa-var-wine-glass-alt: \\f5ce;\n$fa-var-won-sign: \\f159;\n$fa-var-krw: \\f159;\n$fa-var-won: \\f159;\n$fa-var-wreath: \\f7e2;\n$fa-var-wrench: \\f0ad;\n$fa-var-wrench-simple: \\e2d1;\n$fa-var-x: \\58;\n$fa-var-x-ray: \\f497;\n$fa-var-xmark: \\f00d;\n$fa-var-close: \\f00d;\n$fa-var-multiply: \\f00d;\n$fa-var-remove: \\f00d;\n$fa-var-times: \\f00d;\n$fa-var-xmark-to-slot: \\f771;\n$fa-var-times-to-slot: \\f771;\n$fa-var-vote-nay: \\f771;\n$fa-var-y: \\59;\n$fa-var-yen-sign: \\f157;\n$fa-var-cny: \\f157;\n$fa-var-jpy: \\f157;\n$fa-var-rmb: \\f157;\n$fa-var-yen: \\f157;\n$fa-var-yin-yang: \\f6ad;\n$fa-var-z: \\5a;\n\n$fa-var-42-group: \\e080;\n$fa-var-innosoft: \\e080;\n$fa-var-500px: \\f26e;\n$fa-var-accessible-icon: \\f368;\n$fa-var-accusoft: \\f369;\n$fa-var-acquisitions-incorporated: \\f6af;\n$fa-var-adn: \\f170;\n$fa-var-adversal: \\f36a;\n$fa-var-affiliatetheme: \\f36b;\n$fa-var-airbnb: \\f834;\n$fa-var-algolia: \\f36c;\n$fa-var-alipay: \\f642;\n$fa-var-amazon: \\f270;\n$fa-var-amazon-pay: \\f42c;\n$fa-var-amilia: \\f36d;\n$fa-var-android: \\f17b;\n$fa-var-angellist: \\f209;\n$fa-var-angrycreative: \\f36e;\n$fa-var-angular: \\f420;\n$fa-var-app-store: \\f36f;\n$fa-var-app-store-ios: \\f370;\n$fa-var-apper: \\f371;\n$fa-var-apple: \\f179;\n$fa-var-apple-pay: \\f415;\n$fa-var-artstation: \\f77a;\n$fa-var-asymmetrik: \\f372;\n$fa-var-atlassian: \\f77b;\n$fa-var-audible: \\f373;\n$fa-var-autoprefixer: \\f41c;\n$fa-var-avianex: \\f374;\n$fa-var-aviato: \\f421;\n$fa-var-aws: \\f375;\n$fa-var-bandcamp: \\f2d5;\n$fa-var-battle-net: \\f835;\n$fa-var-behance: \\f1b4;\n$fa-var-behance-square: \\f1b5;\n$fa-var-bilibili: \\e3d9;\n$fa-var-bimobject: \\f378;\n$fa-var-bitbucket: \\f171;\n$fa-var-bitcoin: \\f379;\n$fa-var-bity: \\f37a;\n$fa-var-black-tie: \\f27e;\n$fa-var-blackberry: \\f37b;\n$fa-var-blogger: \\f37c;\n$fa-var-blogger-b: \\f37d;\n$fa-var-bluetooth: \\f293;\n$fa-var-bluetooth-b: \\f294;\n$fa-var-bootstrap: \\f836;\n$fa-var-bots: \\e340;\n$fa-var-btc: \\f15a;\n$fa-var-buffer: \\f837;\n$fa-var-buromobelexperte: \\f37f;\n$fa-var-buy-n-large: \\f8a6;\n$fa-var-buysellads: \\f20d;\n$fa-var-canadian-maple-leaf: \\f785;\n$fa-var-cc-amazon-pay: \\f42d;\n$fa-var-cc-amex: \\f1f3;\n$fa-var-cc-apple-pay: \\f416;\n$fa-var-cc-diners-club: \\f24c;\n$fa-var-cc-discover: \\f1f2;\n$fa-var-cc-jcb: \\f24b;\n$fa-var-cc-mastercard: \\f1f1;\n$fa-var-cc-paypal: \\f1f4;\n$fa-var-cc-stripe: \\f1f5;\n$fa-var-cc-visa: \\f1f0;\n$fa-var-centercode: \\f380;\n$fa-var-centos: \\f789;\n$fa-var-chrome: \\f268;\n$fa-var-chromecast: \\f838;\n$fa-var-cloudflare: \\e07d;\n$fa-var-cloudscale: \\f383;\n$fa-var-cloudsmith: \\f384;\n$fa-var-cloudversify: \\f385;\n$fa-var-cmplid: \\e360;\n$fa-var-codepen: \\f1cb;\n$fa-var-codiepie: \\f284;\n$fa-var-confluence: \\f78d;\n$fa-var-connectdevelop: \\f20e;\n$fa-var-contao: \\f26d;\n$fa-var-cotton-bureau: \\f89e;\n$fa-var-cpanel: \\f388;\n$fa-var-creative-commons: \\f25e;\n$fa-var-creative-commons-by: \\f4e7;\n$fa-var-creative-commons-nc: \\f4e8;\n$fa-var-creative-commons-nc-eu: \\f4e9;\n$fa-var-creative-commons-nc-jp: \\f4ea;\n$fa-var-creative-commons-nd: \\f4eb;\n$fa-var-creative-commons-pd: \\f4ec;\n$fa-var-creative-commons-pd-alt: \\f4ed;\n$fa-var-creative-commons-remix: \\f4ee;\n$fa-var-creative-commons-sa: \\f4ef;\n$fa-var-creative-commons-sampling: \\f4f0;\n$fa-var-creative-commons-sampling-plus: \\f4f1;\n$fa-var-creative-commons-share: \\f4f2;\n$fa-var-creative-commons-zero: \\f4f3;\n$fa-var-critical-role: \\f6c9;\n$fa-var-css3: \\f13c;\n$fa-var-css3-alt: \\f38b;\n$fa-var-cuttlefish: \\f38c;\n$fa-var-d-and-d: \\f38d;\n$fa-var-d-and-d-beyond: \\f6ca;\n$fa-var-dailymotion: \\e052;\n$fa-var-dashcube: \\f210;\n$fa-var-deezer: \\e077;\n$fa-var-delicious: \\f1a5;\n$fa-var-deploydog: \\f38e;\n$fa-var-deskpro: \\f38f;\n$fa-var-dev: \\f6cc;\n$fa-var-deviantart: \\f1bd;\n$fa-var-dhl: \\f790;\n$fa-var-diaspora: \\f791;\n$fa-var-digg: \\f1a6;\n$fa-var-digital-ocean: \\f391;\n$fa-var-discord: \\f392;\n$fa-var-discourse: \\f393;\n$fa-var-dochub: \\f394;\n$fa-var-docker: \\f395;\n$fa-var-draft2digital: \\f396;\n$fa-var-dribbble: \\f17d;\n$fa-var-dribbble-square: \\f397;\n$fa-var-dropbox: \\f16b;\n$fa-var-drupal: \\f1a9;\n$fa-var-dyalog: \\f399;\n$fa-var-earlybirds: \\f39a;\n$fa-var-ebay: \\f4f4;\n$fa-var-edge: \\f282;\n$fa-var-edge-legacy: \\e078;\n$fa-var-elementor: \\f430;\n$fa-var-ello: \\f5f1;\n$fa-var-ember: \\f423;\n$fa-var-empire: \\f1d1;\n$fa-var-envira: \\f299;\n$fa-var-erlang: \\f39d;\n$fa-var-ethereum: \\f42e;\n$fa-var-etsy: \\f2d7;\n$fa-var-evernote: \\f839;\n$fa-var-expeditedssl: \\f23e;\n$fa-var-facebook: \\f09a;\n$fa-var-facebook-f: \\f39e;\n$fa-var-facebook-messenger: \\f39f;\n$fa-var-facebook-square: \\f082;\n$fa-var-fantasy-flight-games: \\f6dc;\n$fa-var-fedex: \\f797;\n$fa-var-fedora: \\f798;\n$fa-var-figma: \\f799;\n$fa-var-firefox: \\f269;\n$fa-var-firefox-browser: \\e007;\n$fa-var-first-order: \\f2b0;\n$fa-var-first-order-alt: \\f50a;\n$fa-var-firstdraft: \\f3a1;\n$fa-var-flickr: \\f16e;\n$fa-var-flipboard: \\f44d;\n$fa-var-fly: \\f417;\n$fa-var-font-awesome: \\f2b4;\n$fa-var-font-awesome-flag: \\f2b4;\n$fa-var-font-awesome-logo-full: \\f2b4;\n$fa-var-fonticons: \\f280;\n$fa-var-fonticons-fi: \\f3a2;\n$fa-var-fort-awesome: \\f286;\n$fa-var-fort-awesome-alt: \\f3a3;\n$fa-var-forumbee: \\f211;\n$fa-var-foursquare: \\f180;\n$fa-var-free-code-camp: \\f2c5;\n$fa-var-freebsd: \\f3a4;\n$fa-var-fulcrum: \\f50b;\n$fa-var-galactic-republic: \\f50c;\n$fa-var-galactic-senate: \\f50d;\n$fa-var-get-pocket: \\f265;\n$fa-var-gg: \\f260;\n$fa-var-gg-circle: \\f261;\n$fa-var-git: \\f1d3;\n$fa-var-git-alt: \\f841;\n$fa-var-git-square: \\f1d2;\n$fa-var-github: \\f09b;\n$fa-var-github-alt: \\f113;\n$fa-var-github-square: \\f092;\n$fa-var-gitkraken: \\f3a6;\n$fa-var-gitlab: \\f296;\n$fa-var-gitter: \\f426;\n$fa-var-glide: \\f2a5;\n$fa-var-glide-g: \\f2a6;\n$fa-var-gofore: \\f3a7;\n$fa-var-golang: \\e40f;\n$fa-var-goodreads: \\f3a8;\n$fa-var-goodreads-g: \\f3a9;\n$fa-var-google: \\f1a0;\n$fa-var-google-drive: \\f3aa;\n$fa-var-google-pay: \\e079;\n$fa-var-google-play: \\f3ab;\n$fa-var-google-plus: \\f2b3;\n$fa-var-google-plus-g: \\f0d5;\n$fa-var-google-plus-square: \\f0d4;\n$fa-var-google-wallet: \\f1ee;\n$fa-var-gratipay: \\f184;\n$fa-var-grav: \\f2d6;\n$fa-var-gripfire: \\f3ac;\n$fa-var-grunt: \\f3ad;\n$fa-var-guilded: \\e07e;\n$fa-var-gulp: \\f3ae;\n$fa-var-hacker-news: \\f1d4;\n$fa-var-hacker-news-square: \\f3af;\n$fa-var-hackerrank: \\f5f7;\n$fa-var-hips: \\f452;\n$fa-var-hire-a-helper: \\f3b0;\n$fa-var-hive: \\e07f;\n$fa-var-hooli: \\f427;\n$fa-var-hornbill: \\f592;\n$fa-var-hotjar: \\f3b1;\n$fa-var-houzz: \\f27c;\n$fa-var-html5: \\f13b;\n$fa-var-hubspot: \\f3b2;\n$fa-var-ideal: \\e013;\n$fa-var-imdb: \\f2d8;\n$fa-var-instagram: \\f16d;\n$fa-var-instagram-square: \\e055;\n$fa-var-instalod: \\e081;\n$fa-var-intercom: \\f7af;\n$fa-var-internet-explorer: \\f26b;\n$fa-var-invision: \\f7b0;\n$fa-var-ioxhost: \\f208;\n$fa-var-itch-io: \\f83a;\n$fa-var-itunes: \\f3b4;\n$fa-var-itunes-note: \\f3b5;\n$fa-var-java: \\f4e4;\n$fa-var-jedi-order: \\f50e;\n$fa-var-jenkins: \\f3b6;\n$fa-var-jira: \\f7b1;\n$fa-var-joget: \\f3b7;\n$fa-var-joomla: \\f1aa;\n$fa-var-js: \\f3b8;\n$fa-var-js-square: \\f3b9;\n$fa-var-jsfiddle: \\f1cc;\n$fa-var-kaggle: \\f5fa;\n$fa-var-keybase: \\f4f5;\n$fa-var-keycdn: \\f3ba;\n$fa-var-kickstarter: \\f3bb;\n$fa-var-kickstarter-k: \\f3bc;\n$fa-var-korvue: \\f42f;\n$fa-var-laravel: \\f3bd;\n$fa-var-lastfm: \\f202;\n$fa-var-lastfm-square: \\f203;\n$fa-var-leanpub: \\f212;\n$fa-var-less: \\f41d;\n$fa-var-line: \\f3c0;\n$fa-var-linkedin: \\f08c;\n$fa-var-linkedin-in: \\f0e1;\n$fa-var-linode: \\f2b8;\n$fa-var-linux: \\f17c;\n$fa-var-lyft: \\f3c3;\n$fa-var-magento: \\f3c4;\n$fa-var-mailchimp: \\f59e;\n$fa-var-mandalorian: \\f50f;\n$fa-var-markdown: \\f60f;\n$fa-var-mastodon: \\f4f6;\n$fa-var-maxcdn: \\f136;\n$fa-var-mdb: \\f8ca;\n$fa-var-medapps: \\f3c6;\n$fa-var-medium: \\f23a;\n$fa-var-medium-m: \\f23a;\n$fa-var-medrt: \\f3c8;\n$fa-var-meetup: \\f2e0;\n$fa-var-megaport: \\f5a3;\n$fa-var-mendeley: \\f7b3;\n$fa-var-microblog: \\e01a;\n$fa-var-microsoft: \\f3ca;\n$fa-var-mix: \\f3cb;\n$fa-var-mixcloud: \\f289;\n$fa-var-mixer: \\e056;\n$fa-var-mizuni: \\f3cc;\n$fa-var-modx: \\f285;\n$fa-var-monero: \\f3d0;\n$fa-var-napster: \\f3d2;\n$fa-var-neos: \\f612;\n$fa-var-nimblr: \\f5a8;\n$fa-var-node: \\f419;\n$fa-var-node-js: \\f3d3;\n$fa-var-npm: \\f3d4;\n$fa-var-ns8: \\f3d5;\n$fa-var-nutritionix: \\f3d6;\n$fa-var-octopus-deploy: \\e082;\n$fa-var-odnoklassniki: \\f263;\n$fa-var-odnoklassniki-square: \\f264;\n$fa-var-old-republic: \\f510;\n$fa-var-opencart: \\f23d;\n$fa-var-openid: \\f19b;\n$fa-var-opera: \\f26a;\n$fa-var-optin-monster: \\f23c;\n$fa-var-orcid: \\f8d2;\n$fa-var-osi: \\f41a;\n$fa-var-page4: \\f3d7;\n$fa-var-pagelines: \\f18c;\n$fa-var-palfed: \\f3d8;\n$fa-var-patreon: \\f3d9;\n$fa-var-paypal: \\f1ed;\n$fa-var-penny-arcade: \\f704;\n$fa-var-perbyte: \\e083;\n$fa-var-periscope: \\f3da;\n$fa-var-phabricator: \\f3db;\n$fa-var-phoenix-framework: \\f3dc;\n$fa-var-phoenix-squadron: \\f511;\n$fa-var-php: \\f457;\n$fa-var-pied-piper: \\f2ae;\n$fa-var-pied-piper-alt: \\f1a8;\n$fa-var-pied-piper-hat: \\f4e5;\n$fa-var-pied-piper-pp: \\f1a7;\n$fa-var-pied-piper-square: \\e01e;\n$fa-var-pinterest: \\f0d2;\n$fa-var-pinterest-p: \\f231;\n$fa-var-pinterest-square: \\f0d3;\n$fa-var-pix: \\e43a;\n$fa-var-playstation: \\f3df;\n$fa-var-product-hunt: \\f288;\n$fa-var-pushed: \\f3e1;\n$fa-var-python: \\f3e2;\n$fa-var-qq: \\f1d6;\n$fa-var-quinscape: \\f459;\n$fa-var-quora: \\f2c4;\n$fa-var-r-project: \\f4f7;\n$fa-var-raspberry-pi: \\f7bb;\n$fa-var-ravelry: \\f2d9;\n$fa-var-react: \\f41b;\n$fa-var-reacteurope: \\f75d;\n$fa-var-readme: \\f4d5;\n$fa-var-rebel: \\f1d0;\n$fa-var-red-river: \\f3e3;\n$fa-var-reddit: \\f1a1;\n$fa-var-reddit-alien: \\f281;\n$fa-var-reddit-square: \\f1a2;\n$fa-var-redhat: \\f7bc;\n$fa-var-renren: \\f18b;\n$fa-var-replyd: \\f3e6;\n$fa-var-researchgate: \\f4f8;\n$fa-var-resolving: \\f3e7;\n$fa-var-rev: \\f5b2;\n$fa-var-rocketchat: \\f3e8;\n$fa-var-rockrms: \\f3e9;\n$fa-var-rust: \\e07a;\n$fa-var-safari: \\f267;\n$fa-var-salesforce: \\f83b;\n$fa-var-sass: \\f41e;\n$fa-var-schlix: \\f3ea;\n$fa-var-scribd: \\f28a;\n$fa-var-searchengin: \\f3eb;\n$fa-var-sellcast: \\f2da;\n$fa-var-sellsy: \\f213;\n$fa-var-servicestack: \\f3ec;\n$fa-var-shirtsinbulk: \\f214;\n$fa-var-shopify: \\e057;\n$fa-var-shopware: \\f5b5;\n$fa-var-simplybuilt: \\f215;\n$fa-var-sistrix: \\f3ee;\n$fa-var-sith: \\f512;\n$fa-var-sitrox: \\e44a;\n$fa-var-sketch: \\f7c6;\n$fa-var-skyatlas: \\f216;\n$fa-var-skype: \\f17e;\n$fa-var-slack: \\f198;\n$fa-var-slack-hash: \\f198;\n$fa-var-slideshare: \\f1e7;\n$fa-var-snapchat: \\f2ab;\n$fa-var-snapchat-ghost: \\f2ab;\n$fa-var-snapchat-square: \\f2ad;\n$fa-var-soundcloud: \\f1be;\n$fa-var-sourcetree: \\f7d3;\n$fa-var-speakap: \\f3f3;\n$fa-var-speaker-deck: \\f83c;\n$fa-var-spotify: \\f1bc;\n$fa-var-square-font-awesome: \\f425;\n$fa-var-square-font-awesome-stroke: \\f35c;\n$fa-var-font-awesome-alt: \\f35c;\n$fa-var-squarespace: \\f5be;\n$fa-var-stack-exchange: \\f18d;\n$fa-var-stack-overflow: \\f16c;\n$fa-var-stackpath: \\f842;\n$fa-var-staylinked: \\f3f5;\n$fa-var-steam: \\f1b6;\n$fa-var-steam-square: \\f1b7;\n$fa-var-steam-symbol: \\f3f6;\n$fa-var-sticker-mule: \\f3f7;\n$fa-var-strava: \\f428;\n$fa-var-stripe: \\f429;\n$fa-var-stripe-s: \\f42a;\n$fa-var-studiovinari: \\f3f8;\n$fa-var-stumbleupon: \\f1a4;\n$fa-var-stumbleupon-circle: \\f1a3;\n$fa-var-superpowers: \\f2dd;\n$fa-var-supple: \\f3f9;\n$fa-var-suse: \\f7d6;\n$fa-var-swift: \\f8e1;\n$fa-var-symfony: \\f83d;\n$fa-var-teamspeak: \\f4f9;\n$fa-var-telegram: \\f2c6;\n$fa-var-telegram-plane: \\f2c6;\n$fa-var-tencent-weibo: \\f1d5;\n$fa-var-the-red-yeti: \\f69d;\n$fa-var-themeco: \\f5c6;\n$fa-var-themeisle: \\f2b2;\n$fa-var-think-peaks: \\f731;\n$fa-var-tiktok: \\e07b;\n$fa-var-trade-federation: \\f513;\n$fa-var-trello: \\f181;\n$fa-var-tumblr: \\f173;\n$fa-var-tumblr-square: \\f174;\n$fa-var-twitch: \\f1e8;\n$fa-var-twitter: \\f099;\n$fa-var-twitter-square: \\f081;\n$fa-var-typo3: \\f42b;\n$fa-var-uber: \\f402;\n$fa-var-ubuntu: \\f7df;\n$fa-var-uikit: \\f403;\n$fa-var-umbraco: \\f8e8;\n$fa-var-uncharted: \\e084;\n$fa-var-uniregistry: \\f404;\n$fa-var-unity: \\e049;\n$fa-var-unsplash: \\e07c;\n$fa-var-untappd: \\f405;\n$fa-var-ups: \\f7e0;\n$fa-var-usb: \\f287;\n$fa-var-usps: \\f7e1;\n$fa-var-ussunnah: \\f407;\n$fa-var-vaadin: \\f408;\n$fa-var-viacoin: \\f237;\n$fa-var-viadeo: \\f2a9;\n$fa-var-viadeo-square: \\f2aa;\n$fa-var-viber: \\f409;\n$fa-var-vimeo: \\f40a;\n$fa-var-vimeo-square: \\f194;\n$fa-var-vimeo-v: \\f27d;\n$fa-var-vine: \\f1ca;\n$fa-var-vk: \\f189;\n$fa-var-vnv: \\f40b;\n$fa-var-vuejs: \\f41f;\n$fa-var-watchman-monitoring: \\e087;\n$fa-var-waze: \\f83f;\n$fa-var-weebly: \\f5cc;\n$fa-var-weibo: \\f18a;\n$fa-var-weixin: \\f1d7;\n$fa-var-whatsapp: \\f232;\n$fa-var-whatsapp-square: \\f40c;\n$fa-var-whmcs: \\f40d;\n$fa-var-wikipedia-w: \\f266;\n$fa-var-windows: \\f17a;\n$fa-var-wirsindhandwerk: \\e2d0;\n$fa-var-wsh: \\e2d0;\n$fa-var-wix: \\f5cf;\n$fa-var-wizards-of-the-coast: \\f730;\n$fa-var-wodu: \\e088;\n$fa-var-wolf-pack-battalion: \\f514;\n$fa-var-wordpress: \\f19a;\n$fa-var-wordpress-simple: \\f411;\n$fa-var-wpbeginner: \\f297;\n$fa-var-wpexplorer: \\f2de;\n$fa-var-wpforms: \\f298;\n$fa-var-wpressr: \\f3e4;\n$fa-var-xbox: \\f412;\n$fa-var-xing: \\f168;\n$fa-var-xing-square: \\f169;\n$fa-var-y-combinator: \\f23b;\n$fa-var-yahoo: \\f19e;\n$fa-var-yammer: \\f840;\n$fa-var-yandex: \\f413;\n$fa-var-yandex-international: \\f414;\n$fa-var-yarn: \\f7e3;\n$fa-var-yelp: \\f1e9;\n$fa-var-yoast: \\f2b1;\n$fa-var-youtube: \\f167;\n$fa-var-youtube-square: \\f431;\n$fa-var-zhihu: \\f63f;\n\n$fa-icons: (\n  \"0\": $fa-var-0,\n  \"1\": $fa-var-1,\n  \"2\": $fa-var-2,\n  \"3\": $fa-var-3,\n  \"4\": $fa-var-4,\n  \"5\": $fa-var-5,\n  \"6\": $fa-var-6,\n  \"7\": $fa-var-7,\n  \"8\": $fa-var-8,\n  \"9\": $fa-var-9,\n  \"360-degrees\": $fa-var-360-degrees,\n  \"a\": $fa-var-a,\n  \"abacus\": $fa-var-abacus,\n  \"accent-grave\": $fa-var-accent-grave,\n  \"acorn\": $fa-var-acorn,\n  \"address-book\": $fa-var-address-book,\n  \"contact-book\": $fa-var-contact-book,\n  \"address-card\": $fa-var-address-card,\n  \"contact-card\": $fa-var-contact-card,\n  \"vcard\": $fa-var-vcard,\n  \"air-conditioner\": $fa-var-air-conditioner,\n  \"airplay\": $fa-var-airplay,\n  \"alarm-clock\": $fa-var-alarm-clock,\n  \"alarm-exclamation\": $fa-var-alarm-exclamation,\n  \"alarm-plus\": $fa-var-alarm-plus,\n  \"alarm-snooze\": $fa-var-alarm-snooze,\n  \"album\": $fa-var-album,\n  \"album-collection\": $fa-var-album-collection,\n  \"alicorn\": $fa-var-alicorn,\n  \"alien\": $fa-var-alien,\n  \"alien-8bit\": $fa-var-alien-8bit,\n  \"alien-monster\": $fa-var-alien-monster,\n  \"align-center\": $fa-var-align-center,\n  \"align-justify\": $fa-var-align-justify,\n  \"align-left\": $fa-var-align-left,\n  \"align-right\": $fa-var-align-right,\n  \"align-slash\": $fa-var-align-slash,\n  \"alt\": $fa-var-alt,\n  \"amp-guitar\": $fa-var-amp-guitar,\n  \"ampersand\": $fa-var-ampersand,\n  \"anchor\": $fa-var-anchor,\n  \"angel\": $fa-var-angel,\n  \"angle\": $fa-var-angle,\n  \"angle-90\": $fa-var-angle-90,\n  \"angle-down\": $fa-var-angle-down,\n  \"angle-left\": $fa-var-angle-left,\n  \"angle-right\": $fa-var-angle-right,\n  \"angle-up\": $fa-var-angle-up,\n  \"angles-down\": $fa-var-angles-down,\n  \"angle-double-down\": $fa-var-angle-double-down,\n  \"angles-left\": $fa-var-angles-left,\n  \"angle-double-left\": $fa-var-angle-double-left,\n  \"angles-right\": $fa-var-angles-right,\n  \"angle-double-right\": $fa-var-angle-double-right,\n  \"angles-up\": $fa-var-angles-up,\n  \"angle-double-up\": $fa-var-angle-double-up,\n  \"ankh\": $fa-var-ankh,\n  \"aperture\": $fa-var-aperture,\n  \"apostrophe\": $fa-var-apostrophe,\n  \"apple-core\": $fa-var-apple-core,\n  \"apple-whole\": $fa-var-apple-whole,\n  \"apple-alt\": $fa-var-apple-alt,\n  \"archway\": $fa-var-archway,\n  \"arrow-down\": $fa-var-arrow-down,\n  \"arrow-down-1-9\": $fa-var-arrow-down-1-9,\n  \"sort-numeric-asc\": $fa-var-sort-numeric-asc,\n  \"sort-numeric-down\": $fa-var-sort-numeric-down,\n  \"arrow-down-9-1\": $fa-var-arrow-down-9-1,\n  \"sort-numeric-desc\": $fa-var-sort-numeric-desc,\n  \"sort-numeric-down-alt\": $fa-var-sort-numeric-down-alt,\n  \"arrow-down-a-z\": $fa-var-arrow-down-a-z,\n  \"sort-alpha-asc\": $fa-var-sort-alpha-asc,\n  \"sort-alpha-down\": $fa-var-sort-alpha-down,\n  \"arrow-down-arrow-up\": $fa-var-arrow-down-arrow-up,\n  \"sort-alt\": $fa-var-sort-alt,\n  \"arrow-down-big-small\": $fa-var-arrow-down-big-small,\n  \"sort-size-down\": $fa-var-sort-size-down,\n  \"arrow-down-from-dotted-line\": $fa-var-arrow-down-from-dotted-line,\n  \"arrow-down-from-line\": $fa-var-arrow-down-from-line,\n  \"arrow-from-top\": $fa-var-arrow-from-top,\n  \"arrow-down-left\": $fa-var-arrow-down-left,\n  \"arrow-down-left-and-arrow-up-right-to-center\": $fa-var-arrow-down-left-and-arrow-up-right-to-center,\n  \"arrow-down-long\": $fa-var-arrow-down-long,\n  \"long-arrow-down\": $fa-var-long-arrow-down,\n  \"arrow-down-right\": $fa-var-arrow-down-right,\n  \"arrow-down-short-wide\": $fa-var-arrow-down-short-wide,\n  \"sort-amount-desc\": $fa-var-sort-amount-desc,\n  \"sort-amount-down-alt\": $fa-var-sort-amount-down-alt,\n  \"arrow-down-small-big\": $fa-var-arrow-down-small-big,\n  \"sort-size-down-alt\": $fa-var-sort-size-down-alt,\n  \"arrow-down-square-triangle\": $fa-var-arrow-down-square-triangle,\n  \"sort-shapes-down-alt\": $fa-var-sort-shapes-down-alt,\n  \"arrow-down-to-bracket\": $fa-var-arrow-down-to-bracket,\n  \"arrow-down-to-dotted-line\": $fa-var-arrow-down-to-dotted-line,\n  \"arrow-down-to-line\": $fa-var-arrow-down-to-line,\n  \"arrow-to-bottom\": $fa-var-arrow-to-bottom,\n  \"arrow-down-to-square\": $fa-var-arrow-down-to-square,\n  \"arrow-down-triangle-square\": $fa-var-arrow-down-triangle-square,\n  \"sort-shapes-down\": $fa-var-sort-shapes-down,\n  \"arrow-down-wide-short\": $fa-var-arrow-down-wide-short,\n  \"sort-amount-asc\": $fa-var-sort-amount-asc,\n  \"sort-amount-down\": $fa-var-sort-amount-down,\n  \"arrow-down-z-a\": $fa-var-arrow-down-z-a,\n  \"sort-alpha-desc\": $fa-var-sort-alpha-desc,\n  \"sort-alpha-down-alt\": $fa-var-sort-alpha-down-alt,\n  \"arrow-left\": $fa-var-arrow-left,\n  \"arrow-left-from-line\": $fa-var-arrow-left-from-line,\n  \"arrow-from-right\": $fa-var-arrow-from-right,\n  \"arrow-left-long\": $fa-var-arrow-left-long,\n  \"long-arrow-left\": $fa-var-long-arrow-left,\n  \"arrow-left-long-to-line\": $fa-var-arrow-left-long-to-line,\n  \"arrow-left-to-line\": $fa-var-arrow-left-to-line,\n  \"arrow-to-left\": $fa-var-arrow-to-left,\n  \"arrow-pointer\": $fa-var-arrow-pointer,\n  \"mouse-pointer\": $fa-var-mouse-pointer,\n  \"arrow-right\": $fa-var-arrow-right,\n  \"arrow-right-arrow-left\": $fa-var-arrow-right-arrow-left,\n  \"exchange\": $fa-var-exchange,\n  \"arrow-right-from-bracket\": $fa-var-arrow-right-from-bracket,\n  \"sign-out\": $fa-var-sign-out,\n  \"arrow-right-from-line\": $fa-var-arrow-right-from-line,\n  \"arrow-from-left\": $fa-var-arrow-from-left,\n  \"arrow-right-long\": $fa-var-arrow-right-long,\n  \"long-arrow-right\": $fa-var-long-arrow-right,\n  \"arrow-right-long-to-line\": $fa-var-arrow-right-long-to-line,\n  \"arrow-right-to-bracket\": $fa-var-arrow-right-to-bracket,\n  \"sign-in\": $fa-var-sign-in,\n  \"arrow-right-to-line\": $fa-var-arrow-right-to-line,\n  \"arrow-to-right\": $fa-var-arrow-to-right,\n  \"arrow-rotate-left\": $fa-var-arrow-rotate-left,\n  \"arrow-left-rotate\": $fa-var-arrow-left-rotate,\n  \"arrow-rotate-back\": $fa-var-arrow-rotate-back,\n  \"arrow-rotate-backward\": $fa-var-arrow-rotate-backward,\n  \"undo\": $fa-var-undo,\n  \"arrow-rotate-right\": $fa-var-arrow-rotate-right,\n  \"arrow-right-rotate\": $fa-var-arrow-right-rotate,\n  \"arrow-rotate-forward\": $fa-var-arrow-rotate-forward,\n  \"redo\": $fa-var-redo,\n  \"arrow-trend-down\": $fa-var-arrow-trend-down,\n  \"arrow-trend-up\": $fa-var-arrow-trend-up,\n  \"arrow-turn-down\": $fa-var-arrow-turn-down,\n  \"level-down\": $fa-var-level-down,\n  \"arrow-turn-down-left\": $fa-var-arrow-turn-down-left,\n  \"arrow-turn-down-right\": $fa-var-arrow-turn-down-right,\n  \"arrow-turn-up\": $fa-var-arrow-turn-up,\n  \"level-up\": $fa-var-level-up,\n  \"arrow-up\": $fa-var-arrow-up,\n  \"arrow-up-1-9\": $fa-var-arrow-up-1-9,\n  \"sort-numeric-up\": $fa-var-sort-numeric-up,\n  \"arrow-up-9-1\": $fa-var-arrow-up-9-1,\n  \"sort-numeric-up-alt\": $fa-var-sort-numeric-up-alt,\n  \"arrow-up-a-z\": $fa-var-arrow-up-a-z,\n  \"sort-alpha-up\": $fa-var-sort-alpha-up,\n  \"arrow-up-arrow-down\": $fa-var-arrow-up-arrow-down,\n  \"sort-up-down\": $fa-var-sort-up-down,\n  \"arrow-up-big-small\": $fa-var-arrow-up-big-small,\n  \"sort-size-up\": $fa-var-sort-size-up,\n  \"arrow-up-from-bracket\": $fa-var-arrow-up-from-bracket,\n  \"arrow-up-from-dotted-line\": $fa-var-arrow-up-from-dotted-line,\n  \"arrow-up-from-line\": $fa-var-arrow-up-from-line,\n  \"arrow-from-bottom\": $fa-var-arrow-from-bottom,\n  \"arrow-up-from-square\": $fa-var-arrow-up-from-square,\n  \"arrow-up-left\": $fa-var-arrow-up-left,\n  \"arrow-up-left-from-circle\": $fa-var-arrow-up-left-from-circle,\n  \"arrow-up-long\": $fa-var-arrow-up-long,\n  \"long-arrow-up\": $fa-var-long-arrow-up,\n  \"arrow-up-right\": $fa-var-arrow-up-right,\n  \"arrow-up-right-and-arrow-down-left-from-center\": $fa-var-arrow-up-right-and-arrow-down-left-from-center,\n  \"arrow-up-right-from-square\": $fa-var-arrow-up-right-from-square,\n  \"external-link\": $fa-var-external-link,\n  \"arrow-up-short-wide\": $fa-var-arrow-up-short-wide,\n  \"sort-amount-up-alt\": $fa-var-sort-amount-up-alt,\n  \"arrow-up-small-big\": $fa-var-arrow-up-small-big,\n  \"sort-size-up-alt\": $fa-var-sort-size-up-alt,\n  \"arrow-up-square-triangle\": $fa-var-arrow-up-square-triangle,\n  \"sort-shapes-up-alt\": $fa-var-sort-shapes-up-alt,\n  \"arrow-up-to-dotted-line\": $fa-var-arrow-up-to-dotted-line,\n  \"arrow-up-to-line\": $fa-var-arrow-up-to-line,\n  \"arrow-to-top\": $fa-var-arrow-to-top,\n  \"arrow-up-triangle-square\": $fa-var-arrow-up-triangle-square,\n  \"sort-shapes-up\": $fa-var-sort-shapes-up,\n  \"arrow-up-wide-short\": $fa-var-arrow-up-wide-short,\n  \"sort-amount-up\": $fa-var-sort-amount-up,\n  \"arrow-up-z-a\": $fa-var-arrow-up-z-a,\n  \"sort-alpha-up-alt\": $fa-var-sort-alpha-up-alt,\n  \"arrows-cross\": $fa-var-arrows-cross,\n  \"arrows-from-dotted-line\": $fa-var-arrows-from-dotted-line,\n  \"arrows-from-line\": $fa-var-arrows-from-line,\n  \"arrows-left-right\": $fa-var-arrows-left-right,\n  \"arrows-h\": $fa-var-arrows-h,\n  \"arrows-maximize\": $fa-var-arrows-maximize,\n  \"expand-arrows\": $fa-var-expand-arrows,\n  \"arrows-minimize\": $fa-var-arrows-minimize,\n  \"compress-arrows\": $fa-var-compress-arrows,\n  \"arrows-repeat\": $fa-var-arrows-repeat,\n  \"repeat-alt\": $fa-var-repeat-alt,\n  \"arrows-repeat-1\": $fa-var-arrows-repeat-1,\n  \"repeat-1-alt\": $fa-var-repeat-1-alt,\n  \"arrows-retweet\": $fa-var-arrows-retweet,\n  \"retweet-alt\": $fa-var-retweet-alt,\n  \"arrows-rotate\": $fa-var-arrows-rotate,\n  \"refresh\": $fa-var-refresh,\n  \"sync\": $fa-var-sync,\n  \"arrows-to-dotted-line\": $fa-var-arrows-to-dotted-line,\n  \"arrows-to-line\": $fa-var-arrows-to-line,\n  \"arrows-up-down\": $fa-var-arrows-up-down,\n  \"arrows-v\": $fa-var-arrows-v,\n  \"arrows-up-down-left-right\": $fa-var-arrows-up-down-left-right,\n  \"arrows\": $fa-var-arrows,\n  \"asterisk\": $fa-var-asterisk,\n  \"at\": $fa-var-at,\n  \"atom\": $fa-var-atom,\n  \"atom-simple\": $fa-var-atom-simple,\n  \"atom-alt\": $fa-var-atom-alt,\n  \"audio-description\": $fa-var-audio-description,\n  \"audio-description-slash\": $fa-var-audio-description-slash,\n  \"austral-sign\": $fa-var-austral-sign,\n  \"avocado\": $fa-var-avocado,\n  \"award\": $fa-var-award,\n  \"award-simple\": $fa-var-award-simple,\n  \"axe\": $fa-var-axe,\n  \"axe-battle\": $fa-var-axe-battle,\n  \"b\": $fa-var-b,\n  \"baby\": $fa-var-baby,\n  \"baby-carriage\": $fa-var-baby-carriage,\n  \"carriage-baby\": $fa-var-carriage-baby,\n  \"backpack\": $fa-var-backpack,\n  \"backward\": $fa-var-backward,\n  \"backward-fast\": $fa-var-backward-fast,\n  \"fast-backward\": $fa-var-fast-backward,\n  \"backward-step\": $fa-var-backward-step,\n  \"step-backward\": $fa-var-step-backward,\n  \"bacon\": $fa-var-bacon,\n  \"bacteria\": $fa-var-bacteria,\n  \"bacterium\": $fa-var-bacterium,\n  \"badge\": $fa-var-badge,\n  \"badge-check\": $fa-var-badge-check,\n  \"badge-dollar\": $fa-var-badge-dollar,\n  \"badge-percent\": $fa-var-badge-percent,\n  \"badge-sheriff\": $fa-var-badge-sheriff,\n  \"badger-honey\": $fa-var-badger-honey,\n  \"badminton\": $fa-var-badminton,\n  \"bag-shopping\": $fa-var-bag-shopping,\n  \"shopping-bag\": $fa-var-shopping-bag,\n  \"bagel\": $fa-var-bagel,\n  \"bags-shopping\": $fa-var-bags-shopping,\n  \"baguette\": $fa-var-baguette,\n  \"bahai\": $fa-var-bahai,\n  \"baht-sign\": $fa-var-baht-sign,\n  \"ball-pile\": $fa-var-ball-pile,\n  \"balloon\": $fa-var-balloon,\n  \"balloons\": $fa-var-balloons,\n  \"ballot\": $fa-var-ballot,\n  \"ballot-check\": $fa-var-ballot-check,\n  \"ban\": $fa-var-ban,\n  \"cancel\": $fa-var-cancel,\n  \"ban-bug\": $fa-var-ban-bug,\n  \"debug\": $fa-var-debug,\n  \"ban-parking\": $fa-var-ban-parking,\n  \"parking-circle-slash\": $fa-var-parking-circle-slash,\n  \"ban-smoking\": $fa-var-ban-smoking,\n  \"smoking-ban\": $fa-var-smoking-ban,\n  \"banana\": $fa-var-banana,\n  \"bandage\": $fa-var-bandage,\n  \"band-aid\": $fa-var-band-aid,\n  \"bangladeshi-taka-sign\": $fa-var-bangladeshi-taka-sign,\n  \"banjo\": $fa-var-banjo,\n  \"bank\": $fa-var-bank,\n  \"institution\": $fa-var-institution,\n  \"university\": $fa-var-university,\n  \"barcode\": $fa-var-barcode,\n  \"barcode-read\": $fa-var-barcode-read,\n  \"barcode-scan\": $fa-var-barcode-scan,\n  \"bars\": $fa-var-bars,\n  \"navicon\": $fa-var-navicon,\n  \"bars-filter\": $fa-var-bars-filter,\n  \"bars-progress\": $fa-var-bars-progress,\n  \"tasks-alt\": $fa-var-tasks-alt,\n  \"bars-sort\": $fa-var-bars-sort,\n  \"bars-staggered\": $fa-var-bars-staggered,\n  \"reorder\": $fa-var-reorder,\n  \"stream\": $fa-var-stream,\n  \"baseball\": $fa-var-baseball,\n  \"baseball-ball\": $fa-var-baseball-ball,\n  \"baseball-bat-ball\": $fa-var-baseball-bat-ball,\n  \"basket-shopping\": $fa-var-basket-shopping,\n  \"shopping-basket\": $fa-var-shopping-basket,\n  \"basket-shopping-simple\": $fa-var-basket-shopping-simple,\n  \"shopping-basket-alt\": $fa-var-shopping-basket-alt,\n  \"basketball\": $fa-var-basketball,\n  \"basketball-ball\": $fa-var-basketball-ball,\n  \"basketball-hoop\": $fa-var-basketball-hoop,\n  \"bat\": $fa-var-bat,\n  \"bath\": $fa-var-bath,\n  \"bathtub\": $fa-var-bathtub,\n  \"battery-bolt\": $fa-var-battery-bolt,\n  \"battery-empty\": $fa-var-battery-empty,\n  \"battery-0\": $fa-var-battery-0,\n  \"battery-exclamation\": $fa-var-battery-exclamation,\n  \"battery-full\": $fa-var-battery-full,\n  \"battery\": $fa-var-battery,\n  \"battery-5\": $fa-var-battery-5,\n  \"battery-half\": $fa-var-battery-half,\n  \"battery-3\": $fa-var-battery-3,\n  \"battery-low\": $fa-var-battery-low,\n  \"battery-1\": $fa-var-battery-1,\n  \"battery-quarter\": $fa-var-battery-quarter,\n  \"battery-2\": $fa-var-battery-2,\n  \"battery-slash\": $fa-var-battery-slash,\n  \"battery-three-quarters\": $fa-var-battery-three-quarters,\n  \"battery-4\": $fa-var-battery-4,\n  \"bed\": $fa-var-bed,\n  \"bed-bunk\": $fa-var-bed-bunk,\n  \"bed-empty\": $fa-var-bed-empty,\n  \"bed-front\": $fa-var-bed-front,\n  \"bed-alt\": $fa-var-bed-alt,\n  \"bed-pulse\": $fa-var-bed-pulse,\n  \"procedures\": $fa-var-procedures,\n  \"bee\": $fa-var-bee,\n  \"beer-mug\": $fa-var-beer-mug,\n  \"beer-foam\": $fa-var-beer-foam,\n  \"beer-mug-empty\": $fa-var-beer-mug-empty,\n  \"beer\": $fa-var-beer,\n  \"bell\": $fa-var-bell,\n  \"bell-concierge\": $fa-var-bell-concierge,\n  \"concierge-bell\": $fa-var-concierge-bell,\n  \"bell-exclamation\": $fa-var-bell-exclamation,\n  \"bell-on\": $fa-var-bell-on,\n  \"bell-plus\": $fa-var-bell-plus,\n  \"bell-school\": $fa-var-bell-school,\n  \"bell-school-slash\": $fa-var-bell-school-slash,\n  \"bell-slash\": $fa-var-bell-slash,\n  \"bells\": $fa-var-bells,\n  \"bench-tree\": $fa-var-bench-tree,\n  \"bezier-curve\": $fa-var-bezier-curve,\n  \"bicycle\": $fa-var-bicycle,\n  \"binary\": $fa-var-binary,\n  \"binary-circle-check\": $fa-var-binary-circle-check,\n  \"binary-lock\": $fa-var-binary-lock,\n  \"binary-slash\": $fa-var-binary-slash,\n  \"binoculars\": $fa-var-binoculars,\n  \"biohazard\": $fa-var-biohazard,\n  \"bitcoin-sign\": $fa-var-bitcoin-sign,\n  \"blanket\": $fa-var-blanket,\n  \"blanket-fire\": $fa-var-blanket-fire,\n  \"blender\": $fa-var-blender,\n  \"blender-phone\": $fa-var-blender-phone,\n  \"blinds\": $fa-var-blinds,\n  \"blinds-open\": $fa-var-blinds-open,\n  \"blinds-raised\": $fa-var-blinds-raised,\n  \"block-brick\": $fa-var-block-brick,\n  \"wall-brick\": $fa-var-wall-brick,\n  \"block-brick-fire\": $fa-var-block-brick-fire,\n  \"firewall\": $fa-var-firewall,\n  \"block-question\": $fa-var-block-question,\n  \"block-quote\": $fa-var-block-quote,\n  \"blog\": $fa-var-blog,\n  \"blueberries\": $fa-var-blueberries,\n  \"bold\": $fa-var-bold,\n  \"bolt\": $fa-var-bolt,\n  \"flash\": $fa-var-flash,\n  \"bolt-auto\": $fa-var-bolt-auto,\n  \"bolt-lightning\": $fa-var-bolt-lightning,\n  \"bolt-slash\": $fa-var-bolt-slash,\n  \"bomb\": $fa-var-bomb,\n  \"bone\": $fa-var-bone,\n  \"bone-break\": $fa-var-bone-break,\n  \"bong\": $fa-var-bong,\n  \"book\": $fa-var-book,\n  \"book-arrow-right\": $fa-var-book-arrow-right,\n  \"book-arrow-up\": $fa-var-book-arrow-up,\n  \"book-atlas\": $fa-var-book-atlas,\n  \"atlas\": $fa-var-atlas,\n  \"book-bible\": $fa-var-book-bible,\n  \"bible\": $fa-var-bible,\n  \"book-blank\": $fa-var-book-blank,\n  \"book-alt\": $fa-var-book-alt,\n  \"book-bookmark\": $fa-var-book-bookmark,\n  \"book-circle-arrow-right\": $fa-var-book-circle-arrow-right,\n  \"book-circle-arrow-up\": $fa-var-book-circle-arrow-up,\n  \"book-copy\": $fa-var-book-copy,\n  \"book-font\": $fa-var-book-font,\n  \"book-heart\": $fa-var-book-heart,\n  \"book-journal-whills\": $fa-var-book-journal-whills,\n  \"journal-whills\": $fa-var-journal-whills,\n  \"book-medical\": $fa-var-book-medical,\n  \"book-open\": $fa-var-book-open,\n  \"book-open-cover\": $fa-var-book-open-cover,\n  \"book-open-alt\": $fa-var-book-open-alt,\n  \"book-open-reader\": $fa-var-book-open-reader,\n  \"book-reader\": $fa-var-book-reader,\n  \"book-quran\": $fa-var-book-quran,\n  \"quran\": $fa-var-quran,\n  \"book-section\": $fa-var-book-section,\n  \"book-law\": $fa-var-book-law,\n  \"book-skull\": $fa-var-book-skull,\n  \"book-dead\": $fa-var-book-dead,\n  \"book-sparkles\": $fa-var-book-sparkles,\n  \"book-spells\": $fa-var-book-spells,\n  \"book-tanakh\": $fa-var-book-tanakh,\n  \"tanakh\": $fa-var-tanakh,\n  \"book-user\": $fa-var-book-user,\n  \"bookmark\": $fa-var-bookmark,\n  \"bookmark-slash\": $fa-var-bookmark-slash,\n  \"books\": $fa-var-books,\n  \"books-medical\": $fa-var-books-medical,\n  \"boombox\": $fa-var-boombox,\n  \"boot\": $fa-var-boot,\n  \"boot-heeled\": $fa-var-boot-heeled,\n  \"booth-curtain\": $fa-var-booth-curtain,\n  \"border-all\": $fa-var-border-all,\n  \"border-bottom\": $fa-var-border-bottom,\n  \"border-bottom-right\": $fa-var-border-bottom-right,\n  \"border-style-alt\": $fa-var-border-style-alt,\n  \"border-center-h\": $fa-var-border-center-h,\n  \"border-center-v\": $fa-var-border-center-v,\n  \"border-inner\": $fa-var-border-inner,\n  \"border-left\": $fa-var-border-left,\n  \"border-none\": $fa-var-border-none,\n  \"border-outer\": $fa-var-border-outer,\n  \"border-right\": $fa-var-border-right,\n  \"border-top\": $fa-var-border-top,\n  \"border-top-left\": $fa-var-border-top-left,\n  \"border-style\": $fa-var-border-style,\n  \"bow-arrow\": $fa-var-bow-arrow,\n  \"bowl-chopsticks\": $fa-var-bowl-chopsticks,\n  \"bowl-chopsticks-noodles\": $fa-var-bowl-chopsticks-noodles,\n  \"bowl-hot\": $fa-var-bowl-hot,\n  \"soup\": $fa-var-soup,\n  \"bowl-rice\": $fa-var-bowl-rice,\n  \"bowl-scoop\": $fa-var-bowl-scoop,\n  \"bowl-shaved-ice\": $fa-var-bowl-shaved-ice,\n  \"bowl-scoops\": $fa-var-bowl-scoops,\n  \"bowl-spoon\": $fa-var-bowl-spoon,\n  \"bowling-ball\": $fa-var-bowling-ball,\n  \"bowling-ball-pin\": $fa-var-bowling-ball-pin,\n  \"bowling-pins\": $fa-var-bowling-pins,\n  \"box\": $fa-var-box,\n  \"box-archive\": $fa-var-box-archive,\n  \"archive\": $fa-var-archive,\n  \"box-ballot\": $fa-var-box-ballot,\n  \"box-check\": $fa-var-box-check,\n  \"box-circle-check\": $fa-var-box-circle-check,\n  \"box-dollar\": $fa-var-box-dollar,\n  \"box-usd\": $fa-var-box-usd,\n  \"box-heart\": $fa-var-box-heart,\n  \"box-open\": $fa-var-box-open,\n  \"box-open-full\": $fa-var-box-open-full,\n  \"box-full\": $fa-var-box-full,\n  \"box-taped\": $fa-var-box-taped,\n  \"box-alt\": $fa-var-box-alt,\n  \"box-tissue\": $fa-var-box-tissue,\n  \"boxes-stacked\": $fa-var-boxes-stacked,\n  \"boxes\": $fa-var-boxes,\n  \"boxes-alt\": $fa-var-boxes-alt,\n  \"boxing-glove\": $fa-var-boxing-glove,\n  \"glove-boxing\": $fa-var-glove-boxing,\n  \"bracket-curly\": $fa-var-bracket-curly,\n  \"bracket-curly-left\": $fa-var-bracket-curly-left,\n  \"bracket-curly-right\": $fa-var-bracket-curly-right,\n  \"bracket-round\": $fa-var-bracket-round,\n  \"parenthesis\": $fa-var-parenthesis,\n  \"bracket-round-right\": $fa-var-bracket-round-right,\n  \"bracket-square\": $fa-var-bracket-square,\n  \"bracket\": $fa-var-bracket,\n  \"bracket-left\": $fa-var-bracket-left,\n  \"bracket-square-right\": $fa-var-bracket-square-right,\n  \"brackets-curly\": $fa-var-brackets-curly,\n  \"brackets-round\": $fa-var-brackets-round,\n  \"parentheses\": $fa-var-parentheses,\n  \"brackets-square\": $fa-var-brackets-square,\n  \"brackets\": $fa-var-brackets,\n  \"braille\": $fa-var-braille,\n  \"brain\": $fa-var-brain,\n  \"brain-arrow-curved-right\": $fa-var-brain-arrow-curved-right,\n  \"mind-share\": $fa-var-mind-share,\n  \"brain-circuit\": $fa-var-brain-circuit,\n  \"brake-warning\": $fa-var-brake-warning,\n  \"bread-loaf\": $fa-var-bread-loaf,\n  \"bread-slice\": $fa-var-bread-slice,\n  \"bread-slice-butter\": $fa-var-bread-slice-butter,\n  \"briefcase\": $fa-var-briefcase,\n  \"briefcase-arrow-right\": $fa-var-briefcase-arrow-right,\n  \"briefcase-blank\": $fa-var-briefcase-blank,\n  \"briefcase-medical\": $fa-var-briefcase-medical,\n  \"brightness\": $fa-var-brightness,\n  \"brightness-low\": $fa-var-brightness-low,\n  \"bring-forward\": $fa-var-bring-forward,\n  \"bring-front\": $fa-var-bring-front,\n  \"broccoli\": $fa-var-broccoli,\n  \"broom\": $fa-var-broom,\n  \"browser\": $fa-var-browser,\n  \"browsers\": $fa-var-browsers,\n  \"brush\": $fa-var-brush,\n  \"bug\": $fa-var-bug,\n  \"building\": $fa-var-building,\n  \"buildings\": $fa-var-buildings,\n  \"bullhorn\": $fa-var-bullhorn,\n  \"bullseye\": $fa-var-bullseye,\n  \"bullseye-arrow\": $fa-var-bullseye-arrow,\n  \"bullseye-pointer\": $fa-var-bullseye-pointer,\n  \"burger\": $fa-var-burger,\n  \"hamburger\": $fa-var-hamburger,\n  \"burger-cheese\": $fa-var-burger-cheese,\n  \"cheeseburger\": $fa-var-cheeseburger,\n  \"burger-fries\": $fa-var-burger-fries,\n  \"burger-glass\": $fa-var-burger-glass,\n  \"burger-lettuce\": $fa-var-burger-lettuce,\n  \"burger-soda\": $fa-var-burger-soda,\n  \"burrito\": $fa-var-burrito,\n  \"bus\": $fa-var-bus,\n  \"bus-school\": $fa-var-bus-school,\n  \"bus-simple\": $fa-var-bus-simple,\n  \"bus-alt\": $fa-var-bus-alt,\n  \"business-time\": $fa-var-business-time,\n  \"briefcase-clock\": $fa-var-briefcase-clock,\n  \"butter\": $fa-var-butter,\n  \"c\": $fa-var-c,\n  \"cabinet-filing\": $fa-var-cabinet-filing,\n  \"cable-car\": $fa-var-cable-car,\n  \"cactus\": $fa-var-cactus,\n  \"cake-candles\": $fa-var-cake-candles,\n  \"birthday-cake\": $fa-var-birthday-cake,\n  \"cake-slice\": $fa-var-cake-slice,\n  \"shortcake\": $fa-var-shortcake,\n  \"calculator\": $fa-var-calculator,\n  \"calculator-simple\": $fa-var-calculator-simple,\n  \"calculator-alt\": $fa-var-calculator-alt,\n  \"calendar\": $fa-var-calendar,\n  \"calendar-arrow-down\": $fa-var-calendar-arrow-down,\n  \"calendar-download\": $fa-var-calendar-download,\n  \"calendar-arrow-up\": $fa-var-calendar-arrow-up,\n  \"calendar-upload\": $fa-var-calendar-upload,\n  \"calendar-check\": $fa-var-calendar-check,\n  \"calendar-clock\": $fa-var-calendar-clock,\n  \"calendar-time\": $fa-var-calendar-time,\n  \"calendar-day\": $fa-var-calendar-day,\n  \"calendar-days\": $fa-var-calendar-days,\n  \"calendar-alt\": $fa-var-calendar-alt,\n  \"calendar-exclamation\": $fa-var-calendar-exclamation,\n  \"calendar-heart\": $fa-var-calendar-heart,\n  \"calendar-image\": $fa-var-calendar-image,\n  \"calendar-lines\": $fa-var-calendar-lines,\n  \"calendar-note\": $fa-var-calendar-note,\n  \"calendar-minus\": $fa-var-calendar-minus,\n  \"calendar-pen\": $fa-var-calendar-pen,\n  \"calendar-edit\": $fa-var-calendar-edit,\n  \"calendar-plus\": $fa-var-calendar-plus,\n  \"calendar-range\": $fa-var-calendar-range,\n  \"calendar-star\": $fa-var-calendar-star,\n  \"calendar-week\": $fa-var-calendar-week,\n  \"calendar-xmark\": $fa-var-calendar-xmark,\n  \"calendar-times\": $fa-var-calendar-times,\n  \"calendars\": $fa-var-calendars,\n  \"camcorder\": $fa-var-camcorder,\n  \"video-handheld\": $fa-var-video-handheld,\n  \"camera\": $fa-var-camera,\n  \"camera-alt\": $fa-var-camera-alt,\n  \"camera-cctv\": $fa-var-camera-cctv,\n  \"cctv\": $fa-var-cctv,\n  \"camera-movie\": $fa-var-camera-movie,\n  \"camera-polaroid\": $fa-var-camera-polaroid,\n  \"camera-retro\": $fa-var-camera-retro,\n  \"camera-rotate\": $fa-var-camera-rotate,\n  \"camera-security\": $fa-var-camera-security,\n  \"camera-home\": $fa-var-camera-home,\n  \"camera-slash\": $fa-var-camera-slash,\n  \"camera-viewfinder\": $fa-var-camera-viewfinder,\n  \"camera-web\": $fa-var-camera-web,\n  \"webcam\": $fa-var-webcam,\n  \"camera-web-slash\": $fa-var-camera-web-slash,\n  \"webcam-slash\": $fa-var-webcam-slash,\n  \"campfire\": $fa-var-campfire,\n  \"campground\": $fa-var-campground,\n  \"can-food\": $fa-var-can-food,\n  \"candle-holder\": $fa-var-candle-holder,\n  \"candy\": $fa-var-candy,\n  \"candy-bar\": $fa-var-candy-bar,\n  \"chocolate-bar\": $fa-var-chocolate-bar,\n  \"candy-cane\": $fa-var-candy-cane,\n  \"candy-corn\": $fa-var-candy-corn,\n  \"cannabis\": $fa-var-cannabis,\n  \"capsules\": $fa-var-capsules,\n  \"car\": $fa-var-car,\n  \"automobile\": $fa-var-automobile,\n  \"car-battery\": $fa-var-car-battery,\n  \"battery-car\": $fa-var-battery-car,\n  \"car-bolt\": $fa-var-car-bolt,\n  \"car-building\": $fa-var-car-building,\n  \"car-bump\": $fa-var-car-bump,\n  \"car-bus\": $fa-var-car-bus,\n  \"car-circle-bolt\": $fa-var-car-circle-bolt,\n  \"car-crash\": $fa-var-car-crash,\n  \"car-garage\": $fa-var-car-garage,\n  \"car-mirrors\": $fa-var-car-mirrors,\n  \"car-rear\": $fa-var-car-rear,\n  \"car-alt\": $fa-var-car-alt,\n  \"car-side\": $fa-var-car-side,\n  \"car-side-bolt\": $fa-var-car-side-bolt,\n  \"car-tilt\": $fa-var-car-tilt,\n  \"car-wash\": $fa-var-car-wash,\n  \"car-wrench\": $fa-var-car-wrench,\n  \"car-mechanic\": $fa-var-car-mechanic,\n  \"caravan\": $fa-var-caravan,\n  \"caravan-simple\": $fa-var-caravan-simple,\n  \"caravan-alt\": $fa-var-caravan-alt,\n  \"card-club\": $fa-var-card-club,\n  \"card-diamond\": $fa-var-card-diamond,\n  \"card-heart\": $fa-var-card-heart,\n  \"card-spade\": $fa-var-card-spade,\n  \"cards\": $fa-var-cards,\n  \"caret-down\": $fa-var-caret-down,\n  \"caret-left\": $fa-var-caret-left,\n  \"caret-right\": $fa-var-caret-right,\n  \"caret-up\": $fa-var-caret-up,\n  \"carrot\": $fa-var-carrot,\n  \"cars\": $fa-var-cars,\n  \"cart-arrow-down\": $fa-var-cart-arrow-down,\n  \"cart-arrow-up\": $fa-var-cart-arrow-up,\n  \"cart-circle-arrow-down\": $fa-var-cart-circle-arrow-down,\n  \"cart-circle-arrow-up\": $fa-var-cart-circle-arrow-up,\n  \"cart-circle-check\": $fa-var-cart-circle-check,\n  \"cart-circle-exclamation\": $fa-var-cart-circle-exclamation,\n  \"cart-circle-plus\": $fa-var-cart-circle-plus,\n  \"cart-circle-xmark\": $fa-var-cart-circle-xmark,\n  \"cart-flatbed\": $fa-var-cart-flatbed,\n  \"dolly-flatbed\": $fa-var-dolly-flatbed,\n  \"cart-flatbed-boxes\": $fa-var-cart-flatbed-boxes,\n  \"dolly-flatbed-alt\": $fa-var-dolly-flatbed-alt,\n  \"cart-flatbed-empty\": $fa-var-cart-flatbed-empty,\n  \"dolly-flatbed-empty\": $fa-var-dolly-flatbed-empty,\n  \"cart-flatbed-suitcase\": $fa-var-cart-flatbed-suitcase,\n  \"luggage-cart\": $fa-var-luggage-cart,\n  \"cart-minus\": $fa-var-cart-minus,\n  \"cart-plus\": $fa-var-cart-plus,\n  \"cart-shopping\": $fa-var-cart-shopping,\n  \"shopping-cart\": $fa-var-shopping-cart,\n  \"cart-shopping-fast\": $fa-var-cart-shopping-fast,\n  \"cart-xmark\": $fa-var-cart-xmark,\n  \"cash-register\": $fa-var-cash-register,\n  \"cassette-betamax\": $fa-var-cassette-betamax,\n  \"betamax\": $fa-var-betamax,\n  \"cassette-tape\": $fa-var-cassette-tape,\n  \"cassette-vhs\": $fa-var-cassette-vhs,\n  \"vhs\": $fa-var-vhs,\n  \"castle\": $fa-var-castle,\n  \"cat\": $fa-var-cat,\n  \"cat-space\": $fa-var-cat-space,\n  \"cauldron\": $fa-var-cauldron,\n  \"cedi-sign\": $fa-var-cedi-sign,\n  \"cent-sign\": $fa-var-cent-sign,\n  \"certificate\": $fa-var-certificate,\n  \"chair\": $fa-var-chair,\n  \"chair-office\": $fa-var-chair-office,\n  \"chalkboard\": $fa-var-chalkboard,\n  \"blackboard\": $fa-var-blackboard,\n  \"chalkboard-user\": $fa-var-chalkboard-user,\n  \"chalkboard-teacher\": $fa-var-chalkboard-teacher,\n  \"champagne-glass\": $fa-var-champagne-glass,\n  \"glass-champagne\": $fa-var-glass-champagne,\n  \"champagne-glasses\": $fa-var-champagne-glasses,\n  \"glass-cheers\": $fa-var-glass-cheers,\n  \"charging-station\": $fa-var-charging-station,\n  \"chart-area\": $fa-var-chart-area,\n  \"area-chart\": $fa-var-area-chart,\n  \"chart-bar\": $fa-var-chart-bar,\n  \"bar-chart\": $fa-var-bar-chart,\n  \"chart-bullet\": $fa-var-chart-bullet,\n  \"chart-candlestick\": $fa-var-chart-candlestick,\n  \"chart-column\": $fa-var-chart-column,\n  \"chart-gantt\": $fa-var-chart-gantt,\n  \"chart-line\": $fa-var-chart-line,\n  \"line-chart\": $fa-var-line-chart,\n  \"chart-line-down\": $fa-var-chart-line-down,\n  \"chart-line-up\": $fa-var-chart-line-up,\n  \"chart-mixed\": $fa-var-chart-mixed,\n  \"analytics\": $fa-var-analytics,\n  \"chart-network\": $fa-var-chart-network,\n  \"chart-pie\": $fa-var-chart-pie,\n  \"pie-chart\": $fa-var-pie-chart,\n  \"chart-pie-simple\": $fa-var-chart-pie-simple,\n  \"chart-pie-alt\": $fa-var-chart-pie-alt,\n  \"chart-pyramid\": $fa-var-chart-pyramid,\n  \"chart-radar\": $fa-var-chart-radar,\n  \"chart-scatter\": $fa-var-chart-scatter,\n  \"chart-scatter-3d\": $fa-var-chart-scatter-3d,\n  \"chart-scatter-bubble\": $fa-var-chart-scatter-bubble,\n  \"chart-tree-map\": $fa-var-chart-tree-map,\n  \"chart-user\": $fa-var-chart-user,\n  \"user-chart\": $fa-var-user-chart,\n  \"chart-waterfall\": $fa-var-chart-waterfall,\n  \"check\": $fa-var-check,\n  \"check-double\": $fa-var-check-double,\n  \"check-to-slot\": $fa-var-check-to-slot,\n  \"vote-yea\": $fa-var-vote-yea,\n  \"cheese\": $fa-var-cheese,\n  \"cheese-swiss\": $fa-var-cheese-swiss,\n  \"cherries\": $fa-var-cherries,\n  \"chess\": $fa-var-chess,\n  \"chess-bishop\": $fa-var-chess-bishop,\n  \"chess-bishop-piece\": $fa-var-chess-bishop-piece,\n  \"chess-bishop-alt\": $fa-var-chess-bishop-alt,\n  \"chess-board\": $fa-var-chess-board,\n  \"chess-clock\": $fa-var-chess-clock,\n  \"chess-clock-flip\": $fa-var-chess-clock-flip,\n  \"chess-clock-alt\": $fa-var-chess-clock-alt,\n  \"chess-king\": $fa-var-chess-king,\n  \"chess-king-piece\": $fa-var-chess-king-piece,\n  \"chess-king-alt\": $fa-var-chess-king-alt,\n  \"chess-knight\": $fa-var-chess-knight,\n  \"chess-knight-piece\": $fa-var-chess-knight-piece,\n  \"chess-knight-alt\": $fa-var-chess-knight-alt,\n  \"chess-pawn\": $fa-var-chess-pawn,\n  \"chess-pawn-piece\": $fa-var-chess-pawn-piece,\n  \"chess-pawn-alt\": $fa-var-chess-pawn-alt,\n  \"chess-queen\": $fa-var-chess-queen,\n  \"chess-queen-piece\": $fa-var-chess-queen-piece,\n  \"chess-queen-alt\": $fa-var-chess-queen-alt,\n  \"chess-rook\": $fa-var-chess-rook,\n  \"chess-rook-piece\": $fa-var-chess-rook-piece,\n  \"chess-rook-alt\": $fa-var-chess-rook-alt,\n  \"chestnut\": $fa-var-chestnut,\n  \"chevron-down\": $fa-var-chevron-down,\n  \"chevron-left\": $fa-var-chevron-left,\n  \"chevron-right\": $fa-var-chevron-right,\n  \"chevron-up\": $fa-var-chevron-up,\n  \"chevrons-down\": $fa-var-chevrons-down,\n  \"chevron-double-down\": $fa-var-chevron-double-down,\n  \"chevrons-left\": $fa-var-chevrons-left,\n  \"chevron-double-left\": $fa-var-chevron-double-left,\n  \"chevrons-right\": $fa-var-chevrons-right,\n  \"chevron-double-right\": $fa-var-chevron-double-right,\n  \"chevrons-up\": $fa-var-chevrons-up,\n  \"chevron-double-up\": $fa-var-chevron-double-up,\n  \"child\": $fa-var-child,\n  \"chimney\": $fa-var-chimney,\n  \"chopsticks\": $fa-var-chopsticks,\n  \"church\": $fa-var-church,\n  \"circle\": $fa-var-circle,\n  \"circle-0\": $fa-var-circle-0,\n  \"circle-1\": $fa-var-circle-1,\n  \"circle-2\": $fa-var-circle-2,\n  \"circle-3\": $fa-var-circle-3,\n  \"circle-4\": $fa-var-circle-4,\n  \"circle-5\": $fa-var-circle-5,\n  \"circle-6\": $fa-var-circle-6,\n  \"circle-7\": $fa-var-circle-7,\n  \"circle-8\": $fa-var-circle-8,\n  \"circle-9\": $fa-var-circle-9,\n  \"circle-a\": $fa-var-circle-a,\n  \"circle-ampersand\": $fa-var-circle-ampersand,\n  \"circle-arrow-down\": $fa-var-circle-arrow-down,\n  \"arrow-circle-down\": $fa-var-arrow-circle-down,\n  \"circle-arrow-down-left\": $fa-var-circle-arrow-down-left,\n  \"circle-arrow-down-right\": $fa-var-circle-arrow-down-right,\n  \"circle-arrow-left\": $fa-var-circle-arrow-left,\n  \"arrow-circle-left\": $fa-var-arrow-circle-left,\n  \"circle-arrow-right\": $fa-var-circle-arrow-right,\n  \"arrow-circle-right\": $fa-var-arrow-circle-right,\n  \"circle-arrow-up\": $fa-var-circle-arrow-up,\n  \"arrow-circle-up\": $fa-var-arrow-circle-up,\n  \"circle-arrow-up-left\": $fa-var-circle-arrow-up-left,\n  \"circle-arrow-up-right\": $fa-var-circle-arrow-up-right,\n  \"circle-b\": $fa-var-circle-b,\n  \"circle-bolt\": $fa-var-circle-bolt,\n  \"circle-book-open\": $fa-var-circle-book-open,\n  \"book-circle\": $fa-var-book-circle,\n  \"circle-bookmark\": $fa-var-circle-bookmark,\n  \"bookmark-circle\": $fa-var-bookmark-circle,\n  \"circle-c\": $fa-var-circle-c,\n  \"circle-calendar\": $fa-var-circle-calendar,\n  \"calendar-circle\": $fa-var-calendar-circle,\n  \"circle-camera\": $fa-var-circle-camera,\n  \"camera-circle\": $fa-var-camera-circle,\n  \"circle-caret-down\": $fa-var-circle-caret-down,\n  \"caret-circle-down\": $fa-var-caret-circle-down,\n  \"circle-caret-left\": $fa-var-circle-caret-left,\n  \"caret-circle-left\": $fa-var-caret-circle-left,\n  \"circle-caret-right\": $fa-var-circle-caret-right,\n  \"caret-circle-right\": $fa-var-caret-circle-right,\n  \"circle-caret-up\": $fa-var-circle-caret-up,\n  \"caret-circle-up\": $fa-var-caret-circle-up,\n  \"circle-check\": $fa-var-circle-check,\n  \"check-circle\": $fa-var-check-circle,\n  \"circle-chevron-down\": $fa-var-circle-chevron-down,\n  \"chevron-circle-down\": $fa-var-chevron-circle-down,\n  \"circle-chevron-left\": $fa-var-circle-chevron-left,\n  \"chevron-circle-left\": $fa-var-chevron-circle-left,\n  \"circle-chevron-right\": $fa-var-circle-chevron-right,\n  \"chevron-circle-right\": $fa-var-chevron-circle-right,\n  \"circle-chevron-up\": $fa-var-circle-chevron-up,\n  \"chevron-circle-up\": $fa-var-chevron-circle-up,\n  \"circle-d\": $fa-var-circle-d,\n  \"circle-dashed\": $fa-var-circle-dashed,\n  \"circle-divide\": $fa-var-circle-divide,\n  \"circle-dollar\": $fa-var-circle-dollar,\n  \"dollar-circle\": $fa-var-dollar-circle,\n  \"usd-circle\": $fa-var-usd-circle,\n  \"circle-dollar-to-slot\": $fa-var-circle-dollar-to-slot,\n  \"donate\": $fa-var-donate,\n  \"circle-dot\": $fa-var-circle-dot,\n  \"dot-circle\": $fa-var-dot-circle,\n  \"circle-down\": $fa-var-circle-down,\n  \"arrow-alt-circle-down\": $fa-var-arrow-alt-circle-down,\n  \"circle-down-left\": $fa-var-circle-down-left,\n  \"circle-down-right\": $fa-var-circle-down-right,\n  \"circle-e\": $fa-var-circle-e,\n  \"circle-ellipsis\": $fa-var-circle-ellipsis,\n  \"circle-ellipsis-vertical\": $fa-var-circle-ellipsis-vertical,\n  \"circle-envelope\": $fa-var-circle-envelope,\n  \"envelope-circle\": $fa-var-envelope-circle,\n  \"circle-exclamation\": $fa-var-circle-exclamation,\n  \"exclamation-circle\": $fa-var-exclamation-circle,\n  \"circle-exclamation-check\": $fa-var-circle-exclamation-check,\n  \"circle-f\": $fa-var-circle-f,\n  \"circle-g\": $fa-var-circle-g,\n  \"circle-h\": $fa-var-circle-h,\n  \"hospital-symbol\": $fa-var-hospital-symbol,\n  \"circle-half\": $fa-var-circle-half,\n  \"circle-half-stroke\": $fa-var-circle-half-stroke,\n  \"adjust\": $fa-var-adjust,\n  \"circle-heart\": $fa-var-circle-heart,\n  \"heart-circle\": $fa-var-heart-circle,\n  \"circle-i\": $fa-var-circle-i,\n  \"circle-info\": $fa-var-circle-info,\n  \"info-circle\": $fa-var-info-circle,\n  \"circle-j\": $fa-var-circle-j,\n  \"circle-k\": $fa-var-circle-k,\n  \"circle-l\": $fa-var-circle-l,\n  \"circle-left\": $fa-var-circle-left,\n  \"arrow-alt-circle-left\": $fa-var-arrow-alt-circle-left,\n  \"circle-location-arrow\": $fa-var-circle-location-arrow,\n  \"location-circle\": $fa-var-location-circle,\n  \"circle-m\": $fa-var-circle-m,\n  \"circle-microphone\": $fa-var-circle-microphone,\n  \"microphone-circle\": $fa-var-microphone-circle,\n  \"circle-microphone-lines\": $fa-var-circle-microphone-lines,\n  \"microphone-circle-alt\": $fa-var-microphone-circle-alt,\n  \"circle-minus\": $fa-var-circle-minus,\n  \"minus-circle\": $fa-var-minus-circle,\n  \"circle-n\": $fa-var-circle-n,\n  \"circle-notch\": $fa-var-circle-notch,\n  \"circle-o\": $fa-var-circle-o,\n  \"circle-p\": $fa-var-circle-p,\n  \"circle-parking\": $fa-var-circle-parking,\n  \"parking-circle\": $fa-var-parking-circle,\n  \"circle-pause\": $fa-var-circle-pause,\n  \"pause-circle\": $fa-var-pause-circle,\n  \"circle-phone\": $fa-var-circle-phone,\n  \"phone-circle\": $fa-var-phone-circle,\n  \"circle-phone-flip\": $fa-var-circle-phone-flip,\n  \"phone-circle-alt\": $fa-var-phone-circle-alt,\n  \"circle-phone-hangup\": $fa-var-circle-phone-hangup,\n  \"phone-circle-down\": $fa-var-phone-circle-down,\n  \"circle-play\": $fa-var-circle-play,\n  \"play-circle\": $fa-var-play-circle,\n  \"circle-plus\": $fa-var-circle-plus,\n  \"plus-circle\": $fa-var-plus-circle,\n  \"circle-q\": $fa-var-circle-q,\n  \"circle-quarter\": $fa-var-circle-quarter,\n  \"circle-quarters\": $fa-var-circle-quarters,\n  \"circle-question\": $fa-var-circle-question,\n  \"question-circle\": $fa-var-question-circle,\n  \"circle-r\": $fa-var-circle-r,\n  \"circle-radiation\": $fa-var-circle-radiation,\n  \"radiation-alt\": $fa-var-radiation-alt,\n  \"circle-right\": $fa-var-circle-right,\n  \"arrow-alt-circle-right\": $fa-var-arrow-alt-circle-right,\n  \"circle-s\": $fa-var-circle-s,\n  \"circle-small\": $fa-var-circle-small,\n  \"circle-sort\": $fa-var-circle-sort,\n  \"sort-circle\": $fa-var-sort-circle,\n  \"circle-sort-down\": $fa-var-circle-sort-down,\n  \"sort-circle-down\": $fa-var-sort-circle-down,\n  \"circle-sort-up\": $fa-var-circle-sort-up,\n  \"sort-circle-up\": $fa-var-sort-circle-up,\n  \"circle-star\": $fa-var-circle-star,\n  \"star-circle\": $fa-var-star-circle,\n  \"circle-stop\": $fa-var-circle-stop,\n  \"stop-circle\": $fa-var-stop-circle,\n  \"circle-t\": $fa-var-circle-t,\n  \"circle-three-quarters\": $fa-var-circle-three-quarters,\n  \"circle-trash\": $fa-var-circle-trash,\n  \"trash-circle\": $fa-var-trash-circle,\n  \"circle-u\": $fa-var-circle-u,\n  \"circle-up\": $fa-var-circle-up,\n  \"arrow-alt-circle-up\": $fa-var-arrow-alt-circle-up,\n  \"circle-up-left\": $fa-var-circle-up-left,\n  \"circle-up-right\": $fa-var-circle-up-right,\n  \"circle-user\": $fa-var-circle-user,\n  \"user-circle\": $fa-var-user-circle,\n  \"circle-v\": $fa-var-circle-v,\n  \"circle-video\": $fa-var-circle-video,\n  \"video-circle\": $fa-var-video-circle,\n  \"circle-w\": $fa-var-circle-w,\n  \"circle-waveform-lines\": $fa-var-circle-waveform-lines,\n  \"waveform-circle\": $fa-var-waveform-circle,\n  \"circle-x\": $fa-var-circle-x,\n  \"circle-xmark\": $fa-var-circle-xmark,\n  \"times-circle\": $fa-var-times-circle,\n  \"xmark-circle\": $fa-var-xmark-circle,\n  \"circle-y\": $fa-var-circle-y,\n  \"circle-z\": $fa-var-circle-z,\n  \"citrus\": $fa-var-citrus,\n  \"citrus-slice\": $fa-var-citrus-slice,\n  \"city\": $fa-var-city,\n  \"clapperboard\": $fa-var-clapperboard,\n  \"clapperboard-play\": $fa-var-clapperboard-play,\n  \"clarinet\": $fa-var-clarinet,\n  \"claw-marks\": $fa-var-claw-marks,\n  \"clipboard\": $fa-var-clipboard,\n  \"clipboard-check\": $fa-var-clipboard-check,\n  \"clipboard-list\": $fa-var-clipboard-list,\n  \"clipboard-list-check\": $fa-var-clipboard-list-check,\n  \"clipboard-medical\": $fa-var-clipboard-medical,\n  \"clipboard-prescription\": $fa-var-clipboard-prescription,\n  \"clipboard-user\": $fa-var-clipboard-user,\n  \"clock\": $fa-var-clock,\n  \"clock-four\": $fa-var-clock-four,\n  \"clock-desk\": $fa-var-clock-desk,\n  \"clock-eight\": $fa-var-clock-eight,\n  \"clock-eight-thirty\": $fa-var-clock-eight-thirty,\n  \"clock-eleven\": $fa-var-clock-eleven,\n  \"clock-eleven-thirty\": $fa-var-clock-eleven-thirty,\n  \"clock-five\": $fa-var-clock-five,\n  \"clock-five-thirty\": $fa-var-clock-five-thirty,\n  \"clock-four-thirty\": $fa-var-clock-four-thirty,\n  \"clock-nine\": $fa-var-clock-nine,\n  \"clock-nine-thirty\": $fa-var-clock-nine-thirty,\n  \"clock-one\": $fa-var-clock-one,\n  \"clock-one-thirty\": $fa-var-clock-one-thirty,\n  \"clock-rotate-left\": $fa-var-clock-rotate-left,\n  \"history\": $fa-var-history,\n  \"clock-seven\": $fa-var-clock-seven,\n  \"clock-seven-thirty\": $fa-var-clock-seven-thirty,\n  \"clock-six\": $fa-var-clock-six,\n  \"clock-six-thirty\": $fa-var-clock-six-thirty,\n  \"clock-ten\": $fa-var-clock-ten,\n  \"clock-ten-thirty\": $fa-var-clock-ten-thirty,\n  \"clock-three\": $fa-var-clock-three,\n  \"clock-three-thirty\": $fa-var-clock-three-thirty,\n  \"clock-twelve\": $fa-var-clock-twelve,\n  \"clock-twelve-thirty\": $fa-var-clock-twelve-thirty,\n  \"clock-two\": $fa-var-clock-two,\n  \"clock-two-thirty\": $fa-var-clock-two-thirty,\n  \"clone\": $fa-var-clone,\n  \"closed-captioning\": $fa-var-closed-captioning,\n  \"closed-captioning-slash\": $fa-var-closed-captioning-slash,\n  \"clothes-hanger\": $fa-var-clothes-hanger,\n  \"cloud\": $fa-var-cloud,\n  \"cloud-arrow-down\": $fa-var-cloud-arrow-down,\n  \"cloud-download\": $fa-var-cloud-download,\n  \"cloud-download-alt\": $fa-var-cloud-download-alt,\n  \"cloud-arrow-up\": $fa-var-cloud-arrow-up,\n  \"cloud-upload\": $fa-var-cloud-upload,\n  \"cloud-upload-alt\": $fa-var-cloud-upload-alt,\n  \"cloud-bolt\": $fa-var-cloud-bolt,\n  \"thunderstorm\": $fa-var-thunderstorm,\n  \"cloud-bolt-moon\": $fa-var-cloud-bolt-moon,\n  \"thunderstorm-moon\": $fa-var-thunderstorm-moon,\n  \"cloud-bolt-sun\": $fa-var-cloud-bolt-sun,\n  \"thunderstorm-sun\": $fa-var-thunderstorm-sun,\n  \"cloud-check\": $fa-var-cloud-check,\n  \"cloud-drizzle\": $fa-var-cloud-drizzle,\n  \"cloud-fog\": $fa-var-cloud-fog,\n  \"fog\": $fa-var-fog,\n  \"cloud-hail\": $fa-var-cloud-hail,\n  \"cloud-hail-mixed\": $fa-var-cloud-hail-mixed,\n  \"cloud-meatball\": $fa-var-cloud-meatball,\n  \"cloud-minus\": $fa-var-cloud-minus,\n  \"cloud-moon\": $fa-var-cloud-moon,\n  \"cloud-moon-rain\": $fa-var-cloud-moon-rain,\n  \"cloud-music\": $fa-var-cloud-music,\n  \"cloud-plus\": $fa-var-cloud-plus,\n  \"cloud-rain\": $fa-var-cloud-rain,\n  \"cloud-rainbow\": $fa-var-cloud-rainbow,\n  \"cloud-showers\": $fa-var-cloud-showers,\n  \"cloud-showers-heavy\": $fa-var-cloud-showers-heavy,\n  \"cloud-slash\": $fa-var-cloud-slash,\n  \"cloud-sleet\": $fa-var-cloud-sleet,\n  \"cloud-snow\": $fa-var-cloud-snow,\n  \"cloud-sun\": $fa-var-cloud-sun,\n  \"cloud-sun-rain\": $fa-var-cloud-sun-rain,\n  \"cloud-word\": $fa-var-cloud-word,\n  \"cloud-xmark\": $fa-var-cloud-xmark,\n  \"clouds\": $fa-var-clouds,\n  \"clouds-moon\": $fa-var-clouds-moon,\n  \"clouds-sun\": $fa-var-clouds-sun,\n  \"clover\": $fa-var-clover,\n  \"club\": $fa-var-club,\n  \"coconut\": $fa-var-coconut,\n  \"code\": $fa-var-code,\n  \"code-branch\": $fa-var-code-branch,\n  \"code-commit\": $fa-var-code-commit,\n  \"code-compare\": $fa-var-code-compare,\n  \"code-fork\": $fa-var-code-fork,\n  \"code-merge\": $fa-var-code-merge,\n  \"code-pull-request\": $fa-var-code-pull-request,\n  \"code-pull-request-closed\": $fa-var-code-pull-request-closed,\n  \"code-pull-request-draft\": $fa-var-code-pull-request-draft,\n  \"code-simple\": $fa-var-code-simple,\n  \"coffee-bean\": $fa-var-coffee-bean,\n  \"coffee-beans\": $fa-var-coffee-beans,\n  \"coffee-pot\": $fa-var-coffee-pot,\n  \"coffin\": $fa-var-coffin,\n  \"coffin-cross\": $fa-var-coffin-cross,\n  \"coin\": $fa-var-coin,\n  \"coin-blank\": $fa-var-coin-blank,\n  \"coin-front\": $fa-var-coin-front,\n  \"coin-vertical\": $fa-var-coin-vertical,\n  \"coins\": $fa-var-coins,\n  \"colon\": $fa-var-colon,\n  \"colon-sign\": $fa-var-colon-sign,\n  \"columns-3\": $fa-var-columns-3,\n  \"comet\": $fa-var-comet,\n  \"comma\": $fa-var-comma,\n  \"command\": $fa-var-command,\n  \"comment\": $fa-var-comment,\n  \"comment-arrow-down\": $fa-var-comment-arrow-down,\n  \"comment-arrow-up\": $fa-var-comment-arrow-up,\n  \"comment-arrow-up-right\": $fa-var-comment-arrow-up-right,\n  \"comment-captions\": $fa-var-comment-captions,\n  \"comment-check\": $fa-var-comment-check,\n  \"comment-code\": $fa-var-comment-code,\n  \"comment-dollar\": $fa-var-comment-dollar,\n  \"comment-dots\": $fa-var-comment-dots,\n  \"commenting\": $fa-var-commenting,\n  \"comment-exclamation\": $fa-var-comment-exclamation,\n  \"comment-image\": $fa-var-comment-image,\n  \"comment-lines\": $fa-var-comment-lines,\n  \"comment-medical\": $fa-var-comment-medical,\n  \"comment-middle\": $fa-var-comment-middle,\n  \"comment-middle-top\": $fa-var-comment-middle-top,\n  \"comment-minus\": $fa-var-comment-minus,\n  \"comment-music\": $fa-var-comment-music,\n  \"comment-pen\": $fa-var-comment-pen,\n  \"comment-edit\": $fa-var-comment-edit,\n  \"comment-plus\": $fa-var-comment-plus,\n  \"comment-question\": $fa-var-comment-question,\n  \"comment-quote\": $fa-var-comment-quote,\n  \"comment-slash\": $fa-var-comment-slash,\n  \"comment-smile\": $fa-var-comment-smile,\n  \"comment-sms\": $fa-var-comment-sms,\n  \"sms\": $fa-var-sms,\n  \"comment-text\": $fa-var-comment-text,\n  \"comment-xmark\": $fa-var-comment-xmark,\n  \"comment-times\": $fa-var-comment-times,\n  \"comments\": $fa-var-comments,\n  \"comments-dollar\": $fa-var-comments-dollar,\n  \"comments-question\": $fa-var-comments-question,\n  \"comments-question-check\": $fa-var-comments-question-check,\n  \"compact-disc\": $fa-var-compact-disc,\n  \"compass\": $fa-var-compass,\n  \"compass-drafting\": $fa-var-compass-drafting,\n  \"drafting-compass\": $fa-var-drafting-compass,\n  \"compass-slash\": $fa-var-compass-slash,\n  \"compress\": $fa-var-compress,\n  \"compress-wide\": $fa-var-compress-wide,\n  \"computer-classic\": $fa-var-computer-classic,\n  \"computer-mouse\": $fa-var-computer-mouse,\n  \"mouse\": $fa-var-mouse,\n  \"computer-mouse-scrollwheel\": $fa-var-computer-mouse-scrollwheel,\n  \"mouse-alt\": $fa-var-mouse-alt,\n  \"computer-speaker\": $fa-var-computer-speaker,\n  \"container-storage\": $fa-var-container-storage,\n  \"conveyor-belt\": $fa-var-conveyor-belt,\n  \"conveyor-belt-boxes\": $fa-var-conveyor-belt-boxes,\n  \"conveyor-belt-alt\": $fa-var-conveyor-belt-alt,\n  \"conveyor-belt-empty\": $fa-var-conveyor-belt-empty,\n  \"cookie\": $fa-var-cookie,\n  \"cookie-bite\": $fa-var-cookie-bite,\n  \"copy\": $fa-var-copy,\n  \"copyright\": $fa-var-copyright,\n  \"corn\": $fa-var-corn,\n  \"corner\": $fa-var-corner,\n  \"couch\": $fa-var-couch,\n  \"cow\": $fa-var-cow,\n  \"cowbell\": $fa-var-cowbell,\n  \"cowbell-circle-plus\": $fa-var-cowbell-circle-plus,\n  \"cowbell-more\": $fa-var-cowbell-more,\n  \"crab\": $fa-var-crab,\n  \"crate-apple\": $fa-var-crate-apple,\n  \"apple-crate\": $fa-var-apple-crate,\n  \"crate-empty\": $fa-var-crate-empty,\n  \"credit-card\": $fa-var-credit-card,\n  \"credit-card-alt\": $fa-var-credit-card-alt,\n  \"credit-card-blank\": $fa-var-credit-card-blank,\n  \"credit-card-front\": $fa-var-credit-card-front,\n  \"creemee\": $fa-var-creemee,\n  \"soft-serve\": $fa-var-soft-serve,\n  \"cricket-bat-ball\": $fa-var-cricket-bat-ball,\n  \"cricket\": $fa-var-cricket,\n  \"croissant\": $fa-var-croissant,\n  \"crop\": $fa-var-crop,\n  \"crop-simple\": $fa-var-crop-simple,\n  \"crop-alt\": $fa-var-crop-alt,\n  \"cross\": $fa-var-cross,\n  \"crosshairs\": $fa-var-crosshairs,\n  \"crow\": $fa-var-crow,\n  \"crown\": $fa-var-crown,\n  \"crutch\": $fa-var-crutch,\n  \"crutches\": $fa-var-crutches,\n  \"cruzeiro-sign\": $fa-var-cruzeiro-sign,\n  \"crystal-ball\": $fa-var-crystal-ball,\n  \"cube\": $fa-var-cube,\n  \"cubes\": $fa-var-cubes,\n  \"cucumber\": $fa-var-cucumber,\n  \"cup-straw\": $fa-var-cup-straw,\n  \"cup-straw-swoosh\": $fa-var-cup-straw-swoosh,\n  \"cup-togo\": $fa-var-cup-togo,\n  \"coffee-togo\": $fa-var-coffee-togo,\n  \"cupcake\": $fa-var-cupcake,\n  \"curling-stone\": $fa-var-curling-stone,\n  \"curling\": $fa-var-curling,\n  \"custard\": $fa-var-custard,\n  \"d\": $fa-var-d,\n  \"dagger\": $fa-var-dagger,\n  \"dash\": $fa-var-dash,\n  \"database\": $fa-var-database,\n  \"deer\": $fa-var-deer,\n  \"deer-rudolph\": $fa-var-deer-rudolph,\n  \"delete-left\": $fa-var-delete-left,\n  \"backspace\": $fa-var-backspace,\n  \"delete-right\": $fa-var-delete-right,\n  \"democrat\": $fa-var-democrat,\n  \"desktop\": $fa-var-desktop,\n  \"desktop-alt\": $fa-var-desktop-alt,\n  \"desktop-arrow-down\": $fa-var-desktop-arrow-down,\n  \"dharmachakra\": $fa-var-dharmachakra,\n  \"diagram-lean-canvas\": $fa-var-diagram-lean-canvas,\n  \"diagram-nested\": $fa-var-diagram-nested,\n  \"diagram-project\": $fa-var-diagram-project,\n  \"project-diagram\": $fa-var-project-diagram,\n  \"diagram-sankey\": $fa-var-diagram-sankey,\n  \"diagram-venn\": $fa-var-diagram-venn,\n  \"dial\": $fa-var-dial,\n  \"dial-med-high\": $fa-var-dial-med-high,\n  \"dial-high\": $fa-var-dial-high,\n  \"dial-low\": $fa-var-dial-low,\n  \"dial-max\": $fa-var-dial-max,\n  \"dial-med\": $fa-var-dial-med,\n  \"dial-med-low\": $fa-var-dial-med-low,\n  \"dial-min\": $fa-var-dial-min,\n  \"dial-off\": $fa-var-dial-off,\n  \"diamond\": $fa-var-diamond,\n  \"diamond-exclamation\": $fa-var-diamond-exclamation,\n  \"diamond-turn-right\": $fa-var-diamond-turn-right,\n  \"directions\": $fa-var-directions,\n  \"dice\": $fa-var-dice,\n  \"dice-d10\": $fa-var-dice-d10,\n  \"dice-d12\": $fa-var-dice-d12,\n  \"dice-d20\": $fa-var-dice-d20,\n  \"dice-d4\": $fa-var-dice-d4,\n  \"dice-d6\": $fa-var-dice-d6,\n  \"dice-d8\": $fa-var-dice-d8,\n  \"dice-five\": $fa-var-dice-five,\n  \"dice-four\": $fa-var-dice-four,\n  \"dice-one\": $fa-var-dice-one,\n  \"dice-six\": $fa-var-dice-six,\n  \"dice-three\": $fa-var-dice-three,\n  \"dice-two\": $fa-var-dice-two,\n  \"diploma\": $fa-var-diploma,\n  \"scroll-ribbon\": $fa-var-scroll-ribbon,\n  \"disc-drive\": $fa-var-disc-drive,\n  \"disease\": $fa-var-disease,\n  \"display\": $fa-var-display,\n  \"display-arrow-down\": $fa-var-display-arrow-down,\n  \"display-code\": $fa-var-display-code,\n  \"desktop-code\": $fa-var-desktop-code,\n  \"display-medical\": $fa-var-display-medical,\n  \"desktop-medical\": $fa-var-desktop-medical,\n  \"display-slash\": $fa-var-display-slash,\n  \"desktop-slash\": $fa-var-desktop-slash,\n  \"distribute-spacing-horizontal\": $fa-var-distribute-spacing-horizontal,\n  \"distribute-spacing-vertical\": $fa-var-distribute-spacing-vertical,\n  \"ditto\": $fa-var-ditto,\n  \"divide\": $fa-var-divide,\n  \"dna\": $fa-var-dna,\n  \"do-not-enter\": $fa-var-do-not-enter,\n  \"dog\": $fa-var-dog,\n  \"dog-leashed\": $fa-var-dog-leashed,\n  \"dollar-sign\": $fa-var-dollar-sign,\n  \"dollar\": $fa-var-dollar,\n  \"usd\": $fa-var-usd,\n  \"dolly\": $fa-var-dolly,\n  \"dolly-box\": $fa-var-dolly-box,\n  \"dolly-empty\": $fa-var-dolly-empty,\n  \"dolphin\": $fa-var-dolphin,\n  \"dong-sign\": $fa-var-dong-sign,\n  \"donut\": $fa-var-donut,\n  \"doughnut\": $fa-var-doughnut,\n  \"door-closed\": $fa-var-door-closed,\n  \"door-open\": $fa-var-door-open,\n  \"dove\": $fa-var-dove,\n  \"down\": $fa-var-down,\n  \"arrow-alt-down\": $fa-var-arrow-alt-down,\n  \"down-from-dotted-line\": $fa-var-down-from-dotted-line,\n  \"down-from-line\": $fa-var-down-from-line,\n  \"arrow-alt-from-top\": $fa-var-arrow-alt-from-top,\n  \"down-left\": $fa-var-down-left,\n  \"down-left-and-up-right-to-center\": $fa-var-down-left-and-up-right-to-center,\n  \"compress-alt\": $fa-var-compress-alt,\n  \"down-long\": $fa-var-down-long,\n  \"long-arrow-alt-down\": $fa-var-long-arrow-alt-down,\n  \"down-right\": $fa-var-down-right,\n  \"down-to-dotted-line\": $fa-var-down-to-dotted-line,\n  \"down-to-line\": $fa-var-down-to-line,\n  \"arrow-alt-to-bottom\": $fa-var-arrow-alt-to-bottom,\n  \"download\": $fa-var-download,\n  \"dragon\": $fa-var-dragon,\n  \"draw-circle\": $fa-var-draw-circle,\n  \"draw-polygon\": $fa-var-draw-polygon,\n  \"draw-square\": $fa-var-draw-square,\n  \"dreidel\": $fa-var-dreidel,\n  \"drone\": $fa-var-drone,\n  \"drone-front\": $fa-var-drone-front,\n  \"drone-alt\": $fa-var-drone-alt,\n  \"droplet\": $fa-var-droplet,\n  \"tint\": $fa-var-tint,\n  \"droplet-degree\": $fa-var-droplet-degree,\n  \"dewpoint\": $fa-var-dewpoint,\n  \"droplet-percent\": $fa-var-droplet-percent,\n  \"humidity\": $fa-var-humidity,\n  \"droplet-slash\": $fa-var-droplet-slash,\n  \"tint-slash\": $fa-var-tint-slash,\n  \"drum\": $fa-var-drum,\n  \"drum-steelpan\": $fa-var-drum-steelpan,\n  \"drumstick\": $fa-var-drumstick,\n  \"drumstick-bite\": $fa-var-drumstick-bite,\n  \"dryer\": $fa-var-dryer,\n  \"dryer-heat\": $fa-var-dryer-heat,\n  \"dryer-alt\": $fa-var-dryer-alt,\n  \"duck\": $fa-var-duck,\n  \"dumbbell\": $fa-var-dumbbell,\n  \"dumpster\": $fa-var-dumpster,\n  \"dumpster-fire\": $fa-var-dumpster-fire,\n  \"dungeon\": $fa-var-dungeon,\n  \"e\": $fa-var-e,\n  \"ear\": $fa-var-ear,\n  \"ear-deaf\": $fa-var-ear-deaf,\n  \"deaf\": $fa-var-deaf,\n  \"deafness\": $fa-var-deafness,\n  \"hard-of-hearing\": $fa-var-hard-of-hearing,\n  \"ear-listen\": $fa-var-ear-listen,\n  \"assistive-listening-systems\": $fa-var-assistive-listening-systems,\n  \"ear-muffs\": $fa-var-ear-muffs,\n  \"earth-africa\": $fa-var-earth-africa,\n  \"globe-africa\": $fa-var-globe-africa,\n  \"earth-americas\": $fa-var-earth-americas,\n  \"earth\": $fa-var-earth,\n  \"globe-americas\": $fa-var-globe-americas,\n  \"earth-asia\": $fa-var-earth-asia,\n  \"globe-asia\": $fa-var-globe-asia,\n  \"earth-europa\": $fa-var-earth-europa,\n  \"globe-europe\": $fa-var-globe-europe,\n  \"eclipse\": $fa-var-eclipse,\n  \"egg\": $fa-var-egg,\n  \"egg-fried\": $fa-var-egg-fried,\n  \"eggplant\": $fa-var-eggplant,\n  \"eject\": $fa-var-eject,\n  \"elephant\": $fa-var-elephant,\n  \"elevator\": $fa-var-elevator,\n  \"ellipsis\": $fa-var-ellipsis,\n  \"ellipsis-h\": $fa-var-ellipsis-h,\n  \"ellipsis-stroke\": $fa-var-ellipsis-stroke,\n  \"ellipsis-h-alt\": $fa-var-ellipsis-h-alt,\n  \"ellipsis-stroke-vertical\": $fa-var-ellipsis-stroke-vertical,\n  \"ellipsis-v-alt\": $fa-var-ellipsis-v-alt,\n  \"ellipsis-vertical\": $fa-var-ellipsis-vertical,\n  \"ellipsis-v\": $fa-var-ellipsis-v,\n  \"empty-set\": $fa-var-empty-set,\n  \"engine\": $fa-var-engine,\n  \"engine-warning\": $fa-var-engine-warning,\n  \"engine-exclamation\": $fa-var-engine-exclamation,\n  \"envelope\": $fa-var-envelope,\n  \"envelope-dot\": $fa-var-envelope-dot,\n  \"envelope-badge\": $fa-var-envelope-badge,\n  \"envelope-open\": $fa-var-envelope-open,\n  \"envelope-open-dollar\": $fa-var-envelope-open-dollar,\n  \"envelope-open-text\": $fa-var-envelope-open-text,\n  \"envelopes\": $fa-var-envelopes,\n  \"envelopes-bulk\": $fa-var-envelopes-bulk,\n  \"mail-bulk\": $fa-var-mail-bulk,\n  \"equals\": $fa-var-equals,\n  \"eraser\": $fa-var-eraser,\n  \"escalator\": $fa-var-escalator,\n  \"ethernet\": $fa-var-ethernet,\n  \"euro-sign\": $fa-var-euro-sign,\n  \"eur\": $fa-var-eur,\n  \"euro\": $fa-var-euro,\n  \"exclamation\": $fa-var-exclamation,\n  \"expand\": $fa-var-expand,\n  \"expand-wide\": $fa-var-expand-wide,\n  \"eye\": $fa-var-eye,\n  \"eye-dropper\": $fa-var-eye-dropper,\n  \"eye-dropper-empty\": $fa-var-eye-dropper-empty,\n  \"eyedropper\": $fa-var-eyedropper,\n  \"eye-dropper-full\": $fa-var-eye-dropper-full,\n  \"eye-dropper-half\": $fa-var-eye-dropper-half,\n  \"eye-evil\": $fa-var-eye-evil,\n  \"eye-low-vision\": $fa-var-eye-low-vision,\n  \"low-vision\": $fa-var-low-vision,\n  \"eye-slash\": $fa-var-eye-slash,\n  \"eyes\": $fa-var-eyes,\n  \"f\": $fa-var-f,\n  \"face-angry\": $fa-var-face-angry,\n  \"angry\": $fa-var-angry,\n  \"face-angry-horns\": $fa-var-face-angry-horns,\n  \"face-anguished\": $fa-var-face-anguished,\n  \"face-anxious-sweat\": $fa-var-face-anxious-sweat,\n  \"face-astonished\": $fa-var-face-astonished,\n  \"face-awesome\": $fa-var-face-awesome,\n  \"gave-dandy\": $fa-var-gave-dandy,\n  \"face-confounded\": $fa-var-face-confounded,\n  \"face-confused\": $fa-var-face-confused,\n  \"face-cowboy-hat\": $fa-var-face-cowboy-hat,\n  \"face-disappointed\": $fa-var-face-disappointed,\n  \"face-disguise\": $fa-var-face-disguise,\n  \"face-dizzy\": $fa-var-face-dizzy,\n  \"dizzy\": $fa-var-dizzy,\n  \"face-downcast-sweat\": $fa-var-face-downcast-sweat,\n  \"face-drooling\": $fa-var-face-drooling,\n  \"face-explode\": $fa-var-face-explode,\n  \"exploding-head\": $fa-var-exploding-head,\n  \"face-expressionless\": $fa-var-face-expressionless,\n  \"face-eyes-xmarks\": $fa-var-face-eyes-xmarks,\n  \"face-fearful\": $fa-var-face-fearful,\n  \"face-flushed\": $fa-var-face-flushed,\n  \"flushed\": $fa-var-flushed,\n  \"face-frown\": $fa-var-face-frown,\n  \"frown\": $fa-var-frown,\n  \"face-frown-open\": $fa-var-face-frown-open,\n  \"frown-open\": $fa-var-frown-open,\n  \"face-frown-slight\": $fa-var-face-frown-slight,\n  \"face-glasses\": $fa-var-face-glasses,\n  \"face-grimace\": $fa-var-face-grimace,\n  \"grimace\": $fa-var-grimace,\n  \"face-grin\": $fa-var-face-grin,\n  \"grin\": $fa-var-grin,\n  \"face-grin-beam\": $fa-var-face-grin-beam,\n  \"grin-beam\": $fa-var-grin-beam,\n  \"face-grin-beam-sweat\": $fa-var-face-grin-beam-sweat,\n  \"grin-beam-sweat\": $fa-var-grin-beam-sweat,\n  \"face-grin-hearts\": $fa-var-face-grin-hearts,\n  \"grin-hearts\": $fa-var-grin-hearts,\n  \"face-grin-squint\": $fa-var-face-grin-squint,\n  \"grin-squint\": $fa-var-grin-squint,\n  \"face-grin-squint-tears\": $fa-var-face-grin-squint-tears,\n  \"grin-squint-tears\": $fa-var-grin-squint-tears,\n  \"face-grin-stars\": $fa-var-face-grin-stars,\n  \"grin-stars\": $fa-var-grin-stars,\n  \"face-grin-tears\": $fa-var-face-grin-tears,\n  \"grin-tears\": $fa-var-grin-tears,\n  \"face-grin-tongue\": $fa-var-face-grin-tongue,\n  \"grin-tongue\": $fa-var-grin-tongue,\n  \"face-grin-tongue-squint\": $fa-var-face-grin-tongue-squint,\n  \"grin-tongue-squint\": $fa-var-grin-tongue-squint,\n  \"face-grin-tongue-wink\": $fa-var-face-grin-tongue-wink,\n  \"grin-tongue-wink\": $fa-var-grin-tongue-wink,\n  \"face-grin-wide\": $fa-var-face-grin-wide,\n  \"grin-alt\": $fa-var-grin-alt,\n  \"face-grin-wink\": $fa-var-face-grin-wink,\n  \"grin-wink\": $fa-var-grin-wink,\n  \"face-hand-over-mouth\": $fa-var-face-hand-over-mouth,\n  \"face-hand-yawn\": $fa-var-face-hand-yawn,\n  \"face-head-bandage\": $fa-var-face-head-bandage,\n  \"face-hushed\": $fa-var-face-hushed,\n  \"face-icicles\": $fa-var-face-icicles,\n  \"face-kiss\": $fa-var-face-kiss,\n  \"kiss\": $fa-var-kiss,\n  \"face-kiss-beam\": $fa-var-face-kiss-beam,\n  \"kiss-beam\": $fa-var-kiss-beam,\n  \"face-kiss-closed-eyes\": $fa-var-face-kiss-closed-eyes,\n  \"face-kiss-wink-heart\": $fa-var-face-kiss-wink-heart,\n  \"kiss-wink-heart\": $fa-var-kiss-wink-heart,\n  \"face-laugh\": $fa-var-face-laugh,\n  \"laugh\": $fa-var-laugh,\n  \"face-laugh-beam\": $fa-var-face-laugh-beam,\n  \"laugh-beam\": $fa-var-laugh-beam,\n  \"face-laugh-squint\": $fa-var-face-laugh-squint,\n  \"laugh-squint\": $fa-var-laugh-squint,\n  \"face-laugh-wink\": $fa-var-face-laugh-wink,\n  \"laugh-wink\": $fa-var-laugh-wink,\n  \"face-lying\": $fa-var-face-lying,\n  \"face-mask\": $fa-var-face-mask,\n  \"face-meh\": $fa-var-face-meh,\n  \"meh\": $fa-var-meh,\n  \"face-meh-blank\": $fa-var-face-meh-blank,\n  \"meh-blank\": $fa-var-meh-blank,\n  \"face-monocle\": $fa-var-face-monocle,\n  \"face-nauseated\": $fa-var-face-nauseated,\n  \"face-nose-steam\": $fa-var-face-nose-steam,\n  \"face-party\": $fa-var-face-party,\n  \"face-pensive\": $fa-var-face-pensive,\n  \"face-persevering\": $fa-var-face-persevering,\n  \"face-pleading\": $fa-var-face-pleading,\n  \"face-pouting\": $fa-var-face-pouting,\n  \"face-raised-eyebrow\": $fa-var-face-raised-eyebrow,\n  \"face-relieved\": $fa-var-face-relieved,\n  \"face-rolling-eyes\": $fa-var-face-rolling-eyes,\n  \"meh-rolling-eyes\": $fa-var-meh-rolling-eyes,\n  \"face-sad-cry\": $fa-var-face-sad-cry,\n  \"sad-cry\": $fa-var-sad-cry,\n  \"face-sad-sweat\": $fa-var-face-sad-sweat,\n  \"face-sad-tear\": $fa-var-face-sad-tear,\n  \"sad-tear\": $fa-var-sad-tear,\n  \"face-scream\": $fa-var-face-scream,\n  \"face-shush\": $fa-var-face-shush,\n  \"face-sleeping\": $fa-var-face-sleeping,\n  \"face-sleepy\": $fa-var-face-sleepy,\n  \"face-smile\": $fa-var-face-smile,\n  \"smile\": $fa-var-smile,\n  \"face-smile-beam\": $fa-var-face-smile-beam,\n  \"smile-beam\": $fa-var-smile-beam,\n  \"face-smile-halo\": $fa-var-face-smile-halo,\n  \"face-smile-hearts\": $fa-var-face-smile-hearts,\n  \"face-smile-horns\": $fa-var-face-smile-horns,\n  \"face-smile-plus\": $fa-var-face-smile-plus,\n  \"smile-plus\": $fa-var-smile-plus,\n  \"face-smile-relaxed\": $fa-var-face-smile-relaxed,\n  \"face-smile-tear\": $fa-var-face-smile-tear,\n  \"face-smile-tongue\": $fa-var-face-smile-tongue,\n  \"face-smile-upside-down\": $fa-var-face-smile-upside-down,\n  \"face-smile-wink\": $fa-var-face-smile-wink,\n  \"smile-wink\": $fa-var-smile-wink,\n  \"face-smiling-hands\": $fa-var-face-smiling-hands,\n  \"face-smirking\": $fa-var-face-smirking,\n  \"face-sunglasses\": $fa-var-face-sunglasses,\n  \"face-surprise\": $fa-var-face-surprise,\n  \"surprise\": $fa-var-surprise,\n  \"face-swear\": $fa-var-face-swear,\n  \"face-thermometer\": $fa-var-face-thermometer,\n  \"face-thinking\": $fa-var-face-thinking,\n  \"face-tired\": $fa-var-face-tired,\n  \"tired\": $fa-var-tired,\n  \"face-tissue\": $fa-var-face-tissue,\n  \"face-tongue-money\": $fa-var-face-tongue-money,\n  \"face-tongue-sweat\": $fa-var-face-tongue-sweat,\n  \"face-unamused\": $fa-var-face-unamused,\n  \"face-viewfinder\": $fa-var-face-viewfinder,\n  \"face-vomit\": $fa-var-face-vomit,\n  \"face-weary\": $fa-var-face-weary,\n  \"face-woozy\": $fa-var-face-woozy,\n  \"face-worried\": $fa-var-face-worried,\n  \"face-zany\": $fa-var-face-zany,\n  \"face-zipper\": $fa-var-face-zipper,\n  \"falafel\": $fa-var-falafel,\n  \"family\": $fa-var-family,\n  \"family-dress\": $fa-var-family-dress,\n  \"family-pants\": $fa-var-family-pants,\n  \"fan\": $fa-var-fan,\n  \"fan-table\": $fa-var-fan-table,\n  \"farm\": $fa-var-farm,\n  \"barn-silo\": $fa-var-barn-silo,\n  \"faucet\": $fa-var-faucet,\n  \"faucet-drip\": $fa-var-faucet-drip,\n  \"fax\": $fa-var-fax,\n  \"feather\": $fa-var-feather,\n  \"feather-pointed\": $fa-var-feather-pointed,\n  \"feather-alt\": $fa-var-feather-alt,\n  \"fence\": $fa-var-fence,\n  \"ferris-wheel\": $fa-var-ferris-wheel,\n  \"field-hockey-stick-ball\": $fa-var-field-hockey-stick-ball,\n  \"field-hockey\": $fa-var-field-hockey,\n  \"file\": $fa-var-file,\n  \"file-arrow-down\": $fa-var-file-arrow-down,\n  \"file-download\": $fa-var-file-download,\n  \"file-arrow-up\": $fa-var-file-arrow-up,\n  \"file-upload\": $fa-var-file-upload,\n  \"file-audio\": $fa-var-file-audio,\n  \"file-binary\": $fa-var-file-binary,\n  \"file-certificate\": $fa-var-file-certificate,\n  \"file-award\": $fa-var-file-award,\n  \"file-chart-column\": $fa-var-file-chart-column,\n  \"file-chart-line\": $fa-var-file-chart-line,\n  \"file-chart-pie\": $fa-var-file-chart-pie,\n  \"file-check\": $fa-var-file-check,\n  \"file-code\": $fa-var-file-code,\n  \"file-contract\": $fa-var-file-contract,\n  \"file-csv\": $fa-var-file-csv,\n  \"file-dashed-line\": $fa-var-file-dashed-line,\n  \"page-break\": $fa-var-page-break,\n  \"file-excel\": $fa-var-file-excel,\n  \"file-exclamation\": $fa-var-file-exclamation,\n  \"file-export\": $fa-var-file-export,\n  \"arrow-right-from-file\": $fa-var-arrow-right-from-file,\n  \"file-heart\": $fa-var-file-heart,\n  \"file-image\": $fa-var-file-image,\n  \"file-import\": $fa-var-file-import,\n  \"arrow-right-to-file\": $fa-var-arrow-right-to-file,\n  \"file-invoice\": $fa-var-file-invoice,\n  \"file-invoice-dollar\": $fa-var-file-invoice-dollar,\n  \"file-lines\": $fa-var-file-lines,\n  \"file-alt\": $fa-var-file-alt,\n  \"file-text\": $fa-var-file-text,\n  \"file-lock\": $fa-var-file-lock,\n  \"file-magnifying-glass\": $fa-var-file-magnifying-glass,\n  \"file-search\": $fa-var-file-search,\n  \"file-medical\": $fa-var-file-medical,\n  \"file-minus\": $fa-var-file-minus,\n  \"file-music\": $fa-var-file-music,\n  \"file-pdf\": $fa-var-file-pdf,\n  \"file-pen\": $fa-var-file-pen,\n  \"file-edit\": $fa-var-file-edit,\n  \"file-plus\": $fa-var-file-plus,\n  \"file-plus-minus\": $fa-var-file-plus-minus,\n  \"file-powerpoint\": $fa-var-file-powerpoint,\n  \"file-prescription\": $fa-var-file-prescription,\n  \"file-signature\": $fa-var-file-signature,\n  \"file-slash\": $fa-var-file-slash,\n  \"file-spreadsheet\": $fa-var-file-spreadsheet,\n  \"file-user\": $fa-var-file-user,\n  \"file-video\": $fa-var-file-video,\n  \"file-waveform\": $fa-var-file-waveform,\n  \"file-medical-alt\": $fa-var-file-medical-alt,\n  \"file-word\": $fa-var-file-word,\n  \"file-xmark\": $fa-var-file-xmark,\n  \"file-times\": $fa-var-file-times,\n  \"file-zipper\": $fa-var-file-zipper,\n  \"file-archive\": $fa-var-file-archive,\n  \"files\": $fa-var-files,\n  \"files-medical\": $fa-var-files-medical,\n  \"fill\": $fa-var-fill,\n  \"fill-drip\": $fa-var-fill-drip,\n  \"film\": $fa-var-film,\n  \"film-canister\": $fa-var-film-canister,\n  \"film-simple\": $fa-var-film-simple,\n  \"film-alt\": $fa-var-film-alt,\n  \"film-slash\": $fa-var-film-slash,\n  \"films\": $fa-var-films,\n  \"filter\": $fa-var-filter,\n  \"filter-circle-dollar\": $fa-var-filter-circle-dollar,\n  \"funnel-dollar\": $fa-var-funnel-dollar,\n  \"filter-circle-xmark\": $fa-var-filter-circle-xmark,\n  \"filter-list\": $fa-var-filter-list,\n  \"filter-slash\": $fa-var-filter-slash,\n  \"filters\": $fa-var-filters,\n  \"fingerprint\": $fa-var-fingerprint,\n  \"fire\": $fa-var-fire,\n  \"fire-extinguisher\": $fa-var-fire-extinguisher,\n  \"fire-flame\": $fa-var-fire-flame,\n  \"flame\": $fa-var-flame,\n  \"fire-flame-curved\": $fa-var-fire-flame-curved,\n  \"fire-alt\": $fa-var-fire-alt,\n  \"fire-flame-simple\": $fa-var-fire-flame-simple,\n  \"burn\": $fa-var-burn,\n  \"fire-hydrant\": $fa-var-fire-hydrant,\n  \"fire-smoke\": $fa-var-fire-smoke,\n  \"fireplace\": $fa-var-fireplace,\n  \"fish\": $fa-var-fish,\n  \"fish-bones\": $fa-var-fish-bones,\n  \"fish-cooked\": $fa-var-fish-cooked,\n  \"fishing-rod\": $fa-var-fishing-rod,\n  \"flag\": $fa-var-flag,\n  \"flag-checkered\": $fa-var-flag-checkered,\n  \"flag-pennant\": $fa-var-flag-pennant,\n  \"pennant\": $fa-var-pennant,\n  \"flag-swallowtail\": $fa-var-flag-swallowtail,\n  \"flag-alt\": $fa-var-flag-alt,\n  \"flag-usa\": $fa-var-flag-usa,\n  \"flashlight\": $fa-var-flashlight,\n  \"flask\": $fa-var-flask,\n  \"flask-round-poison\": $fa-var-flask-round-poison,\n  \"flask-poison\": $fa-var-flask-poison,\n  \"flask-round-potion\": $fa-var-flask-round-potion,\n  \"flask-potion\": $fa-var-flask-potion,\n  \"flatbread\": $fa-var-flatbread,\n  \"flatbread-stuffed\": $fa-var-flatbread-stuffed,\n  \"floppy-disk\": $fa-var-floppy-disk,\n  \"save\": $fa-var-save,\n  \"floppy-disk-circle-arrow-right\": $fa-var-floppy-disk-circle-arrow-right,\n  \"save-circle-arrow-right\": $fa-var-save-circle-arrow-right,\n  \"floppy-disk-circle-xmark\": $fa-var-floppy-disk-circle-xmark,\n  \"floppy-disk-times\": $fa-var-floppy-disk-times,\n  \"save-circle-xmark\": $fa-var-save-circle-xmark,\n  \"save-times\": $fa-var-save-times,\n  \"floppy-disk-pen\": $fa-var-floppy-disk-pen,\n  \"floppy-disks\": $fa-var-floppy-disks,\n  \"florin-sign\": $fa-var-florin-sign,\n  \"flower\": $fa-var-flower,\n  \"flower-daffodil\": $fa-var-flower-daffodil,\n  \"flower-tulip\": $fa-var-flower-tulip,\n  \"flute\": $fa-var-flute,\n  \"flux-capacitor\": $fa-var-flux-capacitor,\n  \"flying-disc\": $fa-var-flying-disc,\n  \"folder\": $fa-var-folder,\n  \"folder-arrow-down\": $fa-var-folder-arrow-down,\n  \"folder-download\": $fa-var-folder-download,\n  \"folder-arrow-up\": $fa-var-folder-arrow-up,\n  \"folder-upload\": $fa-var-folder-upload,\n  \"folder-blank\": $fa-var-folder-blank,\n  \"folder-bookmark\": $fa-var-folder-bookmark,\n  \"folder-gear\": $fa-var-folder-gear,\n  \"folder-cog\": $fa-var-folder-cog,\n  \"folder-grid\": $fa-var-folder-grid,\n  \"folder-heart\": $fa-var-folder-heart,\n  \"folder-image\": $fa-var-folder-image,\n  \"folder-magnifying-glass\": $fa-var-folder-magnifying-glass,\n  \"folder-search\": $fa-var-folder-search,\n  \"folder-medical\": $fa-var-folder-medical,\n  \"folder-minus\": $fa-var-folder-minus,\n  \"folder-music\": $fa-var-folder-music,\n  \"folder-open\": $fa-var-folder-open,\n  \"folder-plus\": $fa-var-folder-plus,\n  \"folder-tree\": $fa-var-folder-tree,\n  \"folder-user\": $fa-var-folder-user,\n  \"folder-xmark\": $fa-var-folder-xmark,\n  \"folder-times\": $fa-var-folder-times,\n  \"folders\": $fa-var-folders,\n  \"fondue-pot\": $fa-var-fondue-pot,\n  \"font\": $fa-var-font,\n  \"font-case\": $fa-var-font-case,\n  \"football\": $fa-var-football,\n  \"football-ball\": $fa-var-football-ball,\n  \"football-helmet\": $fa-var-football-helmet,\n  \"fork\": $fa-var-fork,\n  \"utensil-fork\": $fa-var-utensil-fork,\n  \"fork-knife\": $fa-var-fork-knife,\n  \"utensils-alt\": $fa-var-utensils-alt,\n  \"forklift\": $fa-var-forklift,\n  \"forward\": $fa-var-forward,\n  \"forward-fast\": $fa-var-forward-fast,\n  \"fast-forward\": $fa-var-fast-forward,\n  \"forward-step\": $fa-var-forward-step,\n  \"step-forward\": $fa-var-step-forward,\n  \"franc-sign\": $fa-var-franc-sign,\n  \"french-fries\": $fa-var-french-fries,\n  \"frog\": $fa-var-frog,\n  \"function\": $fa-var-function,\n  \"futbol\": $fa-var-futbol,\n  \"futbol-ball\": $fa-var-futbol-ball,\n  \"soccer-ball\": $fa-var-soccer-ball,\n  \"g\": $fa-var-g,\n  \"galaxy\": $fa-var-galaxy,\n  \"gallery-thumbnails\": $fa-var-gallery-thumbnails,\n  \"game-board\": $fa-var-game-board,\n  \"game-board-simple\": $fa-var-game-board-simple,\n  \"game-board-alt\": $fa-var-game-board-alt,\n  \"game-console-handheld\": $fa-var-game-console-handheld,\n  \"gamepad\": $fa-var-gamepad,\n  \"gamepad-modern\": $fa-var-gamepad-modern,\n  \"gamepad-alt\": $fa-var-gamepad-alt,\n  \"garage\": $fa-var-garage,\n  \"garage-car\": $fa-var-garage-car,\n  \"garage-open\": $fa-var-garage-open,\n  \"garlic\": $fa-var-garlic,\n  \"gas-pump\": $fa-var-gas-pump,\n  \"gas-pump-slash\": $fa-var-gas-pump-slash,\n  \"gauge\": $fa-var-gauge,\n  \"dashboard\": $fa-var-dashboard,\n  \"gauge-high\": $fa-var-gauge-high,\n  \"tachometer-alt\": $fa-var-tachometer-alt,\n  \"tachometer-alt-fast\": $fa-var-tachometer-alt-fast,\n  \"gauge-low\": $fa-var-gauge-low,\n  \"tachometer-alt-slow\": $fa-var-tachometer-alt-slow,\n  \"gauge-max\": $fa-var-gauge-max,\n  \"tachometer-alt-fastest\": $fa-var-tachometer-alt-fastest,\n  \"gauge-med\": $fa-var-gauge-med,\n  \"tachometer-alt-average\": $fa-var-tachometer-alt-average,\n  \"gauge-min\": $fa-var-gauge-min,\n  \"tachometer-alt-slowest\": $fa-var-tachometer-alt-slowest,\n  \"gauge-simple\": $fa-var-gauge-simple,\n  \"gauge-simple-high\": $fa-var-gauge-simple-high,\n  \"tachometer\": $fa-var-tachometer,\n  \"gauge-simple-low\": $fa-var-gauge-simple-low,\n  \"tachometer-slow\": $fa-var-tachometer-slow,\n  \"gauge-simple-max\": $fa-var-gauge-simple-max,\n  \"tachometer-fastest\": $fa-var-tachometer-fastest,\n  \"gauge-simple-med\": $fa-var-gauge-simple-med,\n  \"tachometer-average\": $fa-var-tachometer-average,\n  \"gauge-simple-min\": $fa-var-gauge-simple-min,\n  \"tachometer-slowest\": $fa-var-tachometer-slowest,\n  \"gavel\": $fa-var-gavel,\n  \"legal\": $fa-var-legal,\n  \"gear\": $fa-var-gear,\n  \"cog\": $fa-var-cog,\n  \"gears\": $fa-var-gears,\n  \"cogs\": $fa-var-cogs,\n  \"gem\": $fa-var-gem,\n  \"genderless\": $fa-var-genderless,\n  \"ghost\": $fa-var-ghost,\n  \"gif\": $fa-var-gif,\n  \"gift\": $fa-var-gift,\n  \"gift-card\": $fa-var-gift-card,\n  \"gifts\": $fa-var-gifts,\n  \"gingerbread-man\": $fa-var-gingerbread-man,\n  \"glass\": $fa-var-glass,\n  \"glass-citrus\": $fa-var-glass-citrus,\n  \"glass-empty\": $fa-var-glass-empty,\n  \"glass-half\": $fa-var-glass-half,\n  \"glass-half-empty\": $fa-var-glass-half-empty,\n  \"glass-half-full\": $fa-var-glass-half-full,\n  \"glasses\": $fa-var-glasses,\n  \"glasses-round\": $fa-var-glasses-round,\n  \"glasses-alt\": $fa-var-glasses-alt,\n  \"globe\": $fa-var-globe,\n  \"globe-snow\": $fa-var-globe-snow,\n  \"globe-stand\": $fa-var-globe-stand,\n  \"goal-net\": $fa-var-goal-net,\n  \"golf-ball-tee\": $fa-var-golf-ball-tee,\n  \"golf-ball\": $fa-var-golf-ball,\n  \"golf-club\": $fa-var-golf-club,\n  \"golf-flag-hole\": $fa-var-golf-flag-hole,\n  \"gopuram\": $fa-var-gopuram,\n  \"graduation-cap\": $fa-var-graduation-cap,\n  \"mortar-board\": $fa-var-mortar-board,\n  \"gramophone\": $fa-var-gramophone,\n  \"grapes\": $fa-var-grapes,\n  \"grate\": $fa-var-grate,\n  \"grate-droplet\": $fa-var-grate-droplet,\n  \"greater-than\": $fa-var-greater-than,\n  \"greater-than-equal\": $fa-var-greater-than-equal,\n  \"grid\": $fa-var-grid,\n  \"grid-3\": $fa-var-grid-3,\n  \"grid-2\": $fa-var-grid-2,\n  \"grid-2-plus\": $fa-var-grid-2-plus,\n  \"grid-4\": $fa-var-grid-4,\n  \"grid-5\": $fa-var-grid-5,\n  \"grid-dividers\": $fa-var-grid-dividers,\n  \"grid-horizontal\": $fa-var-grid-horizontal,\n  \"grip\": $fa-var-grip,\n  \"grip-horizontal\": $fa-var-grip-horizontal,\n  \"grip-dots\": $fa-var-grip-dots,\n  \"grip-dots-vertical\": $fa-var-grip-dots-vertical,\n  \"grip-lines\": $fa-var-grip-lines,\n  \"grip-lines-vertical\": $fa-var-grip-lines-vertical,\n  \"grip-vertical\": $fa-var-grip-vertical,\n  \"guarani-sign\": $fa-var-guarani-sign,\n  \"guitar\": $fa-var-guitar,\n  \"guitar-electric\": $fa-var-guitar-electric,\n  \"guitars\": $fa-var-guitars,\n  \"gun\": $fa-var-gun,\n  \"gun-slash\": $fa-var-gun-slash,\n  \"gun-squirt\": $fa-var-gun-squirt,\n  \"h\": $fa-var-h,\n  \"h1\": $fa-var-h1,\n  \"h2\": $fa-var-h2,\n  \"h3\": $fa-var-h3,\n  \"h4\": $fa-var-h4,\n  \"h5\": $fa-var-h5,\n  \"h6\": $fa-var-h6,\n  \"hammer\": $fa-var-hammer,\n  \"hammer-crash\": $fa-var-hammer-crash,\n  \"hammer-war\": $fa-var-hammer-war,\n  \"hamsa\": $fa-var-hamsa,\n  \"hand\": $fa-var-hand,\n  \"hand-paper\": $fa-var-hand-paper,\n  \"hand-back-fist\": $fa-var-hand-back-fist,\n  \"hand-rock\": $fa-var-hand-rock,\n  \"hand-back-point-down\": $fa-var-hand-back-point-down,\n  \"hand-back-point-left\": $fa-var-hand-back-point-left,\n  \"hand-back-point-ribbon\": $fa-var-hand-back-point-ribbon,\n  \"hand-back-point-right\": $fa-var-hand-back-point-right,\n  \"hand-back-point-up\": $fa-var-hand-back-point-up,\n  \"hand-dots\": $fa-var-hand-dots,\n  \"allergies\": $fa-var-allergies,\n  \"hand-fingers-crossed\": $fa-var-hand-fingers-crossed,\n  \"hand-fist\": $fa-var-hand-fist,\n  \"fist-raised\": $fa-var-fist-raised,\n  \"hand-heart\": $fa-var-hand-heart,\n  \"hand-holding\": $fa-var-hand-holding,\n  \"hand-holding-box\": $fa-var-hand-holding-box,\n  \"hand-holding-dollar\": $fa-var-hand-holding-dollar,\n  \"hand-holding-usd\": $fa-var-hand-holding-usd,\n  \"hand-holding-droplet\": $fa-var-hand-holding-droplet,\n  \"hand-holding-water\": $fa-var-hand-holding-water,\n  \"hand-holding-heart\": $fa-var-hand-holding-heart,\n  \"hand-holding-magic\": $fa-var-hand-holding-magic,\n  \"hand-holding-medical\": $fa-var-hand-holding-medical,\n  \"hand-holding-seedling\": $fa-var-hand-holding-seedling,\n  \"hand-holding-skull\": $fa-var-hand-holding-skull,\n  \"hand-horns\": $fa-var-hand-horns,\n  \"hand-lizard\": $fa-var-hand-lizard,\n  \"hand-love\": $fa-var-hand-love,\n  \"hand-middle-finger\": $fa-var-hand-middle-finger,\n  \"hand-peace\": $fa-var-hand-peace,\n  \"hand-point-down\": $fa-var-hand-point-down,\n  \"hand-point-left\": $fa-var-hand-point-left,\n  \"hand-point-ribbon\": $fa-var-hand-point-ribbon,\n  \"hand-point-right\": $fa-var-hand-point-right,\n  \"hand-point-up\": $fa-var-hand-point-up,\n  \"hand-pointer\": $fa-var-hand-pointer,\n  \"hand-scissors\": $fa-var-hand-scissors,\n  \"hand-sparkles\": $fa-var-hand-sparkles,\n  \"hand-spock\": $fa-var-hand-spock,\n  \"hand-wave\": $fa-var-hand-wave,\n  \"hands\": $fa-var-hands,\n  \"sign-language\": $fa-var-sign-language,\n  \"signing\": $fa-var-signing,\n  \"hands-asl-interpreting\": $fa-var-hands-asl-interpreting,\n  \"american-sign-language-interpreting\": $fa-var-american-sign-language-interpreting,\n  \"asl-interpreting\": $fa-var-asl-interpreting,\n  \"hands-american-sign-language-interpreting\": $fa-var-hands-american-sign-language-interpreting,\n  \"hands-bubbles\": $fa-var-hands-bubbles,\n  \"hands-wash\": $fa-var-hands-wash,\n  \"hands-clapping\": $fa-var-hands-clapping,\n  \"hands-holding\": $fa-var-hands-holding,\n  \"hands-holding-diamond\": $fa-var-hands-holding-diamond,\n  \"hand-receiving\": $fa-var-hand-receiving,\n  \"hands-holding-dollar\": $fa-var-hands-holding-dollar,\n  \"hands-usd\": $fa-var-hands-usd,\n  \"hands-holding-heart\": $fa-var-hands-holding-heart,\n  \"hands-heart\": $fa-var-hands-heart,\n  \"hands-praying\": $fa-var-hands-praying,\n  \"praying-hands\": $fa-var-praying-hands,\n  \"handshake\": $fa-var-handshake,\n  \"handshake-angle\": $fa-var-handshake-angle,\n  \"hands-helping\": $fa-var-hands-helping,\n  \"handshake-simple\": $fa-var-handshake-simple,\n  \"handshake-alt\": $fa-var-handshake-alt,\n  \"handshake-simple-slash\": $fa-var-handshake-simple-slash,\n  \"handshake-alt-slash\": $fa-var-handshake-alt-slash,\n  \"handshake-slash\": $fa-var-handshake-slash,\n  \"hanukiah\": $fa-var-hanukiah,\n  \"hard-drive\": $fa-var-hard-drive,\n  \"hdd\": $fa-var-hdd,\n  \"hashtag\": $fa-var-hashtag,\n  \"hashtag-lock\": $fa-var-hashtag-lock,\n  \"hat-chef\": $fa-var-hat-chef,\n  \"hat-cowboy\": $fa-var-hat-cowboy,\n  \"hat-cowboy-side\": $fa-var-hat-cowboy-side,\n  \"hat-santa\": $fa-var-hat-santa,\n  \"hat-winter\": $fa-var-hat-winter,\n  \"hat-witch\": $fa-var-hat-witch,\n  \"hat-wizard\": $fa-var-hat-wizard,\n  \"head-side\": $fa-var-head-side,\n  \"head-side-brain\": $fa-var-head-side-brain,\n  \"head-side-cough\": $fa-var-head-side-cough,\n  \"head-side-cough-slash\": $fa-var-head-side-cough-slash,\n  \"head-side-goggles\": $fa-var-head-side-goggles,\n  \"head-vr\": $fa-var-head-vr,\n  \"head-side-headphones\": $fa-var-head-side-headphones,\n  \"head-side-heart\": $fa-var-head-side-heart,\n  \"head-side-mask\": $fa-var-head-side-mask,\n  \"head-side-medical\": $fa-var-head-side-medical,\n  \"head-side-virus\": $fa-var-head-side-virus,\n  \"heading\": $fa-var-heading,\n  \"header\": $fa-var-header,\n  \"headphones\": $fa-var-headphones,\n  \"headphones-simple\": $fa-var-headphones-simple,\n  \"headphones-alt\": $fa-var-headphones-alt,\n  \"headset\": $fa-var-headset,\n  \"heart\": $fa-var-heart,\n  \"heart-crack\": $fa-var-heart-crack,\n  \"heart-broken\": $fa-var-heart-broken,\n  \"heart-half\": $fa-var-heart-half,\n  \"heart-half-stroke\": $fa-var-heart-half-stroke,\n  \"heart-half-alt\": $fa-var-heart-half-alt,\n  \"heart-pulse\": $fa-var-heart-pulse,\n  \"heartbeat\": $fa-var-heartbeat,\n  \"heat\": $fa-var-heat,\n  \"helicopter\": $fa-var-helicopter,\n  \"helmet-battle\": $fa-var-helmet-battle,\n  \"helmet-safety\": $fa-var-helmet-safety,\n  \"hard-hat\": $fa-var-hard-hat,\n  \"hat-hard\": $fa-var-hat-hard,\n  \"hexagon\": $fa-var-hexagon,\n  \"hexagon-check\": $fa-var-hexagon-check,\n  \"hexagon-divide\": $fa-var-hexagon-divide,\n  \"hexagon-exclamation\": $fa-var-hexagon-exclamation,\n  \"hexagon-minus\": $fa-var-hexagon-minus,\n  \"minus-hexagon\": $fa-var-minus-hexagon,\n  \"hexagon-plus\": $fa-var-hexagon-plus,\n  \"plus-hexagon\": $fa-var-plus-hexagon,\n  \"hexagon-xmark\": $fa-var-hexagon-xmark,\n  \"times-hexagon\": $fa-var-times-hexagon,\n  \"xmark-hexagon\": $fa-var-xmark-hexagon,\n  \"high-definition\": $fa-var-high-definition,\n  \"rectangle-hd\": $fa-var-rectangle-hd,\n  \"highlighter\": $fa-var-highlighter,\n  \"highlighter-line\": $fa-var-highlighter-line,\n  \"hippo\": $fa-var-hippo,\n  \"hockey-mask\": $fa-var-hockey-mask,\n  \"hockey-puck\": $fa-var-hockey-puck,\n  \"hockey-stick-puck\": $fa-var-hockey-stick-puck,\n  \"hockey-sticks\": $fa-var-hockey-sticks,\n  \"holly-berry\": $fa-var-holly-berry,\n  \"honey-pot\": $fa-var-honey-pot,\n  \"hood-cloak\": $fa-var-hood-cloak,\n  \"horizontal-rule\": $fa-var-horizontal-rule,\n  \"horse\": $fa-var-horse,\n  \"horse-head\": $fa-var-horse-head,\n  \"horse-saddle\": $fa-var-horse-saddle,\n  \"hose\": $fa-var-hose,\n  \"hose-reel\": $fa-var-hose-reel,\n  \"hospital\": $fa-var-hospital,\n  \"hospital-user\": $fa-var-hospital-user,\n  \"hospital-wide\": $fa-var-hospital-wide,\n  \"hospital-alt\": $fa-var-hospital-alt,\n  \"hospitals\": $fa-var-hospitals,\n  \"hot-tub-person\": $fa-var-hot-tub-person,\n  \"hot-tub\": $fa-var-hot-tub,\n  \"hotdog\": $fa-var-hotdog,\n  \"hotel\": $fa-var-hotel,\n  \"hourglass\": $fa-var-hourglass,\n  \"hourglass-2\": $fa-var-hourglass-2,\n  \"hourglass-half\": $fa-var-hourglass-half,\n  \"hourglass-clock\": $fa-var-hourglass-clock,\n  \"hourglass-empty\": $fa-var-hourglass-empty,\n  \"hourglass-end\": $fa-var-hourglass-end,\n  \"hourglass-3\": $fa-var-hourglass-3,\n  \"hourglass-start\": $fa-var-hourglass-start,\n  \"hourglass-1\": $fa-var-hourglass-1,\n  \"house\": $fa-var-house,\n  \"home\": $fa-var-home,\n  \"house-blank\": $fa-var-house-blank,\n  \"home-blank\": $fa-var-home-blank,\n  \"home-lg-alt\": $fa-var-home-lg-alt,\n  \"house-building\": $fa-var-house-building,\n  \"house-chimney\": $fa-var-house-chimney,\n  \"home-lg\": $fa-var-home-lg,\n  \"house-chimney-blank\": $fa-var-house-chimney-blank,\n  \"house-chimney-crack\": $fa-var-house-chimney-crack,\n  \"house-damage\": $fa-var-house-damage,\n  \"house-chimney-heart\": $fa-var-house-chimney-heart,\n  \"house-chimney-medical\": $fa-var-house-chimney-medical,\n  \"clinic-medical\": $fa-var-clinic-medical,\n  \"house-chimney-user\": $fa-var-house-chimney-user,\n  \"house-chimney-window\": $fa-var-house-chimney-window,\n  \"house-crack\": $fa-var-house-crack,\n  \"house-day\": $fa-var-house-day,\n  \"house-flood\": $fa-var-house-flood,\n  \"house-heart\": $fa-var-house-heart,\n  \"home-heart\": $fa-var-home-heart,\n  \"house-laptop\": $fa-var-house-laptop,\n  \"laptop-house\": $fa-var-laptop-house,\n  \"house-medical\": $fa-var-house-medical,\n  \"house-night\": $fa-var-house-night,\n  \"house-person-leave\": $fa-var-house-person-leave,\n  \"house-person-depart\": $fa-var-house-person-depart,\n  \"house-person-return\": $fa-var-house-person-return,\n  \"house-person-arrive\": $fa-var-house-person-arrive,\n  \"house-signal\": $fa-var-house-signal,\n  \"house-tree\": $fa-var-house-tree,\n  \"house-turret\": $fa-var-house-turret,\n  \"house-user\": $fa-var-house-user,\n  \"home-user\": $fa-var-home-user,\n  \"house-window\": $fa-var-house-window,\n  \"hryvnia-sign\": $fa-var-hryvnia-sign,\n  \"hryvnia\": $fa-var-hryvnia,\n  \"hundred-points\": $fa-var-hundred-points,\n  \"100\": $fa-var-100,\n  \"hurricane\": $fa-var-hurricane,\n  \"hyphen\": $fa-var-hyphen,\n  \"i\": $fa-var-i,\n  \"i-cursor\": $fa-var-i-cursor,\n  \"ice-cream\": $fa-var-ice-cream,\n  \"ice-skate\": $fa-var-ice-skate,\n  \"icicles\": $fa-var-icicles,\n  \"icons\": $fa-var-icons,\n  \"heart-music-camera-bolt\": $fa-var-heart-music-camera-bolt,\n  \"id-badge\": $fa-var-id-badge,\n  \"id-card\": $fa-var-id-card,\n  \"drivers-license\": $fa-var-drivers-license,\n  \"id-card-clip\": $fa-var-id-card-clip,\n  \"id-card-alt\": $fa-var-id-card-alt,\n  \"igloo\": $fa-var-igloo,\n  \"image\": $fa-var-image,\n  \"image-landscape\": $fa-var-image-landscape,\n  \"landscape\": $fa-var-landscape,\n  \"image-polaroid\": $fa-var-image-polaroid,\n  \"image-polaroid-user\": $fa-var-image-polaroid-user,\n  \"image-portrait\": $fa-var-image-portrait,\n  \"portrait\": $fa-var-portrait,\n  \"image-slash\": $fa-var-image-slash,\n  \"image-user\": $fa-var-image-user,\n  \"images\": $fa-var-images,\n  \"images-user\": $fa-var-images-user,\n  \"inbox\": $fa-var-inbox,\n  \"inbox-full\": $fa-var-inbox-full,\n  \"inbox-in\": $fa-var-inbox-in,\n  \"inbox-arrow-down\": $fa-var-inbox-arrow-down,\n  \"inbox-out\": $fa-var-inbox-out,\n  \"inbox-arrow-up\": $fa-var-inbox-arrow-up,\n  \"inboxes\": $fa-var-inboxes,\n  \"indent\": $fa-var-indent,\n  \"indian-rupee-sign\": $fa-var-indian-rupee-sign,\n  \"indian-rupee\": $fa-var-indian-rupee,\n  \"inr\": $fa-var-inr,\n  \"industry\": $fa-var-industry,\n  \"industry-windows\": $fa-var-industry-windows,\n  \"industry-alt\": $fa-var-industry-alt,\n  \"infinity\": $fa-var-infinity,\n  \"info\": $fa-var-info,\n  \"inhaler\": $fa-var-inhaler,\n  \"input-numeric\": $fa-var-input-numeric,\n  \"input-pipe\": $fa-var-input-pipe,\n  \"input-text\": $fa-var-input-text,\n  \"integral\": $fa-var-integral,\n  \"intersection\": $fa-var-intersection,\n  \"island-tropical\": $fa-var-island-tropical,\n  \"island-tree-palm\": $fa-var-island-tree-palm,\n  \"italic\": $fa-var-italic,\n  \"j\": $fa-var-j,\n  \"jack-o-lantern\": $fa-var-jack-o-lantern,\n  \"jedi\": $fa-var-jedi,\n  \"jet-fighter\": $fa-var-jet-fighter,\n  \"fighter-jet\": $fa-var-fighter-jet,\n  \"joint\": $fa-var-joint,\n  \"joystick\": $fa-var-joystick,\n  \"jug\": $fa-var-jug,\n  \"k\": $fa-var-k,\n  \"kaaba\": $fa-var-kaaba,\n  \"kazoo\": $fa-var-kazoo,\n  \"kerning\": $fa-var-kerning,\n  \"key\": $fa-var-key,\n  \"key-skeleton\": $fa-var-key-skeleton,\n  \"key-skeleton-left-right\": $fa-var-key-skeleton-left-right,\n  \"keyboard\": $fa-var-keyboard,\n  \"keyboard-brightness\": $fa-var-keyboard-brightness,\n  \"keyboard-brightness-low\": $fa-var-keyboard-brightness-low,\n  \"keyboard-down\": $fa-var-keyboard-down,\n  \"keyboard-left\": $fa-var-keyboard-left,\n  \"keynote\": $fa-var-keynote,\n  \"khanda\": $fa-var-khanda,\n  \"kidneys\": $fa-var-kidneys,\n  \"kip-sign\": $fa-var-kip-sign,\n  \"kit-medical\": $fa-var-kit-medical,\n  \"first-aid\": $fa-var-first-aid,\n  \"kite\": $fa-var-kite,\n  \"kiwi-bird\": $fa-var-kiwi-bird,\n  \"kiwi-fruit\": $fa-var-kiwi-fruit,\n  \"knife\": $fa-var-knife,\n  \"utensil-knife\": $fa-var-utensil-knife,\n  \"knife-kitchen\": $fa-var-knife-kitchen,\n  \"l\": $fa-var-l,\n  \"lacrosse-stick\": $fa-var-lacrosse-stick,\n  \"lacrosse-stick-ball\": $fa-var-lacrosse-stick-ball,\n  \"lambda\": $fa-var-lambda,\n  \"lamp\": $fa-var-lamp,\n  \"lamp-desk\": $fa-var-lamp-desk,\n  \"lamp-floor\": $fa-var-lamp-floor,\n  \"lamp-street\": $fa-var-lamp-street,\n  \"landmark\": $fa-var-landmark,\n  \"landmark-dome\": $fa-var-landmark-dome,\n  \"landmark-alt\": $fa-var-landmark-alt,\n  \"language\": $fa-var-language,\n  \"laptop\": $fa-var-laptop,\n  \"laptop-arrow-down\": $fa-var-laptop-arrow-down,\n  \"laptop-code\": $fa-var-laptop-code,\n  \"laptop-medical\": $fa-var-laptop-medical,\n  \"laptop-mobile\": $fa-var-laptop-mobile,\n  \"phone-laptop\": $fa-var-phone-laptop,\n  \"laptop-slash\": $fa-var-laptop-slash,\n  \"lari-sign\": $fa-var-lari-sign,\n  \"lasso\": $fa-var-lasso,\n  \"lasso-sparkles\": $fa-var-lasso-sparkles,\n  \"layer-group\": $fa-var-layer-group,\n  \"layer-minus\": $fa-var-layer-minus,\n  \"layer-group-minus\": $fa-var-layer-group-minus,\n  \"layer-plus\": $fa-var-layer-plus,\n  \"layer-group-plus\": $fa-var-layer-group-plus,\n  \"leaf\": $fa-var-leaf,\n  \"leaf-heart\": $fa-var-leaf-heart,\n  \"leaf-maple\": $fa-var-leaf-maple,\n  \"leaf-oak\": $fa-var-leaf-oak,\n  \"leafy-green\": $fa-var-leafy-green,\n  \"left\": $fa-var-left,\n  \"arrow-alt-left\": $fa-var-arrow-alt-left,\n  \"left-from-line\": $fa-var-left-from-line,\n  \"arrow-alt-from-right\": $fa-var-arrow-alt-from-right,\n  \"left-long\": $fa-var-left-long,\n  \"long-arrow-alt-left\": $fa-var-long-arrow-alt-left,\n  \"left-long-to-line\": $fa-var-left-long-to-line,\n  \"left-right\": $fa-var-left-right,\n  \"arrows-alt-h\": $fa-var-arrows-alt-h,\n  \"left-to-line\": $fa-var-left-to-line,\n  \"arrow-alt-to-left\": $fa-var-arrow-alt-to-left,\n  \"lemon\": $fa-var-lemon,\n  \"less-than\": $fa-var-less-than,\n  \"less-than-equal\": $fa-var-less-than-equal,\n  \"life-ring\": $fa-var-life-ring,\n  \"light-ceiling\": $fa-var-light-ceiling,\n  \"light-emergency\": $fa-var-light-emergency,\n  \"light-emergency-on\": $fa-var-light-emergency-on,\n  \"light-switch\": $fa-var-light-switch,\n  \"light-switch-off\": $fa-var-light-switch-off,\n  \"light-switch-on\": $fa-var-light-switch-on,\n  \"lightbulb\": $fa-var-lightbulb,\n  \"lightbulb-dollar\": $fa-var-lightbulb-dollar,\n  \"lightbulb-exclamation\": $fa-var-lightbulb-exclamation,\n  \"lightbulb-exclamation-on\": $fa-var-lightbulb-exclamation-on,\n  \"lightbulb-on\": $fa-var-lightbulb-on,\n  \"lightbulb-slash\": $fa-var-lightbulb-slash,\n  \"lights-holiday\": $fa-var-lights-holiday,\n  \"line-columns\": $fa-var-line-columns,\n  \"line-height\": $fa-var-line-height,\n  \"link\": $fa-var-link,\n  \"chain\": $fa-var-chain,\n  \"link-horizontal\": $fa-var-link-horizontal,\n  \"chain-horizontal\": $fa-var-chain-horizontal,\n  \"link-horizontal-slash\": $fa-var-link-horizontal-slash,\n  \"chain-horizontal-slash\": $fa-var-chain-horizontal-slash,\n  \"link-simple\": $fa-var-link-simple,\n  \"link-simple-slash\": $fa-var-link-simple-slash,\n  \"link-slash\": $fa-var-link-slash,\n  \"chain-broken\": $fa-var-chain-broken,\n  \"chain-slash\": $fa-var-chain-slash,\n  \"unlink\": $fa-var-unlink,\n  \"lips\": $fa-var-lips,\n  \"lira-sign\": $fa-var-lira-sign,\n  \"list\": $fa-var-list,\n  \"list-squares\": $fa-var-list-squares,\n  \"list-check\": $fa-var-list-check,\n  \"tasks\": $fa-var-tasks,\n  \"list-dropdown\": $fa-var-list-dropdown,\n  \"list-music\": $fa-var-list-music,\n  \"list-ol\": $fa-var-list-ol,\n  \"list-1-2\": $fa-var-list-1-2,\n  \"list-numeric\": $fa-var-list-numeric,\n  \"list-radio\": $fa-var-list-radio,\n  \"list-timeline\": $fa-var-list-timeline,\n  \"list-tree\": $fa-var-list-tree,\n  \"list-ul\": $fa-var-list-ul,\n  \"list-dots\": $fa-var-list-dots,\n  \"litecoin-sign\": $fa-var-litecoin-sign,\n  \"loader\": $fa-var-loader,\n  \"lobster\": $fa-var-lobster,\n  \"location-arrow\": $fa-var-location-arrow,\n  \"location-check\": $fa-var-location-check,\n  \"map-marker-check\": $fa-var-map-marker-check,\n  \"location-crosshairs\": $fa-var-location-crosshairs,\n  \"location\": $fa-var-location,\n  \"location-crosshairs-slash\": $fa-var-location-crosshairs-slash,\n  \"location-slash\": $fa-var-location-slash,\n  \"location-dot\": $fa-var-location-dot,\n  \"map-marker-alt\": $fa-var-map-marker-alt,\n  \"location-dot-slash\": $fa-var-location-dot-slash,\n  \"map-marker-alt-slash\": $fa-var-map-marker-alt-slash,\n  \"location-exclamation\": $fa-var-location-exclamation,\n  \"map-marker-exclamation\": $fa-var-map-marker-exclamation,\n  \"location-minus\": $fa-var-location-minus,\n  \"map-marker-minus\": $fa-var-map-marker-minus,\n  \"location-pen\": $fa-var-location-pen,\n  \"map-marker-edit\": $fa-var-map-marker-edit,\n  \"location-pin\": $fa-var-location-pin,\n  \"map-marker\": $fa-var-map-marker,\n  \"location-pin-slash\": $fa-var-location-pin-slash,\n  \"map-marker-slash\": $fa-var-map-marker-slash,\n  \"location-plus\": $fa-var-location-plus,\n  \"map-marker-plus\": $fa-var-map-marker-plus,\n  \"location-question\": $fa-var-location-question,\n  \"map-marker-question\": $fa-var-map-marker-question,\n  \"location-smile\": $fa-var-location-smile,\n  \"map-marker-smile\": $fa-var-map-marker-smile,\n  \"location-xmark\": $fa-var-location-xmark,\n  \"map-marker-times\": $fa-var-map-marker-times,\n  \"map-marker-xmark\": $fa-var-map-marker-xmark,\n  \"lock\": $fa-var-lock,\n  \"lock-a\": $fa-var-lock-a,\n  \"lock-hashtag\": $fa-var-lock-hashtag,\n  \"lock-keyhole\": $fa-var-lock-keyhole,\n  \"lock-alt\": $fa-var-lock-alt,\n  \"lock-keyhole-open\": $fa-var-lock-keyhole-open,\n  \"lock-open-alt\": $fa-var-lock-open-alt,\n  \"lock-open\": $fa-var-lock-open,\n  \"lollipop\": $fa-var-lollipop,\n  \"lollypop\": $fa-var-lollypop,\n  \"loveseat\": $fa-var-loveseat,\n  \"couch-small\": $fa-var-couch-small,\n  \"luchador-mask\": $fa-var-luchador-mask,\n  \"luchador\": $fa-var-luchador,\n  \"mask-luchador\": $fa-var-mask-luchador,\n  \"lungs\": $fa-var-lungs,\n  \"lungs-virus\": $fa-var-lungs-virus,\n  \"m\": $fa-var-m,\n  \"mace\": $fa-var-mace,\n  \"magnet\": $fa-var-magnet,\n  \"magnifying-glass\": $fa-var-magnifying-glass,\n  \"search\": $fa-var-search,\n  \"magnifying-glass-dollar\": $fa-var-magnifying-glass-dollar,\n  \"search-dollar\": $fa-var-search-dollar,\n  \"magnifying-glass-location\": $fa-var-magnifying-glass-location,\n  \"search-location\": $fa-var-search-location,\n  \"magnifying-glass-minus\": $fa-var-magnifying-glass-minus,\n  \"search-minus\": $fa-var-search-minus,\n  \"magnifying-glass-plus\": $fa-var-magnifying-glass-plus,\n  \"search-plus\": $fa-var-search-plus,\n  \"mailbox\": $fa-var-mailbox,\n  \"manat-sign\": $fa-var-manat-sign,\n  \"mandolin\": $fa-var-mandolin,\n  \"mango\": $fa-var-mango,\n  \"manhole\": $fa-var-manhole,\n  \"map\": $fa-var-map,\n  \"map-location\": $fa-var-map-location,\n  \"map-marked\": $fa-var-map-marked,\n  \"map-location-dot\": $fa-var-map-location-dot,\n  \"map-marked-alt\": $fa-var-map-marked-alt,\n  \"map-pin\": $fa-var-map-pin,\n  \"marker\": $fa-var-marker,\n  \"mars\": $fa-var-mars,\n  \"mars-and-venus\": $fa-var-mars-and-venus,\n  \"mars-double\": $fa-var-mars-double,\n  \"mars-stroke\": $fa-var-mars-stroke,\n  \"mars-stroke-right\": $fa-var-mars-stroke-right,\n  \"mars-stroke-h\": $fa-var-mars-stroke-h,\n  \"mars-stroke-up\": $fa-var-mars-stroke-up,\n  \"mars-stroke-v\": $fa-var-mars-stroke-v,\n  \"martini-glass\": $fa-var-martini-glass,\n  \"glass-martini-alt\": $fa-var-glass-martini-alt,\n  \"martini-glass-citrus\": $fa-var-martini-glass-citrus,\n  \"cocktail\": $fa-var-cocktail,\n  \"martini-glass-empty\": $fa-var-martini-glass-empty,\n  \"glass-martini\": $fa-var-glass-martini,\n  \"mask\": $fa-var-mask,\n  \"mask-face\": $fa-var-mask-face,\n  \"mask-snorkel\": $fa-var-mask-snorkel,\n  \"masks-theater\": $fa-var-masks-theater,\n  \"theater-masks\": $fa-var-theater-masks,\n  \"maximize\": $fa-var-maximize,\n  \"expand-arrows-alt\": $fa-var-expand-arrows-alt,\n  \"meat\": $fa-var-meat,\n  \"medal\": $fa-var-medal,\n  \"megaphone\": $fa-var-megaphone,\n  \"melon\": $fa-var-melon,\n  \"melon-slice\": $fa-var-melon-slice,\n  \"memo\": $fa-var-memo,\n  \"memo-circle-check\": $fa-var-memo-circle-check,\n  \"memo-pad\": $fa-var-memo-pad,\n  \"memory\": $fa-var-memory,\n  \"menorah\": $fa-var-menorah,\n  \"mercury\": $fa-var-mercury,\n  \"message\": $fa-var-message,\n  \"comment-alt\": $fa-var-comment-alt,\n  \"message-arrow-down\": $fa-var-message-arrow-down,\n  \"comment-alt-arrow-down\": $fa-var-comment-alt-arrow-down,\n  \"message-arrow-up\": $fa-var-message-arrow-up,\n  \"comment-alt-arrow-up\": $fa-var-comment-alt-arrow-up,\n  \"message-arrow-up-right\": $fa-var-message-arrow-up-right,\n  \"message-bot\": $fa-var-message-bot,\n  \"message-captions\": $fa-var-message-captions,\n  \"comment-alt-captions\": $fa-var-comment-alt-captions,\n  \"message-check\": $fa-var-message-check,\n  \"comment-alt-check\": $fa-var-comment-alt-check,\n  \"message-code\": $fa-var-message-code,\n  \"message-dollar\": $fa-var-message-dollar,\n  \"comment-alt-dollar\": $fa-var-comment-alt-dollar,\n  \"message-dots\": $fa-var-message-dots,\n  \"comment-alt-dots\": $fa-var-comment-alt-dots,\n  \"messaging\": $fa-var-messaging,\n  \"message-exclamation\": $fa-var-message-exclamation,\n  \"comment-alt-exclamation\": $fa-var-comment-alt-exclamation,\n  \"message-image\": $fa-var-message-image,\n  \"comment-alt-image\": $fa-var-comment-alt-image,\n  \"message-lines\": $fa-var-message-lines,\n  \"comment-alt-lines\": $fa-var-comment-alt-lines,\n  \"message-medical\": $fa-var-message-medical,\n  \"comment-alt-medical\": $fa-var-comment-alt-medical,\n  \"message-middle\": $fa-var-message-middle,\n  \"comment-middle-alt\": $fa-var-comment-middle-alt,\n  \"message-middle-top\": $fa-var-message-middle-top,\n  \"comment-middle-top-alt\": $fa-var-comment-middle-top-alt,\n  \"message-minus\": $fa-var-message-minus,\n  \"comment-alt-minus\": $fa-var-comment-alt-minus,\n  \"message-music\": $fa-var-message-music,\n  \"comment-alt-music\": $fa-var-comment-alt-music,\n  \"message-pen\": $fa-var-message-pen,\n  \"comment-alt-edit\": $fa-var-comment-alt-edit,\n  \"message-edit\": $fa-var-message-edit,\n  \"message-plus\": $fa-var-message-plus,\n  \"comment-alt-plus\": $fa-var-comment-alt-plus,\n  \"message-question\": $fa-var-message-question,\n  \"message-quote\": $fa-var-message-quote,\n  \"comment-alt-quote\": $fa-var-comment-alt-quote,\n  \"message-slash\": $fa-var-message-slash,\n  \"comment-alt-slash\": $fa-var-comment-alt-slash,\n  \"message-smile\": $fa-var-message-smile,\n  \"comment-alt-smile\": $fa-var-comment-alt-smile,\n  \"message-sms\": $fa-var-message-sms,\n  \"message-text\": $fa-var-message-text,\n  \"comment-alt-text\": $fa-var-comment-alt-text,\n  \"message-xmark\": $fa-var-message-xmark,\n  \"comment-alt-times\": $fa-var-comment-alt-times,\n  \"message-times\": $fa-var-message-times,\n  \"messages\": $fa-var-messages,\n  \"comments-alt\": $fa-var-comments-alt,\n  \"messages-dollar\": $fa-var-messages-dollar,\n  \"comments-alt-dollar\": $fa-var-comments-alt-dollar,\n  \"messages-question\": $fa-var-messages-question,\n  \"meteor\": $fa-var-meteor,\n  \"meter\": $fa-var-meter,\n  \"meter-bolt\": $fa-var-meter-bolt,\n  \"meter-droplet\": $fa-var-meter-droplet,\n  \"meter-fire\": $fa-var-meter-fire,\n  \"microchip\": $fa-var-microchip,\n  \"microchip-ai\": $fa-var-microchip-ai,\n  \"microphone\": $fa-var-microphone,\n  \"microphone-lines\": $fa-var-microphone-lines,\n  \"microphone-alt\": $fa-var-microphone-alt,\n  \"microphone-lines-slash\": $fa-var-microphone-lines-slash,\n  \"microphone-alt-slash\": $fa-var-microphone-alt-slash,\n  \"microphone-slash\": $fa-var-microphone-slash,\n  \"microphone-stand\": $fa-var-microphone-stand,\n  \"microscope\": $fa-var-microscope,\n  \"microwave\": $fa-var-microwave,\n  \"mill-sign\": $fa-var-mill-sign,\n  \"minimize\": $fa-var-minimize,\n  \"compress-arrows-alt\": $fa-var-compress-arrows-alt,\n  \"minus\": $fa-var-minus,\n  \"subtract\": $fa-var-subtract,\n  \"mistletoe\": $fa-var-mistletoe,\n  \"mitten\": $fa-var-mitten,\n  \"mobile\": $fa-var-mobile,\n  \"mobile-android\": $fa-var-mobile-android,\n  \"mobile-phone\": $fa-var-mobile-phone,\n  \"mobile-button\": $fa-var-mobile-button,\n  \"mobile-notch\": $fa-var-mobile-notch,\n  \"mobile-iphone\": $fa-var-mobile-iphone,\n  \"mobile-screen\": $fa-var-mobile-screen,\n  \"mobile-android-alt\": $fa-var-mobile-android-alt,\n  \"mobile-screen-button\": $fa-var-mobile-screen-button,\n  \"mobile-alt\": $fa-var-mobile-alt,\n  \"mobile-signal\": $fa-var-mobile-signal,\n  \"mobile-signal-out\": $fa-var-mobile-signal-out,\n  \"money-bill\": $fa-var-money-bill,\n  \"money-bill-1\": $fa-var-money-bill-1,\n  \"money-bill-alt\": $fa-var-money-bill-alt,\n  \"money-bill-1-wave\": $fa-var-money-bill-1-wave,\n  \"money-bill-wave-alt\": $fa-var-money-bill-wave-alt,\n  \"money-bill-simple\": $fa-var-money-bill-simple,\n  \"money-bill-simple-wave\": $fa-var-money-bill-simple-wave,\n  \"money-bill-wave\": $fa-var-money-bill-wave,\n  \"money-bills\": $fa-var-money-bills,\n  \"money-bills-simple\": $fa-var-money-bills-simple,\n  \"money-bills-alt\": $fa-var-money-bills-alt,\n  \"money-check\": $fa-var-money-check,\n  \"money-check-dollar\": $fa-var-money-check-dollar,\n  \"money-check-alt\": $fa-var-money-check-alt,\n  \"money-check-dollar-pen\": $fa-var-money-check-dollar-pen,\n  \"money-check-edit-alt\": $fa-var-money-check-edit-alt,\n  \"money-check-pen\": $fa-var-money-check-pen,\n  \"money-check-edit\": $fa-var-money-check-edit,\n  \"money-from-bracket\": $fa-var-money-from-bracket,\n  \"money-simple-from-bracket\": $fa-var-money-simple-from-bracket,\n  \"monitor-waveform\": $fa-var-monitor-waveform,\n  \"monitor-heart-rate\": $fa-var-monitor-heart-rate,\n  \"monkey\": $fa-var-monkey,\n  \"monument\": $fa-var-monument,\n  \"moon\": $fa-var-moon,\n  \"moon-cloud\": $fa-var-moon-cloud,\n  \"moon-over-sun\": $fa-var-moon-over-sun,\n  \"eclipse-alt\": $fa-var-eclipse-alt,\n  \"moon-stars\": $fa-var-moon-stars,\n  \"moped\": $fa-var-moped,\n  \"mortar-pestle\": $fa-var-mortar-pestle,\n  \"mosque\": $fa-var-mosque,\n  \"motorcycle\": $fa-var-motorcycle,\n  \"mountain\": $fa-var-mountain,\n  \"mountains\": $fa-var-mountains,\n  \"mp3-player\": $fa-var-mp3-player,\n  \"mug\": $fa-var-mug,\n  \"mug-hot\": $fa-var-mug-hot,\n  \"mug-marshmallows\": $fa-var-mug-marshmallows,\n  \"mug-saucer\": $fa-var-mug-saucer,\n  \"coffee\": $fa-var-coffee,\n  \"mug-tea\": $fa-var-mug-tea,\n  \"mug-tea-saucer\": $fa-var-mug-tea-saucer,\n  \"mushroom\": $fa-var-mushroom,\n  \"music\": $fa-var-music,\n  \"music-note\": $fa-var-music-note,\n  \"music-alt\": $fa-var-music-alt,\n  \"music-note-slash\": $fa-var-music-note-slash,\n  \"music-alt-slash\": $fa-var-music-alt-slash,\n  \"music-slash\": $fa-var-music-slash,\n  \"n\": $fa-var-n,\n  \"naira-sign\": $fa-var-naira-sign,\n  \"narwhal\": $fa-var-narwhal,\n  \"nesting-dolls\": $fa-var-nesting-dolls,\n  \"network-wired\": $fa-var-network-wired,\n  \"neuter\": $fa-var-neuter,\n  \"newspaper\": $fa-var-newspaper,\n  \"nfc\": $fa-var-nfc,\n  \"nfc-lock\": $fa-var-nfc-lock,\n  \"nfc-magnifying-glass\": $fa-var-nfc-magnifying-glass,\n  \"nfc-pen\": $fa-var-nfc-pen,\n  \"nfc-signal\": $fa-var-nfc-signal,\n  \"nfc-slash\": $fa-var-nfc-slash,\n  \"nfc-trash\": $fa-var-nfc-trash,\n  \"not-equal\": $fa-var-not-equal,\n  \"notdef\": $fa-var-notdef,\n  \"note\": $fa-var-note,\n  \"note-medical\": $fa-var-note-medical,\n  \"note-sticky\": $fa-var-note-sticky,\n  \"sticky-note\": $fa-var-sticky-note,\n  \"notebook\": $fa-var-notebook,\n  \"notes\": $fa-var-notes,\n  \"notes-medical\": $fa-var-notes-medical,\n  \"o\": $fa-var-o,\n  \"object-group\": $fa-var-object-group,\n  \"object-ungroup\": $fa-var-object-ungroup,\n  \"objects-align-bottom\": $fa-var-objects-align-bottom,\n  \"objects-align-center-horizontal\": $fa-var-objects-align-center-horizontal,\n  \"objects-align-center-vertical\": $fa-var-objects-align-center-vertical,\n  \"objects-align-left\": $fa-var-objects-align-left,\n  \"objects-align-right\": $fa-var-objects-align-right,\n  \"objects-align-top\": $fa-var-objects-align-top,\n  \"objects-column\": $fa-var-objects-column,\n  \"octagon\": $fa-var-octagon,\n  \"octagon-check\": $fa-var-octagon-check,\n  \"octagon-divide\": $fa-var-octagon-divide,\n  \"octagon-exclamation\": $fa-var-octagon-exclamation,\n  \"octagon-minus\": $fa-var-octagon-minus,\n  \"minus-octagon\": $fa-var-minus-octagon,\n  \"octagon-plus\": $fa-var-octagon-plus,\n  \"plus-octagon\": $fa-var-plus-octagon,\n  \"octagon-xmark\": $fa-var-octagon-xmark,\n  \"times-octagon\": $fa-var-times-octagon,\n  \"xmark-octagon\": $fa-var-xmark-octagon,\n  \"oil-can\": $fa-var-oil-can,\n  \"oil-can-drip\": $fa-var-oil-can-drip,\n  \"oil-temperature\": $fa-var-oil-temperature,\n  \"oil-temp\": $fa-var-oil-temp,\n  \"olive\": $fa-var-olive,\n  \"olive-branch\": $fa-var-olive-branch,\n  \"om\": $fa-var-om,\n  \"omega\": $fa-var-omega,\n  \"onion\": $fa-var-onion,\n  \"option\": $fa-var-option,\n  \"ornament\": $fa-var-ornament,\n  \"otter\": $fa-var-otter,\n  \"outdent\": $fa-var-outdent,\n  \"dedent\": $fa-var-dedent,\n  \"outlet\": $fa-var-outlet,\n  \"oven\": $fa-var-oven,\n  \"overline\": $fa-var-overline,\n  \"p\": $fa-var-p,\n  \"page\": $fa-var-page,\n  \"page-caret-down\": $fa-var-page-caret-down,\n  \"file-caret-down\": $fa-var-file-caret-down,\n  \"page-caret-up\": $fa-var-page-caret-up,\n  \"file-caret-up\": $fa-var-file-caret-up,\n  \"pager\": $fa-var-pager,\n  \"paint-brush\": $fa-var-paint-brush,\n  \"paint-brush-fine\": $fa-var-paint-brush-fine,\n  \"paint-brush-alt\": $fa-var-paint-brush-alt,\n  \"paint-roller\": $fa-var-paint-roller,\n  \"paintbrush-pencil\": $fa-var-paintbrush-pencil,\n  \"palette\": $fa-var-palette,\n  \"pallet\": $fa-var-pallet,\n  \"pallet-box\": $fa-var-pallet-box,\n  \"pallet-boxes\": $fa-var-pallet-boxes,\n  \"palette-boxes\": $fa-var-palette-boxes,\n  \"pallet-alt\": $fa-var-pallet-alt,\n  \"pan-food\": $fa-var-pan-food,\n  \"pan-frying\": $fa-var-pan-frying,\n  \"pancakes\": $fa-var-pancakes,\n  \"panel-ews\": $fa-var-panel-ews,\n  \"panel-fire\": $fa-var-panel-fire,\n  \"panorama\": $fa-var-panorama,\n  \"paper-plane\": $fa-var-paper-plane,\n  \"paper-plane-top\": $fa-var-paper-plane-top,\n  \"paper-plane-alt\": $fa-var-paper-plane-alt,\n  \"send\": $fa-var-send,\n  \"paperclip\": $fa-var-paperclip,\n  \"paperclip-vertical\": $fa-var-paperclip-vertical,\n  \"parachute-box\": $fa-var-parachute-box,\n  \"paragraph\": $fa-var-paragraph,\n  \"paragraph-left\": $fa-var-paragraph-left,\n  \"paragraph-rtl\": $fa-var-paragraph-rtl,\n  \"party-bell\": $fa-var-party-bell,\n  \"party-horn\": $fa-var-party-horn,\n  \"passport\": $fa-var-passport,\n  \"paste\": $fa-var-paste,\n  \"file-clipboard\": $fa-var-file-clipboard,\n  \"pause\": $fa-var-pause,\n  \"paw\": $fa-var-paw,\n  \"paw-claws\": $fa-var-paw-claws,\n  \"paw-simple\": $fa-var-paw-simple,\n  \"paw-alt\": $fa-var-paw-alt,\n  \"peace\": $fa-var-peace,\n  \"peach\": $fa-var-peach,\n  \"peanut\": $fa-var-peanut,\n  \"peanuts\": $fa-var-peanuts,\n  \"peapod\": $fa-var-peapod,\n  \"pear\": $fa-var-pear,\n  \"pedestal\": $fa-var-pedestal,\n  \"pegasus\": $fa-var-pegasus,\n  \"pen\": $fa-var-pen,\n  \"pen-circle\": $fa-var-pen-circle,\n  \"pen-clip\": $fa-var-pen-clip,\n  \"pen-alt\": $fa-var-pen-alt,\n  \"pen-clip-slash\": $fa-var-pen-clip-slash,\n  \"pen-alt-slash\": $fa-var-pen-alt-slash,\n  \"pen-fancy\": $fa-var-pen-fancy,\n  \"pen-fancy-slash\": $fa-var-pen-fancy-slash,\n  \"pen-field\": $fa-var-pen-field,\n  \"pen-line\": $fa-var-pen-line,\n  \"pen-nib\": $fa-var-pen-nib,\n  \"pen-paintbrush\": $fa-var-pen-paintbrush,\n  \"pencil-paintbrush\": $fa-var-pencil-paintbrush,\n  \"pen-ruler\": $fa-var-pen-ruler,\n  \"pencil-ruler\": $fa-var-pencil-ruler,\n  \"pen-slash\": $fa-var-pen-slash,\n  \"pen-swirl\": $fa-var-pen-swirl,\n  \"pen-to-square\": $fa-var-pen-to-square,\n  \"edit\": $fa-var-edit,\n  \"pencil\": $fa-var-pencil,\n  \"pencil-alt\": $fa-var-pencil-alt,\n  \"pencil-slash\": $fa-var-pencil-slash,\n  \"people\": $fa-var-people,\n  \"people-arrows-left-right\": $fa-var-people-arrows-left-right,\n  \"people-arrows\": $fa-var-people-arrows,\n  \"people-carry-box\": $fa-var-people-carry-box,\n  \"people-carry\": $fa-var-people-carry,\n  \"people-dress\": $fa-var-people-dress,\n  \"people-dress-simple\": $fa-var-people-dress-simple,\n  \"people-pants\": $fa-var-people-pants,\n  \"people-pants-simple\": $fa-var-people-pants-simple,\n  \"people-simple\": $fa-var-people-simple,\n  \"pepper\": $fa-var-pepper,\n  \"pepper-hot\": $fa-var-pepper-hot,\n  \"percent\": $fa-var-percent,\n  \"percentage\": $fa-var-percentage,\n  \"period\": $fa-var-period,\n  \"person\": $fa-var-person,\n  \"male\": $fa-var-male,\n  \"person-biking\": $fa-var-person-biking,\n  \"biking\": $fa-var-biking,\n  \"person-biking-mountain\": $fa-var-person-biking-mountain,\n  \"biking-mountain\": $fa-var-biking-mountain,\n  \"person-booth\": $fa-var-person-booth,\n  \"person-carry-box\": $fa-var-person-carry-box,\n  \"person-carry\": $fa-var-person-carry,\n  \"person-digging\": $fa-var-person-digging,\n  \"digging\": $fa-var-digging,\n  \"person-dolly\": $fa-var-person-dolly,\n  \"person-dolly-empty\": $fa-var-person-dolly-empty,\n  \"person-dots-from-line\": $fa-var-person-dots-from-line,\n  \"diagnoses\": $fa-var-diagnoses,\n  \"person-dress\": $fa-var-person-dress,\n  \"female\": $fa-var-female,\n  \"person-dress-simple\": $fa-var-person-dress-simple,\n  \"person-from-portal\": $fa-var-person-from-portal,\n  \"portal-exit\": $fa-var-portal-exit,\n  \"person-hiking\": $fa-var-person-hiking,\n  \"hiking\": $fa-var-hiking,\n  \"person-pinball\": $fa-var-person-pinball,\n  \"person-praying\": $fa-var-person-praying,\n  \"pray\": $fa-var-pray,\n  \"person-pregnant\": $fa-var-person-pregnant,\n  \"person-running\": $fa-var-person-running,\n  \"running\": $fa-var-running,\n  \"person-seat\": $fa-var-person-seat,\n  \"person-seat-reclined\": $fa-var-person-seat-reclined,\n  \"person-sign\": $fa-var-person-sign,\n  \"person-simple\": $fa-var-person-simple,\n  \"person-skating\": $fa-var-person-skating,\n  \"skating\": $fa-var-skating,\n  \"person-ski-jumping\": $fa-var-person-ski-jumping,\n  \"ski-jump\": $fa-var-ski-jump,\n  \"person-ski-lift\": $fa-var-person-ski-lift,\n  \"ski-lift\": $fa-var-ski-lift,\n  \"person-skiing\": $fa-var-person-skiing,\n  \"skiing\": $fa-var-skiing,\n  \"person-skiing-nordic\": $fa-var-person-skiing-nordic,\n  \"skiing-nordic\": $fa-var-skiing-nordic,\n  \"person-sledding\": $fa-var-person-sledding,\n  \"sledding\": $fa-var-sledding,\n  \"person-snowboarding\": $fa-var-person-snowboarding,\n  \"snowboarding\": $fa-var-snowboarding,\n  \"person-snowmobiling\": $fa-var-person-snowmobiling,\n  \"snowmobile\": $fa-var-snowmobile,\n  \"person-swimming\": $fa-var-person-swimming,\n  \"swimmer\": $fa-var-swimmer,\n  \"person-to-door\": $fa-var-person-to-door,\n  \"person-to-portal\": $fa-var-person-to-portal,\n  \"portal-enter\": $fa-var-portal-enter,\n  \"person-walking\": $fa-var-person-walking,\n  \"walking\": $fa-var-walking,\n  \"person-walking-with-cane\": $fa-var-person-walking-with-cane,\n  \"blind\": $fa-var-blind,\n  \"peseta-sign\": $fa-var-peseta-sign,\n  \"peso-sign\": $fa-var-peso-sign,\n  \"phone\": $fa-var-phone,\n  \"phone-arrow-down-left\": $fa-var-phone-arrow-down-left,\n  \"phone-arrow-down\": $fa-var-phone-arrow-down,\n  \"phone-incoming\": $fa-var-phone-incoming,\n  \"phone-arrow-up-right\": $fa-var-phone-arrow-up-right,\n  \"phone-arrow-up\": $fa-var-phone-arrow-up,\n  \"phone-outgoing\": $fa-var-phone-outgoing,\n  \"phone-flip\": $fa-var-phone-flip,\n  \"phone-alt\": $fa-var-phone-alt,\n  \"phone-hangup\": $fa-var-phone-hangup,\n  \"phone-intercom\": $fa-var-phone-intercom,\n  \"phone-missed\": $fa-var-phone-missed,\n  \"phone-office\": $fa-var-phone-office,\n  \"phone-plus\": $fa-var-phone-plus,\n  \"phone-rotary\": $fa-var-phone-rotary,\n  \"phone-slash\": $fa-var-phone-slash,\n  \"phone-volume\": $fa-var-phone-volume,\n  \"volume-control-phone\": $fa-var-volume-control-phone,\n  \"phone-xmark\": $fa-var-phone-xmark,\n  \"photo-film\": $fa-var-photo-film,\n  \"photo-video\": $fa-var-photo-video,\n  \"photo-film-music\": $fa-var-photo-film-music,\n  \"pi\": $fa-var-pi,\n  \"piano\": $fa-var-piano,\n  \"piano-keyboard\": $fa-var-piano-keyboard,\n  \"pickleball\": $fa-var-pickleball,\n  \"pie\": $fa-var-pie,\n  \"pig\": $fa-var-pig,\n  \"piggy-bank\": $fa-var-piggy-bank,\n  \"pills\": $fa-var-pills,\n  \"pinata\": $fa-var-pinata,\n  \"pinball\": $fa-var-pinball,\n  \"pineapple\": $fa-var-pineapple,\n  \"pipe\": $fa-var-pipe,\n  \"pipe-circle-check\": $fa-var-pipe-circle-check,\n  \"pipe-collar\": $fa-var-pipe-collar,\n  \"pipe-section\": $fa-var-pipe-section,\n  \"pipe-smoking\": $fa-var-pipe-smoking,\n  \"pipe-valve\": $fa-var-pipe-valve,\n  \"pizza\": $fa-var-pizza,\n  \"pizza-slice\": $fa-var-pizza-slice,\n  \"place-of-worship\": $fa-var-place-of-worship,\n  \"plane\": $fa-var-plane,\n  \"plane-arrival\": $fa-var-plane-arrival,\n  \"plane-departure\": $fa-var-plane-departure,\n  \"plane-engines\": $fa-var-plane-engines,\n  \"plane-alt\": $fa-var-plane-alt,\n  \"plane-prop\": $fa-var-plane-prop,\n  \"plane-slash\": $fa-var-plane-slash,\n  \"plane-tail\": $fa-var-plane-tail,\n  \"plane-up\": $fa-var-plane-up,\n  \"plane-up-slash\": $fa-var-plane-up-slash,\n  \"planet-moon\": $fa-var-planet-moon,\n  \"planet-ringed\": $fa-var-planet-ringed,\n  \"plate-utensils\": $fa-var-plate-utensils,\n  \"play\": $fa-var-play,\n  \"play-pause\": $fa-var-play-pause,\n  \"plug\": $fa-var-plug,\n  \"plus\": $fa-var-plus,\n  \"add\": $fa-var-add,\n  \"plus-minus\": $fa-var-plus-minus,\n  \"podcast\": $fa-var-podcast,\n  \"podium\": $fa-var-podium,\n  \"podium-star\": $fa-var-podium-star,\n  \"police-box\": $fa-var-police-box,\n  \"poll-people\": $fa-var-poll-people,\n  \"pompebled\": $fa-var-pompebled,\n  \"poo\": $fa-var-poo,\n  \"poo-storm\": $fa-var-poo-storm,\n  \"poo-bolt\": $fa-var-poo-bolt,\n  \"pool-8-ball\": $fa-var-pool-8-ball,\n  \"poop\": $fa-var-poop,\n  \"popcorn\": $fa-var-popcorn,\n  \"popsicle\": $fa-var-popsicle,\n  \"pot-food\": $fa-var-pot-food,\n  \"potato\": $fa-var-potato,\n  \"power-off\": $fa-var-power-off,\n  \"prescription\": $fa-var-prescription,\n  \"prescription-bottle\": $fa-var-prescription-bottle,\n  \"prescription-bottle-medical\": $fa-var-prescription-bottle-medical,\n  \"prescription-bottle-alt\": $fa-var-prescription-bottle-alt,\n  \"presentation-screen\": $fa-var-presentation-screen,\n  \"presentation\": $fa-var-presentation,\n  \"pretzel\": $fa-var-pretzel,\n  \"print\": $fa-var-print,\n  \"print-magnifying-glass\": $fa-var-print-magnifying-glass,\n  \"print-search\": $fa-var-print-search,\n  \"print-slash\": $fa-var-print-slash,\n  \"projector\": $fa-var-projector,\n  \"pump\": $fa-var-pump,\n  \"pump-medical\": $fa-var-pump-medical,\n  \"pump-soap\": $fa-var-pump-soap,\n  \"pumpkin\": $fa-var-pumpkin,\n  \"puzzle\": $fa-var-puzzle,\n  \"puzzle-piece\": $fa-var-puzzle-piece,\n  \"puzzle-piece-simple\": $fa-var-puzzle-piece-simple,\n  \"puzzle-piece-alt\": $fa-var-puzzle-piece-alt,\n  \"q\": $fa-var-q,\n  \"qrcode\": $fa-var-qrcode,\n  \"question\": $fa-var-question,\n  \"quidditch\": $fa-var-quidditch,\n  \"broom-ball\": $fa-var-broom-ball,\n  \"quidditch-broom-ball\": $fa-var-quidditch-broom-ball,\n  \"quote-left\": $fa-var-quote-left,\n  \"quote-left-alt\": $fa-var-quote-left-alt,\n  \"quote-right\": $fa-var-quote-right,\n  \"quote-right-alt\": $fa-var-quote-right-alt,\n  \"quotes\": $fa-var-quotes,\n  \"r\": $fa-var-r,\n  \"rabbit\": $fa-var-rabbit,\n  \"rabbit-running\": $fa-var-rabbit-running,\n  \"rabbit-fast\": $fa-var-rabbit-fast,\n  \"racquet\": $fa-var-racquet,\n  \"radar\": $fa-var-radar,\n  \"radiation\": $fa-var-radiation,\n  \"radio\": $fa-var-radio,\n  \"radio-tuner\": $fa-var-radio-tuner,\n  \"radio-alt\": $fa-var-radio-alt,\n  \"rainbow\": $fa-var-rainbow,\n  \"raindrops\": $fa-var-raindrops,\n  \"ram\": $fa-var-ram,\n  \"ramp-loading\": $fa-var-ramp-loading,\n  \"raygun\": $fa-var-raygun,\n  \"receipt\": $fa-var-receipt,\n  \"record-vinyl\": $fa-var-record-vinyl,\n  \"rectangle\": $fa-var-rectangle,\n  \"rectangle-landscape\": $fa-var-rectangle-landscape,\n  \"rectangle-ad\": $fa-var-rectangle-ad,\n  \"ad\": $fa-var-ad,\n  \"rectangle-barcode\": $fa-var-rectangle-barcode,\n  \"barcode-alt\": $fa-var-barcode-alt,\n  \"rectangle-code\": $fa-var-rectangle-code,\n  \"rectangle-list\": $fa-var-rectangle-list,\n  \"list-alt\": $fa-var-list-alt,\n  \"rectangle-pro\": $fa-var-rectangle-pro,\n  \"pro\": $fa-var-pro,\n  \"rectangle-terminal\": $fa-var-rectangle-terminal,\n  \"rectangle-vertical\": $fa-var-rectangle-vertical,\n  \"rectangle-portrait\": $fa-var-rectangle-portrait,\n  \"rectangle-vertical-history\": $fa-var-rectangle-vertical-history,\n  \"rectangle-wide\": $fa-var-rectangle-wide,\n  \"rectangle-xmark\": $fa-var-rectangle-xmark,\n  \"rectangle-times\": $fa-var-rectangle-times,\n  \"times-rectangle\": $fa-var-times-rectangle,\n  \"window-close\": $fa-var-window-close,\n  \"rectangles-mixed\": $fa-var-rectangles-mixed,\n  \"recycle\": $fa-var-recycle,\n  \"reel\": $fa-var-reel,\n  \"refrigerator\": $fa-var-refrigerator,\n  \"registered\": $fa-var-registered,\n  \"repeat\": $fa-var-repeat,\n  \"repeat-1\": $fa-var-repeat-1,\n  \"reply\": $fa-var-reply,\n  \"mail-reply\": $fa-var-mail-reply,\n  \"reply-all\": $fa-var-reply-all,\n  \"mail-reply-all\": $fa-var-mail-reply-all,\n  \"reply-clock\": $fa-var-reply-clock,\n  \"reply-time\": $fa-var-reply-time,\n  \"republican\": $fa-var-republican,\n  \"restroom\": $fa-var-restroom,\n  \"restroom-simple\": $fa-var-restroom-simple,\n  \"retweet\": $fa-var-retweet,\n  \"rhombus\": $fa-var-rhombus,\n  \"ribbon\": $fa-var-ribbon,\n  \"right\": $fa-var-right,\n  \"arrow-alt-right\": $fa-var-arrow-alt-right,\n  \"right-from-bracket\": $fa-var-right-from-bracket,\n  \"sign-out-alt\": $fa-var-sign-out-alt,\n  \"right-from-line\": $fa-var-right-from-line,\n  \"arrow-alt-from-left\": $fa-var-arrow-alt-from-left,\n  \"right-left\": $fa-var-right-left,\n  \"exchange-alt\": $fa-var-exchange-alt,\n  \"right-long\": $fa-var-right-long,\n  \"long-arrow-alt-right\": $fa-var-long-arrow-alt-right,\n  \"right-long-to-line\": $fa-var-right-long-to-line,\n  \"right-to-bracket\": $fa-var-right-to-bracket,\n  \"sign-in-alt\": $fa-var-sign-in-alt,\n  \"right-to-line\": $fa-var-right-to-line,\n  \"arrow-alt-to-right\": $fa-var-arrow-alt-to-right,\n  \"ring\": $fa-var-ring,\n  \"rings-wedding\": $fa-var-rings-wedding,\n  \"road\": $fa-var-road,\n  \"robot\": $fa-var-robot,\n  \"robot-astromech\": $fa-var-robot-astromech,\n  \"rocket\": $fa-var-rocket,\n  \"rocket-launch\": $fa-var-rocket-launch,\n  \"roller-coaster\": $fa-var-roller-coaster,\n  \"rotate\": $fa-var-rotate,\n  \"sync-alt\": $fa-var-sync-alt,\n  \"rotate-exclamation\": $fa-var-rotate-exclamation,\n  \"rotate-left\": $fa-var-rotate-left,\n  \"rotate-back\": $fa-var-rotate-back,\n  \"rotate-backward\": $fa-var-rotate-backward,\n  \"undo-alt\": $fa-var-undo-alt,\n  \"rotate-right\": $fa-var-rotate-right,\n  \"redo-alt\": $fa-var-redo-alt,\n  \"rotate-forward\": $fa-var-rotate-forward,\n  \"route\": $fa-var-route,\n  \"route-highway\": $fa-var-route-highway,\n  \"route-interstate\": $fa-var-route-interstate,\n  \"router\": $fa-var-router,\n  \"rss\": $fa-var-rss,\n  \"feed\": $fa-var-feed,\n  \"ruble-sign\": $fa-var-ruble-sign,\n  \"rouble\": $fa-var-rouble,\n  \"rub\": $fa-var-rub,\n  \"ruble\": $fa-var-ruble,\n  \"rugby-ball\": $fa-var-rugby-ball,\n  \"ruler\": $fa-var-ruler,\n  \"ruler-combined\": $fa-var-ruler-combined,\n  \"ruler-horizontal\": $fa-var-ruler-horizontal,\n  \"ruler-triangle\": $fa-var-ruler-triangle,\n  \"ruler-vertical\": $fa-var-ruler-vertical,\n  \"rupee-sign\": $fa-var-rupee-sign,\n  \"rupee\": $fa-var-rupee,\n  \"rupiah-sign\": $fa-var-rupiah-sign,\n  \"rv\": $fa-var-rv,\n  \"s\": $fa-var-s,\n  \"sack\": $fa-var-sack,\n  \"sack-dollar\": $fa-var-sack-dollar,\n  \"sailboat\": $fa-var-sailboat,\n  \"salad\": $fa-var-salad,\n  \"bowl-salad\": $fa-var-bowl-salad,\n  \"salt-shaker\": $fa-var-salt-shaker,\n  \"sandwich\": $fa-var-sandwich,\n  \"satellite\": $fa-var-satellite,\n  \"satellite-dish\": $fa-var-satellite-dish,\n  \"sausage\": $fa-var-sausage,\n  \"saxophone\": $fa-var-saxophone,\n  \"saxophone-fire\": $fa-var-saxophone-fire,\n  \"sax-hot\": $fa-var-sax-hot,\n  \"scale-balanced\": $fa-var-scale-balanced,\n  \"balance-scale\": $fa-var-balance-scale,\n  \"scale-unbalanced\": $fa-var-scale-unbalanced,\n  \"balance-scale-left\": $fa-var-balance-scale-left,\n  \"scale-unbalanced-flip\": $fa-var-scale-unbalanced-flip,\n  \"balance-scale-right\": $fa-var-balance-scale-right,\n  \"scalpel\": $fa-var-scalpel,\n  \"scalpel-line-dashed\": $fa-var-scalpel-line-dashed,\n  \"scalpel-path\": $fa-var-scalpel-path,\n  \"scanner\": $fa-var-scanner,\n  \"scanner-image\": $fa-var-scanner-image,\n  \"scanner-gun\": $fa-var-scanner-gun,\n  \"scanner-keyboard\": $fa-var-scanner-keyboard,\n  \"scanner-touchscreen\": $fa-var-scanner-touchscreen,\n  \"scarecrow\": $fa-var-scarecrow,\n  \"scarf\": $fa-var-scarf,\n  \"school\": $fa-var-school,\n  \"scissors\": $fa-var-scissors,\n  \"cut\": $fa-var-cut,\n  \"screen-users\": $fa-var-screen-users,\n  \"users-class\": $fa-var-users-class,\n  \"screencast\": $fa-var-screencast,\n  \"screwdriver\": $fa-var-screwdriver,\n  \"screwdriver-wrench\": $fa-var-screwdriver-wrench,\n  \"tools\": $fa-var-tools,\n  \"scribble\": $fa-var-scribble,\n  \"scroll\": $fa-var-scroll,\n  \"scroll-old\": $fa-var-scroll-old,\n  \"scroll-torah\": $fa-var-scroll-torah,\n  \"torah\": $fa-var-torah,\n  \"scrubber\": $fa-var-scrubber,\n  \"scythe\": $fa-var-scythe,\n  \"sd-card\": $fa-var-sd-card,\n  \"sd-cards\": $fa-var-sd-cards,\n  \"seal\": $fa-var-seal,\n  \"seal-exclamation\": $fa-var-seal-exclamation,\n  \"seal-question\": $fa-var-seal-question,\n  \"seat-airline\": $fa-var-seat-airline,\n  \"section\": $fa-var-section,\n  \"seedling\": $fa-var-seedling,\n  \"sprout\": $fa-var-sprout,\n  \"semicolon\": $fa-var-semicolon,\n  \"send-back\": $fa-var-send-back,\n  \"send-backward\": $fa-var-send-backward,\n  \"sensor\": $fa-var-sensor,\n  \"sensor-cloud\": $fa-var-sensor-cloud,\n  \"sensor-smoke\": $fa-var-sensor-smoke,\n  \"sensor-fire\": $fa-var-sensor-fire,\n  \"sensor-on\": $fa-var-sensor-on,\n  \"sensor-triangle-exclamation\": $fa-var-sensor-triangle-exclamation,\n  \"sensor-alert\": $fa-var-sensor-alert,\n  \"server\": $fa-var-server,\n  \"shapes\": $fa-var-shapes,\n  \"triangle-circle-square\": $fa-var-triangle-circle-square,\n  \"share\": $fa-var-share,\n  \"arrow-turn-right\": $fa-var-arrow-turn-right,\n  \"mail-forward\": $fa-var-mail-forward,\n  \"share-all\": $fa-var-share-all,\n  \"arrows-turn-right\": $fa-var-arrows-turn-right,\n  \"share-from-square\": $fa-var-share-from-square,\n  \"share-square\": $fa-var-share-square,\n  \"share-nodes\": $fa-var-share-nodes,\n  \"share-alt\": $fa-var-share-alt,\n  \"sheep\": $fa-var-sheep,\n  \"shekel-sign\": $fa-var-shekel-sign,\n  \"ils\": $fa-var-ils,\n  \"shekel\": $fa-var-shekel,\n  \"sheqel\": $fa-var-sheqel,\n  \"sheqel-sign\": $fa-var-sheqel-sign,\n  \"shelves\": $fa-var-shelves,\n  \"inventory\": $fa-var-inventory,\n  \"shelves-empty\": $fa-var-shelves-empty,\n  \"shield\": $fa-var-shield,\n  \"shield-blank\": $fa-var-shield-blank,\n  \"shield-alt\": $fa-var-shield-alt,\n  \"shield-check\": $fa-var-shield-check,\n  \"shield-cross\": $fa-var-shield-cross,\n  \"shield-exclamation\": $fa-var-shield-exclamation,\n  \"shield-keyhole\": $fa-var-shield-keyhole,\n  \"shield-minus\": $fa-var-shield-minus,\n  \"shield-plus\": $fa-var-shield-plus,\n  \"shield-slash\": $fa-var-shield-slash,\n  \"shield-virus\": $fa-var-shield-virus,\n  \"shield-xmark\": $fa-var-shield-xmark,\n  \"shield-times\": $fa-var-shield-times,\n  \"ship\": $fa-var-ship,\n  \"shirt\": $fa-var-shirt,\n  \"t-shirt\": $fa-var-t-shirt,\n  \"tshirt\": $fa-var-tshirt,\n  \"shirt-long-sleeve\": $fa-var-shirt-long-sleeve,\n  \"shirt-running\": $fa-var-shirt-running,\n  \"shirt-tank-top\": $fa-var-shirt-tank-top,\n  \"shish-kebab\": $fa-var-shish-kebab,\n  \"shoe-prints\": $fa-var-shoe-prints,\n  \"shop\": $fa-var-shop,\n  \"store-alt\": $fa-var-store-alt,\n  \"shop-slash\": $fa-var-shop-slash,\n  \"store-alt-slash\": $fa-var-store-alt-slash,\n  \"shovel\": $fa-var-shovel,\n  \"shovel-snow\": $fa-var-shovel-snow,\n  \"shower\": $fa-var-shower,\n  \"shower-down\": $fa-var-shower-down,\n  \"shower-alt\": $fa-var-shower-alt,\n  \"shredder\": $fa-var-shredder,\n  \"shrimp\": $fa-var-shrimp,\n  \"shuffle\": $fa-var-shuffle,\n  \"random\": $fa-var-random,\n  \"shutters\": $fa-var-shutters,\n  \"shuttle-space\": $fa-var-shuttle-space,\n  \"space-shuttle\": $fa-var-space-shuttle,\n  \"shuttlecock\": $fa-var-shuttlecock,\n  \"sickle\": $fa-var-sickle,\n  \"sidebar\": $fa-var-sidebar,\n  \"sidebar-flip\": $fa-var-sidebar-flip,\n  \"sigma\": $fa-var-sigma,\n  \"sign-hanging\": $fa-var-sign-hanging,\n  \"sign\": $fa-var-sign,\n  \"signal\": $fa-var-signal,\n  \"signal-5\": $fa-var-signal-5,\n  \"signal-perfect\": $fa-var-signal-perfect,\n  \"signal-bars\": $fa-var-signal-bars,\n  \"signal-alt\": $fa-var-signal-alt,\n  \"signal-alt-4\": $fa-var-signal-alt-4,\n  \"signal-bars-strong\": $fa-var-signal-bars-strong,\n  \"signal-bars-fair\": $fa-var-signal-bars-fair,\n  \"signal-alt-2\": $fa-var-signal-alt-2,\n  \"signal-bars-good\": $fa-var-signal-bars-good,\n  \"signal-alt-3\": $fa-var-signal-alt-3,\n  \"signal-bars-slash\": $fa-var-signal-bars-slash,\n  \"signal-alt-slash\": $fa-var-signal-alt-slash,\n  \"signal-bars-weak\": $fa-var-signal-bars-weak,\n  \"signal-alt-1\": $fa-var-signal-alt-1,\n  \"signal-fair\": $fa-var-signal-fair,\n  \"signal-2\": $fa-var-signal-2,\n  \"signal-good\": $fa-var-signal-good,\n  \"signal-3\": $fa-var-signal-3,\n  \"signal-slash\": $fa-var-signal-slash,\n  \"signal-stream\": $fa-var-signal-stream,\n  \"signal-stream-slash\": $fa-var-signal-stream-slash,\n  \"signal-strong\": $fa-var-signal-strong,\n  \"signal-4\": $fa-var-signal-4,\n  \"signal-weak\": $fa-var-signal-weak,\n  \"signal-1\": $fa-var-signal-1,\n  \"signature\": $fa-var-signature,\n  \"signature-lock\": $fa-var-signature-lock,\n  \"signature-slash\": $fa-var-signature-slash,\n  \"signs-post\": $fa-var-signs-post,\n  \"map-signs\": $fa-var-map-signs,\n  \"sim-card\": $fa-var-sim-card,\n  \"sim-cards\": $fa-var-sim-cards,\n  \"sink\": $fa-var-sink,\n  \"siren\": $fa-var-siren,\n  \"siren-on\": $fa-var-siren-on,\n  \"sitemap\": $fa-var-sitemap,\n  \"skeleton\": $fa-var-skeleton,\n  \"ski-boot\": $fa-var-ski-boot,\n  \"ski-boot-ski\": $fa-var-ski-boot-ski,\n  \"skull\": $fa-var-skull,\n  \"skull-cow\": $fa-var-skull-cow,\n  \"skull-crossbones\": $fa-var-skull-crossbones,\n  \"slash\": $fa-var-slash,\n  \"slash-back\": $fa-var-slash-back,\n  \"slash-forward\": $fa-var-slash-forward,\n  \"sleigh\": $fa-var-sleigh,\n  \"slider\": $fa-var-slider,\n  \"sliders\": $fa-var-sliders,\n  \"sliders-h\": $fa-var-sliders-h,\n  \"sliders-simple\": $fa-var-sliders-simple,\n  \"sliders-up\": $fa-var-sliders-up,\n  \"sliders-v\": $fa-var-sliders-v,\n  \"slot-machine\": $fa-var-slot-machine,\n  \"smog\": $fa-var-smog,\n  \"smoke\": $fa-var-smoke,\n  \"smoking\": $fa-var-smoking,\n  \"snake\": $fa-var-snake,\n  \"snooze\": $fa-var-snooze,\n  \"zzz\": $fa-var-zzz,\n  \"snow-blowing\": $fa-var-snow-blowing,\n  \"snowflake\": $fa-var-snowflake,\n  \"snowflakes\": $fa-var-snowflakes,\n  \"snowman\": $fa-var-snowman,\n  \"snowman-head\": $fa-var-snowman-head,\n  \"frosty-head\": $fa-var-frosty-head,\n  \"snowplow\": $fa-var-snowplow,\n  \"soap\": $fa-var-soap,\n  \"socks\": $fa-var-socks,\n  \"solar-panel\": $fa-var-solar-panel,\n  \"solar-system\": $fa-var-solar-system,\n  \"sort\": $fa-var-sort,\n  \"unsorted\": $fa-var-unsorted,\n  \"sort-down\": $fa-var-sort-down,\n  \"sort-desc\": $fa-var-sort-desc,\n  \"sort-up\": $fa-var-sort-up,\n  \"sort-asc\": $fa-var-sort-asc,\n  \"spa\": $fa-var-spa,\n  \"space-station-moon\": $fa-var-space-station-moon,\n  \"space-station-moon-construction\": $fa-var-space-station-moon-construction,\n  \"space-station-moon-alt\": $fa-var-space-station-moon-alt,\n  \"spade\": $fa-var-spade,\n  \"spaghetti-monster-flying\": $fa-var-spaghetti-monster-flying,\n  \"pastafarianism\": $fa-var-pastafarianism,\n  \"sparkles\": $fa-var-sparkles,\n  \"speaker\": $fa-var-speaker,\n  \"speakers\": $fa-var-speakers,\n  \"spell-check\": $fa-var-spell-check,\n  \"spider\": $fa-var-spider,\n  \"spider-black-widow\": $fa-var-spider-black-widow,\n  \"spider-web\": $fa-var-spider-web,\n  \"spinner\": $fa-var-spinner,\n  \"spinner-third\": $fa-var-spinner-third,\n  \"split\": $fa-var-split,\n  \"splotch\": $fa-var-splotch,\n  \"spoon\": $fa-var-spoon,\n  \"utensil-spoon\": $fa-var-utensil-spoon,\n  \"sportsball\": $fa-var-sportsball,\n  \"spray-can\": $fa-var-spray-can,\n  \"spray-can-sparkles\": $fa-var-spray-can-sparkles,\n  \"air-freshener\": $fa-var-air-freshener,\n  \"sprinkler\": $fa-var-sprinkler,\n  \"sprinkler-ceiling\": $fa-var-sprinkler-ceiling,\n  \"square\": $fa-var-square,\n  \"square-0\": $fa-var-square-0,\n  \"square-1\": $fa-var-square-1,\n  \"square-2\": $fa-var-square-2,\n  \"square-3\": $fa-var-square-3,\n  \"square-4\": $fa-var-square-4,\n  \"square-5\": $fa-var-square-5,\n  \"square-6\": $fa-var-square-6,\n  \"square-7\": $fa-var-square-7,\n  \"square-8\": $fa-var-square-8,\n  \"square-9\": $fa-var-square-9,\n  \"square-a\": $fa-var-square-a,\n  \"square-a-lock\": $fa-var-square-a-lock,\n  \"square-ampersand\": $fa-var-square-ampersand,\n  \"square-arrow-down\": $fa-var-square-arrow-down,\n  \"arrow-square-down\": $fa-var-arrow-square-down,\n  \"square-arrow-down-left\": $fa-var-square-arrow-down-left,\n  \"square-arrow-down-right\": $fa-var-square-arrow-down-right,\n  \"square-arrow-left\": $fa-var-square-arrow-left,\n  \"arrow-square-left\": $fa-var-arrow-square-left,\n  \"square-arrow-right\": $fa-var-square-arrow-right,\n  \"arrow-square-right\": $fa-var-arrow-square-right,\n  \"square-arrow-up\": $fa-var-square-arrow-up,\n  \"arrow-square-up\": $fa-var-arrow-square-up,\n  \"square-arrow-up-left\": $fa-var-square-arrow-up-left,\n  \"square-arrow-up-right\": $fa-var-square-arrow-up-right,\n  \"external-link-square\": $fa-var-external-link-square,\n  \"square-b\": $fa-var-square-b,\n  \"square-bolt\": $fa-var-square-bolt,\n  \"square-c\": $fa-var-square-c,\n  \"square-caret-down\": $fa-var-square-caret-down,\n  \"caret-square-down\": $fa-var-caret-square-down,\n  \"square-caret-left\": $fa-var-square-caret-left,\n  \"caret-square-left\": $fa-var-caret-square-left,\n  \"square-caret-right\": $fa-var-square-caret-right,\n  \"caret-square-right\": $fa-var-caret-square-right,\n  \"square-caret-up\": $fa-var-square-caret-up,\n  \"caret-square-up\": $fa-var-caret-square-up,\n  \"square-check\": $fa-var-square-check,\n  \"check-square\": $fa-var-check-square,\n  \"square-chevron-down\": $fa-var-square-chevron-down,\n  \"chevron-square-down\": $fa-var-chevron-square-down,\n  \"square-chevron-left\": $fa-var-square-chevron-left,\n  \"chevron-square-left\": $fa-var-chevron-square-left,\n  \"square-chevron-right\": $fa-var-square-chevron-right,\n  \"chevron-square-right\": $fa-var-chevron-square-right,\n  \"square-chevron-up\": $fa-var-square-chevron-up,\n  \"chevron-square-up\": $fa-var-chevron-square-up,\n  \"square-code\": $fa-var-square-code,\n  \"square-d\": $fa-var-square-d,\n  \"square-dashed\": $fa-var-square-dashed,\n  \"square-divide\": $fa-var-square-divide,\n  \"square-dollar\": $fa-var-square-dollar,\n  \"dollar-square\": $fa-var-dollar-square,\n  \"usd-square\": $fa-var-usd-square,\n  \"square-down\": $fa-var-square-down,\n  \"arrow-alt-square-down\": $fa-var-arrow-alt-square-down,\n  \"square-down-left\": $fa-var-square-down-left,\n  \"square-down-right\": $fa-var-square-down-right,\n  \"square-e\": $fa-var-square-e,\n  \"square-ellipsis\": $fa-var-square-ellipsis,\n  \"square-ellipsis-vertical\": $fa-var-square-ellipsis-vertical,\n  \"square-envelope\": $fa-var-square-envelope,\n  \"envelope-square\": $fa-var-envelope-square,\n  \"square-exclamation\": $fa-var-square-exclamation,\n  \"exclamation-square\": $fa-var-exclamation-square,\n  \"square-f\": $fa-var-square-f,\n  \"square-fragile\": $fa-var-square-fragile,\n  \"box-fragile\": $fa-var-box-fragile,\n  \"square-wine-glass-crack\": $fa-var-square-wine-glass-crack,\n  \"square-full\": $fa-var-square-full,\n  \"square-g\": $fa-var-square-g,\n  \"square-h\": $fa-var-square-h,\n  \"h-square\": $fa-var-h-square,\n  \"square-heart\": $fa-var-square-heart,\n  \"heart-square\": $fa-var-heart-square,\n  \"square-i\": $fa-var-square-i,\n  \"square-info\": $fa-var-square-info,\n  \"info-square\": $fa-var-info-square,\n  \"square-j\": $fa-var-square-j,\n  \"square-k\": $fa-var-square-k,\n  \"square-l\": $fa-var-square-l,\n  \"square-left\": $fa-var-square-left,\n  \"arrow-alt-square-left\": $fa-var-arrow-alt-square-left,\n  \"square-m\": $fa-var-square-m,\n  \"square-minus\": $fa-var-square-minus,\n  \"minus-square\": $fa-var-minus-square,\n  \"square-n\": $fa-var-square-n,\n  \"square-o\": $fa-var-square-o,\n  \"square-p\": $fa-var-square-p,\n  \"square-parking\": $fa-var-square-parking,\n  \"parking\": $fa-var-parking,\n  \"square-parking-slash\": $fa-var-square-parking-slash,\n  \"parking-slash\": $fa-var-parking-slash,\n  \"square-pen\": $fa-var-square-pen,\n  \"pen-square\": $fa-var-pen-square,\n  \"pencil-square\": $fa-var-pencil-square,\n  \"square-phone\": $fa-var-square-phone,\n  \"phone-square\": $fa-var-phone-square,\n  \"square-phone-flip\": $fa-var-square-phone-flip,\n  \"phone-square-alt\": $fa-var-phone-square-alt,\n  \"square-phone-hangup\": $fa-var-square-phone-hangup,\n  \"phone-square-down\": $fa-var-phone-square-down,\n  \"square-plus\": $fa-var-square-plus,\n  \"plus-square\": $fa-var-plus-square,\n  \"square-poll-horizontal\": $fa-var-square-poll-horizontal,\n  \"poll-h\": $fa-var-poll-h,\n  \"square-poll-vertical\": $fa-var-square-poll-vertical,\n  \"poll\": $fa-var-poll,\n  \"square-q\": $fa-var-square-q,\n  \"square-quarters\": $fa-var-square-quarters,\n  \"square-question\": $fa-var-square-question,\n  \"question-square\": $fa-var-question-square,\n  \"square-quote\": $fa-var-square-quote,\n  \"square-r\": $fa-var-square-r,\n  \"square-right\": $fa-var-square-right,\n  \"arrow-alt-square-right\": $fa-var-arrow-alt-square-right,\n  \"square-ring\": $fa-var-square-ring,\n  \"square-root\": $fa-var-square-root,\n  \"square-root-variable\": $fa-var-square-root-variable,\n  \"square-root-alt\": $fa-var-square-root-alt,\n  \"square-rss\": $fa-var-square-rss,\n  \"rss-square\": $fa-var-rss-square,\n  \"square-s\": $fa-var-square-s,\n  \"square-share-nodes\": $fa-var-square-share-nodes,\n  \"share-alt-square\": $fa-var-share-alt-square,\n  \"square-sliders\": $fa-var-square-sliders,\n  \"sliders-h-square\": $fa-var-sliders-h-square,\n  \"square-sliders-vertical\": $fa-var-square-sliders-vertical,\n  \"sliders-v-square\": $fa-var-sliders-v-square,\n  \"square-small\": $fa-var-square-small,\n  \"square-star\": $fa-var-square-star,\n  \"square-t\": $fa-var-square-t,\n  \"square-terminal\": $fa-var-square-terminal,\n  \"square-this-way-up\": $fa-var-square-this-way-up,\n  \"box-up\": $fa-var-box-up,\n  \"square-u\": $fa-var-square-u,\n  \"square-up\": $fa-var-square-up,\n  \"arrow-alt-square-up\": $fa-var-arrow-alt-square-up,\n  \"square-up-left\": $fa-var-square-up-left,\n  \"square-up-right\": $fa-var-square-up-right,\n  \"external-link-square-alt\": $fa-var-external-link-square-alt,\n  \"square-user\": $fa-var-square-user,\n  \"square-v\": $fa-var-square-v,\n  \"square-w\": $fa-var-square-w,\n  \"square-x\": $fa-var-square-x,\n  \"square-xmark\": $fa-var-square-xmark,\n  \"times-square\": $fa-var-times-square,\n  \"xmark-square\": $fa-var-xmark-square,\n  \"square-y\": $fa-var-square-y,\n  \"square-z\": $fa-var-square-z,\n  \"squid\": $fa-var-squid,\n  \"squirrel\": $fa-var-squirrel,\n  \"staff\": $fa-var-staff,\n  \"stairs\": $fa-var-stairs,\n  \"stamp\": $fa-var-stamp,\n  \"standard-definition\": $fa-var-standard-definition,\n  \"rectangle-sd\": $fa-var-rectangle-sd,\n  \"star\": $fa-var-star,\n  \"star-and-crescent\": $fa-var-star-and-crescent,\n  \"star-christmas\": $fa-var-star-christmas,\n  \"star-exclamation\": $fa-var-star-exclamation,\n  \"star-half\": $fa-var-star-half,\n  \"star-half-stroke\": $fa-var-star-half-stroke,\n  \"star-half-alt\": $fa-var-star-half-alt,\n  \"star-of-david\": $fa-var-star-of-david,\n  \"star-of-life\": $fa-var-star-of-life,\n  \"star-sharp\": $fa-var-star-sharp,\n  \"star-sharp-half\": $fa-var-star-sharp-half,\n  \"star-sharp-half-stroke\": $fa-var-star-sharp-half-stroke,\n  \"star-sharp-half-alt\": $fa-var-star-sharp-half-alt,\n  \"star-shooting\": $fa-var-star-shooting,\n  \"starfighter\": $fa-var-starfighter,\n  \"starfighter-twin-ion-engine\": $fa-var-starfighter-twin-ion-engine,\n  \"starfighter-alt\": $fa-var-starfighter-alt,\n  \"starfighter-twin-ion-engine-advanced\": $fa-var-starfighter-twin-ion-engine-advanced,\n  \"starfighter-alt-advanced\": $fa-var-starfighter-alt-advanced,\n  \"stars\": $fa-var-stars,\n  \"starship\": $fa-var-starship,\n  \"starship-freighter\": $fa-var-starship-freighter,\n  \"steak\": $fa-var-steak,\n  \"steering-wheel\": $fa-var-steering-wheel,\n  \"sterling-sign\": $fa-var-sterling-sign,\n  \"gbp\": $fa-var-gbp,\n  \"pound-sign\": $fa-var-pound-sign,\n  \"stethoscope\": $fa-var-stethoscope,\n  \"stocking\": $fa-var-stocking,\n  \"stomach\": $fa-var-stomach,\n  \"stop\": $fa-var-stop,\n  \"stopwatch\": $fa-var-stopwatch,\n  \"stopwatch-20\": $fa-var-stopwatch-20,\n  \"store\": $fa-var-store,\n  \"store-slash\": $fa-var-store-slash,\n  \"strawberry\": $fa-var-strawberry,\n  \"street-view\": $fa-var-street-view,\n  \"stretcher\": $fa-var-stretcher,\n  \"strikethrough\": $fa-var-strikethrough,\n  \"stroopwafel\": $fa-var-stroopwafel,\n  \"subscript\": $fa-var-subscript,\n  \"suitcase\": $fa-var-suitcase,\n  \"suitcase-medical\": $fa-var-suitcase-medical,\n  \"medkit\": $fa-var-medkit,\n  \"suitcase-rolling\": $fa-var-suitcase-rolling,\n  \"sun\": $fa-var-sun,\n  \"sun-bright\": $fa-var-sun-bright,\n  \"sun-alt\": $fa-var-sun-alt,\n  \"sun-cloud\": $fa-var-sun-cloud,\n  \"sun-dust\": $fa-var-sun-dust,\n  \"sun-haze\": $fa-var-sun-haze,\n  \"sunglasses\": $fa-var-sunglasses,\n  \"sunrise\": $fa-var-sunrise,\n  \"sunset\": $fa-var-sunset,\n  \"superscript\": $fa-var-superscript,\n  \"swatchbook\": $fa-var-swatchbook,\n  \"sword\": $fa-var-sword,\n  \"sword-laser\": $fa-var-sword-laser,\n  \"sword-laser-alt\": $fa-var-sword-laser-alt,\n  \"swords\": $fa-var-swords,\n  \"swords-laser\": $fa-var-swords-laser,\n  \"symbols\": $fa-var-symbols,\n  \"icons-alt\": $fa-var-icons-alt,\n  \"synagogue\": $fa-var-synagogue,\n  \"syringe\": $fa-var-syringe,\n  \"t\": $fa-var-t,\n  \"table\": $fa-var-table,\n  \"table-cells\": $fa-var-table-cells,\n  \"th\": $fa-var-th,\n  \"table-cells-large\": $fa-var-table-cells-large,\n  \"th-large\": $fa-var-th-large,\n  \"table-columns\": $fa-var-table-columns,\n  \"columns\": $fa-var-columns,\n  \"table-layout\": $fa-var-table-layout,\n  \"table-list\": $fa-var-table-list,\n  \"th-list\": $fa-var-th-list,\n  \"table-picnic\": $fa-var-table-picnic,\n  \"table-pivot\": $fa-var-table-pivot,\n  \"table-rows\": $fa-var-table-rows,\n  \"rows\": $fa-var-rows,\n  \"table-tennis-paddle-ball\": $fa-var-table-tennis-paddle-ball,\n  \"ping-pong-paddle-ball\": $fa-var-ping-pong-paddle-ball,\n  \"table-tennis\": $fa-var-table-tennis,\n  \"table-tree\": $fa-var-table-tree,\n  \"tablet\": $fa-var-tablet,\n  \"tablet-android\": $fa-var-tablet-android,\n  \"tablet-button\": $fa-var-tablet-button,\n  \"tablet-rugged\": $fa-var-tablet-rugged,\n  \"tablet-screen\": $fa-var-tablet-screen,\n  \"tablet-android-alt\": $fa-var-tablet-android-alt,\n  \"tablet-screen-button\": $fa-var-tablet-screen-button,\n  \"tablet-alt\": $fa-var-tablet-alt,\n  \"tablets\": $fa-var-tablets,\n  \"tachograph-digital\": $fa-var-tachograph-digital,\n  \"digital-tachograph\": $fa-var-digital-tachograph,\n  \"taco\": $fa-var-taco,\n  \"tag\": $fa-var-tag,\n  \"tags\": $fa-var-tags,\n  \"tally\": $fa-var-tally,\n  \"tally-5\": $fa-var-tally-5,\n  \"tally-1\": $fa-var-tally-1,\n  \"tally-2\": $fa-var-tally-2,\n  \"tally-3\": $fa-var-tally-3,\n  \"tally-4\": $fa-var-tally-4,\n  \"tamale\": $fa-var-tamale,\n  \"tank-water\": $fa-var-tank-water,\n  \"tape\": $fa-var-tape,\n  \"taxi\": $fa-var-taxi,\n  \"cab\": $fa-var-cab,\n  \"taxi-bus\": $fa-var-taxi-bus,\n  \"teddy-bear\": $fa-var-teddy-bear,\n  \"teeth\": $fa-var-teeth,\n  \"teeth-open\": $fa-var-teeth-open,\n  \"telescope\": $fa-var-telescope,\n  \"temperature-arrow-down\": $fa-var-temperature-arrow-down,\n  \"temperature-down\": $fa-var-temperature-down,\n  \"temperature-arrow-up\": $fa-var-temperature-arrow-up,\n  \"temperature-up\": $fa-var-temperature-up,\n  \"temperature-empty\": $fa-var-temperature-empty,\n  \"temperature-0\": $fa-var-temperature-0,\n  \"thermometer-0\": $fa-var-thermometer-0,\n  \"thermometer-empty\": $fa-var-thermometer-empty,\n  \"temperature-full\": $fa-var-temperature-full,\n  \"temperature-4\": $fa-var-temperature-4,\n  \"thermometer-4\": $fa-var-thermometer-4,\n  \"thermometer-full\": $fa-var-thermometer-full,\n  \"temperature-half\": $fa-var-temperature-half,\n  \"temperature-2\": $fa-var-temperature-2,\n  \"thermometer-2\": $fa-var-thermometer-2,\n  \"thermometer-half\": $fa-var-thermometer-half,\n  \"temperature-high\": $fa-var-temperature-high,\n  \"temperature-list\": $fa-var-temperature-list,\n  \"temperature-low\": $fa-var-temperature-low,\n  \"temperature-quarter\": $fa-var-temperature-quarter,\n  \"temperature-1\": $fa-var-temperature-1,\n  \"thermometer-1\": $fa-var-thermometer-1,\n  \"thermometer-quarter\": $fa-var-thermometer-quarter,\n  \"temperature-snow\": $fa-var-temperature-snow,\n  \"temperature-frigid\": $fa-var-temperature-frigid,\n  \"temperature-sun\": $fa-var-temperature-sun,\n  \"temperature-hot\": $fa-var-temperature-hot,\n  \"temperature-three-quarters\": $fa-var-temperature-three-quarters,\n  \"temperature-3\": $fa-var-temperature-3,\n  \"thermometer-3\": $fa-var-thermometer-3,\n  \"thermometer-three-quarters\": $fa-var-thermometer-three-quarters,\n  \"tenge-sign\": $fa-var-tenge-sign,\n  \"tenge\": $fa-var-tenge,\n  \"tennis-ball\": $fa-var-tennis-ball,\n  \"terminal\": $fa-var-terminal,\n  \"text\": $fa-var-text,\n  \"text-height\": $fa-var-text-height,\n  \"text-size\": $fa-var-text-size,\n  \"text-slash\": $fa-var-text-slash,\n  \"remove-format\": $fa-var-remove-format,\n  \"text-width\": $fa-var-text-width,\n  \"thermometer\": $fa-var-thermometer,\n  \"theta\": $fa-var-theta,\n  \"thought-bubble\": $fa-var-thought-bubble,\n  \"thumbs-down\": $fa-var-thumbs-down,\n  \"thumbs-up\": $fa-var-thumbs-up,\n  \"thumbtack\": $fa-var-thumbtack,\n  \"thumb-tack\": $fa-var-thumb-tack,\n  \"tick\": $fa-var-tick,\n  \"ticket\": $fa-var-ticket,\n  \"ticket-airline\": $fa-var-ticket-airline,\n  \"ticket-simple\": $fa-var-ticket-simple,\n  \"ticket-alt\": $fa-var-ticket-alt,\n  \"tickets-airline\": $fa-var-tickets-airline,\n  \"tilde\": $fa-var-tilde,\n  \"timeline\": $fa-var-timeline,\n  \"timeline-arrow\": $fa-var-timeline-arrow,\n  \"timer\": $fa-var-timer,\n  \"tire\": $fa-var-tire,\n  \"tire-flat\": $fa-var-tire-flat,\n  \"tire-pressure-warning\": $fa-var-tire-pressure-warning,\n  \"tire-rugged\": $fa-var-tire-rugged,\n  \"toggle-off\": $fa-var-toggle-off,\n  \"toggle-on\": $fa-var-toggle-on,\n  \"toilet\": $fa-var-toilet,\n  \"toilet-paper\": $fa-var-toilet-paper,\n  \"toilet-paper-blank\": $fa-var-toilet-paper-blank,\n  \"toilet-paper-alt\": $fa-var-toilet-paper-alt,\n  \"toilet-paper-blank-under\": $fa-var-toilet-paper-blank-under,\n  \"toilet-paper-reverse-alt\": $fa-var-toilet-paper-reverse-alt,\n  \"toilet-paper-slash\": $fa-var-toilet-paper-slash,\n  \"toilet-paper-under\": $fa-var-toilet-paper-under,\n  \"toilet-paper-reverse\": $fa-var-toilet-paper-reverse,\n  \"toilet-paper-under-slash\": $fa-var-toilet-paper-under-slash,\n  \"toilet-paper-reverse-slash\": $fa-var-toilet-paper-reverse-slash,\n  \"tomato\": $fa-var-tomato,\n  \"tombstone\": $fa-var-tombstone,\n  \"tombstone-blank\": $fa-var-tombstone-blank,\n  \"tombstone-alt\": $fa-var-tombstone-alt,\n  \"toolbox\": $fa-var-toolbox,\n  \"tooth\": $fa-var-tooth,\n  \"toothbrush\": $fa-var-toothbrush,\n  \"torii-gate\": $fa-var-torii-gate,\n  \"tornado\": $fa-var-tornado,\n  \"tower-broadcast\": $fa-var-tower-broadcast,\n  \"broadcast-tower\": $fa-var-broadcast-tower,\n  \"tower-control\": $fa-var-tower-control,\n  \"tractor\": $fa-var-tractor,\n  \"trademark\": $fa-var-trademark,\n  \"traffic-cone\": $fa-var-traffic-cone,\n  \"traffic-light\": $fa-var-traffic-light,\n  \"traffic-light-go\": $fa-var-traffic-light-go,\n  \"traffic-light-slow\": $fa-var-traffic-light-slow,\n  \"traffic-light-stop\": $fa-var-traffic-light-stop,\n  \"trailer\": $fa-var-trailer,\n  \"train\": $fa-var-train,\n  \"train-subway\": $fa-var-train-subway,\n  \"subway\": $fa-var-subway,\n  \"train-subway-tunnel\": $fa-var-train-subway-tunnel,\n  \"subway-tunnel\": $fa-var-subway-tunnel,\n  \"train-track\": $fa-var-train-track,\n  \"train-tram\": $fa-var-train-tram,\n  \"tram\": $fa-var-tram,\n  \"train-tunnel\": $fa-var-train-tunnel,\n  \"transformer-bolt\": $fa-var-transformer-bolt,\n  \"transgender\": $fa-var-transgender,\n  \"transgender-alt\": $fa-var-transgender-alt,\n  \"transporter\": $fa-var-transporter,\n  \"transporter-1\": $fa-var-transporter-1,\n  \"transporter-2\": $fa-var-transporter-2,\n  \"transporter-3\": $fa-var-transporter-3,\n  \"transporter-4\": $fa-var-transporter-4,\n  \"transporter-5\": $fa-var-transporter-5,\n  \"transporter-6\": $fa-var-transporter-6,\n  \"transporter-7\": $fa-var-transporter-7,\n  \"transporter-empty\": $fa-var-transporter-empty,\n  \"trash\": $fa-var-trash,\n  \"trash-arrow-up\": $fa-var-trash-arrow-up,\n  \"trash-restore\": $fa-var-trash-restore,\n  \"trash-can\": $fa-var-trash-can,\n  \"trash-alt\": $fa-var-trash-alt,\n  \"trash-can-arrow-up\": $fa-var-trash-can-arrow-up,\n  \"trash-restore-alt\": $fa-var-trash-restore-alt,\n  \"trash-can-check\": $fa-var-trash-can-check,\n  \"trash-can-clock\": $fa-var-trash-can-clock,\n  \"trash-can-list\": $fa-var-trash-can-list,\n  \"trash-can-plus\": $fa-var-trash-can-plus,\n  \"trash-can-slash\": $fa-var-trash-can-slash,\n  \"trash-alt-slash\": $fa-var-trash-alt-slash,\n  \"trash-can-undo\": $fa-var-trash-can-undo,\n  \"trash-can-arrow-turn-left\": $fa-var-trash-can-arrow-turn-left,\n  \"trash-undo-alt\": $fa-var-trash-undo-alt,\n  \"trash-can-xmark\": $fa-var-trash-can-xmark,\n  \"trash-check\": $fa-var-trash-check,\n  \"trash-clock\": $fa-var-trash-clock,\n  \"trash-list\": $fa-var-trash-list,\n  \"trash-plus\": $fa-var-trash-plus,\n  \"trash-slash\": $fa-var-trash-slash,\n  \"trash-undo\": $fa-var-trash-undo,\n  \"trash-arrow-turn-left\": $fa-var-trash-arrow-turn-left,\n  \"trash-xmark\": $fa-var-trash-xmark,\n  \"treasure-chest\": $fa-var-treasure-chest,\n  \"tree\": $fa-var-tree,\n  \"tree-christmas\": $fa-var-tree-christmas,\n  \"tree-deciduous\": $fa-var-tree-deciduous,\n  \"tree-alt\": $fa-var-tree-alt,\n  \"tree-decorated\": $fa-var-tree-decorated,\n  \"tree-large\": $fa-var-tree-large,\n  \"tree-palm\": $fa-var-tree-palm,\n  \"trees\": $fa-var-trees,\n  \"triangle\": $fa-var-triangle,\n  \"triangle-exclamation\": $fa-var-triangle-exclamation,\n  \"exclamation-triangle\": $fa-var-exclamation-triangle,\n  \"warning\": $fa-var-warning,\n  \"triangle-instrument\": $fa-var-triangle-instrument,\n  \"triangle-music\": $fa-var-triangle-music,\n  \"triangle-person-digging\": $fa-var-triangle-person-digging,\n  \"construction\": $fa-var-construction,\n  \"trophy\": $fa-var-trophy,\n  \"trophy-star\": $fa-var-trophy-star,\n  \"trophy-alt\": $fa-var-trophy-alt,\n  \"truck\": $fa-var-truck,\n  \"truck-bolt\": $fa-var-truck-bolt,\n  \"truck-clock\": $fa-var-truck-clock,\n  \"shipping-timed\": $fa-var-shipping-timed,\n  \"truck-container\": $fa-var-truck-container,\n  \"truck-container-empty\": $fa-var-truck-container-empty,\n  \"truck-fast\": $fa-var-truck-fast,\n  \"shipping-fast\": $fa-var-shipping-fast,\n  \"truck-flatbed\": $fa-var-truck-flatbed,\n  \"truck-front\": $fa-var-truck-front,\n  \"truck-medical\": $fa-var-truck-medical,\n  \"ambulance\": $fa-var-ambulance,\n  \"truck-monster\": $fa-var-truck-monster,\n  \"truck-moving\": $fa-var-truck-moving,\n  \"truck-pickup\": $fa-var-truck-pickup,\n  \"truck-plow\": $fa-var-truck-plow,\n  \"truck-ramp\": $fa-var-truck-ramp,\n  \"truck-ramp-box\": $fa-var-truck-ramp-box,\n  \"truck-loading\": $fa-var-truck-loading,\n  \"truck-ramp-couch\": $fa-var-truck-ramp-couch,\n  \"truck-couch\": $fa-var-truck-couch,\n  \"truck-tow\": $fa-var-truck-tow,\n  \"trumpet\": $fa-var-trumpet,\n  \"tty\": $fa-var-tty,\n  \"teletype\": $fa-var-teletype,\n  \"tty-answer\": $fa-var-tty-answer,\n  \"teletype-answer\": $fa-var-teletype-answer,\n  \"tugrik-sign\": $fa-var-tugrik-sign,\n  \"turkey\": $fa-var-turkey,\n  \"turkish-lira-sign\": $fa-var-turkish-lira-sign,\n  \"try\": $fa-var-try,\n  \"turkish-lira\": $fa-var-turkish-lira,\n  \"turn-down\": $fa-var-turn-down,\n  \"level-down-alt\": $fa-var-level-down-alt,\n  \"turn-down-left\": $fa-var-turn-down-left,\n  \"turn-down-right\": $fa-var-turn-down-right,\n  \"turn-up\": $fa-var-turn-up,\n  \"level-up-alt\": $fa-var-level-up-alt,\n  \"turntable\": $fa-var-turntable,\n  \"turtle\": $fa-var-turtle,\n  \"tv\": $fa-var-tv,\n  \"television\": $fa-var-television,\n  \"tv-alt\": $fa-var-tv-alt,\n  \"tv-music\": $fa-var-tv-music,\n  \"tv-retro\": $fa-var-tv-retro,\n  \"typewriter\": $fa-var-typewriter,\n  \"u\": $fa-var-u,\n  \"ufo\": $fa-var-ufo,\n  \"ufo-beam\": $fa-var-ufo-beam,\n  \"umbrella\": $fa-var-umbrella,\n  \"umbrella-beach\": $fa-var-umbrella-beach,\n  \"umbrella-simple\": $fa-var-umbrella-simple,\n  \"umbrella-alt\": $fa-var-umbrella-alt,\n  \"underline\": $fa-var-underline,\n  \"unicorn\": $fa-var-unicorn,\n  \"uniform-martial-arts\": $fa-var-uniform-martial-arts,\n  \"union\": $fa-var-union,\n  \"universal-access\": $fa-var-universal-access,\n  \"unlock\": $fa-var-unlock,\n  \"unlock-keyhole\": $fa-var-unlock-keyhole,\n  \"unlock-alt\": $fa-var-unlock-alt,\n  \"up\": $fa-var-up,\n  \"arrow-alt-up\": $fa-var-arrow-alt-up,\n  \"up-down\": $fa-var-up-down,\n  \"arrows-alt-v\": $fa-var-arrows-alt-v,\n  \"up-down-left-right\": $fa-var-up-down-left-right,\n  \"arrows-alt\": $fa-var-arrows-alt,\n  \"up-from-dotted-line\": $fa-var-up-from-dotted-line,\n  \"up-from-line\": $fa-var-up-from-line,\n  \"arrow-alt-from-bottom\": $fa-var-arrow-alt-from-bottom,\n  \"up-left\": $fa-var-up-left,\n  \"up-long\": $fa-var-up-long,\n  \"long-arrow-alt-up\": $fa-var-long-arrow-alt-up,\n  \"up-right\": $fa-var-up-right,\n  \"up-right-and-down-left-from-center\": $fa-var-up-right-and-down-left-from-center,\n  \"expand-alt\": $fa-var-expand-alt,\n  \"up-right-from-square\": $fa-var-up-right-from-square,\n  \"external-link-alt\": $fa-var-external-link-alt,\n  \"up-to-dotted-line\": $fa-var-up-to-dotted-line,\n  \"up-to-line\": $fa-var-up-to-line,\n  \"arrow-alt-to-top\": $fa-var-arrow-alt-to-top,\n  \"upload\": $fa-var-upload,\n  \"usb-drive\": $fa-var-usb-drive,\n  \"user\": $fa-var-user,\n  \"user-alien\": $fa-var-user-alien,\n  \"user-astronaut\": $fa-var-user-astronaut,\n  \"user-bounty-hunter\": $fa-var-user-bounty-hunter,\n  \"user-check\": $fa-var-user-check,\n  \"user-chef\": $fa-var-user-chef,\n  \"user-clock\": $fa-var-user-clock,\n  \"user-cowboy\": $fa-var-user-cowboy,\n  \"user-crown\": $fa-var-user-crown,\n  \"user-doctor\": $fa-var-user-doctor,\n  \"user-md\": $fa-var-user-md,\n  \"user-doctor-hair\": $fa-var-user-doctor-hair,\n  \"user-doctor-hair-long\": $fa-var-user-doctor-hair-long,\n  \"user-doctor-message\": $fa-var-user-doctor-message,\n  \"user-md-chat\": $fa-var-user-md-chat,\n  \"user-gear\": $fa-var-user-gear,\n  \"user-cog\": $fa-var-user-cog,\n  \"user-graduate\": $fa-var-user-graduate,\n  \"user-group\": $fa-var-user-group,\n  \"user-friends\": $fa-var-user-friends,\n  \"user-group-crown\": $fa-var-user-group-crown,\n  \"users-crown\": $fa-var-users-crown,\n  \"user-hair\": $fa-var-user-hair,\n  \"user-hair-buns\": $fa-var-user-hair-buns,\n  \"user-hair-long\": $fa-var-user-hair-long,\n  \"user-hair-mullet\": $fa-var-user-hair-mullet,\n  \"business-front\": $fa-var-business-front,\n  \"party-back\": $fa-var-party-back,\n  \"trian-balbot\": $fa-var-trian-balbot,\n  \"user-headset\": $fa-var-user-headset,\n  \"user-helmet-safety\": $fa-var-user-helmet-safety,\n  \"user-construction\": $fa-var-user-construction,\n  \"user-hard-hat\": $fa-var-user-hard-hat,\n  \"user-injured\": $fa-var-user-injured,\n  \"user-large\": $fa-var-user-large,\n  \"user-alt\": $fa-var-user-alt,\n  \"user-large-slash\": $fa-var-user-large-slash,\n  \"user-alt-slash\": $fa-var-user-alt-slash,\n  \"user-lock\": $fa-var-user-lock,\n  \"user-minus\": $fa-var-user-minus,\n  \"user-music\": $fa-var-user-music,\n  \"user-ninja\": $fa-var-user-ninja,\n  \"user-nurse\": $fa-var-user-nurse,\n  \"user-nurse-hair\": $fa-var-user-nurse-hair,\n  \"user-nurse-hair-long\": $fa-var-user-nurse-hair-long,\n  \"user-pen\": $fa-var-user-pen,\n  \"user-edit\": $fa-var-user-edit,\n  \"user-pilot\": $fa-var-user-pilot,\n  \"user-pilot-tie\": $fa-var-user-pilot-tie,\n  \"user-plus\": $fa-var-user-plus,\n  \"user-police\": $fa-var-user-police,\n  \"user-police-tie\": $fa-var-user-police-tie,\n  \"user-robot\": $fa-var-user-robot,\n  \"user-secret\": $fa-var-user-secret,\n  \"user-shakespeare\": $fa-var-user-shakespeare,\n  \"user-shield\": $fa-var-user-shield,\n  \"user-slash\": $fa-var-user-slash,\n  \"user-tag\": $fa-var-user-tag,\n  \"user-tie\": $fa-var-user-tie,\n  \"user-tie-hair\": $fa-var-user-tie-hair,\n  \"user-tie-hair-long\": $fa-var-user-tie-hair-long,\n  \"user-unlock\": $fa-var-user-unlock,\n  \"user-visor\": $fa-var-user-visor,\n  \"user-vneck\": $fa-var-user-vneck,\n  \"user-vneck-hair\": $fa-var-user-vneck-hair,\n  \"user-vneck-hair-long\": $fa-var-user-vneck-hair-long,\n  \"user-xmark\": $fa-var-user-xmark,\n  \"user-times\": $fa-var-user-times,\n  \"users\": $fa-var-users,\n  \"group\": $fa-var-group,\n  \"users-gear\": $fa-var-users-gear,\n  \"users-cog\": $fa-var-users-cog,\n  \"users-medical\": $fa-var-users-medical,\n  \"users-slash\": $fa-var-users-slash,\n  \"utensils\": $fa-var-utensils,\n  \"cutlery\": $fa-var-cutlery,\n  \"utensils-slash\": $fa-var-utensils-slash,\n  \"utility-pole\": $fa-var-utility-pole,\n  \"utility-pole-double\": $fa-var-utility-pole-double,\n  \"v\": $fa-var-v,\n  \"vacuum\": $fa-var-vacuum,\n  \"vacuum-robot\": $fa-var-vacuum-robot,\n  \"value-absolute\": $fa-var-value-absolute,\n  \"van-shuttle\": $fa-var-van-shuttle,\n  \"shuttle-van\": $fa-var-shuttle-van,\n  \"vault\": $fa-var-vault,\n  \"vector-circle\": $fa-var-vector-circle,\n  \"vector-polygon\": $fa-var-vector-polygon,\n  \"vector-square\": $fa-var-vector-square,\n  \"vent-damper\": $fa-var-vent-damper,\n  \"venus\": $fa-var-venus,\n  \"venus-double\": $fa-var-venus-double,\n  \"venus-mars\": $fa-var-venus-mars,\n  \"vest\": $fa-var-vest,\n  \"vest-patches\": $fa-var-vest-patches,\n  \"vial\": $fa-var-vial,\n  \"vials\": $fa-var-vials,\n  \"video\": $fa-var-video,\n  \"video-camera\": $fa-var-video-camera,\n  \"video-arrow-down-left\": $fa-var-video-arrow-down-left,\n  \"video-arrow-up-right\": $fa-var-video-arrow-up-right,\n  \"video-plus\": $fa-var-video-plus,\n  \"video-slash\": $fa-var-video-slash,\n  \"vihara\": $fa-var-vihara,\n  \"violin\": $fa-var-violin,\n  \"virus\": $fa-var-virus,\n  \"virus-slash\": $fa-var-virus-slash,\n  \"viruses\": $fa-var-viruses,\n  \"voicemail\": $fa-var-voicemail,\n  \"volcano\": $fa-var-volcano,\n  \"volleyball\": $fa-var-volleyball,\n  \"volleyball-ball\": $fa-var-volleyball-ball,\n  \"volume\": $fa-var-volume,\n  \"volume-medium\": $fa-var-volume-medium,\n  \"volume-high\": $fa-var-volume-high,\n  \"volume-up\": $fa-var-volume-up,\n  \"volume-low\": $fa-var-volume-low,\n  \"volume-down\": $fa-var-volume-down,\n  \"volume-off\": $fa-var-volume-off,\n  \"volume-slash\": $fa-var-volume-slash,\n  \"volume-xmark\": $fa-var-volume-xmark,\n  \"volume-mute\": $fa-var-volume-mute,\n  \"volume-times\": $fa-var-volume-times,\n  \"vr-cardboard\": $fa-var-vr-cardboard,\n  \"w\": $fa-var-w,\n  \"waffle\": $fa-var-waffle,\n  \"wagon-covered\": $fa-var-wagon-covered,\n  \"walker\": $fa-var-walker,\n  \"walkie-talkie\": $fa-var-walkie-talkie,\n  \"wallet\": $fa-var-wallet,\n  \"wand\": $fa-var-wand,\n  \"wand-magic\": $fa-var-wand-magic,\n  \"magic\": $fa-var-magic,\n  \"wand-magic-sparkles\": $fa-var-wand-magic-sparkles,\n  \"magic-wand-sparkles\": $fa-var-magic-wand-sparkles,\n  \"wand-sparkles\": $fa-var-wand-sparkles,\n  \"warehouse\": $fa-var-warehouse,\n  \"warehouse-full\": $fa-var-warehouse-full,\n  \"warehouse-alt\": $fa-var-warehouse-alt,\n  \"washing-machine\": $fa-var-washing-machine,\n  \"washer\": $fa-var-washer,\n  \"watch\": $fa-var-watch,\n  \"watch-apple\": $fa-var-watch-apple,\n  \"watch-calculator\": $fa-var-watch-calculator,\n  \"watch-fitness\": $fa-var-watch-fitness,\n  \"watch-smart\": $fa-var-watch-smart,\n  \"water\": $fa-var-water,\n  \"water-arrow-down\": $fa-var-water-arrow-down,\n  \"water-lower\": $fa-var-water-lower,\n  \"water-arrow-up\": $fa-var-water-arrow-up,\n  \"water-rise\": $fa-var-water-rise,\n  \"water-ladder\": $fa-var-water-ladder,\n  \"ladder-water\": $fa-var-ladder-water,\n  \"swimming-pool\": $fa-var-swimming-pool,\n  \"watermelon-slice\": $fa-var-watermelon-slice,\n  \"wave-pulse\": $fa-var-wave-pulse,\n  \"heart-rate\": $fa-var-heart-rate,\n  \"wave-sine\": $fa-var-wave-sine,\n  \"wave-square\": $fa-var-wave-square,\n  \"wave-triangle\": $fa-var-wave-triangle,\n  \"waveform\": $fa-var-waveform,\n  \"waveform-lines\": $fa-var-waveform-lines,\n  \"weight-hanging\": $fa-var-weight-hanging,\n  \"weight-scale\": $fa-var-weight-scale,\n  \"weight\": $fa-var-weight,\n  \"whale\": $fa-var-whale,\n  \"wheat\": $fa-var-wheat,\n  \"wheat-awn\": $fa-var-wheat-awn,\n  \"wheat-alt\": $fa-var-wheat-alt,\n  \"wheat-awn-slash\": $fa-var-wheat-awn-slash,\n  \"wheat-slash\": $fa-var-wheat-slash,\n  \"wheelchair\": $fa-var-wheelchair,\n  \"wheelchair-move\": $fa-var-wheelchair-move,\n  \"wheelchair-alt\": $fa-var-wheelchair-alt,\n  \"whiskey-glass\": $fa-var-whiskey-glass,\n  \"glass-whiskey\": $fa-var-glass-whiskey,\n  \"whiskey-glass-ice\": $fa-var-whiskey-glass-ice,\n  \"glass-whiskey-rocks\": $fa-var-glass-whiskey-rocks,\n  \"whistle\": $fa-var-whistle,\n  \"wifi\": $fa-var-wifi,\n  \"wifi-3\": $fa-var-wifi-3,\n  \"wifi-strong\": $fa-var-wifi-strong,\n  \"wifi-exclamation\": $fa-var-wifi-exclamation,\n  \"wifi-fair\": $fa-var-wifi-fair,\n  \"wifi-2\": $fa-var-wifi-2,\n  \"wifi-slash\": $fa-var-wifi-slash,\n  \"wifi-weak\": $fa-var-wifi-weak,\n  \"wifi-1\": $fa-var-wifi-1,\n  \"wind\": $fa-var-wind,\n  \"wind-turbine\": $fa-var-wind-turbine,\n  \"wind-warning\": $fa-var-wind-warning,\n  \"wind-circle-exclamation\": $fa-var-wind-circle-exclamation,\n  \"window\": $fa-var-window,\n  \"window-flip\": $fa-var-window-flip,\n  \"window-alt\": $fa-var-window-alt,\n  \"window-frame\": $fa-var-window-frame,\n  \"window-frame-open\": $fa-var-window-frame-open,\n  \"window-maximize\": $fa-var-window-maximize,\n  \"window-minimize\": $fa-var-window-minimize,\n  \"window-restore\": $fa-var-window-restore,\n  \"windsock\": $fa-var-windsock,\n  \"wine-bottle\": $fa-var-wine-bottle,\n  \"wine-glass\": $fa-var-wine-glass,\n  \"wine-glass-crack\": $fa-var-wine-glass-crack,\n  \"fragile\": $fa-var-fragile,\n  \"wine-glass-empty\": $fa-var-wine-glass-empty,\n  \"wine-glass-alt\": $fa-var-wine-glass-alt,\n  \"won-sign\": $fa-var-won-sign,\n  \"krw\": $fa-var-krw,\n  \"won\": $fa-var-won,\n  \"wreath\": $fa-var-wreath,\n  \"wrench\": $fa-var-wrench,\n  \"wrench-simple\": $fa-var-wrench-simple,\n  \"x\": $fa-var-x,\n  \"x-ray\": $fa-var-x-ray,\n  \"xmark\": $fa-var-xmark,\n  \"close\": $fa-var-close,\n  \"multiply\": $fa-var-multiply,\n  \"remove\": $fa-var-remove,\n  \"times\": $fa-var-times,\n  \"xmark-to-slot\": $fa-var-xmark-to-slot,\n  \"times-to-slot\": $fa-var-times-to-slot,\n  \"vote-nay\": $fa-var-vote-nay,\n  \"y\": $fa-var-y,\n  \"yen-sign\": $fa-var-yen-sign,\n  \"cny\": $fa-var-cny,\n  \"jpy\": $fa-var-jpy,\n  \"rmb\": $fa-var-rmb,\n  \"yen\": $fa-var-yen,\n  \"yin-yang\": $fa-var-yin-yang,\n  \"z\": $fa-var-z,\n);\n\n$fa-brand-icons: (\n  \"42-group\": $fa-var-42-group,\n  \"innosoft\": $fa-var-innosoft,\n  \"500px\": $fa-var-500px,\n  \"accessible-icon\": $fa-var-accessible-icon,\n  \"accusoft\": $fa-var-accusoft,\n  \"acquisitions-incorporated\": $fa-var-acquisitions-incorporated,\n  \"adn\": $fa-var-adn,\n  \"adversal\": $fa-var-adversal,\n  \"affiliatetheme\": $fa-var-affiliatetheme,\n  \"airbnb\": $fa-var-airbnb,\n  \"algolia\": $fa-var-algolia,\n  \"alipay\": $fa-var-alipay,\n  \"amazon\": $fa-var-amazon,\n  \"amazon-pay\": $fa-var-amazon-pay,\n  \"amilia\": $fa-var-amilia,\n  \"android\": $fa-var-android,\n  \"angellist\": $fa-var-angellist,\n  \"angrycreative\": $fa-var-angrycreative,\n  \"angular\": $fa-var-angular,\n  \"app-store\": $fa-var-app-store,\n  \"app-store-ios\": $fa-var-app-store-ios,\n  \"apper\": $fa-var-apper,\n  \"apple\": $fa-var-apple,\n  \"apple-pay\": $fa-var-apple-pay,\n  \"artstation\": $fa-var-artstation,\n  \"asymmetrik\": $fa-var-asymmetrik,\n  \"atlassian\": $fa-var-atlassian,\n  \"audible\": $fa-var-audible,\n  \"autoprefixer\": $fa-var-autoprefixer,\n  \"avianex\": $fa-var-avianex,\n  \"aviato\": $fa-var-aviato,\n  \"aws\": $fa-var-aws,\n  \"bandcamp\": $fa-var-bandcamp,\n  \"battle-net\": $fa-var-battle-net,\n  \"behance\": $fa-var-behance,\n  \"behance-square\": $fa-var-behance-square,\n  \"bilibili\": $fa-var-bilibili,\n  \"bimobject\": $fa-var-bimobject,\n  \"bitbucket\": $fa-var-bitbucket,\n  \"bitcoin\": $fa-var-bitcoin,\n  \"bity\": $fa-var-bity,\n  \"black-tie\": $fa-var-black-tie,\n  \"blackberry\": $fa-var-blackberry,\n  \"blogger\": $fa-var-blogger,\n  \"blogger-b\": $fa-var-blogger-b,\n  \"bluetooth\": $fa-var-bluetooth,\n  \"bluetooth-b\": $fa-var-bluetooth-b,\n  \"bootstrap\": $fa-var-bootstrap,\n  \"bots\": $fa-var-bots,\n  \"btc\": $fa-var-btc,\n  \"buffer\": $fa-var-buffer,\n  \"buromobelexperte\": $fa-var-buromobelexperte,\n  \"buy-n-large\": $fa-var-buy-n-large,\n  \"buysellads\": $fa-var-buysellads,\n  \"canadian-maple-leaf\": $fa-var-canadian-maple-leaf,\n  \"cc-amazon-pay\": $fa-var-cc-amazon-pay,\n  \"cc-amex\": $fa-var-cc-amex,\n  \"cc-apple-pay\": $fa-var-cc-apple-pay,\n  \"cc-diners-club\": $fa-var-cc-diners-club,\n  \"cc-discover\": $fa-var-cc-discover,\n  \"cc-jcb\": $fa-var-cc-jcb,\n  \"cc-mastercard\": $fa-var-cc-mastercard,\n  \"cc-paypal\": $fa-var-cc-paypal,\n  \"cc-stripe\": $fa-var-cc-stripe,\n  \"cc-visa\": $fa-var-cc-visa,\n  \"centercode\": $fa-var-centercode,\n  \"centos\": $fa-var-centos,\n  \"chrome\": $fa-var-chrome,\n  \"chromecast\": $fa-var-chromecast,\n  \"cloudflare\": $fa-var-cloudflare,\n  \"cloudscale\": $fa-var-cloudscale,\n  \"cloudsmith\": $fa-var-cloudsmith,\n  \"cloudversify\": $fa-var-cloudversify,\n  \"cmplid\": $fa-var-cmplid,\n  \"codepen\": $fa-var-codepen,\n  \"codiepie\": $fa-var-codiepie,\n  \"confluence\": $fa-var-confluence,\n  \"connectdevelop\": $fa-var-connectdevelop,\n  \"contao\": $fa-var-contao,\n  \"cotton-bureau\": $fa-var-cotton-bureau,\n  \"cpanel\": $fa-var-cpanel,\n  \"creative-commons\": $fa-var-creative-commons,\n  \"creative-commons-by\": $fa-var-creative-commons-by,\n  \"creative-commons-nc\": $fa-var-creative-commons-nc,\n  \"creative-commons-nc-eu\": $fa-var-creative-commons-nc-eu,\n  \"creative-commons-nc-jp\": $fa-var-creative-commons-nc-jp,\n  \"creative-commons-nd\": $fa-var-creative-commons-nd,\n  \"creative-commons-pd\": $fa-var-creative-commons-pd,\n  \"creative-commons-pd-alt\": $fa-var-creative-commons-pd-alt,\n  \"creative-commons-remix\": $fa-var-creative-commons-remix,\n  \"creative-commons-sa\": $fa-var-creative-commons-sa,\n  \"creative-commons-sampling\": $fa-var-creative-commons-sampling,\n  \"creative-commons-sampling-plus\": $fa-var-creative-commons-sampling-plus,\n  \"creative-commons-share\": $fa-var-creative-commons-share,\n  \"creative-commons-zero\": $fa-var-creative-commons-zero,\n  \"critical-role\": $fa-var-critical-role,\n  \"css3\": $fa-var-css3,\n  \"css3-alt\": $fa-var-css3-alt,\n  \"cuttlefish\": $fa-var-cuttlefish,\n  \"d-and-d\": $fa-var-d-and-d,\n  \"d-and-d-beyond\": $fa-var-d-and-d-beyond,\n  \"dailymotion\": $fa-var-dailymotion,\n  \"dashcube\": $fa-var-dashcube,\n  \"deezer\": $fa-var-deezer,\n  \"delicious\": $fa-var-delicious,\n  \"deploydog\": $fa-var-deploydog,\n  \"deskpro\": $fa-var-deskpro,\n  \"dev\": $fa-var-dev,\n  \"deviantart\": $fa-var-deviantart,\n  \"dhl\": $fa-var-dhl,\n  \"diaspora\": $fa-var-diaspora,\n  \"digg\": $fa-var-digg,\n  \"digital-ocean\": $fa-var-digital-ocean,\n  \"discord\": $fa-var-discord,\n  \"discourse\": $fa-var-discourse,\n  \"dochub\": $fa-var-dochub,\n  \"docker\": $fa-var-docker,\n  \"draft2digital\": $fa-var-draft2digital,\n  \"dribbble\": $fa-var-dribbble,\n  \"dribbble-square\": $fa-var-dribbble-square,\n  \"dropbox\": $fa-var-dropbox,\n  \"drupal\": $fa-var-drupal,\n  \"dyalog\": $fa-var-dyalog,\n  \"earlybirds\": $fa-var-earlybirds,\n  \"ebay\": $fa-var-ebay,\n  \"edge\": $fa-var-edge,\n  \"edge-legacy\": $fa-var-edge-legacy,\n  \"elementor\": $fa-var-elementor,\n  \"ello\": $fa-var-ello,\n  \"ember\": $fa-var-ember,\n  \"empire\": $fa-var-empire,\n  \"envira\": $fa-var-envira,\n  \"erlang\": $fa-var-erlang,\n  \"ethereum\": $fa-var-ethereum,\n  \"etsy\": $fa-var-etsy,\n  \"evernote\": $fa-var-evernote,\n  \"expeditedssl\": $fa-var-expeditedssl,\n  \"facebook\": $fa-var-facebook,\n  \"facebook-f\": $fa-var-facebook-f,\n  \"facebook-messenger\": $fa-var-facebook-messenger,\n  \"facebook-square\": $fa-var-facebook-square,\n  \"fantasy-flight-games\": $fa-var-fantasy-flight-games,\n  \"fedex\": $fa-var-fedex,\n  \"fedora\": $fa-var-fedora,\n  \"figma\": $fa-var-figma,\n  \"firefox\": $fa-var-firefox,\n  \"firefox-browser\": $fa-var-firefox-browser,\n  \"first-order\": $fa-var-first-order,\n  \"first-order-alt\": $fa-var-first-order-alt,\n  \"firstdraft\": $fa-var-firstdraft,\n  \"flickr\": $fa-var-flickr,\n  \"flipboard\": $fa-var-flipboard,\n  \"fly\": $fa-var-fly,\n  \"font-awesome\": $fa-var-font-awesome,\n  \"font-awesome-flag\": $fa-var-font-awesome-flag,\n  \"font-awesome-logo-full\": $fa-var-font-awesome-logo-full,\n  \"fonticons\": $fa-var-fonticons,\n  \"fonticons-fi\": $fa-var-fonticons-fi,\n  \"fort-awesome\": $fa-var-fort-awesome,\n  \"fort-awesome-alt\": $fa-var-fort-awesome-alt,\n  \"forumbee\": $fa-var-forumbee,\n  \"foursquare\": $fa-var-foursquare,\n  \"free-code-camp\": $fa-var-free-code-camp,\n  \"freebsd\": $fa-var-freebsd,\n  \"fulcrum\": $fa-var-fulcrum,\n  \"galactic-republic\": $fa-var-galactic-republic,\n  \"galactic-senate\": $fa-var-galactic-senate,\n  \"get-pocket\": $fa-var-get-pocket,\n  \"gg\": $fa-var-gg,\n  \"gg-circle\": $fa-var-gg-circle,\n  \"git\": $fa-var-git,\n  \"git-alt\": $fa-var-git-alt,\n  \"git-square\": $fa-var-git-square,\n  \"github\": $fa-var-github,\n  \"github-alt\": $fa-var-github-alt,\n  \"github-square\": $fa-var-github-square,\n  \"gitkraken\": $fa-var-gitkraken,\n  \"gitlab\": $fa-var-gitlab,\n  \"gitter\": $fa-var-gitter,\n  \"glide\": $fa-var-glide,\n  \"glide-g\": $fa-var-glide-g,\n  \"gofore\": $fa-var-gofore,\n  \"golang\": $fa-var-golang,\n  \"goodreads\": $fa-var-goodreads,\n  \"goodreads-g\": $fa-var-goodreads-g,\n  \"google\": $fa-var-google,\n  \"google-drive\": $fa-var-google-drive,\n  \"google-pay\": $fa-var-google-pay,\n  \"google-play\": $fa-var-google-play,\n  \"google-plus\": $fa-var-google-plus,\n  \"google-plus-g\": $fa-var-google-plus-g,\n  \"google-plus-square\": $fa-var-google-plus-square,\n  \"google-wallet\": $fa-var-google-wallet,\n  \"gratipay\": $fa-var-gratipay,\n  \"grav\": $fa-var-grav,\n  \"gripfire\": $fa-var-gripfire,\n  \"grunt\": $fa-var-grunt,\n  \"guilded\": $fa-var-guilded,\n  \"gulp\": $fa-var-gulp,\n  \"hacker-news\": $fa-var-hacker-news,\n  \"hacker-news-square\": $fa-var-hacker-news-square,\n  \"hackerrank\": $fa-var-hackerrank,\n  \"hips\": $fa-var-hips,\n  \"hire-a-helper\": $fa-var-hire-a-helper,\n  \"hive\": $fa-var-hive,\n  \"hooli\": $fa-var-hooli,\n  \"hornbill\": $fa-var-hornbill,\n  \"hotjar\": $fa-var-hotjar,\n  \"houzz\": $fa-var-houzz,\n  \"html5\": $fa-var-html5,\n  \"hubspot\": $fa-var-hubspot,\n  \"ideal\": $fa-var-ideal,\n  \"imdb\": $fa-var-imdb,\n  \"instagram\": $fa-var-instagram,\n  \"instagram-square\": $fa-var-instagram-square,\n  \"instalod\": $fa-var-instalod,\n  \"intercom\": $fa-var-intercom,\n  \"internet-explorer\": $fa-var-internet-explorer,\n  \"invision\": $fa-var-invision,\n  \"ioxhost\": $fa-var-ioxhost,\n  \"itch-io\": $fa-var-itch-io,\n  \"itunes\": $fa-var-itunes,\n  \"itunes-note\": $fa-var-itunes-note,\n  \"java\": $fa-var-java,\n  \"jedi-order\": $fa-var-jedi-order,\n  \"jenkins\": $fa-var-jenkins,\n  \"jira\": $fa-var-jira,\n  \"joget\": $fa-var-joget,\n  \"joomla\": $fa-var-joomla,\n  \"js\": $fa-var-js,\n  \"js-square\": $fa-var-js-square,\n  \"jsfiddle\": $fa-var-jsfiddle,\n  \"kaggle\": $fa-var-kaggle,\n  \"keybase\": $fa-var-keybase,\n  \"keycdn\": $fa-var-keycdn,\n  \"kickstarter\": $fa-var-kickstarter,\n  \"kickstarter-k\": $fa-var-kickstarter-k,\n  \"korvue\": $fa-var-korvue,\n  \"laravel\": $fa-var-laravel,\n  \"lastfm\": $fa-var-lastfm,\n  \"lastfm-square\": $fa-var-lastfm-square,\n  \"leanpub\": $fa-var-leanpub,\n  \"less\": $fa-var-less,\n  \"line\": $fa-var-line,\n  \"linkedin\": $fa-var-linkedin,\n  \"linkedin-in\": $fa-var-linkedin-in,\n  \"linode\": $fa-var-linode,\n  \"linux\": $fa-var-linux,\n  \"lyft\": $fa-var-lyft,\n  \"magento\": $fa-var-magento,\n  \"mailchimp\": $fa-var-mailchimp,\n  \"mandalorian\": $fa-var-mandalorian,\n  \"markdown\": $fa-var-markdown,\n  \"mastodon\": $fa-var-mastodon,\n  \"maxcdn\": $fa-var-maxcdn,\n  \"mdb\": $fa-var-mdb,\n  \"medapps\": $fa-var-medapps,\n  \"medium\": $fa-var-medium,\n  \"medium-m\": $fa-var-medium-m,\n  \"medrt\": $fa-var-medrt,\n  \"meetup\": $fa-var-meetup,\n  \"megaport\": $fa-var-megaport,\n  \"mendeley\": $fa-var-mendeley,\n  \"microblog\": $fa-var-microblog,\n  \"microsoft\": $fa-var-microsoft,\n  \"mix\": $fa-var-mix,\n  \"mixcloud\": $fa-var-mixcloud,\n  \"mixer\": $fa-var-mixer,\n  \"mizuni\": $fa-var-mizuni,\n  \"modx\": $fa-var-modx,\n  \"monero\": $fa-var-monero,\n  \"napster\": $fa-var-napster,\n  \"neos\": $fa-var-neos,\n  \"nimblr\": $fa-var-nimblr,\n  \"node\": $fa-var-node,\n  \"node-js\": $fa-var-node-js,\n  \"npm\": $fa-var-npm,\n  \"ns8\": $fa-var-ns8,\n  \"nutritionix\": $fa-var-nutritionix,\n  \"octopus-deploy\": $fa-var-octopus-deploy,\n  \"odnoklassniki\": $fa-var-odnoklassniki,\n  \"odnoklassniki-square\": $fa-var-odnoklassniki-square,\n  \"old-republic\": $fa-var-old-republic,\n  \"opencart\": $fa-var-opencart,\n  \"openid\": $fa-var-openid,\n  \"opera\": $fa-var-opera,\n  \"optin-monster\": $fa-var-optin-monster,\n  \"orcid\": $fa-var-orcid,\n  \"osi\": $fa-var-osi,\n  \"page4\": $fa-var-page4,\n  \"pagelines\": $fa-var-pagelines,\n  \"palfed\": $fa-var-palfed,\n  \"patreon\": $fa-var-patreon,\n  \"paypal\": $fa-var-paypal,\n  \"penny-arcade\": $fa-var-penny-arcade,\n  \"perbyte\": $fa-var-perbyte,\n  \"periscope\": $fa-var-periscope,\n  \"phabricator\": $fa-var-phabricator,\n  \"phoenix-framework\": $fa-var-phoenix-framework,\n  \"phoenix-squadron\": $fa-var-phoenix-squadron,\n  \"php\": $fa-var-php,\n  \"pied-piper\": $fa-var-pied-piper,\n  \"pied-piper-alt\": $fa-var-pied-piper-alt,\n  \"pied-piper-hat\": $fa-var-pied-piper-hat,\n  \"pied-piper-pp\": $fa-var-pied-piper-pp,\n  \"pied-piper-square\": $fa-var-pied-piper-square,\n  \"pinterest\": $fa-var-pinterest,\n  \"pinterest-p\": $fa-var-pinterest-p,\n  \"pinterest-square\": $fa-var-pinterest-square,\n  \"pix\": $fa-var-pix,\n  \"playstation\": $fa-var-playstation,\n  \"product-hunt\": $fa-var-product-hunt,\n  \"pushed\": $fa-var-pushed,\n  \"python\": $fa-var-python,\n  \"qq\": $fa-var-qq,\n  \"quinscape\": $fa-var-quinscape,\n  \"quora\": $fa-var-quora,\n  \"r-project\": $fa-var-r-project,\n  \"raspberry-pi\": $fa-var-raspberry-pi,\n  \"ravelry\": $fa-var-ravelry,\n  \"react\": $fa-var-react,\n  \"reacteurope\": $fa-var-reacteurope,\n  \"readme\": $fa-var-readme,\n  \"rebel\": $fa-var-rebel,\n  \"red-river\": $fa-var-red-river,\n  \"reddit\": $fa-var-reddit,\n  \"reddit-alien\": $fa-var-reddit-alien,\n  \"reddit-square\": $fa-var-reddit-square,\n  \"redhat\": $fa-var-redhat,\n  \"renren\": $fa-var-renren,\n  \"replyd\": $fa-var-replyd,\n  \"researchgate\": $fa-var-researchgate,\n  \"resolving\": $fa-var-resolving,\n  \"rev\": $fa-var-rev,\n  \"rocketchat\": $fa-var-rocketchat,\n  \"rockrms\": $fa-var-rockrms,\n  \"rust\": $fa-var-rust,\n  \"safari\": $fa-var-safari,\n  \"salesforce\": $fa-var-salesforce,\n  \"sass\": $fa-var-sass,\n  \"schlix\": $fa-var-schlix,\n  \"scribd\": $fa-var-scribd,\n  \"searchengin\": $fa-var-searchengin,\n  \"sellcast\": $fa-var-sellcast,\n  \"sellsy\": $fa-var-sellsy,\n  \"servicestack\": $fa-var-servicestack,\n  \"shirtsinbulk\": $fa-var-shirtsinbulk,\n  \"shopify\": $fa-var-shopify,\n  \"shopware\": $fa-var-shopware,\n  \"simplybuilt\": $fa-var-simplybuilt,\n  \"sistrix\": $fa-var-sistrix,\n  \"sith\": $fa-var-sith,\n  \"sitrox\": $fa-var-sitrox,\n  \"sketch\": $fa-var-sketch,\n  \"skyatlas\": $fa-var-skyatlas,\n  \"skype\": $fa-var-skype,\n  \"slack\": $fa-var-slack,\n  \"slack-hash\": $fa-var-slack-hash,\n  \"slideshare\": $fa-var-slideshare,\n  \"snapchat\": $fa-var-snapchat,\n  \"snapchat-ghost\": $fa-var-snapchat-ghost,\n  \"snapchat-square\": $fa-var-snapchat-square,\n  \"soundcloud\": $fa-var-soundcloud,\n  \"sourcetree\": $fa-var-sourcetree,\n  \"speakap\": $fa-var-speakap,\n  \"speaker-deck\": $fa-var-speaker-deck,\n  \"spotify\": $fa-var-spotify,\n  \"square-font-awesome\": $fa-var-square-font-awesome,\n  \"square-font-awesome-stroke\": $fa-var-square-font-awesome-stroke,\n  \"font-awesome-alt\": $fa-var-font-awesome-alt,\n  \"squarespace\": $fa-var-squarespace,\n  \"stack-exchange\": $fa-var-stack-exchange,\n  \"stack-overflow\": $fa-var-stack-overflow,\n  \"stackpath\": $fa-var-stackpath,\n  \"staylinked\": $fa-var-staylinked,\n  \"steam\": $fa-var-steam,\n  \"steam-square\": $fa-var-steam-square,\n  \"steam-symbol\": $fa-var-steam-symbol,\n  \"sticker-mule\": $fa-var-sticker-mule,\n  \"strava\": $fa-var-strava,\n  \"stripe\": $fa-var-stripe,\n  \"stripe-s\": $fa-var-stripe-s,\n  \"studiovinari\": $fa-var-studiovinari,\n  \"stumbleupon\": $fa-var-stumbleupon,\n  \"stumbleupon-circle\": $fa-var-stumbleupon-circle,\n  \"superpowers\": $fa-var-superpowers,\n  \"supple\": $fa-var-supple,\n  \"suse\": $fa-var-suse,\n  \"swift\": $fa-var-swift,\n  \"symfony\": $fa-var-symfony,\n  \"teamspeak\": $fa-var-teamspeak,\n  \"telegram\": $fa-var-telegram,\n  \"telegram-plane\": $fa-var-telegram-plane,\n  \"tencent-weibo\": $fa-var-tencent-weibo,\n  \"the-red-yeti\": $fa-var-the-red-yeti,\n  \"themeco\": $fa-var-themeco,\n  \"themeisle\": $fa-var-themeisle,\n  \"think-peaks\": $fa-var-think-peaks,\n  \"tiktok\": $fa-var-tiktok,\n  \"trade-federation\": $fa-var-trade-federation,\n  \"trello\": $fa-var-trello,\n  \"tumblr\": $fa-var-tumblr,\n  \"tumblr-square\": $fa-var-tumblr-square,\n  \"twitch\": $fa-var-twitch,\n  \"twitter\": $fa-var-twitter,\n  \"twitter-square\": $fa-var-twitter-square,\n  \"typo3\": $fa-var-typo3,\n  \"uber\": $fa-var-uber,\n  \"ubuntu\": $fa-var-ubuntu,\n  \"uikit\": $fa-var-uikit,\n  \"umbraco\": $fa-var-umbraco,\n  \"uncharted\": $fa-var-uncharted,\n  \"uniregistry\": $fa-var-uniregistry,\n  \"unity\": $fa-var-unity,\n  \"unsplash\": $fa-var-unsplash,\n  \"untappd\": $fa-var-untappd,\n  \"ups\": $fa-var-ups,\n  \"usb\": $fa-var-usb,\n  \"usps\": $fa-var-usps,\n  \"ussunnah\": $fa-var-ussunnah,\n  \"vaadin\": $fa-var-vaadin,\n  \"viacoin\": $fa-var-viacoin,\n  \"viadeo\": $fa-var-viadeo,\n  \"viadeo-square\": $fa-var-viadeo-square,\n  \"viber\": $fa-var-viber,\n  \"vimeo\": $fa-var-vimeo,\n  \"vimeo-square\": $fa-var-vimeo-square,\n  \"vimeo-v\": $fa-var-vimeo-v,\n  \"vine\": $fa-var-vine,\n  \"vk\": $fa-var-vk,\n  \"vnv\": $fa-var-vnv,\n  \"vuejs\": $fa-var-vuejs,\n  \"watchman-monitoring\": $fa-var-watchman-monitoring,\n  \"waze\": $fa-var-waze,\n  \"weebly\": $fa-var-weebly,\n  \"weibo\": $fa-var-weibo,\n  \"weixin\": $fa-var-weixin,\n  \"whatsapp\": $fa-var-whatsapp,\n  \"whatsapp-square\": $fa-var-whatsapp-square,\n  \"whmcs\": $fa-var-whmcs,\n  \"wikipedia-w\": $fa-var-wikipedia-w,\n  \"windows\": $fa-var-windows,\n  \"wirsindhandwerk\": $fa-var-wirsindhandwerk,\n  \"wsh\": $fa-var-wsh,\n  \"wix\": $fa-var-wix,\n  \"wizards-of-the-coast\": $fa-var-wizards-of-the-coast,\n  \"wodu\": $fa-var-wodu,\n  \"wolf-pack-battalion\": $fa-var-wolf-pack-battalion,\n  \"wordpress\": $fa-var-wordpress,\n  \"wordpress-simple\": $fa-var-wordpress-simple,\n  \"wpbeginner\": $fa-var-wpbeginner,\n  \"wpexplorer\": $fa-var-wpexplorer,\n  \"wpforms\": $fa-var-wpforms,\n  \"wpressr\": $fa-var-wpressr,\n  \"xbox\": $fa-var-xbox,\n  \"xing\": $fa-var-xing,\n  \"xing-square\": $fa-var-xing-square,\n  \"y-combinator\": $fa-var-y-combinator,\n  \"yahoo\": $fa-var-yahoo,\n  \"yammer\": $fa-var-yammer,\n  \"yandex\": $fa-var-yandex,\n  \"yandex-international\": $fa-var-yandex-international,\n  \"yarn\": $fa-var-yarn,\n  \"yelp\": $fa-var-yelp,\n  \"yoast\": $fa-var-yoast,\n  \"youtube\": $fa-var-youtube,\n  \"youtube-square\": $fa-var-youtube-square,\n  \"zhihu\": $fa-var-zhihu,\n);\n","// icons in a list\n// -------------------------\n\n.#{$fa-css-prefix}-ul {\n  list-style-type: none;\n  margin-left: var(--#{$fa-css-prefix}-li-margin, #{$fa-li-margin});\n  padding-left: 0;\n\n  > li { position: relative; }\n}\n\n.#{$fa-css-prefix}-li {\n  left: calc(var(--#{$fa-css-prefix}-li-width, #{$fa-li-width}) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--#{$fa-css-prefix}-li-width, #{$fa-li-width});\n  line-height: inherit;\n}\n","// bordered + pulled icons\n// -------------------------\n\n.#{$fa-css-prefix}-border {\n  border-color: var(--#{$fa-css-prefix}-border-color, #{$fa-border-color});\n  border-radius: var(--#{$fa-css-prefix}-border-radius, #{$fa-border-radius});\n  border-style: var(--#{$fa-css-prefix}-border-style, #{$fa-border-style});\n  border-width: var(--#{$fa-css-prefix}-border-width, #{$fa-border-width});\n  padding: var(--#{$fa-css-prefix}-border-padding, #{$fa-border-padding});\n}\n\n.#{$fa-css-prefix}-pull-left { \n  float: left;\n  margin-right: var(--#{$fa-css-prefix}-pull-margin, #{$fa-pull-margin}); \n}\n\n.#{$fa-css-prefix}-pull-right { \n  float: right;\n  margin-left: var(--#{$fa-css-prefix}-pull-margin, #{$fa-pull-margin}); \n}\n","// animating icons\n// --------------------------\n\n.#{$fa-css-prefix}-beat {\n  animation-name: #{$fa-css-prefix}-beat;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, ease-in-out);\n}\n\n.#{$fa-css-prefix}-fade {\n  animation-name: #{$fa-css-prefix}-fade;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(.4,0,.6,1));\n}\n\n.#{$fa-css-prefix}-flash {\n  animation-name: #{$fa-css-prefix}-flash;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(.4,0,.6,1));\n}\n\n.#{$fa-css-prefix}-flip {\n  animation-name: #{$fa-css-prefix}-flip;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, ease-in-out);\n}\n\n.#{$fa-css-prefix}-spin {\n  animation-name: #{$fa-css-prefix}-spin;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 2s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, linear);\n}\n\n.#{$fa-css-prefix}-spin-reverse {\n  --#{$fa-css-prefix}-animation-direction: reverse;\n}\n\n.#{$fa-css-prefix}-pulse,\n.#{$fa-css-prefix}-spin-pulse {\n  animation-name: #{$fa-css-prefix}-spin;\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, steps(8));\n}\n\n// if agent or operating system prefers reduced motion, disable animations\n// see: https://www.smashingmagazine.com/2020/09/design-reduced-motion-sensitivities/\n// see: https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion\n@media (prefers-reduced-motion: reduce) {\n  .#{$fa-css-prefix}-beat,\n  .#{$fa-css-prefix}-fade,\n  .#{$fa-css-prefix}-flash,\n  .#{$fa-css-prefix}-flip,\n  .#{$fa-css-prefix}-pulse,\n  .#{$fa-css-prefix}-spin,\n  .#{$fa-css-prefix}-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n\n@keyframes #{$fa-css-prefix}-beat {\n  0%, 90% { transform: scale(1); }\n  45% { transform: scale(var(--#{$fa-css-prefix}-beat-scale, 1.25)); }\n}\n\n@keyframes #{$fa-css-prefix}-fade {\n  50% { opacity: var(--#{$fa-css-prefix}-fade-opacity, 0.4); }\n}\n\n@keyframes #{$fa-css-prefix}-flash {\n  0%, 100% {\n    opacity: var(--#{$fa-css-prefix}-flash-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--#{$fa-css-prefix}-flash-scale, 1.125));\n  }\n}\n\n@keyframes #{$fa-css-prefix}-flip {\n  50% {\n    transform: rotate3d(var(--#{$fa-css-prefix}-flip-x, 0), var(--#{$fa-css-prefix}-flip-y, 1), var(--#{$fa-css-prefix}-flip-z, 0), var(--#{$fa-css-prefix}-flip-angle, -180deg));\n  }\n}\n\n@keyframes #{$fa-css-prefix}-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n","// rotating + flipping icons\n// -------------------------\n\n.#{$fa-css-prefix}-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.#{$fa-css-prefix}-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.#{$fa-css-prefix}-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.#{$fa-css-prefix}-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.#{$fa-css-prefix}-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.#{$fa-css-prefix}-flip-both,\n.#{$fa-css-prefix}-flip-horizontal.#{$fa-css-prefix}-flip-vertical { \n  transform: scale(-1, -1);\n}\n\n.#{$fa-css-prefix}-rotate-by {\n  transform: rotate(var(--#{$fa-css-prefix}-rotate-angle, none));\n}\n","// stacking icons\n// -------------------------\n\n.#{$fa-css-prefix}-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: $fa-stack-vertical-align;\n  width: $fa-stack-width;\n}\n\n.#{$fa-css-prefix}-stack-1x,\n.#{$fa-css-prefix}-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n  z-index: var(--#{$fa-css-prefix}-stack-z-index, #{$fa-stack-z-index});\n}\n\n.#{$fa-css-prefix}-stack-1x {\n  line-height: inherit;\n}\n\n.#{$fa-css-prefix}-stack-2x {\n  font-size: 2em;\n}\n\n.#{$fa-css-prefix}-inverse {\n  color: var(--#{$fa-css-prefix}-inverse, #{$fa-inverse});\n}\n","// specific icon class definition\n// -------------------------\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\nreaders do not read off random characters that represent icons */\n\n@each $name, $icon in $fa-icons {\n  .#{$fa-css-prefix}-#{$name}::before { content: fa-content($icon); }\n}\n","// screen-reader utilities\n// -------------------------\n\n// only display content to screen readers\n.sr-only,\n.fa-sr-only {\n  @include fa-sr-only;\n}\n\n// use in conjunction with .sr-only to only display content when it's focused\n.sr-only-focusable,\n.fa-sr-only-focusable {\n  @include fa-sr-only-focusable;\n}\n","/*!\n * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n@import 'functions';\n@import 'variables';\n\n@font-face {\n  font-family: 'Font Awesome 6 Brands';\n  font-style: normal;\n  font-weight: 400;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-brands-400.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-brands-400.ttf') format('truetype');\n}\n\n.fab,\n.fa-brands {\n  font-family: 'Font Awesome 6 Brands';\n  font-weight: 400;\n}\n\n@each $name, $icon in $fa-brand-icons {\n  .#{$fa-css-prefix}-#{$name}:before { content: fa-content($icon); }\n}\n","/*!\n * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n@import 'functions';\n@import 'variables';\n\n@font-face {\n  font-family: 'Font Awesome 6 Pro';\n  font-style: normal;\n  font-weight: 900;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-solid-900.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-solid-900.ttf') format('truetype');\n}\n\n.fas,\n.fa-solid {\n  font-family: 'Font Awesome 6 Pro';\n  font-weight: 900;\n}\n","/*!\n * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n@import 'functions';\n@import 'variables';\n\n@font-face {\n  font-family: 'Font Awesome 6 Pro';\n  font-style: normal;\n  font-weight: 300;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-light-300.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-light-300.ttf') format('truetype');\n}\n\n.fal,\n.fa-light {\n  font-family: 'Font Awesome 6 Pro';\n  font-weight: 300;\n}\n","/*!\n * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n@import 'functions';\n@import 'variables';\n\n@font-face {\n  font-family: 'Font Awesome 6 Pro';\n  font-style: normal;\n  font-weight: 400;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-regular-400.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-regular-400.ttf') format('truetype');\n}\n\n.far,\n.fa-regular {\n  font-family: 'Font Awesome 6 Pro';\n  font-weight: 400;\n}\n","/*!\n * Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license (Commercial License)\n */\n@import 'functions';\n@import 'variables';\n\n@font-face {\n  font-family: 'Font Awesome 6 Pro';\n  font-style: normal;\n  font-weight: 100;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-thin-100.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-thin-100.ttf') format('truetype');\n}\n\n.fat,\n.fa-thin {\n  font-family: 'Font Awesome 6 Pro';\n  font-weight: 100;\n}\n","@import \"../fontawesome/scss/all.scss\";\n\n@font-face {\n  font-family: \"Inter\";\n  font-weight: 100 900;\n  font-display: swap;\n  font-style: normal;\n  font-named-instance: \"Regular\";\n  src: url(\"~assets/NEW/font/Inter.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Soehne\";\n  font-weight: 200;\n  src: url(\"https://cdn.paylix.gg/static/fonts/soehne-extraleicht.woff2\");\n}\n\n@font-face {\n  font-family: \"Soehne\";\n  font-weight: 300;\n  src: url(\"https://cdn.paylix.gg/static/fonts/soehne-leicht.woff2\");\n}\n\n@font-face {\n  font-family: \"Soehne\";\n  font-weight: 400;\n  src: url(\"https://cdn.paylix.gg/static/fonts/soehne-buch.woff2\");\n}\n\n@font-face {\n  font-family: \"Soehne\";\n  font-weight: 500;\n  src: url(\"https://cdn.paylix.gg/static/fonts/soehne-kraftig.woff2\");\n}\n\n@font-face {\n  font-family: \"Soehne\";\n  font-weight: 600;\n  src: url(\"https://cdn.paylix.gg/static/fonts/soehne-halbfett.woff2\");\n}\n\n@font-face {\n  font-family: \"Soehne\";\n  font-weight: 700;\n  src: url(\"https://cdn.paylix.gg/static/fonts/soehne-dreiviertelfett.woff2\");\n}\n\n@font-face {\n  font-family: \"Soehne\";\n  font-weight: 800;\n  src: url(\"https://cdn.paylix.gg/static/fonts/soehne-fett.woff2\");\n}\n\n@font-face {\n  font-family: \"Soehne\";\n  font-weight: 900;\n  src: url(\"https://cdn.paylix.gg/static/fonts/soehne-extrafett.woff2\");\n}\n","html {\n  width: 100vw;\n  margin-left: 0;\n  background-color: white;\n  overflow-x: hidden;\n\n  &.embed {\n    background-color: transparent !important;\n\n    #app {\n      background-color: transparent !important;\n    }\n  }\n}\n\n\n* {\n  box-sizing: border-box;\n}\n\nh1 {\n  margin-top: 0;\n}\n\nh2 {\n  margin-top: 0;\n  margin-bottom: .5rem;\n}\n\nh4 {\n  margin-top: 0;\n  margin-bottom: .5rem;\n}\n\nh6 {\n  margin-top: 0;\n  margin-bottom: .5rem;\n}\n\nh5 {\n  font-size: 1.25rem;\n}\n\nbody {\n  transition: background .9s;\n  background-color: #0000;\n  font-size: 14px;\n  -webkit-font-smoothing: antialiased;\n  font-family: \"Inter\", sans-serif !important;\n  margin: 0;\n}\n\n\n*::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n  background-color: transparent;\n\n  &-track {\n    background-color: transparent;\n  }\n\n  &-thumb {\n    background-color: rgba(0, 0, 0, 0.3);\n  }\n}\n\n.uppercase {\n  text-transform: lowercase;\n\n  &:first-letter {\n    text-transform: uppercase;\n  }\n}\n\n@media (max-width: 375px) {\n  .g-recaptcha {\n    margin: 0 auto;\n    transform: scale(0.98);\n    -webkit-transform: scale(0.98);\n    transform-origin: 0 0;\n    -webkit-transform-origin: 0 0;\n  }\n}\n\n@media (max-width: 360px) {\n  .g-recaptcha {\n    margin: 0 auto;\n    transform: scale(0.92);\n    -webkit-transform: scale(0.92);\n    transform-origin: 0 0;\n    -webkit-transform-origin: 0 0;\n  }\n}\n\n@media (max-width: 320px) {\n  .g-recaptcha {\n    margin: 0 auto;\n    transform: scale(0.8);\n    -webkit-transform: scale(0.8);\n    transform-origin: 0 0;\n    -webkit-transform-origin: 0 0;\n  }\n}\n\n.selectable {\n  -webkit-user-select: text;\n  -khtml-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n\n\n.underline {\n  text-decoration: underline !important;\n}\n\n.transparent-bg {\n  background-color: transparent;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n\n.notransition * {\n  -webkit-transition: none !important;\n  -moz-transition: none !important;\n  -o-transition: none !important;\n  -ms-transition: none !important;\n  transition: none !important;\n}\n\na {\n  color: #6a32e6;\n  text-decoration: none;\n  background-color: transparent;\n}\n\n.is-invalid ~ .invalid-feedback {\n  display: block;\n}\n\nh4 {\n  font-size: 18px;\n}\n\n\n.flag-icon {\n  position: relative;\n  display: inline-block;\n  width: 3rem;\n  height: 2rem;\n  line-height: 1em;\n  border-radius: .25rem;\n  object-fit: cover;\n\n  &:before {\n    content: '\\00a0';\n  }\n}\n\n.flag-icon {\n  position: relative;\n  display: inline-block;\n  width: calc((4 / 3) * 1em);\n  line-height: 1em;\n  object-fit: cover;\n\n  &:before {\n    content: '\\00a0';\n  }\n}\n\n.text-green {\n  color: #28a745 !important;\n}\n\n.text-gold {\n  color: gold !important;\n}\n\n.text-grey {\n  color: dimgrey !important;\n}\n\n.text-red {\n  color: #dc3545 !important;\n}\n\n.grecaptcha-badge {\n  visibility: hidden;\n}\n\n.unselectable {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -webkit-user-drag: none;\n  user-select: none;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.overflow-scroll {\n  overflow: scroll;\n}\n\n.notransition * {\n  -webkit-transition: none;\n  -moz-transition: none;\n  -o-transition: none;\n  transition: none;\n}\n\nhr {\n  width: 100%;\n}\n\n\n\n.button {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  user-select: none;\n  border: 1px solid #0000;\n  line-height: 1.5;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 0 20px;\n  //min-height: 48px;\n  white-space: nowrap;\n  background-color: var(--purple6);\n  font-family: \"Inter\", sans-serif !important;\n\n  &:hover {\n    opacity: .9;\n  }\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: default;\n  }\n\n  &.thin {\n    min-height: 30px;\n    font-size: 12px;\n    padding: 0 10px;\n    border-radius: 6px;\n  }\n}\n\n.button-ghost {\n  background: #0000;\n  border-color: var(--black1);\n  border-radius: .5rem;\n  color: var(--black9);\n\n  &:hover {\n    background: var(--black1);\n  }\n}\n\n\n.w-90 {\n  width: 90% !important;\n}\n.w-80 {\n  width: 80% !important;\n}\n.w-70 {\n  width: 70% !important;\n}\n.w-60 {\n  width: 60%;\n}\n.w-50 {\n  width: 50%;\n}\n.w-40 {\n  width: 40%;\n}\n.w-30 {\n  width: 30% !important;\n}\n.w-20 {\n  width: 20%;\n}\n.w-10 {\n  width: 10%;\n}\n\n\n\n.purple-color {\n  color: var(--purple6) !important;\n}\n\n.text-nowrap {\n  white-space: nowrap;\n}\n\n.w-max {\n  width: max-content !important;\n}\n\n.link-like {\n  color: var(--purple6);\n  text-decoration: underline;\n  cursor: pointer;\n}",".screen {\n\n  &-title {\n    margin-top: .5rem;\n    margin-bottom: 0;\n    font-size: 1.5rem !important;\n    white-space: nowrap;\n    align-items: center;\n    display: flex;\n    margin-right: 1.5rem;\n    width: auto;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    line-height: 29px;\n    color: var(--black9) !important;\n\n    & + div {\n      width: auto;\n      display: flex;\n      justify-content: flex-end;\n    }\n\n    @media (max-width: 768px) {\n      font-weight: 500;\n      font-size: 1.5rem !important;\n    }\n\n    &-container {\n      display: flex;\n\n      @media (max-width: 768px) {\n        flex-wrap: wrap;\n      }\n    }\n  }\n\n  &-note {\n    margin: 1rem 0;\n    font-size: 0.8rem;\n    line-height: 1.2rem;\n    color: var(--black9);\n\n    @media (max-width: 768px) {\n      margin: .5rem 0;\n    }\n  }\n\n  &-header {\n    padding: 1.5rem 0;\n    align-items: flex-end;\n    justify-content: space-between;\n    display: flex;\n    position: relative;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      align-items: flex-start;\n      padding: 1rem 0;\n    }\n  }\n\n  &-filters {\n    display: flex;\n    justify-content: flex-end;\n    flex-wrap: wrap-reverse;\n    gap: .75rem;\n\n    &-button {\n      margin-left: 1rem;\n\n      @media (max-width: 768px) {\n        margin-left: 0;\n      }\n    }\n\n    @media (max-width: 768px) {\n      width: 100%;\n      margin-top: .25rem;\n      display: flex;\n      flex-direction: column;\n    }\n\n    .paylixecommerce-date-picker {\n      @media (max-width: 768px) {\n        width: 100%;\n        justify-content: center;\n      }\n    }\n  }\n\n  &-select {\n    max-width: 30%;\n\n    &.long {\n      max-width: 50%;\n    }\n  }\n\n}\n\n@media (max-width: 768px) {\n  .screen {\n\n    &-title {\n      font-weight: 500;\n      font-size: 1.5rem !important;\n\n      & + div {\n\n      }\n\n      &-container {\n        flex-wrap: wrap;\n      }\n    }\n\n    &-note {\n      margin: .5rem 0;\n    }\n\n    &-header {\n      flex-direction: column;\n      align-items: flex-start;\n      padding: 1rem 0;\n    }\n\n    &-filters {\n      width: 100%;\n      margin-top: 1rem;\n      margin-bottom: .25rem;\n      display: flex;\n      flex-direction: column;\n\n      & > .paylixecommerce-select, .paylixecommerce-input {\n\n      }\n\n      &-button {\n        margin-left: 0;\n      }\n\n      .paylixecommerce-date-picker {\n        width: 100%;\n        justify-content: center;\n      }\n    }\n\n    &-select {\n\n      &.long {\n\n      }\n    }\n\n  }\n\n\n}\n\n",".dark {\n\n  .paylixecommerce-select {\n    background-color: var(--black1);\n    //border-color: var(--black6);\n  }\n\n  .paylixecommerce-label {\n    color: var(--black);\n  }\n\n  .paylixecommerce-input {\n    background-color: var(--black1);\n    //border-color: var(--black6);\n  }\n\n  textarea.paylixecommerce-input {\n    background-color: var(--black1);\n    //border-color: var(--black6);\n  }\n\n  .react-mde {\n    .mde-textarea-wrapper {\n      textarea.mde-text {\n        background-color: var(--black1);\n        border-color: var(--black6);\n        border-bottom: none;\n        border-right: none;\n        border-left: none;\n      }\n    }\n\n    .mde-header {\n      background-color: var(--black1);\n      //border-color: var(--black6);\n    }\n\n  }\n\n  .switcher input:checked + .switcher-slider::before {\n    background: var(--black);\n  }\n\n  .switcher .switcher-slider {\n    background: var(--black3);\n  }\n\n}\n\n\n\n.paylixecommerce-note {\n  display: block;\n  align-items: end;\n  margin-top: .75rem;\n  margin-bottom: 0;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 15px;\n  color: var(--black5);\n\n  @media (max-width: 768px) {\n    font-weight: 400;\n  }\n\n  b {\n    color: var(--black9) !important;\n    font-weight: 600 !important;\n  }\n  a {\n    color: var(--purple6) !important;\n    font-weight: 600 !important;\n  }\n}\n\n.paylixecommerce-note-big {\n  display: block;\n  align-items: end;\n  margin-top: .75rem;\n  margin-bottom: 0;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: var(--black5);\n\n  b {\n    color: var(--black9) !important;\n    font-weight: 500 !important;\n  }\n  a {\n    color: var(--purple6) !important;\n    font-weight: 600 !important;\n  }\n}\n\n.d-block {\n  display: block;\n}\n\n\n.paylixecommerce-label {\n  margin-bottom: .75rem;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 17px;\n  color: var(--black5);\n  display: flex;\n\n  align-items: center;\n}\n\n.paylixecommerce-input-visible {\n  position: absolute;\n  right: 1rem;\n  bottom: .6rem;\n  cursor: pointer;\n}\n\n.paylixecommerce-input-prefix {\n  position: absolute;\n  height: 40px;\n  bottom: 0;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding: 1rem;\n  font-weight: bold;\n  color: var(--black9);\n  top: 29px;\n  right: 0;\n  border-left: 1px solid var(--black2);\n\n  & + div input {\n    padding-right: 2.5rem;\n  }\n}\n\n.paylixecommerce-select {\n  cursor: pointer;\n  padding: 0 2rem 0 14px;\n  height: 40px;\n  max-height: 40px;\n  width: 100%;\n  transition: border .3s ease;\n  outline: none;\n  border-radius: .5rem;\n  appearance: none;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  margin: 0;\n  color: var(--black9);\n  border: 1px solid var(--black2);\n  box-shadow: inset 0 1px 2px rgba(16, 24, 40, 0.05);\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 17px;\n\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background: transparent;\n  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSA3LjVMMTAgMTIuNUwxNSA3LjUiIHN0cm9rZT0iI0EyQUFCNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==');\n  background-repeat: no-repeat;\n  background-position-x: calc(100% - 1rem);\n  background-position-y: 0.5rem;\n\n  &[disabled] {\n    background: var(--black0);\n    border-color: var(--black2);\n    cursor: default;\n  }\n\n  &:active {\n    border-color: var(--purple6);\n  }\n  &:focus {\n    border-color: var(--purple6);\n  }\n  &:hover {\n    border-color: var(--purple6);\n  }\n\n  &::-ms-expand {\n    display: none;\n  }\n\n  &.is-invalid {\n    border: 1px solid var(--red6) !important;\n\n    &:hover {\n      border-color: var(--red6) !important;\n    }\n    &:focus {\n      border-color: var(--red6) !important;\n    }\n  }\n}\n\n\n.switcher {\n  width: 2.75rem;\n  min-width: 2.75rem;\n  height: 1.5rem;\n  margin: 0 0 0 1rem;\n\n  &-label {\n    cursor: pointer;\n    width: calc(100% - 3.75rem);\n\n    .paylixecommerce-note {\n      font-weight: 400;\n      margin: 0;\n    }\n  }\n\n  &.left {\n    margin-right: 0;\n  }\n\n  &-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    width: 100%;\n\n    &.withBorder {\n      margin-bottom: 1rem;\n      padding-bottom: 1rem;\n      border-bottom: 1px solid var(--black1);\n    }\n\n    &.right {\n      .switcher {\n        margin-left: 0;\n        margin-right: 1rem;\n\n        &-label {\n          width: calc(100% - 3.75rem);\n        }\n      }\n    }\n  }\n\n  input {\n    display: none;\n    position: absolute;\n    margin-top: 0.3rem;\n    margin-left: -1.25rem;\n    width: 50px;\n\n    &:checked ~ .switcher-slider::before {\n      transform: translateX(19px);\n    }\n    &:checked + .switcher-slider {\n      background-color: var(--purple6);\n      border-color: var(--purple6);\n\n      &::before {\n        border-color: var(--purple6);\n      }\n    }\n  }\n\n  .switcher-slider {\n    background-color: var(--black1);\n    border: none;\n    border-radius: 50em;\n    font-size: 12px;\n    position: relative;\n    display: block;\n    height: inherit;\n    cursor: pointer;\n    transition: .15s ease-out;\n\n    &:before {\n      width: 20px;\n      height: 20px;\n      top: 2px;\n      border-radius: 100%;\n      position: absolute;\n      left: 2px;\n      box-sizing: border-box;\n      content: \"\";\n      background-color: var(--white);\n      border: 1px solid var(--black1);\n      transition: .15s ease-out;\n      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);\n    }\n\n    span {\n      border-radius: 50em;\n      font-size: 12px;\n      background-color: var(--black0);\n      border: none;\n      position: relative;\n      display: block;\n      height: inherit;\n      cursor: pointer;\n      transition: .15s ease-out;\n    }\n  }\n}\n\n.paylixecommerce-input {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: 1px solid var(--black2);\n  box-shadow: inset 0 1px 2px rgba(16, 24, 40, 0.05);\n  border-radius: .5rem;\n  background: var(--white);\n  width: 100%;\n  padding: 0 14px;\n  transition: border .3s ease !important;\n  height: 40px;\n  max-height: 40px;\n  outline: none;\n\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 17px;\n  color: var(--black9);\n\n  &.textarea {\n    height: auto;\n    max-height: none;\n    padding: .75rem 1rem;\n    border-radius: .5rem;\n    border: 1px solid var(--black2);\n    box-shadow: inset 0 1px 2px rgba(16, 24, 40, 0.05);\n    min-height: 80px;\n  }\n\n  &.is-invalid {\n    border: 1px solid var(--red6) !important;\n\n    &:hover {\n      border-color: var(--red6) !important;\n    }\n    &:focus {\n      border-color: var(--red6) !important;\n    }\n  }\n\n  &:active {\n    border-color: var(--purple6);\n  }\n  &:focus {\n    border-color: var(--purple6);\n  }\n  &:hover {\n    border-color: var(--purple6) !important;\n  }\n\n  &::placeholder {\n    color: var(--black3);\n  }\n\n  &[disabled] {\n    background: var(--black0);\n    border-color: var(--black2);\n\n    &:focus {\n      border-color: var(--black2);\n    }\n  }\n}\n\n.paylixecommerce-checkbox {\n  background-color: #0000;\n  border: 1px solid #0000;\n  position: relative;\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.5rem;\n  cursor: pointer;\n  font-weight: 500;\n  margin-bottom: 1rem;\n  margin-right: 1.5rem;\n\n  input {\n    box-sizing: border-box;\n    padding: 0;\n    position: absolute;\n    z-index: -1;\n    opacity: 0;\n\n    &:not(:disabled):active ~ label::before {\n      color: #fff;\n      background-color: var(--black0);\n      border-color: var(--black3);\n    }\n\n    &:focus ~ label::before {\n      border-color: var(--purple6);\n      box-shadow: 0 0 0 0.2rem rgb(97 59 234 / 25%);\n    }\n\n    &:checked ~ label::before {\n      color: #fff;\n      border-color: var(--purple6);\n      background-color: var(--purple6);\n    }\n\n    &:checked ~ label {\n      color: var(--black9);\n    }\n\n    &:checked ~ label::after {\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e\") !important;\n      border: 1px solid var(--purple6);\n    }\n  }\n\n  label {\n    position: relative;\n    margin-bottom: 0;\n    font-weight: 400;\n    //cursor: pointer;\n    //font-family: 'Inter';\n    //font-style: normal;\n    //font-weight: 500;\n    //font-size: 14px;\n    //line-height: 17px;\n    //color: var(--black4);\n\n    &:before {\n      position: absolute;\n      cursor: pointer;\n      display: block;\n      pointer-events: none;\n      content: \"\";\n      background-color: var(--white);\n      top: 50%;\n      transform: translateY(-50%);\n      border-radius: 2px;\n      transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n      width: 18px;\n      height: 18px;\n      left: -1.75rem;\n      border: 1px solid var(--black5) !important;\n    }\n\n    &:after {\n      top: 50%;\n      cursor: pointer;\n      transform: translateY(-50%);\n      position: absolute;\n      display: block;\n      content: \"\";\n      background: no-repeat 50%/50% 50%;\n      width: 18px;\n      height: 18px;\n      left: -1.75rem;\n      border-radius: 2px;\n    }\n  }\n}\n\n\n.is-invalid .react-mde {\n  textarea {\n    border: 1px solid var(--red6) !important;\n    &:focus {\n      border-color: var(--red6) !important;\n    }\n  }\n}\n\n.react-mde {\n  border: none;\n  border-radius: .5rem;\n\n  .grip {\n    border-top: none;\n    background: var(--black9)\n  }\n\n  ul.mde-header-group {\n    padding: 0 .5rem;\n    margin: .5rem 0;\n\n    li {\n      display: flex !important;\n      align-items: center;\n    }\n  }\n\n  .mde-header {\n    background: var(--white);\n    border: 1px solid var(--black2);\n    border-radius: .5rem .5rem 0 0;\n    border-bottom: none;\n\n    svg {\n      path {\n        fill: var(--black5);\n      }\n    }\n\n    i {\n      color: var(--black5);\n    }\n\n    .mde-tabs {\n      button {\n        border: none;\n        text-align: center;\n        margin: .5rem;\n        position: relative;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        overflow: hidden;\n        cursor: pointer;\n        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n        padding: 0 1rem;\n        text-align: center;\n        font-family: \"Inter\" !important;\n        border-radius: 0.5rem;\n        font-size: 0.875rem;\n        line-height: 18px;\n        box-sizing: border-box;\n        user-select: none;\n        border: none;\n        color: var(--white);\n        background-color: var(--black9);\n        font-weight: 600;\n        height: 1.75rem;\n        font-size: 0.813rem;\n\n\n        &.selected {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .mde-textarea-wrapper {\n    textarea.mde-text {\n      padding: 1rem !important;\n      border: 1px solid var(--black2);\n      border-radius: 0 0 .5rem .5rem;\n      box-shadow: inset 0px 1px 2px rgba(16, 24, 40, 0.05);\n      height: 100px;\n      font-size: 14px;\n      background: var(--white);\n      color: var(--black9) !important;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n\n    &:focus {\n        outline: none;\n        border-color: var(--purple6);\n      }\n    }\n  }\n\n}\n\n\n.invalid-feedback {\n  width: 100%;\n  margin-top: .25rem;\n  font-size: 80%;\n  color: var(--red6);\n}\n\n.paylixecommerce-text, div.mde-preview div.mde-preview-content {\n  color: var(--black6);\n\n  h1 {\n    font-size: 1.6rem;\n    line-height: 3rem;\n  }\n  h2 {\n    font-size: 1.4rem;\n    line-height: 2.5rem;\n  }\n  h3 {\n    font-size: 1.3rem;\n    line-height: 2.4rem;\n  }\n  h4 {\n    font-size: 1.1rem;\n    line-height: 2rem;\n  }\n  h6 {\n    font-weight: 500;\n  }\n\n  p {\n    font-size: .9rem;\n    margin: 0;\n    line-height: 1.2rem;\n    margin-bottom: .6rem;\n    color: var(--black9);\n  }\n\n  input[type=checkbox] {\n    width: 30px;\n    height: 20px;\n    cursor: pointer;\n    font-size: 21px;\n    visibility: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 1rem -2rem;\n    transform: scale(1.25);\n\n    &:after {\n      content: \" \";\n      background-color: #fff;\n      display: inline-block;\n      margin-left: 10px;\n      padding-bottom: 5px;\n      color: #221d3e;\n      width: 17px;\n      height: 17px;\n      visibility: visible;\n      border: 2px solid #181432;\n      padding-left: 3px;\n      border-radius: 2px;\n    }\n\n    &:checked:after {\n      content: \"x\";\n      font-weight: bold;\n      font-size: .8rem;\n      color: #181432;\n      position: relative;\n      padding-bottom: 0;\n      text-align: center;\n      display: flex;\n      align-items: center;\n      justify-content: left;\n      cursor: pointer;\n    }\n  }\n\n  pre {\n    padding: 1rem;\n    border-radius: 2px;\n    margin-top: 1rem;\n    overflow: auto;\n    display: block;\n    line-height: 1rem;\n  }\n\n  ul, ol {\n    line-height: 1.5rem;\n    padding-left: 1.5rem;\n\n    li {\n\n    }\n  }\n\n  ol {\n    list-style: auto;\n    padding-top: 0.5rem;\n  }\n\n  img {\n    max-width: 100%;\n    border-radius: .5rem;\n  }\n}\n\n.dark {\n\n  .edit-modal {\n\n    .info-table {\n      background: var(--white);\n      border: 1px solid var(--black2);\n\n      .info-table-header {\n        background: var(--black1);\n      }\n      .info-table-body > div:not(.paylixecommerce-table-container) {\n        border-color: var(--black2);\n      }\n\n      &.table {\n        .info-table-header {\n          background: var(--black1);\n          border-bottom-color: var(--black0);\n\n          .screen-search input {\n            background: var(--black0);\n          }\n        }\n        .info-table-body {\n          background-color: var(--black1);\n          border-radius: 0 0 .5rem .5rem;\n        }\n      }\n    }\n\n  }\n\n  .info-table {\n    background: var(--white);\n    border-color: transparent;\n\n    .info-table-header {\n      background: var(--black1);\n    }\n    .info-table-body > div:not(.paylixecommerce-table-container) {\n      border-color: var(--black1);\n    }\n\n    &.table {\n      .info-table-header {\n        background: var(--black1);\n        border-bottom-color: var(--black0);\n\n        .screen-search input {\n          background: var(--black0);\n        }\n      }\n      .info-table-body {\n        background-color: var(--black1);\n        border-radius: 0 0 .5rem .5rem;\n      }\n    }\n  }\n}\n\n.info-table {\n  display: flex !important;\n  flex-direction: column;\n  width: 100%;\n  background: var(--white);\n  border-radius: .5rem;\n  border: 1px solid var(--black1);\n  margin-bottom: 1rem;\n  margin-top: 0;\n\n  &.table {\n    .paylixecommerce-table-container {\n      padding: 0;\n      box-shadow: none;\n\n      .paylixecommerce-table {\n        padding: 0;\n        box-shadow: none;\n\n        table {\n          thead th {\n            padding: .5rem 0.75rem;\n          }\n          tbody tr td {\n            border-top-color: var(--black1) !important;\n          }\n        }\n\n        &-container {\n          padding: 0;\n        }\n      }\n    }\n  }\n\n  &.with-shadow {\n    box-shadow: 0px 1px 3px rgb(7 14 35 / 6%), 0px 2px 8px -1px rgb(7 14 35 / 5%);\n    border: none;\n  }\n\n  &.collapsed {\n    .info-table-header {\n      border-bottom: none;\n      border-radius: .5rem .5rem .5rem .5rem;\n    }\n  }\n\n  &-header {\n    padding: 1.25rem;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--black9);\n    cursor: pointer;\n    border-radius: .5rem .5rem 0 0;\n\n    display: flex;\n    justify-content: space-between;\n    border-bottom: 1px solid var(--black1);\n  }\n\n  &-body {\n    & > div:not(.paylixecommerce-table-container) {\n      display: flex;\n      width: 100%;\n      border-top: 1px solid var(--black1);\n      padding: 1rem 1.25rem;\n      justify-content: space-between;\n      color: var(--black4);\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 500;\n      font-size: 13px;\n      line-height: 16px;\n      border-radius: 0 0 .5rem .5rem;\n\n      &:first-child {\n        border-top: none;\n      }\n\n      span:first-child {\n        width: 30%;\n      }\n\n      span:last-child {\n        width: 70%;\n        text-align: right;\n        color: var(--black9);\n        word-break: break-word;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n\n  .info-table {\n\n    &.table {\n      .paylixecommerce-table-container {\n\n        .paylixecommerce-table {\n\n          table {\n            thead th {\n              padding: .5rem 0.75rem;\n            }\n            tbody tr td {\n            }\n          }\n\n          &-container {\n\n          }\n        }\n      }\n    }\n\n    &.with-shadow {\n\n    }\n\n    &.collapsed {\n      .info-table-header {\n\n      }\n    }\n\n    &-header {\n      padding: 1rem;\n    }\n\n    &-body {\n      & > div:not(.paylixecommerce-table-container) {\n        padding: .75rem 1rem;\n\n        &:first-child {\n\n        }\n\n        span:first-child {\n\n        }\n\n        span:last-child {\n\n        }\n      }\n    }\n  }\n}\n\n\n.is-invalid-select > div:first-of-type {\n  border: 1px solid var(--red6) !important;\n\n  &:hover {\n    border-color: var(--red6) !important;\n  }\n  &:focus {\n    border-color: var(--red6) !important;\n  }\n}",".mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.d-none {\n  display: none !important;\n}\n.d-flex {\n  display: flex !important;\n}\n.gap-1 {\n  gap: .25rem;\n}\n.gap-2 {\n  gap: .5rem;\n}\n.gap-3 {\n  gap: .75rem;\n}\n.gap-4 {\n  gap: 1rem;\n}\n.gap-5 {\n  gap: 1.25rem;\n}\n.gap-6 {\n  gap: 1.5rem;\n}\n\n.d-inline {\n  display: inline-flex !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n.my-1 {\n  margin-top: .25rem !important;\n  margin-bottom: .25rem !important;\n}\n.my-2 {\n  margin-top: .5rem !important;\n  margin-bottom: .5rem !important;\n}\n.my-3 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n.my-4 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n.my-5 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n.mx-1 {\n  margin-right: .25rem !important;\n  margin-left: .25rem !important;\n}\n.mx-2 {\n  margin-right: .5rem !important;\n  margin-left: .5rem !important;\n}\n.mx-3 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n.mx-4 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n.mx-5 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.py-1 {\n  padding-top: .25rem !important;\n  padding-bottom: .25rem !important;\n}\n.py-2 {\n  padding-top: .5rem !important;\n  padding-bottom: .5rem !important;\n}\n.py-3 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n.py-4 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n.py-5 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n.px-1 {\n  padding-right: .25rem !important;\n  padding-left: .25rem !important;\n}\n.px-2 {\n  padding-right: .5rem !important;\n  padding-left: .5rem !important;\n}\n.px-3 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n.px-4 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n.px-5 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n.p-1 {\n  padding: .25rem;\n}\n.p-2 {\n  padding: .5rem;\n}\n.p-3 {\n  padding: 1rem;\n}\n.p-4 {\n  padding: 1.5rem;\n}\n.p-5 {\n  padding: 1.5rem;\n}\n.p-0 {\n  padding: 0;\n}\n\n.m-1 {\n  margin: .25rem;\n}\n.m-2 {\n  margin: .5rem;\n}\n.m-3 {\n  margin: 1rem;\n}\n.m-4 {\n  margin: 1.5rem;\n}\n.m-5 {\n  margin: 1.5rem;\n}\n.m-0 {\n  margin: 0;\n}\n\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n.mb-1 {\n  margin-bottom: .25rem !important;\n}\n.mb-2 {\n  margin-bottom: .5rem !important;\n}\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n.mt-1 {\n  margin-top: .25rem !important;\n}\n.mt-2 {\n  margin-top: .5rem !important;\n}\n.mt-3 {\n  margin-top: 1rem !important;\n}\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n\n.m-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.mr-0 {\n  margin-right: 0 !important;\n}\n.mr-1 {\n  margin-right: .25rem !important;\n}\n.mr-2 {\n  margin-right: .5rem !important;\n}\n.mr-3 {\n  margin-right: 1rem !important;\n}\n.mr-4 {\n  margin-right: 1.5rem !important;\n}\n.mr-5 {\n  margin-right: 3rem !important;\n}\n\n\n.ml-0 {\n  margin-left: 0 !important;\n}\n.ml-1 {\n  margin-left: .25rem !important;\n}\n.ml-2 {\n  margin-left: .5rem !important;\n}\n.ml-3 {\n  margin-left: 1rem !important;\n}\n.ml-4 {\n  margin-left: 1.5rem !important;\n}\n.ml-5 {\n  margin-left: 3rem !important;\n}\n\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n.pb-1 {\n  padding-bottom: .25rem !important;\n}\n.pb-2 {\n  padding-bottom: .5rem !important;\n}\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n\n.ml-auto {\n  margin-left: auto;\n}\n.mr-auto {\n  margin-right: auto;\n}\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n.pt-0 {\n  padding-top: 0 !important;\n}\n.pt-1 {\n  padding-top: .25rem !important;\n}\n.pt-2 {\n  padding-top: .5rem !important;\n}\n.pt-3 {\n  padding-top: 1rem !important;\n}\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n\n.pr-0 {\n  padding-right: 0 !important;\n}\n.pr-1 {\n  padding-right: .25rem !important;\n}\n.pr-2 {\n  padding-right: .5rem !important;\n}\n.pr-3 {\n  padding-right: 1rem !important;\n}\n.pr-4 {\n  padding-right: 1.5rem !important;\n}\n.pr-5 {\n  padding-right: 3rem !important;\n}\n\n\n.pl-0 {\n  padding-left: 0 !important;\n}\n.pl-1 {\n  padding-left: .25rem !important;\n}\n.pl-2 {\n  padding-left: .5rem !important;\n}\n.pl-3 {\n  padding-left: 1rem !important;\n}\n.pl-4 {\n  padding-left: 1.5rem !important;\n}\n.pl-5 {\n  padding-left: 3rem !important;\n}\n\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.d-none {\n  display: none !important;\n}\n.d-flex {\n  display: flex !important;\n}\n.gap-1 {\n  gap: .25rem;\n}\n.gap-2 {\n  gap: .5rem;\n}\n.gap-3 {\n  gap: .75rem;\n}\n.gap-4 {\n  gap: 1rem;\n}\n.gap-5 {\n  gap: 1.25rem;\n}\n.gap-6 {\n  gap: 1.5rem;\n}\n\n.d-inline {\n  display: inline-flex !important;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin-bottom: .5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\nh3 {\n  font-size: 1.75rem;\n}\n\nh6 {\n  font-size: 1rem;\n}\n\nhr {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: 0;\n  border-top: 1px solid var(--black1);\n}\n\nsmall {\n  font-size: 80%;\n  font-weight: 400;\n}\n\nlabel {\n  //margin-bottom: .5rem;\n}\n\na {\n  color: #6a3ce2;\n  text-decoration: none;\n  background-color: #0000;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n.flex-row            { flex-direction: row !important; }\n.flex-column         { flex-direction: column !important; }\n.flex-row-reverse    { flex-direction: row-reverse !important; }\n.flex-column-reverse { flex-direction: column-reverse !important; }\n\n.flex-wrap         { flex-wrap: wrap !important; }\n.flex-nowrap       { flex-wrap: nowrap !important; }\n.flex-wrap-reverse { flex-wrap: wrap-reverse !important; }\n.flex-fill         { flex: 1 1 auto !important; }\n\n.justify-content-start   { justify-content: flex-start !important; }\n.justify-content-end     { justify-content: flex-end !important; }\n.justify-content-center  { justify-content: center !important; }\n.justify-content-between { justify-content: space-between !important; }\n.justify-content-around  { justify-content: space-around !important; }\n\n.align-items-start    { align-items: flex-start !important; }\n.align-items-end      { align-items: flex-end !important; }\n.align-items-center   { align-items: center !important; }\n.align-items-baseline { align-items: baseline !important; }\n.align-items-stretch  { align-items: stretch !important; }\n\n.align-content-start   { align-content: flex-start !important; }\n.align-content-end     { align-content: flex-end !important; }\n.align-content-center  { align-content: center !important; }\n.align-content-between { align-content: space-between !important; }\n.align-content-around  { align-content: space-around !important; }\n.align-content-stretch { align-content: stretch !important; }\n\n.align-self-auto     { align-self: auto !important; }\n.align-self-start    { align-self: flex-start !important; }\n.align-self-end      { align-self: flex-end !important; }\n.align-self-center   { align-self: center !important; }\n.align-self-baseline { align-self: baseline !important; }\n.align-self-stretch  { align-self: stretch !important; }\n\n.w-100 {\n  width: 100% !important;\n}\n.w-auto {\n  width: auto !important;\n}","html {\n    --black9: #121417;\n    --black8: #1B1F23;\n    --black7: #262A30;\n    --black6: #454C56;\n    --black5: #555D67;\n    --black4: #777F89;\n    --black3: #A2AAB4;\n    --black2: #DFE5E9;\n    --black1: #E8EDF0;\n    --black0: #F5F7F8;\n    --white: white;\n    --black: #121417;\n\n    --purple9: #43248E;\n    --purple8: #5129AE;\n    --purple7: #6132cf;\n    --purple6: #6a3ce2;\n    --purple5: #8164ee;\n    --purple4: #a191f4;\n    --purple3: #c0b9f9;\n    --purple2: #dbd8fc;\n    --purple1: #eceafd;\n    --purple0: #f4f4fe;\n\n    --red9: #381E1D;\n    --red8: #60211F;\n    --red7: #A53E3E;\n    --red6: #D24242;\n    --red5: #E85757;\n    --red4: #f87171;\n    --red3: #fca5a5;\n    --red2: #fecaca;\n    --red1: #fee2e2;\n    --red0: #fef2f2;\n\n    --orange9: #35241E;\n    --orange8: #753621;\n    --orange7: #BC542A;\n    --orange6: #E16727;\n    --orange5: #F17C2A;\n    --orange4: #F69546;\n    --orange3: #FCB871;\n    --orange2: #fed7aa;\n    --orange1: #F9ECDB;\n    --orange0: #fff7ed;\n\n    --green9: #143120;\n    --green8: #166534;\n    --green7: #15803d;\n    --green6: #239F51;\n    --green5: #35C068;\n    --green4: #66DB91;\n    --green3: #8CEDAF;\n    --green2: #bbf7d0;\n    --green1: #E3F5E9;\n    --green0: #f0fdf4;\n\n    --pink9: #701338;\n    --pink8: #9D174D;\n    --pink7: #BE185D;\n    --pink6: #DB2777;\n    --pink5: #EC4899;\n    --pink4: #F472B6;\n    --pink3: #F9A8D4;\n    --pink2: #FBCFE8;\n    --pink1: #FCE7F3;\n    --pink0: #FDF2F8;\n\n    --blue9: #1E3A8A;\n    --blue8: #1E40AF;\n    --blue7: #1D4ED8;\n    --blue6: #2563EB;\n    --blue5: #3B82F6;\n    --blue4: #60A5FA;\n    --blue3: #93C5FD;\n    --blue2: #BFDBFE;\n    --blue1: #DBEAFE;\n    --blue0: #EFF6FF;\n\n    --cyan9: #164E63;\n    --cyan8: #155E75;\n    --cyan7: #0E7490;\n    --cyan6: #0891B2;\n    --cyan5: #06B6D4;\n    --cyan4: #22D3EE;\n    --cyan3: #67E8F9;\n    --cyan2: #A5F3FC;\n    --cyan1: #D4F6F9;\n    --cyan0: #EEF7F8;\n}\n\n.black9 {\n  color: #121417;\n  --black9: #121417;\n}\n.black8 {\n  color: #1B1F23;\n  --black8: #1B1F23;\n}\n.black7 {\n  color: #32373E;\n  --black7: #32373E;\n}\n.black6 {\n  color: #454C56;\n  --black6: #454C56;\n}\n.black5 {\n  color: #555D67;\n  --black5: #555D67;\n}\n.black4 {\n  color: #777F89;\n  --black4: #777F89;\n}\n.black3 {\n  color: #A2AAB4;\n  --black3: #A2AAB4;\n}\n.black2 {\n  color: #CBD2D8;\n  --black2: #CBD2D8;\n}\n.black1 {\n  color: #E8EDF0;\n  --black1: #E8EDF0;\n}\n.black0 {\n  color: #F5F7F8;\n  --black0: #F5F7F8;\n}\n\n.white {\n  color: white;\n  --white: #000000;\n}\n\n\n.purple9 {\n  color: #43248E;\n  --purple9: #43248E;\n}\n.purple8 {\n  color: #5129AE;\n  --purple8: #5129AE;\n}\n.purple7 {\n  color: #6132cf;\n  --purple7: #6132cf;\n}\n.purple6 {\n  color: #6a3ce2;\n  --purple6: #6a3ce2;\n}\n.purple5 {\n  color: #8164ee;\n  --purple5: #8164ee;\n}\n.purple4 {\n  color: #a191f4;\n  --purple4: #a191f4;\n}\n.purple3 {\n  color: #c0b9f9;\n  --purple3: #c0b9f9;\n}\n.purple2 {\n  color: #dbd8fc;\n  --purple2: #dbd8fc;\n}\n.purple1 {\n  color: #eceafd;\n  --purple1: #eceafd;\n}\n.purple0 {\n  color: #f4f4fe;\n  --purple0: #f4f4fe;\n}\n\n\n.red9 {\n  color: #7f1d1d;\n  --red9: #7f1d1d;\n}\n.red8 {\n  color: #991b1b;\n  --red8: #991b1b;\n}\n.red7 {\n  color: #b91c1c;\n  --red7: #b91c1c;\n}\n.red6 {\n  color: #dc2626;\n  --red6: #dc2626;\n}\n.red5 {\n  color: #ef4444;\n  --red5: #ef4444;\n}\n.red4 {\n  color: #f87171;\n  --red4: #f87171;\n}\n.red3 {\n  color: #fca5a5;\n  --red3: #fca5a5;\n}\n.red2 {\n  color: #fecaca;\n  --red2: #fecaca;\n}\n.red1 {\n  color: #fee2e2;\n  --red1: #fee2e2;\n}\n.red0 {\n  color: #fef2f2;\n  --red0: #fef2f2;\n}\n\n\n.orange9 {\n  color: #7c2d12;\n  --orange9: #7c2d12;\n}\n.orange8 {\n  color: #9a3412;\n  --orange8: #9a3412;\n}\n.orange7 {\n  color: #c2410c;\n  --orange7: #c2410c;\n}\n.orange6 {\n  color: #ea580c;\n  --orange6: #ea580c;\n}\n.orange5 {\n  color: #f97316;\n  --orange5: #f97316;\n}\n.orange4 {\n  color: #fb923c;\n  --orange4: #fb923c;\n}\n.orange3 {\n  color: #fdba74;\n  --orange3: #fdba74;\n}\n.orange2 {\n  color: #fed7aa;\n  --orange2: #fed7aa;\n}\n.orange1 {\n  color: #ffedd5;\n  --orange1: #ffedd5;\n}\n.orange0 {\n  color: #fff7ed;\n  --orange0: #fff7ed;\n}\n\n\n\n.green9 {\n  color: #0B321B;\n  --green9: #0B321B;\n}\n.green8 {\n  color: #166534;\n  --green8: #166534;\n}\n.green7 {\n  color: #15803d;\n  --green7: #15803d;\n}\n.green6 {\n  color: #16a34a;\n  --green6: #16a34a;\n}\n.green5 {\n  color: #22c55e;\n  --green5: #22c55e;\n}\n.green4 {\n  color: #4ade80;\n  --green4: #4ade80;\n}\n.green3 {\n  color: #86efac;\n  --green3: #86efac;\n}\n.green2 {\n  color: #bbf7d0;\n  --green2: #bbf7d0;\n}\n.green1 {\n  color: #dcfce7;\n  --green1: #dcfce7;\n}\n.green0 {\n  color: #f0fdf4;\n  --green0: #f0fdf4;\n}\n\n\n\n.font {\n  font-family: \"Inter\";\n  font-style: normal;\n  color: var(--black9);\n}\n\n.font-normal {\n  font-weight: 500;\n  --font-normal: 500;\n}\n.font-thin {\n  font-weight: 400;\n  --font-thin: 400;\n}\n\n\n.font-size-7 {\n  font-size: 40px;\n  line-height: 48px;\n}\n.font-size-6 {\n  font-size: 32px;\n  line-height: 39px;\n}\n.font-size-5 {\n  font-size: 24px;\n  line-height: 29px;\n}\n.font-size-4 {\n  font-size: 18px;\n  line-height: 22px;\n}\n.font-size-3 {\n  font-size: 16px;\n  line-height: 19px;\n}\n.font-size-2 {\n  font-size: 14px;\n  line-height: 17px;\n}\n.font-size-1 {\n  font-size: 13px;\n  line-height: 16px;\n}\n.font-size-0 {\n  font-size: 12px;\n  line-height: 15px;\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
